var _PixelsPerInch2, _EditorToolbar, _ImageManager, _AltText, _AnnotationEditor, _TextLayer2, _PDFWorker2, _FreeTextEditor, _FreeDrawOutliner, _ColorPicker2, _HighlightEditor, _InkEditor, _StampEditor, _AnnotationEditorLayer2, _DrawLayer2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _superPropGet(t, o, e, r) { var p = _get3(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get3() { return _get3 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get3.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classPrivateFieldLooseBase(e, t) { if (!{}.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance"); return e; }
var id = 0;
function _classPrivateFieldLooseKey(e) { return "__private_" + id++ + "_" + e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2024 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */

/******/ // The require scope
/******/
var __webpack_require__ = {};
/******/
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/
(function () {
  /******/ // define getter functions for harmony exports
  /******/__webpack_require__.d = function (exports, definition) {
    /******/for (var key in definition) {
      /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
        /******/Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
        /******/
      }
      /******/
    }
    /******/
  };
  /******/
})();
/******/
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/
(function () {
  /******/__webpack_require__.o = function (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
  /******/
})();
/******/
/************************************************************************/
var __webpack_exports__ = globalThis.pdfjsLib = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AbortException: function AbortException() {
    return /* reexport */_AbortException;
  },
  AnnotationEditorLayer: function AnnotationEditorLayer() {
    return /* reexport */_AnnotationEditorLayer;
  },
  AnnotationEditorParamsType: function AnnotationEditorParamsType() {
    return /* reexport */_AnnotationEditorParamsType;
  },
  AnnotationEditorType: function AnnotationEditorType() {
    return /* reexport */_AnnotationEditorType;
  },
  AnnotationEditorUIManager: function AnnotationEditorUIManager() {
    return /* reexport */_AnnotationEditorUIManager;
  },
  AnnotationLayer: function AnnotationLayer() {
    return /* reexport */_AnnotationLayer;
  },
  AnnotationMode: function AnnotationMode() {
    return /* reexport */_AnnotationMode;
  },
  ColorPicker: function ColorPicker() {
    return /* reexport */_ColorPicker;
  },
  DOMSVGFactory: function DOMSVGFactory() {
    return /* reexport */_DOMSVGFactory;
  },
  DrawLayer: function DrawLayer() {
    return /* reexport */_DrawLayer;
  },
  FeatureTest: function FeatureTest() {
    return /* reexport */util_FeatureTest;
  },
  GlobalWorkerOptions: function GlobalWorkerOptions() {
    return /* reexport */_GlobalWorkerOptions;
  },
  ImageKind: function ImageKind() {
    return /* reexport */util_ImageKind;
  },
  InvalidPDFException: function InvalidPDFException() {
    return /* reexport */_InvalidPDFException;
  },
  MissingPDFException: function MissingPDFException() {
    return /* reexport */_MissingPDFException;
  },
  OPS: function OPS() {
    return /* reexport */_OPS;
  },
  OutputScale: function OutputScale() {
    return /* reexport */_OutputScale;
  },
  PDFDataRangeTransport: function PDFDataRangeTransport() {
    return /* reexport */_PDFDataRangeTransport;
  },
  PDFDateString: function PDFDateString() {
    return /* reexport */_PDFDateString;
  },
  PDFWorker: function PDFWorker() {
    return /* reexport */_PDFWorker;
  },
  PasswordResponses: function PasswordResponses() {
    return /* reexport */_PasswordResponses;
  },
  PermissionFlag: function PermissionFlag() {
    return /* reexport */_PermissionFlag;
  },
  PixelsPerInch: function PixelsPerInch() {
    return /* reexport */_PixelsPerInch;
  },
  RenderingCancelledException: function RenderingCancelledException() {
    return /* reexport */_RenderingCancelledException;
  },
  TextLayer: function TextLayer() {
    return /* reexport */_TextLayer;
  },
  UnexpectedResponseException: function UnexpectedResponseException() {
    return /* reexport */_UnexpectedResponseException;
  },
  Util: function Util() {
    return /* reexport */_Util;
  },
  VerbosityLevel: function VerbosityLevel() {
    return /* reexport */_VerbosityLevel;
  },
  XfaLayer: function XfaLayer() {
    return /* reexport */_XfaLayer;
  },
  build: function build() {
    return /* reexport */_build;
  },
  createValidAbsoluteUrl: function createValidAbsoluteUrl() {
    return /* reexport */_createValidAbsoluteUrl;
  },
  fetchData: function fetchData() {
    return /* reexport */_fetchData;
  },
  getDocument: function getDocument() {
    return /* reexport */_getDocument;
  },
  getFilenameFromUrl: function getFilenameFromUrl() {
    return /* reexport */_getFilenameFromUrl;
  },
  getPdfFilenameFromUrl: function getPdfFilenameFromUrl() {
    return /* reexport */_getPdfFilenameFromUrl;
  },
  getXfaPageViewport: function getXfaPageViewport() {
    return /* reexport */_getXfaPageViewport;
  },
  isDataScheme: function isDataScheme() {
    return /* reexport */_isDataScheme;
  },
  isPdfFile: function isPdfFile() {
    return /* reexport */_isPdfFile;
  },
  noContextMenu: function noContextMenu() {
    return /* reexport */_noContextMenu;
  },
  normalizeUnicode: function normalizeUnicode() {
    return /* reexport */_normalizeUnicode;
  },
  setLayerDimensions: function setLayerDimensions() {
    return /* reexport */_setLayerDimensions;
  },
  shadow: function shadow() {
    return /* reexport */_shadow;
  },
  version: function version() {
    return /* reexport */_version;
  }
});
; // ./src/shared/util.js
var isNodeJS = (typeof process === "undefined" ? "undefined" : _typeof(process)) === "object" && process + "" === "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
var MAX_IMAGE_SIZE_TO_CACHE = 10e6;
var LINE_FACTOR = 1.35;
var LINE_DESCENT_FACTOR = 0.35;
var BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
var RenderingIntentFlag = {
  ANY: 0x01,
  DISPLAY: 0x02,
  PRINT: 0x04,
  SAVE: 0x08,
  ANNOTATIONS_FORMS: 0x10,
  ANNOTATIONS_STORAGE: 0x20,
  ANNOTATIONS_DISABLE: 0x40,
  IS_EDITING: 0x80,
  OPLIST: 0x100
};
var _AnnotationMode = {
  DISABLE: 0,
  ENABLE: 1,
  ENABLE_FORMS: 2,
  ENABLE_STORAGE: 3
};
var AnnotationEditorPrefix = "pdfjs_internal_editor_";
var _AnnotationEditorType = {
  DISABLE: -1,
  NONE: 0,
  FREETEXT: 3,
  HIGHLIGHT: 9,
  STAMP: 13,
  INK: 15
};
var _AnnotationEditorParamsType = {
  RESIZE: 1,
  CREATE: 2,
  FREETEXT_SIZE: 11,
  FREETEXT_COLOR: 12,
  FREETEXT_OPACITY: 13,
  INK_COLOR: 21,
  INK_THICKNESS: 22,
  INK_OPACITY: 23,
  HIGHLIGHT_COLOR: 31,
  HIGHLIGHT_DEFAULT_COLOR: 32,
  HIGHLIGHT_THICKNESS: 33,
  HIGHLIGHT_FREE: 34,
  HIGHLIGHT_SHOW_ALL: 35
};
var _PermissionFlag = {
  PRINT: 0x04,
  MODIFY_CONTENTS: 0x08,
  COPY: 0x10,
  MODIFY_ANNOTATIONS: 0x20,
  FILL_INTERACTIVE_FORMS: 0x100,
  COPY_FOR_ACCESSIBILITY: 0x200,
  ASSEMBLE: 0x400,
  PRINT_HIGH_QUALITY: 0x800
};
var TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
};
var util_ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
};
var AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
};
var AnnotationReplyType = {
  GROUP: "Group",
  REPLY: "R"
};
var AnnotationFlag = {
  INVISIBLE: 0x01,
  HIDDEN: 0x02,
  PRINT: 0x04,
  NOZOOM: 0x08,
  NOROTATE: 0x10,
  NOVIEW: 0x20,
  READONLY: 0x40,
  LOCKED: 0x80,
  TOGGLENOVIEW: 0x100,
  LOCKEDCONTENTS: 0x200
};
var AnnotationFieldFlag = {
  READONLY: 0x0000001,
  REQUIRED: 0x0000002,
  NOEXPORT: 0x0000004,
  MULTILINE: 0x0001000,
  PASSWORD: 0x0002000,
  NOTOGGLETOOFF: 0x0004000,
  RADIO: 0x0008000,
  PUSHBUTTON: 0x0010000,
  COMBO: 0x0020000,
  EDIT: 0x0040000,
  SORT: 0x0080000,
  FILESELECT: 0x0100000,
  MULTISELECT: 0x0200000,
  DONOTSPELLCHECK: 0x0400000,
  DONOTSCROLL: 0x0800000,
  COMB: 0x1000000,
  RICHTEXT: 0x2000000,
  RADIOSINUNISON: 0x2000000,
  COMMITONSELCHANGE: 0x4000000
};
var AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
};
var AnnotationActionEventType = {
  E: "Mouse Enter",
  X: "Mouse Exit",
  D: "Mouse Down",
  U: "Mouse Up",
  Fo: "Focus",
  Bl: "Blur",
  PO: "PageOpen",
  PC: "PageClose",
  PV: "PageVisible",
  PI: "PageInvisible",
  K: "Keystroke",
  F: "Format",
  V: "Validate",
  C: "Calculate"
};
var DocumentActionEventType = {
  WC: "WillClose",
  WS: "WillSave",
  DS: "DidSave",
  WP: "WillPrint",
  DP: "DidPrint"
};
var PageActionEventType = {
  O: "PageOpen",
  C: "PageClose"
};
var _VerbosityLevel = {
  ERRORS: 0,
  WARNINGS: 1,
  INFOS: 5
};
var _OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91,
  setStrokeTransparent: 92,
  setFillTransparent: 93
};
var _PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
var verbosity = _VerbosityLevel.WARNINGS;
function setVerbosityLevel(level) {
  if (Number.isInteger(level)) {
    verbosity = level;
  }
}
function getVerbosityLevel() {
  return verbosity;
}
function info(msg) {
  if (verbosity >= _VerbosityLevel.INFOS) {
    console.log("Info: ".concat(msg));
  }
}
function warn(msg) {
  if (verbosity >= _VerbosityLevel.WARNINGS) {
    console.log("Warning: ".concat(msg));
  }
}
function unreachable(msg) {
  throw new Error(msg);
}
function assert(cond, msg) {
  if (!cond) {
    unreachable(msg);
  }
}
function _isValidProtocol(url) {
  switch (url === null || url === void 0 ? void 0 : url.protocol) {
    case "http:":
    case "https:":
    case "ftp:":
    case "mailto:":
    case "tel:":
      return true;
    default:
      return false;
  }
}
function _createValidAbsoluteUrl(url) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!url) {
    return null;
  }
  try {
    if (options && typeof url === "string") {
      if (options.addDefaultProtocol && url.startsWith("www.")) {
        var dots = url.match(/\./g);
        if ((dots === null || dots === void 0 ? void 0 : dots.length) >= 2) {
          url = "http://".concat(url);
        }
      }
      if (options.tryConvertEncoding) {
        try {
          url = stringToUTF8String(url);
        } catch (_unused) {}
      }
    }
    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
    if (_isValidProtocol(absoluteUrl)) {
      return absoluteUrl;
    }
  } catch (_unused2) {}
  return null;
}
function _shadow(obj, prop, value) {
  var nonSerializable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  Object.defineProperty(obj, prop, {
    value: value,
    enumerable: !nonSerializable,
    configurable: true,
    writable: false
  });
  return value;
}
var BaseException = function BaseExceptionClosure() {
  function BaseException(message, name) {
    this.message = message;
    this.name = name;
  }
  BaseException.prototype = new Error();
  BaseException.constructor = BaseException;
  return BaseException;
}();
var PasswordException = /*#__PURE__*/function (_BaseException) {
  function PasswordException(msg, code) {
    var _this;
    _classCallCheck(this, PasswordException);
    _this = _callSuper(this, PasswordException, [msg, "PasswordException"]);
    _this.code = code;
    return _this;
  }
  _inherits(PasswordException, _BaseException);
  return _createClass(PasswordException);
}(BaseException);
var UnknownErrorException = /*#__PURE__*/function (_BaseException2) {
  function UnknownErrorException(msg, details) {
    var _this2;
    _classCallCheck(this, UnknownErrorException);
    _this2 = _callSuper(this, UnknownErrorException, [msg, "UnknownErrorException"]);
    _this2.details = details;
    return _this2;
  }
  _inherits(UnknownErrorException, _BaseException2);
  return _createClass(UnknownErrorException);
}(BaseException);
var _InvalidPDFException = /*#__PURE__*/function (_BaseException3) {
  function _InvalidPDFException(msg) {
    _classCallCheck(this, _InvalidPDFException);
    return _callSuper(this, _InvalidPDFException, [msg, "InvalidPDFException"]);
  }
  _inherits(_InvalidPDFException, _BaseException3);
  return _createClass(_InvalidPDFException);
}(BaseException);
var _MissingPDFException = /*#__PURE__*/function (_BaseException4) {
  function _MissingPDFException(msg) {
    _classCallCheck(this, _MissingPDFException);
    return _callSuper(this, _MissingPDFException, [msg, "MissingPDFException"]);
  }
  _inherits(_MissingPDFException, _BaseException4);
  return _createClass(_MissingPDFException);
}(BaseException);
var _UnexpectedResponseException = /*#__PURE__*/function (_BaseException5) {
  function _UnexpectedResponseException(msg, status) {
    var _this3;
    _classCallCheck(this, _UnexpectedResponseException);
    _this3 = _callSuper(this, _UnexpectedResponseException, [msg, "UnexpectedResponseException"]);
    _this3.status = status;
    return _this3;
  }
  _inherits(_UnexpectedResponseException, _BaseException5);
  return _createClass(_UnexpectedResponseException);
}(BaseException);
var FormatError = /*#__PURE__*/function (_BaseException6) {
  function FormatError(msg) {
    _classCallCheck(this, FormatError);
    return _callSuper(this, FormatError, [msg, "FormatError"]);
  }
  _inherits(FormatError, _BaseException6);
  return _createClass(FormatError);
}(BaseException);
var _AbortException = /*#__PURE__*/function (_BaseException7) {
  function _AbortException(msg) {
    _classCallCheck(this, _AbortException);
    return _callSuper(this, _AbortException, [msg, "AbortException"]);
  }
  _inherits(_AbortException, _BaseException7);
  return _createClass(_AbortException);
}(BaseException);
function bytesToString(bytes) {
  if (_typeof(bytes) !== "object" || (bytes === null || bytes === void 0 ? void 0 : bytes.length) === undefined) {
    unreachable("Invalid argument for bytesToString");
  }
  var length = bytes.length;
  var MAX_ARGUMENT_COUNT = 8192;
  if (length < MAX_ARGUMENT_COUNT) {
    return String.fromCharCode.apply(null, bytes);
  }
  var strBuf = [];
  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
    var chunk = bytes.subarray(i, chunkEnd);
    strBuf.push(String.fromCharCode.apply(null, chunk));
  }
  return strBuf.join("");
}
function stringToBytes(str) {
  if (typeof str !== "string") {
    unreachable("Invalid argument for stringToBytes");
  }
  var length = str.length;
  var bytes = new Uint8Array(length);
  for (var i = 0; i < length; ++i) {
    bytes[i] = str.charCodeAt(i) & 0xff;
  }
  return bytes;
}
function string32(value) {
  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function objectSize(obj) {
  return Object.keys(obj).length;
}
function objectFromMap(map) {
  var obj = Object.create(null);
  var _iterator = _createForOfIteratorHelper(map),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ref = _step.value;
      var _ref2 = _slicedToArray(_ref, 2);
      var key = _ref2[0];
      var value = _ref2[1];
      obj[key] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return obj;
}
function isLittleEndian() {
  var buffer8 = new Uint8Array(4);
  buffer8[0] = 1;
  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
  return view32[0] === 1;
}
function isEvalSupported() {
  try {
    new Function("");
    return true;
  } catch (_unused3) {
    return false;
  }
}
var util_FeatureTest = /*#__PURE__*/function () {
  function util_FeatureTest() {
    _classCallCheck(this, util_FeatureTest);
  }
  return _createClass(util_FeatureTest, null, [{
    key: "isLittleEndian",
    get: function get() {
      return _shadow(this, "isLittleEndian", isLittleEndian());
    }
  }, {
    key: "isEvalSupported",
    get: function get() {
      return _shadow(this, "isEvalSupported", isEvalSupported());
    }
  }, {
    key: "isOffscreenCanvasSupported",
    get: function get() {
      return _shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
    }
  }, {
    key: "platform",
    get: function get() {
      var _navigator;
      if (typeof navigator !== "undefined" && typeof ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.platform) === "string") {
        var _navigator2;
        return _shadow(this, "platform", {
          isMac: navigator.platform.includes("Mac"),
          isWindows: navigator.platform.includes("Win"),
          isFirefox: typeof ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.userAgent) === "string" && navigator.userAgent.includes("Firefox")
        });
      }
      return _shadow(this, "platform", {
        isMac: false,
        isWindows: false,
        isFirefox: false
      });
    }
  }, {
    key: "isCSSRoundSupported",
    get: function get() {
      var _globalThis$CSS, _globalThis$CSS$suppo;
      return _shadow(this, "isCSSRoundSupported", (_globalThis$CSS = globalThis.CSS) === null || _globalThis$CSS === void 0 || (_globalThis$CSS$suppo = _globalThis$CSS.supports) === null || _globalThis$CSS$suppo === void 0 ? void 0 : _globalThis$CSS$suppo.call(_globalThis$CSS, "width: round(1.5px, 1px)"));
    }
  }]);
}();
var hexNumbers = Array.from(Array(256).keys(), function (n) {
  return n.toString(16).padStart(2, "0");
});
var _getExtremumOnCurve = /*#__PURE__*/_classPrivateFieldLooseKey("getExtremumOnCurve");
var _getExtremum = /*#__PURE__*/_classPrivateFieldLooseKey("getExtremum");
var _Util = /*#__PURE__*/function () {
  function _Util() {
    _classCallCheck(this, _Util);
  }
  return _createClass(_Util, null, [{
    key: "makeHexColor",
    value: function makeHexColor(r, g, b) {
      return "#".concat(hexNumbers[r]).concat(hexNumbers[g]).concat(hexNumbers[b]);
    }
  }, {
    key: "scaleMinMax",
    value: function scaleMinMax(transform, minMax) {
      var temp;
      if (transform[0]) {
        if (transform[0] < 0) {
          temp = minMax[0];
          minMax[0] = minMax[2];
          minMax[2] = temp;
        }
        minMax[0] *= transform[0];
        minMax[2] *= transform[0];
        if (transform[3] < 0) {
          temp = minMax[1];
          minMax[1] = minMax[3];
          minMax[3] = temp;
        }
        minMax[1] *= transform[3];
        minMax[3] *= transform[3];
      } else {
        temp = minMax[0];
        minMax[0] = minMax[1];
        minMax[1] = temp;
        temp = minMax[2];
        minMax[2] = minMax[3];
        minMax[3] = temp;
        if (transform[1] < 0) {
          temp = minMax[1];
          minMax[1] = minMax[3];
          minMax[3] = temp;
        }
        minMax[1] *= transform[1];
        minMax[3] *= transform[1];
        if (transform[2] < 0) {
          temp = minMax[0];
          minMax[0] = minMax[2];
          minMax[2] = temp;
        }
        minMax[0] *= transform[2];
        minMax[2] *= transform[2];
      }
      minMax[0] += transform[4];
      minMax[1] += transform[5];
      minMax[2] += transform[4];
      minMax[3] += transform[5];
    }
  }, {
    key: "transform",
    value: function transform(m1, m2) {
      return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
    }
  }, {
    key: "applyTransform",
    value: function applyTransform(p, m) {
      var xt = p[0] * m[0] + p[1] * m[2] + m[4];
      var yt = p[0] * m[1] + p[1] * m[3] + m[5];
      return [xt, yt];
    }
  }, {
    key: "applyInverseTransform",
    value: function applyInverseTransform(p, m) {
      var d = m[0] * m[3] - m[1] * m[2];
      var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
      var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
      return [xt, yt];
    }
  }, {
    key: "getAxialAlignedBoundingBox",
    value: function getAxialAlignedBoundingBox(r, m) {
      var p1 = this.applyTransform(r, m);
      var p2 = this.applyTransform(r.slice(2, 4), m);
      var p3 = this.applyTransform([r[0], r[3]], m);
      var p4 = this.applyTransform([r[2], r[1]], m);
      return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
    }
  }, {
    key: "inverseTransform",
    value: function inverseTransform(m) {
      var d = m[0] * m[3] - m[1] * m[2];
      return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
    }
  }, {
    key: "singularValueDecompose2dScale",
    value: function singularValueDecompose2dScale(m) {
      var transpose = [m[0], m[2], m[1], m[3]];
      var a = m[0] * transpose[0] + m[1] * transpose[2];
      var b = m[0] * transpose[1] + m[1] * transpose[3];
      var c = m[2] * transpose[0] + m[3] * transpose[2];
      var d = m[2] * transpose[1] + m[3] * transpose[3];
      var first = (a + d) / 2;
      var second = Math.sqrt(Math.pow(a + d, 2) - 4 * (a * d - c * b)) / 2;
      var sx = first + second || 1;
      var sy = first - second || 1;
      return [Math.sqrt(sx), Math.sqrt(sy)];
    }
  }, {
    key: "normalizeRect",
    value: function normalizeRect(rect) {
      var r = rect.slice(0);
      if (rect[0] > rect[2]) {
        r[0] = rect[2];
        r[2] = rect[0];
      }
      if (rect[1] > rect[3]) {
        r[1] = rect[3];
        r[3] = rect[1];
      }
      return r;
    }
  }, {
    key: "intersect",
    value: function intersect(rect1, rect2) {
      var xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
      var xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
      if (xLow > xHigh) {
        return null;
      }
      var yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
      var yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
      if (yLow > yHigh) {
        return null;
      }
      return [xLow, yLow, xHigh, yHigh];
    }
  }, {
    key: "bezierBoundingBox",
    value: function bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
      if (minMax) {
        minMax[0] = Math.min(minMax[0], x0, x3);
        minMax[1] = Math.min(minMax[1], y0, y3);
        minMax[2] = Math.max(minMax[2], x0, x3);
        minMax[3] = Math.max(minMax[3], y0, y3);
      } else {
        minMax = [Math.min(x0, x3), Math.min(y0, y3), Math.max(x0, x3), Math.max(y0, y3)];
      }
      _classPrivateFieldLooseBase(this, _getExtremum)[_getExtremum](x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-x0 + 3 * (x1 - x2) + x3), 6 * (x0 - 2 * x1 + x2), 3 * (x1 - x0), minMax);
      _classPrivateFieldLooseBase(this, _getExtremum)[_getExtremum](x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-y0 + 3 * (y1 - y2) + y3), 6 * (y0 - 2 * y1 + y2), 3 * (y1 - y0), minMax);
      return minMax;
    }
  }]);
}();
function _getExtremumOnCurve2(x0, x1, x2, x3, y0, y1, y2, y3, t, minMax) {
  if (t <= 0 || t >= 1) {
    return;
  }
  var mt = 1 - t;
  var tt = t * t;
  var ttt = tt * t;
  var x = mt * (mt * (mt * x0 + 3 * t * x1) + 3 * tt * x2) + ttt * x3;
  var y = mt * (mt * (mt * y0 + 3 * t * y1) + 3 * tt * y2) + ttt * y3;
  minMax[0] = Math.min(minMax[0], x);
  minMax[1] = Math.min(minMax[1], y);
  minMax[2] = Math.max(minMax[2], x);
  minMax[3] = Math.max(minMax[3], y);
}
function _getExtremum2(x0, x1, x2, x3, y0, y1, y2, y3, a, b, c, minMax) {
  if (Math.abs(a) < 1e-12) {
    if (Math.abs(b) >= 1e-12) {
      _classPrivateFieldLooseBase(this, _getExtremumOnCurve)[_getExtremumOnCurve](x0, x1, x2, x3, y0, y1, y2, y3, -c / b, minMax);
    }
    return;
  }
  var delta = Math.pow(b, 2) - 4 * c * a;
  if (delta < 0) {
    return;
  }
  var sqrtDelta = Math.sqrt(delta);
  var a2 = 2 * a;
  _classPrivateFieldLooseBase(this, _getExtremumOnCurve)[_getExtremumOnCurve](x0, x1, x2, x3, y0, y1, y2, y3, (-b + sqrtDelta) / a2, minMax);
  _classPrivateFieldLooseBase(this, _getExtremumOnCurve)[_getExtremumOnCurve](x0, x1, x2, x3, y0, y1, y2, y3, (-b - sqrtDelta) / a2, minMax);
}
Object.defineProperty(_Util, _getExtremum, {
  value: _getExtremum2
});
Object.defineProperty(_Util, _getExtremumOnCurve, {
  value: _getExtremumOnCurve2
});
var PDFStringTranslateTable = /* unused pure expression or super */null && [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2d8, 0x2c7, 0x2c6, 0x2d9, 0x2dd, 0x2db, 0x2da, 0x2dc, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203a, 0x2212, 0x2030, 0x201e, 0x201c, 0x201d, 0x2018, 0x2019, 0x201a, 0x2122, 0xfb01, 0xfb02, 0x141, 0x152, 0x160, 0x178, 0x17d, 0x131, 0x142, 0x153, 0x161, 0x17e, 0, 0x20ac];
function stringToPDFString(str) {
  if (str[0] >= "\xEF") {
    var encoding;
    if (str[0] === "\xFE" && str[1] === "\xFF") {
      encoding = "utf-16be";
      if (str.length % 2 === 1) {
        str = str.slice(0, -1);
      }
    } else if (str[0] === "\xFF" && str[1] === "\xFE") {
      encoding = "utf-16le";
      if (str.length % 2 === 1) {
        str = str.slice(0, -1);
      }
    } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") {
      encoding = "utf-8";
    }
    if (encoding) {
      try {
        var decoder = new TextDecoder(encoding, {
          fatal: true
        });
        var buffer = stringToBytes(str);
        var decoded = decoder.decode(buffer);
        if (!decoded.includes("\x1b")) {
          return decoded;
        }
        return decoded.replaceAll(/\x1b[^\x1b]*(?:\x1b|$)/g, "");
      } catch (ex) {
        warn("stringToPDFString: \"".concat(ex, "\"."));
      }
    }
  }
  var strBuf = [];
  for (var i = 0, ii = str.length; i < ii; i++) {
    var charCode = str.charCodeAt(i);
    if (charCode === 0x1b) {
      while (++i < ii && str.charCodeAt(i) !== 0x1b) {}
      continue;
    }
    var code = PDFStringTranslateTable[charCode];
    strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
  }
  return strBuf.join("");
}
function stringToUTF8String(str) {
  return decodeURIComponent(escape(str));
}
function utf8StringToString(str) {
  return unescape(encodeURIComponent(str));
}
function isArrayEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (var i = 0, ii = arr1.length; i < ii; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
}
function getModificationDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var buffer = [date.getUTCFullYear().toString(), (date.getUTCMonth() + 1).toString().padStart(2, "0"), date.getUTCDate().toString().padStart(2, "0"), date.getUTCHours().toString().padStart(2, "0"), date.getUTCMinutes().toString().padStart(2, "0"), date.getUTCSeconds().toString().padStart(2, "0")];
  return buffer.join("");
}
var NormalizeRegex = null;
var NormalizationMap = null;
function _normalizeUnicode(str) {
  if (!NormalizeRegex) {
    NormalizeRegex = /([\xA0\xB5\u037E\u0EB3\u2000-\u200A\u202F\u2126\uFB00-\uFB04\uFB06\uFB20-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBA1\uFBA4-\uFBA9\uFBAE-\uFBB1\uFBD3-\uFBDC\uFBDE-\uFBE7\uFBEA-\uFBF8\uFBFC\uFBFD\uFC00-\uFC5D\uFC64-\uFCF1\uFCF5-\uFD3D\uFD88\uFDF4\uFDFA\uFDFB\uFE71\uFE77\uFE79\uFE7B\uFE7D]+)|(\uFB05+)/g;
    NormalizationMap = new Map([["ﬅ", "ſt"]]);
  }
  return str.replaceAll(NormalizeRegex, function (_, p1, p2) {
    return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
  });
}
function getUuid() {
  var _crypto, _crypto2;
  if (typeof crypto !== "undefined" && typeof ((_crypto = crypto) === null || _crypto === void 0 ? void 0 : _crypto.randomUUID) === "function") {
    return crypto.randomUUID();
  }
  var buf = new Uint8Array(32);
  if (typeof crypto !== "undefined" && typeof ((_crypto2 = crypto) === null || _crypto2 === void 0 ? void 0 : _crypto2.getRandomValues) === "function") {
    crypto.getRandomValues(buf);
  } else {
    for (var i = 0; i < 32; i++) {
      buf[i] = Math.floor(Math.random() * 255);
    }
  }
  return bytesToString(buf);
}
var AnnotationPrefix = "pdfjs_internal_id_";
var FontRenderOps = {
  BEZIER_CURVE_TO: 0,
  MOVE_TO: 1,
  LINE_TO: 2,
  QUADRATIC_CURVE_TO: 3,
  RESTORE: 4,
  SAVE: 5,
  SCALE: 6,
  TRANSFORM: 7,
  TRANSLATE: 8
};
function toHexUtil(arr) {
  if (Uint8Array.prototype.toHex) {
    return arr.toHex();
  }
  return Array.from(arr, function (num) {
    return hexNumbers[num];
  }).join("");
}
function toBase64Util(arr) {
  if (Uint8Array.prototype.toBase64) {
    return arr.toBase64();
  }
  return btoa(bytesToString(arr));
}
function fromBase64Util(str) {
  if (Uint8Array.fromBase64) {
    return Uint8Array.fromBase64(str);
  }
  return stringToBytes(atob(str));
}
; // ./src/display/display_utils.js

var SVG_NS = "http://www.w3.org/2000/svg";
var _PixelsPerInch = /*#__PURE__*/_createClass(function _PixelsPerInch() {
  _classCallCheck(this, _PixelsPerInch);
});
_PixelsPerInch2 = _PixelsPerInch;
_PixelsPerInch.CSS = 96.0;
_PixelsPerInch.PDF = 72.0;
_PixelsPerInch.PDF_TO_CSS_UNITS = _PixelsPerInch2.CSS / _PixelsPerInch2.PDF;
function _fetchData(_x) {
  return _fetchData2.apply(this, arguments);
}
function _fetchData2() {
  _fetchData2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee50(url) {
    var type,
      response,
      _args51 = arguments;
    return _regeneratorRuntime().wrap(function _callee50$(_context51) {
      while (1) switch (_context51.prev = _context51.next) {
        case 0:
          type = _args51.length > 1 && _args51[1] !== undefined ? _args51[1] : "text";
          if (!isValidFetchUrl(url, document.baseURI)) {
            _context51.next = 14;
            break;
          }
          _context51.next = 4;
          return fetch(url);
        case 4:
          response = _context51.sent;
          if (response.ok) {
            _context51.next = 7;
            break;
          }
          throw new Error(response.statusText);
        case 7:
          _context51.t0 = type;
          _context51.next = _context51.t0 === "arraybuffer" ? 10 : _context51.t0 === "blob" ? 11 : _context51.t0 === "json" ? 12 : 13;
          break;
        case 10:
          return _context51.abrupt("return", response.arrayBuffer());
        case 11:
          return _context51.abrupt("return", response.blob());
        case 12:
          return _context51.abrupt("return", response.json());
        case 13:
          return _context51.abrupt("return", response.text());
        case 14:
          return _context51.abrupt("return", new Promise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.open("GET", url, true);
            request.responseType = type;
            request.onreadystatechange = function () {
              if (request.readyState !== XMLHttpRequest.DONE) {
                return;
              }
              if (request.status === 200 || request.status === 0) {
                switch (type) {
                  case "arraybuffer":
                  case "blob":
                  case "json":
                    resolve(request.response);
                    return;
                }
                resolve(request.responseText);
                return;
              }
              reject(new Error(request.statusText));
            };
            request.send(null);
          }));
        case 15:
        case "end":
          return _context51.stop();
      }
    }, _callee50);
  }));
  return _fetchData2.apply(this, arguments);
}
var PageViewport = /*#__PURE__*/function () {
  function PageViewport(_ref3) {
    var viewBox = _ref3.viewBox,
      scale = _ref3.scale,
      rotation = _ref3.rotation,
      _ref3$offsetX = _ref3.offsetX,
      offsetX = _ref3$offsetX === void 0 ? 0 : _ref3$offsetX,
      _ref3$offsetY = _ref3.offsetY,
      offsetY = _ref3$offsetY === void 0 ? 0 : _ref3$offsetY,
      _ref3$dontFlip = _ref3.dontFlip,
      dontFlip = _ref3$dontFlip === void 0 ? false : _ref3$dontFlip;
    _classCallCheck(this, PageViewport);
    this.viewBox = viewBox;
    this.scale = scale;
    this.rotation = rotation;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    var centerX = (viewBox[2] + viewBox[0]) / 2;
    var centerY = (viewBox[3] + viewBox[1]) / 2;
    var rotateA, rotateB, rotateC, rotateD;
    rotation %= 360;
    if (rotation < 0) {
      rotation += 360;
    }
    switch (rotation) {
      case 180:
        rotateA = -1;
        rotateB = 0;
        rotateC = 0;
        rotateD = 1;
        break;
      case 90:
        rotateA = 0;
        rotateB = 1;
        rotateC = 1;
        rotateD = 0;
        break;
      case 270:
        rotateA = 0;
        rotateB = -1;
        rotateC = -1;
        rotateD = 0;
        break;
      case 0:
        rotateA = 1;
        rotateB = 0;
        rotateC = 0;
        rotateD = -1;
        break;
      default:
        throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
    }
    if (dontFlip) {
      rotateC = -rotateC;
      rotateD = -rotateD;
    }
    var offsetCanvasX, offsetCanvasY;
    var width, height;
    if (rotateA === 0) {
      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
      width = (viewBox[3] - viewBox[1]) * scale;
      height = (viewBox[2] - viewBox[0]) * scale;
    } else {
      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
      width = (viewBox[2] - viewBox[0]) * scale;
      height = (viewBox[3] - viewBox[1]) * scale;
    }
    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
    this.width = width;
    this.height = height;
  }
  return _createClass(PageViewport, [{
    key: "rawDims",
    get: function get() {
      var viewBox = this.viewBox;
      return _shadow(this, "rawDims", {
        pageWidth: viewBox[2] - viewBox[0],
        pageHeight: viewBox[3] - viewBox[1],
        pageX: viewBox[0],
        pageY: viewBox[1]
      });
    }
  }, {
    key: "clone",
    value: function clone() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$scale = _ref4.scale,
        scale = _ref4$scale === void 0 ? this.scale : _ref4$scale,
        _ref4$rotation = _ref4.rotation,
        rotation = _ref4$rotation === void 0 ? this.rotation : _ref4$rotation,
        _ref4$offsetX = _ref4.offsetX,
        offsetX = _ref4$offsetX === void 0 ? this.offsetX : _ref4$offsetX,
        _ref4$offsetY = _ref4.offsetY,
        offsetY = _ref4$offsetY === void 0 ? this.offsetY : _ref4$offsetY,
        _ref4$dontFlip = _ref4.dontFlip,
        dontFlip = _ref4$dontFlip === void 0 ? false : _ref4$dontFlip;
      return new PageViewport({
        viewBox: this.viewBox.slice(),
        scale: scale,
        rotation: rotation,
        offsetX: offsetX,
        offsetY: offsetY,
        dontFlip: dontFlip
      });
    }
  }, {
    key: "convertToViewportPoint",
    value: function convertToViewportPoint(x, y) {
      return _Util.applyTransform([x, y], this.transform);
    }
  }, {
    key: "convertToViewportRectangle",
    value: function convertToViewportRectangle(rect) {
      var topLeft = _Util.applyTransform([rect[0], rect[1]], this.transform);
      var bottomRight = _Util.applyTransform([rect[2], rect[3]], this.transform);
      return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
    }
  }, {
    key: "convertToPdfPoint",
    value: function convertToPdfPoint(x, y) {
      return _Util.applyInverseTransform([x, y], this.transform);
    }
  }]);
}();
var _RenderingCancelledException = /*#__PURE__*/function (_BaseException8) {
  function _RenderingCancelledException(msg) {
    var _this4;
    var extraDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    _classCallCheck(this, _RenderingCancelledException);
    _this4 = _callSuper(this, _RenderingCancelledException, [msg, "RenderingCancelledException"]);
    _this4.extraDelay = extraDelay;
    return _this4;
  }
  _inherits(_RenderingCancelledException, _BaseException8);
  return _createClass(_RenderingCancelledException);
}(BaseException);
function _isDataScheme(url) {
  var ii = url.length;
  var i = 0;
  while (i < ii && url[i].trim() === "") {
    i++;
  }
  return url.substring(i, i + 5).toLowerCase() === "data:";
}
function _isPdfFile(filename) {
  return typeof filename === "string" && /\.pdf$/i.test(filename);
}
function _getFilenameFromUrl(url) {
  var _url$split = url.split(/[#?]/, 1);
  var _url$split2 = _slicedToArray(_url$split, 1);
  url = _url$split2[0];
  return url.substring(url.lastIndexOf("/") + 1);
}
function _getPdfFilenameFromUrl(url) {
  var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "document.pdf";
  if (typeof url !== "string") {
    return defaultFilename;
  }
  if (_isDataScheme(url)) {
    warn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
    return defaultFilename;
  }
  var reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
  var reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
  var splitURI = reURI.exec(url);
  var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
  if (suggestedFilename) {
    suggestedFilename = suggestedFilename[0];
    if (suggestedFilename.includes("%")) {
      try {
        suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
      } catch (_unused4) {}
    }
  }
  return suggestedFilename || defaultFilename;
}
var StatTimer = /*#__PURE__*/function () {
  function StatTimer() {
    _classCallCheck(this, StatTimer);
    this.started = Object.create(null);
    this.times = [];
  }
  return _createClass(StatTimer, [{
    key: "time",
    value: function time(name) {
      if (name in this.started) {
        warn("Timer is already running for ".concat(name));
      }
      this.started[name] = Date.now();
    }
  }, {
    key: "timeEnd",
    value: function timeEnd(name) {
      if (!(name in this.started)) {
        warn("Timer has not been started for ".concat(name));
      }
      this.times.push({
        name: name,
        start: this.started[name],
        end: Date.now()
      });
      delete this.started[name];
    }
  }, {
    key: "toString",
    value: function toString() {
      var outBuf = [];
      var longest = 0;
      var _iterator2 = _createForOfIteratorHelper(this.times),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ref5 = _step2.value;
          var name = _ref5.name;
          longest = Math.max(name.length, longest);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(this.times),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref6 = _step3.value;
          var _name = _ref6.name;
          var start = _ref6.start;
          var end = _ref6.end;
          outBuf.push("".concat(_name.padEnd(longest), " ").concat(end - start, "ms\n"));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return outBuf.join("");
    }
  }]);
}();
function isValidFetchUrl(url, baseUrl) {
  try {
    var _ref7 = baseUrl ? new URL(url, baseUrl) : new URL(url),
      protocol = _ref7.protocol;
    return protocol === "http:" || protocol === "https:";
  } catch (_unused5) {
    return false;
  }
}
function _noContextMenu(e) {
  e.preventDefault();
}
function deprecated(details) {
  console.log("Deprecated API usage: " + details);
}
var _regex = /*#__PURE__*/_classPrivateFieldLooseKey("regex");
var _PDFDateString = /*#__PURE__*/function () {
  function _PDFDateString() {
    _classCallCheck(this, _PDFDateString);
  }
  return _createClass(_PDFDateString, null, [{
    key: "toDateObject",
    value: function toDateObject(input) {
      var _classPrivateFieldLoo;
      if (!input || typeof input !== "string") {
        return null;
      }
      (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _regex))[_regex] || (_classPrivateFieldLoo[_regex] = new RegExp("^D:" + "(\\d{4})" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "([Z|+|-])?" + "(\\d{2})?" + "'?" + "(\\d{2})?" + "'?"));
      var matches = _classPrivateFieldLooseBase(this, _regex)[_regex].exec(input);
      if (!matches) {
        return null;
      }
      var year = parseInt(matches[1], 10);
      var month = parseInt(matches[2], 10);
      month = month >= 1 && month <= 12 ? month - 1 : 0;
      var day = parseInt(matches[3], 10);
      day = day >= 1 && day <= 31 ? day : 1;
      var hour = parseInt(matches[4], 10);
      hour = hour >= 0 && hour <= 23 ? hour : 0;
      var minute = parseInt(matches[5], 10);
      minute = minute >= 0 && minute <= 59 ? minute : 0;
      var second = parseInt(matches[6], 10);
      second = second >= 0 && second <= 59 ? second : 0;
      var universalTimeRelation = matches[7] || "Z";
      var offsetHour = parseInt(matches[8], 10);
      offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
      var offsetMinute = parseInt(matches[9], 10) || 0;
      offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
      if (universalTimeRelation === "-") {
        hour += offsetHour;
        minute += offsetMinute;
      } else if (universalTimeRelation === "+") {
        hour -= offsetHour;
        minute -= offsetMinute;
      }
      return new Date(Date.UTC(year, month, day, hour, minute, second));
    }
  }]);
}();
Object.defineProperty(_PDFDateString, _regex, {
  writable: true,
  value: void 0
});
function _getXfaPageViewport(xfaPage, _ref8) {
  var _ref8$scale = _ref8.scale,
    scale = _ref8$scale === void 0 ? 1 : _ref8$scale,
    _ref8$rotation = _ref8.rotation,
    rotation = _ref8$rotation === void 0 ? 0 : _ref8$rotation;
  var _xfaPage$attributes$s = xfaPage.attributes.style,
    width = _xfaPage$attributes$s.width,
    height = _xfaPage$attributes$s.height;
  var viewBox = [0, 0, parseInt(width), parseInt(height)];
  return new PageViewport({
    viewBox: viewBox,
    scale: scale,
    rotation: rotation
  });
}
function getRGB(color) {
  if (color.startsWith("#")) {
    var colorRGB = parseInt(color.slice(1), 16);
    return [(colorRGB & 0xff0000) >> 16, (colorRGB & 0x00ff00) >> 8, colorRGB & 0x0000ff];
  }
  if (color.startsWith("rgb(")) {
    return color.slice(4, -1).split(",").map(function (x) {
      return parseInt(x);
    });
  }
  if (color.startsWith("rgba(")) {
    return color.slice(5, -1).split(",").map(function (x) {
      return parseInt(x);
    }).slice(0, 3);
  }
  warn("Not a valid color format: \"".concat(color, "\""));
  return [0, 0, 0];
}
function getColorValues(colors) {
  var span = document.createElement("span");
  span.style.visibility = "hidden";
  document.body.append(span);
  var _iterator4 = _createForOfIteratorHelper(colors.keys()),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var name = _step4.value;
      span.style.color = name;
      var computedColor = window.getComputedStyle(span).color;
      colors.set(name, getRGB(computedColor));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  span.remove();
}
function getCurrentTransform(ctx) {
  var _ctx$getTransform = ctx.getTransform(),
    a = _ctx$getTransform.a,
    b = _ctx$getTransform.b,
    c = _ctx$getTransform.c,
    d = _ctx$getTransform.d,
    e = _ctx$getTransform.e,
    f = _ctx$getTransform.f;
  return [a, b, c, d, e, f];
}
function getCurrentTransformInverse(ctx) {
  var _ctx$getTransform$inv = ctx.getTransform().invertSelf(),
    a = _ctx$getTransform$inv.a,
    b = _ctx$getTransform$inv.b,
    c = _ctx$getTransform$inv.c,
    d = _ctx$getTransform$inv.d,
    e = _ctx$getTransform$inv.e,
    f = _ctx$getTransform$inv.f;
  return [a, b, c, d, e, f];
}
function _setLayerDimensions(div, viewport) {
  var mustFlip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var mustRotate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (viewport instanceof PageViewport) {
    var _viewport$rawDims = viewport.rawDims,
      pageWidth = _viewport$rawDims.pageWidth,
      pageHeight = _viewport$rawDims.pageHeight;
    var style = div.style;
    var useRound = util_FeatureTest.isCSSRoundSupported;
    var w = "var(--scale-factor) * ".concat(pageWidth, "px"),
      h = "var(--scale-factor) * ".concat(pageHeight, "px");
    var widthStr = useRound ? "round(down, ".concat(w, ", var(--scale-round-x, 1px))") : "calc(".concat(w, ")"),
      heightStr = useRound ? "round(down, ".concat(h, ", var(--scale-round-y, 1px))") : "calc(".concat(h, ")");
    if (!mustFlip || viewport.rotation % 180 === 0) {
      style.width = widthStr;
      style.height = heightStr;
    } else {
      style.width = heightStr;
      style.height = widthStr;
    }
  }
  if (mustRotate) {
    div.setAttribute("data-main-rotation", viewport.rotation);
  }
}
var _OutputScale = /*#__PURE__*/function () {
  function _OutputScale() {
    _classCallCheck(this, _OutputScale);
    var pixelRatio = window.devicePixelRatio || 1;
    this.sx = pixelRatio;
    this.sy = pixelRatio;
  }
  return _createClass(_OutputScale, [{
    key: "scaled",
    get: function get() {
      return this.sx !== 1 || this.sy !== 1;
    }
  }, {
    key: "symmetric",
    get: function get() {
      return this.sx === this.sy;
    }
  }]);
}();
; // ./src/display/editor/toolbar.js
var _toolbar = /*#__PURE__*/_classPrivateFieldLooseKey("toolbar");
var _colorPicker = /*#__PURE__*/_classPrivateFieldLooseKey("colorPicker");
var _editor = /*#__PURE__*/_classPrivateFieldLooseKey("editor");
var _buttons = /*#__PURE__*/_classPrivateFieldLooseKey("buttons");
var _altText = /*#__PURE__*/_classPrivateFieldLooseKey("altText");
var _l10nRemove = /*#__PURE__*/_classPrivateFieldLooseKey("l10nRemove");
var _pointerDown = /*#__PURE__*/_classPrivateFieldLooseKey("pointerDown");
var _focusIn = /*#__PURE__*/_classPrivateFieldLooseKey("focusIn");
var _focusOut = /*#__PURE__*/_classPrivateFieldLooseKey("focusOut");
var _addListenersToElement = /*#__PURE__*/_classPrivateFieldLooseKey("addListenersToElement");
var _addDeleteButton = /*#__PURE__*/_classPrivateFieldLooseKey("addDeleteButton");
var _divider = /*#__PURE__*/_classPrivateFieldLooseKey("divider");
var EditorToolbar = /*#__PURE__*/function () {
  function EditorToolbar(editor) {
    var _classPrivateFieldLoo2;
    _classCallCheck(this, EditorToolbar);
    Object.defineProperty(this, _divider, {
      get: _get_divider,
      set: void 0
    });
    Object.defineProperty(this, _addDeleteButton, {
      value: _addDeleteButton2
    });
    Object.defineProperty(this, _addListenersToElement, {
      value: _addListenersToElement2
    });
    Object.defineProperty(this, _focusOut, {
      value: _focusOut2
    });
    Object.defineProperty(this, _focusIn, {
      value: _focusIn2
    });
    Object.defineProperty(this, _toolbar, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _colorPicker, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _editor, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _buttons, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _altText, {
      writable: true,
      value: null
    });
    _classPrivateFieldLooseBase(this, _editor)[_editor] = editor;
    (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(EditorToolbar, _l10nRemove))[_l10nRemove] || (_classPrivateFieldLoo2[_l10nRemove] = Object.freeze({
      freetext: "pdfjs-editor-remove-freetext-button",
      highlight: "pdfjs-editor-remove-highlight-button",
      ink: "pdfjs-editor-remove-ink-button",
      stamp: "pdfjs-editor-remove-stamp-button"
    }));
  }
  return _createClass(EditorToolbar, [{
    key: "render",
    value: function render() {
      var editToolbar = _classPrivateFieldLooseBase(this, _toolbar)[_toolbar] = document.createElement("div");
      editToolbar.classList.add("editToolbar", "hidden");
      editToolbar.setAttribute("role", "toolbar");
      var signal = _classPrivateFieldLooseBase(this, _editor)[_editor]._uiManager._signal;
      editToolbar.addEventListener("contextmenu", _noContextMenu, {
        signal: signal
      });
      editToolbar.addEventListener("pointerdown", _classPrivateFieldLooseBase(EditorToolbar, _pointerDown)[_pointerDown], {
        signal: signal
      });
      var buttons = _classPrivateFieldLooseBase(this, _buttons)[_buttons] = document.createElement("div");
      buttons.className = "buttons";
      editToolbar.append(buttons);
      var position = _classPrivateFieldLooseBase(this, _editor)[_editor].toolbarPosition;
      if (position) {
        var style = editToolbar.style;
        var x = _classPrivateFieldLooseBase(this, _editor)[_editor]._uiManager.direction === "ltr" ? 1 - position[0] : position[0];
        style.insetInlineEnd = "".concat(100 * x, "%");
        style.top = "calc(".concat(100 * position[1], "% + var(--editor-toolbar-vert-offset))");
      }
      _classPrivateFieldLooseBase(this, _addDeleteButton)[_addDeleteButton]();
      return editToolbar;
    }
  }, {
    key: "div",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _toolbar)[_toolbar];
    }
  }, {
    key: "hide",
    value: function hide() {
      var _classPrivateFieldLoo3;
      _classPrivateFieldLooseBase(this, _toolbar)[_toolbar].classList.add("hidden");
      (_classPrivateFieldLoo3 = _classPrivateFieldLooseBase(this, _colorPicker)[_colorPicker]) === null || _classPrivateFieldLoo3 === void 0 || _classPrivateFieldLoo3.hideDropdown();
    }
  }, {
    key: "show",
    value: function show() {
      var _classPrivateFieldLoo4;
      _classPrivateFieldLooseBase(this, _toolbar)[_toolbar].classList.remove("hidden");
      (_classPrivateFieldLoo4 = _classPrivateFieldLooseBase(this, _altText)[_altText]) === null || _classPrivateFieldLoo4 === void 0 || _classPrivateFieldLoo4.shown();
    }
  }, {
    key: "addAltText",
    value: function () {
      var _addAltText = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(altText) {
        var button;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return altText.render();
            case 2:
              button = _context.sent;
              _classPrivateFieldLooseBase(this, _addListenersToElement)[_addListenersToElement](button);
              _classPrivateFieldLooseBase(this, _buttons)[_buttons].prepend(button, _classPrivateFieldLooseBase(this, _divider)[_divider]);
              _classPrivateFieldLooseBase(this, _altText)[_altText] = altText;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function addAltText(_x2) {
        return _addAltText.apply(this, arguments);
      }
      return addAltText;
    }()
  }, {
    key: "addColorPicker",
    value: function addColorPicker(colorPicker) {
      _classPrivateFieldLooseBase(this, _colorPicker)[_colorPicker] = colorPicker;
      var button = colorPicker.renderButton();
      _classPrivateFieldLooseBase(this, _addListenersToElement)[_addListenersToElement](button);
      _classPrivateFieldLooseBase(this, _buttons)[_buttons].prepend(button, _classPrivateFieldLooseBase(this, _divider)[_divider]);
    }
  }, {
    key: "remove",
    value: function remove() {
      var _classPrivateFieldLoo5;
      _classPrivateFieldLooseBase(this, _toolbar)[_toolbar].remove();
      (_classPrivateFieldLoo5 = _classPrivateFieldLooseBase(this, _colorPicker)[_colorPicker]) === null || _classPrivateFieldLoo5 === void 0 || _classPrivateFieldLoo5.destroy();
      _classPrivateFieldLooseBase(this, _colorPicker)[_colorPicker] = null;
    }
  }]);
}();
_EditorToolbar = EditorToolbar;
function _pointerDown2(e) {
  e.stopPropagation();
}
function _focusIn2(e) {
  _classPrivateFieldLooseBase(this, _editor)[_editor]._focusEventsAllowed = false;
  e.preventDefault();
  e.stopPropagation();
}
function _focusOut2(e) {
  _classPrivateFieldLooseBase(this, _editor)[_editor]._focusEventsAllowed = true;
  e.preventDefault();
  e.stopPropagation();
}
function _addListenersToElement2(element) {
  var signal = _classPrivateFieldLooseBase(this, _editor)[_editor]._uiManager._signal;
  element.addEventListener("focusin", _classPrivateFieldLooseBase(this, _focusIn)[_focusIn].bind(this), {
    capture: true,
    signal: signal
  });
  element.addEventListener("focusout", _classPrivateFieldLooseBase(this, _focusOut)[_focusOut].bind(this), {
    capture: true,
    signal: signal
  });
  element.addEventListener("contextmenu", _noContextMenu, {
    signal: signal
  });
}
function _addDeleteButton2() {
  var _classPrivateFieldLoo126 = _classPrivateFieldLooseBase(this, _editor)[_editor],
    editorType = _classPrivateFieldLoo126.editorType,
    _uiManager = _classPrivateFieldLoo126._uiManager;
  var button = document.createElement("button");
  button.className = "delete";
  button.tabIndex = 0;
  button.setAttribute("data-l10n-id", _classPrivateFieldLooseBase(_EditorToolbar, _l10nRemove)[_l10nRemove][editorType]);
  _classPrivateFieldLooseBase(this, _addListenersToElement)[_addListenersToElement](button);
  button.addEventListener("click", function (e) {
    _uiManager.delete();
  }, {
    signal: _uiManager._signal
  });
  _classPrivateFieldLooseBase(this, _buttons)[_buttons].append(button);
}
function _get_divider() {
  var divider = document.createElement("div");
  divider.className = "divider";
  return divider;
}
Object.defineProperty(EditorToolbar, _pointerDown, {
  value: _pointerDown2
});
Object.defineProperty(EditorToolbar, _l10nRemove, {
  writable: true,
  value: null
});
var _buttons2 = /*#__PURE__*/_classPrivateFieldLooseKey("buttons");
var _toolbar2 = /*#__PURE__*/_classPrivateFieldLooseKey("toolbar");
var _uiManager2 = /*#__PURE__*/_classPrivateFieldLooseKey("uiManager");
var _render = /*#__PURE__*/_classPrivateFieldLooseKey("render");
var _getLastPoint = /*#__PURE__*/_classPrivateFieldLooseKey("getLastPoint");
var _addHighlightButton = /*#__PURE__*/_classPrivateFieldLooseKey("addHighlightButton");
var HighlightToolbar = /*#__PURE__*/function () {
  function HighlightToolbar(uiManager) {
    _classCallCheck(this, HighlightToolbar);
    Object.defineProperty(this, _addHighlightButton, {
      value: _addHighlightButton2
    });
    Object.defineProperty(this, _getLastPoint, {
      value: _getLastPoint2
    });
    Object.defineProperty(this, _render, {
      value: _render2
    });
    Object.defineProperty(this, _buttons2, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _toolbar2, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _uiManager2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _uiManager2)[_uiManager2] = uiManager;
  }
  return _createClass(HighlightToolbar, [{
    key: "show",
    value: function show(parent, boxes, isLTR) {
      var _classPrivateFieldLoo9;
      var _classPrivateFieldLoo6 = _classPrivateFieldLooseBase(this, _getLastPoint)[_getLastPoint](boxes, isLTR),
        _classPrivateFieldLoo7 = _slicedToArray(_classPrivateFieldLoo6, 2),
        x = _classPrivateFieldLoo7[0],
        y = _classPrivateFieldLoo7[1];
      var _classPrivateFieldLoo8 = (_classPrivateFieldLoo9 = _classPrivateFieldLooseBase(this, _toolbar2))[_toolbar2] || (_classPrivateFieldLoo9[_toolbar2] = _classPrivateFieldLooseBase(this, _render)[_render]()),
        style = _classPrivateFieldLoo8.style;
      parent.append(_classPrivateFieldLooseBase(this, _toolbar2)[_toolbar2]);
      style.insetInlineEnd = "".concat(100 * x, "%");
      style.top = "calc(".concat(100 * y, "% + var(--editor-toolbar-vert-offset))");
    }
  }, {
    key: "hide",
    value: function hide() {
      _classPrivateFieldLooseBase(this, _toolbar2)[_toolbar2].remove();
    }
  }]);
}();
function _render2() {
  var editToolbar = _classPrivateFieldLooseBase(this, _toolbar2)[_toolbar2] = document.createElement("div");
  editToolbar.className = "editToolbar";
  editToolbar.setAttribute("role", "toolbar");
  editToolbar.addEventListener("contextmenu", _noContextMenu, {
    signal: _classPrivateFieldLooseBase(this, _uiManager2)[_uiManager2]._signal
  });
  var buttons = _classPrivateFieldLooseBase(this, _buttons2)[_buttons2] = document.createElement("div");
  buttons.className = "buttons";
  editToolbar.append(buttons);
  _classPrivateFieldLooseBase(this, _addHighlightButton)[_addHighlightButton]();
  return editToolbar;
}
function _getLastPoint2(boxes, isLTR) {
  var lastY = 0;
  var lastX = 0;
  var _iterator159 = _createForOfIteratorHelper(boxes),
    _step159;
  try {
    for (_iterator159.s(); !(_step159 = _iterator159.n()).done;) {
      var box = _step159.value;
      var y = box.y + box.height;
      if (y < lastY) {
        continue;
      }
      var x = box.x + (isLTR ? box.width : 0);
      if (y > lastY) {
        lastX = x;
        lastY = y;
        continue;
      }
      if (isLTR) {
        if (x > lastX) {
          lastX = x;
        }
      } else if (x < lastX) {
        lastX = x;
      }
    }
  } catch (err) {
    _iterator159.e(err);
  } finally {
    _iterator159.f();
  }
  return [isLTR ? 1 - lastX : lastX, lastY];
}
function _addHighlightButton2() {
  var _this88 = this;
  var button = document.createElement("button");
  button.className = "highlightButton";
  button.tabIndex = 0;
  button.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button1");
  var span = document.createElement("span");
  button.append(span);
  span.className = "visuallyHidden";
  span.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button-label");
  var signal = _classPrivateFieldLooseBase(this, _uiManager2)[_uiManager2]._signal;
  button.addEventListener("contextmenu", _noContextMenu, {
    signal: signal
  });
  button.addEventListener("click", function () {
    _classPrivateFieldLooseBase(_this88, _uiManager2)[_uiManager2].highlightSelection("floating_button");
  }, {
    signal: signal
  });
  _classPrivateFieldLooseBase(this, _buttons2)[_buttons2].append(button);
}
; // ./src/display/editor/tools.js

function bindEvents(obj, element, names) {
  var _iterator5 = _createForOfIteratorHelper(names),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var name = _step5.value;
      element.addEventListener(name, obj[name].bind(obj));
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
}
function opacityToHex(opacity) {
  return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
}
var _id = /*#__PURE__*/_classPrivateFieldLooseKey("id");
var IdManager = /*#__PURE__*/function () {
  function IdManager() {
    _classCallCheck(this, IdManager);
    Object.defineProperty(this, _id, {
      writable: true,
      value: 0
    });
  }
  return _createClass(IdManager, [{
    key: "id",
    get: function get() {
      return "".concat(AnnotationEditorPrefix).concat(_classPrivateFieldLooseBase(this, _id)[_id]++);
    }
  }]);
}();
var _baseId = /*#__PURE__*/_classPrivateFieldLooseKey("baseId");
var _id2 = /*#__PURE__*/_classPrivateFieldLooseKey("id");
var _cache = /*#__PURE__*/_classPrivateFieldLooseKey("cache");
var _get = /*#__PURE__*/_classPrivateFieldLooseKey("get");
var ImageManager = /*#__PURE__*/function () {
  function ImageManager() {
    _classCallCheck(this, ImageManager);
    Object.defineProperty(this, _get, {
      value: _get2
    });
    Object.defineProperty(this, _baseId, {
      writable: true,
      value: getUuid()
    });
    Object.defineProperty(this, _id2, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _cache, {
      writable: true,
      value: null
    });
  }
  return _createClass(ImageManager, [{
    key: "getFromFile",
    value: function () {
      var _getFromFile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file) {
        var lastModified, name, size, type;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              lastModified = file.lastModified, name = file.name, size = file.size, type = file.type;
              return _context2.abrupt("return", _classPrivateFieldLooseBase(this, _get)[_get]("".concat(lastModified, "_").concat(name, "_").concat(size, "_").concat(type), file));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getFromFile(_x3) {
        return _getFromFile.apply(this, arguments);
      }
      return getFromFile;
    }()
  }, {
    key: "getFromUrl",
    value: function () {
      var _getFromUrl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", _classPrivateFieldLooseBase(this, _get)[_get](url, url));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getFromUrl(_x4) {
        return _getFromUrl.apply(this, arguments);
      }
      return getFromUrl;
    }()
  }, {
    key: "getFromBlob",
    value: function () {
      var _getFromBlob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(id, blobPromise) {
        var blob;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return blobPromise;
            case 2:
              blob = _context4.sent;
              return _context4.abrupt("return", _classPrivateFieldLooseBase(this, _get)[_get](id, blob));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getFromBlob(_x5, _x6) {
        return _getFromBlob.apply(this, arguments);
      }
      return getFromBlob;
    }()
  }, {
    key: "getFromId",
    value: function () {
      var _getFromId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(id) {
        var _classPrivateFieldLoo10;
        var data, blobPromise;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              (_classPrivateFieldLoo10 = _classPrivateFieldLooseBase(this, _cache))[_cache] || (_classPrivateFieldLoo10[_cache] = new Map());
              data = _classPrivateFieldLooseBase(this, _cache)[_cache].get(id);
              if (data) {
                _context5.next = 4;
                break;
              }
              return _context5.abrupt("return", null);
            case 4:
              if (!data.bitmap) {
                _context5.next = 7;
                break;
              }
              data.refCounter += 1;
              return _context5.abrupt("return", data);
            case 7:
              if (!data.file) {
                _context5.next = 9;
                break;
              }
              return _context5.abrupt("return", this.getFromFile(data.file));
            case 9:
              if (!data.blobPromise) {
                _context5.next = 13;
                break;
              }
              blobPromise = data.blobPromise;
              delete data.blobPromise;
              return _context5.abrupt("return", this.getFromBlob(data.id, blobPromise));
            case 13:
              return _context5.abrupt("return", this.getFromUrl(data.url));
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getFromId(_x7) {
        return _getFromId.apply(this, arguments);
      }
      return getFromId;
    }()
  }, {
    key: "getFromCanvas",
    value: function getFromCanvas(id, canvas) {
      var _classPrivateFieldLoo11, _data;
      (_classPrivateFieldLoo11 = _classPrivateFieldLooseBase(this, _cache))[_cache] || (_classPrivateFieldLoo11[_cache] = new Map());
      var data = _classPrivateFieldLooseBase(this, _cache)[_cache].get(id);
      if ((_data = data) !== null && _data !== void 0 && _data.bitmap) {
        data.refCounter += 1;
        return data;
      }
      var offscreen = new OffscreenCanvas(canvas.width, canvas.height);
      var ctx = offscreen.getContext("2d");
      ctx.drawImage(canvas, 0, 0);
      data = {
        bitmap: offscreen.transferToImageBitmap(),
        id: "image_".concat(_classPrivateFieldLooseBase(this, _baseId)[_baseId], "_").concat(_classPrivateFieldLooseBase(this, _id2)[_id2]++),
        refCounter: 1,
        isSvg: false
      };
      _classPrivateFieldLooseBase(this, _cache)[_cache].set(id, data);
      _classPrivateFieldLooseBase(this, _cache)[_cache].set(data.id, data);
      return data;
    }
  }, {
    key: "getSvgUrl",
    value: function getSvgUrl(id) {
      var data = _classPrivateFieldLooseBase(this, _cache)[_cache].get(id);
      if (!(data !== null && data !== void 0 && data.isSvg)) {
        return null;
      }
      return data.svgUrl;
    }
  }, {
    key: "deleteId",
    value: function deleteId(id) {
      var _classPrivateFieldLoo12, _bitmap$close;
      (_classPrivateFieldLoo12 = _classPrivateFieldLooseBase(this, _cache))[_cache] || (_classPrivateFieldLoo12[_cache] = new Map());
      var data = _classPrivateFieldLooseBase(this, _cache)[_cache].get(id);
      if (!data) {
        return;
      }
      data.refCounter -= 1;
      if (data.refCounter !== 0) {
        return;
      }
      var bitmap = data.bitmap;
      if (!data.url && !data.file) {
        var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
        var ctx = canvas.getContext("bitmaprenderer");
        ctx.transferFromImageBitmap(bitmap);
        data.blobPromise = canvas.convertToBlob();
      }
      (_bitmap$close = bitmap.close) === null || _bitmap$close === void 0 || _bitmap$close.call(bitmap);
      data.bitmap = null;
    }
  }, {
    key: "isValidId",
    value: function isValidId(id) {
      return id.startsWith("image_".concat(_classPrivateFieldLooseBase(this, _baseId)[_baseId], "_"));
    }
  }], [{
    key: "_isSVGFittingCanvas",
    get: function get() {
      var svg = "data:image/svg+xml;charset=UTF-8,<svg viewBox=\"0 0 1 1\" width=\"1\" height=\"1\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"1\" height=\"1\" style=\"fill:red;\"/></svg>";
      var canvas = new OffscreenCanvas(1, 3);
      var ctx = canvas.getContext("2d", {
        willReadFrequently: true
      });
      var image = new Image();
      image.src = svg;
      var promise = image.decode().then(function () {
        ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
        return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
      });
      return _shadow(this, "_isSVGFittingCanvas", promise);
    }
  }]);
}();
_ImageManager = ImageManager;
function _get2(_x47, _x48) {
  return _get4.apply(this, arguments);
}
function _get4() {
  _get4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee54(key, rawData) {
    var _classPrivateFieldLoo173, _data9;
    var data, image, mustRemoveAspectRatioPromise, fileReader, imageElement, imagePromise;
    return _regeneratorRuntime().wrap(function _callee54$(_context55) {
      while (1) switch (_context55.prev = _context55.next) {
        case 0:
          (_classPrivateFieldLoo173 = _classPrivateFieldLooseBase(this, _cache))[_cache] || (_classPrivateFieldLoo173[_cache] = new Map());
          data = _classPrivateFieldLooseBase(this, _cache)[_cache].get(key);
          if (!(data === null)) {
            _context55.next = 4;
            break;
          }
          return _context55.abrupt("return", null);
        case 4:
          if (!((_data9 = data) !== null && _data9 !== void 0 && _data9.bitmap)) {
            _context55.next = 7;
            break;
          }
          data.refCounter += 1;
          return _context55.abrupt("return", data);
        case 7:
          _context55.prev = 7;
          data || (data = {
            bitmap: null,
            id: "image_".concat(_classPrivateFieldLooseBase(this, _baseId)[_baseId], "_").concat(_classPrivateFieldLooseBase(this, _id2)[_id2]++),
            refCounter: 0,
            isSvg: false
          });
          if (!(typeof rawData === "string")) {
            _context55.next = 16;
            break;
          }
          data.url = rawData;
          _context55.next = 13;
          return _fetchData(rawData, "blob");
        case 13:
          image = _context55.sent;
          _context55.next = 17;
          break;
        case 16:
          if (rawData instanceof File) {
            image = data.file = rawData;
          } else if (rawData instanceof Blob) {
            image = rawData;
          }
        case 17:
          if (!(image.type === "image/svg+xml")) {
            _context55.next = 27;
            break;
          }
          mustRemoveAspectRatioPromise = _ImageManager._isSVGFittingCanvas;
          fileReader = new FileReader();
          imageElement = new Image();
          imagePromise = new Promise(function (resolve, reject) {
            imageElement.onload = function () {
              data.bitmap = imageElement;
              data.isSvg = true;
              resolve();
            };
            fileReader.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
              var url;
              return _regeneratorRuntime().wrap(function _callee53$(_context54) {
                while (1) switch (_context54.prev = _context54.next) {
                  case 0:
                    url = data.svgUrl = fileReader.result;
                    _context54.next = 3;
                    return mustRemoveAspectRatioPromise;
                  case 3:
                    if (!_context54.sent) {
                      _context54.next = 7;
                      break;
                    }
                    _context54.t0 = "".concat(url, "#svgView(preserveAspectRatio(none))");
                    _context54.next = 8;
                    break;
                  case 7:
                    _context54.t0 = url;
                  case 8:
                    imageElement.src = _context54.t0;
                  case 9:
                  case "end":
                    return _context54.stop();
                }
              }, _callee53);
            }));
            imageElement.onerror = fileReader.onerror = reject;
          });
          fileReader.readAsDataURL(image);
          _context55.next = 25;
          return imagePromise;
        case 25:
          _context55.next = 30;
          break;
        case 27:
          _context55.next = 29;
          return createImageBitmap(image);
        case 29:
          data.bitmap = _context55.sent;
        case 30:
          data.refCounter = 1;
          _context55.next = 37;
          break;
        case 33:
          _context55.prev = 33;
          _context55.t0 = _context55["catch"](7);
          console.error(_context55.t0);
          data = null;
        case 37:
          _classPrivateFieldLooseBase(this, _cache)[_cache].set(key, data);
          if (data) {
            _classPrivateFieldLooseBase(this, _cache)[_cache].set(data.id, data);
          }
          return _context55.abrupt("return", data);
        case 40:
        case "end":
          return _context55.stop();
      }
    }, _callee54, this, [[7, 33]]);
  }));
  return _get4.apply(this, arguments);
}
var _commands = /*#__PURE__*/_classPrivateFieldLooseKey("commands");
var _locked = /*#__PURE__*/_classPrivateFieldLooseKey("locked");
var _maxSize = /*#__PURE__*/_classPrivateFieldLooseKey("maxSize");
var _position = /*#__PURE__*/_classPrivateFieldLooseKey("position");
var CommandManager = /*#__PURE__*/function () {
  function CommandManager() {
    var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 128;
    _classCallCheck(this, CommandManager);
    Object.defineProperty(this, _commands, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _locked, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _maxSize, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _position, {
      writable: true,
      value: -1
    });
    _classPrivateFieldLooseBase(this, _maxSize)[_maxSize] = maxSize;
  }
  return _createClass(CommandManager, [{
    key: "add",
    value: function add(_ref9) {
      var cmd = _ref9.cmd,
        undo = _ref9.undo,
        post = _ref9.post,
        mustExec = _ref9.mustExec,
        _ref9$type = _ref9.type,
        type = _ref9$type === void 0 ? NaN : _ref9$type,
        _ref9$overwriteIfSame = _ref9.overwriteIfSameType,
        overwriteIfSameType = _ref9$overwriteIfSame === void 0 ? false : _ref9$overwriteIfSame,
        _ref9$keepUndo = _ref9.keepUndo,
        keepUndo = _ref9$keepUndo === void 0 ? false : _ref9$keepUndo;
      if (mustExec) {
        cmd();
      }
      if (_classPrivateFieldLooseBase(this, _locked)[_locked]) {
        return;
      }
      var save = {
        cmd: cmd,
        undo: undo,
        post: post,
        type: type
      };
      if (_classPrivateFieldLooseBase(this, _position)[_position] === -1) {
        if (_classPrivateFieldLooseBase(this, _commands)[_commands].length > 0) {
          _classPrivateFieldLooseBase(this, _commands)[_commands].length = 0;
        }
        _classPrivateFieldLooseBase(this, _position)[_position] = 0;
        _classPrivateFieldLooseBase(this, _commands)[_commands].push(save);
        return;
      }
      if (overwriteIfSameType && _classPrivateFieldLooseBase(this, _commands)[_commands][_classPrivateFieldLooseBase(this, _position)[_position]].type === type) {
        if (keepUndo) {
          save.undo = _classPrivateFieldLooseBase(this, _commands)[_commands][_classPrivateFieldLooseBase(this, _position)[_position]].undo;
        }
        _classPrivateFieldLooseBase(this, _commands)[_commands][_classPrivateFieldLooseBase(this, _position)[_position]] = save;
        return;
      }
      var next = _classPrivateFieldLooseBase(this, _position)[_position] + 1;
      if (next === _classPrivateFieldLooseBase(this, _maxSize)[_maxSize]) {
        _classPrivateFieldLooseBase(this, _commands)[_commands].splice(0, 1);
      } else {
        _classPrivateFieldLooseBase(this, _position)[_position] = next;
        if (next < _classPrivateFieldLooseBase(this, _commands)[_commands].length) {
          _classPrivateFieldLooseBase(this, _commands)[_commands].splice(next);
        }
      }
      _classPrivateFieldLooseBase(this, _commands)[_commands].push(save);
    }
  }, {
    key: "undo",
    value: function undo() {
      if (_classPrivateFieldLooseBase(this, _position)[_position] === -1) {
        return;
      }
      _classPrivateFieldLooseBase(this, _locked)[_locked] = true;
      var _classPrivateFieldLoo13 = _classPrivateFieldLooseBase(this, _commands)[_commands][_classPrivateFieldLooseBase(this, _position)[_position]],
        undo = _classPrivateFieldLoo13.undo,
        post = _classPrivateFieldLoo13.post;
      undo();
      post === null || post === void 0 || post();
      _classPrivateFieldLooseBase(this, _locked)[_locked] = false;
      _classPrivateFieldLooseBase(this, _position)[_position] -= 1;
    }
  }, {
    key: "redo",
    value: function redo() {
      if (_classPrivateFieldLooseBase(this, _position)[_position] < _classPrivateFieldLooseBase(this, _commands)[_commands].length - 1) {
        _classPrivateFieldLooseBase(this, _position)[_position] += 1;
        _classPrivateFieldLooseBase(this, _locked)[_locked] = true;
        var _classPrivateFieldLoo14 = _classPrivateFieldLooseBase(this, _commands)[_commands][_classPrivateFieldLooseBase(this, _position)[_position]],
          cmd = _classPrivateFieldLoo14.cmd,
          post = _classPrivateFieldLoo14.post;
        cmd();
        post === null || post === void 0 || post();
        _classPrivateFieldLooseBase(this, _locked)[_locked] = false;
      }
    }
  }, {
    key: "hasSomethingToUndo",
    value: function hasSomethingToUndo() {
      return _classPrivateFieldLooseBase(this, _position)[_position] !== -1;
    }
  }, {
    key: "hasSomethingToRedo",
    value: function hasSomethingToRedo() {
      return _classPrivateFieldLooseBase(this, _position)[_position] < _classPrivateFieldLooseBase(this, _commands)[_commands].length - 1;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _classPrivateFieldLooseBase(this, _commands)[_commands] = null;
    }
  }]);
}();
var _serialize = /*#__PURE__*/_classPrivateFieldLooseKey("serialize");
var KeyboardManager = /*#__PURE__*/function () {
  function KeyboardManager(callbacks) {
    _classCallCheck(this, KeyboardManager);
    Object.defineProperty(this, _serialize, {
      value: _serialize2
    });
    this.buffer = [];
    this.callbacks = new Map();
    this.allKeys = new Set();
    var isMac = util_FeatureTest.platform.isMac;
    var _iterator6 = _createForOfIteratorHelper(callbacks),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _ref10 = _step6.value;
        var _ref11 = _slicedToArray(_ref10, 3);
        var keys = _ref11[0];
        var callback = _ref11[1];
        var _ref11$ = _ref11[2];
        var options = _ref11$ === void 0 ? {} : _ref11$;
        var _iterator7 = _createForOfIteratorHelper(keys),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var key = _step7.value;
            var isMacKey = key.startsWith("mac+");
            if (isMac && isMacKey) {
              this.callbacks.set(key.slice(4), {
                callback: callback,
                options: options
              });
              this.allKeys.add(key.split("+").at(-1));
            } else if (!isMac && !isMacKey) {
              this.callbacks.set(key, {
                callback: callback,
                options: options
              });
              this.allKeys.add(key.split("+").at(-1));
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
  return _createClass(KeyboardManager, [{
    key: "exec",
    value: function exec(self, event) {
      if (!this.allKeys.has(event.key)) {
        return;
      }
      var info = this.callbacks.get(_classPrivateFieldLooseBase(this, _serialize)[_serialize](event));
      if (!info) {
        return;
      }
      var callback = info.callback,
        _info$options = info.options,
        _info$options$bubbles = _info$options.bubbles,
        bubbles = _info$options$bubbles === void 0 ? false : _info$options$bubbles,
        _info$options$args = _info$options.args,
        args = _info$options$args === void 0 ? [] : _info$options$args,
        _info$options$checker = _info$options.checker,
        checker = _info$options$checker === void 0 ? null : _info$options$checker;
      if (checker && !checker(self, event)) {
        return;
      }
      callback.bind.apply(callback, [self].concat(_toConsumableArray(args), [event]))();
      if (!bubbles) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
  }]);
}();
function _serialize2(event) {
  if (event.altKey) {
    this.buffer.push("alt");
  }
  if (event.ctrlKey) {
    this.buffer.push("ctrl");
  }
  if (event.metaKey) {
    this.buffer.push("meta");
  }
  if (event.shiftKey) {
    this.buffer.push("shift");
  }
  this.buffer.push(event.key);
  var str = this.buffer.join("+");
  this.buffer.length = 0;
  return str;
}
var ColorManager = /*#__PURE__*/function () {
  function ColorManager() {
    _classCallCheck(this, ColorManager);
  }
  return _createClass(ColorManager, [{
    key: "_colors",
    get: function get() {
      var colors = new Map([["CanvasText", null], ["Canvas", null]]);
      getColorValues(colors);
      return _shadow(this, "_colors", colors);
    }
  }, {
    key: "convert",
    value: function convert(color) {
      var rgb = getRGB(color);
      if (!window.matchMedia("(forced-colors: active)").matches) {
        return rgb;
      }
      var _iterator8 = _createForOfIteratorHelper(this._colors),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _ref12 = _step8.value;
          var _ref13 = _slicedToArray(_ref12, 2);
          var name = _ref13[0];
          var RGB = _ref13[1];
          if (RGB.every(function (x, i) {
            return x === rgb[i];
          })) {
            return ColorManager._colorsMapping.get(name);
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return rgb;
    }
  }, {
    key: "getHexCode",
    value: function getHexCode(name) {
      var rgb = this._colors.get(name);
      if (!rgb) {
        return name;
      }
      return _Util.makeHexColor.apply(_Util, _toConsumableArray(rgb));
    }
  }]);
}();
ColorManager._colorsMapping = new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]);
var _abortController = /*#__PURE__*/_classPrivateFieldLooseKey("abortController");
var _activeEditor = /*#__PURE__*/_classPrivateFieldLooseKey("activeEditor");
var _allEditors = /*#__PURE__*/_classPrivateFieldLooseKey("allEditors");
var _allLayers = /*#__PURE__*/_classPrivateFieldLooseKey("allLayers");
var _altTextManager = /*#__PURE__*/_classPrivateFieldLooseKey("altTextManager");
var _annotationStorage = /*#__PURE__*/_classPrivateFieldLooseKey("annotationStorage");
var _changedExistingAnnotations = /*#__PURE__*/_classPrivateFieldLooseKey("changedExistingAnnotations");
var _commandManager = /*#__PURE__*/_classPrivateFieldLooseKey("commandManager");
var _copyPasteAC = /*#__PURE__*/_classPrivateFieldLooseKey("copyPasteAC");
var _currentPageIndex = /*#__PURE__*/_classPrivateFieldLooseKey("currentPageIndex");
var _deletedAnnotationsElementIds = /*#__PURE__*/_classPrivateFieldLooseKey("deletedAnnotationsElementIds");
var _draggingEditors = /*#__PURE__*/_classPrivateFieldLooseKey("draggingEditors");
var _editorTypes = /*#__PURE__*/_classPrivateFieldLooseKey("editorTypes");
var _editorsToRescale = /*#__PURE__*/_classPrivateFieldLooseKey("editorsToRescale");
var _enableHighlightFloatingButton = /*#__PURE__*/_classPrivateFieldLooseKey("enableHighlightFloatingButton");
var _enableUpdatedAddImage = /*#__PURE__*/_classPrivateFieldLooseKey("enableUpdatedAddImage");
var _enableNewAltTextWhenAddingImage = /*#__PURE__*/_classPrivateFieldLooseKey("enableNewAltTextWhenAddingImage");
var _filterFactory = /*#__PURE__*/_classPrivateFieldLooseKey("filterFactory");
var _focusMainContainerTimeoutId = /*#__PURE__*/_classPrivateFieldLooseKey("focusMainContainerTimeoutId");
var _focusManagerAC = /*#__PURE__*/_classPrivateFieldLooseKey("focusManagerAC");
var _highlightColors = /*#__PURE__*/_classPrivateFieldLooseKey("highlightColors");
var _highlightWhenShiftUp = /*#__PURE__*/_classPrivateFieldLooseKey("highlightWhenShiftUp");
var _highlightToolbar = /*#__PURE__*/_classPrivateFieldLooseKey("highlightToolbar");
var _idManager = /*#__PURE__*/_classPrivateFieldLooseKey("idManager");
var _isEnabled = /*#__PURE__*/_classPrivateFieldLooseKey("isEnabled");
var _isWaiting = /*#__PURE__*/_classPrivateFieldLooseKey("isWaiting");
var _keyboardManagerAC = /*#__PURE__*/_classPrivateFieldLooseKey("keyboardManagerAC");
var _lastActiveElement = /*#__PURE__*/_classPrivateFieldLooseKey("lastActiveElement");
var _mainHighlightColorPicker = /*#__PURE__*/_classPrivateFieldLooseKey("mainHighlightColorPicker");
var _mlManager = /*#__PURE__*/_classPrivateFieldLooseKey("mlManager");
var _mode = /*#__PURE__*/_classPrivateFieldLooseKey("mode");
var _selectedEditors = /*#__PURE__*/_classPrivateFieldLooseKey("selectedEditors");
var _selectedTextNode = /*#__PURE__*/_classPrivateFieldLooseKey("selectedTextNode");
var _pageColors = /*#__PURE__*/_classPrivateFieldLooseKey("pageColors");
var _showAllStates = /*#__PURE__*/_classPrivateFieldLooseKey("showAllStates");
var _previousStates = /*#__PURE__*/_classPrivateFieldLooseKey("previousStates");
var _translation = /*#__PURE__*/_classPrivateFieldLooseKey("translation");
var _translationTimeoutId = /*#__PURE__*/_classPrivateFieldLooseKey("translationTimeoutId");
var _container = /*#__PURE__*/_classPrivateFieldLooseKey("container");
var _viewer = /*#__PURE__*/_classPrivateFieldLooseKey("viewer");
var _updateModeCapability = /*#__PURE__*/_classPrivateFieldLooseKey("updateModeCapability");
var _getAnchorElementForSelection = /*#__PURE__*/_classPrivateFieldLooseKey("getAnchorElementForSelection");
var _getLayerForTextLayer = /*#__PURE__*/_classPrivateFieldLooseKey("getLayerForTextLayer");
var _displayHighlightToolbar = /*#__PURE__*/_classPrivateFieldLooseKey("displayHighlightToolbar");
var _selectionChange = /*#__PURE__*/_classPrivateFieldLooseKey("selectionChange");
var _onSelectEnd = /*#__PURE__*/_classPrivateFieldLooseKey("onSelectEnd");
var _addSelectionListener = /*#__PURE__*/_classPrivateFieldLooseKey("addSelectionListener");
var _addFocusManager = /*#__PURE__*/_classPrivateFieldLooseKey("addFocusManager");
var _removeFocusManager = /*#__PURE__*/_classPrivateFieldLooseKey("removeFocusManager");
var _addKeyboardManager = /*#__PURE__*/_classPrivateFieldLooseKey("addKeyboardManager");
var _removeKeyboardManager = /*#__PURE__*/_classPrivateFieldLooseKey("removeKeyboardManager");
var _addCopyPasteListeners = /*#__PURE__*/_classPrivateFieldLooseKey("addCopyPasteListeners");
var _removeCopyPasteListeners = /*#__PURE__*/_classPrivateFieldLooseKey("removeCopyPasteListeners");
var _addDragAndDropListeners = /*#__PURE__*/_classPrivateFieldLooseKey("addDragAndDropListeners");
var _dispatchUpdateStates = /*#__PURE__*/_classPrivateFieldLooseKey("dispatchUpdateStates");
var _dispatchUpdateUI = /*#__PURE__*/_classPrivateFieldLooseKey("dispatchUpdateUI");
var _enableAll = /*#__PURE__*/_classPrivateFieldLooseKey("enableAll");
var _disableAll = /*#__PURE__*/_classPrivateFieldLooseKey("disableAll");
var _addEditorToLayer = /*#__PURE__*/_classPrivateFieldLooseKey("addEditorToLayer");
var _lastSelectedEditor = /*#__PURE__*/_classPrivateFieldLooseKey("lastSelectedEditor");
var _isEmpty = /*#__PURE__*/_classPrivateFieldLooseKey("isEmpty");
var _selectEditors = /*#__PURE__*/_classPrivateFieldLooseKey("selectEditors");
var _AnnotationEditorUIManager = /*#__PURE__*/function () {
  function _AnnotationEditorUIManager(container, viewer, altTextManager, eventBus, pdfDocument, pageColors, highlightColors, enableHighlightFloatingButton, enableUpdatedAddImage, enableNewAltTextWhenAddingImage, mlManager) {
    var _this5 = this;
    _classCallCheck(this, _AnnotationEditorUIManager);
    Object.defineProperty(this, _selectEditors, {
      value: _selectEditors2
    });
    Object.defineProperty(this, _isEmpty, {
      value: _isEmpty2
    });
    Object.defineProperty(this, _lastSelectedEditor, {
      get: _get_lastSelectedEditor,
      set: void 0
    });
    Object.defineProperty(this, _addEditorToLayer, {
      value: _addEditorToLayer2
    });
    Object.defineProperty(this, _disableAll, {
      value: _disableAll2
    });
    Object.defineProperty(this, _enableAll, {
      value: _enableAll2
    });
    Object.defineProperty(this, _dispatchUpdateUI, {
      value: _dispatchUpdateUI2
    });
    Object.defineProperty(this, _dispatchUpdateStates, {
      value: _dispatchUpdateStates2
    });
    Object.defineProperty(this, _addDragAndDropListeners, {
      value: _addDragAndDropListeners2
    });
    Object.defineProperty(this, _removeCopyPasteListeners, {
      value: _removeCopyPasteListeners2
    });
    Object.defineProperty(this, _addCopyPasteListeners, {
      value: _addCopyPasteListeners2
    });
    Object.defineProperty(this, _removeKeyboardManager, {
      value: _removeKeyboardManager2
    });
    Object.defineProperty(this, _addKeyboardManager, {
      value: _addKeyboardManager2
    });
    Object.defineProperty(this, _removeFocusManager, {
      value: _removeFocusManager2
    });
    Object.defineProperty(this, _addFocusManager, {
      value: _addFocusManager2
    });
    Object.defineProperty(this, _addSelectionListener, {
      value: _addSelectionListener2
    });
    Object.defineProperty(this, _onSelectEnd, {
      value: _onSelectEnd2
    });
    Object.defineProperty(this, _selectionChange, {
      value: _selectionChange2
    });
    Object.defineProperty(this, _displayHighlightToolbar, {
      value: _displayHighlightToolbar2
    });
    Object.defineProperty(this, _getLayerForTextLayer, {
      value: _getLayerForTextLayer2
    });
    Object.defineProperty(this, _getAnchorElementForSelection, {
      value: _getAnchorElementForSelection2
    });
    Object.defineProperty(this, _abortController, {
      writable: true,
      value: new AbortController()
    });
    Object.defineProperty(this, _activeEditor, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _allEditors, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _allLayers, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _altTextManager, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _annotationStorage, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _changedExistingAnnotations, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _commandManager, {
      writable: true,
      value: new CommandManager()
    });
    Object.defineProperty(this, _copyPasteAC, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _currentPageIndex, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _deletedAnnotationsElementIds, {
      writable: true,
      value: new Set()
    });
    Object.defineProperty(this, _draggingEditors, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _editorTypes, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _editorsToRescale, {
      writable: true,
      value: new Set()
    });
    Object.defineProperty(this, _enableHighlightFloatingButton, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _enableUpdatedAddImage, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _enableNewAltTextWhenAddingImage, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _filterFactory, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _focusMainContainerTimeoutId, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _focusManagerAC, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _highlightColors, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _highlightWhenShiftUp, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _highlightToolbar, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _idManager, {
      writable: true,
      value: new IdManager()
    });
    Object.defineProperty(this, _isEnabled, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _isWaiting, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _keyboardManagerAC, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _lastActiveElement, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _mainHighlightColorPicker, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _mlManager, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _mode, {
      writable: true,
      value: _AnnotationEditorType.NONE
    });
    Object.defineProperty(this, _selectedEditors, {
      writable: true,
      value: new Set()
    });
    Object.defineProperty(this, _selectedTextNode, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _pageColors, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _showAllStates, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _previousStates, {
      writable: true,
      value: {
        isEditing: false,
        isEmpty: true,
        hasSomethingToUndo: false,
        hasSomethingToRedo: false,
        hasSelectedEditor: false,
        hasSelectedText: false
      }
    });
    Object.defineProperty(this, _translation, {
      writable: true,
      value: [0, 0]
    });
    Object.defineProperty(this, _translationTimeoutId, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _container, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _viewer, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _updateModeCapability, {
      writable: true,
      value: null
    });
    var _signal = this._signal = _classPrivateFieldLooseBase(this, _abortController)[_abortController].signal;
    _classPrivateFieldLooseBase(this, _container)[_container] = container;
    _classPrivateFieldLooseBase(this, _viewer)[_viewer] = viewer;
    _classPrivateFieldLooseBase(this, _altTextManager)[_altTextManager] = altTextManager;
    this._eventBus = eventBus;
    eventBus._on("editingaction", this.onEditingAction.bind(this), {
      signal: _signal
    });
    eventBus._on("pagechanging", this.onPageChanging.bind(this), {
      signal: _signal
    });
    eventBus._on("scalechanging", this.onScaleChanging.bind(this), {
      signal: _signal
    });
    eventBus._on("rotationchanging", this.onRotationChanging.bind(this), {
      signal: _signal
    });
    eventBus._on("setpreference", this.onSetPreference.bind(this), {
      signal: _signal
    });
    eventBus._on("switchannotationeditorparams", function (evt) {
      return _this5.updateParams(evt.type, evt.value);
    }, {
      signal: _signal
    });
    _classPrivateFieldLooseBase(this, _addSelectionListener)[_addSelectionListener]();
    _classPrivateFieldLooseBase(this, _addDragAndDropListeners)[_addDragAndDropListeners]();
    _classPrivateFieldLooseBase(this, _addKeyboardManager)[_addKeyboardManager]();
    _classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage] = pdfDocument.annotationStorage;
    _classPrivateFieldLooseBase(this, _filterFactory)[_filterFactory] = pdfDocument.filterFactory;
    _classPrivateFieldLooseBase(this, _pageColors)[_pageColors] = pageColors;
    _classPrivateFieldLooseBase(this, _highlightColors)[_highlightColors] = highlightColors || null;
    _classPrivateFieldLooseBase(this, _enableHighlightFloatingButton)[_enableHighlightFloatingButton] = enableHighlightFloatingButton;
    _classPrivateFieldLooseBase(this, _enableUpdatedAddImage)[_enableUpdatedAddImage] = enableUpdatedAddImage;
    _classPrivateFieldLooseBase(this, _enableNewAltTextWhenAddingImage)[_enableNewAltTextWhenAddingImage] = enableNewAltTextWhenAddingImage;
    _classPrivateFieldLooseBase(this, _mlManager)[_mlManager] = mlManager || null;
    this.viewParameters = {
      realScale: _PixelsPerInch.PDF_TO_CSS_UNITS,
      rotation: 0
    };
    this.isShiftKeyDown = false;
  }
  return _createClass(_AnnotationEditorUIManager, [{
    key: "destroy",
    value: function destroy() {
      var _classPrivateFieldLoo15, _classPrivateFieldLoo16, _classPrivateFieldLoo17, _classPrivateFieldLoo18;
      (_classPrivateFieldLoo15 = _classPrivateFieldLooseBase(this, _updateModeCapability)[_updateModeCapability]) === null || _classPrivateFieldLoo15 === void 0 || _classPrivateFieldLoo15.resolve();
      _classPrivateFieldLooseBase(this, _updateModeCapability)[_updateModeCapability] = null;
      (_classPrivateFieldLoo16 = _classPrivateFieldLooseBase(this, _abortController)[_abortController]) === null || _classPrivateFieldLoo16 === void 0 || _classPrivateFieldLoo16.abort();
      _classPrivateFieldLooseBase(this, _abortController)[_abortController] = null;
      this._signal = null;
      var _iterator9 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values()),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var layer = _step9.value;
          layer.destroy();
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].clear();
      _classPrivateFieldLooseBase(this, _allEditors)[_allEditors].clear();
      _classPrivateFieldLooseBase(this, _editorsToRescale)[_editorsToRescale].clear();
      _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor] = null;
      _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].clear();
      _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].destroy();
      (_classPrivateFieldLoo17 = _classPrivateFieldLooseBase(this, _altTextManager)[_altTextManager]) === null || _classPrivateFieldLoo17 === void 0 || _classPrivateFieldLoo17.destroy();
      (_classPrivateFieldLoo18 = _classPrivateFieldLooseBase(this, _highlightToolbar)[_highlightToolbar]) === null || _classPrivateFieldLoo18 === void 0 || _classPrivateFieldLoo18.hide();
      _classPrivateFieldLooseBase(this, _highlightToolbar)[_highlightToolbar] = null;
      if (_classPrivateFieldLooseBase(this, _focusMainContainerTimeoutId)[_focusMainContainerTimeoutId]) {
        clearTimeout(_classPrivateFieldLooseBase(this, _focusMainContainerTimeoutId)[_focusMainContainerTimeoutId]);
        _classPrivateFieldLooseBase(this, _focusMainContainerTimeoutId)[_focusMainContainerTimeoutId] = null;
      }
      if (_classPrivateFieldLooseBase(this, _translationTimeoutId)[_translationTimeoutId]) {
        clearTimeout(_classPrivateFieldLooseBase(this, _translationTimeoutId)[_translationTimeoutId]);
        _classPrivateFieldLooseBase(this, _translationTimeoutId)[_translationTimeoutId] = null;
      }
    }
  }, {
    key: "combinedSignal",
    value: function combinedSignal(ac) {
      return AbortSignal.any([this._signal, ac.signal]);
    }
  }, {
    key: "mlManager",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _mlManager)[_mlManager];
    }
  }, {
    key: "useNewAltTextFlow",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _enableUpdatedAddImage)[_enableUpdatedAddImage];
    }
  }, {
    key: "useNewAltTextWhenAddingImage",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _enableNewAltTextWhenAddingImage)[_enableNewAltTextWhenAddingImage];
    }
  }, {
    key: "hcmFilter",
    get: function get() {
      return _shadow(this, "hcmFilter", _classPrivateFieldLooseBase(this, _pageColors)[_pageColors] ? _classPrivateFieldLooseBase(this, _filterFactory)[_filterFactory].addHCMFilter(_classPrivateFieldLooseBase(this, _pageColors)[_pageColors].foreground, _classPrivateFieldLooseBase(this, _pageColors)[_pageColors].background) : "none");
    }
  }, {
    key: "direction",
    get: function get() {
      return _shadow(this, "direction", getComputedStyle(_classPrivateFieldLooseBase(this, _container)[_container]).direction);
    }
  }, {
    key: "highlightColors",
    get: function get() {
      return _shadow(this, "highlightColors", _classPrivateFieldLooseBase(this, _highlightColors)[_highlightColors] ? new Map(_classPrivateFieldLooseBase(this, _highlightColors)[_highlightColors].split(",").map(function (pair) {
        return pair.split("=").map(function (x) {
          return x.trim();
        });
      })) : null);
    }
  }, {
    key: "highlightColorNames",
    get: function get() {
      return _shadow(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, function (e) {
        return e.reverse();
      })) : null);
    }
  }, {
    key: "setMainHighlightColorPicker",
    value: function setMainHighlightColorPicker(colorPicker) {
      _classPrivateFieldLooseBase(this, _mainHighlightColorPicker)[_mainHighlightColorPicker] = colorPicker;
    }
  }, {
    key: "editAltText",
    value: function editAltText(editor) {
      var _classPrivateFieldLoo19;
      var firstTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      (_classPrivateFieldLoo19 = _classPrivateFieldLooseBase(this, _altTextManager)[_altTextManager]) === null || _classPrivateFieldLoo19 === void 0 || _classPrivateFieldLoo19.editAltText(this, editor, firstTime);
    }
  }, {
    key: "switchToMode",
    value: function switchToMode(mode, callback) {
      this._eventBus.on("annotationeditormodechanged", callback, {
        once: true,
        signal: this._signal
      });
      this._eventBus.dispatch("showannotationeditorui", {
        source: this,
        mode: mode
      });
    }
  }, {
    key: "setPreference",
    value: function setPreference(name, value) {
      this._eventBus.dispatch("setpreference", {
        source: this,
        name: name,
        value: value
      });
    }
  }, {
    key: "onSetPreference",
    value: function onSetPreference(_ref14) {
      var name = _ref14.name,
        value = _ref14.value;
      switch (name) {
        case "enableNewAltTextWhenAddingImage":
          _classPrivateFieldLooseBase(this, _enableNewAltTextWhenAddingImage)[_enableNewAltTextWhenAddingImage] = value;
          break;
      }
    }
  }, {
    key: "onPageChanging",
    value: function onPageChanging(_ref15) {
      var pageNumber = _ref15.pageNumber;
      _classPrivateFieldLooseBase(this, _currentPageIndex)[_currentPageIndex] = pageNumber - 1;
    }
  }, {
    key: "focusMainContainer",
    value: function focusMainContainer() {
      _classPrivateFieldLooseBase(this, _container)[_container].focus();
    }
  }, {
    key: "findParent",
    value: function findParent(x, y) {
      var _iterator10 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values()),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var layer = _step10.value;
          var _layer$div$getBoundin = layer.div.getBoundingClientRect(),
            layerX = _layer$div$getBoundin.x,
            layerY = _layer$div$getBoundin.y,
            width = _layer$div$getBoundin.width,
            height = _layer$div$getBoundin.height;
          if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) {
            return layer;
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      return null;
    }
  }, {
    key: "disableUserSelect",
    value: function disableUserSelect() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _classPrivateFieldLooseBase(this, _viewer)[_viewer].classList.toggle("noUserSelect", value);
    }
  }, {
    key: "addShouldRescale",
    value: function addShouldRescale(editor) {
      _classPrivateFieldLooseBase(this, _editorsToRescale)[_editorsToRescale].add(editor);
    }
  }, {
    key: "removeShouldRescale",
    value: function removeShouldRescale(editor) {
      _classPrivateFieldLooseBase(this, _editorsToRescale)[_editorsToRescale].delete(editor);
    }
  }, {
    key: "onScaleChanging",
    value: function onScaleChanging(_ref16) {
      var scale = _ref16.scale;
      this.commitOrRemove();
      this.viewParameters.realScale = scale * _PixelsPerInch.PDF_TO_CSS_UNITS;
      var _iterator11 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editorsToRescale)[_editorsToRescale]),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var editor = _step11.value;
          editor.onScaleChanging();
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
  }, {
    key: "onRotationChanging",
    value: function onRotationChanging(_ref17) {
      var pagesRotation = _ref17.pagesRotation;
      this.commitOrRemove();
      this.viewParameters.rotation = pagesRotation;
    }
  }, {
    key: "highlightSelection",
    value: function highlightSelection() {
      var _this6 = this;
      var methodOfCreation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var selection = document.getSelection();
      if (!selection || selection.isCollapsed) {
        return;
      }
      var anchorNode = selection.anchorNode,
        anchorOffset = selection.anchorOffset,
        focusNode = selection.focusNode,
        focusOffset = selection.focusOffset;
      var text = selection.toString();
      var anchorElement = _classPrivateFieldLooseBase(this, _getAnchorElementForSelection)[_getAnchorElementForSelection](selection);
      var textLayer = anchorElement.closest(".textLayer");
      var boxes = this.getSelectionBoxes(textLayer);
      if (!boxes) {
        return;
      }
      selection.empty();
      var layer = _classPrivateFieldLooseBase(this, _getLayerForTextLayer)[_getLayerForTextLayer](textLayer);
      var isNoneMode = _classPrivateFieldLooseBase(this, _mode)[_mode] === _AnnotationEditorType.NONE;
      var callback = function callback() {
        layer === null || layer === void 0 || layer.createAndAddNewEditor({
          x: 0,
          y: 0
        }, false, {
          methodOfCreation: methodOfCreation,
          boxes: boxes,
          anchorNode: anchorNode,
          anchorOffset: anchorOffset,
          focusNode: focusNode,
          focusOffset: focusOffset,
          text: text
        });
        if (isNoneMode) {
          _this6.showAllEditors("highlight", true, true);
        }
      };
      if (isNoneMode) {
        this.switchToMode(_AnnotationEditorType.HIGHLIGHT, callback);
        return;
      }
      callback();
    }
  }, {
    key: "addToAnnotationStorage",
    value: function addToAnnotationStorage(editor) {
      if (!editor.isEmpty() && _classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage] && !_classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage].has(editor.id)) {
        _classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage].setValue(editor.id, editor);
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      this.isShiftKeyDown = false;
      if (_classPrivateFieldLooseBase(this, _highlightWhenShiftUp)[_highlightWhenShiftUp]) {
        _classPrivateFieldLooseBase(this, _highlightWhenShiftUp)[_highlightWhenShiftUp] = false;
        _classPrivateFieldLooseBase(this, _onSelectEnd)[_onSelectEnd]("main_toolbar");
      }
      if (!this.hasSelection) {
        return;
      }
      var _document = document,
        activeElement = _document.activeElement;
      var _iterator12 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var editor = _step12.value;
          if (editor.div.contains(activeElement)) {
            _classPrivateFieldLooseBase(this, _lastActiveElement)[_lastActiveElement] = [editor, activeElement];
            editor._focusEventsAllowed = false;
            break;
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (!_classPrivateFieldLooseBase(this, _lastActiveElement)[_lastActiveElement]) {
        return;
      }
      var _classPrivateFieldLoo20 = _slicedToArray(_classPrivateFieldLooseBase(this, _lastActiveElement)[_lastActiveElement], 2),
        lastEditor = _classPrivateFieldLoo20[0],
        lastActiveElement = _classPrivateFieldLoo20[1];
      _classPrivateFieldLooseBase(this, _lastActiveElement)[_lastActiveElement] = null;
      lastActiveElement.addEventListener("focusin", function () {
        lastEditor._focusEventsAllowed = true;
      }, {
        once: true,
        signal: this._signal
      });
      lastActiveElement.focus();
    }
  }, {
    key: "addEditListeners",
    value: function addEditListeners() {
      _classPrivateFieldLooseBase(this, _addKeyboardManager)[_addKeyboardManager]();
      _classPrivateFieldLooseBase(this, _addCopyPasteListeners)[_addCopyPasteListeners]();
    }
  }, {
    key: "removeEditListeners",
    value: function removeEditListeners() {
      _classPrivateFieldLooseBase(this, _removeKeyboardManager)[_removeKeyboardManager]();
      _classPrivateFieldLooseBase(this, _removeCopyPasteListeners)[_removeCopyPasteListeners]();
    }
  }, {
    key: "dragOver",
    value: function dragOver(event) {
      var _iterator13 = _createForOfIteratorHelper(event.dataTransfer.items),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _ref18 = _step13.value;
          var type = _ref18.type;
          var _iterator14 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]),
            _step14;
          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var editorType = _step14.value;
              if (editorType.isHandlingMimeForPasting(type)) {
                event.dataTransfer.dropEffect = "copy";
                event.preventDefault();
                return;
              }
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }
  }, {
    key: "drop",
    value: function drop(event) {
      var _iterator15 = _createForOfIteratorHelper(event.dataTransfer.items),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var item = _step15.value;
          var _iterator16 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var editorType = _step16.value;
              if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                event.preventDefault();
                return;
              }
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }
  }, {
    key: "copy",
    value: function copy(event) {
      var _classPrivateFieldLoo21;
      event.preventDefault();
      (_classPrivateFieldLoo21 = _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor]) === null || _classPrivateFieldLoo21 === void 0 || _classPrivateFieldLoo21.commitOrRemove();
      if (!this.hasSelection) {
        return;
      }
      var editors = [];
      var _iterator17 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var editor = _step17.value;
          var serialized = editor.serialize(true);
          if (serialized) {
            editors.push(serialized);
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
      if (editors.length === 0) {
        return;
      }
      event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
    }
  }, {
    key: "cut",
    value: function cut(event) {
      this.copy(event);
      this.delete();
    }
  }, {
    key: "paste",
    value: function () {
      var _paste = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(event) {
        var _this7 = this;
        var clipboardData, _iterator18, _step18, item, _iterator20, _step20, editorType, data, layer, newEditors, _iterator19, _step19, editor, deserializedEditor, cmd, undo;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              event.preventDefault();
              clipboardData = event.clipboardData;
              _iterator18 = _createForOfIteratorHelper(clipboardData.items);
              _context6.prev = 3;
              _iterator18.s();
            case 5:
              if ((_step18 = _iterator18.n()).done) {
                _context6.next = 27;
                break;
              }
              item = _step18.value;
              _iterator20 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]);
              _context6.prev = 8;
              _iterator20.s();
            case 10:
              if ((_step20 = _iterator20.n()).done) {
                _context6.next = 17;
                break;
              }
              editorType = _step20.value;
              if (!editorType.isHandlingMimeForPasting(item.type)) {
                _context6.next = 15;
                break;
              }
              editorType.paste(item, this.currentLayer);
              return _context6.abrupt("return");
            case 15:
              _context6.next = 10;
              break;
            case 17:
              _context6.next = 22;
              break;
            case 19:
              _context6.prev = 19;
              _context6.t0 = _context6["catch"](8);
              _iterator20.e(_context6.t0);
            case 22:
              _context6.prev = 22;
              _iterator20.f();
              return _context6.finish(22);
            case 25:
              _context6.next = 5;
              break;
            case 27:
              _context6.next = 32;
              break;
            case 29:
              _context6.prev = 29;
              _context6.t1 = _context6["catch"](3);
              _iterator18.e(_context6.t1);
            case 32:
              _context6.prev = 32;
              _iterator18.f();
              return _context6.finish(32);
            case 35:
              data = clipboardData.getData("application/pdfjs");
              if (data) {
                _context6.next = 38;
                break;
              }
              return _context6.abrupt("return");
            case 38:
              _context6.prev = 38;
              data = JSON.parse(data);
              _context6.next = 46;
              break;
            case 42:
              _context6.prev = 42;
              _context6.t2 = _context6["catch"](38);
              warn("paste: \"".concat(_context6.t2.message, "\"."));
              return _context6.abrupt("return");
            case 46:
              if (Array.isArray(data)) {
                _context6.next = 48;
                break;
              }
              return _context6.abrupt("return");
            case 48:
              this.unselectAll();
              layer = this.currentLayer;
              _context6.prev = 50;
              newEditors = [];
              _iterator19 = _createForOfIteratorHelper(data);
              _context6.prev = 53;
              _iterator19.s();
            case 55:
              if ((_step19 = _iterator19.n()).done) {
                _context6.next = 65;
                break;
              }
              editor = _step19.value;
              _context6.next = 59;
              return layer.deserialize(editor);
            case 59:
              deserializedEditor = _context6.sent;
              if (deserializedEditor) {
                _context6.next = 62;
                break;
              }
              return _context6.abrupt("return");
            case 62:
              newEditors.push(deserializedEditor);
            case 63:
              _context6.next = 55;
              break;
            case 65:
              _context6.next = 70;
              break;
            case 67:
              _context6.prev = 67;
              _context6.t3 = _context6["catch"](53);
              _iterator19.e(_context6.t3);
            case 70:
              _context6.prev = 70;
              _iterator19.f();
              return _context6.finish(70);
            case 73:
              cmd = function cmd() {
                for (var _i = 0, _newEditors = newEditors; _i < _newEditors.length; _i++) {
                  var editor = _newEditors[_i];
                  _classPrivateFieldLooseBase(_this7, _addEditorToLayer)[_addEditorToLayer](editor);
                }
                _classPrivateFieldLooseBase(_this7, _selectEditors)[_selectEditors](newEditors);
              };
              undo = function undo() {
                for (var _i2 = 0, _newEditors2 = newEditors; _i2 < _newEditors2.length; _i2++) {
                  var editor = _newEditors2[_i2];
                  editor.remove();
                }
              };
              this.addCommands({
                cmd: cmd,
                undo: undo,
                mustExec: true
              });
              _context6.next = 81;
              break;
            case 78:
              _context6.prev = 78;
              _context6.t4 = _context6["catch"](50);
              warn("paste: \"".concat(_context6.t4.message, "\"."));
            case 81:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[3, 29, 32, 35], [8, 19, 22, 25], [38, 42], [50, 78], [53, 67, 70, 73]]);
      }));
      function paste(_x8) {
        return _paste.apply(this, arguments);
      }
      return paste;
    }()
  }, {
    key: "keydown",
    value: function keydown(event) {
      if (!this.isShiftKeyDown && event.key === "Shift") {
        this.isShiftKeyDown = true;
      }
      if (_classPrivateFieldLooseBase(this, _mode)[_mode] !== _AnnotationEditorType.NONE && !this.isEditorHandlingKeyboard) {
        _AnnotationEditorUIManager._keyboardManager.exec(this, event);
      }
    }
  }, {
    key: "keyup",
    value: function keyup(event) {
      if (this.isShiftKeyDown && event.key === "Shift") {
        this.isShiftKeyDown = false;
        if (_classPrivateFieldLooseBase(this, _highlightWhenShiftUp)[_highlightWhenShiftUp]) {
          _classPrivateFieldLooseBase(this, _highlightWhenShiftUp)[_highlightWhenShiftUp] = false;
          _classPrivateFieldLooseBase(this, _onSelectEnd)[_onSelectEnd]("main_toolbar");
        }
      }
    }
  }, {
    key: "onEditingAction",
    value: function onEditingAction(_ref19) {
      var name = _ref19.name;
      switch (name) {
        case "undo":
        case "redo":
        case "delete":
        case "selectAll":
          this[name]();
          break;
        case "highlightSelection":
          this.highlightSelection("context_menu");
          break;
      }
    }
  }, {
    key: "setEditingState",
    value: function setEditingState(isEditing) {
      if (isEditing) {
        _classPrivateFieldLooseBase(this, _addFocusManager)[_addFocusManager]();
        _classPrivateFieldLooseBase(this, _addCopyPasteListeners)[_addCopyPasteListeners]();
        _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
          isEditing: _classPrivateFieldLooseBase(this, _mode)[_mode] !== _AnnotationEditorType.NONE,
          isEmpty: _classPrivateFieldLooseBase(this, _isEmpty)[_isEmpty](),
          hasSomethingToUndo: _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].hasSomethingToUndo(),
          hasSomethingToRedo: _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].hasSomethingToRedo(),
          hasSelectedEditor: false
        });
      } else {
        _classPrivateFieldLooseBase(this, _removeFocusManager)[_removeFocusManager]();
        _classPrivateFieldLooseBase(this, _removeCopyPasteListeners)[_removeCopyPasteListeners]();
        _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
          isEditing: false
        });
        this.disableUserSelect(false);
      }
    }
  }, {
    key: "registerEditorTypes",
    value: function registerEditorTypes(types) {
      if (_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]) {
        return;
      }
      _classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes] = types;
      var _iterator21 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var editorType = _step21.value;
          _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI](editorType.defaultPropertiesToUpdate);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }
  }, {
    key: "getId",
    value: function getId() {
      return _classPrivateFieldLooseBase(this, _idManager)[_idManager].id;
    }
  }, {
    key: "currentLayer",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].get(_classPrivateFieldLooseBase(this, _currentPageIndex)[_currentPageIndex]);
    }
  }, {
    key: "getLayer",
    value: function getLayer(pageIndex) {
      return _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].get(pageIndex);
    }
  }, {
    key: "currentPageIndex",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _currentPageIndex)[_currentPageIndex];
    }
  }, {
    key: "addLayer",
    value: function addLayer(layer) {
      _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].set(layer.pageIndex, layer);
      if (_classPrivateFieldLooseBase(this, _isEnabled)[_isEnabled]) {
        layer.enable();
      } else {
        layer.disable();
      }
    }
  }, {
    key: "removeLayer",
    value: function removeLayer(layer) {
      _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].delete(layer.pageIndex);
    }
  }, {
    key: "updateMode",
    value: function () {
      var _updateMode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(mode) {
        var editId,
          isFromKeyboard,
          _iterator22,
          _step22,
          layer,
          _iterator23,
          _step23,
          editor,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              editId = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;
              isFromKeyboard = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : false;
              if (!(_classPrivateFieldLooseBase(this, _mode)[_mode] === mode)) {
                _context7.next = 4;
                break;
              }
              return _context7.abrupt("return");
            case 4:
              if (!_classPrivateFieldLooseBase(this, _updateModeCapability)[_updateModeCapability]) {
                _context7.next = 9;
                break;
              }
              _context7.next = 7;
              return _classPrivateFieldLooseBase(this, _updateModeCapability)[_updateModeCapability].promise;
            case 7:
              if (_classPrivateFieldLooseBase(this, _updateModeCapability)[_updateModeCapability]) {
                _context7.next = 9;
                break;
              }
              return _context7.abrupt("return");
            case 9:
              _classPrivateFieldLooseBase(this, _updateModeCapability)[_updateModeCapability] = Promise.withResolvers();
              _classPrivateFieldLooseBase(this, _mode)[_mode] = mode;
              if (!(mode === _AnnotationEditorType.NONE)) {
                _context7.next = 16;
                break;
              }
              this.setEditingState(false);
              _classPrivateFieldLooseBase(this, _disableAll)[_disableAll]();
              _classPrivateFieldLooseBase(this, _updateModeCapability)[_updateModeCapability].resolve();
              return _context7.abrupt("return");
            case 16:
              this.setEditingState(true);
              _context7.next = 19;
              return _classPrivateFieldLooseBase(this, _enableAll)[_enableAll]();
            case 19:
              this.unselectAll();
              _iterator22 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values());
              try {
                for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                  layer = _step22.value;
                  layer.updateMode(mode);
                }
              } catch (err) {
                _iterator22.e(err);
              } finally {
                _iterator22.f();
              }
              if (editId) {
                _context7.next = 26;
                break;
              }
              if (isFromKeyboard) {
                this.addNewEditorFromKeyboard();
              }
              _classPrivateFieldLooseBase(this, _updateModeCapability)[_updateModeCapability].resolve();
              return _context7.abrupt("return");
            case 26:
              _iterator23 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].values());
              try {
                for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                  editor = _step23.value;
                  if (editor.annotationElementId === editId) {
                    this.setSelected(editor);
                    editor.enterInEditMode();
                  } else {
                    editor.unselect();
                  }
                }
              } catch (err) {
                _iterator23.e(err);
              } finally {
                _iterator23.f();
              }
              _classPrivateFieldLooseBase(this, _updateModeCapability)[_updateModeCapability].resolve();
            case 29:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function updateMode(_x9) {
        return _updateMode.apply(this, arguments);
      }
      return updateMode;
    }()
  }, {
    key: "addNewEditorFromKeyboard",
    value: function addNewEditorFromKeyboard() {
      if (this.currentLayer.canCreateNewEmptyEditor()) {
        this.currentLayer.addNewEditor();
      }
    }
  }, {
    key: "updateToolbar",
    value: function updateToolbar(mode) {
      if (mode === _classPrivateFieldLooseBase(this, _mode)[_mode]) {
        return;
      }
      this._eventBus.dispatch("switchannotationeditormode", {
        source: this,
        mode: mode
      });
    }
  }, {
    key: "updateParams",
    value: function updateParams(type, value) {
      var _classPrivateFieldLoo22, _classPrivateFieldLoo23;
      if (!_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]) {
        return;
      }
      switch (type) {
        case _AnnotationEditorParamsType.CREATE:
          this.currentLayer.addNewEditor();
          return;
        case _AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR:
          (_classPrivateFieldLoo22 = _classPrivateFieldLooseBase(this, _mainHighlightColorPicker)[_mainHighlightColorPicker]) === null || _classPrivateFieldLoo22 === void 0 || _classPrivateFieldLoo22.updateColor(value);
          break;
        case _AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL:
          this._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
              type: "editing",
              data: {
                type: "highlight",
                action: "toggle_visibility"
              }
            }
          });
          ((_classPrivateFieldLoo23 = _classPrivateFieldLooseBase(this, _showAllStates))[_showAllStates] || (_classPrivateFieldLoo23[_showAllStates] = new Map())).set(type, value);
          this.showAllEditors("highlight", value);
          break;
      }
      var _iterator24 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var editor = _step24.value;
          editor.updateParams(type, value);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      var _iterator25 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editorTypes)[_editorTypes]),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var editorType = _step25.value;
          editorType.updateDefaultParams(type, value);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
    }
  }, {
    key: "showAllEditors",
    value: function showAllEditors(type, visible) {
      var _classPrivateFieldLoo24, _classPrivateFieldLoo25;
      var updateButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _iterator26 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].values()),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var editor = _step26.value;
          if (editor.editorType === type) {
            editor.show(visible);
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      var state = (_classPrivateFieldLoo24 = (_classPrivateFieldLoo25 = _classPrivateFieldLooseBase(this, _showAllStates)[_showAllStates]) === null || _classPrivateFieldLoo25 === void 0 ? void 0 : _classPrivateFieldLoo25.get(_AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL)) !== null && _classPrivateFieldLoo24 !== void 0 ? _classPrivateFieldLoo24 : true;
      if (state !== visible) {
        _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI]([[_AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL, visible]]);
      }
    }
  }, {
    key: "enableWaiting",
    value: function enableWaiting() {
      var mustWait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (_classPrivateFieldLooseBase(this, _isWaiting)[_isWaiting] === mustWait) {
        return;
      }
      _classPrivateFieldLooseBase(this, _isWaiting)[_isWaiting] = mustWait;
      var _iterator27 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values()),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var layer = _step27.value;
          if (mustWait) {
            layer.disableClick();
          } else {
            layer.enableClick();
          }
          layer.div.classList.toggle("waiting", mustWait);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
    }
  }, {
    key: "getEditors",
    value: function getEditors(pageIndex) {
      var editors = [];
      var _iterator28 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].values()),
        _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var editor = _step28.value;
          if (editor.pageIndex === pageIndex) {
            editors.push(editor);
          }
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
      return editors;
    }
  }, {
    key: "getEditor",
    value: function getEditor(id) {
      return _classPrivateFieldLooseBase(this, _allEditors)[_allEditors].get(id);
    }
  }, {
    key: "addEditor",
    value: function addEditor(editor) {
      _classPrivateFieldLooseBase(this, _allEditors)[_allEditors].set(editor.id, editor);
    }
  }, {
    key: "removeEditor",
    value: function removeEditor(editor) {
      var _this8 = this;
      if (editor.div.contains(document.activeElement)) {
        if (_classPrivateFieldLooseBase(this, _focusMainContainerTimeoutId)[_focusMainContainerTimeoutId]) {
          clearTimeout(_classPrivateFieldLooseBase(this, _focusMainContainerTimeoutId)[_focusMainContainerTimeoutId]);
        }
        _classPrivateFieldLooseBase(this, _focusMainContainerTimeoutId)[_focusMainContainerTimeoutId] = setTimeout(function () {
          _this8.focusMainContainer();
          _classPrivateFieldLooseBase(_this8, _focusMainContainerTimeoutId)[_focusMainContainerTimeoutId] = null;
        }, 0);
      }
      _classPrivateFieldLooseBase(this, _allEditors)[_allEditors].delete(editor.id);
      this.unselect(editor);
      if (!editor.annotationElementId || !_classPrivateFieldLooseBase(this, _deletedAnnotationsElementIds)[_deletedAnnotationsElementIds].has(editor.annotationElementId)) {
        var _classPrivateFieldLoo26;
        (_classPrivateFieldLoo26 = _classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage]) === null || _classPrivateFieldLoo26 === void 0 || _classPrivateFieldLoo26.remove(editor.id);
      }
    }
  }, {
    key: "addDeletedAnnotationElement",
    value: function addDeletedAnnotationElement(editor) {
      _classPrivateFieldLooseBase(this, _deletedAnnotationsElementIds)[_deletedAnnotationsElementIds].add(editor.annotationElementId);
      this.addChangedExistingAnnotation(editor);
      editor.deleted = true;
    }
  }, {
    key: "isDeletedAnnotationElement",
    value: function isDeletedAnnotationElement(annotationElementId) {
      return _classPrivateFieldLooseBase(this, _deletedAnnotationsElementIds)[_deletedAnnotationsElementIds].has(annotationElementId);
    }
  }, {
    key: "removeDeletedAnnotationElement",
    value: function removeDeletedAnnotationElement(editor) {
      _classPrivateFieldLooseBase(this, _deletedAnnotationsElementIds)[_deletedAnnotationsElementIds].delete(editor.annotationElementId);
      this.removeChangedExistingAnnotation(editor);
      editor.deleted = false;
    }
  }, {
    key: "setActiveEditor",
    value: function setActiveEditor(editor) {
      if (_classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor] === editor) {
        return;
      }
      _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor] = editor;
      if (editor) {
        _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI](editor.propertiesToUpdate);
      }
    }
  }, {
    key: "updateUI",
    value: function updateUI(editor) {
      if (_classPrivateFieldLooseBase(this, _lastSelectedEditor)[_lastSelectedEditor] === editor) {
        _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI](editor.propertiesToUpdate);
      }
    }
  }, {
    key: "toggleSelected",
    value: function toggleSelected(editor) {
      if (_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].has(editor)) {
        _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].delete(editor);
        editor.unselect();
        _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
          hasSelectedEditor: this.hasSelection
        });
        return;
      }
      _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].add(editor);
      editor.select();
      _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI](editor.propertiesToUpdate);
      _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
        hasSelectedEditor: true
      });
    }
  }, {
    key: "setSelected",
    value: function setSelected(editor) {
      var _iterator29 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var ed = _step29.value;
          if (ed !== editor) {
            ed.unselect();
          }
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
      _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].clear();
      _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].add(editor);
      editor.select();
      _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI](editor.propertiesToUpdate);
      _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
        hasSelectedEditor: true
      });
    }
  }, {
    key: "isSelected",
    value: function isSelected(editor) {
      return _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].has(editor);
    }
  }, {
    key: "firstSelectedEditor",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].values().next().value;
    }
  }, {
    key: "unselect",
    value: function unselect(editor) {
      editor.unselect();
      _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].delete(editor);
      _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
        hasSelectedEditor: this.hasSelection
      });
    }
  }, {
    key: "hasSelection",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].size !== 0;
    }
  }, {
    key: "isEnterHandled",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].size === 1 && this.firstSelectedEditor.isEnterHandled;
    }
  }, {
    key: "undo",
    value: function undo() {
      _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].undo();
      _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
        hasSomethingToUndo: _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].hasSomethingToUndo(),
        hasSomethingToRedo: true,
        isEmpty: _classPrivateFieldLooseBase(this, _isEmpty)[_isEmpty]()
      });
    }
  }, {
    key: "redo",
    value: function redo() {
      _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].redo();
      _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
        hasSomethingToUndo: true,
        hasSomethingToRedo: _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].hasSomethingToRedo(),
        isEmpty: _classPrivateFieldLooseBase(this, _isEmpty)[_isEmpty]()
      });
    }
  }, {
    key: "addCommands",
    value: function addCommands(params) {
      _classPrivateFieldLooseBase(this, _commandManager)[_commandManager].add(params);
      _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
        hasSomethingToUndo: true,
        hasSomethingToRedo: false,
        isEmpty: _classPrivateFieldLooseBase(this, _isEmpty)[_isEmpty]()
      });
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _this9 = this;
      this.commitOrRemove();
      if (!this.hasSelection) {
        return;
      }
      var editors = _toConsumableArray(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]);
      var cmd = function cmd() {
        var _iterator30 = _createForOfIteratorHelper(editors),
          _step30;
        try {
          for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
            var editor = _step30.value;
            editor.remove();
          }
        } catch (err) {
          _iterator30.e(err);
        } finally {
          _iterator30.f();
        }
      };
      var undo = function undo() {
        var _iterator31 = _createForOfIteratorHelper(editors),
          _step31;
        try {
          for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
            var editor = _step31.value;
            _classPrivateFieldLooseBase(_this9, _addEditorToLayer)[_addEditorToLayer](editor);
          }
        } catch (err) {
          _iterator31.e(err);
        } finally {
          _iterator31.f();
        }
      };
      this.addCommands({
        cmd: cmd,
        undo: undo,
        mustExec: true
      });
    }
  }, {
    key: "commitOrRemove",
    value: function commitOrRemove() {
      var _classPrivateFieldLoo27;
      (_classPrivateFieldLoo27 = _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor]) === null || _classPrivateFieldLoo27 === void 0 || _classPrivateFieldLoo27.commitOrRemove();
    }
  }, {
    key: "hasSomethingToControl",
    value: function hasSomethingToControl() {
      return _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor] || this.hasSelection;
    }
  }, {
    key: "selectAll",
    value: function selectAll() {
      var _iterator32 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var editor = _step32.value;
          editor.commit();
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      _classPrivateFieldLooseBase(this, _selectEditors)[_selectEditors](_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].values());
    }
  }, {
    key: "unselectAll",
    value: function unselectAll() {
      if (_classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor]) {
        _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor].commitOrRemove();
        if (_classPrivateFieldLooseBase(this, _mode)[_mode] !== _AnnotationEditorType.NONE) {
          return;
        }
      }
      if (!this.hasSelection) {
        return;
      }
      var _iterator33 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
        _step33;
      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var editor = _step33.value;
          editor.unselect();
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
      _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].clear();
      _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
        hasSelectedEditor: false
      });
    }
  }, {
    key: "translateSelectedEditors",
    value: function translateSelectedEditors(x, y) {
      var _this10 = this;
      var noCommit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!noCommit) {
        this.commitOrRemove();
      }
      if (!this.hasSelection) {
        return;
      }
      _classPrivateFieldLooseBase(this, _translation)[_translation][0] += x;
      _classPrivateFieldLooseBase(this, _translation)[_translation][1] += y;
      var _classPrivateFieldLoo28 = _slicedToArray(_classPrivateFieldLooseBase(this, _translation)[_translation], 2),
        totalX = _classPrivateFieldLoo28[0],
        totalY = _classPrivateFieldLoo28[1];
      var editors = _toConsumableArray(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]);
      var TIME_TO_WAIT = 1000;
      if (_classPrivateFieldLooseBase(this, _translationTimeoutId)[_translationTimeoutId]) {
        clearTimeout(_classPrivateFieldLooseBase(this, _translationTimeoutId)[_translationTimeoutId]);
      }
      _classPrivateFieldLooseBase(this, _translationTimeoutId)[_translationTimeoutId] = setTimeout(function () {
        _classPrivateFieldLooseBase(_this10, _translationTimeoutId)[_translationTimeoutId] = null;
        _classPrivateFieldLooseBase(_this10, _translation)[_translation][0] = _classPrivateFieldLooseBase(_this10, _translation)[_translation][1] = 0;
        _this10.addCommands({
          cmd: function cmd() {
            var _iterator34 = _createForOfIteratorHelper(editors),
              _step34;
            try {
              for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                var editor = _step34.value;
                if (_classPrivateFieldLooseBase(_this10, _allEditors)[_allEditors].has(editor.id)) {
                  editor.translateInPage(totalX, totalY);
                }
              }
            } catch (err) {
              _iterator34.e(err);
            } finally {
              _iterator34.f();
            }
          },
          undo: function undo() {
            var _iterator35 = _createForOfIteratorHelper(editors),
              _step35;
            try {
              for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
                var editor = _step35.value;
                if (_classPrivateFieldLooseBase(_this10, _allEditors)[_allEditors].has(editor.id)) {
                  editor.translateInPage(-totalX, -totalY);
                }
              }
            } catch (err) {
              _iterator35.e(err);
            } finally {
              _iterator35.f();
            }
          },
          mustExec: false
        });
      }, TIME_TO_WAIT);
      var _iterator36 = _createForOfIteratorHelper(editors),
        _step36;
      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var editor = _step36.value;
          editor.translateInPage(x, y);
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
    }
  }, {
    key: "setUpDragSession",
    value: function setUpDragSession() {
      if (!this.hasSelection) {
        return;
      }
      this.disableUserSelect(true);
      _classPrivateFieldLooseBase(this, _draggingEditors)[_draggingEditors] = new Map();
      var _iterator37 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var editor = _step37.value;
          _classPrivateFieldLooseBase(this, _draggingEditors)[_draggingEditors].set(editor, {
            savedX: editor.x,
            savedY: editor.y,
            savedPageIndex: editor.pageIndex,
            newX: 0,
            newY: 0,
            newPageIndex: -1
          });
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
    }
  }, {
    key: "endDragSession",
    value: function endDragSession() {
      var _this11 = this;
      if (!_classPrivateFieldLooseBase(this, _draggingEditors)[_draggingEditors]) {
        return false;
      }
      this.disableUserSelect(false);
      var map = _classPrivateFieldLooseBase(this, _draggingEditors)[_draggingEditors];
      _classPrivateFieldLooseBase(this, _draggingEditors)[_draggingEditors] = null;
      var mustBeAddedInUndoStack = false;
      var _iterator38 = _createForOfIteratorHelper(map),
        _step38;
      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var _ref20 = _step38.value;
          var _ref21 = _slicedToArray(_ref20, 2);
          var _ref21$ = _ref21[0];
          var x = _ref21$.x;
          var y = _ref21$.y;
          var pageIndex = _ref21$.pageIndex;
          var value = _ref21[1];
          value.newX = x;
          value.newY = y;
          value.newPageIndex = pageIndex;
          mustBeAddedInUndoStack || (mustBeAddedInUndoStack = x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex);
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
      if (!mustBeAddedInUndoStack) {
        return false;
      }
      var move = function move(editor, x, y, pageIndex) {
        if (_classPrivateFieldLooseBase(_this11, _allEditors)[_allEditors].has(editor.id)) {
          var parent = _classPrivateFieldLooseBase(_this11, _allLayers)[_allLayers].get(pageIndex);
          if (parent) {
            editor._setParentAndPosition(parent, x, y);
          } else {
            editor.pageIndex = pageIndex;
            editor.x = x;
            editor.y = y;
          }
        }
      };
      this.addCommands({
        cmd: function cmd() {
          var _iterator39 = _createForOfIteratorHelper(map),
            _step39;
          try {
            for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
              var _ref22 = _step39.value;
              var _ref23 = _slicedToArray(_ref22, 2);
              var editor = _ref23[0];
              var _ref23$ = _ref23[1];
              var newX = _ref23$.newX;
              var newY = _ref23$.newY;
              var newPageIndex = _ref23$.newPageIndex;
              move(editor, newX, newY, newPageIndex);
            }
          } catch (err) {
            _iterator39.e(err);
          } finally {
            _iterator39.f();
          }
        },
        undo: function undo() {
          var _iterator40 = _createForOfIteratorHelper(map),
            _step40;
          try {
            for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
              var _ref24 = _step40.value;
              var _ref25 = _slicedToArray(_ref24, 2);
              var editor = _ref25[0];
              var _ref25$ = _ref25[1];
              var savedX = _ref25$.savedX;
              var savedY = _ref25$.savedY;
              var savedPageIndex = _ref25$.savedPageIndex;
              move(editor, savedX, savedY, savedPageIndex);
            }
          } catch (err) {
            _iterator40.e(err);
          } finally {
            _iterator40.f();
          }
        },
        mustExec: true
      });
      return true;
    }
  }, {
    key: "dragSelectedEditors",
    value: function dragSelectedEditors(tx, ty) {
      if (!_classPrivateFieldLooseBase(this, _draggingEditors)[_draggingEditors]) {
        return;
      }
      var _iterator41 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _draggingEditors)[_draggingEditors].keys()),
        _step41;
      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var editor = _step41.value;
          editor.drag(tx, ty);
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }
    }
  }, {
    key: "rebuild",
    value: function rebuild(editor) {
      if (editor.parent === null) {
        var parent = this.getLayer(editor.pageIndex);
        if (parent) {
          parent.changeParent(editor);
          parent.addOrRebuild(editor);
        } else {
          this.addEditor(editor);
          this.addToAnnotationStorage(editor);
          editor.rebuild();
        }
      } else {
        editor.parent.addOrRebuild(editor);
      }
    }
  }, {
    key: "isEditorHandlingKeyboard",
    get: function get() {
      var _this$getActive;
      return ((_this$getActive = this.getActive()) === null || _this$getActive === void 0 ? void 0 : _this$getActive.shouldGetKeyboardEvents()) || _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
    }
  }, {
    key: "isActive",
    value: function isActive(editor) {
      return _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor] === editor;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      return _classPrivateFieldLooseBase(this, _activeEditor)[_activeEditor];
    }
  }, {
    key: "getMode",
    value: function getMode() {
      return _classPrivateFieldLooseBase(this, _mode)[_mode];
    }
  }, {
    key: "imageManager",
    get: function get() {
      return _shadow(this, "imageManager", new ImageManager());
    }
  }, {
    key: "getSelectionBoxes",
    value: function getSelectionBoxes(textLayer) {
      if (!textLayer) {
        return null;
      }
      var selection = document.getSelection();
      for (var i = 0, ii = selection.rangeCount; i < ii; i++) {
        if (!textLayer.contains(selection.getRangeAt(i).commonAncestorContainer)) {
          return null;
        }
      }
      var _textLayer$getBoundin = textLayer.getBoundingClientRect(),
        layerX = _textLayer$getBoundin.x,
        layerY = _textLayer$getBoundin.y,
        parentWidth = _textLayer$getBoundin.width,
        parentHeight = _textLayer$getBoundin.height;
      var rotator;
      switch (textLayer.getAttribute("data-main-rotation")) {
        case "90":
          rotator = function rotator(x, y, w, h) {
            return {
              x: (y - layerY) / parentHeight,
              y: 1 - (x + w - layerX) / parentWidth,
              width: h / parentHeight,
              height: w / parentWidth
            };
          };
          break;
        case "180":
          rotator = function rotator(x, y, w, h) {
            return {
              x: 1 - (x + w - layerX) / parentWidth,
              y: 1 - (y + h - layerY) / parentHeight,
              width: w / parentWidth,
              height: h / parentHeight
            };
          };
          break;
        case "270":
          rotator = function rotator(x, y, w, h) {
            return {
              x: 1 - (y + h - layerY) / parentHeight,
              y: (x - layerX) / parentWidth,
              width: h / parentHeight,
              height: w / parentWidth
            };
          };
          break;
        default:
          rotator = function rotator(x, y, w, h) {
            return {
              x: (x - layerX) / parentWidth,
              y: (y - layerY) / parentHeight,
              width: w / parentWidth,
              height: h / parentHeight
            };
          };
          break;
      }
      var boxes = [];
      for (var _i3 = 0, _ii = selection.rangeCount; _i3 < _ii; _i3++) {
        var range = selection.getRangeAt(_i3);
        if (range.collapsed) {
          continue;
        }
        var _iterator42 = _createForOfIteratorHelper(range.getClientRects()),
          _step42;
        try {
          for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
            var _ref26 = _step42.value;
            var x = _ref26.x;
            var y = _ref26.y;
            var width = _ref26.width;
            var height = _ref26.height;
            if (width === 0 || height === 0) {
              continue;
            }
            boxes.push(rotator(x, y, width, height));
          }
        } catch (err) {
          _iterator42.e(err);
        } finally {
          _iterator42.f();
        }
      }
      return boxes.length === 0 ? null : boxes;
    }
  }, {
    key: "addChangedExistingAnnotation",
    value: function addChangedExistingAnnotation(_ref27) {
      var _classPrivateFieldLoo29;
      var annotationElementId = _ref27.annotationElementId,
        id = _ref27.id;
      ((_classPrivateFieldLoo29 = _classPrivateFieldLooseBase(this, _changedExistingAnnotations))[_changedExistingAnnotations] || (_classPrivateFieldLoo29[_changedExistingAnnotations] = new Map())).set(annotationElementId, id);
    }
  }, {
    key: "removeChangedExistingAnnotation",
    value: function removeChangedExistingAnnotation(_ref28) {
      var _classPrivateFieldLoo30;
      var annotationElementId = _ref28.annotationElementId;
      (_classPrivateFieldLoo30 = _classPrivateFieldLooseBase(this, _changedExistingAnnotations)[_changedExistingAnnotations]) === null || _classPrivateFieldLoo30 === void 0 || _classPrivateFieldLoo30.delete(annotationElementId);
    }
  }, {
    key: "renderAnnotationElement",
    value: function renderAnnotationElement(annotation) {
      var _classPrivateFieldLoo31;
      var editorId = (_classPrivateFieldLoo31 = _classPrivateFieldLooseBase(this, _changedExistingAnnotations)[_changedExistingAnnotations]) === null || _classPrivateFieldLoo31 === void 0 ? void 0 : _classPrivateFieldLoo31.get(annotation.data.id);
      if (!editorId) {
        return;
      }
      var editor = _classPrivateFieldLooseBase(this, _annotationStorage)[_annotationStorage].getRawValue(editorId);
      if (!editor) {
        return;
      }
      if (_classPrivateFieldLooseBase(this, _mode)[_mode] === _AnnotationEditorType.NONE && !editor.hasBeenModified) {
        return;
      }
      editor.renderAnnotationElement(annotation);
    }
  }], [{
    key: "_keyboardManager",
    get: function get() {
      var proto = _AnnotationEditorUIManager.prototype;
      var arrowChecker = function arrowChecker(self) {
        return _classPrivateFieldLooseBase(self, _container)[_container].contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && self.hasSomethingToControl();
      };
      var textInputChecker = function textInputChecker(_self, _ref29) {
        var el = _ref29.target;
        if (el instanceof HTMLInputElement) {
          var type = el.type;
          return type !== "text" && type !== "number";
        }
        return true;
      };
      var small = this.TRANSLATE_SMALL;
      var big = this.TRANSLATE_BIG;
      return _shadow(this, "_keyboardManager", new KeyboardManager([[["ctrl+a", "mac+meta+a"], proto.selectAll, {
        checker: textInputChecker
      }], [["ctrl+z", "mac+meta+z"], proto.undo, {
        checker: textInputChecker
      }], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], proto.redo, {
        checker: textInputChecker
      }], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], proto.delete, {
        checker: textInputChecker
      }], [["Enter", "mac+Enter"], proto.addNewEditorFromKeyboard, {
        checker: function checker(self, _ref30) {
          var el = _ref30.target;
          return !(el instanceof HTMLButtonElement) && _classPrivateFieldLooseBase(self, _container)[_container].contains(el) && !self.isEnterHandled;
        }
      }], [[" ", "mac+ "], proto.addNewEditorFromKeyboard, {
        checker: function checker(self, _ref31) {
          var el = _ref31.target;
          return !(el instanceof HTMLButtonElement) && _classPrivateFieldLooseBase(self, _container)[_container].contains(document.activeElement);
        }
      }], [["Escape", "mac+Escape"], proto.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], proto.translateSelectedEditors, {
        args: [-small, 0],
        checker: arrowChecker
      }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], proto.translateSelectedEditors, {
        args: [-big, 0],
        checker: arrowChecker
      }], [["ArrowRight", "mac+ArrowRight"], proto.translateSelectedEditors, {
        args: [small, 0],
        checker: arrowChecker
      }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], proto.translateSelectedEditors, {
        args: [big, 0],
        checker: arrowChecker
      }], [["ArrowUp", "mac+ArrowUp"], proto.translateSelectedEditors, {
        args: [0, -small],
        checker: arrowChecker
      }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], proto.translateSelectedEditors, {
        args: [0, -big],
        checker: arrowChecker
      }], [["ArrowDown", "mac+ArrowDown"], proto.translateSelectedEditors, {
        args: [0, small],
        checker: arrowChecker
      }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], proto.translateSelectedEditors, {
        args: [0, big],
        checker: arrowChecker
      }]]));
    }
  }]);
}();
function _getAnchorElementForSelection2(_ref165) {
  var anchorNode = _ref165.anchorNode;
  return anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentElement : anchorNode;
}
function _getLayerForTextLayer2(textLayer) {
  var currentLayer = this.currentLayer;
  if (currentLayer.hasTextLayer(textLayer)) {
    return currentLayer;
  }
  var _iterator160 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values()),
    _step160;
  try {
    for (_iterator160.s(); !(_step160 = _iterator160.n()).done;) {
      var layer = _step160.value;
      if (layer.hasTextLayer(textLayer)) {
        return layer;
      }
    }
  } catch (err) {
    _iterator160.e(err);
  } finally {
    _iterator160.f();
  }
  return null;
}
function _displayHighlightToolbar2() {
  var _classPrivateFieldLoo127;
  var selection = document.getSelection();
  if (!selection || selection.isCollapsed) {
    return;
  }
  var anchorElement = _classPrivateFieldLooseBase(this, _getAnchorElementForSelection)[_getAnchorElementForSelection](selection);
  var textLayer = anchorElement.closest(".textLayer");
  var boxes = this.getSelectionBoxes(textLayer);
  if (!boxes) {
    return;
  }
  (_classPrivateFieldLoo127 = _classPrivateFieldLooseBase(this, _highlightToolbar))[_highlightToolbar] || (_classPrivateFieldLoo127[_highlightToolbar] = new HighlightToolbar(this));
  _classPrivateFieldLooseBase(this, _highlightToolbar)[_highlightToolbar].show(textLayer, boxes, this.direction === "ltr");
}
function _selectionChange2() {
  var _classPrivateFieldLoo130,
    _this89 = this;
  var selection = document.getSelection();
  if (!selection || selection.isCollapsed) {
    if (_classPrivateFieldLooseBase(this, _selectedTextNode)[_selectedTextNode]) {
      var _classPrivateFieldLoo128;
      (_classPrivateFieldLoo128 = _classPrivateFieldLooseBase(this, _highlightToolbar)[_highlightToolbar]) === null || _classPrivateFieldLoo128 === void 0 || _classPrivateFieldLoo128.hide();
      _classPrivateFieldLooseBase(this, _selectedTextNode)[_selectedTextNode] = null;
      _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
        hasSelectedText: false
      });
    }
    return;
  }
  var anchorNode = selection.anchorNode;
  if (anchorNode === _classPrivateFieldLooseBase(this, _selectedTextNode)[_selectedTextNode]) {
    return;
  }
  var anchorElement = _classPrivateFieldLooseBase(this, _getAnchorElementForSelection)[_getAnchorElementForSelection](selection);
  var textLayer = anchorElement.closest(".textLayer");
  if (!textLayer) {
    if (_classPrivateFieldLooseBase(this, _selectedTextNode)[_selectedTextNode]) {
      var _classPrivateFieldLoo129;
      (_classPrivateFieldLoo129 = _classPrivateFieldLooseBase(this, _highlightToolbar)[_highlightToolbar]) === null || _classPrivateFieldLoo129 === void 0 || _classPrivateFieldLoo129.hide();
      _classPrivateFieldLooseBase(this, _selectedTextNode)[_selectedTextNode] = null;
      _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
        hasSelectedText: false
      });
    }
    return;
  }
  (_classPrivateFieldLoo130 = _classPrivateFieldLooseBase(this, _highlightToolbar)[_highlightToolbar]) === null || _classPrivateFieldLoo130 === void 0 || _classPrivateFieldLoo130.hide();
  _classPrivateFieldLooseBase(this, _selectedTextNode)[_selectedTextNode] = anchorNode;
  _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
    hasSelectedText: true
  });
  if (_classPrivateFieldLooseBase(this, _mode)[_mode] !== _AnnotationEditorType.HIGHLIGHT && _classPrivateFieldLooseBase(this, _mode)[_mode] !== _AnnotationEditorType.NONE) {
    return;
  }
  if (_classPrivateFieldLooseBase(this, _mode)[_mode] === _AnnotationEditorType.HIGHLIGHT) {
    this.showAllEditors("highlight", true, true);
  }
  _classPrivateFieldLooseBase(this, _highlightWhenShiftUp)[_highlightWhenShiftUp] = this.isShiftKeyDown;
  if (!this.isShiftKeyDown) {
    var activeLayer = _classPrivateFieldLooseBase(this, _mode)[_mode] === _AnnotationEditorType.HIGHLIGHT ? _classPrivateFieldLooseBase(this, _getLayerForTextLayer)[_getLayerForTextLayer](textLayer) : null;
    activeLayer === null || activeLayer === void 0 || activeLayer.toggleDrawing();
    var ac = new AbortController();
    var signal = this.combinedSignal(ac);
    var pointerup = function pointerup(e) {
      if (e.type === "pointerup" && e.button !== 0) {
        return;
      }
      ac.abort();
      activeLayer === null || activeLayer === void 0 || activeLayer.toggleDrawing(true);
      if (e.type === "pointerup") {
        _classPrivateFieldLooseBase(_this89, _onSelectEnd)[_onSelectEnd]("main_toolbar");
      }
    };
    window.addEventListener("pointerup", pointerup, {
      signal: signal
    });
    window.addEventListener("blur", pointerup, {
      signal: signal
    });
  }
}
function _onSelectEnd2() {
  var methodOfCreation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (_classPrivateFieldLooseBase(this, _mode)[_mode] === _AnnotationEditorType.HIGHLIGHT) {
    this.highlightSelection(methodOfCreation);
  } else if (_classPrivateFieldLooseBase(this, _enableHighlightFloatingButton)[_enableHighlightFloatingButton]) {
    _classPrivateFieldLooseBase(this, _displayHighlightToolbar)[_displayHighlightToolbar]();
  }
}
function _addSelectionListener2() {
  document.addEventListener("selectionchange", _classPrivateFieldLooseBase(this, _selectionChange)[_selectionChange].bind(this), {
    signal: this._signal
  });
}
function _addFocusManager2() {
  if (_classPrivateFieldLooseBase(this, _focusManagerAC)[_focusManagerAC]) {
    return;
  }
  _classPrivateFieldLooseBase(this, _focusManagerAC)[_focusManagerAC] = new AbortController();
  var signal = this.combinedSignal(_classPrivateFieldLooseBase(this, _focusManagerAC)[_focusManagerAC]);
  window.addEventListener("focus", this.focus.bind(this), {
    signal: signal
  });
  window.addEventListener("blur", this.blur.bind(this), {
    signal: signal
  });
}
function _removeFocusManager2() {
  var _classPrivateFieldLoo131;
  (_classPrivateFieldLoo131 = _classPrivateFieldLooseBase(this, _focusManagerAC)[_focusManagerAC]) === null || _classPrivateFieldLoo131 === void 0 || _classPrivateFieldLoo131.abort();
  _classPrivateFieldLooseBase(this, _focusManagerAC)[_focusManagerAC] = null;
}
function _addKeyboardManager2() {
  if (_classPrivateFieldLooseBase(this, _keyboardManagerAC)[_keyboardManagerAC]) {
    return;
  }
  _classPrivateFieldLooseBase(this, _keyboardManagerAC)[_keyboardManagerAC] = new AbortController();
  var signal = this.combinedSignal(_classPrivateFieldLooseBase(this, _keyboardManagerAC)[_keyboardManagerAC]);
  window.addEventListener("keydown", this.keydown.bind(this), {
    signal: signal
  });
  window.addEventListener("keyup", this.keyup.bind(this), {
    signal: signal
  });
}
function _removeKeyboardManager2() {
  var _classPrivateFieldLoo132;
  (_classPrivateFieldLoo132 = _classPrivateFieldLooseBase(this, _keyboardManagerAC)[_keyboardManagerAC]) === null || _classPrivateFieldLoo132 === void 0 || _classPrivateFieldLoo132.abort();
  _classPrivateFieldLooseBase(this, _keyboardManagerAC)[_keyboardManagerAC] = null;
}
function _addCopyPasteListeners2() {
  if (_classPrivateFieldLooseBase(this, _copyPasteAC)[_copyPasteAC]) {
    return;
  }
  _classPrivateFieldLooseBase(this, _copyPasteAC)[_copyPasteAC] = new AbortController();
  var signal = this.combinedSignal(_classPrivateFieldLooseBase(this, _copyPasteAC)[_copyPasteAC]);
  document.addEventListener("copy", this.copy.bind(this), {
    signal: signal
  });
  document.addEventListener("cut", this.cut.bind(this), {
    signal: signal
  });
  document.addEventListener("paste", this.paste.bind(this), {
    signal: signal
  });
}
function _removeCopyPasteListeners2() {
  var _classPrivateFieldLoo133;
  (_classPrivateFieldLoo133 = _classPrivateFieldLooseBase(this, _copyPasteAC)[_copyPasteAC]) === null || _classPrivateFieldLoo133 === void 0 || _classPrivateFieldLoo133.abort();
  _classPrivateFieldLooseBase(this, _copyPasteAC)[_copyPasteAC] = null;
}
function _addDragAndDropListeners2() {
  var signal = this._signal;
  document.addEventListener("dragover", this.dragOver.bind(this), {
    signal: signal
  });
  document.addEventListener("drop", this.drop.bind(this), {
    signal: signal
  });
}
function _dispatchUpdateStates2(details) {
  var _this90 = this;
  var hasChanged = Object.entries(details).some(function (_ref166) {
    var _ref167 = _slicedToArray(_ref166, 2),
      key = _ref167[0],
      value = _ref167[1];
    return _classPrivateFieldLooseBase(_this90, _previousStates)[_previousStates][key] !== value;
  });
  if (hasChanged) {
    this._eventBus.dispatch("annotationeditorstateschanged", {
      source: this,
      details: Object.assign(_classPrivateFieldLooseBase(this, _previousStates)[_previousStates], details)
    });
    if (_classPrivateFieldLooseBase(this, _mode)[_mode] === _AnnotationEditorType.HIGHLIGHT && details.hasSelectedEditor === false) {
      _classPrivateFieldLooseBase(this, _dispatchUpdateUI)[_dispatchUpdateUI]([[_AnnotationEditorParamsType.HIGHLIGHT_FREE, true]]);
    }
  }
}
function _dispatchUpdateUI2(details) {
  this._eventBus.dispatch("annotationeditorparamschanged", {
    source: this,
    details: details
  });
}
function _enableAll2() {
  return _enableAll3.apply(this, arguments);
}
function _enableAll3() {
  _enableAll3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
    var promises, _iterator184, _step184, layer, _iterator185, _step185, editor;
    return _regeneratorRuntime().wrap(function _callee55$(_context56) {
      while (1) switch (_context56.prev = _context56.next) {
        case 0:
          if (_classPrivateFieldLooseBase(this, _isEnabled)[_isEnabled]) {
            _context56.next = 9;
            break;
          }
          _classPrivateFieldLooseBase(this, _isEnabled)[_isEnabled] = true;
          promises = [];
          _iterator184 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values());
          try {
            for (_iterator184.s(); !(_step184 = _iterator184.n()).done;) {
              layer = _step184.value;
              promises.push(layer.enable());
            }
          } catch (err) {
            _iterator184.e(err);
          } finally {
            _iterator184.f();
          }
          _context56.next = 7;
          return Promise.all(promises);
        case 7:
          _iterator185 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].values());
          try {
            for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
              editor = _step185.value;
              editor.enable();
            }
          } catch (err) {
            _iterator185.e(err);
          } finally {
            _iterator185.f();
          }
        case 9:
        case "end":
          return _context56.stop();
      }
    }, _callee55, this);
  }));
  return _enableAll3.apply(this, arguments);
}
function _disableAll2() {
  this.unselectAll();
  if (_classPrivateFieldLooseBase(this, _isEnabled)[_isEnabled]) {
    _classPrivateFieldLooseBase(this, _isEnabled)[_isEnabled] = false;
    var _iterator161 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allLayers)[_allLayers].values()),
      _step161;
    try {
      for (_iterator161.s(); !(_step161 = _iterator161.n()).done;) {
        var layer = _step161.value;
        layer.disable();
      }
    } catch (err) {
      _iterator161.e(err);
    } finally {
      _iterator161.f();
    }
    var _iterator162 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].values()),
      _step162;
    try {
      for (_iterator162.s(); !(_step162 = _iterator162.n()).done;) {
        var editor = _step162.value;
        editor.disable();
      }
    } catch (err) {
      _iterator162.e(err);
    } finally {
      _iterator162.f();
    }
  }
}
function _addEditorToLayer2(editor) {
  var layer = _classPrivateFieldLooseBase(this, _allLayers)[_allLayers].get(editor.pageIndex);
  if (layer) {
    layer.addOrRebuild(editor);
  } else {
    this.addEditor(editor);
    this.addToAnnotationStorage(editor);
  }
}
function _get_lastSelectedEditor() {
  var ed = null;
  var _iterator163 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
    _step163;
  try {
    for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
      ed = _step163.value;
    }
  } catch (err) {
    _iterator163.e(err);
  } finally {
    _iterator163.f();
  }
  return ed;
}
function _isEmpty2() {
  if (_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].size === 0) {
    return true;
  }
  if (_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].size === 1) {
    var _iterator164 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allEditors)[_allEditors].values()),
      _step164;
    try {
      for (_iterator164.s(); !(_step164 = _iterator164.n()).done;) {
        var editor = _step164.value;
        return editor.isEmpty();
      }
    } catch (err) {
      _iterator164.e(err);
    } finally {
      _iterator164.f();
    }
  }
  return false;
}
function _selectEditors2(editors) {
  var _iterator165 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors]),
    _step165;
  try {
    for (_iterator165.s(); !(_step165 = _iterator165.n()).done;) {
      var editor = _step165.value;
      editor.unselect();
    }
  } catch (err) {
    _iterator165.e(err);
  } finally {
    _iterator165.f();
  }
  _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].clear();
  var _iterator166 = _createForOfIteratorHelper(editors),
    _step166;
  try {
    for (_iterator166.s(); !(_step166 = _iterator166.n()).done;) {
      var _editor7 = _step166.value;
      if (_editor7.isEmpty()) {
        continue;
      }
      _classPrivateFieldLooseBase(this, _selectedEditors)[_selectedEditors].add(_editor7);
      _editor7.select();
    }
  } catch (err) {
    _iterator166.e(err);
  } finally {
    _iterator166.f();
  }
  _classPrivateFieldLooseBase(this, _dispatchUpdateStates)[_dispatchUpdateStates]({
    hasSelectedEditor: this.hasSelection
  });
}
_AnnotationEditorUIManager.TRANSLATE_SMALL = 1;
_AnnotationEditorUIManager.TRANSLATE_BIG = 10;
; // ./src/display/editor/alt_text.js
var _altText2 = /*#__PURE__*/_classPrivateFieldLooseKey("altText");
var _altTextDecorative = /*#__PURE__*/_classPrivateFieldLooseKey("altTextDecorative");
var _altTextButton = /*#__PURE__*/_classPrivateFieldLooseKey("altTextButton");
var _altTextButtonLabel = /*#__PURE__*/_classPrivateFieldLooseKey("altTextButtonLabel");
var _altTextTooltip = /*#__PURE__*/_classPrivateFieldLooseKey("altTextTooltip");
var _altTextTooltipTimeout = /*#__PURE__*/_classPrivateFieldLooseKey("altTextTooltipTimeout");
var _altTextWasFromKeyBoard = /*#__PURE__*/_classPrivateFieldLooseKey("altTextWasFromKeyBoard");
var _badge = /*#__PURE__*/_classPrivateFieldLooseKey("badge");
var _editor2 = /*#__PURE__*/_classPrivateFieldLooseKey("editor");
var _guessedText = /*#__PURE__*/_classPrivateFieldLooseKey("guessedText");
var _textWithDisclaimer = /*#__PURE__*/_classPrivateFieldLooseKey("textWithDisclaimer");
var _useNewAltTextFlow = /*#__PURE__*/_classPrivateFieldLooseKey("useNewAltTextFlow");
var _l10nNewButton = /*#__PURE__*/_classPrivateFieldLooseKey("l10nNewButton");
var _label = /*#__PURE__*/_classPrivateFieldLooseKey("label");
var _setState = /*#__PURE__*/_classPrivateFieldLooseKey("setState");
var AltText = /*#__PURE__*/function () {
  function AltText(editor) {
    var _classPrivateFieldLoo32;
    _classCallCheck(this, AltText);
    Object.defineProperty(this, _setState, {
      value: _setState2
    });
    Object.defineProperty(this, _label, {
      get: _get_label,
      set: void 0
    });
    Object.defineProperty(this, _altText2, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _altTextDecorative, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _altTextButton, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _altTextButtonLabel, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _altTextTooltip, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _altTextTooltipTimeout, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _altTextWasFromKeyBoard, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _badge, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _editor2, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _guessedText, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _textWithDisclaimer, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _useNewAltTextFlow, {
      writable: true,
      value: false
    });
    _classPrivateFieldLooseBase(this, _editor2)[_editor2] = editor;
    _classPrivateFieldLooseBase(this, _useNewAltTextFlow)[_useNewAltTextFlow] = editor._uiManager.useNewAltTextFlow;
    (_classPrivateFieldLoo32 = _classPrivateFieldLooseBase(AltText, _l10nNewButton))[_l10nNewButton] || (_classPrivateFieldLoo32[_l10nNewButton] = Object.freeze({
      added: "pdfjs-editor-new-alt-text-added-button",
      "added-label": "pdfjs-editor-new-alt-text-added-button-label",
      missing: "pdfjs-editor-new-alt-text-missing-button",
      "missing-label": "pdfjs-editor-new-alt-text-missing-button-label",
      review: "pdfjs-editor-new-alt-text-to-review-button",
      "review-label": "pdfjs-editor-new-alt-text-to-review-button-label"
    }));
  }
  return _createClass(AltText, [{
    key: "render",
    value: function () {
      var _render3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this12 = this;
        var altText, label, signal, onClick;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              altText = _classPrivateFieldLooseBase(this, _altTextButton)[_altTextButton] = document.createElement("button");
              altText.className = "altText";
              altText.tabIndex = "0";
              label = _classPrivateFieldLooseBase(this, _altTextButtonLabel)[_altTextButtonLabel] = document.createElement("span");
              altText.append(label);
              if (_classPrivateFieldLooseBase(this, _useNewAltTextFlow)[_useNewAltTextFlow]) {
                altText.classList.add("new");
                altText.setAttribute("data-l10n-id", _classPrivateFieldLooseBase(AltText, _l10nNewButton)[_l10nNewButton].missing);
                label.setAttribute("data-l10n-id", _classPrivateFieldLooseBase(AltText, _l10nNewButton)[_l10nNewButton]["missing-label"]);
              } else {
                altText.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button");
                label.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button-label");
              }
              signal = _classPrivateFieldLooseBase(this, _editor2)[_editor2]._uiManager._signal;
              altText.addEventListener("contextmenu", _noContextMenu, {
                signal: signal
              });
              altText.addEventListener("pointerdown", function (event) {
                return event.stopPropagation();
              }, {
                signal: signal
              });
              onClick = function onClick(event) {
                event.preventDefault();
                _classPrivateFieldLooseBase(_this12, _editor2)[_editor2]._uiManager.editAltText(_classPrivateFieldLooseBase(_this12, _editor2)[_editor2]);
                if (_classPrivateFieldLooseBase(_this12, _useNewAltTextFlow)[_useNewAltTextFlow]) {
                  _classPrivateFieldLooseBase(_this12, _editor2)[_editor2]._reportTelemetry({
                    action: "pdfjs.image.alt_text.image_status_label_clicked",
                    data: {
                      label: _classPrivateFieldLooseBase(_this12, _label)[_label]
                    }
                  });
                }
              };
              altText.addEventListener("click", onClick, {
                capture: true,
                signal: signal
              });
              altText.addEventListener("keydown", function (event) {
                if (event.target === altText && event.key === "Enter") {
                  _classPrivateFieldLooseBase(_this12, _altTextWasFromKeyBoard)[_altTextWasFromKeyBoard] = true;
                  onClick(event);
                }
              }, {
                signal: signal
              });
              _context8.next = 14;
              return _classPrivateFieldLooseBase(this, _setState)[_setState]();
            case 14:
              return _context8.abrupt("return", altText);
            case 15:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function render() {
        return _render3.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "finish",
    value: function finish() {
      if (!_classPrivateFieldLooseBase(this, _altTextButton)[_altTextButton]) {
        return;
      }
      _classPrivateFieldLooseBase(this, _altTextButton)[_altTextButton].focus({
        focusVisible: _classPrivateFieldLooseBase(this, _altTextWasFromKeyBoard)[_altTextWasFromKeyBoard]
      });
      _classPrivateFieldLooseBase(this, _altTextWasFromKeyBoard)[_altTextWasFromKeyBoard] = false;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      if (_classPrivateFieldLooseBase(this, _useNewAltTextFlow)[_useNewAltTextFlow]) {
        return _classPrivateFieldLooseBase(this, _altText2)[_altText2] === null;
      }
      return !_classPrivateFieldLooseBase(this, _altText2)[_altText2] && !_classPrivateFieldLooseBase(this, _altTextDecorative)[_altTextDecorative];
    }
  }, {
    key: "hasData",
    value: function hasData() {
      if (_classPrivateFieldLooseBase(this, _useNewAltTextFlow)[_useNewAltTextFlow]) {
        return _classPrivateFieldLooseBase(this, _altText2)[_altText2] !== null || !!_classPrivateFieldLooseBase(this, _guessedText)[_guessedText];
      }
      return this.isEmpty();
    }
  }, {
    key: "guessedText",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _guessedText)[_guessedText];
    }
  }, {
    key: "setGuessedText",
    value: function () {
      var _setGuessedText = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(guessedText) {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!(_classPrivateFieldLooseBase(this, _altText2)[_altText2] !== null)) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              _classPrivateFieldLooseBase(this, _guessedText)[_guessedText] = guessedText;
              _context9.next = 5;
              return AltText._l10n.get("pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer", {
                generatedAltText: guessedText
              });
            case 5:
              _classPrivateFieldLooseBase(this, _textWithDisclaimer)[_textWithDisclaimer] = _context9.sent;
              _classPrivateFieldLooseBase(this, _setState)[_setState]();
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function setGuessedText(_x10) {
        return _setGuessedText.apply(this, arguments);
      }
      return setGuessedText;
    }()
  }, {
    key: "toggleAltTextBadge",
    value: function toggleAltTextBadge() {
      var visibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!_classPrivateFieldLooseBase(this, _useNewAltTextFlow)[_useNewAltTextFlow] || _classPrivateFieldLooseBase(this, _altText2)[_altText2]) {
        var _classPrivateFieldLoo33;
        (_classPrivateFieldLoo33 = _classPrivateFieldLooseBase(this, _badge)[_badge]) === null || _classPrivateFieldLoo33 === void 0 || _classPrivateFieldLoo33.remove();
        _classPrivateFieldLooseBase(this, _badge)[_badge] = null;
        return;
      }
      if (!_classPrivateFieldLooseBase(this, _badge)[_badge]) {
        var badge = _classPrivateFieldLooseBase(this, _badge)[_badge] = document.createElement("div");
        badge.className = "noAltTextBadge";
        _classPrivateFieldLooseBase(this, _editor2)[_editor2].div.append(badge);
      }
      _classPrivateFieldLooseBase(this, _badge)[_badge].classList.toggle("hidden", !visibility);
    }
  }, {
    key: "serialize",
    value: function serialize(isForCopying) {
      var altText = _classPrivateFieldLooseBase(this, _altText2)[_altText2];
      if (!isForCopying && _classPrivateFieldLooseBase(this, _guessedText)[_guessedText] === altText) {
        altText = _classPrivateFieldLooseBase(this, _textWithDisclaimer)[_textWithDisclaimer];
      }
      return {
        altText: altText,
        decorative: _classPrivateFieldLooseBase(this, _altTextDecorative)[_altTextDecorative],
        guessedText: _classPrivateFieldLooseBase(this, _guessedText)[_guessedText],
        textWithDisclaimer: _classPrivateFieldLooseBase(this, _textWithDisclaimer)[_textWithDisclaimer]
      };
    }
  }, {
    key: "data",
    get: function get() {
      return {
        altText: _classPrivateFieldLooseBase(this, _altText2)[_altText2],
        decorative: _classPrivateFieldLooseBase(this, _altTextDecorative)[_altTextDecorative]
      };
    },
    set: function set(_ref32) {
      var altText = _ref32.altText,
        decorative = _ref32.decorative,
        guessedText = _ref32.guessedText,
        textWithDisclaimer = _ref32.textWithDisclaimer,
        _ref32$cancel = _ref32.cancel,
        cancel = _ref32$cancel === void 0 ? false : _ref32$cancel;
      if (guessedText) {
        _classPrivateFieldLooseBase(this, _guessedText)[_guessedText] = guessedText;
        _classPrivateFieldLooseBase(this, _textWithDisclaimer)[_textWithDisclaimer] = textWithDisclaimer;
      }
      if (_classPrivateFieldLooseBase(this, _altText2)[_altText2] === altText && _classPrivateFieldLooseBase(this, _altTextDecorative)[_altTextDecorative] === decorative) {
        return;
      }
      if (!cancel) {
        _classPrivateFieldLooseBase(this, _altText2)[_altText2] = altText;
        _classPrivateFieldLooseBase(this, _altTextDecorative)[_altTextDecorative] = decorative;
      }
      _classPrivateFieldLooseBase(this, _setState)[_setState]();
    }
  }, {
    key: "toggle",
    value: function toggle() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!_classPrivateFieldLooseBase(this, _altTextButton)[_altTextButton]) {
        return;
      }
      if (!enabled && _classPrivateFieldLooseBase(this, _altTextTooltipTimeout)[_altTextTooltipTimeout]) {
        clearTimeout(_classPrivateFieldLooseBase(this, _altTextTooltipTimeout)[_altTextTooltipTimeout]);
        _classPrivateFieldLooseBase(this, _altTextTooltipTimeout)[_altTextTooltipTimeout] = null;
      }
      _classPrivateFieldLooseBase(this, _altTextButton)[_altTextButton].disabled = !enabled;
    }
  }, {
    key: "shown",
    value: function shown() {
      _classPrivateFieldLooseBase(this, _editor2)[_editor2]._reportTelemetry({
        action: "pdfjs.image.alt_text.image_status_label_displayed",
        data: {
          label: _classPrivateFieldLooseBase(this, _label)[_label]
        }
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _classPrivateFieldLoo34, _classPrivateFieldLoo35;
      (_classPrivateFieldLoo34 = _classPrivateFieldLooseBase(this, _altTextButton)[_altTextButton]) === null || _classPrivateFieldLoo34 === void 0 || _classPrivateFieldLoo34.remove();
      _classPrivateFieldLooseBase(this, _altTextButton)[_altTextButton] = null;
      _classPrivateFieldLooseBase(this, _altTextButtonLabel)[_altTextButtonLabel] = null;
      _classPrivateFieldLooseBase(this, _altTextTooltip)[_altTextTooltip] = null;
      (_classPrivateFieldLoo35 = _classPrivateFieldLooseBase(this, _badge)[_badge]) === null || _classPrivateFieldLoo35 === void 0 || _classPrivateFieldLoo35.remove();
      _classPrivateFieldLooseBase(this, _badge)[_badge] = null;
    }
  }], [{
    key: "initialize",
    value: function initialize(l10n) {
      var _AltText$_l10n;
      (_AltText$_l10n = AltText._l10n) !== null && _AltText$_l10n !== void 0 ? _AltText$_l10n : AltText._l10n = l10n;
    }
  }]);
}();
_AltText = AltText;
function _get_label() {
  return _classPrivateFieldLooseBase(this, _altText2)[_altText2] && "added" || _classPrivateFieldLooseBase(this, _altText2)[_altText2] === null && this.guessedText && "review" || "missing";
}
function _setState2() {
  return _setState3.apply(this, arguments);
}
function _setState3() {
  _setState3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
    var _this112 = this;
    var button, _classPrivateFieldLoo174, _classPrivateFieldLoo175, _classPrivateFieldLoo176, tooltip, DELAY_TO_SHOW_TOOLTIP, signal, element;
    return _regeneratorRuntime().wrap(function _callee56$(_context57) {
      while (1) switch (_context57.prev = _context57.next) {
        case 0:
          button = _classPrivateFieldLooseBase(this, _altTextButton)[_altTextButton];
          if (button) {
            _context57.next = 3;
            break;
          }
          return _context57.abrupt("return");
        case 3:
          if (!_classPrivateFieldLooseBase(this, _useNewAltTextFlow)[_useNewAltTextFlow]) {
            _context57.next = 12;
            break;
          }
          button.classList.toggle("done", !!_classPrivateFieldLooseBase(this, _altText2)[_altText2]);
          button.setAttribute("data-l10n-id", _classPrivateFieldLooseBase(_AltText, _l10nNewButton)[_l10nNewButton][_classPrivateFieldLooseBase(this, _label)[_label]]);
          (_classPrivateFieldLoo174 = _classPrivateFieldLooseBase(this, _altTextButtonLabel)[_altTextButtonLabel]) === null || _classPrivateFieldLoo174 === void 0 || _classPrivateFieldLoo174.setAttribute("data-l10n-id", _classPrivateFieldLooseBase(_AltText, _l10nNewButton)[_l10nNewButton]["".concat(_classPrivateFieldLooseBase(this, _label)[_label], "-label")]);
          if (_classPrivateFieldLooseBase(this, _altText2)[_altText2]) {
            _context57.next = 10;
            break;
          }
          (_classPrivateFieldLoo175 = _classPrivateFieldLooseBase(this, _altTextTooltip)[_altTextTooltip]) === null || _classPrivateFieldLoo175 === void 0 || _classPrivateFieldLoo175.remove();
          return _context57.abrupt("return");
        case 10:
          _context57.next = 18;
          break;
        case 12:
          if (!(!_classPrivateFieldLooseBase(this, _altText2)[_altText2] && !_classPrivateFieldLooseBase(this, _altTextDecorative)[_altTextDecorative])) {
            _context57.next = 16;
            break;
          }
          button.classList.remove("done");
          (_classPrivateFieldLoo176 = _classPrivateFieldLooseBase(this, _altTextTooltip)[_altTextTooltip]) === null || _classPrivateFieldLoo176 === void 0 || _classPrivateFieldLoo176.remove();
          return _context57.abrupt("return");
        case 16:
          button.classList.add("done");
          button.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-edit-button");
        case 18:
          tooltip = _classPrivateFieldLooseBase(this, _altTextTooltip)[_altTextTooltip];
          if (!tooltip) {
            _classPrivateFieldLooseBase(this, _altTextTooltip)[_altTextTooltip] = tooltip = document.createElement("span");
            tooltip.className = "tooltip";
            tooltip.setAttribute("role", "tooltip");
            tooltip.id = "alt-text-tooltip-".concat(_classPrivateFieldLooseBase(this, _editor2)[_editor2].id);
            DELAY_TO_SHOW_TOOLTIP = 100;
            signal = _classPrivateFieldLooseBase(this, _editor2)[_editor2]._uiManager._signal;
            signal.addEventListener("abort", function () {
              clearTimeout(_classPrivateFieldLooseBase(_this112, _altTextTooltipTimeout)[_altTextTooltipTimeout]);
              _classPrivateFieldLooseBase(_this112, _altTextTooltipTimeout)[_altTextTooltipTimeout] = null;
            }, {
              once: true
            });
            button.addEventListener("mouseenter", function () {
              _classPrivateFieldLooseBase(_this112, _altTextTooltipTimeout)[_altTextTooltipTimeout] = setTimeout(function () {
                _classPrivateFieldLooseBase(_this112, _altTextTooltipTimeout)[_altTextTooltipTimeout] = null;
                _classPrivateFieldLooseBase(_this112, _altTextTooltip)[_altTextTooltip].classList.add("show");
                _classPrivateFieldLooseBase(_this112, _editor2)[_editor2]._reportTelemetry({
                  action: "alt_text_tooltip"
                });
              }, DELAY_TO_SHOW_TOOLTIP);
            }, {
              signal: signal
            });
            button.addEventListener("mouseleave", function () {
              var _classPrivateFieldLoo177;
              if (_classPrivateFieldLooseBase(_this112, _altTextTooltipTimeout)[_altTextTooltipTimeout]) {
                clearTimeout(_classPrivateFieldLooseBase(_this112, _altTextTooltipTimeout)[_altTextTooltipTimeout]);
                _classPrivateFieldLooseBase(_this112, _altTextTooltipTimeout)[_altTextTooltipTimeout] = null;
              }
              (_classPrivateFieldLoo177 = _classPrivateFieldLooseBase(_this112, _altTextTooltip)[_altTextTooltip]) === null || _classPrivateFieldLoo177 === void 0 || _classPrivateFieldLoo177.classList.remove("show");
            }, {
              signal: signal
            });
          }
          if (_classPrivateFieldLooseBase(this, _altTextDecorative)[_altTextDecorative]) {
            tooltip.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-decorative-tooltip");
          } else {
            tooltip.removeAttribute("data-l10n-id");
            tooltip.textContent = _classPrivateFieldLooseBase(this, _altText2)[_altText2];
          }
          if (!tooltip.parentNode) {
            button.append(tooltip);
          }
          element = _classPrivateFieldLooseBase(this, _editor2)[_editor2].getImageForAltText();
          element === null || element === void 0 || element.setAttribute("aria-describedby", tooltip.id);
        case 24:
        case "end":
          return _context57.stop();
      }
    }, _callee56, this);
  }));
  return _setState3.apply(this, arguments);
}
Object.defineProperty(AltText, _l10nNewButton, {
  writable: true,
  value: null
});
AltText._l10n = null;
; // ./src/display/editor/editor.js
var _accessibilityData = /*#__PURE__*/_classPrivateFieldLooseKey("accessibilityData");
var _allResizerDivs = /*#__PURE__*/_classPrivateFieldLooseKey("allResizerDivs");
var _altText3 = /*#__PURE__*/_classPrivateFieldLooseKey("altText");
var _disabled = /*#__PURE__*/_classPrivateFieldLooseKey("disabled");
var _keepAspectRatio = /*#__PURE__*/_classPrivateFieldLooseKey("keepAspectRatio");
var _resizersDiv = /*#__PURE__*/_classPrivateFieldLooseKey("resizersDiv");
var _savedDimensions = /*#__PURE__*/_classPrivateFieldLooseKey("savedDimensions");
var _focusAC = /*#__PURE__*/_classPrivateFieldLooseKey("focusAC");
var _focusedResizerName = /*#__PURE__*/_classPrivateFieldLooseKey("focusedResizerName");
var _hasBeenClicked = /*#__PURE__*/_classPrivateFieldLooseKey("hasBeenClicked");
var _initialPosition = /*#__PURE__*/_classPrivateFieldLooseKey("initialPosition");
var _isEditing = /*#__PURE__*/_classPrivateFieldLooseKey("isEditing");
var _isInEditMode = /*#__PURE__*/_classPrivateFieldLooseKey("isInEditMode");
var _isResizerEnabledForKeyboard = /*#__PURE__*/_classPrivateFieldLooseKey("isResizerEnabledForKeyboard");
var _moveInDOMTimeout = /*#__PURE__*/_classPrivateFieldLooseKey("moveInDOMTimeout");
var _prevDragX = /*#__PURE__*/_classPrivateFieldLooseKey("prevDragX");
var _prevDragY = /*#__PURE__*/_classPrivateFieldLooseKey("prevDragY");
var _telemetryTimeouts = /*#__PURE__*/_classPrivateFieldLooseKey("telemetryTimeouts");
var _isDraggable = /*#__PURE__*/_classPrivateFieldLooseKey("isDraggable");
var _zIndex = /*#__PURE__*/_classPrivateFieldLooseKey("zIndex");
var _translate = /*#__PURE__*/_classPrivateFieldLooseKey("translate");
var _rotatePoint = /*#__PURE__*/_classPrivateFieldLooseKey("rotatePoint");
var _getRotationMatrix = /*#__PURE__*/_classPrivateFieldLooseKey("getRotationMatrix");
var _createResizers = /*#__PURE__*/_classPrivateFieldLooseKey("createResizers");
var _resizerPointerdown = /*#__PURE__*/_classPrivateFieldLooseKey("resizerPointerdown");
var _addResizeToUndoStack = /*#__PURE__*/_classPrivateFieldLooseKey("addResizeToUndoStack");
var _resizerPointermove = /*#__PURE__*/_classPrivateFieldLooseKey("resizerPointermove");
var _selectOnPointerEvent = /*#__PURE__*/_classPrivateFieldLooseKey("selectOnPointerEvent");
var _setUpDragSession = /*#__PURE__*/_classPrivateFieldLooseKey("setUpDragSession");
var _addFocusListeners = /*#__PURE__*/_classPrivateFieldLooseKey("addFocusListeners");
var _resizerKeydown = /*#__PURE__*/_classPrivateFieldLooseKey("resizerKeydown");
var _resizerBlur = /*#__PURE__*/_classPrivateFieldLooseKey("resizerBlur");
var _resizerFocus = /*#__PURE__*/_classPrivateFieldLooseKey("resizerFocus");
var _setResizerTabIndex = /*#__PURE__*/_classPrivateFieldLooseKey("setResizerTabIndex");
var _stopResizing = /*#__PURE__*/_classPrivateFieldLooseKey("stopResizing");
var AnnotationEditor = /*#__PURE__*/function () {
  function AnnotationEditor(parameters) {
    _classCallCheck(this, AnnotationEditor);
    Object.defineProperty(this, _stopResizing, {
      value: _stopResizing2
    });
    Object.defineProperty(this, _setResizerTabIndex, {
      value: _setResizerTabIndex2
    });
    Object.defineProperty(this, _resizerFocus, {
      value: _resizerFocus2
    });
    Object.defineProperty(this, _resizerBlur, {
      value: _resizerBlur2
    });
    Object.defineProperty(this, _resizerKeydown, {
      value: _resizerKeydown2
    });
    Object.defineProperty(this, _addFocusListeners, {
      value: _addFocusListeners2
    });
    Object.defineProperty(this, _setUpDragSession, {
      value: _setUpDragSession2
    });
    Object.defineProperty(this, _selectOnPointerEvent, {
      value: _selectOnPointerEvent2
    });
    Object.defineProperty(this, _resizerPointermove, {
      value: _resizerPointermove2
    });
    Object.defineProperty(this, _addResizeToUndoStack, {
      value: _addResizeToUndoStack2
    });
    Object.defineProperty(this, _resizerPointerdown, {
      value: _resizerPointerdown2
    });
    Object.defineProperty(this, _createResizers, {
      value: _createResizers2
    });
    Object.defineProperty(this, _getRotationMatrix, {
      value: _getRotationMatrix2
    });
    Object.defineProperty(this, _translate, {
      value: _translate2
    });
    Object.defineProperty(this, _accessibilityData, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _allResizerDivs, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _altText3, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _disabled, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _keepAspectRatio, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _resizersDiv, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _savedDimensions, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _focusAC, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _focusedResizerName, {
      writable: true,
      value: ""
    });
    Object.defineProperty(this, _hasBeenClicked, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _initialPosition, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _isEditing, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _isInEditMode, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _isResizerEnabledForKeyboard, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _moveInDOMTimeout, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _prevDragX, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _prevDragY, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _telemetryTimeouts, {
      writable: true,
      value: null
    });
    this._editToolbar = null;
    this._initialOptions = Object.create(null);
    this._initialData = null;
    this._isVisible = true;
    this._uiManager = null;
    this._focusEventsAllowed = true;
    Object.defineProperty(this, _isDraggable, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _zIndex, {
      writable: true,
      value: AnnotationEditor._zIndex++
    });
    this.parent = parameters.parent;
    this.id = parameters.id;
    this.width = this.height = null;
    this.pageIndex = parameters.parent.pageIndex;
    this.name = parameters.name;
    this.div = null;
    this._uiManager = parameters.uiManager;
    this.annotationElementId = null;
    this._willKeepAspectRatio = false;
    this._initialOptions.isCentered = parameters.isCentered;
    this._structTreeParentId = null;
    var _this$parent$viewport = this.parent.viewport,
      _rotation2 = _this$parent$viewport.rotation,
      _this$parent$viewport2 = _this$parent$viewport.rawDims,
      _pageWidth = _this$parent$viewport2.pageWidth,
      _pageHeight = _this$parent$viewport2.pageHeight,
      pageX = _this$parent$viewport2.pageX,
      pageY = _this$parent$viewport2.pageY;
    this.rotation = _rotation2;
    this.pageRotation = (360 + _rotation2 - this._uiManager.viewParameters.rotation) % 360;
    this.pageDimensions = [_pageWidth, _pageHeight];
    this.pageTranslation = [pageX, pageY];
    var _this$parentDimension = _slicedToArray(this.parentDimensions, 2),
      _width = _this$parentDimension[0],
      _height = _this$parentDimension[1];
    this.x = parameters.x / _width;
    this.y = parameters.y / _height;
    this.isAttachedToDOM = false;
    this.deleted = false;
  }
  return _createClass(AnnotationEditor, [{
    key: "editorType",
    get: function get() {
      return Object.getPrototypeOf(this).constructor._type;
    }
  }, {
    key: "propertiesToUpdate",
    get: function get() {
      return [];
    }
  }, {
    key: "_isDraggable",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _isDraggable)[_isDraggable];
    },
    set: function set(value) {
      var _this$div;
      _classPrivateFieldLooseBase(this, _isDraggable)[_isDraggable] = value;
      (_this$div = this.div) === null || _this$div === void 0 || _this$div.classList.toggle("draggable", value);
    }
  }, {
    key: "isEnterHandled",
    get: function get() {
      return true;
    }
  }, {
    key: "center",
    value: function center() {
      var _this$pageDimensions = _slicedToArray(this.pageDimensions, 2),
        pageWidth = _this$pageDimensions[0],
        pageHeight = _this$pageDimensions[1];
      switch (this.parentRotation) {
        case 90:
          this.x -= this.height * pageHeight / (pageWidth * 2);
          this.y += this.width * pageWidth / (pageHeight * 2);
          break;
        case 180:
          this.x += this.width / 2;
          this.y += this.height / 2;
          break;
        case 270:
          this.x += this.height * pageHeight / (pageWidth * 2);
          this.y -= this.width * pageWidth / (pageHeight * 2);
          break;
        default:
          this.x -= this.width / 2;
          this.y -= this.height / 2;
          break;
      }
      this.fixAndSetPosition();
    }
  }, {
    key: "addCommands",
    value: function addCommands(params) {
      this._uiManager.addCommands(params);
    }
  }, {
    key: "currentLayer",
    get: function get() {
      return this._uiManager.currentLayer;
    }
  }, {
    key: "setInBackground",
    value: function setInBackground() {
      this.div.style.zIndex = 0;
    }
  }, {
    key: "setInForeground",
    value: function setInForeground() {
      this.div.style.zIndex = _classPrivateFieldLooseBase(this, _zIndex)[_zIndex];
    }
  }, {
    key: "setParent",
    value: function setParent(parent) {
      if (parent !== null) {
        this.pageIndex = parent.pageIndex;
        this.pageDimensions = parent.pageDimensions;
      } else {
        _classPrivateFieldLooseBase(this, _stopResizing)[_stopResizing]();
      }
      this.parent = parent;
    }
  }, {
    key: "focusin",
    value: function focusin(event) {
      if (!this._focusEventsAllowed) {
        return;
      }
      if (!_classPrivateFieldLooseBase(this, _hasBeenClicked)[_hasBeenClicked]) {
        this.parent.setSelected(this);
      } else {
        _classPrivateFieldLooseBase(this, _hasBeenClicked)[_hasBeenClicked] = false;
      }
    }
  }, {
    key: "focusout",
    value: function focusout(event) {
      var _this$parent;
      if (!this._focusEventsAllowed) {
        return;
      }
      if (!this.isAttachedToDOM) {
        return;
      }
      var target = event.relatedTarget;
      if (target !== null && target !== void 0 && target.closest("#".concat(this.id))) {
        return;
      }
      event.preventDefault();
      if (!((_this$parent = this.parent) !== null && _this$parent !== void 0 && _this$parent.isMultipleSelection)) {
        this.commitOrRemove();
      }
    }
  }, {
    key: "commitOrRemove",
    value: function commitOrRemove() {
      if (this.isEmpty()) {
        this.remove();
      } else {
        this.commit();
      }
    }
  }, {
    key: "commit",
    value: function commit() {
      this.addToAnnotationStorage();
    }
  }, {
    key: "addToAnnotationStorage",
    value: function addToAnnotationStorage() {
      this._uiManager.addToAnnotationStorage(this);
    }
  }, {
    key: "setAt",
    value: function setAt(x, y, tx, ty) {
      var _this$parentDimension2 = _slicedToArray(this.parentDimensions, 2),
        width = _this$parentDimension2[0],
        height = _this$parentDimension2[1];
      var _this$screenToPageTra = this.screenToPageTranslation(tx, ty);
      var _this$screenToPageTra2 = _slicedToArray(_this$screenToPageTra, 2);
      tx = _this$screenToPageTra2[0];
      ty = _this$screenToPageTra2[1];
      this.x = (x + tx) / width;
      this.y = (y + ty) / height;
      this.fixAndSetPosition();
    }
  }, {
    key: "translate",
    value: function translate(x, y) {
      _classPrivateFieldLooseBase(this, _translate)[_translate](this.parentDimensions, x, y);
    }
  }, {
    key: "translateInPage",
    value: function translateInPage(x, y) {
      var _classPrivateFieldLoo36;
      (_classPrivateFieldLoo36 = _classPrivateFieldLooseBase(this, _initialPosition))[_initialPosition] || (_classPrivateFieldLoo36[_initialPosition] = [this.x, this.y]);
      _classPrivateFieldLooseBase(this, _translate)[_translate](this.pageDimensions, x, y);
      this.div.scrollIntoView({
        block: "nearest"
      });
    }
  }, {
    key: "drag",
    value: function drag(tx, ty) {
      var _classPrivateFieldLoo37;
      (_classPrivateFieldLoo37 = _classPrivateFieldLooseBase(this, _initialPosition))[_initialPosition] || (_classPrivateFieldLoo37[_initialPosition] = [this.x, this.y]);
      var _this$parentDimension3 = _slicedToArray(this.parentDimensions, 2),
        parentWidth = _this$parentDimension3[0],
        parentHeight = _this$parentDimension3[1];
      this.x += tx / parentWidth;
      this.y += ty / parentHeight;
      if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
        var _this$div$getBounding = this.div.getBoundingClientRect(),
          _x11 = _this$div$getBounding.x,
          _y = _this$div$getBounding.y;
        if (this.parent.findNewParent(this, _x11, _y)) {
          this.x -= Math.floor(this.x);
          this.y -= Math.floor(this.y);
        }
      }
      var x = this.x,
        y = this.y;
      var _this$getBaseTranslat = this.getBaseTranslation(),
        _this$getBaseTranslat2 = _slicedToArray(_this$getBaseTranslat, 2),
        bx = _this$getBaseTranslat2[0],
        by = _this$getBaseTranslat2[1];
      x += bx;
      y += by;
      this.div.style.left = "".concat((100 * x).toFixed(2), "%");
      this.div.style.top = "".concat((100 * y).toFixed(2), "%");
      this.div.scrollIntoView({
        block: "nearest"
      });
    }
  }, {
    key: "_hasBeenMoved",
    get: function get() {
      return !!_classPrivateFieldLooseBase(this, _initialPosition)[_initialPosition] && (_classPrivateFieldLooseBase(this, _initialPosition)[_initialPosition][0] !== this.x || _classPrivateFieldLooseBase(this, _initialPosition)[_initialPosition][1] !== this.y);
    }
  }, {
    key: "getBaseTranslation",
    value: function getBaseTranslation() {
      var _this$parentDimension4 = _slicedToArray(this.parentDimensions, 2),
        parentWidth = _this$parentDimension4[0],
        parentHeight = _this$parentDimension4[1];
      var _borderLineWidth = AnnotationEditor._borderLineWidth;
      var x = _borderLineWidth / parentWidth;
      var y = _borderLineWidth / parentHeight;
      switch (this.rotation) {
        case 90:
          return [-x, y];
        case 180:
          return [x, y];
        case 270:
          return [x, -y];
        default:
          return [-x, -y];
      }
    }
  }, {
    key: "_mustFixPosition",
    get: function get() {
      return true;
    }
  }, {
    key: "fixAndSetPosition",
    value: function fixAndSetPosition() {
      var rotation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.rotation;
      var _this$pageDimensions2 = _slicedToArray(this.pageDimensions, 2),
        pageWidth = _this$pageDimensions2[0],
        pageHeight = _this$pageDimensions2[1];
      var x = this.x,
        y = this.y,
        width = this.width,
        height = this.height;
      width *= pageWidth;
      height *= pageHeight;
      x *= pageWidth;
      y *= pageHeight;
      if (this._mustFixPosition) {
        switch (rotation) {
          case 0:
            x = Math.max(0, Math.min(pageWidth - width, x));
            y = Math.max(0, Math.min(pageHeight - height, y));
            break;
          case 90:
            x = Math.max(0, Math.min(pageWidth - height, x));
            y = Math.min(pageHeight, Math.max(width, y));
            break;
          case 180:
            x = Math.min(pageWidth, Math.max(width, x));
            y = Math.min(pageHeight, Math.max(height, y));
            break;
          case 270:
            x = Math.min(pageWidth, Math.max(height, x));
            y = Math.max(0, Math.min(pageHeight - width, y));
            break;
        }
      }
      this.x = x /= pageWidth;
      this.y = y /= pageHeight;
      var _this$getBaseTranslat3 = this.getBaseTranslation(),
        _this$getBaseTranslat4 = _slicedToArray(_this$getBaseTranslat3, 2),
        bx = _this$getBaseTranslat4[0],
        by = _this$getBaseTranslat4[1];
      x += bx;
      y += by;
      var style = this.div.style;
      style.left = "".concat((100 * x).toFixed(2), "%");
      style.top = "".concat((100 * y).toFixed(2), "%");
      this.moveInDOM();
    }
  }, {
    key: "screenToPageTranslation",
    value: function screenToPageTranslation(x, y) {
      return _classPrivateFieldLooseBase(AnnotationEditor, _rotatePoint)[_rotatePoint](x, y, this.parentRotation);
    }
  }, {
    key: "pageTranslationToScreen",
    value: function pageTranslationToScreen(x, y) {
      return _classPrivateFieldLooseBase(AnnotationEditor, _rotatePoint)[_rotatePoint](x, y, 360 - this.parentRotation);
    }
  }, {
    key: "parentScale",
    get: function get() {
      return this._uiManager.viewParameters.realScale;
    }
  }, {
    key: "parentRotation",
    get: function get() {
      return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
    }
  }, {
    key: "parentDimensions",
    get: function get() {
      var parentScale = this.parentScale,
        _this$pageDimensions3 = _slicedToArray(this.pageDimensions, 2),
        pageWidth = _this$pageDimensions3[0],
        pageHeight = _this$pageDimensions3[1];
      return [pageWidth * parentScale, pageHeight * parentScale];
    }
  }, {
    key: "setDims",
    value: function setDims(width, height) {
      var _this$parentDimension5 = _slicedToArray(this.parentDimensions, 2),
        parentWidth = _this$parentDimension5[0],
        parentHeight = _this$parentDimension5[1];
      this.div.style.width = "".concat((100 * width / parentWidth).toFixed(2), "%");
      if (!_classPrivateFieldLooseBase(this, _keepAspectRatio)[_keepAspectRatio]) {
        this.div.style.height = "".concat((100 * height / parentHeight).toFixed(2), "%");
      }
    }
  }, {
    key: "fixDims",
    value: function fixDims() {
      var style = this.div.style;
      var height = style.height,
        width = style.width;
      var widthPercent = width.endsWith("%");
      var heightPercent = !_classPrivateFieldLooseBase(this, _keepAspectRatio)[_keepAspectRatio] && height.endsWith("%");
      if (widthPercent && heightPercent) {
        return;
      }
      var _this$parentDimension6 = _slicedToArray(this.parentDimensions, 2),
        parentWidth = _this$parentDimension6[0],
        parentHeight = _this$parentDimension6[1];
      if (!widthPercent) {
        style.width = "".concat((100 * parseFloat(width) / parentWidth).toFixed(2), "%");
      }
      if (!_classPrivateFieldLooseBase(this, _keepAspectRatio)[_keepAspectRatio] && !heightPercent) {
        style.height = "".concat((100 * parseFloat(height) / parentHeight).toFixed(2), "%");
      }
    }
  }, {
    key: "getInitialTranslation",
    value: function getInitialTranslation() {
      return [0, 0];
    }
  }, {
    key: "altTextFinish",
    value: function altTextFinish() {
      var _classPrivateFieldLoo38;
      (_classPrivateFieldLoo38 = _classPrivateFieldLooseBase(this, _altText3)[_altText3]) === null || _classPrivateFieldLoo38 === void 0 || _classPrivateFieldLoo38.finish();
    }
  }, {
    key: "addEditToolbar",
    value: function () {
      var _addEditToolbar = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(this._editToolbar || _classPrivateFieldLooseBase(this, _isInEditMode)[_isInEditMode])) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return", this._editToolbar);
            case 2:
              this._editToolbar = new EditorToolbar(this);
              this.div.append(this._editToolbar.render());
              if (!_classPrivateFieldLooseBase(this, _altText3)[_altText3]) {
                _context10.next = 7;
                break;
              }
              _context10.next = 7;
              return this._editToolbar.addAltText(_classPrivateFieldLooseBase(this, _altText3)[_altText3]);
            case 7:
              return _context10.abrupt("return", this._editToolbar);
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function addEditToolbar() {
        return _addEditToolbar.apply(this, arguments);
      }
      return addEditToolbar;
    }()
  }, {
    key: "removeEditToolbar",
    value: function removeEditToolbar() {
      var _classPrivateFieldLoo39;
      if (!this._editToolbar) {
        return;
      }
      this._editToolbar.remove();
      this._editToolbar = null;
      (_classPrivateFieldLoo39 = _classPrivateFieldLooseBase(this, _altText3)[_altText3]) === null || _classPrivateFieldLoo39 === void 0 || _classPrivateFieldLoo39.destroy();
    }
  }, {
    key: "addContainer",
    value: function addContainer(container) {
      var _this$_editToolbar;
      var editToolbarDiv = (_this$_editToolbar = this._editToolbar) === null || _this$_editToolbar === void 0 ? void 0 : _this$_editToolbar.div;
      if (editToolbarDiv) {
        editToolbarDiv.before(container);
      } else {
        this.div.append(container);
      }
    }
  }, {
    key: "getClientDimensions",
    value: function getClientDimensions() {
      return this.div.getBoundingClientRect();
    }
  }, {
    key: "addAltTextButton",
    value: function () {
      var _addAltTextButton = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!_classPrivateFieldLooseBase(this, _altText3)[_altText3]) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return");
            case 2:
              AltText.initialize(AnnotationEditor._l10n);
              _classPrivateFieldLooseBase(this, _altText3)[_altText3] = new AltText(this);
              if (_classPrivateFieldLooseBase(this, _accessibilityData)[_accessibilityData]) {
                _classPrivateFieldLooseBase(this, _altText3)[_altText3].data = _classPrivateFieldLooseBase(this, _accessibilityData)[_accessibilityData];
                _classPrivateFieldLooseBase(this, _accessibilityData)[_accessibilityData] = null;
              }
              _context11.next = 7;
              return this.addEditToolbar();
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function addAltTextButton() {
        return _addAltTextButton.apply(this, arguments);
      }
      return addAltTextButton;
    }()
  }, {
    key: "altTextData",
    get: function get() {
      var _classPrivateFieldLoo40;
      return (_classPrivateFieldLoo40 = _classPrivateFieldLooseBase(this, _altText3)[_altText3]) === null || _classPrivateFieldLoo40 === void 0 ? void 0 : _classPrivateFieldLoo40.data;
    },
    set: function set(data) {
      if (!_classPrivateFieldLooseBase(this, _altText3)[_altText3]) {
        return;
      }
      _classPrivateFieldLooseBase(this, _altText3)[_altText3].data = data;
    }
  }, {
    key: "guessedAltText",
    get: function get() {
      var _classPrivateFieldLoo41;
      return (_classPrivateFieldLoo41 = _classPrivateFieldLooseBase(this, _altText3)[_altText3]) === null || _classPrivateFieldLoo41 === void 0 ? void 0 : _classPrivateFieldLoo41.guessedText;
    }
  }, {
    key: "setGuessedAltText",
    value: function () {
      var _setGuessedAltText = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(text) {
        var _classPrivateFieldLoo42;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return (_classPrivateFieldLoo42 = _classPrivateFieldLooseBase(this, _altText3)[_altText3]) === null || _classPrivateFieldLoo42 === void 0 ? void 0 : _classPrivateFieldLoo42.setGuessedText(text);
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function setGuessedAltText(_x12) {
        return _setGuessedAltText.apply(this, arguments);
      }
      return setGuessedAltText;
    }()
  }, {
    key: "serializeAltText",
    value: function serializeAltText(isForCopying) {
      var _classPrivateFieldLoo43;
      return (_classPrivateFieldLoo43 = _classPrivateFieldLooseBase(this, _altText3)[_altText3]) === null || _classPrivateFieldLoo43 === void 0 ? void 0 : _classPrivateFieldLoo43.serialize(isForCopying);
    }
  }, {
    key: "hasAltText",
    value: function hasAltText() {
      return !!_classPrivateFieldLooseBase(this, _altText3)[_altText3] && !_classPrivateFieldLooseBase(this, _altText3)[_altText3].isEmpty();
    }
  }, {
    key: "hasAltTextData",
    value: function hasAltTextData() {
      var _classPrivateFieldLoo44, _classPrivateFieldLoo45;
      return (_classPrivateFieldLoo44 = (_classPrivateFieldLoo45 = _classPrivateFieldLooseBase(this, _altText3)[_altText3]) === null || _classPrivateFieldLoo45 === void 0 ? void 0 : _classPrivateFieldLoo45.hasData()) !== null && _classPrivateFieldLoo44 !== void 0 ? _classPrivateFieldLoo44 : false;
    }
  }, {
    key: "render",
    value: function render() {
      this.div = document.createElement("div");
      this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
      this.div.className = this.name;
      this.div.setAttribute("id", this.id);
      this.div.tabIndex = _classPrivateFieldLooseBase(this, _disabled)[_disabled] ? -1 : 0;
      if (!this._isVisible) {
        this.div.classList.add("hidden");
      }
      this.setInForeground();
      _classPrivateFieldLooseBase(this, _addFocusListeners)[_addFocusListeners]();
      var _this$parentDimension7 = _slicedToArray(this.parentDimensions, 2),
        parentWidth = _this$parentDimension7[0],
        parentHeight = _this$parentDimension7[1];
      if (this.parentRotation % 180 !== 0) {
        this.div.style.maxWidth = "".concat((100 * parentHeight / parentWidth).toFixed(2), "%");
        this.div.style.maxHeight = "".concat((100 * parentWidth / parentHeight).toFixed(2), "%");
      }
      var _this$getInitialTrans = this.getInitialTranslation(),
        _this$getInitialTrans2 = _slicedToArray(_this$getInitialTrans, 2),
        tx = _this$getInitialTrans2[0],
        ty = _this$getInitialTrans2[1];
      this.translate(tx, ty);
      bindEvents(this, this.div, ["pointerdown"]);
      return this.div;
    }
  }, {
    key: "pointerdown",
    value: function pointerdown(event) {
      var isMac = util_FeatureTest.platform.isMac;
      if (event.button !== 0 || event.ctrlKey && isMac) {
        event.preventDefault();
        return;
      }
      _classPrivateFieldLooseBase(this, _hasBeenClicked)[_hasBeenClicked] = true;
      if (this._isDraggable) {
        _classPrivateFieldLooseBase(this, _setUpDragSession)[_setUpDragSession](event);
        return;
      }
      _classPrivateFieldLooseBase(this, _selectOnPointerEvent)[_selectOnPointerEvent](event);
    }
  }, {
    key: "isSelected",
    get: function get() {
      return this._uiManager.isSelected(this);
    }
  }, {
    key: "moveInDOM",
    value: function moveInDOM() {
      var _this13 = this;
      if (_classPrivateFieldLooseBase(this, _moveInDOMTimeout)[_moveInDOMTimeout]) {
        clearTimeout(_classPrivateFieldLooseBase(this, _moveInDOMTimeout)[_moveInDOMTimeout]);
      }
      _classPrivateFieldLooseBase(this, _moveInDOMTimeout)[_moveInDOMTimeout] = setTimeout(function () {
        var _this13$parent;
        _classPrivateFieldLooseBase(_this13, _moveInDOMTimeout)[_moveInDOMTimeout] = null;
        (_this13$parent = _this13.parent) === null || _this13$parent === void 0 || _this13$parent.moveEditorInDOM(_this13);
      }, 0);
    }
  }, {
    key: "_setParentAndPosition",
    value: function _setParentAndPosition(parent, x, y) {
      parent.changeParent(this);
      this.x = x;
      this.y = y;
      this.fixAndSetPosition();
    }
  }, {
    key: "getRect",
    value: function getRect(tx, ty) {
      var rotation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.rotation;
      var scale = this.parentScale;
      var _this$pageDimensions4 = _slicedToArray(this.pageDimensions, 2),
        pageWidth = _this$pageDimensions4[0],
        pageHeight = _this$pageDimensions4[1];
      var _this$pageTranslation = _slicedToArray(this.pageTranslation, 2),
        pageX = _this$pageTranslation[0],
        pageY = _this$pageTranslation[1];
      var shiftX = tx / scale;
      var shiftY = ty / scale;
      var x = this.x * pageWidth;
      var y = this.y * pageHeight;
      var width = this.width * pageWidth;
      var height = this.height * pageHeight;
      switch (rotation) {
        case 0:
          return [x + shiftX + pageX, pageHeight - y - shiftY - height + pageY, x + shiftX + width + pageX, pageHeight - y - shiftY + pageY];
        case 90:
          return [x + shiftY + pageX, pageHeight - y + shiftX + pageY, x + shiftY + height + pageX, pageHeight - y + shiftX + width + pageY];
        case 180:
          return [x - shiftX - width + pageX, pageHeight - y + shiftY + pageY, x - shiftX + pageX, pageHeight - y + shiftY + height + pageY];
        case 270:
          return [x - shiftY - height + pageX, pageHeight - y - shiftX - width + pageY, x - shiftY + pageX, pageHeight - y - shiftX + pageY];
        default:
          throw new Error("Invalid rotation");
      }
    }
  }, {
    key: "getRectInCurrentCoords",
    value: function getRectInCurrentCoords(rect, pageHeight) {
      var _rect = _slicedToArray(rect, 4),
        x1 = _rect[0],
        y1 = _rect[1],
        x2 = _rect[2],
        y2 = _rect[3];
      var width = x2 - x1;
      var height = y2 - y1;
      switch (this.rotation) {
        case 0:
          return [x1, pageHeight - y2, width, height];
        case 90:
          return [x1, pageHeight - y1, height, width];
        case 180:
          return [x2, pageHeight - y1, width, height];
        case 270:
          return [x2, pageHeight - y2, height, width];
        default:
          throw new Error("Invalid rotation");
      }
    }
  }, {
    key: "onceAdded",
    value: function onceAdded() {}
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return false;
    }
  }, {
    key: "enableEditMode",
    value: function enableEditMode() {
      _classPrivateFieldLooseBase(this, _isInEditMode)[_isInEditMode] = true;
    }
  }, {
    key: "disableEditMode",
    value: function disableEditMode() {
      _classPrivateFieldLooseBase(this, _isInEditMode)[_isInEditMode] = false;
    }
  }, {
    key: "isInEditMode",
    value: function isInEditMode() {
      return _classPrivateFieldLooseBase(this, _isInEditMode)[_isInEditMode];
    }
  }, {
    key: "shouldGetKeyboardEvents",
    value: function shouldGetKeyboardEvents() {
      return _classPrivateFieldLooseBase(this, _isResizerEnabledForKeyboard)[_isResizerEnabledForKeyboard];
    }
  }, {
    key: "needsToBeRebuilt",
    value: function needsToBeRebuilt() {
      return this.div && !this.isAttachedToDOM;
    }
  }, {
    key: "rebuild",
    value: function rebuild() {
      _classPrivateFieldLooseBase(this, _addFocusListeners)[_addFocusListeners]();
    }
  }, {
    key: "rotate",
    value: function rotate(_angle) {}
  }, {
    key: "serializeDeleted",
    value: function serializeDeleted() {
      var _this$_initialData;
      return {
        id: this.annotationElementId,
        deleted: true,
        pageIndex: this.pageIndex,
        popupRef: ((_this$_initialData = this._initialData) === null || _this$_initialData === void 0 ? void 0 : _this$_initialData.popupRef) || ""
      };
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var isForCopying = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      unreachable("An editor must be serializable");
    }
  }, {
    key: "hasBeenModified",
    get: function get() {
      return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
    }
  }, {
    key: "remove",
    value: function remove() {
      var _classPrivateFieldLoo46;
      (_classPrivateFieldLoo46 = _classPrivateFieldLooseBase(this, _focusAC)[_focusAC]) === null || _classPrivateFieldLoo46 === void 0 || _classPrivateFieldLoo46.abort();
      _classPrivateFieldLooseBase(this, _focusAC)[_focusAC] = null;
      if (!this.isEmpty()) {
        this.commit();
      }
      if (this.parent) {
        this.parent.remove(this);
      } else {
        this._uiManager.removeEditor(this);
      }
      if (_classPrivateFieldLooseBase(this, _moveInDOMTimeout)[_moveInDOMTimeout]) {
        clearTimeout(_classPrivateFieldLooseBase(this, _moveInDOMTimeout)[_moveInDOMTimeout]);
        _classPrivateFieldLooseBase(this, _moveInDOMTimeout)[_moveInDOMTimeout] = null;
      }
      _classPrivateFieldLooseBase(this, _stopResizing)[_stopResizing]();
      this.removeEditToolbar();
      if (_classPrivateFieldLooseBase(this, _telemetryTimeouts)[_telemetryTimeouts]) {
        var _iterator43 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _telemetryTimeouts)[_telemetryTimeouts].values()),
          _step43;
        try {
          for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
            var timeout = _step43.value;
            clearTimeout(timeout);
          }
        } catch (err) {
          _iterator43.e(err);
        } finally {
          _iterator43.f();
        }
        _classPrivateFieldLooseBase(this, _telemetryTimeouts)[_telemetryTimeouts] = null;
      }
      this.parent = null;
    }
  }, {
    key: "isResizable",
    get: function get() {
      return false;
    }
  }, {
    key: "makeResizable",
    value: function makeResizable() {
      if (this.isResizable) {
        _classPrivateFieldLooseBase(this, _createResizers)[_createResizers]();
        _classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv].classList.remove("hidden");
        bindEvents(this, this.div, ["keydown"]);
      }
    }
  }, {
    key: "toolbarPosition",
    get: function get() {
      return null;
    }
  }, {
    key: "keydown",
    value: function keydown(event) {
      if (!this.isResizable || event.target !== this.div || event.key !== "Enter") {
        return;
      }
      this._uiManager.setSelected(this);
      _classPrivateFieldLooseBase(this, _savedDimensions)[_savedDimensions] = {
        savedX: this.x,
        savedY: this.y,
        savedWidth: this.width,
        savedHeight: this.height
      };
      var children = _classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv].children;
      if (!_classPrivateFieldLooseBase(this, _allResizerDivs)[_allResizerDivs]) {
        _classPrivateFieldLooseBase(this, _allResizerDivs)[_allResizerDivs] = Array.from(children);
        var boundResizerKeydown = _classPrivateFieldLooseBase(this, _resizerKeydown)[_resizerKeydown].bind(this);
        var boundResizerBlur = _classPrivateFieldLooseBase(this, _resizerBlur)[_resizerBlur].bind(this);
        var signal = this._uiManager._signal;
        var _iterator44 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allResizerDivs)[_allResizerDivs]),
          _step44;
        try {
          for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
            var div = _step44.value;
            var name = div.getAttribute("data-resizer-name");
            div.setAttribute("role", "spinbutton");
            div.addEventListener("keydown", boundResizerKeydown, {
              signal: signal
            });
            div.addEventListener("blur", boundResizerBlur, {
              signal: signal
            });
            div.addEventListener("focus", _classPrivateFieldLooseBase(this, _resizerFocus)[_resizerFocus].bind(this, name), {
              signal: signal
            });
            div.setAttribute("data-l10n-id", AnnotationEditor._l10nResizer[name]);
          }
        } catch (err) {
          _iterator44.e(err);
        } finally {
          _iterator44.f();
        }
      }
      var first = _classPrivateFieldLooseBase(this, _allResizerDivs)[_allResizerDivs][0];
      var firstPosition = 0;
      var _iterator45 = _createForOfIteratorHelper(children),
        _step45;
      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var _div2 = _step45.value;
          if (_div2 === first) {
            break;
          }
          firstPosition++;
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
      var nextFirstPosition = (360 - this.rotation + this.parentRotation) % 360 / 90 * (_classPrivateFieldLooseBase(this, _allResizerDivs)[_allResizerDivs].length / 4);
      if (nextFirstPosition !== firstPosition) {
        if (nextFirstPosition < firstPosition) {
          for (var _i4 = 0; _i4 < firstPosition - nextFirstPosition; _i4++) {
            _classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv].append(_classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv].firstChild);
          }
        } else if (nextFirstPosition > firstPosition) {
          for (var _i5 = 0; _i5 < nextFirstPosition - firstPosition; _i5++) {
            _classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv].firstChild.before(_classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv].lastChild);
          }
        }
        var i = 0;
        var _iterator46 = _createForOfIteratorHelper(children),
          _step46;
        try {
          for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
            var child = _step46.value;
            var _div = _classPrivateFieldLooseBase(this, _allResizerDivs)[_allResizerDivs][i++];
            var _name2 = _div.getAttribute("data-resizer-name");
            child.setAttribute("data-l10n-id", AnnotationEditor._l10nResizer[_name2]);
          }
        } catch (err) {
          _iterator46.e(err);
        } finally {
          _iterator46.f();
        }
      }
      _classPrivateFieldLooseBase(this, _setResizerTabIndex)[_setResizerTabIndex](0);
      _classPrivateFieldLooseBase(this, _isResizerEnabledForKeyboard)[_isResizerEnabledForKeyboard] = true;
      _classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv].firstChild.focus({
        focusVisible: true
      });
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, {
    key: "_resizeWithKeyboard",
    value: function _resizeWithKeyboard(x, y) {
      if (!_classPrivateFieldLooseBase(this, _isResizerEnabledForKeyboard)[_isResizerEnabledForKeyboard]) {
        return;
      }
      _classPrivateFieldLooseBase(this, _resizerPointermove)[_resizerPointermove](_classPrivateFieldLooseBase(this, _focusedResizerName)[_focusedResizerName], {
        movementX: x,
        movementY: y
      });
    }
  }, {
    key: "_stopResizingWithKeyboard",
    value: function _stopResizingWithKeyboard() {
      _classPrivateFieldLooseBase(this, _stopResizing)[_stopResizing]();
      this.div.focus();
    }
  }, {
    key: "select",
    value: function select() {
      var _this$div2,
        _this14 = this,
        _this$_editToolbar2,
        _classPrivateFieldLoo47;
      this.makeResizable();
      (_this$div2 = this.div) === null || _this$div2 === void 0 || _this$div2.classList.add("selectedEditor");
      if (!this._editToolbar) {
        this.addEditToolbar().then(function () {
          var _this14$div;
          if ((_this14$div = _this14.div) !== null && _this14$div !== void 0 && _this14$div.classList.contains("selectedEditor")) {
            var _this14$_editToolbar;
            (_this14$_editToolbar = _this14._editToolbar) === null || _this14$_editToolbar === void 0 || _this14$_editToolbar.show();
          }
        });
        return;
      }
      (_this$_editToolbar2 = this._editToolbar) === null || _this$_editToolbar2 === void 0 || _this$_editToolbar2.show();
      (_classPrivateFieldLoo47 = _classPrivateFieldLooseBase(this, _altText3)[_altText3]) === null || _classPrivateFieldLoo47 === void 0 || _classPrivateFieldLoo47.toggleAltTextBadge(false);
    }
  }, {
    key: "unselect",
    value: function unselect() {
      var _classPrivateFieldLoo48, _this$div3, _this$div4, _this$_editToolbar3, _classPrivateFieldLoo49;
      (_classPrivateFieldLoo48 = _classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv]) === null || _classPrivateFieldLoo48 === void 0 || _classPrivateFieldLoo48.classList.add("hidden");
      (_this$div3 = this.div) === null || _this$div3 === void 0 || _this$div3.classList.remove("selectedEditor");
      if ((_this$div4 = this.div) !== null && _this$div4 !== void 0 && _this$div4.contains(document.activeElement)) {
        this._uiManager.currentLayer.div.focus({
          preventScroll: true
        });
      }
      (_this$_editToolbar3 = this._editToolbar) === null || _this$_editToolbar3 === void 0 || _this$_editToolbar3.hide();
      (_classPrivateFieldLoo49 = _classPrivateFieldLooseBase(this, _altText3)[_altText3]) === null || _classPrivateFieldLoo49 === void 0 || _classPrivateFieldLoo49.toggleAltTextBadge(true);
    }
  }, {
    key: "updateParams",
    value: function updateParams(type, value) {}
  }, {
    key: "disableEditing",
    value: function disableEditing() {}
  }, {
    key: "enableEditing",
    value: function enableEditing() {}
  }, {
    key: "enterInEditMode",
    value: function enterInEditMode() {}
  }, {
    key: "getImageForAltText",
    value: function getImageForAltText() {
      return null;
    }
  }, {
    key: "contentDiv",
    get: function get() {
      return this.div;
    }
  }, {
    key: "isEditing",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _isEditing)[_isEditing];
    },
    set: function set(value) {
      _classPrivateFieldLooseBase(this, _isEditing)[_isEditing] = value;
      if (!this.parent) {
        return;
      }
      if (value) {
        this.parent.setSelected(this);
        this.parent.setActiveEditor(this);
      } else {
        this.parent.setActiveEditor(null);
      }
    }
  }, {
    key: "setAspectRatio",
    value: function setAspectRatio(width, height) {
      _classPrivateFieldLooseBase(this, _keepAspectRatio)[_keepAspectRatio] = true;
      var aspectRatio = width / height;
      var style = this.div.style;
      style.aspectRatio = aspectRatio;
      style.height = "auto";
    }
  }, {
    key: "telemetryInitialData",
    get: function get() {
      return {
        action: "added"
      };
    }
  }, {
    key: "telemetryFinalData",
    get: function get() {
      return null;
    }
  }, {
    key: "_reportTelemetry",
    value: function _reportTelemetry(data) {
      var _this15 = this;
      var mustWait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (mustWait) {
        var _classPrivateFieldLoo50;
        (_classPrivateFieldLoo50 = _classPrivateFieldLooseBase(this, _telemetryTimeouts))[_telemetryTimeouts] || (_classPrivateFieldLoo50[_telemetryTimeouts] = new Map());
        var action = data.action;
        var timeout = _classPrivateFieldLooseBase(this, _telemetryTimeouts)[_telemetryTimeouts].get(action);
        if (timeout) {
          clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
          _this15._reportTelemetry(data);
          _classPrivateFieldLooseBase(_this15, _telemetryTimeouts)[_telemetryTimeouts].delete(action);
          if (_classPrivateFieldLooseBase(_this15, _telemetryTimeouts)[_telemetryTimeouts].size === 0) {
            _classPrivateFieldLooseBase(_this15, _telemetryTimeouts)[_telemetryTimeouts] = null;
          }
        }, AnnotationEditor._telemetryTimeout);
        _classPrivateFieldLooseBase(this, _telemetryTimeouts)[_telemetryTimeouts].set(action, timeout);
        return;
      }
      data.type || (data.type = this.editorType);
      this._uiManager._eventBus.dispatch("reporttelemetry", {
        source: this,
        details: {
          type: "editing",
          data: data
        }
      });
    }
  }, {
    key: "show",
    value: function show() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._isVisible;
      this.div.classList.toggle("hidden", !visible);
      this._isVisible = visible;
    }
  }, {
    key: "enable",
    value: function enable() {
      if (this.div) {
        this.div.tabIndex = 0;
      }
      _classPrivateFieldLooseBase(this, _disabled)[_disabled] = false;
    }
  }, {
    key: "disable",
    value: function disable() {
      if (this.div) {
        this.div.tabIndex = -1;
      }
      _classPrivateFieldLooseBase(this, _disabled)[_disabled] = true;
    }
  }, {
    key: "renderAnnotationElement",
    value: function renderAnnotationElement(annotation) {
      var content = annotation.container.querySelector(".annotationContent");
      if (!content) {
        content = document.createElement("div");
        content.classList.add("annotationContent", this.editorType);
        annotation.container.prepend(content);
      } else if (content.nodeName === "CANVAS") {
        var canvas = content;
        content = document.createElement("div");
        content.classList.add("annotationContent", this.editorType);
        canvas.before(content);
      }
      return content;
    }
  }, {
    key: "resetAnnotationElement",
    value: function resetAnnotationElement(annotation) {
      var firstChild = annotation.container.firstChild;
      if ((firstChild === null || firstChild === void 0 ? void 0 : firstChild.nodeName) === "DIV" && firstChild.classList.contains("annotationContent")) {
        firstChild.remove();
      }
    }
  }], [{
    key: "_resizerKeyboardManager",
    get: function get() {
      var resize = AnnotationEditor.prototype._resizeWithKeyboard;
      var small = _AnnotationEditorUIManager.TRANSLATE_SMALL;
      var big = _AnnotationEditorUIManager.TRANSLATE_BIG;
      return _shadow(this, "_resizerKeyboardManager", new KeyboardManager([[["ArrowLeft", "mac+ArrowLeft"], resize, {
        args: [-small, 0]
      }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], resize, {
        args: [-big, 0]
      }], [["ArrowRight", "mac+ArrowRight"], resize, {
        args: [small, 0]
      }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], resize, {
        args: [big, 0]
      }], [["ArrowUp", "mac+ArrowUp"], resize, {
        args: [0, -small]
      }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], resize, {
        args: [0, -big]
      }], [["ArrowDown", "mac+ArrowDown"], resize, {
        args: [0, small]
      }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], resize, {
        args: [0, big]
      }], [["Escape", "mac+Escape"], AnnotationEditor.prototype._stopResizingWithKeyboard]]));
    }
  }, {
    key: "_defaultLineColor",
    get: function get() {
      return _shadow(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
    }
  }, {
    key: "deleteAnnotationElement",
    value: function deleteAnnotationElement(editor) {
      var fakeEditor = new FakeEditor({
        id: editor.parent.getNextId(),
        parent: editor.parent,
        uiManager: editor._uiManager
      });
      fakeEditor.annotationElementId = editor.annotationElementId;
      fakeEditor.deleted = true;
      fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
    }
  }, {
    key: "initialize",
    value: function initialize(l10n, _uiManager) {
      var _AnnotationEditor$_l;
      (_AnnotationEditor$_l = AnnotationEditor._l10n) !== null && _AnnotationEditor$_l !== void 0 ? _AnnotationEditor$_l : AnnotationEditor._l10n = l10n;
      AnnotationEditor._l10nResizer || (AnnotationEditor._l10nResizer = Object.freeze({
        topLeft: "pdfjs-editor-resizer-top-left",
        topMiddle: "pdfjs-editor-resizer-top-middle",
        topRight: "pdfjs-editor-resizer-top-right",
        middleRight: "pdfjs-editor-resizer-middle-right",
        bottomRight: "pdfjs-editor-resizer-bottom-right",
        bottomMiddle: "pdfjs-editor-resizer-bottom-middle",
        bottomLeft: "pdfjs-editor-resizer-bottom-left",
        middleLeft: "pdfjs-editor-resizer-middle-left"
      }));
      if (AnnotationEditor._borderLineWidth !== -1) {
        return;
      }
      var style = getComputedStyle(document.documentElement);
      AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
    }
  }, {
    key: "updateDefaultParams",
    value: function updateDefaultParams(_type, _value) {}
  }, {
    key: "defaultPropertiesToUpdate",
    get: function get() {
      return [];
    }
  }, {
    key: "isHandlingMimeForPasting",
    value: function isHandlingMimeForPasting(mime) {
      return false;
    }
  }, {
    key: "paste",
    value: function paste(item, parent) {
      unreachable("Not implemented");
    }
  }, {
    key: "deserialize",
    value: function () {
      var _deserialize = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(data, parent, uiManager) {
        var editor, _editor$pageDimension, pageWidth, pageHeight, _editor$getRectInCurr, _editor$getRectInCurr2, x, y, width, height;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              editor = new this.prototype.constructor({
                parent: parent,
                id: parent.getNextId(),
                uiManager: uiManager
              });
              editor.rotation = data.rotation;
              _classPrivateFieldLooseBase(editor, _accessibilityData)[_accessibilityData] = data.accessibilityData;
              _editor$pageDimension = _slicedToArray(editor.pageDimensions, 2), pageWidth = _editor$pageDimension[0], pageHeight = _editor$pageDimension[1];
              _editor$getRectInCurr = editor.getRectInCurrentCoords(data.rect, pageHeight), _editor$getRectInCurr2 = _slicedToArray(_editor$getRectInCurr, 4), x = _editor$getRectInCurr2[0], y = _editor$getRectInCurr2[1], width = _editor$getRectInCurr2[2], height = _editor$getRectInCurr2[3];
              editor.x = x / pageWidth;
              editor.y = y / pageHeight;
              editor.width = width / pageWidth;
              editor.height = height / pageHeight;
              return _context13.abrupt("return", editor);
            case 10:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function deserialize(_x13, _x14, _x15) {
        return _deserialize.apply(this, arguments);
      }
      return deserialize;
    }()
  }, {
    key: "MIN_SIZE",
    get: function get() {
      return 16;
    }
  }, {
    key: "canCreateNewEmptyEditor",
    value: function canCreateNewEmptyEditor() {
      return true;
    }
  }]);
}();
_AnnotationEditor = AnnotationEditor;
function _translate2(_ref168, x, y) {
  var _ref169 = _slicedToArray(_ref168, 2),
    width = _ref169[0],
    height = _ref169[1];
  var _this$screenToPageTra3 = this.screenToPageTranslation(x, y);
  var _this$screenToPageTra4 = _slicedToArray(_this$screenToPageTra3, 2);
  x = _this$screenToPageTra4[0];
  y = _this$screenToPageTra4[1];
  this.x += x / width;
  this.y += y / height;
  this.fixAndSetPosition();
}
function _rotatePoint2(x, y, angle) {
  switch (angle) {
    case 90:
      return [y, -x];
    case 180:
      return [-x, -y];
    case 270:
      return [-y, x];
    default:
      return [x, y];
  }
}
function _getRotationMatrix2(rotation) {
  switch (rotation) {
    case 90:
      {
        var _this$pageDimensions6 = _slicedToArray(this.pageDimensions, 2),
          pageWidth = _this$pageDimensions6[0],
          pageHeight = _this$pageDimensions6[1];
        return [0, -pageWidth / pageHeight, pageHeight / pageWidth, 0];
      }
    case 180:
      return [-1, 0, 0, -1];
    case 270:
      {
        var _this$pageDimensions7 = _slicedToArray(this.pageDimensions, 2),
          _pageWidth3 = _this$pageDimensions7[0],
          _pageHeight3 = _this$pageDimensions7[1];
        return [0, _pageWidth3 / _pageHeight3, -_pageHeight3 / _pageWidth3, 0];
      }
    default:
      return [1, 0, 0, 1];
  }
}
function _createResizers2() {
  if (_classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv]) {
    return;
  }
  _classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv] = document.createElement("div");
  _classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv].classList.add("resizers");
  var classes = this._willKeepAspectRatio ? ["topLeft", "topRight", "bottomRight", "bottomLeft"] : ["topLeft", "topMiddle", "topRight", "middleRight", "bottomRight", "bottomMiddle", "bottomLeft", "middleLeft"];
  var signal = this._uiManager._signal;
  for (var _i29 = 0, _classes = classes; _i29 < _classes.length; _i29++) {
    var name = _classes[_i29];
    var div = document.createElement("div");
    _classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv].append(div);
    div.classList.add("resizer", name);
    div.setAttribute("data-resizer-name", name);
    div.addEventListener("pointerdown", _classPrivateFieldLooseBase(this, _resizerPointerdown)[_resizerPointerdown].bind(this, name), {
      signal: signal
    });
    div.addEventListener("contextmenu", _noContextMenu, {
      signal: signal
    });
    div.tabIndex = -1;
  }
  this.div.prepend(_classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv]);
}
function _resizerPointerdown2(name, event) {
  var _classPrivateFieldLoo134,
    _this91 = this;
  event.preventDefault();
  var isMac = util_FeatureTest.platform.isMac;
  if (event.button !== 0 || event.ctrlKey && isMac) {
    return;
  }
  (_classPrivateFieldLoo134 = _classPrivateFieldLooseBase(this, _altText3)[_altText3]) === null || _classPrivateFieldLoo134 === void 0 || _classPrivateFieldLoo134.toggle(false);
  var savedDraggable = this._isDraggable;
  this._isDraggable = false;
  var ac = new AbortController();
  var signal = this._uiManager.combinedSignal(ac);
  this.parent.togglePointerEvents(false);
  window.addEventListener("pointermove", _classPrivateFieldLooseBase(this, _resizerPointermove)[_resizerPointermove].bind(this, name), {
    passive: true,
    capture: true,
    signal: signal
  });
  window.addEventListener("contextmenu", _noContextMenu, {
    signal: signal
  });
  var savedX = this.x;
  var savedY = this.y;
  var savedWidth = this.width;
  var savedHeight = this.height;
  var savedParentCursor = this.parent.div.style.cursor;
  var savedCursor = this.div.style.cursor;
  this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
  var pointerUpCallback = function pointerUpCallback() {
    var _classPrivateFieldLoo135;
    ac.abort();
    _this91.parent.togglePointerEvents(true);
    (_classPrivateFieldLoo135 = _classPrivateFieldLooseBase(_this91, _altText3)[_altText3]) === null || _classPrivateFieldLoo135 === void 0 || _classPrivateFieldLoo135.toggle(true);
    _this91._isDraggable = savedDraggable;
    _this91.parent.div.style.cursor = savedParentCursor;
    _this91.div.style.cursor = savedCursor;
    _classPrivateFieldLooseBase(_this91, _addResizeToUndoStack)[_addResizeToUndoStack](savedX, savedY, savedWidth, savedHeight);
  };
  window.addEventListener("pointerup", pointerUpCallback, {
    signal: signal
  });
  window.addEventListener("blur", pointerUpCallback, {
    signal: signal
  });
}
function _addResizeToUndoStack2(savedX, savedY, savedWidth, savedHeight) {
  var _this92 = this;
  var newX = this.x;
  var newY = this.y;
  var newWidth = this.width;
  var newHeight = this.height;
  if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) {
    return;
  }
  this.addCommands({
    cmd: function cmd() {
      _this92.width = newWidth;
      _this92.height = newHeight;
      _this92.x = newX;
      _this92.y = newY;
      var _this92$parentDimensi = _slicedToArray(_this92.parentDimensions, 2),
        parentWidth = _this92$parentDimensi[0],
        parentHeight = _this92$parentDimensi[1];
      _this92.setDims(parentWidth * newWidth, parentHeight * newHeight);
      _this92.fixAndSetPosition();
    },
    undo: function undo() {
      _this92.width = savedWidth;
      _this92.height = savedHeight;
      _this92.x = savedX;
      _this92.y = savedY;
      var _this92$parentDimensi2 = _slicedToArray(_this92.parentDimensions, 2),
        parentWidth = _this92$parentDimensi2[0],
        parentHeight = _this92$parentDimensi2[1];
      _this92.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
      _this92.fixAndSetPosition();
    },
    mustExec: true
  });
}
function _resizerPointermove2(name, event) {
  var _this$parentDimension14 = _slicedToArray(this.parentDimensions, 2),
    parentWidth = _this$parentDimension14[0],
    parentHeight = _this$parentDimension14[1];
  var savedX = this.x;
  var savedY = this.y;
  var savedWidth = this.width;
  var savedHeight = this.height;
  var minWidth = _AnnotationEditor.MIN_SIZE / parentWidth;
  var minHeight = _AnnotationEditor.MIN_SIZE / parentHeight;
  var round = function round(x) {
    return Math.round(x * 10000) / 10000;
  };
  var rotationMatrix = _classPrivateFieldLooseBase(this, _getRotationMatrix)[_getRotationMatrix](this.rotation);
  var transf = function transf(x, y) {
    return [rotationMatrix[0] * x + rotationMatrix[2] * y, rotationMatrix[1] * x + rotationMatrix[3] * y];
  };
  var invRotationMatrix = _classPrivateFieldLooseBase(this, _getRotationMatrix)[_getRotationMatrix](360 - this.rotation);
  var invTransf = function invTransf(x, y) {
    return [invRotationMatrix[0] * x + invRotationMatrix[2] * y, invRotationMatrix[1] * x + invRotationMatrix[3] * y];
  };
  var getPoint;
  var getOpposite;
  var isDiagonal = false;
  var isHorizontal = false;
  switch (name) {
    case "topLeft":
      isDiagonal = true;
      getPoint = function getPoint(w, h) {
        return [0, 0];
      };
      getOpposite = function getOpposite(w, h) {
        return [w, h];
      };
      break;
    case "topMiddle":
      getPoint = function getPoint(w, h) {
        return [w / 2, 0];
      };
      getOpposite = function getOpposite(w, h) {
        return [w / 2, h];
      };
      break;
    case "topRight":
      isDiagonal = true;
      getPoint = function getPoint(w, h) {
        return [w, 0];
      };
      getOpposite = function getOpposite(w, h) {
        return [0, h];
      };
      break;
    case "middleRight":
      isHorizontal = true;
      getPoint = function getPoint(w, h) {
        return [w, h / 2];
      };
      getOpposite = function getOpposite(w, h) {
        return [0, h / 2];
      };
      break;
    case "bottomRight":
      isDiagonal = true;
      getPoint = function getPoint(w, h) {
        return [w, h];
      };
      getOpposite = function getOpposite(w, h) {
        return [0, 0];
      };
      break;
    case "bottomMiddle":
      getPoint = function getPoint(w, h) {
        return [w / 2, h];
      };
      getOpposite = function getOpposite(w, h) {
        return [w / 2, 0];
      };
      break;
    case "bottomLeft":
      isDiagonal = true;
      getPoint = function getPoint(w, h) {
        return [0, h];
      };
      getOpposite = function getOpposite(w, h) {
        return [w, 0];
      };
      break;
    case "middleLeft":
      isHorizontal = true;
      getPoint = function getPoint(w, h) {
        return [0, h / 2];
      };
      getOpposite = function getOpposite(w, h) {
        return [w, h / 2];
      };
      break;
  }
  var point = getPoint(savedWidth, savedHeight);
  var oppositePoint = getOpposite(savedWidth, savedHeight);
  var transfOppositePoint = transf.apply(void 0, _toConsumableArray(oppositePoint));
  var oppositeX = round(savedX + transfOppositePoint[0]);
  var oppositeY = round(savedY + transfOppositePoint[1]);
  var ratioX = 1;
  var ratioY = 1;
  var _this$screenToPageTra5 = this.screenToPageTranslation(event.movementX, event.movementY),
    _this$screenToPageTra6 = _slicedToArray(_this$screenToPageTra5, 2),
    deltaX = _this$screenToPageTra6[0],
    deltaY = _this$screenToPageTra6[1];
  var _invTransf = invTransf(deltaX / parentWidth, deltaY / parentHeight);
  var _invTransf2 = _slicedToArray(_invTransf, 2);
  deltaX = _invTransf2[0];
  deltaY = _invTransf2[1];
  if (isDiagonal) {
    var oldDiag = Math.hypot(savedWidth, savedHeight);
    ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
  } else if (isHorizontal) {
    ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
  } else {
    ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
  }
  var newWidth = round(savedWidth * ratioX);
  var newHeight = round(savedHeight * ratioY);
  transfOppositePoint = transf.apply(void 0, _toConsumableArray(getOpposite(newWidth, newHeight)));
  var newX = oppositeX - transfOppositePoint[0];
  var newY = oppositeY - transfOppositePoint[1];
  this.width = newWidth;
  this.height = newHeight;
  this.x = newX;
  this.y = newY;
  this.setDims(parentWidth * newWidth, parentHeight * newHeight);
  this.fixAndSetPosition();
}
function _selectOnPointerEvent2(event) {
  var isMac = util_FeatureTest.platform.isMac;
  if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) {
    this.parent.toggleSelected(this);
  } else {
    this.parent.setSelected(this);
  }
}
function _setUpDragSession2(event) {
  var _this93 = this;
  var isSelected = this.isSelected;
  this._uiManager.setUpDragSession();
  var ac = new AbortController();
  var signal = this._uiManager.combinedSignal(ac);
  if (isSelected) {
    this.div.classList.add("moving");
    _classPrivateFieldLooseBase(this, _prevDragX)[_prevDragX] = event.clientX;
    _classPrivateFieldLooseBase(this, _prevDragY)[_prevDragY] = event.clientY;
    var pointerMoveCallback = function pointerMoveCallback(e) {
      var x = e.clientX,
        y = e.clientY;
      var _this93$screenToPageT = _this93.screenToPageTranslation(x - _classPrivateFieldLooseBase(_this93, _prevDragX)[_prevDragX], y - _classPrivateFieldLooseBase(_this93, _prevDragY)[_prevDragY]),
        _this93$screenToPageT2 = _slicedToArray(_this93$screenToPageT, 2),
        tx = _this93$screenToPageT2[0],
        ty = _this93$screenToPageT2[1];
      _classPrivateFieldLooseBase(_this93, _prevDragX)[_prevDragX] = x;
      _classPrivateFieldLooseBase(_this93, _prevDragY)[_prevDragY] = y;
      _this93._uiManager.dragSelectedEditors(tx, ty);
    };
    window.addEventListener("pointermove", pointerMoveCallback, {
      passive: true,
      capture: true,
      signal: signal
    });
  }
  var pointerUpCallback = function pointerUpCallback() {
    ac.abort();
    if (isSelected) {
      _this93.div.classList.remove("moving");
    }
    _classPrivateFieldLooseBase(_this93, _hasBeenClicked)[_hasBeenClicked] = false;
    if (!_this93._uiManager.endDragSession()) {
      _classPrivateFieldLooseBase(_this93, _selectOnPointerEvent)[_selectOnPointerEvent](event);
    }
  };
  window.addEventListener("pointerup", pointerUpCallback, {
    signal: signal
  });
  window.addEventListener("blur", pointerUpCallback, {
    signal: signal
  });
}
function _addFocusListeners2() {
  if (_classPrivateFieldLooseBase(this, _focusAC)[_focusAC] || !this.div) {
    return;
  }
  _classPrivateFieldLooseBase(this, _focusAC)[_focusAC] = new AbortController();
  var signal = this._uiManager.combinedSignal(_classPrivateFieldLooseBase(this, _focusAC)[_focusAC]);
  this.div.addEventListener("focusin", this.focusin.bind(this), {
    signal: signal
  });
  this.div.addEventListener("focusout", this.focusout.bind(this), {
    signal: signal
  });
}
function _resizerKeydown2(event) {
  _AnnotationEditor._resizerKeyboardManager.exec(this, event);
}
function _resizerBlur2(event) {
  var _event$relatedTarget;
  if (_classPrivateFieldLooseBase(this, _isResizerEnabledForKeyboard)[_isResizerEnabledForKeyboard] && ((_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.parentNode) !== _classPrivateFieldLooseBase(this, _resizersDiv)[_resizersDiv]) {
    _classPrivateFieldLooseBase(this, _stopResizing)[_stopResizing]();
  }
}
function _resizerFocus2(name) {
  _classPrivateFieldLooseBase(this, _focusedResizerName)[_focusedResizerName] = _classPrivateFieldLooseBase(this, _isResizerEnabledForKeyboard)[_isResizerEnabledForKeyboard] ? name : "";
}
function _setResizerTabIndex2(value) {
  if (!_classPrivateFieldLooseBase(this, _allResizerDivs)[_allResizerDivs]) {
    return;
  }
  var _iterator167 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _allResizerDivs)[_allResizerDivs]),
    _step167;
  try {
    for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
      var div = _step167.value;
      div.tabIndex = value;
    }
  } catch (err) {
    _iterator167.e(err);
  } finally {
    _iterator167.f();
  }
}
function _stopResizing2() {
  _classPrivateFieldLooseBase(this, _isResizerEnabledForKeyboard)[_isResizerEnabledForKeyboard] = false;
  _classPrivateFieldLooseBase(this, _setResizerTabIndex)[_setResizerTabIndex](-1);
  if (_classPrivateFieldLooseBase(this, _savedDimensions)[_savedDimensions]) {
    var _classPrivateFieldLoo136 = _classPrivateFieldLooseBase(this, _savedDimensions)[_savedDimensions],
      savedX = _classPrivateFieldLoo136.savedX,
      savedY = _classPrivateFieldLoo136.savedY,
      savedWidth = _classPrivateFieldLoo136.savedWidth,
      savedHeight = _classPrivateFieldLoo136.savedHeight;
    _classPrivateFieldLooseBase(this, _addResizeToUndoStack)[_addResizeToUndoStack](savedX, savedY, savedWidth, savedHeight);
    _classPrivateFieldLooseBase(this, _savedDimensions)[_savedDimensions] = null;
  }
}
Object.defineProperty(AnnotationEditor, _rotatePoint, {
  value: _rotatePoint2
});
AnnotationEditor._l10n = null;
AnnotationEditor._l10nResizer = null;
AnnotationEditor._borderLineWidth = -1;
AnnotationEditor._colorManager = new ColorManager();
AnnotationEditor._zIndex = 1;
AnnotationEditor._telemetryTimeout = 1000;
var FakeEditor = /*#__PURE__*/function (_AnnotationEditor2) {
  function FakeEditor(params) {
    var _this16;
    _classCallCheck(this, FakeEditor);
    _this16 = _callSuper(this, FakeEditor, [params]);
    _this16.annotationElementId = params.annotationElementId;
    _this16.deleted = true;
    return _this16;
  }
  _inherits(FakeEditor, _AnnotationEditor2);
  return _createClass(FakeEditor, [{
    key: "serialize",
    value: function serialize() {
      return this.serializeDeleted();
    }
  }]);
}(AnnotationEditor);
; // ./src/shared/murmurhash3.js
var SEED = 0xc3d2e1f0;
var MASK_HIGH = 0xffff0000;
var MASK_LOW = 0xffff;
var MurmurHash3_64 = /*#__PURE__*/function () {
  function MurmurHash3_64(seed) {
    _classCallCheck(this, MurmurHash3_64);
    this.h1 = seed ? seed & 0xffffffff : SEED;
    this.h2 = seed ? seed & 0xffffffff : SEED;
  }
  return _createClass(MurmurHash3_64, [{
    key: "update",
    value: function update(input) {
      var data, length;
      if (typeof input === "string") {
        data = new Uint8Array(input.length * 2);
        length = 0;
        for (var i = 0, ii = input.length; i < ii; i++) {
          var code = input.charCodeAt(i);
          if (code <= 0xff) {
            data[length++] = code;
          } else {
            data[length++] = code >>> 8;
            data[length++] = code & 0xff;
          }
        }
      } else if (ArrayBuffer.isView(input)) {
        data = input.slice();
        length = data.byteLength;
      } else {
        throw new Error("Invalid data format, must be a string or TypedArray.");
      }
      var blockCounts = length >> 2;
      var tailLength = length - blockCounts * 4;
      var dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
      var k1 = 0,
        k2 = 0;
      var h1 = this.h1,
        h2 = this.h2;
      var C1 = 0xcc9e2d51,
        C2 = 0x1b873593;
      var C1_LOW = C1 & MASK_LOW,
        C2_LOW = C2 & MASK_LOW;
      for (var _i6 = 0; _i6 < blockCounts; _i6++) {
        if (_i6 & 1) {
          k1 = dataUint32[_i6];
          k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
          k1 = k1 << 15 | k1 >>> 17;
          k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
          h1 ^= k1;
          h1 = h1 << 13 | h1 >>> 19;
          h1 = h1 * 5 + 0xe6546b64;
        } else {
          k2 = dataUint32[_i6];
          k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
          k2 = k2 << 15 | k2 >>> 17;
          k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
          h2 ^= k2;
          h2 = h2 << 13 | h2 >>> 19;
          h2 = h2 * 5 + 0xe6546b64;
        }
      }
      k1 = 0;
      switch (tailLength) {
        case 3:
          k1 ^= data[blockCounts * 4 + 2] << 16;
        case 2:
          k1 ^= data[blockCounts * 4 + 1] << 8;
        case 1:
          k1 ^= data[blockCounts * 4];
          k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
          k1 = k1 << 15 | k1 >>> 17;
          k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
          if (blockCounts & 1) {
            h1 ^= k1;
          } else {
            h2 ^= k1;
          }
      }
      this.h1 = h1;
      this.h2 = h2;
    }
  }, {
    key: "hexdigest",
    value: function hexdigest() {
      var h1 = this.h1,
        h2 = this.h2;
      h1 ^= h2 >>> 1;
      h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
      h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
      h1 ^= h2 >>> 1;
      h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
      h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
      h1 ^= h2 >>> 1;
      return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
    }
  }]);
}();
; // ./src/display/annotation_storage.js

var SerializableEmpty = Object.freeze({
  map: null,
  hash: "",
  transfer: undefined
});
var _modified = /*#__PURE__*/_classPrivateFieldLooseKey("modified");
var _modifiedIds = /*#__PURE__*/_classPrivateFieldLooseKey("modifiedIds");
var _storage = /*#__PURE__*/_classPrivateFieldLooseKey("storage");
var _setModified = /*#__PURE__*/_classPrivateFieldLooseKey("setModified");
var AnnotationStorage = /*#__PURE__*/function () {
  function AnnotationStorage() {
    _classCallCheck(this, AnnotationStorage);
    Object.defineProperty(this, _setModified, {
      value: _setModified2
    });
    Object.defineProperty(this, _modified, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _modifiedIds, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _storage, {
      writable: true,
      value: new Map()
    });
    this.onSetModified = null;
    this.onResetModified = null;
    this.onAnnotationEditor = null;
  }
  return _createClass(AnnotationStorage, [{
    key: "getValue",
    value: function getValue(key, defaultValue) {
      var value = _classPrivateFieldLooseBase(this, _storage)[_storage].get(key);
      if (value === undefined) {
        return defaultValue;
      }
      return Object.assign(defaultValue, value);
    }
  }, {
    key: "getRawValue",
    value: function getRawValue(key) {
      return _classPrivateFieldLooseBase(this, _storage)[_storage].get(key);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      _classPrivateFieldLooseBase(this, _storage)[_storage].delete(key);
      if (_classPrivateFieldLooseBase(this, _storage)[_storage].size === 0) {
        this.resetModified();
      }
      if (typeof this.onAnnotationEditor === "function") {
        var _iterator47 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _storage)[_storage].values()),
          _step47;
        try {
          for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
            var value = _step47.value;
            if (value instanceof AnnotationEditor) {
              return;
            }
          }
        } catch (err) {
          _iterator47.e(err);
        } finally {
          _iterator47.f();
        }
        this.onAnnotationEditor(null);
      }
    }
  }, {
    key: "setValue",
    value: function setValue(key, value) {
      var obj = _classPrivateFieldLooseBase(this, _storage)[_storage].get(key);
      var modified = false;
      if (obj !== undefined) {
        for (var _i7 = 0, _Object$entries = Object.entries(value); _i7 < _Object$entries.length; _i7++) {
          var _ref33 = _Object$entries[_i7];
          var _ref34 = _slicedToArray(_ref33, 2);
          var entry = _ref34[0];
          var val = _ref34[1];
          if (obj[entry] !== val) {
            modified = true;
            obj[entry] = val;
          }
        }
      } else {
        modified = true;
        _classPrivateFieldLooseBase(this, _storage)[_storage].set(key, value);
      }
      if (modified) {
        _classPrivateFieldLooseBase(this, _setModified)[_setModified]();
      }
      if (value instanceof AnnotationEditor && typeof this.onAnnotationEditor === "function") {
        this.onAnnotationEditor(value.constructor._type);
      }
    }
  }, {
    key: "has",
    value: function has(key) {
      return _classPrivateFieldLooseBase(this, _storage)[_storage].has(key);
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return _classPrivateFieldLooseBase(this, _storage)[_storage].size > 0 ? objectFromMap(_classPrivateFieldLooseBase(this, _storage)[_storage]) : null;
    }
  }, {
    key: "setAll",
    value: function setAll(obj) {
      for (var _i8 = 0, _Object$entries2 = Object.entries(obj); _i8 < _Object$entries2.length; _i8++) {
        var _ref35 = _Object$entries2[_i8];
        var _ref36 = _slicedToArray(_ref35, 2);
        var key = _ref36[0];
        var val = _ref36[1];
        this.setValue(key, val);
      }
    }
  }, {
    key: "size",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _storage)[_storage].size;
    }
  }, {
    key: "resetModified",
    value: function resetModified() {
      if (_classPrivateFieldLooseBase(this, _modified)[_modified]) {
        _classPrivateFieldLooseBase(this, _modified)[_modified] = false;
        if (typeof this.onResetModified === "function") {
          this.onResetModified();
        }
      }
    }
  }, {
    key: "print",
    get: function get() {
      return new PrintAnnotationStorage(this);
    }
  }, {
    key: "serializable",
    get: function get() {
      if (_classPrivateFieldLooseBase(this, _storage)[_storage].size === 0) {
        return SerializableEmpty;
      }
      var map = new Map(),
        hash = new MurmurHash3_64(),
        transfer = [];
      var context = Object.create(null);
      var hasBitmap = false;
      var _iterator48 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _storage)[_storage]),
        _step48;
      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var _ref37 = _step48.value;
          var _ref38 = _slicedToArray(_ref37, 2);
          var key = _ref38[0];
          var val = _ref38[1];
          var serialized = val instanceof AnnotationEditor ? val.serialize(false, context) : val;
          if (serialized) {
            map.set(key, serialized);
            hash.update("".concat(key, ":").concat(JSON.stringify(serialized)));
            hasBitmap || (hasBitmap = !!serialized.bitmap);
          }
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }
      if (hasBitmap) {
        var _iterator49 = _createForOfIteratorHelper(map.values()),
          _step49;
        try {
          for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
            var value = _step49.value;
            if (value.bitmap) {
              transfer.push(value.bitmap);
            }
          }
        } catch (err) {
          _iterator49.e(err);
        } finally {
          _iterator49.f();
        }
      }
      return map.size > 0 ? {
        map: map,
        hash: hash.hexdigest(),
        transfer: transfer
      } : SerializableEmpty;
    }
  }, {
    key: "editorStats",
    get: function get() {
      var stats = null;
      var typeToEditor = new Map();
      var _iterator50 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _storage)[_storage].values()),
        _step50;
      try {
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          var _stats;
          var value = _step50.value;
          if (!(value instanceof AnnotationEditor)) {
            continue;
          }
          var editorStats = value.telemetryFinalData;
          if (!editorStats) {
            continue;
          }
          var type = editorStats.type;
          if (!typeToEditor.has(type)) {
            typeToEditor.set(type, Object.getPrototypeOf(value).constructor);
          }
          stats || (stats = Object.create(null));
          var map = (_stats = stats)[type] || (_stats[type] = new Map());
          for (var _i9 = 0, _Object$entries3 = Object.entries(editorStats); _i9 < _Object$entries3.length; _i9++) {
            var _counters$get;
            var _ref41 = _Object$entries3[_i9];
            var _ref42 = _slicedToArray(_ref41, 2);
            var key = _ref42[0];
            var val = _ref42[1];
            if (key === "type") {
              continue;
            }
            var counters = map.get(key);
            if (!counters) {
              counters = new Map();
              map.set(key, counters);
            }
            var count = (_counters$get = counters.get(val)) !== null && _counters$get !== void 0 ? _counters$get : 0;
            counters.set(val, count + 1);
          }
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
      var _iterator51 = _createForOfIteratorHelper(typeToEditor),
        _step51;
      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var _ref39 = _step51.value;
          var _ref40 = _slicedToArray(_ref39, 2);
          var _type2 = _ref40[0];
          var editor = _ref40[1];
          stats[_type2] = editor.computeTelemetryFinalData(stats[_type2]);
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
      return stats;
    }
  }, {
    key: "resetModifiedIds",
    value: function resetModifiedIds() {
      _classPrivateFieldLooseBase(this, _modifiedIds)[_modifiedIds] = null;
    }
  }, {
    key: "modifiedIds",
    get: function get() {
      if (_classPrivateFieldLooseBase(this, _modifiedIds)[_modifiedIds]) {
        return _classPrivateFieldLooseBase(this, _modifiedIds)[_modifiedIds];
      }
      var ids = [];
      var _iterator52 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _storage)[_storage].values()),
        _step52;
      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var value = _step52.value;
          if (!(value instanceof AnnotationEditor) || !value.annotationElementId || !value.serialize()) {
            continue;
          }
          ids.push(value.annotationElementId);
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
      return _classPrivateFieldLooseBase(this, _modifiedIds)[_modifiedIds] = {
        ids: new Set(ids),
        hash: ids.join(",")
      };
    }
  }]);
}();
function _setModified2() {
  if (!_classPrivateFieldLooseBase(this, _modified)[_modified]) {
    _classPrivateFieldLooseBase(this, _modified)[_modified] = true;
    if (typeof this.onSetModified === "function") {
      this.onSetModified();
    }
  }
}
var _serializable = /*#__PURE__*/_classPrivateFieldLooseKey("serializable");
var PrintAnnotationStorage = /*#__PURE__*/function (_AnnotationStorage2) {
  function PrintAnnotationStorage(parent) {
    var _this17;
    _classCallCheck(this, PrintAnnotationStorage);
    _this17 = _callSuper(this, PrintAnnotationStorage);
    Object.defineProperty(_this17, _serializable, {
      writable: true,
      value: void 0
    });
    var _parent$serializable = parent.serializable,
      map = _parent$serializable.map,
      hash = _parent$serializable.hash,
      transfer = _parent$serializable.transfer;
    var clone = structuredClone(map, transfer ? {
      transfer: transfer
    } : null);
    _classPrivateFieldLooseBase(_this17, _serializable)[_serializable] = {
      map: clone,
      hash: hash,
      transfer: transfer
    };
    return _this17;
  }
  _inherits(PrintAnnotationStorage, _AnnotationStorage2);
  return _createClass(PrintAnnotationStorage, [{
    key: "print",
    get: function get() {
      unreachable("Should not call PrintAnnotationStorage.print");
    }
  }, {
    key: "serializable",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _serializable)[_serializable];
    }
  }, {
    key: "modifiedIds",
    get: function get() {
      return _shadow(this, "modifiedIds", {
        ids: new Set(),
        hash: ""
      });
    }
  }]);
}(AnnotationStorage);
; // ./src/display/font_loader.js
var _systemFonts = /*#__PURE__*/_classPrivateFieldLooseKey("systemFonts");
var FontLoader = /*#__PURE__*/function () {
  function FontLoader(_ref43) {
    var _ref43$ownerDocument = _ref43.ownerDocument,
      ownerDocument = _ref43$ownerDocument === void 0 ? globalThis.document : _ref43$ownerDocument,
      _ref43$styleElement = _ref43.styleElement,
      styleElement = _ref43$styleElement === void 0 ? null : _ref43$styleElement;
    _classCallCheck(this, FontLoader);
    Object.defineProperty(this, _systemFonts, {
      writable: true,
      value: new Set()
    });
    this._document = ownerDocument;
    this.nativeFontFaces = new Set();
    this.styleElement = null;
    this.loadingRequests = [];
    this.loadTestFontId = 0;
  }
  return _createClass(FontLoader, [{
    key: "addNativeFontFace",
    value: function addNativeFontFace(nativeFontFace) {
      this.nativeFontFaces.add(nativeFontFace);
      this._document.fonts.add(nativeFontFace);
    }
  }, {
    key: "removeNativeFontFace",
    value: function removeNativeFontFace(nativeFontFace) {
      this.nativeFontFaces.delete(nativeFontFace);
      this._document.fonts.delete(nativeFontFace);
    }
  }, {
    key: "insertRule",
    value: function insertRule(rule) {
      if (!this.styleElement) {
        this.styleElement = this._document.createElement("style");
        this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
      }
      var styleSheet = this.styleElement.sheet;
      styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
  }, {
    key: "clear",
    value: function clear() {
      var _iterator53 = _createForOfIteratorHelper(this.nativeFontFaces),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var nativeFontFace = _step53.value;
          this._document.fonts.delete(nativeFontFace);
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
      this.nativeFontFaces.clear();
      _classPrivateFieldLooseBase(this, _systemFonts)[_systemFonts].clear();
      if (this.styleElement) {
        this.styleElement.remove();
        this.styleElement = null;
      }
    }
  }, {
    key: "loadSystemFont",
    value: function () {
      var _loadSystemFont = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref44) {
        var info, _inspectFont, loadedName, src, style, fontFace;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              info = _ref44.systemFontInfo, _inspectFont = _ref44._inspectFont;
              if (!(!info || _classPrivateFieldLooseBase(this, _systemFonts)[_systemFonts].has(info.loadedName))) {
                _context14.next = 3;
                break;
              }
              return _context14.abrupt("return");
            case 3:
              assert(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
              if (!this.isFontLoadingAPISupported) {
                _context14.next = 20;
                break;
              }
              loadedName = info.loadedName, src = info.src, style = info.style;
              fontFace = new FontFace(loadedName, src, style);
              this.addNativeFontFace(fontFace);
              _context14.prev = 8;
              _context14.next = 11;
              return fontFace.load();
            case 11:
              _classPrivateFieldLooseBase(this, _systemFonts)[_systemFonts].add(loadedName);
              _inspectFont === null || _inspectFont === void 0 || _inspectFont(info);
              _context14.next = 19;
              break;
            case 15:
              _context14.prev = 15;
              _context14.t0 = _context14["catch"](8);
              warn("Cannot load system font: ".concat(info.baseFontName, ", installing it could help to improve PDF rendering."));
              this.removeNativeFontFace(fontFace);
            case 19:
              return _context14.abrupt("return");
            case 20:
              unreachable("Not implemented: loadSystemFont without the Font Loading API.");
            case 21:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this, [[8, 15]]);
      }));
      function loadSystemFont(_x16) {
        return _loadSystemFont.apply(this, arguments);
      }
      return loadSystemFont;
    }()
  }, {
    key: "bind",
    value: function () {
      var _bind = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(font) {
        var _this18 = this;
        var nativeFontFace, rule;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!(font.attached || font.missingFile && !font.systemFontInfo)) {
                _context15.next = 2;
                break;
              }
              return _context15.abrupt("return");
            case 2:
              font.attached = true;
              if (!font.systemFontInfo) {
                _context15.next = 7;
                break;
              }
              _context15.next = 6;
              return this.loadSystemFont(font);
            case 6:
              return _context15.abrupt("return");
            case 7:
              if (!this.isFontLoadingAPISupported) {
                _context15.next = 22;
                break;
              }
              nativeFontFace = font.createNativeFontFace();
              if (!nativeFontFace) {
                _context15.next = 21;
                break;
              }
              this.addNativeFontFace(nativeFontFace);
              _context15.prev = 11;
              _context15.next = 14;
              return nativeFontFace.loaded;
            case 14:
              _context15.next = 21;
              break;
            case 16:
              _context15.prev = 16;
              _context15.t0 = _context15["catch"](11);
              warn("Failed to load font '".concat(nativeFontFace.family, "': '").concat(_context15.t0, "'."));
              font.disableFontFace = true;
              throw _context15.t0;
            case 21:
              return _context15.abrupt("return");
            case 22:
              rule = font.createFontFaceRule();
              if (!rule) {
                _context15.next = 29;
                break;
              }
              this.insertRule(rule);
              if (!this.isSyncFontLoadingSupported) {
                _context15.next = 27;
                break;
              }
              return _context15.abrupt("return");
            case 27:
              _context15.next = 29;
              return new Promise(function (resolve) {
                var request = _this18._queueLoadingCallback(resolve);
                _this18._prepareFontLoadEvent(font, request);
              });
            case 29:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this, [[11, 16]]);
      }));
      function bind(_x17) {
        return _bind.apply(this, arguments);
      }
      return bind;
    }()
  }, {
    key: "isFontLoadingAPISupported",
    get: function get() {
      var _this$_document;
      var hasFonts = !!((_this$_document = this._document) !== null && _this$_document !== void 0 && _this$_document.fonts);
      return _shadow(this, "isFontLoadingAPISupported", hasFonts);
    }
  }, {
    key: "isSyncFontLoadingSupported",
    get: function get() {
      var _navigator3;
      var supported = false;
      if (isNodeJS) {
        supported = true;
      } else if (typeof navigator !== "undefined" && typeof ((_navigator3 = navigator) === null || _navigator3 === void 0 ? void 0 : _navigator3.userAgent) === "string" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) {
        supported = true;
      }
      return _shadow(this, "isSyncFontLoadingSupported", supported);
    }
  }, {
    key: "_queueLoadingCallback",
    value: function _queueLoadingCallback(callback) {
      function completeRequest() {
        assert(!request.done, "completeRequest() cannot be called twice.");
        request.done = true;
        while (loadingRequests.length > 0 && loadingRequests[0].done) {
          var otherRequest = loadingRequests.shift();
          setTimeout(otherRequest.callback, 0);
        }
      }
      var loadingRequests = this.loadingRequests;
      var request = {
        done: false,
        complete: completeRequest,
        callback: callback
      };
      loadingRequests.push(request);
      return request;
    }
  }, {
    key: "_loadTestFont",
    get: function get() {
      var testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQA" + "FQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAA" + "ALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgA" + "AAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1" + "AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD" + "6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACM" + "AooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4D" + "IP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAA" + "AAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUA" + "AQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgAB" + "AAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABY" + "AAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAA" + "AC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAA" + "AAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQAC" + "AQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3" + "Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTj" + "FQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
      return _shadow(this, "_loadTestFont", testFont);
    }
  }, {
    key: "_prepareFontLoadEvent",
    value: function _prepareFontLoadEvent(font, request) {
      function int32(data, offset) {
        return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
      }
      function spliceString(s, offset, remove, insert) {
        var chunk1 = s.substring(0, offset);
        var chunk2 = s.substring(offset + remove);
        return chunk1 + insert + chunk2;
      }
      var i, ii;
      var canvas = this._document.createElement("canvas");
      canvas.width = 1;
      canvas.height = 1;
      var ctx = canvas.getContext("2d");
      var called = 0;
      function isFontReady(name, callback) {
        if (++called > 30) {
          warn("Load test font never loaded.");
          callback();
          return;
        }
        ctx.font = "30px " + name;
        ctx.fillText(".", 0, 20);
        var imageData = ctx.getImageData(0, 0, 1, 1);
        if (imageData.data[3] > 0) {
          callback();
          return;
        }
        setTimeout(isFontReady.bind(null, name, callback));
      }
      var loadTestFontId = "lt".concat(Date.now()).concat(this.loadTestFontId++);
      var data = this._loadTestFont;
      var COMMENT_OFFSET = 976;
      data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
      var CFF_CHECKSUM_OFFSET = 16;
      var XXXX_VALUE = 0x58585858;
      var checksum = int32(data, CFF_CHECKSUM_OFFSET);
      for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
        checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
      }
      if (i < loadTestFontId.length) {
        checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
      }
      data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, string32(checksum));
      var url = "url(data:font/opentype;base64,".concat(btoa(data), ");");
      var rule = "@font-face {font-family:\"".concat(loadTestFontId, "\";src:").concat(url, "}");
      this.insertRule(rule);
      var div = this._document.createElement("div");
      div.style.visibility = "hidden";
      div.style.width = div.style.height = "10px";
      div.style.position = "absolute";
      div.style.top = div.style.left = "0px";
      for (var _i10 = 0, _arr = [font.loadedName, loadTestFontId]; _i10 < _arr.length; _i10++) {
        var name = _arr[_i10];
        var span = this._document.createElement("span");
        span.textContent = "Hi";
        span.style.fontFamily = name;
        div.append(span);
      }
      this._document.body.append(div);
      isFontReady(loadTestFontId, function () {
        div.remove();
        request.complete();
      });
    }
  }]);
}();
var FontFaceObject = /*#__PURE__*/function () {
  function FontFaceObject(translatedData, _ref45) {
    var _ref45$disableFontFac = _ref45.disableFontFace,
      disableFontFace = _ref45$disableFontFac === void 0 ? false : _ref45$disableFontFac,
      _ref45$inspectFont = _ref45.inspectFont,
      inspectFont = _ref45$inspectFont === void 0 ? null : _ref45$inspectFont;
    _classCallCheck(this, FontFaceObject);
    this.compiledGlyphs = Object.create(null);
    for (var i in translatedData) {
      this[i] = translatedData[i];
    }
    this.disableFontFace = disableFontFace === true;
    this._inspectFont = inspectFont;
  }
  return _createClass(FontFaceObject, [{
    key: "createNativeFontFace",
    value: function createNativeFontFace() {
      var _this$_inspectFont;
      if (!this.data || this.disableFontFace) {
        return null;
      }
      var nativeFontFace;
      if (!this.cssFontInfo) {
        nativeFontFace = new FontFace(this.loadedName, this.data, {});
      } else {
        var css = {
          weight: this.cssFontInfo.fontWeight
        };
        if (this.cssFontInfo.italicAngle) {
          css.style = "oblique ".concat(this.cssFontInfo.italicAngle, "deg");
        }
        nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
      }
      (_this$_inspectFont = this._inspectFont) === null || _this$_inspectFont === void 0 || _this$_inspectFont.call(this, this);
      return nativeFontFace;
    }
  }, {
    key: "createFontFaceRule",
    value: function createFontFaceRule() {
      var _this$_inspectFont2;
      if (!this.data || this.disableFontFace) {
        return null;
      }
      var url = "url(data:".concat(this.mimetype, ";base64,").concat(toBase64Util(this.data), ");");
      var rule;
      if (!this.cssFontInfo) {
        rule = "@font-face {font-family:\"".concat(this.loadedName, "\";src:").concat(url, "}");
      } else {
        var css = "font-weight: ".concat(this.cssFontInfo.fontWeight, ";");
        if (this.cssFontInfo.italicAngle) {
          css += "font-style: oblique ".concat(this.cssFontInfo.italicAngle, "deg;");
        }
        rule = "@font-face {font-family:\"".concat(this.cssFontInfo.fontFamily, "\";").concat(css, "src:").concat(url, "}");
      }
      (_this$_inspectFont2 = this._inspectFont) === null || _this$_inspectFont2 === void 0 || _this$_inspectFont2.call(this, this, url);
      return rule;
    }
  }, {
    key: "getPathGenerator",
    value: function getPathGenerator(objs, character) {
      if (this.compiledGlyphs[character] !== undefined) {
        return this.compiledGlyphs[character];
      }
      var cmds;
      try {
        cmds = objs.get(this.loadedName + "_path_" + character);
      } catch (ex) {
        warn("getPathGenerator - ignoring character: \"".concat(ex, "\"."));
      }
      if (!Array.isArray(cmds) || cmds.length === 0) {
        return this.compiledGlyphs[character] = function (c, size) {};
      }
      var commands = [];
      var _loop = function _loop(_i11) {
        switch (cmds[_i11++]) {
          case FontRenderOps.BEZIER_CURVE_TO:
            {
              var _cmds$slice = cmds.slice(_i11, _i11 + 6),
                _cmds$slice2 = _slicedToArray(_cmds$slice, 6),
                a = _cmds$slice2[0],
                b = _cmds$slice2[1],
                c = _cmds$slice2[2],
                d = _cmds$slice2[3],
                e = _cmds$slice2[4],
                f = _cmds$slice2[5];
              commands.push(function (ctx) {
                return ctx.bezierCurveTo(a, b, c, d, e, f);
              });
              _i11 += 6;
            }
            break;
          case FontRenderOps.MOVE_TO:
            {
              var _cmds$slice3 = cmds.slice(_i11, _i11 + 2),
                _cmds$slice4 = _slicedToArray(_cmds$slice3, 2),
                _a = _cmds$slice4[0],
                _b = _cmds$slice4[1];
              commands.push(function (ctx) {
                return ctx.moveTo(_a, _b);
              });
              _i11 += 2;
            }
            break;
          case FontRenderOps.LINE_TO:
            {
              var _cmds$slice5 = cmds.slice(_i11, _i11 + 2),
                _cmds$slice6 = _slicedToArray(_cmds$slice5, 2),
                _a2 = _cmds$slice6[0],
                _b2 = _cmds$slice6[1];
              commands.push(function (ctx) {
                return ctx.lineTo(_a2, _b2);
              });
              _i11 += 2;
            }
            break;
          case FontRenderOps.QUADRATIC_CURVE_TO:
            {
              var _cmds$slice7 = cmds.slice(_i11, _i11 + 4),
                _cmds$slice8 = _slicedToArray(_cmds$slice7, 4),
                _a3 = _cmds$slice8[0],
                _b3 = _cmds$slice8[1],
                _c = _cmds$slice8[2],
                _d = _cmds$slice8[3];
              commands.push(function (ctx) {
                return ctx.quadraticCurveTo(_a3, _b3, _c, _d);
              });
              _i11 += 4;
            }
            break;
          case FontRenderOps.RESTORE:
            commands.push(function (ctx) {
              return ctx.restore();
            });
            break;
          case FontRenderOps.SAVE:
            commands.push(function (ctx) {
              return ctx.save();
            });
            break;
          case FontRenderOps.SCALE:
            assert(commands.length === 2, "Scale command is only valid at the third position.");
            break;
          case FontRenderOps.TRANSFORM:
            {
              var _cmds$slice9 = cmds.slice(_i11, _i11 + 6),
                _cmds$slice10 = _slicedToArray(_cmds$slice9, 6),
                _a4 = _cmds$slice10[0],
                _b4 = _cmds$slice10[1],
                _c2 = _cmds$slice10[2],
                _d2 = _cmds$slice10[3],
                _e = _cmds$slice10[4],
                _f = _cmds$slice10[5];
              commands.push(function (ctx) {
                return ctx.transform(_a4, _b4, _c2, _d2, _e, _f);
              });
              _i11 += 6;
            }
            break;
          case FontRenderOps.TRANSLATE:
            {
              var _cmds$slice11 = cmds.slice(_i11, _i11 + 2),
                _cmds$slice12 = _slicedToArray(_cmds$slice11, 2),
                _a5 = _cmds$slice12[0],
                _b5 = _cmds$slice12[1];
              commands.push(function (ctx) {
                return ctx.translate(_a5, _b5);
              });
              _i11 += 2;
            }
            break;
        }
        i = _i11;
      };
      for (var i = 0, ii = cmds.length; i < ii;) {
        _loop(i);
      }
      return this.compiledGlyphs[character] = function glyphDrawer(ctx, size) {
        commands[0](ctx);
        commands[1](ctx);
        ctx.scale(size, -size);
        for (var _i12 = 2, _ii2 = commands.length; _i12 < _ii2; _i12++) {
          commands[_i12](ctx);
        }
      };
    }
  }]);
}();
; // ./src/display/canvas_factory.js
var _enableHWA = /*#__PURE__*/_classPrivateFieldLooseKey("enableHWA");
var BaseCanvasFactory = /*#__PURE__*/function () {
  function BaseCanvasFactory(_ref46) {
    var _ref46$enableHWA = _ref46.enableHWA,
      enableHWA = _ref46$enableHWA === void 0 ? false : _ref46$enableHWA;
    _classCallCheck(this, BaseCanvasFactory);
    Object.defineProperty(this, _enableHWA, {
      writable: true,
      value: false
    });
    _classPrivateFieldLooseBase(this, _enableHWA)[_enableHWA] = enableHWA;
  }
  return _createClass(BaseCanvasFactory, [{
    key: "create",
    value: function create(width, height) {
      if (width <= 0 || height <= 0) {
        throw new Error("Invalid canvas size");
      }
      var canvas = this._createCanvas(width, height);
      return {
        canvas: canvas,
        context: canvas.getContext("2d", {
          willReadFrequently: !_classPrivateFieldLooseBase(this, _enableHWA)[_enableHWA]
        })
      };
    }
  }, {
    key: "reset",
    value: function reset(canvasAndContext, width, height) {
      if (!canvasAndContext.canvas) {
        throw new Error("Canvas is not specified");
      }
      if (width <= 0 || height <= 0) {
        throw new Error("Invalid canvas size");
      }
      canvasAndContext.canvas.width = width;
      canvasAndContext.canvas.height = height;
    }
  }, {
    key: "destroy",
    value: function destroy(canvasAndContext) {
      if (!canvasAndContext.canvas) {
        throw new Error("Canvas is not specified");
      }
      canvasAndContext.canvas.width = 0;
      canvasAndContext.canvas.height = 0;
      canvasAndContext.canvas = null;
      canvasAndContext.context = null;
    }
  }, {
    key: "_createCanvas",
    value: function _createCanvas(width, height) {
      unreachable("Abstract method `_createCanvas` called.");
    }
  }]);
}();
var DOMCanvasFactory = /*#__PURE__*/function (_BaseCanvasFactory2) {
  function DOMCanvasFactory(_ref47) {
    var _this19;
    var _ref47$ownerDocument = _ref47.ownerDocument,
      ownerDocument = _ref47$ownerDocument === void 0 ? globalThis.document : _ref47$ownerDocument,
      _ref47$enableHWA = _ref47.enableHWA,
      enableHWA = _ref47$enableHWA === void 0 ? false : _ref47$enableHWA;
    _classCallCheck(this, DOMCanvasFactory);
    _this19 = _callSuper(this, DOMCanvasFactory, [{
      enableHWA: enableHWA
    }]);
    _this19._document = ownerDocument;
    return _this19;
  }
  _inherits(DOMCanvasFactory, _BaseCanvasFactory2);
  return _createClass(DOMCanvasFactory, [{
    key: "_createCanvas",
    value: function _createCanvas(width, height) {
      var canvas = this._document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      return canvas;
    }
  }]);
}(BaseCanvasFactory);
; // ./src/display/cmap_reader_factory.js
var BaseCMapReaderFactory = /*#__PURE__*/function () {
  function BaseCMapReaderFactory(_ref48) {
    var _ref48$baseUrl = _ref48.baseUrl,
      baseUrl = _ref48$baseUrl === void 0 ? null : _ref48$baseUrl,
      _ref48$isCompressed = _ref48.isCompressed,
      isCompressed = _ref48$isCompressed === void 0 ? true : _ref48$isCompressed;
    _classCallCheck(this, BaseCMapReaderFactory);
    this.baseUrl = baseUrl;
    this.isCompressed = isCompressed;
  }
  return _createClass(BaseCMapReaderFactory, [{
    key: "fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(_ref49) {
        var _this20 = this;
        var name, url;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              name = _ref49.name;
              if (this.baseUrl) {
                _context16.next = 3;
                break;
              }
              throw new Error("Ensure that the `cMapUrl` and `cMapPacked` API parameters are provided.");
            case 3:
              if (name) {
                _context16.next = 5;
                break;
              }
              throw new Error("CMap name must be specified.");
            case 5:
              url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
              return _context16.abrupt("return", this._fetch(url).then(function (cMapData) {
                return {
                  cMapData: cMapData,
                  isCompressed: _this20.isCompressed
                };
              }).catch(function (reason) {
                throw new Error("Unable to load ".concat(_this20.isCompressed ? "binary " : "", "CMap at: ").concat(url));
              }));
            case 7:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function fetch(_x18) {
        return _fetch2.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "_fetch",
    value: function () {
      var _fetch3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(url) {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              unreachable("Abstract method `_fetch` called.");
            case 1:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
      function _fetch(_x19) {
        return _fetch3.apply(this, arguments);
      }
      return _fetch;
    }()
  }]);
}();
var DOMCMapReaderFactory = /*#__PURE__*/function (_BaseCMapReaderFactor) {
  function DOMCMapReaderFactory() {
    _classCallCheck(this, DOMCMapReaderFactory);
    return _callSuper(this, DOMCMapReaderFactory, arguments);
  }
  _inherits(DOMCMapReaderFactory, _BaseCMapReaderFactor);
  return _createClass(DOMCMapReaderFactory, [{
    key: "_fetch",
    value: function () {
      var _fetch4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(url) {
        var data;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return _fetchData(url, this.isCompressed ? "arraybuffer" : "text");
            case 2:
              data = _context18.sent;
              return _context18.abrupt("return", data instanceof ArrayBuffer ? new Uint8Array(data) : stringToBytes(data));
            case 4:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function _fetch(_x20) {
        return _fetch4.apply(this, arguments);
      }
      return _fetch;
    }()
  }]);
}(BaseCMapReaderFactory);
; // ./src/display/filter_factory.js
var BaseFilterFactory = /*#__PURE__*/function () {
  function BaseFilterFactory() {
    _classCallCheck(this, BaseFilterFactory);
  }
  return _createClass(BaseFilterFactory, [{
    key: "addFilter",
    value: function addFilter(maps) {
      return "none";
    }
  }, {
    key: "addHCMFilter",
    value: function addHCMFilter(fgColor, bgColor) {
      return "none";
    }
  }, {
    key: "addAlphaFilter",
    value: function addAlphaFilter(map) {
      return "none";
    }
  }, {
    key: "addLuminosityFilter",
    value: function addLuminosityFilter(map) {
      return "none";
    }
  }, {
    key: "addHighlightHCMFilter",
    value: function addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
      return "none";
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var keepHCM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    }
  }]);
}();
var _baseUrl = /*#__PURE__*/_classPrivateFieldLooseKey("baseUrl");
var _cache2 = /*#__PURE__*/_classPrivateFieldLooseKey("_cache");
var _defs = /*#__PURE__*/_classPrivateFieldLooseKey("_defs");
var _docId = /*#__PURE__*/_classPrivateFieldLooseKey("docId");
var _document2 = /*#__PURE__*/_classPrivateFieldLooseKey("document");
var _hcmCache = /*#__PURE__*/_classPrivateFieldLooseKey("_hcmCache");
var _id3 = /*#__PURE__*/_classPrivateFieldLooseKey("id");
var _cache3 = /*#__PURE__*/_classPrivateFieldLooseKey("cache");
var _hcmCache2 = /*#__PURE__*/_classPrivateFieldLooseKey("hcmCache");
var _defs2 = /*#__PURE__*/_classPrivateFieldLooseKey("defs");
var _createTables = /*#__PURE__*/_classPrivateFieldLooseKey("createTables");
var _createUrl = /*#__PURE__*/_classPrivateFieldLooseKey("createUrl");
var _addLuminosityConversion = /*#__PURE__*/_classPrivateFieldLooseKey("addLuminosityConversion");
var _addGrayConversion = /*#__PURE__*/_classPrivateFieldLooseKey("addGrayConversion");
var _createFilter = /*#__PURE__*/_classPrivateFieldLooseKey("createFilter");
var _appendFeFunc = /*#__PURE__*/_classPrivateFieldLooseKey("appendFeFunc");
var _addTransferMapConversion = /*#__PURE__*/_classPrivateFieldLooseKey("addTransferMapConversion");
var _addTransferMapAlphaConversion = /*#__PURE__*/_classPrivateFieldLooseKey("addTransferMapAlphaConversion");
var _getRGB = /*#__PURE__*/_classPrivateFieldLooseKey("getRGB");
var DOMFilterFactory = /*#__PURE__*/function (_BaseFilterFactory) {
  function DOMFilterFactory(_ref50) {
    var _this21;
    var docId = _ref50.docId,
      _ref50$ownerDocument = _ref50.ownerDocument,
      ownerDocument = _ref50$ownerDocument === void 0 ? globalThis.document : _ref50$ownerDocument;
    _classCallCheck(this, DOMFilterFactory);
    _this21 = _callSuper(this, DOMFilterFactory);
    Object.defineProperty(_this21, _getRGB, {
      value: _getRGB2
    });
    Object.defineProperty(_this21, _addTransferMapAlphaConversion, {
      value: _addTransferMapAlphaConversion2
    });
    Object.defineProperty(_this21, _addTransferMapConversion, {
      value: _addTransferMapConversion2
    });
    Object.defineProperty(_this21, _appendFeFunc, {
      value: _appendFeFunc2
    });
    Object.defineProperty(_this21, _createFilter, {
      value: _createFilter2
    });
    Object.defineProperty(_this21, _addGrayConversion, {
      value: _addGrayConversion2
    });
    Object.defineProperty(_this21, _addLuminosityConversion, {
      value: _addLuminosityConversion2
    });
    Object.defineProperty(_this21, _createUrl, {
      value: _createUrl2
    });
    Object.defineProperty(_this21, _createTables, {
      value: _createTables2
    });
    Object.defineProperty(_this21, _defs2, {
      get: _get_defs,
      set: void 0
    });
    Object.defineProperty(_this21, _hcmCache2, {
      get: _get_hcmCache,
      set: void 0
    });
    Object.defineProperty(_this21, _cache3, {
      get: _get_cache,
      set: void 0
    });
    Object.defineProperty(_this21, _baseUrl, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this21, _cache2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this21, _defs, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this21, _docId, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this21, _document2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this21, _hcmCache, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this21, _id3, {
      writable: true,
      value: 0
    });
    _classPrivateFieldLooseBase(_this21, _docId)[_docId] = docId;
    _classPrivateFieldLooseBase(_this21, _document2)[_document2] = ownerDocument;
    return _this21;
  }
  _inherits(DOMFilterFactory, _BaseFilterFactory);
  return _createClass(DOMFilterFactory, [{
    key: "addFilter",
    value: function addFilter(maps) {
      if (!maps) {
        return "none";
      }
      var value = _classPrivateFieldLooseBase(this, _cache3)[_cache3].get(maps);
      if (value) {
        return value;
      }
      var _classPrivateFieldLoo51 = _classPrivateFieldLooseBase(this, _createTables)[_createTables](maps),
        _classPrivateFieldLoo52 = _slicedToArray(_classPrivateFieldLoo51, 3),
        tableR = _classPrivateFieldLoo52[0],
        tableG = _classPrivateFieldLoo52[1],
        tableB = _classPrivateFieldLoo52[2];
      var key = maps.length === 1 ? tableR : "".concat(tableR).concat(tableG).concat(tableB);
      value = _classPrivateFieldLooseBase(this, _cache3)[_cache3].get(key);
      if (value) {
        _classPrivateFieldLooseBase(this, _cache3)[_cache3].set(maps, value);
        return value;
      }
      var id = "g_".concat(_classPrivateFieldLooseBase(this, _docId)[_docId], "_transfer_map_").concat(_classPrivateFieldLooseBase(this, _id3)[_id3]++);
      var url = _classPrivateFieldLooseBase(this, _createUrl)[_createUrl](id);
      _classPrivateFieldLooseBase(this, _cache3)[_cache3].set(maps, url);
      _classPrivateFieldLooseBase(this, _cache3)[_cache3].set(key, url);
      var filter = _classPrivateFieldLooseBase(this, _createFilter)[_createFilter](id);
      _classPrivateFieldLooseBase(this, _addTransferMapConversion)[_addTransferMapConversion](tableR, tableG, tableB, filter);
      return url;
    }
  }, {
    key: "addHCMFilter",
    value: function addHCMFilter(fgColor, bgColor) {
      var _info;
      var key = "".concat(fgColor, "-").concat(bgColor);
      var filterName = "base";
      var info = _classPrivateFieldLooseBase(this, _hcmCache2)[_hcmCache2].get(filterName);
      if (((_info = info) === null || _info === void 0 ? void 0 : _info.key) === key) {
        return info.url;
      }
      if (info) {
        var _info$filter;
        (_info$filter = info.filter) === null || _info$filter === void 0 || _info$filter.remove();
        info.key = key;
        info.url = "none";
        info.filter = null;
      } else {
        info = {
          key: key,
          url: "none",
          filter: null
        };
        _classPrivateFieldLooseBase(this, _hcmCache2)[_hcmCache2].set(filterName, info);
      }
      if (!fgColor || !bgColor) {
        return info.url;
      }
      var fgRGB = _classPrivateFieldLooseBase(this, _getRGB)[_getRGB](fgColor);
      fgColor = _Util.makeHexColor.apply(_Util, _toConsumableArray(fgRGB));
      var bgRGB = _classPrivateFieldLooseBase(this, _getRGB)[_getRGB](bgColor);
      bgColor = _Util.makeHexColor.apply(_Util, _toConsumableArray(bgRGB));
      _classPrivateFieldLooseBase(this, _defs2)[_defs2].style.color = "";
      if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) {
        return info.url;
      }
      var map = new Array(256);
      for (var i = 0; i <= 255; i++) {
        var x = i / 255;
        map[i] = x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
      }
      var table = map.join(",");
      var id = "g_".concat(_classPrivateFieldLooseBase(this, _docId)[_docId], "_hcm_filter");
      var filter = info.filter = _classPrivateFieldLooseBase(this, _createFilter)[_createFilter](id);
      _classPrivateFieldLooseBase(this, _addTransferMapConversion)[_addTransferMapConversion](table, table, table, filter);
      _classPrivateFieldLooseBase(this, _addGrayConversion)[_addGrayConversion](filter);
      var getSteps = function getSteps(c, n) {
        var start = fgRGB[c] / 255;
        var end = bgRGB[c] / 255;
        var arr = new Array(n + 1);
        for (var _i13 = 0; _i13 <= n; _i13++) {
          arr[_i13] = start + _i13 / n * (end - start);
        }
        return arr.join(",");
      };
      _classPrivateFieldLooseBase(this, _addTransferMapConversion)[_addTransferMapConversion](getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
      info.url = _classPrivateFieldLooseBase(this, _createUrl)[_createUrl](id);
      return info.url;
    }
  }, {
    key: "addAlphaFilter",
    value: function addAlphaFilter(map) {
      var value = _classPrivateFieldLooseBase(this, _cache3)[_cache3].get(map);
      if (value) {
        return value;
      }
      var _classPrivateFieldLoo53 = _classPrivateFieldLooseBase(this, _createTables)[_createTables]([map]),
        _classPrivateFieldLoo54 = _slicedToArray(_classPrivateFieldLoo53, 1),
        tableA = _classPrivateFieldLoo54[0];
      var key = "alpha_".concat(tableA);
      value = _classPrivateFieldLooseBase(this, _cache3)[_cache3].get(key);
      if (value) {
        _classPrivateFieldLooseBase(this, _cache3)[_cache3].set(map, value);
        return value;
      }
      var id = "g_".concat(_classPrivateFieldLooseBase(this, _docId)[_docId], "_alpha_map_").concat(_classPrivateFieldLooseBase(this, _id3)[_id3]++);
      var url = _classPrivateFieldLooseBase(this, _createUrl)[_createUrl](id);
      _classPrivateFieldLooseBase(this, _cache3)[_cache3].set(map, url);
      _classPrivateFieldLooseBase(this, _cache3)[_cache3].set(key, url);
      var filter = _classPrivateFieldLooseBase(this, _createFilter)[_createFilter](id);
      _classPrivateFieldLooseBase(this, _addTransferMapAlphaConversion)[_addTransferMapAlphaConversion](tableA, filter);
      return url;
    }
  }, {
    key: "addLuminosityFilter",
    value: function addLuminosityFilter(map) {
      var value = _classPrivateFieldLooseBase(this, _cache3)[_cache3].get(map || "luminosity");
      if (value) {
        return value;
      }
      var tableA, key;
      if (map) {
        var _classPrivateFieldLoo55 = _classPrivateFieldLooseBase(this, _createTables)[_createTables]([map]);
        var _classPrivateFieldLoo56 = _slicedToArray(_classPrivateFieldLoo55, 1);
        tableA = _classPrivateFieldLoo56[0];
        key = "luminosity_".concat(tableA);
      } else {
        key = "luminosity";
      }
      value = _classPrivateFieldLooseBase(this, _cache3)[_cache3].get(key);
      if (value) {
        _classPrivateFieldLooseBase(this, _cache3)[_cache3].set(map, value);
        return value;
      }
      var id = "g_".concat(_classPrivateFieldLooseBase(this, _docId)[_docId], "_luminosity_map_").concat(_classPrivateFieldLooseBase(this, _id3)[_id3]++);
      var url = _classPrivateFieldLooseBase(this, _createUrl)[_createUrl](id);
      _classPrivateFieldLooseBase(this, _cache3)[_cache3].set(map, url);
      _classPrivateFieldLooseBase(this, _cache3)[_cache3].set(key, url);
      var filter = _classPrivateFieldLooseBase(this, _createFilter)[_createFilter](id);
      _classPrivateFieldLooseBase(this, _addLuminosityConversion)[_addLuminosityConversion](filter);
      if (map) {
        _classPrivateFieldLooseBase(this, _addTransferMapAlphaConversion)[_addTransferMapAlphaConversion](tableA, filter);
      }
      return url;
    }
  }, {
    key: "addHighlightHCMFilter",
    value: function addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
      var _info2;
      var key = "".concat(fgColor, "-").concat(bgColor, "-").concat(newFgColor, "-").concat(newBgColor);
      var info = _classPrivateFieldLooseBase(this, _hcmCache2)[_hcmCache2].get(filterName);
      if (((_info2 = info) === null || _info2 === void 0 ? void 0 : _info2.key) === key) {
        return info.url;
      }
      if (info) {
        var _info$filter2;
        (_info$filter2 = info.filter) === null || _info$filter2 === void 0 || _info$filter2.remove();
        info.key = key;
        info.url = "none";
        info.filter = null;
      } else {
        info = {
          key: key,
          url: "none",
          filter: null
        };
        _classPrivateFieldLooseBase(this, _hcmCache2)[_hcmCache2].set(filterName, info);
      }
      if (!fgColor || !bgColor) {
        return info.url;
      }
      var _map = [fgColor, bgColor].map(_classPrivateFieldLooseBase(this, _getRGB)[_getRGB].bind(this)),
        _map2 = _slicedToArray(_map, 2),
        fgRGB = _map2[0],
        bgRGB = _map2[1];
      var fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
      var bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
      var _map3 = [newFgColor, newBgColor].map(_classPrivateFieldLooseBase(this, _getRGB)[_getRGB].bind(this)),
        _map4 = _slicedToArray(_map3, 2),
        newFgRGB = _map4[0],
        newBgRGB = _map4[1];
      if (bgGray < fgGray) {
        var _ref51 = [bgGray, fgGray, newBgRGB, newFgRGB];
        fgGray = _ref51[0];
        bgGray = _ref51[1];
        newFgRGB = _ref51[2];
        newBgRGB = _ref51[3];
      }
      _classPrivateFieldLooseBase(this, _defs2)[_defs2].style.color = "";
      var getSteps = function getSteps(fg, bg, n) {
        var arr = new Array(256);
        var step = (bgGray - fgGray) / n;
        var newStart = fg / 255;
        var newStep = (bg - fg) / (255 * n);
        var prev = 0;
        for (var i = 0; i <= n; i++) {
          var k = Math.round(fgGray + i * step);
          var value = newStart + i * newStep;
          for (var j = prev; j <= k; j++) {
            arr[j] = value;
          }
          prev = k + 1;
        }
        for (var _i14 = prev; _i14 < 256; _i14++) {
          arr[_i14] = arr[prev - 1];
        }
        return arr.join(",");
      };
      var id = "g_".concat(_classPrivateFieldLooseBase(this, _docId)[_docId], "_hcm_").concat(filterName, "_filter");
      var filter = info.filter = _classPrivateFieldLooseBase(this, _createFilter)[_createFilter](id);
      _classPrivateFieldLooseBase(this, _addGrayConversion)[_addGrayConversion](filter);
      _classPrivateFieldLooseBase(this, _addTransferMapConversion)[_addTransferMapConversion](getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
      info.url = _classPrivateFieldLooseBase(this, _createUrl)[_createUrl](id);
      return info.url;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var keepHCM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (keepHCM && _classPrivateFieldLooseBase(this, _hcmCache2)[_hcmCache2].size !== 0) {
        return;
      }
      if (_classPrivateFieldLooseBase(this, _defs)[_defs]) {
        _classPrivateFieldLooseBase(this, _defs)[_defs].parentNode.parentNode.remove();
        _classPrivateFieldLooseBase(this, _defs)[_defs] = null;
      }
      if (_classPrivateFieldLooseBase(this, _cache2)[_cache2]) {
        _classPrivateFieldLooseBase(this, _cache2)[_cache2].clear();
        _classPrivateFieldLooseBase(this, _cache2)[_cache2] = null;
      }
      _classPrivateFieldLooseBase(this, _id3)[_id3] = 0;
    }
  }]);
}(BaseFilterFactory);
function _get_cache() {
  var _classPrivateFieldLoo137;
  return (_classPrivateFieldLoo137 = _classPrivateFieldLooseBase(this, _cache2))[_cache2] || (_classPrivateFieldLoo137[_cache2] = new Map());
}
function _get_hcmCache() {
  var _classPrivateFieldLoo138;
  return (_classPrivateFieldLoo138 = _classPrivateFieldLooseBase(this, _hcmCache))[_hcmCache] || (_classPrivateFieldLoo138[_hcmCache] = new Map());
}
function _get_defs() {
  if (!_classPrivateFieldLooseBase(this, _defs)[_defs]) {
    var div = _classPrivateFieldLooseBase(this, _document2)[_document2].createElement("div");
    var style = div.style;
    style.visibility = "hidden";
    style.contain = "strict";
    style.width = style.height = 0;
    style.position = "absolute";
    style.top = style.left = 0;
    style.zIndex = -1;
    var svg = _classPrivateFieldLooseBase(this, _document2)[_document2].createElementNS(SVG_NS, "svg");
    svg.setAttribute("width", 0);
    svg.setAttribute("height", 0);
    _classPrivateFieldLooseBase(this, _defs)[_defs] = _classPrivateFieldLooseBase(this, _document2)[_document2].createElementNS(SVG_NS, "defs");
    div.append(svg);
    svg.append(_classPrivateFieldLooseBase(this, _defs)[_defs]);
    _classPrivateFieldLooseBase(this, _document2)[_document2].body.append(div);
  }
  return _classPrivateFieldLooseBase(this, _defs)[_defs];
}
function _createTables2(maps) {
  if (maps.length === 1) {
    var _mapR = maps[0];
    var buffer = new Array(256);
    for (var i = 0; i < 256; i++) {
      buffer[i] = _mapR[i] / 255;
    }
    var table = buffer.join(",");
    return [table, table, table];
  }
  var _maps = _slicedToArray(maps, 3),
    mapR = _maps[0],
    mapG = _maps[1],
    mapB = _maps[2];
  var bufferR = new Array(256);
  var bufferG = new Array(256);
  var bufferB = new Array(256);
  for (var _i30 = 0; _i30 < 256; _i30++) {
    bufferR[_i30] = mapR[_i30] / 255;
    bufferG[_i30] = mapG[_i30] / 255;
    bufferB[_i30] = mapB[_i30] / 255;
  }
  return [bufferR.join(","), bufferG.join(","), bufferB.join(",")];
}
function _createUrl2(id) {
  if (_classPrivateFieldLooseBase(this, _baseUrl)[_baseUrl] === undefined) {
    _classPrivateFieldLooseBase(this, _baseUrl)[_baseUrl] = "";
    var url = _classPrivateFieldLooseBase(this, _document2)[_document2].URL;
    if (url !== _classPrivateFieldLooseBase(this, _document2)[_document2].baseURI) {
      if (_isDataScheme(url)) {
        warn('#createUrl: ignore "data:"-URL for performance reasons.');
      } else {
        _classPrivateFieldLooseBase(this, _baseUrl)[_baseUrl] = url.split("#", 1)[0];
      }
    }
  }
  return "url(".concat(_classPrivateFieldLooseBase(this, _baseUrl)[_baseUrl], "#").concat(id, ")");
}
function _addLuminosityConversion2(filter) {
  var feColorMatrix = _classPrivateFieldLooseBase(this, _document2)[_document2].createElementNS(SVG_NS, "feColorMatrix");
  feColorMatrix.setAttribute("type", "matrix");
  feColorMatrix.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0");
  filter.append(feColorMatrix);
}
function _addGrayConversion2(filter) {
  var feColorMatrix = _classPrivateFieldLooseBase(this, _document2)[_document2].createElementNS(SVG_NS, "feColorMatrix");
  feColorMatrix.setAttribute("type", "matrix");
  feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
  filter.append(feColorMatrix);
}
function _createFilter2(id) {
  var filter = _classPrivateFieldLooseBase(this, _document2)[_document2].createElementNS(SVG_NS, "filter");
  filter.setAttribute("color-interpolation-filters", "sRGB");
  filter.setAttribute("id", id);
  _classPrivateFieldLooseBase(this, _defs2)[_defs2].append(filter);
  return filter;
}
function _appendFeFunc2(feComponentTransfer, func, table) {
  var feFunc = _classPrivateFieldLooseBase(this, _document2)[_document2].createElementNS(SVG_NS, func);
  feFunc.setAttribute("type", "discrete");
  feFunc.setAttribute("tableValues", table);
  feComponentTransfer.append(feFunc);
}
function _addTransferMapConversion2(rTable, gTable, bTable, filter) {
  var feComponentTransfer = _classPrivateFieldLooseBase(this, _document2)[_document2].createElementNS(SVG_NS, "feComponentTransfer");
  filter.append(feComponentTransfer);
  _classPrivateFieldLooseBase(this, _appendFeFunc)[_appendFeFunc](feComponentTransfer, "feFuncR", rTable);
  _classPrivateFieldLooseBase(this, _appendFeFunc)[_appendFeFunc](feComponentTransfer, "feFuncG", gTable);
  _classPrivateFieldLooseBase(this, _appendFeFunc)[_appendFeFunc](feComponentTransfer, "feFuncB", bTable);
}
function _addTransferMapAlphaConversion2(aTable, filter) {
  var feComponentTransfer = _classPrivateFieldLooseBase(this, _document2)[_document2].createElementNS(SVG_NS, "feComponentTransfer");
  filter.append(feComponentTransfer);
  _classPrivateFieldLooseBase(this, _appendFeFunc)[_appendFeFunc](feComponentTransfer, "feFuncA", aTable);
}
function _getRGB2(color) {
  _classPrivateFieldLooseBase(this, _defs2)[_defs2].style.color = color;
  return getRGB(getComputedStyle(_classPrivateFieldLooseBase(this, _defs2)[_defs2]).getPropertyValue("color"));
}
; // ./src/display/standard_fontdata_factory.js
var BaseStandardFontDataFactory = /*#__PURE__*/function () {
  function BaseStandardFontDataFactory(_ref52) {
    var _ref52$baseUrl = _ref52.baseUrl,
      baseUrl = _ref52$baseUrl === void 0 ? null : _ref52$baseUrl;
    _classCallCheck(this, BaseStandardFontDataFactory);
    this.baseUrl = baseUrl;
  }
  return _createClass(BaseStandardFontDataFactory, [{
    key: "fetch",
    value: function () {
      var _fetch5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(_ref53) {
        var filename, url;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              filename = _ref53.filename;
              if (this.baseUrl) {
                _context19.next = 3;
                break;
              }
              throw new Error("Ensure that the `standardFontDataUrl` API parameter is provided.");
            case 3:
              if (filename) {
                _context19.next = 5;
                break;
              }
              throw new Error("Font filename must be specified.");
            case 5:
              url = "".concat(this.baseUrl).concat(filename);
              return _context19.abrupt("return", this._fetch(url).catch(function (reason) {
                throw new Error("Unable to load font data at: ".concat(url));
              }));
            case 7:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function fetch(_x21) {
        return _fetch5.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "_fetch",
    value: function () {
      var _fetch6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(url) {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              unreachable("Abstract method `_fetch` called.");
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      function _fetch(_x22) {
        return _fetch6.apply(this, arguments);
      }
      return _fetch;
    }()
  }]);
}();
var DOMStandardFontDataFactory = /*#__PURE__*/function (_BaseStandardFontData) {
  function DOMStandardFontDataFactory() {
    _classCallCheck(this, DOMStandardFontDataFactory);
    return _callSuper(this, DOMStandardFontDataFactory, arguments);
  }
  _inherits(DOMStandardFontDataFactory, _BaseStandardFontData);
  return _createClass(DOMStandardFontDataFactory, [{
    key: "_fetch",
    value: function () {
      var _fetch7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(url) {
        var data;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return _fetchData(url, "arraybuffer");
            case 2:
              data = _context21.sent;
              return _context21.abrupt("return", new Uint8Array(data));
            case 4:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
      function _fetch(_x23) {
        return _fetch7.apply(this, arguments);
      }
      return _fetch;
    }()
  }]);
}(BaseStandardFontDataFactory);
; // ./src/display/node_utils.js

if (isNodeJS) {
  var packageCapability = Promise.withResolvers();
  var packageMap = null;
  var loadPackages = /*#__PURE__*/function () {
    var _ref54 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
      var fs, http, https, url, canvas, path2d;
      return _regeneratorRuntime().wrap(function _callee22$(_context22) {
        while (1) switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return import(/*webpackIgnore: true*/"fs");
          case 2:
            fs = _context22.sent;
            _context22.next = 5;
            return import(/*webpackIgnore: true*/"http");
          case 5:
            http = _context22.sent;
            _context22.next = 8;
            return import(/*webpackIgnore: true*/"https");
          case 8:
            https = _context22.sent;
            _context22.next = 11;
            return import(/*webpackIgnore: true*/"url");
          case 11:
            url = _context22.sent;
            return _context22.abrupt("return", new Map(Object.entries({
              fs: fs,
              http: http,
              https: https,
              url: url,
              canvas: canvas,
              path2d: path2d
            })));
          case 13:
          case "end":
            return _context22.stop();
        }
      }, _callee22);
    }));
    return function loadPackages() {
      return _ref54.apply(this, arguments);
    };
  }();
  loadPackages().then(function (map) {
    packageMap = map;
    packageCapability.resolve();
  }, function (reason) {
    warn("loadPackages: ".concat(reason));
    packageMap = new Map();
    packageCapability.resolve();
  });
}
var NodePackages = /*#__PURE__*/function () {
  function NodePackages() {
    _classCallCheck(this, NodePackages);
  }
  return _createClass(NodePackages, null, [{
    key: "promise",
    get: function get() {
      return packageCapability.promise;
    }
  }, {
    key: "get",
    value: function get(name) {
      var _packageMap;
      return (_packageMap = packageMap) === null || _packageMap === void 0 ? void 0 : _packageMap.get(name);
    }
  }]);
}();
function node_utils_fetchData(_x24) {
  return _node_utils_fetchData.apply(this, arguments);
}
function _node_utils_fetchData() {
  _node_utils_fetchData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee51(url) {
    var fs, data;
    return _regeneratorRuntime().wrap(function _callee51$(_context52) {
      while (1) switch (_context52.prev = _context52.next) {
        case 0:
          fs = NodePackages.get("fs");
          _context52.next = 3;
          return fs.promises.readFile(url);
        case 3:
          data = _context52.sent;
          return _context52.abrupt("return", new Uint8Array(data));
        case 5:
        case "end":
          return _context52.stop();
      }
    }, _callee51);
  }));
  return _node_utils_fetchData.apply(this, arguments);
}
var NodeFilterFactory = /*#__PURE__*/function (_BaseFilterFactory2) {
  function NodeFilterFactory() {
    _classCallCheck(this, NodeFilterFactory);
    return _callSuper(this, NodeFilterFactory, arguments);
  }
  _inherits(NodeFilterFactory, _BaseFilterFactory2);
  return _createClass(NodeFilterFactory);
}(BaseFilterFactory);
var NodeCanvasFactory = /*#__PURE__*/function (_BaseCanvasFactory3) {
  function NodeCanvasFactory() {
    _classCallCheck(this, NodeCanvasFactory);
    return _callSuper(this, NodeCanvasFactory, arguments);
  }
  _inherits(NodeCanvasFactory, _BaseCanvasFactory3);
  return _createClass(NodeCanvasFactory, [{
    key: "_createCanvas",
    value: function _createCanvas(width, height) {
      var canvas = NodePackages.get("canvas");
      return canvas.createCanvas(width, height);
    }
  }]);
}(BaseCanvasFactory);
var NodeCMapReaderFactory = /*#__PURE__*/function (_BaseCMapReaderFactor2) {
  function NodeCMapReaderFactory() {
    _classCallCheck(this, NodeCMapReaderFactory);
    return _callSuper(this, NodeCMapReaderFactory, arguments);
  }
  _inherits(NodeCMapReaderFactory, _BaseCMapReaderFactor2);
  return _createClass(NodeCMapReaderFactory, [{
    key: "_fetch",
    value: function () {
      var _fetch8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23(url) {
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              return _context23.abrupt("return", node_utils_fetchData(url));
            case 1:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }));
      function _fetch(_x25) {
        return _fetch8.apply(this, arguments);
      }
      return _fetch;
    }()
  }]);
}(BaseCMapReaderFactory);
var NodeStandardFontDataFactory = /*#__PURE__*/function (_BaseStandardFontData2) {
  function NodeStandardFontDataFactory() {
    _classCallCheck(this, NodeStandardFontDataFactory);
    return _callSuper(this, NodeStandardFontDataFactory, arguments);
  }
  _inherits(NodeStandardFontDataFactory, _BaseStandardFontData2);
  return _createClass(NodeStandardFontDataFactory, [{
    key: "_fetch",
    value: function () {
      var _fetch9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(url) {
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              return _context24.abrupt("return", node_utils_fetchData(url));
            case 1:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }));
      function _fetch(_x26) {
        return _fetch9.apply(this, arguments);
      }
      return _fetch;
    }()
  }]);
}(BaseStandardFontDataFactory);
; // ./src/display/pattern_helper.js

var PathType = {
  FILL: "Fill",
  STROKE: "Stroke",
  SHADING: "Shading"
};
function applyBoundingBox(ctx, bbox) {
  if (!bbox) {
    return;
  }
  var width = bbox[2] - bbox[0];
  var height = bbox[3] - bbox[1];
  var region = new Path2D();
  region.rect(bbox[0], bbox[1], width, height);
  ctx.clip(region);
}
var BaseShadingPattern = /*#__PURE__*/function () {
  function BaseShadingPattern() {
    _classCallCheck(this, BaseShadingPattern);
  }
  return _createClass(BaseShadingPattern, [{
    key: "getPattern",
    value: function getPattern() {
      unreachable("Abstract method `getPattern` called.");
    }
  }]);
}();
var RadialAxialShadingPattern = /*#__PURE__*/function (_BaseShadingPattern) {
  function RadialAxialShadingPattern(IR) {
    var _this22;
    _classCallCheck(this, RadialAxialShadingPattern);
    _this22 = _callSuper(this, RadialAxialShadingPattern);
    _this22._type = IR[1];
    _this22._bbox = IR[2];
    _this22._colorStops = IR[3];
    _this22._p0 = IR[4];
    _this22._p1 = IR[5];
    _this22._r0 = IR[6];
    _this22._r1 = IR[7];
    _this22.matrix = null;
    return _this22;
  }
  _inherits(RadialAxialShadingPattern, _BaseShadingPattern);
  return _createClass(RadialAxialShadingPattern, [{
    key: "_createGradient",
    value: function _createGradient(ctx) {
      var grad;
      if (this._type === "axial") {
        grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
      } else if (this._type === "radial") {
        grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
      }
      var _iterator54 = _createForOfIteratorHelper(this._colorStops),
        _step54;
      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var colorStop = _step54.value;
          grad.addColorStop(colorStop[0], colorStop[1]);
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
      return grad;
    }
  }, {
    key: "getPattern",
    value: function getPattern(ctx, owner, inverse, pathType) {
      var pattern;
      if (pathType === PathType.STROKE || pathType === PathType.FILL) {
        var ownerBBox = owner.current.getClippedPathBoundingBox(pathType, getCurrentTransform(ctx)) || [0, 0, 0, 0];
        var width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
        var height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
        var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height);
        var tmpCtx = tmpCanvas.context;
        tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
        tmpCtx.beginPath();
        tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
        tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
        inverse = _Util.transform(inverse, [1, 0, 0, 1, ownerBBox[0], ownerBBox[1]]);
        tmpCtx.transform.apply(tmpCtx, _toConsumableArray(owner.baseTransform));
        if (this.matrix) {
          tmpCtx.transform.apply(tmpCtx, _toConsumableArray(this.matrix));
        }
        applyBoundingBox(tmpCtx, this._bbox);
        tmpCtx.fillStyle = this._createGradient(tmpCtx);
        tmpCtx.fill();
        pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
        var domMatrix = new DOMMatrix(inverse);
        pattern.setTransform(domMatrix);
      } else {
        applyBoundingBox(ctx, this._bbox);
        pattern = this._createGradient(ctx);
      }
      return pattern;
    }
  }]);
}(BaseShadingPattern);
function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
  var coords = context.coords,
    colors = context.colors;
  var bytes = data.data,
    rowSize = data.width * 4;
  var tmp;
  if (coords[p1 + 1] > coords[p2 + 1]) {
    tmp = p1;
    p1 = p2;
    p2 = tmp;
    tmp = c1;
    c1 = c2;
    c2 = tmp;
  }
  if (coords[p2 + 1] > coords[p3 + 1]) {
    tmp = p2;
    p2 = p3;
    p3 = tmp;
    tmp = c2;
    c2 = c3;
    c3 = tmp;
  }
  if (coords[p1 + 1] > coords[p2 + 1]) {
    tmp = p1;
    p1 = p2;
    p2 = tmp;
    tmp = c1;
    c1 = c2;
    c2 = tmp;
  }
  var x1 = (coords[p1] + context.offsetX) * context.scaleX;
  var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
  var x2 = (coords[p2] + context.offsetX) * context.scaleX;
  var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
  var x3 = (coords[p3] + context.offsetX) * context.scaleX;
  var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
  if (y1 >= y3) {
    return;
  }
  var c1r = colors[c1],
    c1g = colors[c1 + 1],
    c1b = colors[c1 + 2];
  var c2r = colors[c2],
    c2g = colors[c2 + 1],
    c2b = colors[c2 + 2];
  var c3r = colors[c3],
    c3g = colors[c3 + 1],
    c3b = colors[c3 + 2];
  var minY = Math.round(y1),
    maxY = Math.round(y3);
  var xa, car, cag, cab;
  var xb, cbr, cbg, cbb;
  for (var y = minY; y <= maxY; y++) {
    if (y < y2) {
      var _k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
      xa = x1 - (x1 - x2) * _k;
      car = c1r - (c1r - c2r) * _k;
      cag = c1g - (c1g - c2g) * _k;
      cab = c1b - (c1b - c2b) * _k;
    } else {
      var _k2 = void 0;
      if (y > y3) {
        _k2 = 1;
      } else if (y2 === y3) {
        _k2 = 0;
      } else {
        _k2 = (y2 - y) / (y2 - y3);
      }
      xa = x2 - (x2 - x3) * _k2;
      car = c2r - (c2r - c3r) * _k2;
      cag = c2g - (c2g - c3g) * _k2;
      cab = c2b - (c2b - c3b) * _k2;
    }
    var k = void 0;
    if (y < y1) {
      k = 0;
    } else if (y > y3) {
      k = 1;
    } else {
      k = (y1 - y) / (y1 - y3);
    }
    xb = x1 - (x1 - x3) * k;
    cbr = c1r - (c1r - c3r) * k;
    cbg = c1g - (c1g - c3g) * k;
    cbb = c1b - (c1b - c3b) * k;
    var x1_ = Math.round(Math.min(xa, xb));
    var x2_ = Math.round(Math.max(xa, xb));
    var j = rowSize * y + x1_ * 4;
    for (var x = x1_; x <= x2_; x++) {
      k = (xa - x) / (xa - xb);
      if (k < 0) {
        k = 0;
      } else if (k > 1) {
        k = 1;
      }
      bytes[j++] = car - (car - cbr) * k | 0;
      bytes[j++] = cag - (cag - cbg) * k | 0;
      bytes[j++] = cab - (cab - cbb) * k | 0;
      bytes[j++] = 255;
    }
  }
}
function drawFigure(data, figure, context) {
  var ps = figure.coords;
  var cs = figure.colors;
  var i, ii;
  switch (figure.type) {
    case "lattice":
      var verticesPerRow = figure.verticesPerRow;
      var rows = Math.floor(ps.length / verticesPerRow) - 1;
      var cols = verticesPerRow - 1;
      for (i = 0; i < rows; i++) {
        var q = i * verticesPerRow;
        for (var j = 0; j < cols; j++, q++) {
          drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
          drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
        }
      }
      break;
    case "triangles":
      for (i = 0, ii = ps.length; i < ii; i += 3) {
        drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
      }
      break;
    default:
      throw new Error("illegal figure");
  }
}
var MeshShadingPattern = /*#__PURE__*/function (_BaseShadingPattern2) {
  function MeshShadingPattern(IR) {
    var _this23;
    _classCallCheck(this, MeshShadingPattern);
    _this23 = _callSuper(this, MeshShadingPattern);
    _this23._coords = IR[2];
    _this23._colors = IR[3];
    _this23._figures = IR[4];
    _this23._bounds = IR[5];
    _this23._bbox = IR[7];
    _this23._background = IR[8];
    _this23.matrix = null;
    return _this23;
  }
  _inherits(MeshShadingPattern, _BaseShadingPattern2);
  return _createClass(MeshShadingPattern, [{
    key: "_createMeshCanvas",
    value: function _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
      var EXPECTED_SCALE = 1.1;
      var MAX_PATTERN_SIZE = 3000;
      var BORDER_SIZE = 2;
      var offsetX = Math.floor(this._bounds[0]);
      var offsetY = Math.floor(this._bounds[1]);
      var boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
      var boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
      var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
      var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
      var scaleX = boundsWidth / width;
      var scaleY = boundsHeight / height;
      var context = {
        coords: this._coords,
        colors: this._colors,
        offsetX: -offsetX,
        offsetY: -offsetY,
        scaleX: 1 / scaleX,
        scaleY: 1 / scaleY
      };
      var paddedWidth = width + BORDER_SIZE * 2;
      var paddedHeight = height + BORDER_SIZE * 2;
      var tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight);
      var tmpCtx = tmpCanvas.context;
      var data = tmpCtx.createImageData(width, height);
      if (backgroundColor) {
        var bytes = data.data;
        for (var i = 0, ii = bytes.length; i < ii; i += 4) {
          bytes[i] = backgroundColor[0];
          bytes[i + 1] = backgroundColor[1];
          bytes[i + 2] = backgroundColor[2];
          bytes[i + 3] = 255;
        }
      }
      var _iterator55 = _createForOfIteratorHelper(this._figures),
        _step55;
      try {
        for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
          var figure = _step55.value;
          drawFigure(data, figure, context);
        }
      } catch (err) {
        _iterator55.e(err);
      } finally {
        _iterator55.f();
      }
      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
      var canvas = tmpCanvas.canvas;
      return {
        canvas: canvas,
        offsetX: offsetX - BORDER_SIZE * scaleX,
        offsetY: offsetY - BORDER_SIZE * scaleY,
        scaleX: scaleX,
        scaleY: scaleY
      };
    }
  }, {
    key: "getPattern",
    value: function getPattern(ctx, owner, inverse, pathType) {
      applyBoundingBox(ctx, this._bbox);
      var scale;
      if (pathType === PathType.SHADING) {
        scale = _Util.singularValueDecompose2dScale(getCurrentTransform(ctx));
      } else {
        scale = _Util.singularValueDecompose2dScale(owner.baseTransform);
        if (this.matrix) {
          var matrixScale = _Util.singularValueDecompose2dScale(this.matrix);
          scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
        }
      }
      var temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
      if (pathType !== PathType.SHADING) {
        ctx.setTransform.apply(ctx, _toConsumableArray(owner.baseTransform));
        if (this.matrix) {
          ctx.transform.apply(ctx, _toConsumableArray(this.matrix));
        }
      }
      ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
      ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
      return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
    }
  }]);
}(BaseShadingPattern);
var DummyShadingPattern = /*#__PURE__*/function (_BaseShadingPattern3) {
  function DummyShadingPattern() {
    _classCallCheck(this, DummyShadingPattern);
    return _callSuper(this, DummyShadingPattern, arguments);
  }
  _inherits(DummyShadingPattern, _BaseShadingPattern3);
  return _createClass(DummyShadingPattern, [{
    key: "getPattern",
    value: function getPattern() {
      return "hotpink";
    }
  }]);
}(BaseShadingPattern);
function getShadingPattern(IR) {
  switch (IR[0]) {
    case "RadialAxial":
      return new RadialAxialShadingPattern(IR);
    case "Mesh":
      return new MeshShadingPattern(IR);
    case "Dummy":
      return new DummyShadingPattern();
  }
  throw new Error("Unknown IR type: ".concat(IR[0]));
}
var PaintType = {
  COLORED: 1,
  UNCOLORED: 2
};
var TilingPattern = /*#__PURE__*/function () {
  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
    _classCallCheck(this, TilingPattern);
    this.operatorList = IR[2];
    this.matrix = IR[3];
    this.bbox = IR[4];
    this.xstep = IR[5];
    this.ystep = IR[6];
    this.paintType = IR[7];
    this.tilingType = IR[8];
    this.color = color;
    this.ctx = ctx;
    this.canvasGraphicsFactory = canvasGraphicsFactory;
    this.baseTransform = baseTransform;
  }
  return _createClass(TilingPattern, [{
    key: "createPatternCanvas",
    value: function createPatternCanvas(owner) {
      var bbox = this.bbox,
        operatorList = this.operatorList,
        paintType = this.paintType,
        tilingType = this.tilingType,
        color = this.color,
        canvasGraphicsFactory = this.canvasGraphicsFactory;
      var xstep = this.xstep,
        ystep = this.ystep;
      xstep = Math.abs(xstep);
      ystep = Math.abs(ystep);
      info("TilingType: " + tilingType);
      var x0 = bbox[0],
        y0 = bbox[1],
        x1 = bbox[2],
        y1 = bbox[3];
      var width = x1 - x0;
      var height = y1 - y0;
      var matrixScale = _Util.singularValueDecompose2dScale(this.matrix);
      var curMatrixScale = _Util.singularValueDecompose2dScale(this.baseTransform);
      var combinedScaleX = matrixScale[0] * curMatrixScale[0];
      var combinedScaleY = matrixScale[1] * curMatrixScale[1];
      var canvasWidth = width,
        canvasHeight = height,
        redrawHorizontally = false,
        redrawVertically = false;
      var xScaledStep = Math.ceil(xstep * combinedScaleX);
      var yScaledStep = Math.ceil(ystep * combinedScaleY);
      var xScaledWidth = Math.ceil(width * combinedScaleX);
      var yScaledHeight = Math.ceil(height * combinedScaleY);
      if (xScaledStep >= xScaledWidth) {
        canvasWidth = xstep;
      } else {
        redrawHorizontally = true;
      }
      if (yScaledStep >= yScaledHeight) {
        canvasHeight = ystep;
      } else {
        redrawVertically = true;
      }
      var dimx = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
      var dimy = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
      var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size);
      var tmpCtx = tmpCanvas.context;
      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
      graphics.groupLevel = owner.groupLevel;
      this.setFillAndStrokeStyleToContext(graphics, paintType, color);
      tmpCtx.translate(-dimx.scale * x0, -dimy.scale * y0);
      graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
      tmpCtx.save();
      this.clipBbox(graphics, x0, y0, x1, y1);
      graphics.baseTransform = getCurrentTransform(graphics.ctx);
      graphics.executeOperatorList(operatorList);
      graphics.endDrawing();
      tmpCtx.restore();
      if (redrawHorizontally || redrawVertically) {
        var image = tmpCanvas.canvas;
        if (redrawHorizontally) {
          canvasWidth = xstep;
        }
        if (redrawVertically) {
          canvasHeight = ystep;
        }
        var dimx2 = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
        var dimy2 = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
        var xSize = dimx2.size;
        var ySize = dimy2.size;
        var tmpCanvas2 = owner.cachedCanvases.getCanvas("pattern-workaround", xSize, ySize);
        var tmpCtx2 = tmpCanvas2.context;
        var ii = redrawHorizontally ? Math.floor(width / xstep) : 0;
        var jj = redrawVertically ? Math.floor(height / ystep) : 0;
        for (var i = 0; i <= ii; i++) {
          for (var j = 0; j <= jj; j++) {
            tmpCtx2.drawImage(image, xSize * i, ySize * j, xSize, ySize, 0, 0, xSize, ySize);
          }
        }
        return {
          canvas: tmpCanvas2.canvas,
          scaleX: dimx2.scale,
          scaleY: dimy2.scale,
          offsetX: x0,
          offsetY: y0
        };
      }
      return {
        canvas: tmpCanvas.canvas,
        scaleX: dimx.scale,
        scaleY: dimy.scale,
        offsetX: x0,
        offsetY: y0
      };
    }
  }, {
    key: "getSizeAndScale",
    value: function getSizeAndScale(step, realOutputSize, scale) {
      var maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
      var size = Math.ceil(step * scale);
      if (size >= maxSize) {
        size = maxSize;
      } else {
        scale = size / step;
      }
      return {
        scale: scale,
        size: size
      };
    }
  }, {
    key: "clipBbox",
    value: function clipBbox(graphics, x0, y0, x1, y1) {
      var bboxWidth = x1 - x0;
      var bboxHeight = y1 - y0;
      graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
      graphics.current.updateRectMinMax(getCurrentTransform(graphics.ctx), [x0, y0, x1, y1]);
      graphics.clip();
      graphics.endPath();
    }
  }, {
    key: "setFillAndStrokeStyleToContext",
    value: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
      var context = graphics.ctx,
        current = graphics.current;
      switch (paintType) {
        case PaintType.COLORED:
          var ctx = this.ctx;
          context.fillStyle = ctx.fillStyle;
          context.strokeStyle = ctx.strokeStyle;
          current.fillColor = ctx.fillStyle;
          current.strokeColor = ctx.strokeStyle;
          break;
        case PaintType.UNCOLORED:
          var cssColor = _Util.makeHexColor(color[0], color[1], color[2]);
          context.fillStyle = cssColor;
          context.strokeStyle = cssColor;
          current.fillColor = cssColor;
          current.strokeColor = cssColor;
          break;
        default:
          throw new FormatError("Unsupported paint type: ".concat(paintType));
      }
    }
  }, {
    key: "getPattern",
    value: function getPattern(ctx, owner, inverse, pathType) {
      var matrix = inverse;
      if (pathType !== PathType.SHADING) {
        matrix = _Util.transform(matrix, owner.baseTransform);
        if (this.matrix) {
          matrix = _Util.transform(matrix, this.matrix);
        }
      }
      var temporaryPatternCanvas = this.createPatternCanvas(owner);
      var domMatrix = new DOMMatrix(matrix);
      domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
      domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
      var pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
      pattern.setTransform(domMatrix);
      return pattern;
    }
  }]);
}();
TilingPattern.MAX_PATTERN_SIZE = 3000;
; // ./src/shared/image_utils.js

function convertToRGBA(params) {
  switch (params.kind) {
    case ImageKind.GRAYSCALE_1BPP:
      return convertBlackAndWhiteToRGBA(params);
    case ImageKind.RGB_24BPP:
      return convertRGBToRGBA(params);
  }
  return null;
}
function convertBlackAndWhiteToRGBA(_ref55) {
  var src = _ref55.src,
    _ref55$srcPos = _ref55.srcPos,
    srcPos = _ref55$srcPos === void 0 ? 0 : _ref55$srcPos,
    dest = _ref55.dest,
    width = _ref55.width,
    height = _ref55.height,
    _ref55$nonBlackColor = _ref55.nonBlackColor,
    nonBlackColor = _ref55$nonBlackColor === void 0 ? 0xffffffff : _ref55$nonBlackColor,
    _ref55$inverseDecode = _ref55.inverseDecode,
    inverseDecode = _ref55$inverseDecode === void 0 ? false : _ref55$inverseDecode;
  var black = util_FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
  var _ref56 = inverseDecode ? [nonBlackColor, black] : [black, nonBlackColor],
    _ref57 = _slicedToArray(_ref56, 2),
    zeroMapping = _ref57[0],
    oneMapping = _ref57[1];
  var widthInSource = width >> 3;
  var widthRemainder = width & 7;
  var srcLength = src.length;
  dest = new Uint32Array(dest.buffer);
  var destPos = 0;
  for (var i = 0; i < height; i++) {
    for (var max = srcPos + widthInSource; srcPos < max; srcPos++) {
      var _elem = srcPos < srcLength ? src[srcPos] : 255;
      dest[destPos++] = _elem & 128 ? oneMapping : zeroMapping;
      dest[destPos++] = _elem & 64 ? oneMapping : zeroMapping;
      dest[destPos++] = _elem & 32 ? oneMapping : zeroMapping;
      dest[destPos++] = _elem & 16 ? oneMapping : zeroMapping;
      dest[destPos++] = _elem & 8 ? oneMapping : zeroMapping;
      dest[destPos++] = _elem & 4 ? oneMapping : zeroMapping;
      dest[destPos++] = _elem & 2 ? oneMapping : zeroMapping;
      dest[destPos++] = _elem & 1 ? oneMapping : zeroMapping;
    }
    if (widthRemainder === 0) {
      continue;
    }
    var elem = srcPos < srcLength ? src[srcPos++] : 255;
    for (var j = 0; j < widthRemainder; j++) {
      dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
    }
  }
  return {
    srcPos: srcPos,
    destPos: destPos
  };
}
function convertRGBToRGBA(_ref58) {
  var src = _ref58.src,
    _ref58$srcPos = _ref58.srcPos,
    srcPos = _ref58$srcPos === void 0 ? 0 : _ref58$srcPos,
    dest = _ref58.dest,
    _ref58$destPos = _ref58.destPos,
    destPos = _ref58$destPos === void 0 ? 0 : _ref58$destPos,
    width = _ref58.width,
    height = _ref58.height;
  var i = 0;
  var len32 = src.length >> 2;
  var src32 = new Uint32Array(src.buffer, srcPos, len32);
  if (FeatureTest.isLittleEndian) {
    for (; i < len32 - 2; i += 3, destPos += 4) {
      var s1 = src32[i];
      var s2 = src32[i + 1];
      var s3 = src32[i + 2];
      dest[destPos] = s1 | 0xff000000;
      dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
      dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
      dest[destPos + 3] = s3 >>> 8 | 0xff000000;
    }
    for (var j = i * 4, jj = src.length; j < jj; j += 3) {
      dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
    }
  } else {
    for (; i < len32 - 2; i += 3, destPos += 4) {
      var _s = src32[i];
      var _s2 = src32[i + 1];
      var _s3 = src32[i + 2];
      dest[destPos] = _s | 0xff;
      dest[destPos + 1] = _s << 24 | _s2 >>> 8 | 0xff;
      dest[destPos + 2] = _s2 << 16 | _s3 >>> 16 | 0xff;
      dest[destPos + 3] = _s3 << 8 | 0xff;
    }
    for (var _j = i * 4, _jj = src.length; _j < _jj; _j += 3) {
      dest[destPos++] = src[_j] << 24 | src[_j + 1] << 16 | src[_j + 2] << 8 | 0xff;
    }
  }
  return {
    srcPos: srcPos,
    destPos: destPos
  };
}
function grayToRGBA(src, dest) {
  if (FeatureTest.isLittleEndian) {
    for (var i = 0, ii = src.length; i < ii; i++) {
      dest[i] = src[i] * 0x10101 | 0xff000000;
    }
  } else {
    for (var _i15 = 0, _ii3 = src.length; _i15 < _ii3; _i15++) {
      dest[_i15] = src[_i15] * 0x1010100 | 0x000000ff;
    }
  }
}
; // ./src/display/canvas.js

var MIN_FONT_SIZE = 16;
var MAX_FONT_SIZE = 100;
var EXECUTION_TIME = 15;
var EXECUTION_STEPS = 10;
var MAX_SIZE_TO_COMPILE = 1000;
var FULL_CHUNK_HEIGHT = 16;
function mirrorContextOperations(ctx, destCtx) {
  if (ctx._removeMirroring) {
    throw new Error("Context is already forwarding operations.");
  }
  ctx.__originalSave = ctx.save;
  ctx.__originalRestore = ctx.restore;
  ctx.__originalRotate = ctx.rotate;
  ctx.__originalScale = ctx.scale;
  ctx.__originalTranslate = ctx.translate;
  ctx.__originalTransform = ctx.transform;
  ctx.__originalSetTransform = ctx.setTransform;
  ctx.__originalResetTransform = ctx.resetTransform;
  ctx.__originalClip = ctx.clip;
  ctx.__originalMoveTo = ctx.moveTo;
  ctx.__originalLineTo = ctx.lineTo;
  ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
  ctx.__originalRect = ctx.rect;
  ctx.__originalClosePath = ctx.closePath;
  ctx.__originalBeginPath = ctx.beginPath;
  ctx._removeMirroring = function () {
    ctx.save = ctx.__originalSave;
    ctx.restore = ctx.__originalRestore;
    ctx.rotate = ctx.__originalRotate;
    ctx.scale = ctx.__originalScale;
    ctx.translate = ctx.__originalTranslate;
    ctx.transform = ctx.__originalTransform;
    ctx.setTransform = ctx.__originalSetTransform;
    ctx.resetTransform = ctx.__originalResetTransform;
    ctx.clip = ctx.__originalClip;
    ctx.moveTo = ctx.__originalMoveTo;
    ctx.lineTo = ctx.__originalLineTo;
    ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
    ctx.rect = ctx.__originalRect;
    ctx.closePath = ctx.__originalClosePath;
    ctx.beginPath = ctx.__originalBeginPath;
    delete ctx._removeMirroring;
  };
  ctx.save = function ctxSave() {
    destCtx.save();
    this.__originalSave();
  };
  ctx.restore = function ctxRestore() {
    destCtx.restore();
    this.__originalRestore();
  };
  ctx.translate = function ctxTranslate(x, y) {
    destCtx.translate(x, y);
    this.__originalTranslate(x, y);
  };
  ctx.scale = function ctxScale(x, y) {
    destCtx.scale(x, y);
    this.__originalScale(x, y);
  };
  ctx.transform = function ctxTransform(a, b, c, d, e, f) {
    destCtx.transform(a, b, c, d, e, f);
    this.__originalTransform(a, b, c, d, e, f);
  };
  ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
    destCtx.setTransform(a, b, c, d, e, f);
    this.__originalSetTransform(a, b, c, d, e, f);
  };
  ctx.resetTransform = function ctxResetTransform() {
    destCtx.resetTransform();
    this.__originalResetTransform();
  };
  ctx.rotate = function ctxRotate(angle) {
    destCtx.rotate(angle);
    this.__originalRotate(angle);
  };
  ctx.clip = function ctxRotate(rule) {
    destCtx.clip(rule);
    this.__originalClip(rule);
  };
  ctx.moveTo = function (x, y) {
    destCtx.moveTo(x, y);
    this.__originalMoveTo(x, y);
  };
  ctx.lineTo = function (x, y) {
    destCtx.lineTo(x, y);
    this.__originalLineTo(x, y);
  };
  ctx.bezierCurveTo = function (cp1x, cp1y, cp2x, cp2y, x, y) {
    destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
  };
  ctx.rect = function (x, y, width, height) {
    destCtx.rect(x, y, width, height);
    this.__originalRect(x, y, width, height);
  };
  ctx.closePath = function () {
    destCtx.closePath();
    this.__originalClosePath();
  };
  ctx.beginPath = function () {
    destCtx.beginPath();
    this.__originalBeginPath();
  };
}
var CachedCanvases = /*#__PURE__*/function () {
  function CachedCanvases(canvasFactory) {
    _classCallCheck(this, CachedCanvases);
    this.canvasFactory = canvasFactory;
    this.cache = Object.create(null);
  }
  return _createClass(CachedCanvases, [{
    key: "getCanvas",
    value: function getCanvas(id, width, height) {
      var canvasEntry;
      if (this.cache[id] !== undefined) {
        canvasEntry = this.cache[id];
        this.canvasFactory.reset(canvasEntry, width, height);
      } else {
        canvasEntry = this.canvasFactory.create(width, height);
        this.cache[id] = canvasEntry;
      }
      return canvasEntry;
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      delete this.cache[id];
    }
  }, {
    key: "clear",
    value: function clear() {
      for (var _id4 in this.cache) {
        var canvasEntry = this.cache[_id4];
        this.canvasFactory.destroy(canvasEntry);
        delete this.cache[_id4];
      }
    }
  }]);
}();
function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
  var _getCurrentTransform = getCurrentTransform(ctx),
    _getCurrentTransform2 = _slicedToArray(_getCurrentTransform, 6),
    a = _getCurrentTransform2[0],
    b = _getCurrentTransform2[1],
    c = _getCurrentTransform2[2],
    d = _getCurrentTransform2[3],
    tx = _getCurrentTransform2[4],
    ty = _getCurrentTransform2[5];
  if (b === 0 && c === 0) {
    var tlX = destX * a + tx;
    var rTlX = Math.round(tlX);
    var tlY = destY * d + ty;
    var rTlY = Math.round(tlY);
    var brX = (destX + destW) * a + tx;
    var rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
    var brY = (destY + destH) * d + ty;
    var rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
    ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
    ctx.setTransform(a, b, c, d, tx, ty);
    return [rWidth, rHeight];
  }
  if (a === 0 && d === 0) {
    var _tlX = destY * c + tx;
    var _rTlX = Math.round(_tlX);
    var _tlY = destX * b + ty;
    var _rTlY = Math.round(_tlY);
    var _brX = (destY + destH) * c + tx;
    var _rWidth = Math.abs(Math.round(_brX) - _rTlX) || 1;
    var _brY = (destX + destW) * b + ty;
    var _rHeight = Math.abs(Math.round(_brY) - _rTlY) || 1;
    ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, _rTlX, _rTlY);
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, _rHeight, _rWidth);
    ctx.setTransform(a, b, c, d, tx, ty);
    return [_rHeight, _rWidth];
  }
  ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
  var scaleX = Math.hypot(a, b);
  var scaleY = Math.hypot(c, d);
  return [scaleX * destW, scaleY * destH];
}
function compileType3Glyph(imgData) {
  var width = imgData.width,
    height = imgData.height;
  if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) {
    return null;
  }
  var POINT_TO_PROCESS_LIMIT = 1000;
  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
  var width1 = width + 1;
  var points = new Uint8Array(width1 * (height + 1));
  var i, j, j0;
  var lineSize = width + 7 & ~7;
  var data = new Uint8Array(lineSize * height),
    pos = 0;
  var _iterator56 = _createForOfIteratorHelper(imgData.data),
    _step56;
  try {
    for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
      var elem = _step56.value;
      var mask = 128;
      while (mask > 0) {
        data[pos++] = elem & mask ? 0 : 255;
        mask >>= 1;
      }
    }
  } catch (err) {
    _iterator56.e(err);
  } finally {
    _iterator56.f();
  }
  var count = 0;
  pos = 0;
  if (data[pos] !== 0) {
    points[0] = 1;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j] = data[pos] ? 2 : 1;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j] = 2;
    ++count;
  }
  for (i = 1; i < height; i++) {
    pos = i * lineSize;
    j0 = i * width1;
    if (data[pos - lineSize] !== data[pos]) {
      points[j0] = data[pos] ? 1 : 8;
      ++count;
    }
    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
    for (j = 1; j < width; j++) {
      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
      if (POINT_TYPES[sum]) {
        points[j0 + j] = POINT_TYPES[sum];
        ++count;
      }
      pos++;
    }
    if (data[pos - lineSize] !== data[pos]) {
      points[j0 + j] = data[pos] ? 2 : 4;
      ++count;
    }
    if (count > POINT_TO_PROCESS_LIMIT) {
      return null;
    }
  }
  pos = lineSize * (height - 1);
  j0 = i * width1;
  if (data[pos] !== 0) {
    points[j0] = 8;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j0 + j] = data[pos] ? 4 : 8;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j0 + j] = 4;
    ++count;
  }
  if (count > POINT_TO_PROCESS_LIMIT) {
    return null;
  }
  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
  var path = new Path2D();
  for (i = 0; count && i <= height; i++) {
    var p = i * width1;
    var end = p + width;
    while (p < end && !points[p]) {
      p++;
    }
    if (p === end) {
      continue;
    }
    path.moveTo(p % width1, i);
    var p0 = p;
    var type = points[p];
    do {
      var step = steps[type];
      do {
        p += step;
      } while (!points[p]);
      var pp = points[p];
      if (pp !== 5 && pp !== 10) {
        type = pp;
        points[p] = 0;
      } else {
        type = pp & 0x33 * type >> 4;
        points[p] &= type >> 2 | type << 2;
      }
      path.lineTo(p % width1, p / width1 | 0);
      if (!points[p]) {
        --count;
      }
    } while (p0 !== p);
    --i;
  }
  data = null;
  points = null;
  var drawOutline = function drawOutline(c) {
    c.save();
    c.scale(1 / width, -1 / height);
    c.translate(0, -height);
    c.fill(path);
    c.beginPath();
    c.restore();
  };
  return drawOutline;
}
var CanvasExtraState = /*#__PURE__*/function () {
  function CanvasExtraState(width, height) {
    _classCallCheck(this, CanvasExtraState);
    this.alphaIsShape = false;
    this.fontSize = 0;
    this.fontSizeScale = 1;
    this.textMatrix = IDENTITY_MATRIX;
    this.textMatrixScale = 1;
    this.fontMatrix = FONT_IDENTITY_MATRIX;
    this.leading = 0;
    this.x = 0;
    this.y = 0;
    this.lineX = 0;
    this.lineY = 0;
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.textHScale = 1;
    this.textRenderingMode = TextRenderingMode.FILL;
    this.textRise = 0;
    this.fillColor = "#000000";
    this.strokeColor = "#000000";
    this.patternFill = false;
    this.fillAlpha = 1;
    this.strokeAlpha = 1;
    this.lineWidth = 1;
    this.activeSMask = null;
    this.transferMaps = "none";
    this.startNewPathAndClipBox([0, 0, width, height]);
  }
  return _createClass(CanvasExtraState, [{
    key: "clone",
    value: function clone() {
      var clone = Object.create(this);
      clone.clipBox = this.clipBox.slice();
      return clone;
    }
  }, {
    key: "setCurrentPoint",
    value: function setCurrentPoint(x, y) {
      this.x = x;
      this.y = y;
    }
  }, {
    key: "updatePathMinMax",
    value: function updatePathMinMax(transform, x, y) {
      var _Util$applyTransform = _Util.applyTransform([x, y], transform);
      var _Util$applyTransform2 = _slicedToArray(_Util$applyTransform, 2);
      x = _Util$applyTransform2[0];
      y = _Util$applyTransform2[1];
      this.minX = Math.min(this.minX, x);
      this.minY = Math.min(this.minY, y);
      this.maxX = Math.max(this.maxX, x);
      this.maxY = Math.max(this.maxY, y);
    }
  }, {
    key: "updateRectMinMax",
    value: function updateRectMinMax(transform, rect) {
      var p1 = _Util.applyTransform(rect, transform);
      var p2 = _Util.applyTransform(rect.slice(2), transform);
      var p3 = _Util.applyTransform([rect[0], rect[3]], transform);
      var p4 = _Util.applyTransform([rect[2], rect[1]], transform);
      this.minX = Math.min(this.minX, p1[0], p2[0], p3[0], p4[0]);
      this.minY = Math.min(this.minY, p1[1], p2[1], p3[1], p4[1]);
      this.maxX = Math.max(this.maxX, p1[0], p2[0], p3[0], p4[0]);
      this.maxY = Math.max(this.maxY, p1[1], p2[1], p3[1], p4[1]);
    }
  }, {
    key: "updateScalingPathMinMax",
    value: function updateScalingPathMinMax(transform, minMax) {
      _Util.scaleMinMax(transform, minMax);
      this.minX = Math.min(this.minX, minMax[0]);
      this.minY = Math.min(this.minY, minMax[1]);
      this.maxX = Math.max(this.maxX, minMax[2]);
      this.maxY = Math.max(this.maxY, minMax[3]);
    }
  }, {
    key: "updateCurvePathMinMax",
    value: function updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
      var box = _Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3, minMax);
      if (minMax) {
        return;
      }
      this.updateRectMinMax(transform, box);
    }
  }, {
    key: "getPathBoundingBox",
    value: function getPathBoundingBox() {
      var pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PathType.FILL;
      var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var box = [this.minX, this.minY, this.maxX, this.maxY];
      if (pathType === PathType.STROKE) {
        if (!transform) {
          unreachable("Stroke bounding box must include transform.");
        }
        var scale = _Util.singularValueDecompose2dScale(transform);
        var xStrokePad = scale[0] * this.lineWidth / 2;
        var yStrokePad = scale[1] * this.lineWidth / 2;
        box[0] -= xStrokePad;
        box[1] -= yStrokePad;
        box[2] += xStrokePad;
        box[3] += yStrokePad;
      }
      return box;
    }
  }, {
    key: "updateClipFromPath",
    value: function updateClipFromPath() {
      var intersect = _Util.intersect(this.clipBox, this.getPathBoundingBox());
      this.startNewPathAndClipBox(intersect || [0, 0, 0, 0]);
    }
  }, {
    key: "isEmptyClip",
    value: function isEmptyClip() {
      return this.minX === Infinity;
    }
  }, {
    key: "startNewPathAndClipBox",
    value: function startNewPathAndClipBox(box) {
      this.clipBox = box;
      this.minX = Infinity;
      this.minY = Infinity;
      this.maxX = 0;
      this.maxY = 0;
    }
  }, {
    key: "getClippedPathBoundingBox",
    value: function getClippedPathBoundingBox() {
      var pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PathType.FILL;
      var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return _Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
    }
  }]);
}();
function putBinaryImageData(ctx, imgData) {
  if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
    ctx.putImageData(imgData, 0, 0);
    return;
  }
  var height = imgData.height,
    width = imgData.width;
  var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
  var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
  var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
  var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
  var srcPos = 0,
    destPos;
  var src = imgData.data;
  var dest = chunkImgData.data;
  var i, j, thisChunkHeight, elemsInThisChunk;
  if (imgData.kind === util_ImageKind.GRAYSCALE_1BPP) {
    var srcLength = src.byteLength;
    var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
    var dest32DataLength = dest32.length;
    var fullSrcDiff = width + 7 >> 3;
    var white = 0xffffffff;
    var black = util_FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
    for (i = 0; i < totalChunks; i++) {
      thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
      destPos = 0;
      for (j = 0; j < thisChunkHeight; j++) {
        var srcDiff = srcLength - srcPos;
        var k = 0;
        var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
        var kEndUnrolled = kEnd & ~7;
        var mask = 0;
        var srcByte = 0;
        for (; k < kEndUnrolled; k += 8) {
          srcByte = src[srcPos++];
          dest32[destPos++] = srcByte & 128 ? white : black;
          dest32[destPos++] = srcByte & 64 ? white : black;
          dest32[destPos++] = srcByte & 32 ? white : black;
          dest32[destPos++] = srcByte & 16 ? white : black;
          dest32[destPos++] = srcByte & 8 ? white : black;
          dest32[destPos++] = srcByte & 4 ? white : black;
          dest32[destPos++] = srcByte & 2 ? white : black;
          dest32[destPos++] = srcByte & 1 ? white : black;
        }
        for (; k < kEnd; k++) {
          if (mask === 0) {
            srcByte = src[srcPos++];
            mask = 128;
          }
          dest32[destPos++] = srcByte & mask ? white : black;
          mask >>= 1;
        }
      }
      while (destPos < dest32DataLength) {
        dest32[destPos++] = 0;
      }
      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  } else if (imgData.kind === util_ImageKind.RGBA_32BPP) {
    j = 0;
    elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
    for (i = 0; i < fullChunks; i++) {
      dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
      srcPos += elemsInThisChunk;
      ctx.putImageData(chunkImgData, 0, j);
      j += FULL_CHUNK_HEIGHT;
    }
    if (i < totalChunks) {
      elemsInThisChunk = width * partialChunkHeight * 4;
      dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
      ctx.putImageData(chunkImgData, 0, j);
    }
  } else if (imgData.kind === util_ImageKind.RGB_24BPP) {
    thisChunkHeight = FULL_CHUNK_HEIGHT;
    elemsInThisChunk = width * thisChunkHeight;
    for (i = 0; i < totalChunks; i++) {
      if (i >= fullChunks) {
        thisChunkHeight = partialChunkHeight;
        elemsInThisChunk = width * thisChunkHeight;
      }
      destPos = 0;
      for (j = elemsInThisChunk; j--;) {
        dest[destPos++] = src[srcPos++];
        dest[destPos++] = src[srcPos++];
        dest[destPos++] = src[srcPos++];
        dest[destPos++] = 255;
      }
      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  } else {
    throw new Error("bad image kind: ".concat(imgData.kind));
  }
}
function putBinaryImageMask(ctx, imgData) {
  if (imgData.bitmap) {
    ctx.drawImage(imgData.bitmap, 0, 0);
    return;
  }
  var height = imgData.height,
    width = imgData.width;
  var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
  var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
  var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
  var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
  var srcPos = 0;
  var src = imgData.data;
  var dest = chunkImgData.data;
  for (var i = 0; i < totalChunks; i++) {
    var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
    var _convertBlackAndWhite = convertBlackAndWhiteToRGBA({
      src: src,
      srcPos: srcPos,
      dest: dest,
      width: width,
      height: thisChunkHeight,
      nonBlackColor: 0
    });
    srcPos = _convertBlackAndWhite.srcPos;
    ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
  }
}
function copyCtxState(sourceCtx, destCtx) {
  var properties = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
  for (var _i16 = 0, _properties = properties; _i16 < _properties.length; _i16++) {
    var property = _properties[_i16];
    if (sourceCtx[property] !== undefined) {
      destCtx[property] = sourceCtx[property];
    }
  }
  if (sourceCtx.setLineDash !== undefined) {
    destCtx.setLineDash(sourceCtx.getLineDash());
    destCtx.lineDashOffset = sourceCtx.lineDashOffset;
  }
}
function resetCtxToDefault(ctx) {
  ctx.strokeStyle = ctx.fillStyle = "#000000";
  ctx.fillRule = "nonzero";
  ctx.globalAlpha = 1;
  ctx.lineWidth = 1;
  ctx.lineCap = "butt";
  ctx.lineJoin = "miter";
  ctx.miterLimit = 10;
  ctx.globalCompositeOperation = "source-over";
  ctx.font = "10px sans-serif";
  if (ctx.setLineDash !== undefined) {
    ctx.setLineDash([]);
    ctx.lineDashOffset = 0;
  }
  if (!isNodeJS) {
    var filter = ctx.filter;
    if (filter !== "none" && filter !== "") {
      ctx.filter = "none";
    }
  }
}
function getImageSmoothingEnabled(transform, interpolate) {
  if (interpolate) {
    return true;
  }
  var scale = _Util.singularValueDecompose2dScale(transform);
  scale[0] = Math.fround(scale[0]);
  scale[1] = Math.fround(scale[1]);
  var actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _PixelsPerInch.PDF_TO_CSS_UNITS);
  return scale[0] <= actualScale && scale[1] <= actualScale;
}
var LINE_CAP_STYLES = ["butt", "round", "square"];
var LINE_JOIN_STYLES = ["miter", "round", "bevel"];
var NORMAL_CLIP = {};
var EO_CLIP = {};
var _restoreInitialState = /*#__PURE__*/_classPrivateFieldLooseKey("restoreInitialState");
var _drawFilter = /*#__PURE__*/_classPrivateFieldLooseKey("drawFilter");
var CanvasGraphics = /*#__PURE__*/function () {
  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, _ref59, annotationCanvasMap, pageColors) {
    var optionalContentConfig = _ref59.optionalContentConfig,
      _ref59$markedContentS = _ref59.markedContentStack,
      markedContentStack = _ref59$markedContentS === void 0 ? null : _ref59$markedContentS;
    _classCallCheck(this, CanvasGraphics);
    Object.defineProperty(this, _drawFilter, {
      value: _drawFilter2
    });
    Object.defineProperty(this, _restoreInitialState, {
      value: _restoreInitialState2
    });
    this.ctx = canvasCtx;
    this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
    this.stateStack = [];
    this.pendingClip = null;
    this.pendingEOFill = false;
    this.res = null;
    this.xobjs = null;
    this.commonObjs = commonObjs;
    this.objs = objs;
    this.canvasFactory = canvasFactory;
    this.filterFactory = filterFactory;
    this.groupStack = [];
    this.processingType3 = null;
    this.baseTransform = null;
    this.baseTransformStack = [];
    this.groupLevel = 0;
    this.smaskStack = [];
    this.smaskCounter = 0;
    this.tempSMask = null;
    this.suspendedCtx = null;
    this.contentVisible = true;
    this.markedContentStack = markedContentStack || [];
    this.optionalContentConfig = optionalContentConfig;
    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
    this.cachedPatterns = new Map();
    this.annotationCanvasMap = annotationCanvasMap;
    this.viewportScale = 1;
    this.outputScaleX = 1;
    this.outputScaleY = 1;
    this.pageColors = pageColors;
    this._cachedScaleForStroking = [-1, 0];
    this._cachedGetSinglePixelWidth = null;
    this._cachedBitmapsMap = new Map();
  }
  return _createClass(CanvasGraphics, [{
    key: "getObject",
    value: function getObject(data) {
      var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (typeof data === "string") {
        return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
      }
      return fallback;
    }
  }, {
    key: "beginDrawing",
    value: function beginDrawing(_ref60) {
      var _this$ctx3;
      var transform = _ref60.transform,
        viewport = _ref60.viewport,
        _ref60$transparency = _ref60.transparency,
        transparency = _ref60$transparency === void 0 ? false : _ref60$transparency,
        _ref60$background = _ref60.background,
        background = _ref60$background === void 0 ? null : _ref60$background;
      var width = this.ctx.canvas.width;
      var height = this.ctx.canvas.height;
      var savedFillStyle = this.ctx.fillStyle;
      this.ctx.fillStyle = background || "#ffffff";
      this.ctx.fillRect(0, 0, width, height);
      this.ctx.fillStyle = savedFillStyle;
      if (transparency) {
        var _this$ctx;
        var transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
        this.compositeCtx = this.ctx;
        this.transparentCanvas = transparentCanvas.canvas;
        this.ctx = transparentCanvas.context;
        this.ctx.save();
        (_this$ctx = this.ctx).transform.apply(_this$ctx, _toConsumableArray(getCurrentTransform(this.compositeCtx)));
      }
      this.ctx.save();
      resetCtxToDefault(this.ctx);
      if (transform) {
        var _this$ctx2;
        (_this$ctx2 = this.ctx).transform.apply(_this$ctx2, _toConsumableArray(transform));
        this.outputScaleX = transform[0];
        this.outputScaleY = transform[0];
      }
      (_this$ctx3 = this.ctx).transform.apply(_this$ctx3, _toConsumableArray(viewport.transform));
      this.viewportScale = viewport.scale;
      this.baseTransform = getCurrentTransform(this.ctx);
    }
  }, {
    key: "executeOperatorList",
    value: function executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
      var argsArray = operatorList.argsArray;
      var fnArray = operatorList.fnArray;
      var i = executionStartIdx || 0;
      var argsArrayLen = argsArray.length;
      if (argsArrayLen === i) {
        return i;
      }
      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
      var steps = 0;
      var commonObjs = this.commonObjs;
      var objs = this.objs;
      var fnId;
      while (true) {
        if (stepper !== undefined && i === stepper.nextBreakPoint) {
          stepper.breakIt(i, continueCallback);
          return i;
        }
        fnId = fnArray[i];
        if (fnId !== _OPS.dependency) {
          this[fnId].apply(this, argsArray[i]);
        } else {
          var _iterator57 = _createForOfIteratorHelper(argsArray[i]),
            _step57;
          try {
            for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
              var depObjId = _step57.value;
              var objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
              if (!objsPool.has(depObjId)) {
                objsPool.get(depObjId, continueCallback);
                return i;
              }
            }
          } catch (err) {
            _iterator57.e(err);
          } finally {
            _iterator57.f();
          }
        }
        i++;
        if (i === argsArrayLen) {
          return i;
        }
        if (chunkOperations && ++steps > EXECUTION_STEPS) {
          if (Date.now() > endTime) {
            continueCallback();
            return i;
          }
          steps = 0;
        }
      }
    }
  }, {
    key: "endDrawing",
    value: function endDrawing() {
      _classPrivateFieldLooseBase(this, _restoreInitialState)[_restoreInitialState]();
      this.cachedCanvases.clear();
      this.cachedPatterns.clear();
      var _iterator58 = _createForOfIteratorHelper(this._cachedBitmapsMap.values()),
        _step58;
      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var cache = _step58.value;
          var _iterator59 = _createForOfIteratorHelper(cache.values()),
            _step59;
          try {
            for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
              var canvas = _step59.value;
              if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) {
                canvas.width = canvas.height = 0;
              }
            }
          } catch (err) {
            _iterator59.e(err);
          } finally {
            _iterator59.f();
          }
          cache.clear();
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }
      this._cachedBitmapsMap.clear();
      _classPrivateFieldLooseBase(this, _drawFilter)[_drawFilter]();
    }
  }, {
    key: "_scaleImage",
    value: function _scaleImage(img, inverseTransform) {
      var _img$width, _img$height;
      var width = (_img$width = img.width) !== null && _img$width !== void 0 ? _img$width : img.displayWidth;
      var height = (_img$height = img.height) !== null && _img$height !== void 0 ? _img$height : img.displayHeight;
      var widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
      var heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
      var paintWidth = width,
        paintHeight = height;
      var tmpCanvasId = "prescale1";
      var tmpCanvas, tmpCtx;
      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
        var newWidth = paintWidth,
          newHeight = paintHeight;
        if (widthScale > 2 && paintWidth > 1) {
          newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
          widthScale /= paintWidth / newWidth;
        }
        if (heightScale > 2 && paintHeight > 1) {
          newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
          heightScale /= paintHeight / newHeight;
        }
        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
        tmpCtx = tmpCanvas.context;
        tmpCtx.clearRect(0, 0, newWidth, newHeight);
        tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
        img = tmpCanvas.canvas;
        paintWidth = newWidth;
        paintHeight = newHeight;
        tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
      }
      return {
        img: img,
        paintWidth: paintWidth,
        paintHeight: paintHeight
      };
    }
  }, {
    key: "_createMaskCanvas",
    value: function _createMaskCanvas(img) {
      var ctx = this.ctx;
      var width = img.width,
        height = img.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var currentTransform = getCurrentTransform(ctx);
      var cache, cacheKey, scaled, maskCanvas;
      if ((img.bitmap || img.data) && img.count > 1) {
        var mainKey = img.bitmap || img.data.buffer;
        cacheKey = JSON.stringify(isPatternFill ? currentTransform : [currentTransform.slice(0, 4), fillColor]);
        cache = this._cachedBitmapsMap.get(mainKey);
        if (!cache) {
          cache = new Map();
          this._cachedBitmapsMap.set(mainKey, cache);
        }
        var cachedImage = cache.get(cacheKey);
        if (cachedImage && !isPatternFill) {
          var _offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
          var _offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
          return {
            canvas: cachedImage,
            offsetX: _offsetX,
            offsetY: _offsetY
          };
        }
        scaled = cachedImage;
      }
      if (!scaled) {
        maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
        putBinaryImageMask(maskCanvas.context, img);
      }
      var maskToCanvas = _Util.transform(currentTransform, [1 / width, 0, 0, -1 / height, 0, 0]);
      maskToCanvas = _Util.transform(maskToCanvas, [1, 0, 0, 1, 0, -height]);
      var _Util$getAxialAligned = _Util.getAxialAlignedBoundingBox([0, 0, width, height], maskToCanvas),
        _Util$getAxialAligned2 = _slicedToArray(_Util$getAxialAligned, 4),
        minX = _Util$getAxialAligned2[0],
        minY = _Util$getAxialAligned2[1],
        maxX = _Util$getAxialAligned2[2],
        maxY = _Util$getAxialAligned2[3];
      var drawnWidth = Math.round(maxX - minX) || 1;
      var drawnHeight = Math.round(maxY - minY) || 1;
      var fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
      var fillCtx = fillCanvas.context;
      var offsetX = minX;
      var offsetY = minY;
      fillCtx.translate(-offsetX, -offsetY);
      fillCtx.transform.apply(fillCtx, _toConsumableArray(maskToCanvas));
      if (!scaled) {
        scaled = this._scaleImage(maskCanvas.canvas, getCurrentTransformInverse(fillCtx));
        scaled = scaled.img;
        if (cache && isPatternFill) {
          cache.set(cacheKey, scaled);
        }
      }
      fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled(getCurrentTransform(fillCtx), img.interpolate);
      drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
      fillCtx.globalCompositeOperation = "source-in";
      var inverse = _Util.transform(getCurrentTransformInverse(fillCtx), [1, 0, 0, 1, -offsetX, -offsetY]);
      fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, PathType.FILL) : fillColor;
      fillCtx.fillRect(0, 0, width, height);
      if (cache && !isPatternFill) {
        this.cachedCanvases.delete("fillCanvas");
        cache.set(cacheKey, fillCanvas.canvas);
      }
      return {
        canvas: fillCanvas.canvas,
        offsetX: Math.round(offsetX),
        offsetY: Math.round(offsetY)
      };
    }
  }, {
    key: "setLineWidth",
    value: function setLineWidth(width) {
      if (width !== this.current.lineWidth) {
        this._cachedScaleForStroking[0] = -1;
      }
      this.current.lineWidth = width;
      this.ctx.lineWidth = width;
    }
  }, {
    key: "setLineCap",
    value: function setLineCap(style) {
      this.ctx.lineCap = LINE_CAP_STYLES[style];
    }
  }, {
    key: "setLineJoin",
    value: function setLineJoin(style) {
      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
    }
  }, {
    key: "setMiterLimit",
    value: function setMiterLimit(limit) {
      this.ctx.miterLimit = limit;
    }
  }, {
    key: "setDash",
    value: function setDash(dashArray, dashPhase) {
      var ctx = this.ctx;
      if (ctx.setLineDash !== undefined) {
        ctx.setLineDash(dashArray);
        ctx.lineDashOffset = dashPhase;
      }
    }
  }, {
    key: "setRenderingIntent",
    value: function setRenderingIntent(intent) {}
  }, {
    key: "setFlatness",
    value: function setFlatness(flatness) {}
  }, {
    key: "setGState",
    value: function setGState(states) {
      var _iterator60 = _createForOfIteratorHelper(states),
        _step60;
      try {
        for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
          var _ref61 = _step60.value;
          var _ref62 = _slicedToArray(_ref61, 2);
          var key = _ref62[0];
          var value = _ref62[1];
          switch (key) {
            case "LW":
              this.setLineWidth(value);
              break;
            case "LC":
              this.setLineCap(value);
              break;
            case "LJ":
              this.setLineJoin(value);
              break;
            case "ML":
              this.setMiterLimit(value);
              break;
            case "D":
              this.setDash(value[0], value[1]);
              break;
            case "RI":
              this.setRenderingIntent(value);
              break;
            case "FL":
              this.setFlatness(value);
              break;
            case "Font":
              this.setFont(value[0], value[1]);
              break;
            case "CA":
              this.current.strokeAlpha = value;
              break;
            case "ca":
              this.current.fillAlpha = value;
              this.ctx.globalAlpha = value;
              break;
            case "BM":
              this.ctx.globalCompositeOperation = value;
              break;
            case "SMask":
              this.current.activeSMask = value ? this.tempSMask : null;
              this.tempSMask = null;
              this.checkSMaskState();
              break;
            case "TR":
              this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
              break;
          }
        }
      } catch (err) {
        _iterator60.e(err);
      } finally {
        _iterator60.f();
      }
    }
  }, {
    key: "inSMaskMode",
    get: function get() {
      return !!this.suspendedCtx;
    }
  }, {
    key: "checkSMaskState",
    value: function checkSMaskState() {
      var inSMaskMode = this.inSMaskMode;
      if (this.current.activeSMask && !inSMaskMode) {
        this.beginSMaskMode();
      } else if (!this.current.activeSMask && inSMaskMode) {
        this.endSMaskMode();
      }
    }
  }, {
    key: "beginSMaskMode",
    value: function beginSMaskMode() {
      if (this.inSMaskMode) {
        throw new Error("beginSMaskMode called while already in smask mode");
      }
      var drawnWidth = this.ctx.canvas.width;
      var drawnHeight = this.ctx.canvas.height;
      var cacheId = "smaskGroupAt" + this.groupLevel;
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
      this.suspendedCtx = this.ctx;
      this.ctx = scratchCanvas.context;
      var ctx = this.ctx;
      ctx.setTransform.apply(ctx, _toConsumableArray(getCurrentTransform(this.suspendedCtx)));
      copyCtxState(this.suspendedCtx, ctx);
      mirrorContextOperations(ctx, this.suspendedCtx);
      this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
    }
  }, {
    key: "endSMaskMode",
    value: function endSMaskMode() {
      if (!this.inSMaskMode) {
        throw new Error("endSMaskMode called while not in smask mode");
      }
      this.ctx._removeMirroring();
      copyCtxState(this.ctx, this.suspendedCtx);
      this.ctx = this.suspendedCtx;
      this.suspendedCtx = null;
    }
  }, {
    key: "compose",
    value: function compose(dirtyBox) {
      if (!this.current.activeSMask) {
        return;
      }
      if (!dirtyBox) {
        dirtyBox = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
      } else {
        dirtyBox[0] = Math.floor(dirtyBox[0]);
        dirtyBox[1] = Math.floor(dirtyBox[1]);
        dirtyBox[2] = Math.ceil(dirtyBox[2]);
        dirtyBox[3] = Math.ceil(dirtyBox[3]);
      }
      var smask = this.current.activeSMask;
      var suspendedCtx = this.suspendedCtx;
      this.composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
      this.ctx.save();
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
      this.ctx.restore();
    }
  }, {
    key: "composeSMask",
    value: function composeSMask(ctx, smask, layerCtx, layerBox) {
      var layerOffsetX = layerBox[0];
      var layerOffsetY = layerBox[1];
      var layerWidth = layerBox[2] - layerOffsetX;
      var layerHeight = layerBox[3] - layerOffsetY;
      if (layerWidth === 0 || layerHeight === 0) {
        return;
      }
      this.genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
      ctx.save();
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = "source-over";
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(layerCtx.canvas, 0, 0);
      ctx.restore();
    }
  }, {
    key: "genericComposeSMask",
    value: function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
      var maskCanvas = maskCtx.canvas;
      var maskX = layerOffsetX - maskOffsetX;
      var maskY = layerOffsetY - maskOffsetY;
      if (backdrop) {
        var backdropRGB = _Util.makeHexColor.apply(_Util, _toConsumableArray(backdrop));
        if (maskX < 0 || maskY < 0 || maskX + width > maskCanvas.width || maskY + height > maskCanvas.height) {
          var canvas = this.cachedCanvases.getCanvas("maskExtension", width, height);
          var ctx = canvas.context;
          ctx.drawImage(maskCanvas, -maskX, -maskY);
          ctx.globalCompositeOperation = "destination-atop";
          ctx.fillStyle = backdropRGB;
          ctx.fillRect(0, 0, width, height);
          ctx.globalCompositeOperation = "source-over";
          maskCanvas = canvas.canvas;
          maskX = maskY = 0;
        } else {
          maskCtx.save();
          maskCtx.globalAlpha = 1;
          maskCtx.setTransform(1, 0, 0, 1, 0, 0);
          var _clip = new Path2D();
          _clip.rect(maskX, maskY, width, height);
          maskCtx.clip(_clip);
          maskCtx.globalCompositeOperation = "destination-atop";
          maskCtx.fillStyle = backdropRGB;
          maskCtx.fillRect(maskX, maskY, width, height);
          maskCtx.restore();
        }
      }
      layerCtx.save();
      layerCtx.globalAlpha = 1;
      layerCtx.setTransform(1, 0, 0, 1, 0, 0);
      if (subtype === "Alpha" && transferMap) {
        layerCtx.filter = this.filterFactory.addAlphaFilter(transferMap);
      } else if (subtype === "Luminosity") {
        layerCtx.filter = this.filterFactory.addLuminosityFilter(transferMap);
      }
      var clip = new Path2D();
      clip.rect(layerOffsetX, layerOffsetY, width, height);
      layerCtx.clip(clip);
      layerCtx.globalCompositeOperation = "destination-in";
      layerCtx.drawImage(maskCanvas, maskX, maskY, width, height, layerOffsetX, layerOffsetY, width, height);
      layerCtx.restore();
    }
  }, {
    key: "save",
    value: function save() {
      if (this.inSMaskMode) {
        copyCtxState(this.ctx, this.suspendedCtx);
        this.suspendedCtx.save();
      } else {
        this.ctx.save();
      }
      var old = this.current;
      this.stateStack.push(old);
      this.current = old.clone();
    }
  }, {
    key: "restore",
    value: function restore() {
      if (this.stateStack.length === 0 && this.inSMaskMode) {
        this.endSMaskMode();
      }
      if (this.stateStack.length !== 0) {
        this.current = this.stateStack.pop();
        if (this.inSMaskMode) {
          this.suspendedCtx.restore();
          copyCtxState(this.suspendedCtx, this.ctx);
        } else {
          this.ctx.restore();
        }
        this.checkSMaskState();
        this.pendingClip = null;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
      }
    }
  }, {
    key: "transform",
    value: function transform(a, b, c, d, e, f) {
      this.ctx.transform(a, b, c, d, e, f);
      this._cachedScaleForStroking[0] = -1;
      this._cachedGetSinglePixelWidth = null;
    }
  }, {
    key: "constructPath",
    value: function constructPath(ops, args, minMax) {
      var ctx = this.ctx;
      var current = this.current;
      var x = current.x,
        y = current.y;
      var startX, startY;
      var currentTransform = getCurrentTransform(ctx);
      var isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
      var minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
        switch (ops[i] | 0) {
          case _OPS.rectangle:
            x = args[j++];
            y = args[j++];
            var width = args[j++];
            var height = args[j++];
            var xw = x + width;
            var yh = y + height;
            ctx.moveTo(x, y);
            if (width === 0 || height === 0) {
              ctx.lineTo(xw, yh);
            } else {
              ctx.lineTo(xw, y);
              ctx.lineTo(xw, yh);
              ctx.lineTo(x, yh);
            }
            if (!isScalingMatrix) {
              current.updateRectMinMax(currentTransform, [x, y, xw, yh]);
            }
            ctx.closePath();
            break;
          case _OPS.moveTo:
            x = args[j++];
            y = args[j++];
            ctx.moveTo(x, y);
            if (!isScalingMatrix) {
              current.updatePathMinMax(currentTransform, x, y);
            }
            break;
          case _OPS.lineTo:
            x = args[j++];
            y = args[j++];
            ctx.lineTo(x, y);
            if (!isScalingMatrix) {
              current.updatePathMinMax(currentTransform, x, y);
            }
            break;
          case _OPS.curveTo:
            startX = x;
            startY = y;
            x = args[j + 4];
            y = args[j + 5];
            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
            current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
            j += 6;
            break;
          case _OPS.curveTo2:
            startX = x;
            startY = y;
            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
            current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
            x = args[j + 2];
            y = args[j + 3];
            j += 4;
            break;
          case _OPS.curveTo3:
            startX = x;
            startY = y;
            x = args[j + 2];
            y = args[j + 3];
            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
            current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
            j += 4;
            break;
          case _OPS.closePath:
            ctx.closePath();
            break;
        }
      }
      if (isScalingMatrix) {
        current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
      }
      current.setCurrentPoint(x, y);
    }
  }, {
    key: "closePath",
    value: function closePath() {
      this.ctx.closePath();
    }
  }, {
    key: "stroke",
    value: function stroke() {
      var consumePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var ctx = this.ctx;
      var strokeColor = this.current.strokeColor;
      ctx.globalAlpha = this.current.strokeAlpha;
      if (this.contentVisible) {
        if (_typeof(strokeColor) === "object" && strokeColor !== null && strokeColor !== void 0 && strokeColor.getPattern) {
          ctx.save();
          ctx.strokeStyle = strokeColor.getPattern(ctx, this, getCurrentTransformInverse(ctx), PathType.STROKE);
          this.rescaleAndStroke(false);
          ctx.restore();
        } else {
          this.rescaleAndStroke(true);
        }
      }
      if (consumePath) {
        this.consumePath(this.current.getClippedPathBoundingBox());
      }
      ctx.globalAlpha = this.current.fillAlpha;
    }
  }, {
    key: "closeStroke",
    value: function closeStroke() {
      this.closePath();
      this.stroke();
    }
  }, {
    key: "fill",
    value: function fill() {
      var consumePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var needRestore = false;
      if (isPatternFill) {
        ctx.save();
        ctx.fillStyle = fillColor.getPattern(ctx, this, getCurrentTransformInverse(ctx), PathType.FILL);
        needRestore = true;
      }
      var intersect = this.current.getClippedPathBoundingBox();
      if (this.contentVisible && intersect !== null) {
        if (this.pendingEOFill) {
          ctx.fill("evenodd");
          this.pendingEOFill = false;
        } else {
          ctx.fill();
        }
      }
      if (needRestore) {
        ctx.restore();
      }
      if (consumePath) {
        this.consumePath(intersect);
      }
    }
  }, {
    key: "eoFill",
    value: function eoFill() {
      this.pendingEOFill = true;
      this.fill();
    }
  }, {
    key: "fillStroke",
    value: function fillStroke() {
      this.fill(false);
      this.stroke(false);
      this.consumePath();
    }
  }, {
    key: "eoFillStroke",
    value: function eoFillStroke() {
      this.pendingEOFill = true;
      this.fillStroke();
    }
  }, {
    key: "closeFillStroke",
    value: function closeFillStroke() {
      this.closePath();
      this.fillStroke();
    }
  }, {
    key: "closeEOFillStroke",
    value: function closeEOFillStroke() {
      this.pendingEOFill = true;
      this.closePath();
      this.fillStroke();
    }
  }, {
    key: "endPath",
    value: function endPath() {
      this.consumePath();
    }
  }, {
    key: "clip",
    value: function clip() {
      this.pendingClip = NORMAL_CLIP;
    }
  }, {
    key: "eoClip",
    value: function eoClip() {
      this.pendingClip = EO_CLIP;
    }
  }, {
    key: "beginText",
    value: function beginText() {
      this.current.textMatrix = IDENTITY_MATRIX;
      this.current.textMatrixScale = 1;
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    }
  }, {
    key: "endText",
    value: function endText() {
      var paths = this.pendingTextPaths;
      var ctx = this.ctx;
      if (paths === undefined) {
        ctx.beginPath();
        return;
      }
      ctx.save();
      ctx.beginPath();
      var _iterator61 = _createForOfIteratorHelper(paths),
        _step61;
      try {
        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
          var path = _step61.value;
          ctx.setTransform.apply(ctx, _toConsumableArray(path.transform));
          ctx.translate(path.x, path.y);
          path.addToPath(ctx, path.fontSize);
        }
      } catch (err) {
        _iterator61.e(err);
      } finally {
        _iterator61.f();
      }
      ctx.restore();
      ctx.clip();
      ctx.beginPath();
      delete this.pendingTextPaths;
    }
  }, {
    key: "setCharSpacing",
    value: function setCharSpacing(spacing) {
      this.current.charSpacing = spacing;
    }
  }, {
    key: "setWordSpacing",
    value: function setWordSpacing(spacing) {
      this.current.wordSpacing = spacing;
    }
  }, {
    key: "setHScale",
    value: function setHScale(scale) {
      this.current.textHScale = scale / 100;
    }
  }, {
    key: "setLeading",
    value: function setLeading(leading) {
      this.current.leading = -leading;
    }
  }, {
    key: "setFont",
    value: function setFont(fontRefName, size) {
      var _fontObj$systemFontIn;
      var fontObj = this.commonObjs.get(fontRefName);
      var current = this.current;
      if (!fontObj) {
        throw new Error("Can't find font for ".concat(fontRefName));
      }
      current.fontMatrix = fontObj.fontMatrix || FONT_IDENTITY_MATRIX;
      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
        warn("Invalid font matrix for font " + fontRefName);
      }
      if (size < 0) {
        size = -size;
        current.fontDirection = -1;
      } else {
        current.fontDirection = 1;
      }
      this.current.font = fontObj;
      this.current.fontSize = size;
      if (fontObj.isType3Font) {
        return;
      }
      var name = fontObj.loadedName || "sans-serif";
      var typeface = ((_fontObj$systemFontIn = fontObj.systemFontInfo) === null || _fontObj$systemFontIn === void 0 ? void 0 : _fontObj$systemFontIn.css) || "\"".concat(name, "\", ").concat(fontObj.fallbackName);
      var bold = "normal";
      if (fontObj.black) {
        bold = "900";
      } else if (fontObj.bold) {
        bold = "bold";
      }
      var italic = fontObj.italic ? "italic" : "normal";
      var browserFontSize = size;
      if (size < MIN_FONT_SIZE) {
        browserFontSize = MIN_FONT_SIZE;
      } else if (size > MAX_FONT_SIZE) {
        browserFontSize = MAX_FONT_SIZE;
      }
      this.current.fontSizeScale = size / browserFontSize;
      this.ctx.font = "".concat(italic, " ").concat(bold, " ").concat(browserFontSize, "px ").concat(typeface);
    }
  }, {
    key: "setTextRenderingMode",
    value: function setTextRenderingMode(mode) {
      this.current.textRenderingMode = mode;
    }
  }, {
    key: "setTextRise",
    value: function setTextRise(rise) {
      this.current.textRise = rise;
    }
  }, {
    key: "moveText",
    value: function moveText(x, y) {
      this.current.x = this.current.lineX += x;
      this.current.y = this.current.lineY += y;
    }
  }, {
    key: "setLeadingMoveText",
    value: function setLeadingMoveText(x, y) {
      this.setLeading(-y);
      this.moveText(x, y);
    }
  }, {
    key: "setTextMatrix",
    value: function setTextMatrix(a, b, c, d, e, f) {
      this.current.textMatrix = [a, b, c, d, e, f];
      this.current.textMatrixScale = Math.hypot(a, b);
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    }
  }, {
    key: "nextLine",
    value: function nextLine() {
      this.moveText(0, this.current.leading);
    }
  }, {
    key: "paintChar",
    value: function paintChar(character, x, y, patternTransform) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var textRenderingMode = current.textRenderingMode;
      var fontSize = current.fontSize / current.fontSizeScale;
      var fillStrokeMode = textRenderingMode & TextRenderingMode.FILL_STROKE_MASK;
      var isAddToPathSet = !!(textRenderingMode & TextRenderingMode.ADD_TO_PATH_FLAG);
      var patternFill = current.patternFill && !font.missingFile;
      var addToPath;
      if (font.disableFontFace || isAddToPathSet || patternFill) {
        addToPath = font.getPathGenerator(this.commonObjs, character);
      }
      if (font.disableFontFace || patternFill) {
        ctx.save();
        ctx.translate(x, y);
        ctx.beginPath();
        addToPath(ctx, fontSize);
        if (patternTransform) {
          ctx.setTransform.apply(ctx, _toConsumableArray(patternTransform));
        }
        if (fillStrokeMode === TextRenderingMode.FILL || fillStrokeMode === TextRenderingMode.FILL_STROKE) {
          ctx.fill();
        }
        if (fillStrokeMode === TextRenderingMode.STROKE || fillStrokeMode === TextRenderingMode.FILL_STROKE) {
          ctx.stroke();
        }
        ctx.restore();
      } else {
        if (fillStrokeMode === TextRenderingMode.FILL || fillStrokeMode === TextRenderingMode.FILL_STROKE) {
          ctx.fillText(character, x, y);
        }
        if (fillStrokeMode === TextRenderingMode.STROKE || fillStrokeMode === TextRenderingMode.FILL_STROKE) {
          ctx.strokeText(character, x, y);
        }
      }
      if (isAddToPathSet) {
        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
        paths.push({
          transform: getCurrentTransform(ctx),
          x: x,
          y: y,
          fontSize: fontSize,
          addToPath: addToPath
        });
      }
    }
  }, {
    key: "isFontSubpixelAAEnabled",
    get: function get() {
      var _this$cachedCanvases$ = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10),
        ctx = _this$cachedCanvases$.context;
      ctx.scale(1.5, 1);
      ctx.fillText("I", 0, 10);
      var data = ctx.getImageData(0, 0, 10, 10).data;
      var enabled = false;
      for (var i = 3; i < data.length; i += 4) {
        if (data[i] > 0 && data[i] < 255) {
          enabled = true;
          break;
        }
      }
      return _shadow(this, "isFontSubpixelAAEnabled", enabled);
    }
  }, {
    key: "showText",
    value: function showText(glyphs) {
      var current = this.current;
      var font = current.font;
      if (font.isType3Font) {
        return this.showType3Text(glyphs);
      }
      var fontSize = current.fontSize;
      if (fontSize === 0) {
        return undefined;
      }
      var ctx = this.ctx;
      var fontSizeScale = current.fontSizeScale;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var fontDirection = current.fontDirection;
      var textHScale = current.textHScale * fontDirection;
      var glyphsLength = glyphs.length;
      var vertical = font.vertical;
      var spacingDir = vertical ? 1 : -1;
      var defaultVMetrics = font.defaultVMetrics;
      var widthAdvanceScale = fontSize * current.fontMatrix[0];
      var simpleFillText = current.textRenderingMode === TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
      ctx.save();
      ctx.transform.apply(ctx, _toConsumableArray(current.textMatrix));
      ctx.translate(current.x, current.y + current.textRise);
      if (fontDirection > 0) {
        ctx.scale(textHScale, -1);
      } else {
        ctx.scale(textHScale, 1);
      }
      var patternTransform;
      if (current.patternFill) {
        ctx.save();
        var pattern = current.fillColor.getPattern(ctx, this, getCurrentTransformInverse(ctx), PathType.FILL);
        patternTransform = getCurrentTransform(ctx);
        ctx.restore();
        ctx.fillStyle = pattern;
      }
      var lineWidth = current.lineWidth;
      var scale = current.textMatrixScale;
      if (scale === 0 || lineWidth === 0) {
        var fillStrokeMode = current.textRenderingMode & TextRenderingMode.FILL_STROKE_MASK;
        if (fillStrokeMode === TextRenderingMode.STROKE || fillStrokeMode === TextRenderingMode.FILL_STROKE) {
          lineWidth = this.getSinglePixelWidth();
        }
      } else {
        lineWidth /= scale;
      }
      if (fontSizeScale !== 1.0) {
        ctx.scale(fontSizeScale, fontSizeScale);
        lineWidth /= fontSizeScale;
      }
      ctx.lineWidth = lineWidth;
      if (font.isInvalidPDFjsFont) {
        var chars = [];
        var width = 0;
        var _iterator62 = _createForOfIteratorHelper(glyphs),
          _step62;
        try {
          for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
            var glyph = _step62.value;
            chars.push(glyph.unicode);
            width += glyph.width;
          }
        } catch (err) {
          _iterator62.e(err);
        } finally {
          _iterator62.f();
        }
        ctx.fillText(chars.join(""), 0, 0);
        current.x += width * widthAdvanceScale * textHScale;
        ctx.restore();
        this.compose();
        return undefined;
      }
      var x = 0,
        i;
      for (i = 0; i < glyphsLength; ++i) {
        var _glyph = glyphs[i];
        if (typeof _glyph === "number") {
          x += spacingDir * _glyph * fontSize / 1000;
          continue;
        }
        var restoreNeeded = false;
        var spacing = (_glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var character = _glyph.fontChar;
        var accent = _glyph.accent;
        var scaledX = void 0,
          scaledY = void 0;
        var _width2 = _glyph.width;
        if (vertical) {
          var vmetric = _glyph.vmetric || defaultVMetrics;
          var vx = -(_glyph.vmetric ? vmetric[1] : _width2 * 0.5) * widthAdvanceScale;
          var vy = vmetric[2] * widthAdvanceScale;
          _width2 = vmetric ? -vmetric[0] : _width2;
          scaledX = vx / fontSizeScale;
          scaledY = (x + vy) / fontSizeScale;
        } else {
          scaledX = x / fontSizeScale;
          scaledY = 0;
        }
        if (font.remeasure && _width2 > 0) {
          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
          if (_width2 < measuredWidth && this.isFontSubpixelAAEnabled) {
            var characterScaleX = _width2 / measuredWidth;
            restoreNeeded = true;
            ctx.save();
            ctx.scale(characterScaleX, 1);
            scaledX /= characterScaleX;
          } else if (_width2 !== measuredWidth) {
            scaledX += (_width2 - measuredWidth) / 2000 * fontSize / fontSizeScale;
          }
        }
        if (this.contentVisible && (_glyph.isInFont || font.missingFile)) {
          if (simpleFillText && !accent) {
            ctx.fillText(character, scaledX, scaledY);
          } else {
            this.paintChar(character, scaledX, scaledY, patternTransform);
            if (accent) {
              var scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
              var scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
            }
          }
        }
        var charWidth = vertical ? _width2 * widthAdvanceScale - spacing * fontDirection : _width2 * widthAdvanceScale + spacing * fontDirection;
        x += charWidth;
        if (restoreNeeded) {
          ctx.restore();
        }
      }
      if (vertical) {
        current.y -= x;
      } else {
        current.x += x * textHScale;
      }
      ctx.restore();
      this.compose();
      return undefined;
    }
  }, {
    key: "showType3Text",
    value: function showType3Text(glyphs) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var fontSize = current.fontSize;
      var fontDirection = current.fontDirection;
      var spacingDir = font.vertical ? 1 : -1;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var textHScale = current.textHScale * fontDirection;
      var fontMatrix = current.fontMatrix || FONT_IDENTITY_MATRIX;
      var glyphsLength = glyphs.length;
      var isTextInvisible = current.textRenderingMode === TextRenderingMode.INVISIBLE;
      var i, glyph, width, spacingLength;
      if (isTextInvisible || fontSize === 0) {
        return;
      }
      this._cachedScaleForStroking[0] = -1;
      this._cachedGetSinglePixelWidth = null;
      ctx.save();
      ctx.transform.apply(ctx, _toConsumableArray(current.textMatrix));
      ctx.translate(current.x, current.y);
      ctx.scale(textHScale, fontDirection);
      for (i = 0; i < glyphsLength; ++i) {
        glyph = glyphs[i];
        if (typeof glyph === "number") {
          spacingLength = spacingDir * glyph * fontSize / 1000;
          this.ctx.translate(spacingLength, 0);
          current.x += spacingLength * textHScale;
          continue;
        }
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var operatorList = font.charProcOperatorList[glyph.operatorListId];
        if (!operatorList) {
          warn("Type3 character \"".concat(glyph.operatorListId, "\" is not available."));
          continue;
        }
        if (this.contentVisible) {
          this.processingType3 = glyph;
          this.save();
          ctx.scale(fontSize, fontSize);
          ctx.transform.apply(ctx, _toConsumableArray(fontMatrix));
          this.executeOperatorList(operatorList);
          this.restore();
        }
        var transformed = _Util.applyTransform([glyph.width, 0], fontMatrix);
        width = transformed[0] * fontSize + spacing;
        ctx.translate(width, 0);
        current.x += width * textHScale;
      }
      ctx.restore();
      this.processingType3 = null;
    }
  }, {
    key: "setCharWidth",
    value: function setCharWidth(xWidth, yWidth) {}
  }, {
    key: "setCharWidthAndBounds",
    value: function setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
      this.ctx.rect(llx, lly, urx - llx, ury - lly);
      this.ctx.clip();
      this.endPath();
    }
  }, {
    key: "getColorN_Pattern",
    value: function getColorN_Pattern(IR) {
      var _this24 = this;
      var pattern;
      if (IR[0] === "TilingPattern") {
        var color = IR[1];
        var baseTransform = this.baseTransform || getCurrentTransform(this.ctx);
        var canvasGraphicsFactory = {
          createCanvasGraphics: function createCanvasGraphics(ctx) {
            return new CanvasGraphics(ctx, _this24.commonObjs, _this24.objs, _this24.canvasFactory, _this24.filterFactory, {
              optionalContentConfig: _this24.optionalContentConfig,
              markedContentStack: _this24.markedContentStack
            });
          }
        };
        pattern = new TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
      } else {
        pattern = this._getPattern(IR[1], IR[2]);
      }
      return pattern;
    }
  }, {
    key: "setStrokeColorN",
    value: function setStrokeColorN() {
      this.current.strokeColor = this.getColorN_Pattern(arguments);
    }
  }, {
    key: "setFillColorN",
    value: function setFillColorN() {
      this.current.fillColor = this.getColorN_Pattern(arguments);
      this.current.patternFill = true;
    }
  }, {
    key: "setStrokeRGBColor",
    value: function setStrokeRGBColor(r, g, b) {
      this.ctx.strokeStyle = this.current.strokeColor = _Util.makeHexColor(r, g, b);
    }
  }, {
    key: "setStrokeTransparent",
    value: function setStrokeTransparent() {
      this.ctx.strokeStyle = this.current.strokeColor = "transparent";
    }
  }, {
    key: "setFillRGBColor",
    value: function setFillRGBColor(r, g, b) {
      this.ctx.fillStyle = this.current.fillColor = _Util.makeHexColor(r, g, b);
      this.current.patternFill = false;
    }
  }, {
    key: "setFillTransparent",
    value: function setFillTransparent() {
      this.ctx.fillStyle = this.current.fillColor = "transparent";
      this.current.patternFill = false;
    }
  }, {
    key: "_getPattern",
    value: function _getPattern(objId) {
      var matrix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var pattern;
      if (this.cachedPatterns.has(objId)) {
        pattern = this.cachedPatterns.get(objId);
      } else {
        pattern = getShadingPattern(this.getObject(objId));
        this.cachedPatterns.set(objId, pattern);
      }
      if (matrix) {
        pattern.matrix = matrix;
      }
      return pattern;
    }
  }, {
    key: "shadingFill",
    value: function shadingFill(objId) {
      if (!this.contentVisible) {
        return;
      }
      var ctx = this.ctx;
      this.save();
      var pattern = this._getPattern(objId);
      ctx.fillStyle = pattern.getPattern(ctx, this, getCurrentTransformInverse(ctx), PathType.SHADING);
      var inv = getCurrentTransformInverse(ctx);
      if (inv) {
        var _ctx$canvas = ctx.canvas,
          width = _ctx$canvas.width,
          height = _ctx$canvas.height;
        var _Util$getAxialAligned3 = _Util.getAxialAlignedBoundingBox([0, 0, width, height], inv),
          _Util$getAxialAligned4 = _slicedToArray(_Util$getAxialAligned3, 4),
          x0 = _Util$getAxialAligned4[0],
          y0 = _Util$getAxialAligned4[1],
          x1 = _Util$getAxialAligned4[2],
          y1 = _Util$getAxialAligned4[3];
        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
      } else {
        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
      }
      this.compose(this.current.getClippedPathBoundingBox());
      this.restore();
    }
  }, {
    key: "beginInlineImage",
    value: function beginInlineImage() {
      unreachable("Should not call beginInlineImage");
    }
  }, {
    key: "beginImageData",
    value: function beginImageData() {
      unreachable("Should not call beginImageData");
    }
  }, {
    key: "paintFormXObjectBegin",
    value: function paintFormXObjectBegin(matrix, bbox) {
      if (!this.contentVisible) {
        return;
      }
      this.save();
      this.baseTransformStack.push(this.baseTransform);
      if (matrix) {
        this.transform.apply(this, _toConsumableArray(matrix));
      }
      this.baseTransform = getCurrentTransform(this.ctx);
      if (bbox) {
        var width = bbox[2] - bbox[0];
        var height = bbox[3] - bbox[1];
        this.ctx.rect(bbox[0], bbox[1], width, height);
        this.current.updateRectMinMax(getCurrentTransform(this.ctx), bbox);
        this.clip();
        this.endPath();
      }
    }
  }, {
    key: "paintFormXObjectEnd",
    value: function paintFormXObjectEnd() {
      if (!this.contentVisible) {
        return;
      }
      this.restore();
      this.baseTransform = this.baseTransformStack.pop();
    }
  }, {
    key: "beginGroup",
    value: function beginGroup(group) {
      if (!this.contentVisible) {
        return;
      }
      this.save();
      if (this.inSMaskMode) {
        this.endSMaskMode();
        this.current.activeSMask = null;
      }
      var currentCtx = this.ctx;
      if (!group.isolated) {
        info("TODO: Support non-isolated groups.");
      }
      if (group.knockout) {
        warn("Knockout groups not supported.");
      }
      var currentTransform = getCurrentTransform(currentCtx);
      if (group.matrix) {
        currentCtx.transform.apply(currentCtx, _toConsumableArray(group.matrix));
      }
      if (!group.bbox) {
        throw new Error("Bounding box is required.");
      }
      var bounds = _Util.getAxialAlignedBoundingBox(group.bbox, getCurrentTransform(currentCtx));
      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
      bounds = _Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
      var offsetX = Math.floor(bounds[0]);
      var offsetY = Math.floor(bounds[1]);
      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
      this.current.startNewPathAndClipBox([0, 0, drawnWidth, drawnHeight]);
      var cacheId = "groupAt" + this.groupLevel;
      if (group.smask) {
        cacheId += "_smask_" + this.smaskCounter++ % 2;
      }
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
      var groupCtx = scratchCanvas.context;
      groupCtx.translate(-offsetX, -offsetY);
      groupCtx.transform.apply(groupCtx, _toConsumableArray(currentTransform));
      if (group.smask) {
        this.smaskStack.push({
          canvas: scratchCanvas.canvas,
          context: groupCtx,
          offsetX: offsetX,
          offsetY: offsetY,
          subtype: group.smask.subtype,
          backdrop: group.smask.backdrop,
          transferMap: group.smask.transferMap || null,
          startTransformInverse: null
        });
      } else {
        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
        currentCtx.translate(offsetX, offsetY);
        currentCtx.save();
      }
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    }
  }, {
    key: "endGroup",
    value: function endGroup(group) {
      if (!this.contentVisible) {
        return;
      }
      this.groupLevel--;
      var groupCtx = this.ctx;
      var ctx = this.groupStack.pop();
      this.ctx = ctx;
      this.ctx.imageSmoothingEnabled = false;
      if (group.smask) {
        this.tempSMask = this.smaskStack.pop();
        this.restore();
      } else {
        var _this$ctx4;
        this.ctx.restore();
        var currentMtx = getCurrentTransform(this.ctx);
        this.restore();
        this.ctx.save();
        (_this$ctx4 = this.ctx).setTransform.apply(_this$ctx4, _toConsumableArray(currentMtx));
        var dirtyBox = _Util.getAxialAlignedBoundingBox([0, 0, groupCtx.canvas.width, groupCtx.canvas.height], currentMtx);
        this.ctx.drawImage(groupCtx.canvas, 0, 0);
        this.ctx.restore();
        this.compose(dirtyBox);
      }
    }
  }, {
    key: "beginAnnotation",
    value: function beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
      _classPrivateFieldLooseBase(this, _restoreInitialState)[_restoreInitialState]();
      resetCtxToDefault(this.ctx);
      this.ctx.save();
      this.save();
      if (this.baseTransform) {
        var _this$ctx5;
        (_this$ctx5 = this.ctx).setTransform.apply(_this$ctx5, _toConsumableArray(this.baseTransform));
      }
      if (rect) {
        var width = rect[2] - rect[0];
        var height = rect[3] - rect[1];
        if (hasOwnCanvas && this.annotationCanvasMap) {
          transform = transform.slice();
          transform[4] -= rect[0];
          transform[5] -= rect[1];
          rect = rect.slice();
          rect[0] = rect[1] = 0;
          rect[2] = width;
          rect[3] = height;
          var _Util$singularValueDe = _Util.singularValueDecompose2dScale(getCurrentTransform(this.ctx)),
            _Util$singularValueDe2 = _slicedToArray(_Util$singularValueDe, 2),
            scaleX = _Util$singularValueDe2[0],
            scaleY = _Util$singularValueDe2[1];
          var viewportScale = this.viewportScale;
          var canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
          var canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
          this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
          var _this$annotationCanva = this.annotationCanvas,
            canvas = _this$annotationCanva.canvas,
            context = _this$annotationCanva.context;
          this.annotationCanvasMap.set(id, canvas);
          this.annotationCanvas.savedCtx = this.ctx;
          this.ctx = context;
          this.ctx.save();
          this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
          resetCtxToDefault(this.ctx);
        } else {
          resetCtxToDefault(this.ctx);
          this.endPath();
          this.ctx.rect(rect[0], rect[1], width, height);
          this.ctx.clip();
          this.ctx.beginPath();
        }
      }
      this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
      this.transform.apply(this, _toConsumableArray(transform));
      this.transform.apply(this, _toConsumableArray(matrix));
    }
  }, {
    key: "endAnnotation",
    value: function endAnnotation() {
      if (this.annotationCanvas) {
        this.ctx.restore();
        _classPrivateFieldLooseBase(this, _drawFilter)[_drawFilter]();
        this.ctx = this.annotationCanvas.savedCtx;
        delete this.annotationCanvas.savedCtx;
        delete this.annotationCanvas;
      }
    }
  }, {
    key: "paintImageMaskXObject",
    value: function paintImageMaskXObject(img) {
      if (!this.contentVisible) {
        return;
      }
      var count = img.count;
      img = this.getObject(img.data, img);
      img.count = count;
      var ctx = this.ctx;
      var glyph = this.processingType3;
      if (glyph) {
        if (glyph.compiled === undefined) {
          glyph.compiled = compileType3Glyph(img);
        }
        if (glyph.compiled) {
          glyph.compiled(ctx);
          return;
        }
      }
      var mask = this._createMaskCanvas(img);
      var maskCanvas = mask.canvas;
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
      ctx.restore();
      this.compose();
    }
  }, {
    key: "paintImageMaskXObjectRepeat",
    value: function paintImageMaskXObjectRepeat(img, scaleX) {
      var skewX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var skewY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var scaleY = arguments.length > 4 ? arguments[4] : undefined;
      var positions = arguments.length > 5 ? arguments[5] : undefined;
      if (!this.contentVisible) {
        return;
      }
      img = this.getObject(img.data, img);
      var ctx = this.ctx;
      ctx.save();
      var currentTransform = getCurrentTransform(ctx);
      ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
      var mask = this._createMaskCanvas(img);
      ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        var trans = _Util.transform(currentTransform, [scaleX, skewX, skewY, scaleY, positions[i], positions[i + 1]]);
        var _Util$applyTransform3 = _Util.applyTransform([0, 0], trans),
          _Util$applyTransform4 = _slicedToArray(_Util$applyTransform3, 2),
          x = _Util$applyTransform4[0],
          y = _Util$applyTransform4[1];
        ctx.drawImage(mask.canvas, x, y);
      }
      ctx.restore();
      this.compose();
    }
  }, {
    key: "paintImageMaskXObjectGroup",
    value: function paintImageMaskXObjectGroup(images) {
      if (!this.contentVisible) {
        return;
      }
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var _iterator63 = _createForOfIteratorHelper(images),
        _step63;
      try {
        for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
          var image = _step63.value;
          var data = image.data,
            width = image.width,
            height = image.height,
            transform = image.transform;
          var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
          var maskCtx = maskCanvas.context;
          maskCtx.save();
          var img = this.getObject(data, image);
          putBinaryImageMask(maskCtx, img);
          maskCtx.globalCompositeOperation = "source-in";
          maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, getCurrentTransformInverse(ctx), PathType.FILL) : fillColor;
          maskCtx.fillRect(0, 0, width, height);
          maskCtx.restore();
          ctx.save();
          ctx.transform.apply(ctx, _toConsumableArray(transform));
          ctx.scale(1, -1);
          drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
          ctx.restore();
        }
      } catch (err) {
        _iterator63.e(err);
      } finally {
        _iterator63.f();
      }
      this.compose();
    }
  }, {
    key: "paintImageXObject",
    value: function paintImageXObject(objId) {
      if (!this.contentVisible) {
        return;
      }
      var imgData = this.getObject(objId);
      if (!imgData) {
        warn("Dependent image isn't ready yet");
        return;
      }
      this.paintInlineImageXObject(imgData);
    }
  }, {
    key: "paintImageXObjectRepeat",
    value: function paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
      if (!this.contentVisible) {
        return;
      }
      var imgData = this.getObject(objId);
      if (!imgData) {
        warn("Dependent image isn't ready yet");
        return;
      }
      var width = imgData.width;
      var height = imgData.height;
      var map = [];
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        map.push({
          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
          x: 0,
          y: 0,
          w: width,
          h: height
        });
      }
      this.paintInlineImageXObjectGroup(imgData, map);
    }
  }, {
    key: "applyTransferMapsToCanvas",
    value: function applyTransferMapsToCanvas(ctx) {
      if (this.current.transferMaps !== "none") {
        ctx.filter = this.current.transferMaps;
        ctx.drawImage(ctx.canvas, 0, 0);
        ctx.filter = "none";
      }
      return ctx.canvas;
    }
  }, {
    key: "applyTransferMapsToBitmap",
    value: function applyTransferMapsToBitmap(imgData) {
      if (this.current.transferMaps === "none") {
        return imgData.bitmap;
      }
      var bitmap = imgData.bitmap,
        width = imgData.width,
        height = imgData.height;
      var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
      var tmpCtx = tmpCanvas.context;
      tmpCtx.filter = this.current.transferMaps;
      tmpCtx.drawImage(bitmap, 0, 0);
      tmpCtx.filter = "none";
      return tmpCanvas.canvas;
    }
  }, {
    key: "paintInlineImageXObject",
    value: function paintInlineImageXObject(imgData) {
      if (!this.contentVisible) {
        return;
      }
      var width = imgData.width;
      var height = imgData.height;
      var ctx = this.ctx;
      this.save();
      if (!isNodeJS) {
        var filter = ctx.filter;
        if (filter !== "none" && filter !== "") {
          ctx.filter = "none";
        }
      }
      ctx.scale(1 / width, -1 / height);
      var imgToPaint;
      if (imgData.bitmap) {
        imgToPaint = this.applyTransferMapsToBitmap(imgData);
      } else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) {
        imgToPaint = imgData;
      } else {
        var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
        var tmpCtx = tmpCanvas.context;
        putBinaryImageData(tmpCtx, imgData);
        imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
      }
      var scaled = this._scaleImage(imgToPaint, getCurrentTransformInverse(ctx));
      ctx.imageSmoothingEnabled = getImageSmoothingEnabled(getCurrentTransform(ctx), imgData.interpolate);
      drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
      this.compose();
      this.restore();
    }
  }, {
    key: "paintInlineImageXObjectGroup",
    value: function paintInlineImageXObjectGroup(imgData, map) {
      if (!this.contentVisible) {
        return;
      }
      var ctx = this.ctx;
      var imgToPaint;
      if (imgData.bitmap) {
        imgToPaint = imgData.bitmap;
      } else {
        var w = imgData.width;
        var h = imgData.height;
        var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
        var tmpCtx = tmpCanvas.context;
        putBinaryImageData(tmpCtx, imgData);
        imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
      }
      var _iterator64 = _createForOfIteratorHelper(map),
        _step64;
      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var entry = _step64.value;
          ctx.save();
          ctx.transform.apply(ctx, _toConsumableArray(entry.transform));
          ctx.scale(1, -1);
          drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
          ctx.restore();
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
      this.compose();
    }
  }, {
    key: "paintSolidColorImageMask",
    value: function paintSolidColorImageMask() {
      if (!this.contentVisible) {
        return;
      }
      this.ctx.fillRect(0, 0, 1, 1);
      this.compose();
    }
  }, {
    key: "markPoint",
    value: function markPoint(tag) {}
  }, {
    key: "markPointProps",
    value: function markPointProps(tag, properties) {}
  }, {
    key: "beginMarkedContent",
    value: function beginMarkedContent(tag) {
      this.markedContentStack.push({
        visible: true
      });
    }
  }, {
    key: "beginMarkedContentProps",
    value: function beginMarkedContentProps(tag, properties) {
      if (tag === "OC") {
        this.markedContentStack.push({
          visible: this.optionalContentConfig.isVisible(properties)
        });
      } else {
        this.markedContentStack.push({
          visible: true
        });
      }
      this.contentVisible = this.isContentVisible();
    }
  }, {
    key: "endMarkedContent",
    value: function endMarkedContent() {
      this.markedContentStack.pop();
      this.contentVisible = this.isContentVisible();
    }
  }, {
    key: "beginCompat",
    value: function beginCompat() {}
  }, {
    key: "endCompat",
    value: function endCompat() {}
  }, {
    key: "consumePath",
    value: function consumePath(clipBox) {
      var isEmpty = this.current.isEmptyClip();
      if (this.pendingClip) {
        this.current.updateClipFromPath();
      }
      if (!this.pendingClip) {
        this.compose(clipBox);
      }
      var ctx = this.ctx;
      if (this.pendingClip) {
        if (!isEmpty) {
          if (this.pendingClip === EO_CLIP) {
            ctx.clip("evenodd");
          } else {
            ctx.clip();
          }
        }
        this.pendingClip = null;
      }
      this.current.startNewPathAndClipBox(this.current.clipBox);
      ctx.beginPath();
    }
  }, {
    key: "getSinglePixelWidth",
    value: function getSinglePixelWidth() {
      if (!this._cachedGetSinglePixelWidth) {
        var m = getCurrentTransform(this.ctx);
        if (m[1] === 0 && m[2] === 0) {
          this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
        } else {
          var absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
          var normX = Math.hypot(m[0], m[2]);
          var normY = Math.hypot(m[1], m[3]);
          this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
        }
      }
      return this._cachedGetSinglePixelWidth;
    }
  }, {
    key: "getScaleForStroking",
    value: function getScaleForStroking() {
      if (this._cachedScaleForStroking[0] === -1) {
        var lineWidth = this.current.lineWidth;
        var _this$ctx$getTransfor = this.ctx.getTransform(),
          a = _this$ctx$getTransfor.a,
          b = _this$ctx$getTransfor.b,
          c = _this$ctx$getTransfor.c,
          d = _this$ctx$getTransfor.d;
        var scaleX, scaleY;
        if (b === 0 && c === 0) {
          var normX = Math.abs(a);
          var normY = Math.abs(d);
          if (normX === normY) {
            if (lineWidth === 0) {
              scaleX = scaleY = 1 / normX;
            } else {
              var scaledLineWidth = normX * lineWidth;
              scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
            }
          } else if (lineWidth === 0) {
            scaleX = 1 / normX;
            scaleY = 1 / normY;
          } else {
            var scaledXLineWidth = normX * lineWidth;
            var scaledYLineWidth = normY * lineWidth;
            scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
            scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
          }
        } else {
          var absDet = Math.abs(a * d - b * c);
          var _normX = Math.hypot(a, b);
          var _normY = Math.hypot(c, d);
          if (lineWidth === 0) {
            scaleX = _normY / absDet;
            scaleY = _normX / absDet;
          } else {
            var baseArea = lineWidth * absDet;
            scaleX = _normY > baseArea ? _normY / baseArea : 1;
            scaleY = _normX > baseArea ? _normX / baseArea : 1;
          }
        }
        this._cachedScaleForStroking[0] = scaleX;
        this._cachedScaleForStroking[1] = scaleY;
      }
      return this._cachedScaleForStroking;
    }
  }, {
    key: "rescaleAndStroke",
    value: function rescaleAndStroke(saveRestore) {
      var ctx = this.ctx;
      var lineWidth = this.current.lineWidth;
      var _this$getScaleForStro = this.getScaleForStroking(),
        _this$getScaleForStro2 = _slicedToArray(_this$getScaleForStro, 2),
        scaleX = _this$getScaleForStro2[0],
        scaleY = _this$getScaleForStro2[1];
      ctx.lineWidth = lineWidth || 1;
      if (scaleX === 1 && scaleY === 1) {
        ctx.stroke();
        return;
      }
      var dashes = ctx.getLineDash();
      if (saveRestore) {
        ctx.save();
      }
      ctx.scale(scaleX, scaleY);
      if (dashes.length > 0) {
        var scale = Math.max(scaleX, scaleY);
        ctx.setLineDash(dashes.map(function (x) {
          return x / scale;
        }));
        ctx.lineDashOffset /= scale;
      }
      ctx.stroke();
      if (saveRestore) {
        ctx.restore();
      }
    }
  }, {
    key: "isContentVisible",
    value: function isContentVisible() {
      for (var i = this.markedContentStack.length - 1; i >= 0; i--) {
        if (!this.markedContentStack[i].visible) {
          return false;
        }
      }
      return true;
    }
  }]);
}();
function _restoreInitialState2() {
  while (this.stateStack.length || this.inSMaskMode) {
    this.restore();
  }
  this.current.activeSMask = null;
  this.ctx.restore();
  if (this.transparentCanvas) {
    this.ctx = this.compositeCtx;
    this.ctx.save();
    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
    this.ctx.drawImage(this.transparentCanvas, 0, 0);
    this.ctx.restore();
    this.transparentCanvas = null;
  }
}
function _drawFilter2() {
  if (this.pageColors) {
    var hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
    if (hcmFilterId !== "none") {
      var savedFilter = this.ctx.filter;
      this.ctx.filter = hcmFilterId;
      this.ctx.drawImage(this.ctx.canvas, 0, 0);
      this.ctx.filter = savedFilter;
    }
  }
}
for (var op in _OPS) {
  if (CanvasGraphics.prototype[op] !== undefined) {
    CanvasGraphics.prototype[_OPS[op]] = CanvasGraphics.prototype[op];
  }
}
; // ./src/display/worker_options.js
var _port = /*#__PURE__*/_classPrivateFieldLooseKey("port");
var _src = /*#__PURE__*/_classPrivateFieldLooseKey("src");
var _GlobalWorkerOptions = /*#__PURE__*/function () {
  function _GlobalWorkerOptions() {
    _classCallCheck(this, _GlobalWorkerOptions);
  }
  return _createClass(_GlobalWorkerOptions, null, [{
    key: "workerPort",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _port)[_port];
    },
    set: function set(val) {
      if (!(typeof Worker !== "undefined" && val instanceof Worker) && val !== null) {
        throw new Error("Invalid `workerPort` type.");
      }
      _classPrivateFieldLooseBase(this, _port)[_port] = val;
    }
  }, {
    key: "workerSrc",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _src)[_src];
    },
    set: function set(val) {
      if (typeof val !== "string") {
        throw new Error("Invalid `workerSrc` type.");
      }
      _classPrivateFieldLooseBase(this, _src)[_src] = val;
    }
  }]);
}();
Object.defineProperty(_GlobalWorkerOptions, _port, {
  writable: true,
  value: null
});
Object.defineProperty(_GlobalWorkerOptions, _src, {
  writable: true,
  value: ""
});
; // ./src/shared/message_handler.js

var CallbackKind = {
  UNKNOWN: 0,
  DATA: 1,
  ERROR: 2
};
var StreamKind = {
  UNKNOWN: 0,
  CANCEL: 1,
  CANCEL_COMPLETE: 2,
  CLOSE: 3,
  ENQUEUE: 4,
  ERROR: 5,
  PULL: 6,
  PULL_COMPLETE: 7,
  START_COMPLETE: 8
};
function wrapReason(reason) {
  if (!(reason instanceof Error || _typeof(reason) === "object" && reason !== null)) {
    unreachable('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
  }
  switch (reason.name) {
    case "AbortException":
      return new _AbortException(reason.message);
    case "MissingPDFException":
      return new _MissingPDFException(reason.message);
    case "PasswordException":
      return new PasswordException(reason.message, reason.code);
    case "UnexpectedResponseException":
      return new _UnexpectedResponseException(reason.message, reason.status);
    case "UnknownErrorException":
      return new UnknownErrorException(reason.message, reason.details);
    default:
      return new UnknownErrorException(reason.message, reason.toString());
  }
}
var _messageAC = /*#__PURE__*/_classPrivateFieldLooseKey("messageAC");
var _onMessage = /*#__PURE__*/_classPrivateFieldLooseKey("onMessage");
var _createStreamSink = /*#__PURE__*/_classPrivateFieldLooseKey("createStreamSink");
var _processStreamMessage = /*#__PURE__*/_classPrivateFieldLooseKey("processStreamMessage");
var _deleteStreamController = /*#__PURE__*/_classPrivateFieldLooseKey("deleteStreamController");
var MessageHandler = /*#__PURE__*/function () {
  function MessageHandler(_sourceName, _targetName, _comObj) {
    _classCallCheck(this, MessageHandler);
    Object.defineProperty(this, _deleteStreamController, {
      value: _deleteStreamController2
    });
    Object.defineProperty(this, _processStreamMessage, {
      value: _processStreamMessage2
    });
    Object.defineProperty(this, _createStreamSink, {
      value: _createStreamSink2
    });
    Object.defineProperty(this, _onMessage, {
      value: _onMessage2
    });
    Object.defineProperty(this, _messageAC, {
      writable: true,
      value: new AbortController()
    });
    this.sourceName = _sourceName;
    this.targetName = _targetName;
    this.comObj = _comObj;
    this.callbackId = 1;
    this.streamId = 1;
    this.streamSinks = Object.create(null);
    this.streamControllers = Object.create(null);
    this.callbackCapabilities = Object.create(null);
    this.actionHandler = Object.create(null);
    _comObj.addEventListener("message", _classPrivateFieldLooseBase(this, _onMessage)[_onMessage].bind(this), {
      signal: _classPrivateFieldLooseBase(this, _messageAC)[_messageAC].signal
    });
  }
  return _createClass(MessageHandler, [{
    key: "on",
    value: function on(actionName, handler) {
      var ah = this.actionHandler;
      if (ah[actionName]) {
        throw new Error("There is already an actionName called \"".concat(actionName, "\""));
      }
      ah[actionName] = handler;
    }
  }, {
    key: "send",
    value: function send(actionName, data, transfers) {
      this.comObj.postMessage({
        sourceName: this.sourceName,
        targetName: this.targetName,
        action: actionName,
        data: data
      }, transfers);
    }
  }, {
    key: "sendWithPromise",
    value: function sendWithPromise(actionName, data, transfers) {
      var callbackId = this.callbackId++;
      var capability = Promise.withResolvers();
      this.callbackCapabilities[callbackId] = capability;
      try {
        this.comObj.postMessage({
          sourceName: this.sourceName,
          targetName: this.targetName,
          action: actionName,
          callbackId: callbackId,
          data: data
        }, transfers);
      } catch (ex) {
        capability.reject(ex);
      }
      return capability.promise;
    }
  }, {
    key: "sendWithStream",
    value: function sendWithStream(actionName, data, queueingStrategy, transfers) {
      var _this25 = this;
      var streamId = this.streamId++,
        sourceName = this.sourceName,
        targetName = this.targetName,
        comObj = this.comObj;
      return new ReadableStream({
        start: function start(controller) {
          var startCapability = Promise.withResolvers();
          _this25.streamControllers[streamId] = {
            controller: controller,
            startCall: startCapability,
            pullCall: null,
            cancelCall: null,
            isClosed: false
          };
          comObj.postMessage({
            sourceName: sourceName,
            targetName: targetName,
            action: actionName,
            streamId: streamId,
            data: data,
            desiredSize: controller.desiredSize
          }, transfers);
          return startCapability.promise;
        },
        pull: function pull(controller) {
          var pullCapability = Promise.withResolvers();
          _this25.streamControllers[streamId].pullCall = pullCapability;
          comObj.postMessage({
            sourceName: sourceName,
            targetName: targetName,
            stream: StreamKind.PULL,
            streamId: streamId,
            desiredSize: controller.desiredSize
          });
          return pullCapability.promise;
        },
        cancel: function cancel(reason) {
          assert(reason instanceof Error, "cancel must have a valid reason");
          var cancelCapability = Promise.withResolvers();
          _this25.streamControllers[streamId].cancelCall = cancelCapability;
          _this25.streamControllers[streamId].isClosed = true;
          comObj.postMessage({
            sourceName: sourceName,
            targetName: targetName,
            stream: StreamKind.CANCEL,
            streamId: streamId,
            reason: wrapReason(reason)
          });
          return cancelCapability.promise;
        }
      }, queueingStrategy);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _classPrivateFieldLoo57;
      (_classPrivateFieldLoo57 = _classPrivateFieldLooseBase(this, _messageAC)[_messageAC]) === null || _classPrivateFieldLoo57 === void 0 || _classPrivateFieldLoo57.abort();
      _classPrivateFieldLooseBase(this, _messageAC)[_messageAC] = null;
    }
  }]);
}();
function _onMessage2(_ref170) {
  var data = _ref170.data;
  if (data.targetName !== this.sourceName) {
    return;
  }
  if (data.stream) {
    _classPrivateFieldLooseBase(this, _processStreamMessage)[_processStreamMessage](data);
    return;
  }
  if (data.callback) {
    var callbackId = data.callbackId;
    var capability = this.callbackCapabilities[callbackId];
    if (!capability) {
      throw new Error("Cannot resolve callback ".concat(callbackId));
    }
    delete this.callbackCapabilities[callbackId];
    if (data.callback === CallbackKind.DATA) {
      capability.resolve(data.data);
    } else if (data.callback === CallbackKind.ERROR) {
      capability.reject(wrapReason(data.reason));
    } else {
      throw new Error("Unexpected callback case");
    }
    return;
  }
  var action = this.actionHandler[data.action];
  if (!action) {
    throw new Error("Unknown action from worker: ".concat(data.action));
  }
  if (data.callbackId) {
    var sourceName = this.sourceName,
      targetName = data.sourceName,
      comObj = this.comObj;
    new Promise(function (resolve) {
      resolve(action(data.data));
    }).then(function (result) {
      comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        callback: CallbackKind.DATA,
        callbackId: data.callbackId,
        data: result
      });
    }, function (reason) {
      comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        callback: CallbackKind.ERROR,
        callbackId: data.callbackId,
        reason: wrapReason(reason)
      });
    });
    return;
  }
  if (data.streamId) {
    _classPrivateFieldLooseBase(this, _createStreamSink)[_createStreamSink](data);
    return;
  }
  action(data.data);
}
function _createStreamSink2(data) {
  var streamId = data.streamId,
    sourceName = this.sourceName,
    targetName = data.sourceName,
    comObj = this.comObj;
  var self = this,
    action = this.actionHandler[data.action];
  var streamSink = {
    enqueue: function enqueue(chunk) {
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var transfers = arguments.length > 2 ? arguments[2] : undefined;
      if (this.isCancelled) {
        return;
      }
      var lastDesiredSize = this.desiredSize;
      this.desiredSize -= size;
      if (lastDesiredSize > 0 && this.desiredSize <= 0) {
        this.sinkCapability = Promise.withResolvers();
        this.ready = this.sinkCapability.promise;
      }
      comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: StreamKind.ENQUEUE,
        streamId: streamId,
        chunk: chunk
      }, transfers);
    },
    close: function close() {
      if (this.isCancelled) {
        return;
      }
      this.isCancelled = true;
      comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: StreamKind.CLOSE,
        streamId: streamId
      });
      delete self.streamSinks[streamId];
    },
    error: function error(reason) {
      assert(reason instanceof Error, "error must have a valid reason");
      if (this.isCancelled) {
        return;
      }
      this.isCancelled = true;
      comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: StreamKind.ERROR,
        streamId: streamId,
        reason: wrapReason(reason)
      });
    },
    sinkCapability: Promise.withResolvers(),
    onPull: null,
    onCancel: null,
    isCancelled: false,
    desiredSize: data.desiredSize,
    ready: null
  };
  streamSink.sinkCapability.resolve();
  streamSink.ready = streamSink.sinkCapability.promise;
  this.streamSinks[streamId] = streamSink;
  new Promise(function (resolve) {
    resolve(action(data.data, streamSink));
  }).then(function () {
    comObj.postMessage({
      sourceName: sourceName,
      targetName: targetName,
      stream: StreamKind.START_COMPLETE,
      streamId: streamId,
      success: true
    });
  }, function (reason) {
    comObj.postMessage({
      sourceName: sourceName,
      targetName: targetName,
      stream: StreamKind.START_COMPLETE,
      streamId: streamId,
      reason: wrapReason(reason)
    });
  });
}
function _processStreamMessage2(data) {
  var streamId = data.streamId,
    sourceName = this.sourceName,
    targetName = data.sourceName,
    comObj = this.comObj;
  var streamController = this.streamControllers[streamId],
    streamSink = this.streamSinks[streamId];
  switch (data.stream) {
    case StreamKind.START_COMPLETE:
      if (data.success) {
        streamController.startCall.resolve();
      } else {
        streamController.startCall.reject(wrapReason(data.reason));
      }
      break;
    case StreamKind.PULL_COMPLETE:
      if (data.success) {
        streamController.pullCall.resolve();
      } else {
        streamController.pullCall.reject(wrapReason(data.reason));
      }
      break;
    case StreamKind.PULL:
      if (!streamSink) {
        comObj.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: StreamKind.PULL_COMPLETE,
          streamId: streamId,
          success: true
        });
        break;
      }
      if (streamSink.desiredSize <= 0 && data.desiredSize > 0) {
        streamSink.sinkCapability.resolve();
      }
      streamSink.desiredSize = data.desiredSize;
      new Promise(function (resolve) {
        var _streamSink$onPull;
        resolve((_streamSink$onPull = streamSink.onPull) === null || _streamSink$onPull === void 0 ? void 0 : _streamSink$onPull.call(streamSink));
      }).then(function () {
        comObj.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: StreamKind.PULL_COMPLETE,
          streamId: streamId,
          success: true
        });
      }, function (reason) {
        comObj.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: StreamKind.PULL_COMPLETE,
          streamId: streamId,
          reason: wrapReason(reason)
        });
      });
      break;
    case StreamKind.ENQUEUE:
      assert(streamController, "enqueue should have stream controller");
      if (streamController.isClosed) {
        break;
      }
      streamController.controller.enqueue(data.chunk);
      break;
    case StreamKind.CLOSE:
      assert(streamController, "close should have stream controller");
      if (streamController.isClosed) {
        break;
      }
      streamController.isClosed = true;
      streamController.controller.close();
      _classPrivateFieldLooseBase(this, _deleteStreamController)[_deleteStreamController](streamController, streamId);
      break;
    case StreamKind.ERROR:
      assert(streamController, "error should have stream controller");
      streamController.controller.error(wrapReason(data.reason));
      _classPrivateFieldLooseBase(this, _deleteStreamController)[_deleteStreamController](streamController, streamId);
      break;
    case StreamKind.CANCEL_COMPLETE:
      if (data.success) {
        streamController.cancelCall.resolve();
      } else {
        streamController.cancelCall.reject(wrapReason(data.reason));
      }
      _classPrivateFieldLooseBase(this, _deleteStreamController)[_deleteStreamController](streamController, streamId);
      break;
    case StreamKind.CANCEL:
      if (!streamSink) {
        break;
      }
      new Promise(function (resolve) {
        var _streamSink$onCancel;
        resolve((_streamSink$onCancel = streamSink.onCancel) === null || _streamSink$onCancel === void 0 ? void 0 : _streamSink$onCancel.call(streamSink, wrapReason(data.reason)));
      }).then(function () {
        comObj.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: StreamKind.CANCEL_COMPLETE,
          streamId: streamId,
          success: true
        });
      }, function (reason) {
        comObj.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: StreamKind.CANCEL_COMPLETE,
          streamId: streamId,
          reason: wrapReason(reason)
        });
      });
      streamSink.sinkCapability.reject(wrapReason(data.reason));
      streamSink.isCancelled = true;
      delete this.streamSinks[streamId];
      break;
    default:
      throw new Error("Unexpected stream case");
  }
}
function _deleteStreamController2(_x49, _x50) {
  return _deleteStreamController3.apply(this, arguments);
}
function _deleteStreamController3() {
  _deleteStreamController3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee57(streamController, streamId) {
    var _streamController$sta, _streamController$pul, _streamController$can;
    return _regeneratorRuntime().wrap(function _callee57$(_context58) {
      while (1) switch (_context58.prev = _context58.next) {
        case 0:
          _context58.next = 2;
          return Promise.allSettled([(_streamController$sta = streamController.startCall) === null || _streamController$sta === void 0 ? void 0 : _streamController$sta.promise, (_streamController$pul = streamController.pullCall) === null || _streamController$pul === void 0 ? void 0 : _streamController$pul.promise, (_streamController$can = streamController.cancelCall) === null || _streamController$can === void 0 ? void 0 : _streamController$can.promise]);
        case 2:
          delete this.streamControllers[streamId];
        case 3:
        case "end":
          return _context58.stop();
      }
    }, _callee57, this);
  }));
  return _deleteStreamController3.apply(this, arguments);
}
; // ./src/display/metadata.js
var _metadataMap = /*#__PURE__*/_classPrivateFieldLooseKey("metadataMap");
var _data2 = /*#__PURE__*/_classPrivateFieldLooseKey("data");
var Metadata = /*#__PURE__*/function () {
  function Metadata(_ref63) {
    var parsedData = _ref63.parsedData,
      rawData = _ref63.rawData;
    _classCallCheck(this, Metadata);
    Object.defineProperty(this, _metadataMap, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _data2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _metadataMap)[_metadataMap] = parsedData;
    _classPrivateFieldLooseBase(this, _data2)[_data2] = rawData;
  }
  return _createClass(Metadata, [{
    key: "getRaw",
    value: function getRaw() {
      return _classPrivateFieldLooseBase(this, _data2)[_data2];
    }
  }, {
    key: "get",
    value: function get(name) {
      var _classPrivateFieldLoo58;
      return (_classPrivateFieldLoo58 = _classPrivateFieldLooseBase(this, _metadataMap)[_metadataMap].get(name)) !== null && _classPrivateFieldLoo58 !== void 0 ? _classPrivateFieldLoo58 : null;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return objectFromMap(_classPrivateFieldLooseBase(this, _metadataMap)[_metadataMap]);
    }
  }, {
    key: "has",
    value: function has(name) {
      return _classPrivateFieldLooseBase(this, _metadataMap)[_metadataMap].has(name);
    }
  }]);
}();
; // ./src/display/optional_content_config.js

var INTERNAL = Symbol("INTERNAL");
var _isDisplay = /*#__PURE__*/_classPrivateFieldLooseKey("isDisplay");
var _isPrint = /*#__PURE__*/_classPrivateFieldLooseKey("isPrint");
var _userSet = /*#__PURE__*/_classPrivateFieldLooseKey("userSet");
var _visible = /*#__PURE__*/_classPrivateFieldLooseKey("visible");
var OptionalContentGroup = /*#__PURE__*/function () {
  function OptionalContentGroup(renderingIntent, _ref64) {
    var name = _ref64.name,
      intent = _ref64.intent,
      usage = _ref64.usage,
      rbGroups = _ref64.rbGroups;
    _classCallCheck(this, OptionalContentGroup);
    Object.defineProperty(this, _isDisplay, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _isPrint, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _userSet, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _visible, {
      writable: true,
      value: true
    });
    _classPrivateFieldLooseBase(this, _isDisplay)[_isDisplay] = !!(renderingIntent & RenderingIntentFlag.DISPLAY);
    _classPrivateFieldLooseBase(this, _isPrint)[_isPrint] = !!(renderingIntent & RenderingIntentFlag.PRINT);
    this.name = name;
    this.intent = intent;
    this.usage = usage;
    this.rbGroups = rbGroups;
  }
  return _createClass(OptionalContentGroup, [{
    key: "visible",
    get: function get() {
      if (_classPrivateFieldLooseBase(this, _userSet)[_userSet]) {
        return _classPrivateFieldLooseBase(this, _visible)[_visible];
      }
      if (!_classPrivateFieldLooseBase(this, _visible)[_visible]) {
        return false;
      }
      var _this$usage = this.usage,
        print = _this$usage.print,
        view = _this$usage.view;
      if (_classPrivateFieldLooseBase(this, _isDisplay)[_isDisplay]) {
        return (view === null || view === void 0 ? void 0 : view.viewState) !== "OFF";
      } else if (_classPrivateFieldLooseBase(this, _isPrint)[_isPrint]) {
        return (print === null || print === void 0 ? void 0 : print.printState) !== "OFF";
      }
      return true;
    }
  }, {
    key: "_setVisible",
    value: function _setVisible(internal, visible) {
      var userSet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (internal !== INTERNAL) {
        unreachable("Internal method `_setVisible` called.");
      }
      _classPrivateFieldLooseBase(this, _userSet)[_userSet] = userSet;
      _classPrivateFieldLooseBase(this, _visible)[_visible] = visible;
    }
  }]);
}();
var _cachedGetHash = /*#__PURE__*/_classPrivateFieldLooseKey("cachedGetHash");
var _groups = /*#__PURE__*/_classPrivateFieldLooseKey("groups");
var _initialHash = /*#__PURE__*/_classPrivateFieldLooseKey("initialHash");
var _order = /*#__PURE__*/_classPrivateFieldLooseKey("order");
var _evaluateVisibilityExpression = /*#__PURE__*/_classPrivateFieldLooseKey("evaluateVisibilityExpression");
var OptionalContentConfig = /*#__PURE__*/function () {
  function OptionalContentConfig(data) {
    var renderingIntent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : RenderingIntentFlag.DISPLAY;
    _classCallCheck(this, OptionalContentConfig);
    Object.defineProperty(this, _evaluateVisibilityExpression, {
      value: _evaluateVisibilityExpression2
    });
    Object.defineProperty(this, _cachedGetHash, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _groups, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _initialHash, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _order, {
      writable: true,
      value: null
    });
    this.renderingIntent = renderingIntent;
    this.name = null;
    this.creator = null;
    if (data === null) {
      return;
    }
    this.name = data.name;
    this.creator = data.creator;
    _classPrivateFieldLooseBase(this, _order)[_order] = data.order;
    var _iterator65 = _createForOfIteratorHelper(data.groups),
      _step65;
    try {
      for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
        var _group = _step65.value;
        _classPrivateFieldLooseBase(this, _groups)[_groups].set(_group.id, new OptionalContentGroup(renderingIntent, _group));
      }
    } catch (err) {
      _iterator65.e(err);
    } finally {
      _iterator65.f();
    }
    if (data.baseState === "OFF") {
      var _iterator66 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _groups)[_groups].values()),
        _step66;
      try {
        for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
          var group = _step66.value;
          group._setVisible(INTERNAL, false);
        }
      } catch (err) {
        _iterator66.e(err);
      } finally {
        _iterator66.f();
      }
    }
    var _iterator67 = _createForOfIteratorHelper(data.on),
      _step67;
    try {
      for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
        var on = _step67.value;
        _classPrivateFieldLooseBase(this, _groups)[_groups].get(on)._setVisible(INTERNAL, true);
      }
    } catch (err) {
      _iterator67.e(err);
    } finally {
      _iterator67.f();
    }
    var _iterator68 = _createForOfIteratorHelper(data.off),
      _step68;
    try {
      for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
        var off = _step68.value;
        _classPrivateFieldLooseBase(this, _groups)[_groups].get(off)._setVisible(INTERNAL, false);
      }
    } catch (err) {
      _iterator68.e(err);
    } finally {
      _iterator68.f();
    }
    _classPrivateFieldLooseBase(this, _initialHash)[_initialHash] = this.getHash();
  }
  return _createClass(OptionalContentConfig, [{
    key: "isVisible",
    value: function isVisible(group) {
      if (_classPrivateFieldLooseBase(this, _groups)[_groups].size === 0) {
        return true;
      }
      if (!group) {
        info("Optional content group not defined.");
        return true;
      }
      if (group.type === "OCG") {
        if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(group.id)) {
          warn("Optional content group not found: ".concat(group.id));
          return true;
        }
        return _classPrivateFieldLooseBase(this, _groups)[_groups].get(group.id).visible;
      } else if (group.type === "OCMD") {
        if (group.expression) {
          return _classPrivateFieldLooseBase(this, _evaluateVisibilityExpression)[_evaluateVisibilityExpression](group.expression);
        }
        if (!group.policy || group.policy === "AnyOn") {
          var _iterator69 = _createForOfIteratorHelper(group.ids),
            _step69;
          try {
            for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
              var _id5 = _step69.value;
              if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(_id5)) {
                warn("Optional content group not found: ".concat(_id5));
                return true;
              }
              if (_classPrivateFieldLooseBase(this, _groups)[_groups].get(_id5).visible) {
                return true;
              }
            }
          } catch (err) {
            _iterator69.e(err);
          } finally {
            _iterator69.f();
          }
          return false;
        } else if (group.policy === "AllOn") {
          var _iterator70 = _createForOfIteratorHelper(group.ids),
            _step70;
          try {
            for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
              var _id6 = _step70.value;
              if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(_id6)) {
                warn("Optional content group not found: ".concat(_id6));
                return true;
              }
              if (!_classPrivateFieldLooseBase(this, _groups)[_groups].get(_id6).visible) {
                return false;
              }
            }
          } catch (err) {
            _iterator70.e(err);
          } finally {
            _iterator70.f();
          }
          return true;
        } else if (group.policy === "AnyOff") {
          var _iterator71 = _createForOfIteratorHelper(group.ids),
            _step71;
          try {
            for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
              var _id7 = _step71.value;
              if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(_id7)) {
                warn("Optional content group not found: ".concat(_id7));
                return true;
              }
              if (!_classPrivateFieldLooseBase(this, _groups)[_groups].get(_id7).visible) {
                return true;
              }
            }
          } catch (err) {
            _iterator71.e(err);
          } finally {
            _iterator71.f();
          }
          return false;
        } else if (group.policy === "AllOff") {
          var _iterator72 = _createForOfIteratorHelper(group.ids),
            _step72;
          try {
            for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
              var _id8 = _step72.value;
              if (!_classPrivateFieldLooseBase(this, _groups)[_groups].has(_id8)) {
                warn("Optional content group not found: ".concat(_id8));
                return true;
              }
              if (_classPrivateFieldLooseBase(this, _groups)[_groups].get(_id8).visible) {
                return false;
              }
            }
          } catch (err) {
            _iterator72.e(err);
          } finally {
            _iterator72.f();
          }
          return true;
        }
        warn("Unknown optional content policy ".concat(group.policy, "."));
        return true;
      }
      warn("Unknown group type ".concat(group.type, "."));
      return true;
    }
  }, {
    key: "setVisibility",
    value: function setVisibility(id) {
      var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var preserveRB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var group = _classPrivateFieldLooseBase(this, _groups)[_groups].get(id);
      if (!group) {
        warn("Optional content group not found: ".concat(id));
        return;
      }
      if (preserveRB && visible && group.rbGroups.length) {
        var _iterator73 = _createForOfIteratorHelper(group.rbGroups),
          _step73;
        try {
          for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
            var rbGroup = _step73.value;
            var _iterator74 = _createForOfIteratorHelper(rbGroup),
              _step74;
            try {
              for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
                var otherId = _step74.value;
                if (otherId !== id) {
                  var _classPrivateFieldLoo59;
                  (_classPrivateFieldLoo59 = _classPrivateFieldLooseBase(this, _groups)[_groups].get(otherId)) === null || _classPrivateFieldLoo59 === void 0 || _classPrivateFieldLoo59._setVisible(INTERNAL, false, true);
                }
              }
            } catch (err) {
              _iterator74.e(err);
            } finally {
              _iterator74.f();
            }
          }
        } catch (err) {
          _iterator73.e(err);
        } finally {
          _iterator73.f();
        }
      }
      group._setVisible(INTERNAL, !!visible, true);
      _classPrivateFieldLooseBase(this, _cachedGetHash)[_cachedGetHash] = null;
    }
  }, {
    key: "setOCGState",
    value: function setOCGState(_ref65) {
      var state = _ref65.state,
        preserveRB = _ref65.preserveRB;
      var operator;
      var _iterator75 = _createForOfIteratorHelper(state),
        _step75;
      try {
        for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
          var elem = _step75.value;
          switch (elem) {
            case "ON":
            case "OFF":
            case "Toggle":
              operator = elem;
              continue;
          }
          var group = _classPrivateFieldLooseBase(this, _groups)[_groups].get(elem);
          if (!group) {
            continue;
          }
          switch (operator) {
            case "ON":
              this.setVisibility(elem, true, preserveRB);
              break;
            case "OFF":
              this.setVisibility(elem, false, preserveRB);
              break;
            case "Toggle":
              this.setVisibility(elem, !group.visible, preserveRB);
              break;
          }
        }
      } catch (err) {
        _iterator75.e(err);
      } finally {
        _iterator75.f();
      }
      _classPrivateFieldLooseBase(this, _cachedGetHash)[_cachedGetHash] = null;
    }
  }, {
    key: "hasInitialVisibility",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _initialHash)[_initialHash] === null || this.getHash() === _classPrivateFieldLooseBase(this, _initialHash)[_initialHash];
    }
  }, {
    key: "getOrder",
    value: function getOrder() {
      if (!_classPrivateFieldLooseBase(this, _groups)[_groups].size) {
        return null;
      }
      if (_classPrivateFieldLooseBase(this, _order)[_order]) {
        return _classPrivateFieldLooseBase(this, _order)[_order].slice();
      }
      return _toConsumableArray(_classPrivateFieldLooseBase(this, _groups)[_groups].keys());
    }
  }, {
    key: "getGroups",
    value: function getGroups() {
      return _classPrivateFieldLooseBase(this, _groups)[_groups].size > 0 ? objectFromMap(_classPrivateFieldLooseBase(this, _groups)[_groups]) : null;
    }
  }, {
    key: "getGroup",
    value: function getGroup(id) {
      return _classPrivateFieldLooseBase(this, _groups)[_groups].get(id) || null;
    }
  }, {
    key: "getHash",
    value: function getHash() {
      if (_classPrivateFieldLooseBase(this, _cachedGetHash)[_cachedGetHash] !== null) {
        return _classPrivateFieldLooseBase(this, _cachedGetHash)[_cachedGetHash];
      }
      var hash = new MurmurHash3_64();
      var _iterator76 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _groups)[_groups]),
        _step76;
      try {
        for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
          var _ref66 = _step76.value;
          var _ref67 = _slicedToArray(_ref66, 2);
          var _id9 = _ref67[0];
          var group = _ref67[1];
          hash.update("".concat(_id9, ":").concat(group.visible));
        }
      } catch (err) {
        _iterator76.e(err);
      } finally {
        _iterator76.f();
      }
      return _classPrivateFieldLooseBase(this, _cachedGetHash)[_cachedGetHash] = hash.hexdigest();
    }
  }]);
}();
function _evaluateVisibilityExpression2(array) {
  var length = array.length;
  if (length < 2) {
    return true;
  }
  var operator = array[0];
  for (var i = 1; i < length; i++) {
    var element = array[i];
    var state = void 0;
    if (Array.isArray(element)) {
      state = _classPrivateFieldLooseBase(this, _evaluateVisibilityExpression)[_evaluateVisibilityExpression](element);
    } else if (_classPrivateFieldLooseBase(this, _groups)[_groups].has(element)) {
      state = _classPrivateFieldLooseBase(this, _groups)[_groups].get(element).visible;
    } else {
      warn("Optional content group not found: ".concat(element));
      return true;
    }
    switch (operator) {
      case "And":
        if (!state) {
          return false;
        }
        break;
      case "Or":
        if (state) {
          return true;
        }
        break;
      case "Not":
        return !state;
      default:
        return true;
    }
  }
  return operator === "And";
}
; // ./src/display/transport_stream.js
var PDFDataTransportStream = /*#__PURE__*/function () {
  function PDFDataTransportStream(pdfDataRangeTransport, _ref68) {
    var _this26 = this;
    var _ref68$disableRange = _ref68.disableRange,
      disableRange = _ref68$disableRange === void 0 ? false : _ref68$disableRange,
      _ref68$disableStream = _ref68.disableStream,
      disableStream = _ref68$disableStream === void 0 ? false : _ref68$disableStream;
    _classCallCheck(this, PDFDataTransportStream);
    assert(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
    var length = pdfDataRangeTransport.length,
      initialData = pdfDataRangeTransport.initialData,
      progressiveDone = pdfDataRangeTransport.progressiveDone,
      contentDispositionFilename = pdfDataRangeTransport.contentDispositionFilename;
    this._queuedChunks = [];
    this._progressiveDone = progressiveDone;
    this._contentDispositionFilename = contentDispositionFilename;
    if ((initialData === null || initialData === void 0 ? void 0 : initialData.length) > 0) {
      var buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
      this._queuedChunks.push(buffer);
    }
    this._pdfDataRangeTransport = pdfDataRangeTransport;
    this._isStreamingSupported = !disableStream;
    this._isRangeSupported = !disableRange;
    this._contentLength = length;
    this._fullRequestReader = null;
    this._rangeReaders = [];
    pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
      _this26._onReceiveData({
        begin: begin,
        chunk: chunk
      });
    });
    pdfDataRangeTransport.addProgressListener(function (loaded, total) {
      _this26._onProgress({
        loaded: loaded,
        total: total
      });
    });
    pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
      _this26._onReceiveData({
        chunk: chunk
      });
    });
    pdfDataRangeTransport.addProgressiveDoneListener(function () {
      _this26._onProgressiveDone();
    });
    pdfDataRangeTransport.transportReady();
  }
  return _createClass(PDFDataTransportStream, [{
    key: "_onReceiveData",
    value: function _onReceiveData(_ref69) {
      var begin = _ref69.begin,
        chunk = _ref69.chunk;
      var buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
      if (begin === undefined) {
        if (this._fullRequestReader) {
          this._fullRequestReader._enqueue(buffer);
        } else {
          this._queuedChunks.push(buffer);
        }
      } else {
        var found = this._rangeReaders.some(function (rangeReader) {
          if (rangeReader._begin !== begin) {
            return false;
          }
          rangeReader._enqueue(buffer);
          return true;
        });
        assert(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
      }
    }
  }, {
    key: "_progressiveDataLength",
    get: function get() {
      var _this$_fullRequestRea, _this$_fullRequestRea2;
      return (_this$_fullRequestRea = (_this$_fullRequestRea2 = this._fullRequestReader) === null || _this$_fullRequestRea2 === void 0 ? void 0 : _this$_fullRequestRea2._loaded) !== null && _this$_fullRequestRea !== void 0 ? _this$_fullRequestRea : 0;
    }
  }, {
    key: "_onProgress",
    value: function _onProgress(evt) {
      if (evt.total === undefined) {
        var _this$_rangeReaders$, _this$_rangeReaders$$;
        (_this$_rangeReaders$ = this._rangeReaders[0]) === null || _this$_rangeReaders$ === void 0 || (_this$_rangeReaders$$ = _this$_rangeReaders$.onProgress) === null || _this$_rangeReaders$$ === void 0 || _this$_rangeReaders$$.call(_this$_rangeReaders$, {
          loaded: evt.loaded
        });
      } else {
        var _this$_fullRequestRea3, _this$_fullRequestRea4;
        (_this$_fullRequestRea3 = this._fullRequestReader) === null || _this$_fullRequestRea3 === void 0 || (_this$_fullRequestRea4 = _this$_fullRequestRea3.onProgress) === null || _this$_fullRequestRea4 === void 0 || _this$_fullRequestRea4.call(_this$_fullRequestRea3, {
          loaded: evt.loaded,
          total: evt.total
        });
      }
    }
  }, {
    key: "_onProgressiveDone",
    value: function _onProgressiveDone() {
      var _this$_fullRequestRea5;
      (_this$_fullRequestRea5 = this._fullRequestReader) === null || _this$_fullRequestRea5 === void 0 || _this$_fullRequestRea5.progressiveDone();
      this._progressiveDone = true;
    }
  }, {
    key: "_removeRangeReader",
    value: function _removeRangeReader(reader) {
      var i = this._rangeReaders.indexOf(reader);
      if (i >= 0) {
        this._rangeReaders.splice(i, 1);
      }
    }
  }, {
    key: "getFullReader",
    value: function getFullReader() {
      assert(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
      var queuedChunks = this._queuedChunks;
      this._queuedChunks = null;
      return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(begin, end) {
      if (end <= this._progressiveDataLength) {
        return null;
      }
      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
      this._pdfDataRangeTransport.requestDataRange(begin, end);
      this._rangeReaders.push(reader);
      return reader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      var _this$_fullRequestRea6;
      (_this$_fullRequestRea6 = this._fullRequestReader) === null || _this$_fullRequestRea6 === void 0 || _this$_fullRequestRea6.cancel(reason);
      var _iterator77 = _createForOfIteratorHelper(this._rangeReaders.slice(0)),
        _step77;
      try {
        for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
          var reader = _step77.value;
          reader.cancel(reason);
        }
      } catch (err) {
        _iterator77.e(err);
      } finally {
        _iterator77.f();
      }
      this._pdfDataRangeTransport.abort();
    }
  }]);
}();
var PDFDataTransportStreamReader = /*#__PURE__*/function () {
  function PDFDataTransportStreamReader(stream, queuedChunks) {
    var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var contentDispositionFilename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, PDFDataTransportStreamReader);
    this._stream = stream;
    this._done = progressiveDone || false;
    this._filename = _isPdfFile(contentDispositionFilename) ? contentDispositionFilename : null;
    this._queuedChunks = queuedChunks || [];
    this._loaded = 0;
    var _iterator78 = _createForOfIteratorHelper(this._queuedChunks),
      _step78;
    try {
      for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
        var chunk = _step78.value;
        this._loaded += chunk.byteLength;
      }
    } catch (err) {
      _iterator78.e(err);
    } finally {
      _iterator78.f();
    }
    this._requests = [];
    this._headersReady = Promise.resolve();
    stream._fullRequestReader = this;
    this.onProgress = null;
  }
  return _createClass(PDFDataTransportStreamReader, [{
    key: "_enqueue",
    value: function _enqueue(chunk) {
      if (this._done) {
        return;
      }
      if (this._requests.length > 0) {
        var requestCapability = this._requests.shift();
        requestCapability.resolve({
          value: chunk,
          done: false
        });
      } else {
        this._queuedChunks.push(chunk);
      }
      this._loaded += chunk.byteLength;
    }
  }, {
    key: "headersReady",
    get: function get() {
      return this._headersReady;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._stream._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._stream._isStreamingSupported;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._stream._contentLength;
    }
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var chunk, requestCapability;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              if (!(this._queuedChunks.length > 0)) {
                _context25.next = 3;
                break;
              }
              chunk = this._queuedChunks.shift();
              return _context25.abrupt("return", {
                value: chunk,
                done: false
              });
            case 3:
              if (!this._done) {
                _context25.next = 5;
                break;
              }
              return _context25.abrupt("return", {
                value: undefined,
                done: true
              });
            case 5:
              requestCapability = Promise.withResolvers();
              this._requests.push(requestCapability);
              return _context25.abrupt("return", requestCapability.promise);
            case 8:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function read() {
        return _read.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;
      var _iterator79 = _createForOfIteratorHelper(this._requests),
        _step79;
      try {
        for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
          var requestCapability = _step79.value;
          requestCapability.resolve({
            value: undefined,
            done: true
          });
        }
      } catch (err) {
        _iterator79.e(err);
      } finally {
        _iterator79.f();
      }
      this._requests.length = 0;
    }
  }, {
    key: "progressiveDone",
    value: function progressiveDone() {
      if (this._done) {
        return;
      }
      this._done = true;
    }
  }]);
}();
var PDFDataTransportStreamRangeReader = /*#__PURE__*/function () {
  function PDFDataTransportStreamRangeReader(stream, begin, end) {
    _classCallCheck(this, PDFDataTransportStreamRangeReader);
    this._stream = stream;
    this._begin = begin;
    this._end = end;
    this._queuedChunk = null;
    this._requests = [];
    this._done = false;
    this.onProgress = null;
  }
  return _createClass(PDFDataTransportStreamRangeReader, [{
    key: "_enqueue",
    value: function _enqueue(chunk) {
      if (this._done) {
        return;
      }
      if (this._requests.length === 0) {
        this._queuedChunk = chunk;
      } else {
        var requestsCapability = this._requests.shift();
        requestsCapability.resolve({
          value: chunk,
          done: false
        });
        var _iterator80 = _createForOfIteratorHelper(this._requests),
          _step80;
        try {
          for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
            var requestCapability = _step80.value;
            requestCapability.resolve({
              value: undefined,
              done: true
            });
          }
        } catch (err) {
          _iterator80.e(err);
        } finally {
          _iterator80.f();
        }
        this._requests.length = 0;
      }
      this._done = true;
      this._stream._removeRangeReader(this);
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return false;
    }
  }, {
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var chunk, requestCapability;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!this._queuedChunk) {
                _context26.next = 4;
                break;
              }
              chunk = this._queuedChunk;
              this._queuedChunk = null;
              return _context26.abrupt("return", {
                value: chunk,
                done: false
              });
            case 4:
              if (!this._done) {
                _context26.next = 6;
                break;
              }
              return _context26.abrupt("return", {
                value: undefined,
                done: true
              });
            case 6:
              requestCapability = Promise.withResolvers();
              this._requests.push(requestCapability);
              return _context26.abrupt("return", requestCapability.promise);
            case 9:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function read() {
        return _read2.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;
      var _iterator81 = _createForOfIteratorHelper(this._requests),
        _step81;
      try {
        for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
          var requestCapability = _step81.value;
          requestCapability.resolve({
            value: undefined,
            done: true
          });
        }
      } catch (err) {
        _iterator81.e(err);
      } finally {
        _iterator81.f();
      }
      this._requests.length = 0;
      this._stream._removeRangeReader(this);
    }
  }]);
}();
; // ./src/display/content_disposition.js

function getFilenameFromContentDispositionHeader(contentDisposition) {
  var needsEncodingFixup = true;
  var tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
  if (tmp) {
    tmp = tmp[1];
    var filename = rfc2616unquote(tmp);
    filename = unescape(filename);
    filename = rfc5987decode(filename);
    filename = rfc2047decode(filename);
    return fixupEncoding(filename);
  }
  tmp = rfc2231getparam(contentDisposition);
  if (tmp) {
    var _filename = rfc2047decode(tmp);
    return fixupEncoding(_filename);
  }
  tmp = toParamRegExp("filename", "i").exec(contentDisposition);
  if (tmp) {
    tmp = tmp[1];
    var _filename2 = rfc2616unquote(tmp);
    _filename2 = rfc2047decode(_filename2);
    return fixupEncoding(_filename2);
  }
  function toParamRegExp(attributePattern, flags) {
    return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
  }
  function textdecode(encoding, value) {
    if (encoding) {
      if (!/^[\x00-\xFF]+$/.test(value)) {
        return value;
      }
      try {
        var decoder = new TextDecoder(encoding, {
          fatal: true
        });
        var buffer = stringToBytes(value);
        value = decoder.decode(buffer);
        needsEncodingFixup = false;
      } catch (_unused7) {}
    }
    return value;
  }
  function fixupEncoding(value) {
    if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
      value = textdecode("utf-8", value);
      if (needsEncodingFixup) {
        value = textdecode("iso-8859-1", value);
      }
    }
    return value;
  }
  function rfc2231getparam(contentDispositionStr) {
    var matches = [];
    var match;
    var iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
    while ((match = iter.exec(contentDispositionStr)) !== null) {
      var _match = match,
        _match2 = _slicedToArray(_match, 4),
        n = _match2[1],
        quot = _match2[2],
        part = _match2[3];
      n = parseInt(n, 10);
      if (n in matches) {
        if (n === 0) {
          break;
        }
        continue;
      }
      matches[n] = [quot, part];
    }
    var parts = [];
    for (var _n = 0; _n < matches.length; ++_n) {
      if (!(_n in matches)) {
        break;
      }
      var _matches$_n = _slicedToArray(matches[_n], 2),
        _quot = _matches$_n[0],
        _part = _matches$_n[1];
      _part = rfc2616unquote(_part);
      if (_quot) {
        _part = unescape(_part);
        if (_n === 0) {
          _part = rfc5987decode(_part);
        }
      }
      parts.push(_part);
    }
    return parts.join("");
  }
  function rfc2616unquote(value) {
    if (value.startsWith('"')) {
      var parts = value.slice(1).split('\\"');
      for (var i = 0; i < parts.length; ++i) {
        var quotindex = parts[i].indexOf('"');
        if (quotindex !== -1) {
          parts[i] = parts[i].slice(0, quotindex);
          parts.length = i + 1;
        }
        parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
      }
      value = parts.join('"');
    }
    return value;
  }
  function rfc5987decode(extvalue) {
    var encodingend = extvalue.indexOf("'");
    if (encodingend === -1) {
      return extvalue;
    }
    var encoding = extvalue.slice(0, encodingend);
    var langvalue = extvalue.slice(encodingend + 1);
    var value = langvalue.replace(/^[^']*'/, "");
    return textdecode(encoding, value);
  }
  function rfc2047decode(value) {
    if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) {
      return value;
    }
    return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (matches, charset, encoding, text) {
      if (encoding === "q" || encoding === "Q") {
        text = text.replaceAll("_", " ");
        text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function (match, hex) {
          return String.fromCharCode(parseInt(hex, 16));
        });
        return textdecode(charset, text);
      }
      try {
        text = atob(text);
      } catch (_unused8) {}
      return textdecode(charset, text);
    });
  }
  return "";
}
; // ./src/display/network_utils.js

function createHeaders(isHttp, httpHeaders) {
  var headers = new Headers();
  if (!isHttp || !httpHeaders || _typeof(httpHeaders) !== "object") {
    return headers;
  }
  for (var key in httpHeaders) {
    var val = httpHeaders[key];
    if (val !== undefined) {
      headers.append(key, val);
    }
  }
  return headers;
}
function validateRangeRequestCapabilities(_ref70) {
  var responseHeaders = _ref70.responseHeaders,
    isHttp = _ref70.isHttp,
    rangeChunkSize = _ref70.rangeChunkSize,
    disableRange = _ref70.disableRange;
  var returnValues = {
    allowRangeRequests: false,
    suggestedLength: undefined
  };
  var length = parseInt(responseHeaders.get("Content-Length"), 10);
  if (!Number.isInteger(length)) {
    return returnValues;
  }
  returnValues.suggestedLength = length;
  if (length <= 2 * rangeChunkSize) {
    return returnValues;
  }
  if (disableRange || !isHttp) {
    return returnValues;
  }
  if (responseHeaders.get("Accept-Ranges") !== "bytes") {
    return returnValues;
  }
  var contentEncoding = responseHeaders.get("Content-Encoding") || "identity";
  if (contentEncoding !== "identity") {
    return returnValues;
  }
  returnValues.allowRangeRequests = true;
  return returnValues;
}
function extractFilenameFromHeader(responseHeaders) {
  var contentDisposition = responseHeaders.get("Content-Disposition");
  if (contentDisposition) {
    var filename = getFilenameFromContentDispositionHeader(contentDisposition);
    if (filename.includes("%")) {
      try {
        filename = decodeURIComponent(filename);
      } catch (_unused9) {}
    }
    if (_isPdfFile(filename)) {
      return filename;
    }
  }
  return null;
}
function createResponseStatusError(status, url) {
  if (status === 404 || status === 0 && url.startsWith("file:")) {
    return new _MissingPDFException('Missing PDF "' + url + '".');
  }
  return new _UnexpectedResponseException("Unexpected server response (".concat(status, ") while retrieving PDF \"").concat(url, "\"."), status);
}
function validateResponseStatus(status) {
  return status === 200 || status === 206;
}
; // ./src/display/fetch_stream.js

function createFetchOptions(headers, withCredentials, abortController) {
  return {
    method: "GET",
    headers: headers,
    signal: abortController.signal,
    mode: "cors",
    credentials: withCredentials ? "include" : "same-origin",
    redirect: "follow"
  };
}
function getArrayBuffer(val) {
  if (val instanceof Uint8Array) {
    return val.buffer;
  }
  if (val instanceof ArrayBuffer) {
    return val;
  }
  warn("getArrayBuffer - unexpected data format: ".concat(val));
  return new Uint8Array(val).buffer;
}
var PDFFetchStream = /*#__PURE__*/function () {
  function PDFFetchStream(source) {
    _classCallCheck(this, PDFFetchStream);
    this.source = source;
    this.isHttp = /^https?:/i.test(source.url);
    this.headers = createHeaders(this.isHttp, source.httpHeaders);
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }
  return _createClass(PDFFetchStream, [{
    key: "_progressiveDataLength",
    get: function get() {
      var _this$_fullRequestRea7, _this$_fullRequestRea8;
      return (_this$_fullRequestRea7 = (_this$_fullRequestRea8 = this._fullRequestReader) === null || _this$_fullRequestRea8 === void 0 ? void 0 : _this$_fullRequestRea8._loaded) !== null && _this$_fullRequestRea7 !== void 0 ? _this$_fullRequestRea7 : 0;
    }
  }, {
    key: "getFullReader",
    value: function getFullReader() {
      assert(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
      this._fullRequestReader = new PDFFetchStreamReader(this);
      return this._fullRequestReader;
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(begin, end) {
      if (end <= this._progressiveDataLength) {
        return null;
      }
      var reader = new PDFFetchStreamRangeReader(this, begin, end);
      this._rangeRequestReaders.push(reader);
      return reader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      var _this$_fullRequestRea9;
      (_this$_fullRequestRea9 = this._fullRequestReader) === null || _this$_fullRequestRea9 === void 0 || _this$_fullRequestRea9.cancel(reason);
      var _iterator82 = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)),
        _step82;
      try {
        for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
          var reader = _step82.value;
          reader.cancel(reason);
        }
      } catch (err) {
        _iterator82.e(err);
      } finally {
        _iterator82.f();
      }
    }
  }]);
}();
var PDFFetchStreamReader = /*#__PURE__*/function () {
  function PDFFetchStreamReader(stream) {
    var _this27 = this;
    _classCallCheck(this, PDFFetchStreamReader);
    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    this._filename = null;
    var source = stream.source;
    this._withCredentials = source.withCredentials || false;
    this._contentLength = source.length;
    this._headersCapability = Promise.withResolvers();
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._abortController = new AbortController();
    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    var headers = new Headers(stream.headers);
    var url = source.url;
    fetch(url, createFetchOptions(headers, this._withCredentials, this._abortController)).then(function (response) {
      if (!validateResponseStatus(response.status)) {
        throw createResponseStatusError(response.status, url);
      }
      _this27._reader = response.body.getReader();
      _this27._headersCapability.resolve();
      var responseHeaders = response.headers;
      var _validateRangeRequest = validateRangeRequestCapabilities({
          responseHeaders: responseHeaders,
          isHttp: stream.isHttp,
          rangeChunkSize: _this27._rangeChunkSize,
          disableRange: _this27._disableRange
        }),
        allowRangeRequests = _validateRangeRequest.allowRangeRequests,
        suggestedLength = _validateRangeRequest.suggestedLength;
      _this27._isRangeSupported = allowRangeRequests;
      _this27._contentLength = suggestedLength || _this27._contentLength;
      _this27._filename = extractFilenameFromHeader(responseHeaders);
      if (!_this27._isStreamingSupported && _this27._isRangeSupported) {
        _this27.cancel(new _AbortException("Streaming is disabled."));
      }
    }).catch(this._headersCapability.reject);
    this.onProgress = null;
  }
  return _createClass(PDFFetchStreamReader, [{
    key: "headersReady",
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }, {
    key: "read",
    value: function () {
      var _read3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var _this$onProgress;
        var _yield$this$_reader$r, value, done;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return this._headersCapability.promise;
            case 2:
              _context27.next = 4;
              return this._reader.read();
            case 4:
              _yield$this$_reader$r = _context27.sent;
              value = _yield$this$_reader$r.value;
              done = _yield$this$_reader$r.done;
              if (!done) {
                _context27.next = 9;
                break;
              }
              return _context27.abrupt("return", {
                value: value,
                done: done
              });
            case 9:
              this._loaded += value.byteLength;
              (_this$onProgress = this.onProgress) === null || _this$onProgress === void 0 || _this$onProgress.call(this, {
                loaded: this._loaded,
                total: this._contentLength
              });
              return _context27.abrupt("return", {
                value: getArrayBuffer(value),
                done: false
              });
            case 12:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function read() {
        return _read3.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      var _this$_reader;
      (_this$_reader = this._reader) === null || _this$_reader === void 0 || _this$_reader.cancel(reason);
      this._abortController.abort();
    }
  }]);
}();
var PDFFetchStreamRangeReader = /*#__PURE__*/function () {
  function PDFFetchStreamRangeReader(stream, begin, end) {
    var _this28 = this;
    _classCallCheck(this, PDFFetchStreamRangeReader);
    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    var source = stream.source;
    this._withCredentials = source.withCredentials || false;
    this._readCapability = Promise.withResolvers();
    this._isStreamingSupported = !source.disableStream;
    this._abortController = new AbortController();
    var headers = new Headers(stream.headers);
    headers.append("Range", "bytes=".concat(begin, "-").concat(end - 1));
    var url = source.url;
    fetch(url, createFetchOptions(headers, this._withCredentials, this._abortController)).then(function (response) {
      if (!validateResponseStatus(response.status)) {
        throw createResponseStatusError(response.status, url);
      }
      _this28._readCapability.resolve();
      _this28._reader = response.body.getReader();
    }).catch(this._readCapability.reject);
    this.onProgress = null;
  }
  return _createClass(PDFFetchStreamRangeReader, [{
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }, {
    key: "read",
    value: function () {
      var _read4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var _this$onProgress2;
        var _yield$this$_reader$r2, value, done;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return this._readCapability.promise;
            case 2:
              _context28.next = 4;
              return this._reader.read();
            case 4:
              _yield$this$_reader$r2 = _context28.sent;
              value = _yield$this$_reader$r2.value;
              done = _yield$this$_reader$r2.done;
              if (!done) {
                _context28.next = 9;
                break;
              }
              return _context28.abrupt("return", {
                value: value,
                done: done
              });
            case 9:
              this._loaded += value.byteLength;
              (_this$onProgress2 = this.onProgress) === null || _this$onProgress2 === void 0 || _this$onProgress2.call(this, {
                loaded: this._loaded
              });
              return _context28.abrupt("return", {
                value: getArrayBuffer(value),
                done: false
              });
            case 12:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function read() {
        return _read4.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      var _this$_reader2;
      (_this$_reader2 = this._reader) === null || _this$_reader2 === void 0 || _this$_reader2.cancel(reason);
      this._abortController.abort();
    }
  }]);
}();
; // ./src/display/network.js

var OK_RESPONSE = 200;
var PARTIAL_CONTENT_RESPONSE = 206;
function network_getArrayBuffer(xhr) {
  var data = xhr.response;
  if (typeof data !== "string") {
    return data;
  }
  return stringToBytes(data).buffer;
}
var NetworkManager = /*#__PURE__*/function () {
  function NetworkManager(_ref71) {
    var url = _ref71.url,
      httpHeaders = _ref71.httpHeaders,
      withCredentials = _ref71.withCredentials;
    _classCallCheck(this, NetworkManager);
    this.url = url;
    this.isHttp = /^https?:/i.test(url);
    this.headers = createHeaders(this.isHttp, httpHeaders);
    this.withCredentials = withCredentials || false;
    this.currXhrId = 0;
    this.pendingRequests = Object.create(null);
  }
  return _createClass(NetworkManager, [{
    key: "requestRange",
    value: function requestRange(begin, end, listeners) {
      var args = {
        begin: begin,
        end: end
      };
      for (var prop in listeners) {
        args[prop] = listeners[prop];
      }
      return this.request(args);
    }
  }, {
    key: "requestFull",
    value: function requestFull(listeners) {
      return this.request(listeners);
    }
  }, {
    key: "request",
    value: function request(args) {
      var xhr = new XMLHttpRequest();
      var xhrId = this.currXhrId++;
      var pendingRequest = this.pendingRequests[xhrId] = {
        xhr: xhr
      };
      xhr.open("GET", this.url);
      xhr.withCredentials = this.withCredentials;
      var _iterator83 = _createForOfIteratorHelper(this.headers),
        _step83;
      try {
        for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
          var _ref72 = _step83.value;
          var _ref73 = _slicedToArray(_ref72, 2);
          var key = _ref73[0];
          var val = _ref73[1];
          xhr.setRequestHeader(key, val);
        }
      } catch (err) {
        _iterator83.e(err);
      } finally {
        _iterator83.f();
      }
      if (this.isHttp && "begin" in args && "end" in args) {
        xhr.setRequestHeader("Range", "bytes=".concat(args.begin, "-").concat(args.end - 1));
        pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
      } else {
        pendingRequest.expectedStatus = OK_RESPONSE;
      }
      xhr.responseType = "arraybuffer";
      if (args.onError) {
        xhr.onerror = function (evt) {
          args.onError(xhr.status);
        };
      }
      xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
      xhr.onprogress = this.onProgress.bind(this, xhrId);
      pendingRequest.onHeadersReceived = args.onHeadersReceived;
      pendingRequest.onDone = args.onDone;
      pendingRequest.onError = args.onError;
      pendingRequest.onProgress = args.onProgress;
      xhr.send(null);
      return xhrId;
    }
  }, {
    key: "onProgress",
    value: function onProgress(xhrId, evt) {
      var _pendingRequest$onPro;
      var pendingRequest = this.pendingRequests[xhrId];
      if (!pendingRequest) {
        return;
      }
      (_pendingRequest$onPro = pendingRequest.onProgress) === null || _pendingRequest$onPro === void 0 || _pendingRequest$onPro.call(pendingRequest, evt);
    }
  }, {
    key: "onStateChange",
    value: function onStateChange(xhrId, evt) {
      var pendingRequest = this.pendingRequests[xhrId];
      if (!pendingRequest) {
        return;
      }
      var xhr = pendingRequest.xhr;
      if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
        pendingRequest.onHeadersReceived();
        delete pendingRequest.onHeadersReceived;
      }
      if (xhr.readyState !== 4) {
        return;
      }
      if (!(xhrId in this.pendingRequests)) {
        return;
      }
      delete this.pendingRequests[xhrId];
      if (xhr.status === 0 && this.isHttp) {
        var _pendingRequest$onErr;
        (_pendingRequest$onErr = pendingRequest.onError) === null || _pendingRequest$onErr === void 0 || _pendingRequest$onErr.call(pendingRequest, xhr.status);
        return;
      }
      var xhrStatus = xhr.status || OK_RESPONSE;
      var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
      if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
        var _pendingRequest$onErr2;
        (_pendingRequest$onErr2 = pendingRequest.onError) === null || _pendingRequest$onErr2 === void 0 || _pendingRequest$onErr2.call(pendingRequest, xhr.status);
        return;
      }
      var chunk = network_getArrayBuffer(xhr);
      if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
        var rangeHeader = xhr.getResponseHeader("Content-Range");
        var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
        pendingRequest.onDone({
          begin: parseInt(matches[1], 10),
          chunk: chunk
        });
      } else if (chunk) {
        pendingRequest.onDone({
          begin: 0,
          chunk: chunk
        });
      } else {
        var _pendingRequest$onErr3;
        (_pendingRequest$onErr3 = pendingRequest.onError) === null || _pendingRequest$onErr3 === void 0 || _pendingRequest$onErr3.call(pendingRequest, xhr.status);
      }
    }
  }, {
    key: "getRequestXhr",
    value: function getRequestXhr(xhrId) {
      return this.pendingRequests[xhrId].xhr;
    }
  }, {
    key: "isPendingRequest",
    value: function isPendingRequest(xhrId) {
      return xhrId in this.pendingRequests;
    }
  }, {
    key: "abortRequest",
    value: function abortRequest(xhrId) {
      var xhr = this.pendingRequests[xhrId].xhr;
      delete this.pendingRequests[xhrId];
      xhr.abort();
    }
  }]);
}();
var PDFNetworkStream = /*#__PURE__*/function () {
  function PDFNetworkStream(source) {
    _classCallCheck(this, PDFNetworkStream);
    this._source = source;
    this._manager = new NetworkManager(source);
    this._rangeChunkSize = source.rangeChunkSize;
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }
  return _createClass(PDFNetworkStream, [{
    key: "_onRangeRequestReaderClosed",
    value: function _onRangeRequestReaderClosed(reader) {
      var i = this._rangeRequestReaders.indexOf(reader);
      if (i >= 0) {
        this._rangeRequestReaders.splice(i, 1);
      }
    }
  }, {
    key: "getFullReader",
    value: function getFullReader() {
      assert(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
      this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
      return this._fullRequestReader;
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(begin, end) {
      var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
      reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
      this._rangeRequestReaders.push(reader);
      return reader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      var _this$_fullRequestRea10;
      (_this$_fullRequestRea10 = this._fullRequestReader) === null || _this$_fullRequestRea10 === void 0 || _this$_fullRequestRea10.cancel(reason);
      var _iterator84 = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)),
        _step84;
      try {
        for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
          var reader = _step84.value;
          reader.cancel(reason);
        }
      } catch (err) {
        _iterator84.e(err);
      } finally {
        _iterator84.f();
      }
    }
  }]);
}();
var PDFNetworkStreamFullRequestReader = /*#__PURE__*/function () {
  function PDFNetworkStreamFullRequestReader(manager, source) {
    _classCallCheck(this, PDFNetworkStreamFullRequestReader);
    this._manager = manager;
    var args = {
      onHeadersReceived: this._onHeadersReceived.bind(this),
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    };
    this._url = source.url;
    this._fullRequestId = manager.requestFull(args);
    this._headersCapability = Promise.withResolvers();
    this._disableRange = source.disableRange || false;
    this._contentLength = source.length;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._isStreamingSupported = false;
    this._isRangeSupported = false;
    this._cachedChunks = [];
    this._requests = [];
    this._done = false;
    this._storedError = undefined;
    this._filename = null;
    this.onProgress = null;
  }
  return _createClass(PDFNetworkStreamFullRequestReader, [{
    key: "_onHeadersReceived",
    value: function _onHeadersReceived() {
      var fullRequestXhrId = this._fullRequestId;
      var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
      var responseHeaders = new Headers(fullRequestXhr.getAllResponseHeaders().trim().split(/[\r\n]+/).map(function (x) {
        var _x$split = x.split(": "),
          _x$split2 = _toArray(_x$split),
          key = _x$split2[0],
          val = _x$split2.slice(1);
        return [key, val.join(": ")];
      }));
      var _validateRangeRequest2 = validateRangeRequestCapabilities({
          responseHeaders: responseHeaders,
          isHttp: this._manager.isHttp,
          rangeChunkSize: this._rangeChunkSize,
          disableRange: this._disableRange
        }),
        allowRangeRequests = _validateRangeRequest2.allowRangeRequests,
        suggestedLength = _validateRangeRequest2.suggestedLength;
      if (allowRangeRequests) {
        this._isRangeSupported = true;
      }
      this._contentLength = suggestedLength || this._contentLength;
      this._filename = extractFilenameFromHeader(responseHeaders);
      if (this._isRangeSupported) {
        this._manager.abortRequest(fullRequestXhrId);
      }
      this._headersCapability.resolve();
    }
  }, {
    key: "_onDone",
    value: function _onDone(data) {
      if (data) {
        if (this._requests.length > 0) {
          var requestCapability = this._requests.shift();
          requestCapability.resolve({
            value: data.chunk,
            done: false
          });
        } else {
          this._cachedChunks.push(data.chunk);
        }
      }
      this._done = true;
      if (this._cachedChunks.length > 0) {
        return;
      }
      var _iterator85 = _createForOfIteratorHelper(this._requests),
        _step85;
      try {
        for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
          var _requestCapability = _step85.value;
          _requestCapability.resolve({
            value: undefined,
            done: true
          });
        }
      } catch (err) {
        _iterator85.e(err);
      } finally {
        _iterator85.f();
      }
      this._requests.length = 0;
    }
  }, {
    key: "_onError",
    value: function _onError(status) {
      this._storedError = createResponseStatusError(status, this._url);
      this._headersCapability.reject(this._storedError);
      var _iterator86 = _createForOfIteratorHelper(this._requests),
        _step86;
      try {
        for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
          var requestCapability = _step86.value;
          requestCapability.reject(this._storedError);
        }
      } catch (err) {
        _iterator86.e(err);
      } finally {
        _iterator86.f();
      }
      this._requests.length = 0;
      this._cachedChunks.length = 0;
    }
  }, {
    key: "_onProgress",
    value: function _onProgress(evt) {
      var _this$onProgress3;
      (_this$onProgress3 = this.onProgress) === null || _this$onProgress3 === void 0 || _this$onProgress3.call(this, {
        loaded: evt.loaded,
        total: evt.lengthComputable ? evt.total : this._contentLength
      });
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: "headersReady",
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: "read",
    value: function () {
      var _read5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var chunk, requestCapability;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              if (!this._storedError) {
                _context29.next = 2;
                break;
              }
              throw this._storedError;
            case 2:
              if (!(this._cachedChunks.length > 0)) {
                _context29.next = 5;
                break;
              }
              chunk = this._cachedChunks.shift();
              return _context29.abrupt("return", {
                value: chunk,
                done: false
              });
            case 5:
              if (!this._done) {
                _context29.next = 7;
                break;
              }
              return _context29.abrupt("return", {
                value: undefined,
                done: true
              });
            case 7:
              requestCapability = Promise.withResolvers();
              this._requests.push(requestCapability);
              return _context29.abrupt("return", requestCapability.promise);
            case 10:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function read() {
        return _read5.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;
      this._headersCapability.reject(reason);
      var _iterator87 = _createForOfIteratorHelper(this._requests),
        _step87;
      try {
        for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
          var requestCapability = _step87.value;
          requestCapability.resolve({
            value: undefined,
            done: true
          });
        }
      } catch (err) {
        _iterator87.e(err);
      } finally {
        _iterator87.f();
      }
      this._requests.length = 0;
      if (this._manager.isPendingRequest(this._fullRequestId)) {
        this._manager.abortRequest(this._fullRequestId);
      }
      this._fullRequestReader = null;
    }
  }]);
}();
var PDFNetworkStreamRangeRequestReader = /*#__PURE__*/function () {
  function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
    _classCallCheck(this, PDFNetworkStreamRangeRequestReader);
    this._manager = manager;
    var args = {
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    };
    this._url = manager.url;
    this._requestId = manager.requestRange(begin, end, args);
    this._requests = [];
    this._queuedChunk = null;
    this._done = false;
    this._storedError = undefined;
    this.onProgress = null;
    this.onClosed = null;
  }
  return _createClass(PDFNetworkStreamRangeRequestReader, [{
    key: "_close",
    value: function _close() {
      var _this$onClosed;
      (_this$onClosed = this.onClosed) === null || _this$onClosed === void 0 || _this$onClosed.call(this, this);
    }
  }, {
    key: "_onDone",
    value: function _onDone(data) {
      var chunk = data.chunk;
      if (this._requests.length > 0) {
        var requestCapability = this._requests.shift();
        requestCapability.resolve({
          value: chunk,
          done: false
        });
      } else {
        this._queuedChunk = chunk;
      }
      this._done = true;
      var _iterator88 = _createForOfIteratorHelper(this._requests),
        _step88;
      try {
        for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
          var _requestCapability2 = _step88.value;
          _requestCapability2.resolve({
            value: undefined,
            done: true
          });
        }
      } catch (err) {
        _iterator88.e(err);
      } finally {
        _iterator88.f();
      }
      this._requests.length = 0;
      this._close();
    }
  }, {
    key: "_onError",
    value: function _onError(status) {
      this._storedError = createResponseStatusError(status, this._url);
      var _iterator89 = _createForOfIteratorHelper(this._requests),
        _step89;
      try {
        for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
          var requestCapability = _step89.value;
          requestCapability.reject(this._storedError);
        }
      } catch (err) {
        _iterator89.e(err);
      } finally {
        _iterator89.f();
      }
      this._requests.length = 0;
      this._queuedChunk = null;
    }
  }, {
    key: "_onProgress",
    value: function _onProgress(evt) {
      if (!this.isStreamingSupported) {
        var _this$onProgress4;
        (_this$onProgress4 = this.onProgress) === null || _this$onProgress4 === void 0 || _this$onProgress4.call(this, {
          loaded: evt.loaded
        });
      }
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return false;
    }
  }, {
    key: "read",
    value: function () {
      var _read6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var chunk, requestCapability;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              if (!this._storedError) {
                _context30.next = 2;
                break;
              }
              throw this._storedError;
            case 2:
              if (!(this._queuedChunk !== null)) {
                _context30.next = 6;
                break;
              }
              chunk = this._queuedChunk;
              this._queuedChunk = null;
              return _context30.abrupt("return", {
                value: chunk,
                done: false
              });
            case 6:
              if (!this._done) {
                _context30.next = 8;
                break;
              }
              return _context30.abrupt("return", {
                value: undefined,
                done: true
              });
            case 8:
              requestCapability = Promise.withResolvers();
              this._requests.push(requestCapability);
              return _context30.abrupt("return", requestCapability.promise);
            case 11:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function read() {
        return _read6.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;
      var _iterator90 = _createForOfIteratorHelper(this._requests),
        _step90;
      try {
        for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
          var requestCapability = _step90.value;
          requestCapability.resolve({
            value: undefined,
            done: true
          });
        }
      } catch (err) {
        _iterator90.e(err);
      } finally {
        _iterator90.f();
      }
      this._requests.length = 0;
      if (this._manager.isPendingRequest(this._requestId)) {
        this._manager.abortRequest(this._requestId);
      }
      this._close();
    }
  }]);
}();
; // ./src/display/node_stream.js

var urlRegex = /^[a-z][a-z0-9\-+.]+:/i;
function parseUrlOrPath(sourceUrl) {
  if (urlRegex.test(sourceUrl)) {
    return new URL(sourceUrl);
  }
  var url = NodePackages.get("url");
  return new URL(url.pathToFileURL(sourceUrl));
}
function createRequest(url, headers, callback) {
  if (url.protocol === "http:") {
    var http = NodePackages.get("http");
    return http.request(url, {
      headers: headers
    }, callback);
  }
  var https = NodePackages.get("https");
  return https.request(url, {
    headers: headers
  }, callback);
}
var PDFNodeStream = /*#__PURE__*/function () {
  function PDFNodeStream(source) {
    _classCallCheck(this, PDFNodeStream);
    this.source = source;
    this.url = parseUrlOrPath(source.url);
    this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
    this.isFsUrl = this.url.protocol === "file:";
    this.headers = createHeaders(this.isHttp, source.httpHeaders);
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }
  return _createClass(PDFNodeStream, [{
    key: "_progressiveDataLength",
    get: function get() {
      var _this$_fullRequestRea11, _this$_fullRequestRea12;
      return (_this$_fullRequestRea11 = (_this$_fullRequestRea12 = this._fullRequestReader) === null || _this$_fullRequestRea12 === void 0 ? void 0 : _this$_fullRequestRea12._loaded) !== null && _this$_fullRequestRea11 !== void 0 ? _this$_fullRequestRea11 : 0;
    }
  }, {
    key: "getFullReader",
    value: function getFullReader() {
      assert(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
      this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
      return this._fullRequestReader;
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(start, end) {
      if (end <= this._progressiveDataLength) {
        return null;
      }
      var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
      this._rangeRequestReaders.push(rangeReader);
      return rangeReader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      var _this$_fullRequestRea13;
      (_this$_fullRequestRea13 = this._fullRequestReader) === null || _this$_fullRequestRea13 === void 0 || _this$_fullRequestRea13.cancel(reason);
      var _iterator91 = _createForOfIteratorHelper(this._rangeRequestReaders.slice(0)),
        _step91;
      try {
        for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
          var reader = _step91.value;
          reader.cancel(reason);
        }
      } catch (err) {
        _iterator91.e(err);
      } finally {
        _iterator91.f();
      }
    }
  }]);
}();
var BaseFullReader = /*#__PURE__*/function () {
  function BaseFullReader(stream) {
    _classCallCheck(this, BaseFullReader);
    this._url = stream.url;
    this._done = false;
    this._storedError = null;
    this.onProgress = null;
    var source = stream.source;
    this._contentLength = source.length;
    this._loaded = 0;
    this._filename = null;
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._readableStream = null;
    this._readCapability = Promise.withResolvers();
    this._headersCapability = Promise.withResolvers();
  }
  return _createClass(BaseFullReader, [{
    key: "headersReady",
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }, {
    key: "read",
    value: function () {
      var _read7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var _this$onProgress5;
        var chunk, buffer;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return this._readCapability.promise;
            case 2:
              if (!this._done) {
                _context31.next = 4;
                break;
              }
              return _context31.abrupt("return", {
                value: undefined,
                done: true
              });
            case 4:
              if (!this._storedError) {
                _context31.next = 6;
                break;
              }
              throw this._storedError;
            case 6:
              chunk = this._readableStream.read();
              if (!(chunk === null)) {
                _context31.next = 10;
                break;
              }
              this._readCapability = Promise.withResolvers();
              return _context31.abrupt("return", this.read());
            case 10:
              this._loaded += chunk.length;
              (_this$onProgress5 = this.onProgress) === null || _this$onProgress5 === void 0 || _this$onProgress5.call(this, {
                loaded: this._loaded,
                total: this._contentLength
              });
              buffer = new Uint8Array(chunk).buffer;
              return _context31.abrupt("return", {
                value: buffer,
                done: false
              });
            case 14:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function read() {
        return _read7.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);
        return;
      }
      this._readableStream.destroy(reason);
    }
  }, {
    key: "_error",
    value: function _error(reason) {
      this._storedError = reason;
      this._readCapability.resolve();
    }
  }, {
    key: "_setReadableStream",
    value: function _setReadableStream(readableStream) {
      var _this29 = this;
      this._readableStream = readableStream;
      readableStream.on("readable", function () {
        _this29._readCapability.resolve();
      });
      readableStream.on("end", function () {
        readableStream.destroy();
        _this29._done = true;
        _this29._readCapability.resolve();
      });
      readableStream.on("error", function (reason) {
        _this29._error(reason);
      });
      if (!this._isStreamingSupported && this._isRangeSupported) {
        this._error(new _AbortException("streaming is disabled"));
      }
      if (this._storedError) {
        this._readableStream.destroy(this._storedError);
      }
    }
  }]);
}();
var BaseRangeReader = /*#__PURE__*/function () {
  function BaseRangeReader(stream) {
    _classCallCheck(this, BaseRangeReader);
    this._url = stream.url;
    this._done = false;
    this._storedError = null;
    this.onProgress = null;
    this._loaded = 0;
    this._readableStream = null;
    this._readCapability = Promise.withResolvers();
    var source = stream.source;
    this._isStreamingSupported = !source.disableStream;
  }
  return _createClass(BaseRangeReader, [{
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }, {
    key: "read",
    value: function () {
      var _read8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var _this$onProgress6;
        var chunk, buffer;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return this._readCapability.promise;
            case 2:
              if (!this._done) {
                _context32.next = 4;
                break;
              }
              return _context32.abrupt("return", {
                value: undefined,
                done: true
              });
            case 4:
              if (!this._storedError) {
                _context32.next = 6;
                break;
              }
              throw this._storedError;
            case 6:
              chunk = this._readableStream.read();
              if (!(chunk === null)) {
                _context32.next = 10;
                break;
              }
              this._readCapability = Promise.withResolvers();
              return _context32.abrupt("return", this.read());
            case 10:
              this._loaded += chunk.length;
              (_this$onProgress6 = this.onProgress) === null || _this$onProgress6 === void 0 || _this$onProgress6.call(this, {
                loaded: this._loaded
              });
              buffer = new Uint8Array(chunk).buffer;
              return _context32.abrupt("return", {
                value: buffer,
                done: false
              });
            case 14:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function read() {
        return _read8.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);
        return;
      }
      this._readableStream.destroy(reason);
    }
  }, {
    key: "_error",
    value: function _error(reason) {
      this._storedError = reason;
      this._readCapability.resolve();
    }
  }, {
    key: "_setReadableStream",
    value: function _setReadableStream(readableStream) {
      var _this30 = this;
      this._readableStream = readableStream;
      readableStream.on("readable", function () {
        _this30._readCapability.resolve();
      });
      readableStream.on("end", function () {
        readableStream.destroy();
        _this30._done = true;
        _this30._readCapability.resolve();
      });
      readableStream.on("error", function (reason) {
        _this30._error(reason);
      });
      if (this._storedError) {
        this._readableStream.destroy(this._storedError);
      }
    }
  }]);
}();
var PDFNodeStreamFullReader = /*#__PURE__*/function (_BaseFullReader) {
  function PDFNodeStreamFullReader(stream) {
    var _this31;
    _classCallCheck(this, PDFNodeStreamFullReader);
    _this31 = _callSuper(this, PDFNodeStreamFullReader, [stream]);
    var headers = Object.fromEntries(stream.headers);
    var handleResponse = function handleResponse(response) {
      if (response.statusCode === 404) {
        var error = new _MissingPDFException("Missing PDF \"".concat(_this31._url, "\"."));
        _this31._storedError = error;
        _this31._headersCapability.reject(error);
        return;
      }
      _this31._headersCapability.resolve();
      _this31._setReadableStream(response);
      var responseHeaders = new Headers(_this31._readableStream.headers);
      var _validateRangeRequest3 = validateRangeRequestCapabilities({
          responseHeaders: responseHeaders,
          isHttp: stream.isHttp,
          rangeChunkSize: _this31._rangeChunkSize,
          disableRange: _this31._disableRange
        }),
        allowRangeRequests = _validateRangeRequest3.allowRangeRequests,
        suggestedLength = _validateRangeRequest3.suggestedLength;
      _this31._isRangeSupported = allowRangeRequests;
      _this31._contentLength = suggestedLength || _this31._contentLength;
      _this31._filename = extractFilenameFromHeader(responseHeaders);
    };
    _this31._request = createRequest(_this31._url, headers, handleResponse);
    _this31._request.on("error", function (reason) {
      _this31._storedError = reason;
      _this31._headersCapability.reject(reason);
    });
    _this31._request.end();
    return _this31;
  }
  _inherits(PDFNodeStreamFullReader, _BaseFullReader);
  return _createClass(PDFNodeStreamFullReader);
}(BaseFullReader);
var PDFNodeStreamRangeReader = /*#__PURE__*/function (_BaseRangeReader) {
  function PDFNodeStreamRangeReader(stream, start, end) {
    var _this32;
    _classCallCheck(this, PDFNodeStreamRangeReader);
    _this32 = _callSuper(this, PDFNodeStreamRangeReader, [stream]);
    var headers = Object.fromEntries(stream.headers);
    headers.Range = "bytes=".concat(start, "-").concat(end - 1);
    var handleResponse = function handleResponse(response) {
      if (response.statusCode === 404) {
        var error = new _MissingPDFException("Missing PDF \"".concat(_this32._url, "\"."));
        _this32._storedError = error;
        return;
      }
      _this32._setReadableStream(response);
    };
    _this32._request = createRequest(_this32._url, headers, handleResponse);
    _this32._request.on("error", function (reason) {
      _this32._storedError = reason;
    });
    _this32._request.end();
    return _this32;
  }
  _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);
  return _createClass(PDFNodeStreamRangeReader);
}(BaseRangeReader);
var PDFNodeStreamFsFullReader = /*#__PURE__*/function (_BaseFullReader2) {
  function PDFNodeStreamFsFullReader(stream) {
    var _this33;
    _classCallCheck(this, PDFNodeStreamFsFullReader);
    _this33 = _callSuper(this, PDFNodeStreamFsFullReader, [stream]);
    var fs = NodePackages.get("fs");
    fs.promises.lstat(_this33._url).then(function (stat) {
      _this33._contentLength = stat.size;
      _this33._setReadableStream(fs.createReadStream(_this33._url));
      _this33._headersCapability.resolve();
    }, function (error) {
      if (error.code === "ENOENT") {
        error = new _MissingPDFException("Missing PDF \"".concat(_this33._url, "\"."));
      }
      _this33._storedError = error;
      _this33._headersCapability.reject(error);
    });
    return _this33;
  }
  _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);
  return _createClass(PDFNodeStreamFsFullReader);
}(BaseFullReader);
var PDFNodeStreamFsRangeReader = /*#__PURE__*/function (_BaseRangeReader2) {
  function PDFNodeStreamFsRangeReader(stream, start, end) {
    var _this34;
    _classCallCheck(this, PDFNodeStreamFsRangeReader);
    _this34 = _callSuper(this, PDFNodeStreamFsRangeReader, [stream]);
    var fs = NodePackages.get("fs");
    _this34._setReadableStream(fs.createReadStream(_this34._url, {
      start: start,
      end: end - 1
    }));
    return _this34;
  }
  _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);
  return _createClass(PDFNodeStreamFsRangeReader);
}(BaseRangeReader);
; // ./src/display/text_layer.js

var MAX_TEXT_DIVS_TO_RENDER = 100000;
var DEFAULT_FONT_SIZE = 30;
var DEFAULT_FONT_ASCENT = 0.8;
var _capability = /*#__PURE__*/_classPrivateFieldLooseKey("capability");
var _container2 = /*#__PURE__*/_classPrivateFieldLooseKey("container");
var _disableProcessItems = /*#__PURE__*/_classPrivateFieldLooseKey("disableProcessItems");
var _fontInspectorEnabled = /*#__PURE__*/_classPrivateFieldLooseKey("fontInspectorEnabled");
var _lang = /*#__PURE__*/_classPrivateFieldLooseKey("lang");
var _layoutTextParams = /*#__PURE__*/_classPrivateFieldLooseKey("layoutTextParams");
var _pageHeight2 = /*#__PURE__*/_classPrivateFieldLooseKey("pageHeight");
var _pageWidth2 = /*#__PURE__*/_classPrivateFieldLooseKey("pageWidth");
var _reader = /*#__PURE__*/_classPrivateFieldLooseKey("reader");
var _rootContainer = /*#__PURE__*/_classPrivateFieldLooseKey("rootContainer");
var _rotation3 = /*#__PURE__*/_classPrivateFieldLooseKey("rotation");
var _scale = /*#__PURE__*/_classPrivateFieldLooseKey("scale");
var _styleCache = /*#__PURE__*/_classPrivateFieldLooseKey("styleCache");
var _textContentItemsStr = /*#__PURE__*/_classPrivateFieldLooseKey("textContentItemsStr");
var _textContentSource = /*#__PURE__*/_classPrivateFieldLooseKey("textContentSource");
var _textDivs = /*#__PURE__*/_classPrivateFieldLooseKey("textDivs");
var _textDivProperties = /*#__PURE__*/_classPrivateFieldLooseKey("textDivProperties");
var _transform = /*#__PURE__*/_classPrivateFieldLooseKey("transform");
var _ascentCache = /*#__PURE__*/_classPrivateFieldLooseKey("ascentCache");
var _canvasContexts = /*#__PURE__*/_classPrivateFieldLooseKey("canvasContexts");
var _canvasCtxFonts = /*#__PURE__*/_classPrivateFieldLooseKey("canvasCtxFonts");
var _minFontSize = /*#__PURE__*/_classPrivateFieldLooseKey("minFontSize");
var _pendingTextLayers = /*#__PURE__*/_classPrivateFieldLooseKey("pendingTextLayers");
var _processItems = /*#__PURE__*/_classPrivateFieldLooseKey("processItems");
var _appendText = /*#__PURE__*/_classPrivateFieldLooseKey("appendText");
var _layout = /*#__PURE__*/_classPrivateFieldLooseKey("layout");
var _getCtx = /*#__PURE__*/_classPrivateFieldLooseKey("getCtx");
var _ensureCtxFont = /*#__PURE__*/_classPrivateFieldLooseKey("ensureCtxFont");
var _ensureMinFontSizeComputed = /*#__PURE__*/_classPrivateFieldLooseKey("ensureMinFontSizeComputed");
var _getAscent = /*#__PURE__*/_classPrivateFieldLooseKey("getAscent");
var _TextLayer = /*#__PURE__*/function () {
  function _TextLayer(_ref74) {
    var _globalThis$FontInspe,
      _this35 = this;
    var textContentSource = _ref74.textContentSource,
      container = _ref74.container,
      viewport = _ref74.viewport;
    _classCallCheck(this, _TextLayer);
    Object.defineProperty(this, _layout, {
      value: _layout2
    });
    Object.defineProperty(this, _appendText, {
      value: _appendText2
    });
    Object.defineProperty(this, _processItems, {
      value: _processItems2
    });
    Object.defineProperty(this, _capability, {
      writable: true,
      value: Promise.withResolvers()
    });
    Object.defineProperty(this, _container2, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _disableProcessItems, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _fontInspectorEnabled, {
      writable: true,
      value: !!((_globalThis$FontInspe = globalThis.FontInspector) !== null && _globalThis$FontInspe !== void 0 && _globalThis$FontInspe.enabled)
    });
    Object.defineProperty(this, _lang, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _layoutTextParams, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _pageHeight2, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _pageWidth2, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _reader, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _rootContainer, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _rotation3, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _scale, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _styleCache, {
      writable: true,
      value: Object.create(null)
    });
    Object.defineProperty(this, _textContentItemsStr, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _textContentSource, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _textDivs, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _textDivProperties, {
      writable: true,
      value: new WeakMap()
    });
    Object.defineProperty(this, _transform, {
      writable: true,
      value: null
    });
    if (textContentSource instanceof ReadableStream) {
      _classPrivateFieldLooseBase(this, _textContentSource)[_textContentSource] = textContentSource;
    } else if (_typeof(textContentSource) === "object") {
      _classPrivateFieldLooseBase(this, _textContentSource)[_textContentSource] = new ReadableStream({
        start: function start(controller) {
          controller.enqueue(textContentSource);
          controller.close();
        }
      });
    } else {
      throw new Error('No "textContentSource" parameter specified.');
    }
    _classPrivateFieldLooseBase(this, _container2)[_container2] = _classPrivateFieldLooseBase(this, _rootContainer)[_rootContainer] = container;
    _classPrivateFieldLooseBase(this, _scale)[_scale] = viewport.scale * (globalThis.devicePixelRatio || 1);
    _classPrivateFieldLooseBase(this, _rotation3)[_rotation3] = viewport.rotation;
    _classPrivateFieldLooseBase(this, _layoutTextParams)[_layoutTextParams] = {
      div: null,
      properties: null,
      ctx: null
    };
    var _viewport$rawDims2 = viewport.rawDims,
      pageWidth = _viewport$rawDims2.pageWidth,
      pageHeight = _viewport$rawDims2.pageHeight,
      pageX = _viewport$rawDims2.pageX,
      pageY = _viewport$rawDims2.pageY;
    _classPrivateFieldLooseBase(this, _transform)[_transform] = [1, 0, 0, -1, -pageX, pageY + pageHeight];
    _classPrivateFieldLooseBase(this, _pageWidth2)[_pageWidth2] = pageWidth;
    _classPrivateFieldLooseBase(this, _pageHeight2)[_pageHeight2] = pageHeight;
    _classPrivateFieldLooseBase(_TextLayer, _ensureMinFontSizeComputed)[_ensureMinFontSizeComputed]();
    _setLayerDimensions(container, viewport);
    _classPrivateFieldLooseBase(this, _capability)[_capability].promise.finally(function () {
      _classPrivateFieldLooseBase(_TextLayer, _pendingTextLayers)[_pendingTextLayers].delete(_this35);
      _classPrivateFieldLooseBase(_this35, _layoutTextParams)[_layoutTextParams] = null;
      _classPrivateFieldLooseBase(_this35, _styleCache)[_styleCache] = null;
    }).catch(function () {});
  }
  return _createClass(_TextLayer, [{
    key: "render",
    value: function render() {
      var _this36 = this;
      var _pump = function pump() {
        _classPrivateFieldLooseBase(_this36, _reader)[_reader].read().then(function (_ref75) {
          var _classPrivateFieldLoo60, _classPrivateFieldLoo61;
          var value = _ref75.value,
            done = _ref75.done;
          if (done) {
            _classPrivateFieldLooseBase(_this36, _capability)[_capability].resolve();
            return;
          }
          (_classPrivateFieldLoo61 = (_classPrivateFieldLoo60 = _classPrivateFieldLooseBase(_this36, _lang))[_lang]) !== null && _classPrivateFieldLoo61 !== void 0 ? _classPrivateFieldLoo61 : _classPrivateFieldLoo60[_lang] = value.lang;
          Object.assign(_classPrivateFieldLooseBase(_this36, _styleCache)[_styleCache], value.styles);
          _classPrivateFieldLooseBase(_this36, _processItems)[_processItems](value.items);
          _pump();
        }, _classPrivateFieldLooseBase(_this36, _capability)[_capability].reject);
      };
      _classPrivateFieldLooseBase(this, _reader)[_reader] = _classPrivateFieldLooseBase(this, _textContentSource)[_textContentSource].getReader();
      _classPrivateFieldLooseBase(_TextLayer, _pendingTextLayers)[_pendingTextLayers].add(this);
      _pump();
      return _classPrivateFieldLooseBase(this, _capability)[_capability].promise;
    }
  }, {
    key: "update",
    value: function update(_ref76) {
      var viewport = _ref76.viewport,
        _ref76$onBefore = _ref76.onBefore,
        onBefore = _ref76$onBefore === void 0 ? null : _ref76$onBefore;
      var scale = viewport.scale * (globalThis.devicePixelRatio || 1);
      var rotation = viewport.rotation;
      if (rotation !== _classPrivateFieldLooseBase(this, _rotation3)[_rotation3]) {
        onBefore === null || onBefore === void 0 || onBefore();
        _classPrivateFieldLooseBase(this, _rotation3)[_rotation3] = rotation;
        _setLayerDimensions(_classPrivateFieldLooseBase(this, _rootContainer)[_rootContainer], {
          rotation: rotation
        });
      }
      if (scale !== _classPrivateFieldLooseBase(this, _scale)[_scale]) {
        onBefore === null || onBefore === void 0 || onBefore();
        _classPrivateFieldLooseBase(this, _scale)[_scale] = scale;
        var params = {
          div: null,
          properties: null,
          ctx: _classPrivateFieldLooseBase(_TextLayer, _getCtx)[_getCtx](_classPrivateFieldLooseBase(this, _lang)[_lang])
        };
        var _iterator92 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _textDivs)[_textDivs]),
          _step92;
        try {
          for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
            var div = _step92.value;
            params.properties = _classPrivateFieldLooseBase(this, _textDivProperties)[_textDivProperties].get(div);
            params.div = div;
            _classPrivateFieldLooseBase(this, _layout)[_layout](params);
          }
        } catch (err) {
          _iterator92.e(err);
        } finally {
          _iterator92.f();
        }
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _classPrivateFieldLoo62;
      var abortEx = new _AbortException("TextLayer task cancelled.");
      (_classPrivateFieldLoo62 = _classPrivateFieldLooseBase(this, _reader)[_reader]) === null || _classPrivateFieldLoo62 === void 0 || _classPrivateFieldLoo62.cancel(abortEx).catch(function () {});
      _classPrivateFieldLooseBase(this, _reader)[_reader] = null;
      _classPrivateFieldLooseBase(this, _capability)[_capability].reject(abortEx);
    }
  }, {
    key: "textDivs",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _textDivs)[_textDivs];
    }
  }, {
    key: "textContentItemsStr",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _textContentItemsStr)[_textContentItemsStr];
    }
  }], [{
    key: "fontFamilyMap",
    get: function get() {
      var _util_FeatureTest$pla = util_FeatureTest.platform,
        isWindows = _util_FeatureTest$pla.isWindows,
        isFirefox = _util_FeatureTest$pla.isFirefox;
      return _shadow(this, "fontFamilyMap", new Map([["sans-serif", "".concat(isWindows && isFirefox ? "Calibri, " : "", "sans-serif")], ["monospace", "".concat(isWindows && isFirefox ? "Lucida Console, " : "", "monospace")]]));
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (_classPrivateFieldLooseBase(this, _pendingTextLayers)[_pendingTextLayers].size > 0) {
        return;
      }
      _classPrivateFieldLooseBase(this, _ascentCache)[_ascentCache].clear();
      var _iterator93 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _canvasContexts)[_canvasContexts].values()),
        _step93;
      try {
        for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
          var _ref77 = _step93.value;
          var canvas = _ref77.canvas;
          canvas.remove();
        }
      } catch (err) {
        _iterator93.e(err);
      } finally {
        _iterator93.f();
      }
      _classPrivateFieldLooseBase(this, _canvasContexts)[_canvasContexts].clear();
    }
  }]);
}();
_TextLayer2 = _TextLayer;
function _processItems2(items) {
  var _classPrivateFieldLoo139, _classPrivateFieldLoo140;
  if (_classPrivateFieldLooseBase(this, _disableProcessItems)[_disableProcessItems]) {
    return;
  }
  (_classPrivateFieldLoo140 = (_classPrivateFieldLoo139 = _classPrivateFieldLooseBase(this, _layoutTextParams)[_layoutTextParams]).ctx) !== null && _classPrivateFieldLoo140 !== void 0 ? _classPrivateFieldLoo140 : _classPrivateFieldLoo139.ctx = _classPrivateFieldLooseBase(_TextLayer2, _getCtx)[_getCtx](_classPrivateFieldLooseBase(this, _lang)[_lang]);
  var textDivs = _classPrivateFieldLooseBase(this, _textDivs)[_textDivs],
    textContentItemsStr = _classPrivateFieldLooseBase(this, _textContentItemsStr)[_textContentItemsStr];
  var _iterator168 = _createForOfIteratorHelper(items),
    _step168;
  try {
    for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
      var item = _step168.value;
      if (textDivs.length > MAX_TEXT_DIVS_TO_RENDER) {
        warn("Ignoring additional textDivs for performance reasons.");
        _classPrivateFieldLooseBase(this, _disableProcessItems)[_disableProcessItems] = true;
        return;
      }
      if (item.str === undefined) {
        if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
          var parent = _classPrivateFieldLooseBase(this, _container2)[_container2];
          _classPrivateFieldLooseBase(this, _container2)[_container2] = document.createElement("span");
          _classPrivateFieldLooseBase(this, _container2)[_container2].classList.add("markedContent");
          if (item.id !== null) {
            _classPrivateFieldLooseBase(this, _container2)[_container2].setAttribute("id", "".concat(item.id));
          }
          parent.append(_classPrivateFieldLooseBase(this, _container2)[_container2]);
        } else if (item.type === "endMarkedContent") {
          _classPrivateFieldLooseBase(this, _container2)[_container2] = _classPrivateFieldLooseBase(this, _container2)[_container2].parentNode;
        }
        continue;
      }
      textContentItemsStr.push(item.str);
      _classPrivateFieldLooseBase(this, _appendText)[_appendText](item);
    }
  } catch (err) {
    _iterator168.e(err);
  } finally {
    _iterator168.f();
  }
}
function _appendText2(geom) {
  var textDiv = document.createElement("span");
  var textDivProperties = {
    angle: 0,
    canvasWidth: 0,
    hasText: geom.str !== "",
    hasEOL: geom.hasEOL,
    fontSize: 0
  };
  _classPrivateFieldLooseBase(this, _textDivs)[_textDivs].push(textDiv);
  var tx = _Util.transform(_classPrivateFieldLooseBase(this, _transform)[_transform], geom.transform);
  var angle = Math.atan2(tx[1], tx[0]);
  var style = _classPrivateFieldLooseBase(this, _styleCache)[_styleCache][geom.fontName];
  if (style.vertical) {
    angle += Math.PI / 2;
  }
  var fontFamily = _classPrivateFieldLooseBase(this, _fontInspectorEnabled)[_fontInspectorEnabled] && style.fontSubstitution || style.fontFamily;
  fontFamily = _TextLayer2.fontFamilyMap.get(fontFamily) || fontFamily;
  var fontHeight = Math.hypot(tx[2], tx[3]);
  var fontAscent = fontHeight * _classPrivateFieldLooseBase(_TextLayer2, _getAscent)[_getAscent](fontFamily, _classPrivateFieldLooseBase(this, _lang)[_lang]);
  var left, top;
  if (angle === 0) {
    left = tx[4];
    top = tx[5] - fontAscent;
  } else {
    left = tx[4] + fontAscent * Math.sin(angle);
    top = tx[5] - fontAscent * Math.cos(angle);
  }
  var scaleFactorStr = "calc(var(--scale-factor)*";
  var divStyle = textDiv.style;
  if (_classPrivateFieldLooseBase(this, _container2)[_container2] === _classPrivateFieldLooseBase(this, _rootContainer)[_rootContainer]) {
    divStyle.left = "".concat((100 * left / _classPrivateFieldLooseBase(this, _pageWidth2)[_pageWidth2]).toFixed(2), "%");
    divStyle.top = "".concat((100 * top / _classPrivateFieldLooseBase(this, _pageHeight2)[_pageHeight2]).toFixed(2), "%");
  } else {
    divStyle.left = "".concat(scaleFactorStr).concat(left.toFixed(2), "px)");
    divStyle.top = "".concat(scaleFactorStr).concat(top.toFixed(2), "px)");
  }
  divStyle.fontSize = "".concat(scaleFactorStr).concat((_classPrivateFieldLooseBase(_TextLayer2, _minFontSize)[_minFontSize] * fontHeight).toFixed(2), "px)");
  divStyle.fontFamily = fontFamily;
  textDivProperties.fontSize = fontHeight;
  textDiv.setAttribute("role", "presentation");
  textDiv.textContent = geom.str;
  textDiv.dir = geom.dir;
  if (_classPrivateFieldLooseBase(this, _fontInspectorEnabled)[_fontInspectorEnabled]) {
    textDiv.dataset.fontName = style.fontSubstitutionLoadedName || geom.fontName;
  }
  if (angle !== 0) {
    textDivProperties.angle = angle * (180 / Math.PI);
  }
  var shouldScaleText = false;
  if (geom.str.length > 1) {
    shouldScaleText = true;
  } else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
    var absScaleX = Math.abs(geom.transform[0]),
      absScaleY = Math.abs(geom.transform[3]);
    if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) {
      shouldScaleText = true;
    }
  }
  if (shouldScaleText) {
    textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
  }
  _classPrivateFieldLooseBase(this, _textDivProperties)[_textDivProperties].set(textDiv, textDivProperties);
  _classPrivateFieldLooseBase(this, _layoutTextParams)[_layoutTextParams].div = textDiv;
  _classPrivateFieldLooseBase(this, _layoutTextParams)[_layoutTextParams].properties = textDivProperties;
  _classPrivateFieldLooseBase(this, _layout)[_layout](_classPrivateFieldLooseBase(this, _layoutTextParams)[_layoutTextParams]);
  if (textDivProperties.hasText) {
    _classPrivateFieldLooseBase(this, _container2)[_container2].append(textDiv);
  }
  if (textDivProperties.hasEOL) {
    var br = document.createElement("br");
    br.setAttribute("role", "presentation");
    _classPrivateFieldLooseBase(this, _container2)[_container2].append(br);
  }
}
function _layout2(params) {
  var div = params.div,
    properties = params.properties,
    ctx = params.ctx;
  var style = div.style;
  var transform = "";
  if (_classPrivateFieldLooseBase(_TextLayer2, _minFontSize)[_minFontSize] > 1) {
    transform = "scale(".concat(1 / _classPrivateFieldLooseBase(_TextLayer2, _minFontSize)[_minFontSize], ")");
  }
  if (properties.canvasWidth !== 0 && properties.hasText) {
    var fontFamily = style.fontFamily;
    var canvasWidth = properties.canvasWidth,
      fontSize = properties.fontSize;
    _classPrivateFieldLooseBase(_TextLayer2, _ensureCtxFont)[_ensureCtxFont](ctx, fontSize * _classPrivateFieldLooseBase(this, _scale)[_scale], fontFamily);
    var _ctx$measureText = ctx.measureText(div.textContent),
      width = _ctx$measureText.width;
    if (width > 0) {
      transform = "scaleX(".concat(canvasWidth * _classPrivateFieldLooseBase(this, _scale)[_scale] / width, ") ").concat(transform);
    }
  }
  if (properties.angle !== 0) {
    transform = "rotate(".concat(properties.angle, "deg) ").concat(transform);
  }
  if (transform.length > 0) {
    style.transform = transform;
  }
}
function _getCtx2() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var ctx = _classPrivateFieldLooseBase(this, _canvasContexts)[_canvasContexts].get(lang || (lang = ""));
  if (!ctx) {
    var canvas = document.createElement("canvas");
    canvas.className = "hiddenCanvasElement";
    canvas.lang = lang;
    document.body.append(canvas);
    ctx = canvas.getContext("2d", {
      alpha: false,
      willReadFrequently: true
    });
    _classPrivateFieldLooseBase(this, _canvasContexts)[_canvasContexts].set(lang, ctx);
    _classPrivateFieldLooseBase(this, _canvasCtxFonts)[_canvasCtxFonts].set(ctx, {
      size: 0,
      family: ""
    });
  }
  return ctx;
}
function _ensureCtxFont2(ctx, size, family) {
  var cached = _classPrivateFieldLooseBase(this, _canvasCtxFonts)[_canvasCtxFonts].get(ctx);
  if (size === cached.size && family === cached.family) {
    return;
  }
  ctx.font = "".concat(size, "px ").concat(family);
  cached.size = size;
  cached.family = family;
}
function _ensureMinFontSizeComputed2() {
  if (_classPrivateFieldLooseBase(this, _minFontSize)[_minFontSize] !== null) {
    return;
  }
  var div = document.createElement("div");
  div.style.opacity = 0;
  div.style.lineHeight = 1;
  div.style.fontSize = "1px";
  div.style.position = "absolute";
  div.textContent = "X";
  document.body.append(div);
  _classPrivateFieldLooseBase(this, _minFontSize)[_minFontSize] = div.getBoundingClientRect().height;
  div.remove();
}
function _getAscent2(fontFamily, lang) {
  var cachedAscent = _classPrivateFieldLooseBase(this, _ascentCache)[_ascentCache].get(fontFamily);
  if (cachedAscent) {
    return cachedAscent;
  }
  var ctx = _classPrivateFieldLooseBase(this, _getCtx)[_getCtx](lang);
  ctx.canvas.width = ctx.canvas.height = DEFAULT_FONT_SIZE;
  _classPrivateFieldLooseBase(this, _ensureCtxFont)[_ensureCtxFont](ctx, DEFAULT_FONT_SIZE, fontFamily);
  var metrics = ctx.measureText("");
  var ascent = metrics.fontBoundingBoxAscent;
  var descent = Math.abs(metrics.fontBoundingBoxDescent);
  if (ascent) {
    var _ratio2 = ascent / (ascent + descent);
    _classPrivateFieldLooseBase(this, _ascentCache)[_ascentCache].set(fontFamily, _ratio2);
    ctx.canvas.width = ctx.canvas.height = 0;
    return _ratio2;
  }
  ctx.strokeStyle = "red";
  ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
  ctx.strokeText("g", 0, 0);
  var pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
  descent = 0;
  for (var i = pixels.length - 1 - 3; i >= 0; i -= 4) {
    if (pixels[i] > 0) {
      descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
      break;
    }
  }
  ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
  ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
  pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
  ascent = 0;
  for (var _i31 = 0, ii = pixels.length; _i31 < ii; _i31 += 4) {
    if (pixels[_i31] > 0) {
      ascent = DEFAULT_FONT_SIZE - Math.floor(_i31 / 4 / DEFAULT_FONT_SIZE);
      break;
    }
  }
  ctx.canvas.width = ctx.canvas.height = 0;
  var ratio = ascent ? ascent / (ascent + descent) : DEFAULT_FONT_ASCENT;
  _classPrivateFieldLooseBase(this, _ascentCache)[_ascentCache].set(fontFamily, ratio);
  return ratio;
}
Object.defineProperty(_TextLayer, _getAscent, {
  value: _getAscent2
});
Object.defineProperty(_TextLayer, _ensureMinFontSizeComputed, {
  value: _ensureMinFontSizeComputed2
});
Object.defineProperty(_TextLayer, _ensureCtxFont, {
  value: _ensureCtxFont2
});
Object.defineProperty(_TextLayer, _getCtx, {
  value: _getCtx2
});
Object.defineProperty(_TextLayer, _ascentCache, {
  writable: true,
  value: new Map()
});
Object.defineProperty(_TextLayer, _canvasContexts, {
  writable: true,
  value: new Map()
});
Object.defineProperty(_TextLayer, _canvasCtxFonts, {
  writable: true,
  value: new WeakMap()
});
Object.defineProperty(_TextLayer, _minFontSize, {
  writable: true,
  value: null
});
Object.defineProperty(_TextLayer, _pendingTextLayers, {
  writable: true,
  value: new Set()
});
; // ./src/display/xfa_text.js
var XfaText = /*#__PURE__*/function () {
  function XfaText() {
    _classCallCheck(this, XfaText);
  }
  return _createClass(XfaText, null, [{
    key: "textContent",
    value: function textContent(xfa) {
      var items = [];
      var output = {
        items: items,
        styles: Object.create(null)
      };
      function walk(node) {
        var _node$attributes;
        if (!node) {
          return;
        }
        var str = null;
        var name = node.name;
        if (name === "#text") {
          str = node.value;
        } else if (!XfaText.shouldBuildText(name)) {
          return;
        } else if (node !== null && node !== void 0 && (_node$attributes = node.attributes) !== null && _node$attributes !== void 0 && _node$attributes.textContent) {
          str = node.attributes.textContent;
        } else if (node.value) {
          str = node.value;
        }
        if (str !== null) {
          items.push({
            str: str
          });
        }
        if (!node.children) {
          return;
        }
        var _iterator94 = _createForOfIteratorHelper(node.children),
          _step94;
        try {
          for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
            var child = _step94.value;
            walk(child);
          }
        } catch (err) {
          _iterator94.e(err);
        } finally {
          _iterator94.f();
        }
      }
      walk(xfa);
      return output;
    }
  }, {
    key: "shouldBuildText",
    value: function shouldBuildText(name) {
      return !(name === "textarea" || name === "input" || name === "option" || name === "select");
    }
  }]);
}();
; // ./src/display/api.js

var DEFAULT_RANGE_CHUNK_SIZE = 65536;
var RENDERING_CANCELLED_TIMEOUT = 100;
var DELAYED_CLEANUP_TIMEOUT = 5000;
var DefaultCanvasFactory = isNodeJS ? NodeCanvasFactory : DOMCanvasFactory;
var DefaultCMapReaderFactory = isNodeJS ? NodeCMapReaderFactory : DOMCMapReaderFactory;
var DefaultFilterFactory = isNodeJS ? NodeFilterFactory : DOMFilterFactory;
var DefaultStandardFontDataFactory = isNodeJS ? NodeStandardFontDataFactory : DOMStandardFontDataFactory;
function _getDocument() {
  var _src$password, _window, _src$length;
  var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (typeof src === "string" || src instanceof URL) {
    src = {
      url: src
    };
  } else if (src instanceof ArrayBuffer || ArrayBuffer.isView(src)) {
    src = {
      data: src
    };
  }
  var task = new PDFDocumentLoadingTask();
  var docId = task.docId;
  var url = src.url ? getUrlProp(src.url) : null;
  var data = src.data ? getDataProp(src.data) : null;
  var httpHeaders = src.httpHeaders || null;
  var withCredentials = src.withCredentials === true;
  var password = (_src$password = src.password) !== null && _src$password !== void 0 ? _src$password : null;
  var rangeTransport = src.range instanceof _PDFDataRangeTransport ? src.range : null;
  var rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
  var worker = src.worker instanceof _PDFWorker ? src.worker : null;
  var verbosity = src.verbosity;
  var docBaseUrl = typeof src.docBaseUrl === "string" && !_isDataScheme(src.docBaseUrl) ? src.docBaseUrl : null;
  var cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
  var cMapPacked = src.cMapPacked !== false;
  var CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
  var standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
  var StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
  var ignoreErrors = src.stopAtErrors !== true;
  var maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
  var isEvalSupported = src.isEvalSupported !== false;
  var isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !isNodeJS;
  var isChrome = typeof src.isChrome === "boolean" ? src.isChrome : !util_FeatureTest.platform.isFirefox && typeof window !== "undefined" && !!((_window = window) !== null && _window !== void 0 && _window.chrome);
  var canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
  var disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : isNodeJS;
  var fontExtraProperties = src.fontExtraProperties === true;
  var enableXfa = src.enableXfa === true;
  var ownerDocument = src.ownerDocument || globalThis.document;
  var disableRange = src.disableRange === true;
  var disableStream = src.disableStream === true;
  var disableAutoFetch = src.disableAutoFetch === true;
  var pdfBug = src.pdfBug === true;
  var CanvasFactory = src.CanvasFactory || DefaultCanvasFactory;
  var FilterFactory = src.FilterFactory || DefaultFilterFactory;
  var enableHWA = src.enableHWA === true;
  var length = rangeTransport ? rangeTransport.length : (_src$length = src.length) !== null && _src$length !== void 0 ? _src$length : NaN;
  var useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !isNodeJS && !disableFontFace;
  var useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === DOMCMapReaderFactory && StandardFontDataFactory === DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && isValidFetchUrl(cMapUrl, document.baseURI) && isValidFetchUrl(standardFontDataUrl, document.baseURI);
  if (src.canvasFactory) {
    deprecated("`canvasFactory`-instance option, please use `CanvasFactory` instead.");
  }
  if (src.filterFactory) {
    deprecated("`filterFactory`-instance option, please use `FilterFactory` instead.");
  }
  var styleElement = null;
  setVerbosityLevel(verbosity);
  var transportFactory = {
    canvasFactory: new CanvasFactory({
      ownerDocument: ownerDocument,
      enableHWA: enableHWA
    }),
    filterFactory: new FilterFactory({
      docId: docId,
      ownerDocument: ownerDocument
    }),
    cMapReaderFactory: useWorkerFetch ? null : new CMapReaderFactory({
      baseUrl: cMapUrl,
      isCompressed: cMapPacked
    }),
    standardFontDataFactory: useWorkerFetch ? null : new StandardFontDataFactory({
      baseUrl: standardFontDataUrl
    })
  };
  if (!worker) {
    var workerParams = {
      verbosity: verbosity,
      port: _GlobalWorkerOptions.workerPort
    };
    worker = workerParams.port ? _PDFWorker.fromPort(workerParams) : new _PDFWorker(workerParams);
    task._worker = worker;
  }
  var docParams = {
    docId: docId,
    apiVersion: "4.8.69",
    data: data,
    password: password,
    disableAutoFetch: disableAutoFetch,
    rangeChunkSize: rangeChunkSize,
    length: length,
    docBaseUrl: docBaseUrl,
    enableXfa: enableXfa,
    evaluatorOptions: {
      maxImageSize: maxImageSize,
      disableFontFace: disableFontFace,
      ignoreErrors: ignoreErrors,
      isEvalSupported: isEvalSupported,
      isOffscreenCanvasSupported: isOffscreenCanvasSupported,
      isChrome: isChrome,
      canvasMaxAreaInBytes: canvasMaxAreaInBytes,
      fontExtraProperties: fontExtraProperties,
      useSystemFonts: useSystemFonts,
      cMapUrl: useWorkerFetch ? cMapUrl : null,
      standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
    }
  };
  var transportParams = {
    disableFontFace: disableFontFace,
    fontExtraProperties: fontExtraProperties,
    ownerDocument: ownerDocument,
    pdfBug: pdfBug,
    styleElement: styleElement,
    loadingParams: {
      disableAutoFetch: disableAutoFetch,
      enableXfa: enableXfa
    }
  };
  worker.promise.then(function () {
    if (task.destroyed) {
      throw new Error("Loading aborted");
    }
    if (worker.destroyed) {
      throw new Error("Worker was destroyed");
    }
    var workerIdPromise = worker.messageHandler.sendWithPromise("GetDocRequest", docParams, data ? [data.buffer] : null);
    var networkStream;
    if (rangeTransport) {
      networkStream = new PDFDataTransportStream(rangeTransport, {
        disableRange: disableRange,
        disableStream: disableStream
      });
    } else if (!data) {
      if (!url) {
        throw new Error("getDocument - no `url` parameter provided.");
      }
      var NetworkStream;
      if (isNodeJS) {
        var isFetchSupported = typeof fetch !== "undefined" && typeof Response !== "undefined" && "body" in Response.prototype;
        NetworkStream = isFetchSupported && isValidFetchUrl(url) ? PDFFetchStream : PDFNodeStream;
      } else {
        NetworkStream = isValidFetchUrl(url) ? PDFFetchStream : PDFNetworkStream;
      }
      networkStream = new NetworkStream({
        url: url,
        length: length,
        httpHeaders: httpHeaders,
        withCredentials: withCredentials,
        rangeChunkSize: rangeChunkSize,
        disableRange: disableRange,
        disableStream: disableStream
      });
    }
    return workerIdPromise.then(function (workerId) {
      if (task.destroyed) {
        throw new Error("Loading aborted");
      }
      if (worker.destroyed) {
        throw new Error("Worker was destroyed");
      }
      var messageHandler = new MessageHandler(docId, workerId, worker.port);
      var transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
      task._transport = transport;
      messageHandler.send("Ready", null);
    });
  }).catch(task._capability.reject);
  return task;
}
function getUrlProp(val) {
  if (val instanceof URL) {
    return val.href;
  }
  try {
    return new URL(val, window.location).href;
  } catch (_unused10) {
    if (isNodeJS && typeof val === "string") {
      return val;
    }
  }
  throw new Error("Invalid PDF url data: " + "either string or URL-object is expected in the url property.");
}
function getDataProp(val) {
  if (isNodeJS && typeof Buffer !== "undefined" && val instanceof Buffer) {
    throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
  }
  if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) {
    return val;
  }
  if (typeof val === "string") {
    return stringToBytes(val);
  }
  if (val instanceof ArrayBuffer || ArrayBuffer.isView(val) || _typeof(val) === "object" && !isNaN(val === null || val === void 0 ? void 0 : val.length)) {
    return new Uint8Array(val);
  }
  throw new Error("Invalid PDF binary data: either TypedArray, " + "string, or array-like object is expected in the data property.");
}
function isRefProxy(ref) {
  return _typeof(ref) === "object" && Number.isInteger(ref === null || ref === void 0 ? void 0 : ref.num) && ref.num >= 0 && Number.isInteger(ref === null || ref === void 0 ? void 0 : ref.gen) && ref.gen >= 0;
}
var _docId2 = /*#__PURE__*/_classPrivateFieldLooseKey("docId");
var PDFDocumentLoadingTask = /*#__PURE__*/function () {
  function PDFDocumentLoadingTask() {
    _classCallCheck(this, PDFDocumentLoadingTask);
    this._capability = Promise.withResolvers();
    this._transport = null;
    this._worker = null;
    this.docId = "d".concat(_classPrivateFieldLooseBase(PDFDocumentLoadingTask, _docId2)[_docId2]++);
    this.destroyed = false;
    this.onPassword = null;
    this.onProgress = null;
  }
  return _createClass(PDFDocumentLoadingTask, [{
    key: "promise",
    get: function get() {
      return this._capability.promise;
    }
  }, {
    key: "destroy",
    value: function () {
      var _destroy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var _this$_worker, _this$_transport, _this$_worker2;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              this.destroyed = true;
              _context33.prev = 1;
              if ((_this$_worker = this._worker) !== null && _this$_worker !== void 0 && _this$_worker.port) {
                this._worker._pendingDestroy = true;
              }
              _context33.next = 5;
              return (_this$_transport = this._transport) === null || _this$_transport === void 0 ? void 0 : _this$_transport.destroy();
            case 5:
              _context33.next = 11;
              break;
            case 7:
              _context33.prev = 7;
              _context33.t0 = _context33["catch"](1);
              if ((_this$_worker2 = this._worker) !== null && _this$_worker2 !== void 0 && _this$_worker2.port) {
                delete this._worker._pendingDestroy;
              }
              throw _context33.t0;
            case 11:
              this._transport = null;
              if (this._worker) {
                this._worker.destroy();
                this._worker = null;
              }
            case 13:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this, [[1, 7]]);
      }));
      function destroy() {
        return _destroy.apply(this, arguments);
      }
      return destroy;
    }()
  }]);
}();
Object.defineProperty(PDFDocumentLoadingTask, _docId2, {
  writable: true,
  value: 0
});
var _PDFDataRangeTransport = /*#__PURE__*/function () {
  function _PDFDataRangeTransport(length, initialData) {
    var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var contentDispositionFilename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, _PDFDataRangeTransport);
    this.length = length;
    this.initialData = initialData;
    this.progressiveDone = progressiveDone;
    this.contentDispositionFilename = contentDispositionFilename;
    this._rangeListeners = [];
    this._progressListeners = [];
    this._progressiveReadListeners = [];
    this._progressiveDoneListeners = [];
    this._readyCapability = Promise.withResolvers();
  }
  return _createClass(_PDFDataRangeTransport, [{
    key: "addRangeListener",
    value: function addRangeListener(listener) {
      this._rangeListeners.push(listener);
    }
  }, {
    key: "addProgressListener",
    value: function addProgressListener(listener) {
      this._progressListeners.push(listener);
    }
  }, {
    key: "addProgressiveReadListener",
    value: function addProgressiveReadListener(listener) {
      this._progressiveReadListeners.push(listener);
    }
  }, {
    key: "addProgressiveDoneListener",
    value: function addProgressiveDoneListener(listener) {
      this._progressiveDoneListeners.push(listener);
    }
  }, {
    key: "onDataRange",
    value: function onDataRange(begin, chunk) {
      var _iterator95 = _createForOfIteratorHelper(this._rangeListeners),
        _step95;
      try {
        for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
          var listener = _step95.value;
          listener(begin, chunk);
        }
      } catch (err) {
        _iterator95.e(err);
      } finally {
        _iterator95.f();
      }
    }
  }, {
    key: "onDataProgress",
    value: function onDataProgress(loaded, total) {
      var _this37 = this;
      this._readyCapability.promise.then(function () {
        var _iterator96 = _createForOfIteratorHelper(_this37._progressListeners),
          _step96;
        try {
          for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
            var listener = _step96.value;
            listener(loaded, total);
          }
        } catch (err) {
          _iterator96.e(err);
        } finally {
          _iterator96.f();
        }
      });
    }
  }, {
    key: "onDataProgressiveRead",
    value: function onDataProgressiveRead(chunk) {
      var _this38 = this;
      this._readyCapability.promise.then(function () {
        var _iterator97 = _createForOfIteratorHelper(_this38._progressiveReadListeners),
          _step97;
        try {
          for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
            var listener = _step97.value;
            listener(chunk);
          }
        } catch (err) {
          _iterator97.e(err);
        } finally {
          _iterator97.f();
        }
      });
    }
  }, {
    key: "onDataProgressiveDone",
    value: function onDataProgressiveDone() {
      var _this39 = this;
      this._readyCapability.promise.then(function () {
        var _iterator98 = _createForOfIteratorHelper(_this39._progressiveDoneListeners),
          _step98;
        try {
          for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
            var listener = _step98.value;
            listener();
          }
        } catch (err) {
          _iterator98.e(err);
        } finally {
          _iterator98.f();
        }
      });
    }
  }, {
    key: "transportReady",
    value: function transportReady() {
      this._readyCapability.resolve();
    }
  }, {
    key: "requestDataRange",
    value: function requestDataRange(begin, end) {
      unreachable("Abstract method PDFDataRangeTransport.requestDataRange");
    }
  }, {
    key: "abort",
    value: function abort() {}
  }]);
}();
var PDFDocumentProxy = /*#__PURE__*/function () {
  function PDFDocumentProxy(pdfInfo, transport) {
    _classCallCheck(this, PDFDocumentProxy);
    this._pdfInfo = pdfInfo;
    this._transport = transport;
  }
  return _createClass(PDFDocumentProxy, [{
    key: "annotationStorage",
    get: function get() {
      return this._transport.annotationStorage;
    }
  }, {
    key: "canvasFactory",
    get: function get() {
      return this._transport.canvasFactory;
    }
  }, {
    key: "filterFactory",
    get: function get() {
      return this._transport.filterFactory;
    }
  }, {
    key: "numPages",
    get: function get() {
      return this._pdfInfo.numPages;
    }
  }, {
    key: "fingerprints",
    get: function get() {
      return this._pdfInfo.fingerprints;
    }
  }, {
    key: "isPureXfa",
    get: function get() {
      return _shadow(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
  }, {
    key: "allXfaHtml",
    get: function get() {
      return this._transport._htmlForXfa;
    }
  }, {
    key: "getPage",
    value: function getPage(pageNumber) {
      return this._transport.getPage(pageNumber);
    }
  }, {
    key: "getPageIndex",
    value: function getPageIndex(ref) {
      return this._transport.getPageIndex(ref);
    }
  }, {
    key: "getDestinations",
    value: function getDestinations() {
      return this._transport.getDestinations();
    }
  }, {
    key: "getDestination",
    value: function getDestination(id) {
      return this._transport.getDestination(id);
    }
  }, {
    key: "getPageLabels",
    value: function getPageLabels() {
      return this._transport.getPageLabels();
    }
  }, {
    key: "getPageLayout",
    value: function getPageLayout() {
      return this._transport.getPageLayout();
    }
  }, {
    key: "getPageMode",
    value: function getPageMode() {
      return this._transport.getPageMode();
    }
  }, {
    key: "getViewerPreferences",
    value: function getViewerPreferences() {
      return this._transport.getViewerPreferences();
    }
  }, {
    key: "getOpenAction",
    value: function getOpenAction() {
      return this._transport.getOpenAction();
    }
  }, {
    key: "getAttachments",
    value: function getAttachments() {
      return this._transport.getAttachments();
    }
  }, {
    key: "getJSActions",
    value: function getJSActions() {
      return this._transport.getDocJSActions();
    }
  }, {
    key: "getOutline",
    value: function getOutline() {
      return this._transport.getOutline();
    }
  }, {
    key: "getOptionalContentConfig",
    value: function getOptionalContentConfig() {
      var _ref78 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref78$intent = _ref78.intent,
        intent = _ref78$intent === void 0 ? "display" : _ref78$intent;
      var _this$_transport$getR = this._transport.getRenderingIntent(intent),
        renderingIntent = _this$_transport$getR.renderingIntent;
      return this._transport.getOptionalContentConfig(renderingIntent);
    }
  }, {
    key: "getPermissions",
    value: function getPermissions() {
      return this._transport.getPermissions();
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      return this._transport.getMetadata();
    }
  }, {
    key: "getMarkInfo",
    value: function getMarkInfo() {
      return this._transport.getMarkInfo();
    }
  }, {
    key: "getData",
    value: function getData() {
      return this._transport.getData();
    }
  }, {
    key: "saveDocument",
    value: function saveDocument() {
      return this._transport.saveDocument();
    }
  }, {
    key: "getDownloadInfo",
    value: function getDownloadInfo() {
      return this._transport.downloadInfoCapability.promise;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var keepLoadedFonts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this.loadingTask.destroy();
    }
  }, {
    key: "cachedPageNumber",
    value: function cachedPageNumber(ref) {
      return this._transport.cachedPageNumber(ref);
    }
  }, {
    key: "loadingParams",
    get: function get() {
      return this._transport.loadingParams;
    }
  }, {
    key: "loadingTask",
    get: function get() {
      return this._transport.loadingTask;
    }
  }, {
    key: "getFieldObjects",
    value: function getFieldObjects() {
      return this._transport.getFieldObjects();
    }
  }, {
    key: "hasJSActions",
    value: function hasJSActions() {
      return this._transport.hasJSActions();
    }
  }, {
    key: "getCalculationOrderIds",
    value: function getCalculationOrderIds() {
      return this._transport.getCalculationOrderIds();
    }
  }]);
}();
var _delayedCleanupTimeout = /*#__PURE__*/_classPrivateFieldLooseKey("delayedCleanupTimeout");
var _pendingCleanup = /*#__PURE__*/_classPrivateFieldLooseKey("pendingCleanup");
var _tryCleanup = /*#__PURE__*/_classPrivateFieldLooseKey("tryCleanup");
var _abortDelayedCleanup = /*#__PURE__*/_classPrivateFieldLooseKey("abortDelayedCleanup");
var PDFPageProxy = /*#__PURE__*/function () {
  function PDFPageProxy(pageIndex, pageInfo, transport) {
    var pdfBug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    _classCallCheck(this, PDFPageProxy);
    Object.defineProperty(this, _abortDelayedCleanup, {
      value: _abortDelayedCleanup2
    });
    Object.defineProperty(this, _tryCleanup, {
      value: _tryCleanup2
    });
    Object.defineProperty(this, _delayedCleanupTimeout, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _pendingCleanup, {
      writable: true,
      value: false
    });
    this._pageIndex = pageIndex;
    this._pageInfo = pageInfo;
    this._transport = transport;
    this._stats = pdfBug ? new StatTimer() : null;
    this._pdfBug = pdfBug;
    this.commonObjs = transport.commonObjs;
    this.objs = new PDFObjects();
    this._maybeCleanupAfterRender = false;
    this._intentStates = new Map();
    this.destroyed = false;
  }
  return _createClass(PDFPageProxy, [{
    key: "pageNumber",
    get: function get() {
      return this._pageIndex + 1;
    }
  }, {
    key: "rotate",
    get: function get() {
      return this._pageInfo.rotate;
    }
  }, {
    key: "ref",
    get: function get() {
      return this._pageInfo.ref;
    }
  }, {
    key: "userUnit",
    get: function get() {
      return this._pageInfo.userUnit;
    }
  }, {
    key: "view",
    get: function get() {
      return this._pageInfo.view;
    }
  }, {
    key: "getViewport",
    value: function getViewport() {
      var _ref79 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        scale = _ref79.scale,
        _ref79$rotation = _ref79.rotation,
        rotation = _ref79$rotation === void 0 ? this.rotate : _ref79$rotation,
        _ref79$offsetX = _ref79.offsetX,
        offsetX = _ref79$offsetX === void 0 ? 0 : _ref79$offsetX,
        _ref79$offsetY = _ref79.offsetY,
        offsetY = _ref79$offsetY === void 0 ? 0 : _ref79$offsetY,
        _ref79$dontFlip = _ref79.dontFlip,
        dontFlip = _ref79$dontFlip === void 0 ? false : _ref79$dontFlip;
      return new PageViewport({
        viewBox: this.view,
        scale: scale,
        rotation: rotation,
        offsetX: offsetX,
        offsetY: offsetY,
        dontFlip: dontFlip
      });
    }
  }, {
    key: "getAnnotations",
    value: function getAnnotations() {
      var _ref80 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref80$intent = _ref80.intent,
        intent = _ref80$intent === void 0 ? "display" : _ref80$intent;
      var _this$_transport$getR2 = this._transport.getRenderingIntent(intent),
        renderingIntent = _this$_transport$getR2.renderingIntent;
      return this._transport.getAnnotations(this._pageIndex, renderingIntent);
    }
  }, {
    key: "getJSActions",
    value: function getJSActions() {
      return this._transport.getPageJSActions(this._pageIndex);
    }
  }, {
    key: "filterFactory",
    get: function get() {
      return this._transport.filterFactory;
    }
  }, {
    key: "isPureXfa",
    get: function get() {
      return _shadow(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
  }, {
    key: "getXfa",
    value: function () {
      var _getXfa = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var _this$_transport$_htm;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              return _context34.abrupt("return", ((_this$_transport$_htm = this._transport._htmlForXfa) === null || _this$_transport$_htm === void 0 ? void 0 : _this$_transport$_htm.children[this._pageIndex]) || null);
            case 1:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function getXfa() {
        return _getXfa.apply(this, arguments);
      }
      return getXfa;
    }()
  }, {
    key: "render",
    value: function render(_ref81) {
      var _this$_stats,
        _this40 = this,
        _intentState;
      var canvasContext = _ref81.canvasContext,
        viewport = _ref81.viewport,
        _ref81$intent = _ref81.intent,
        intent = _ref81$intent === void 0 ? "display" : _ref81$intent,
        _ref81$annotationMode = _ref81.annotationMode,
        annotationMode = _ref81$annotationMode === void 0 ? _AnnotationMode.ENABLE : _ref81$annotationMode,
        _ref81$transform = _ref81.transform,
        transform = _ref81$transform === void 0 ? null : _ref81$transform,
        _ref81$background = _ref81.background,
        background = _ref81$background === void 0 ? null : _ref81$background,
        _ref81$optionalConten = _ref81.optionalContentConfigPromise,
        optionalContentConfigPromise = _ref81$optionalConten === void 0 ? null : _ref81$optionalConten,
        _ref81$annotationCanv = _ref81.annotationCanvasMap,
        annotationCanvasMap = _ref81$annotationCanv === void 0 ? null : _ref81$annotationCanv,
        _ref81$pageColors = _ref81.pageColors,
        pageColors = _ref81$pageColors === void 0 ? null : _ref81$pageColors,
        _ref81$printAnnotatio = _ref81.printAnnotationStorage,
        printAnnotationStorage = _ref81$printAnnotatio === void 0 ? null : _ref81$printAnnotatio,
        _ref81$isEditing = _ref81.isEditing,
        isEditing = _ref81$isEditing === void 0 ? false : _ref81$isEditing;
      (_this$_stats = this._stats) === null || _this$_stats === void 0 || _this$_stats.time("Overall");
      var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing);
      var renderingIntent = intentArgs.renderingIntent,
        cacheKey = intentArgs.cacheKey;
      _classPrivateFieldLooseBase(this, _pendingCleanup)[_pendingCleanup] = false;
      _classPrivateFieldLooseBase(this, _abortDelayedCleanup)[_abortDelayedCleanup]();
      optionalContentConfigPromise || (optionalContentConfigPromise = this._transport.getOptionalContentConfig(renderingIntent));
      var intentState = this._intentStates.get(cacheKey);
      if (!intentState) {
        intentState = Object.create(null);
        this._intentStates.set(cacheKey, intentState);
      }
      if (intentState.streamReaderCancelTimeout) {
        clearTimeout(intentState.streamReaderCancelTimeout);
        intentState.streamReaderCancelTimeout = null;
      }
      var intentPrint = !!(renderingIntent & RenderingIntentFlag.PRINT);
      if (!intentState.displayReadyCapability) {
        var _this$_stats2;
        intentState.displayReadyCapability = Promise.withResolvers();
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false,
          separateAnnots: null
        };
        (_this$_stats2 = this._stats) === null || _this$_stats2 === void 0 || _this$_stats2.time("Page Request");
        this._pumpOperatorList(intentArgs);
      }
      var complete = function complete(error) {
        intentState.renderTasks.delete(internalRenderTask);
        if (_this40._maybeCleanupAfterRender || intentPrint) {
          _classPrivateFieldLooseBase(_this40, _pendingCleanup)[_pendingCleanup] = true;
        }
        _classPrivateFieldLooseBase(_this40, _tryCleanup)[_tryCleanup](!intentPrint);
        if (error) {
          internalRenderTask.capability.reject(error);
          _this40._abortOperatorList({
            intentState: intentState,
            reason: error instanceof Error ? error : new Error(error)
          });
        } else {
          internalRenderTask.capability.resolve();
        }
        if (_this40._stats) {
          var _globalThis$Stats;
          _this40._stats.timeEnd("Rendering");
          _this40._stats.timeEnd("Overall");
          if ((_globalThis$Stats = globalThis.Stats) !== null && _globalThis$Stats !== void 0 && _globalThis$Stats.enabled) {
            globalThis.Stats.add(_this40.pageNumber, _this40._stats);
          }
        }
      };
      var internalRenderTask = new InternalRenderTask({
        callback: complete,
        params: {
          canvasContext: canvasContext,
          viewport: viewport,
          transform: transform,
          background: background
        },
        objs: this.objs,
        commonObjs: this.commonObjs,
        annotationCanvasMap: annotationCanvasMap,
        operatorList: intentState.operatorList,
        pageIndex: this._pageIndex,
        canvasFactory: this._transport.canvasFactory,
        filterFactory: this._transport.filterFactory,
        useRequestAnimationFrame: !intentPrint,
        pdfBug: this._pdfBug,
        pageColors: pageColors
      });
      ((_intentState = intentState).renderTasks || (_intentState.renderTasks = new Set())).add(internalRenderTask);
      var renderTask = internalRenderTask.task;
      Promise.all([intentState.displayReadyCapability.promise, optionalContentConfigPromise]).then(function (_ref82) {
        var _this40$_stats;
        var _ref83 = _slicedToArray(_ref82, 2),
          transparency = _ref83[0],
          optionalContentConfig = _ref83[1];
        if (_this40.destroyed) {
          complete();
          return;
        }
        (_this40$_stats = _this40._stats) === null || _this40$_stats === void 0 || _this40$_stats.time("Rendering");
        if (!(optionalContentConfig.renderingIntent & renderingIntent)) {
          throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` " + "and `PDFDocumentProxy.getOptionalContentConfig` methods.");
        }
        internalRenderTask.initializeGraphics({
          transparency: transparency,
          optionalContentConfig: optionalContentConfig
        });
        internalRenderTask.operatorListChanged();
      }).catch(complete);
      return renderTask;
    }
  }, {
    key: "getOperatorList",
    value: function getOperatorList() {
      var _ref84 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref84$intent = _ref84.intent,
        intent = _ref84$intent === void 0 ? "display" : _ref84$intent,
        _ref84$annotationMode = _ref84.annotationMode,
        annotationMode = _ref84$annotationMode === void 0 ? _AnnotationMode.ENABLE : _ref84$annotationMode,
        _ref84$printAnnotatio = _ref84.printAnnotationStorage,
        printAnnotationStorage = _ref84$printAnnotatio === void 0 ? null : _ref84$printAnnotatio,
        _ref84$isEditing = _ref84.isEditing,
        isEditing = _ref84$isEditing === void 0 ? false : _ref84$isEditing;
      function operatorListChanged() {
        if (intentState.operatorList.lastChunk) {
          intentState.opListReadCapability.resolve(intentState.operatorList);
          intentState.renderTasks.delete(opListTask);
        }
      }
      var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing, true);
      var intentState = this._intentStates.get(intentArgs.cacheKey);
      if (!intentState) {
        intentState = Object.create(null);
        this._intentStates.set(intentArgs.cacheKey, intentState);
      }
      var opListTask;
      if (!intentState.opListReadCapability) {
        var _intentState2, _this$_stats3;
        opListTask = Object.create(null);
        opListTask.operatorListChanged = operatorListChanged;
        intentState.opListReadCapability = Promise.withResolvers();
        ((_intentState2 = intentState).renderTasks || (_intentState2.renderTasks = new Set())).add(opListTask);
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false,
          separateAnnots: null
        };
        (_this$_stats3 = this._stats) === null || _this$_stats3 === void 0 || _this$_stats3.time("Page Request");
        this._pumpOperatorList(intentArgs);
      }
      return intentState.opListReadCapability.promise;
    }
  }, {
    key: "streamTextContent",
    value: function streamTextContent() {
      var _ref85 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref85$includeMarkedC = _ref85.includeMarkedContent,
        includeMarkedContent = _ref85$includeMarkedC === void 0 ? false : _ref85$includeMarkedC,
        _ref85$disableNormali = _ref85.disableNormalization,
        disableNormalization = _ref85$disableNormali === void 0 ? false : _ref85$disableNormali;
      var TEXT_CONTENT_CHUNK_SIZE = 100;
      return this._transport.messageHandler.sendWithStream("GetTextContent", {
        pageIndex: this._pageIndex,
        includeMarkedContent: includeMarkedContent === true,
        disableNormalization: disableNormalization === true
      }, {
        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
        size: function size(textContent) {
          return textContent.items.length;
        }
      });
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this._transport._htmlForXfa) {
        return this.getXfa().then(function (xfa) {
          return XfaText.textContent(xfa);
        });
      }
      var readableStream = this.streamTextContent(params);
      return new Promise(function (resolve, reject) {
        function pump() {
          reader.read().then(function (_ref86) {
            var _textContent$lang, _textContent$items;
            var value = _ref86.value,
              done = _ref86.done;
            if (done) {
              resolve(textContent);
              return;
            }
            (_textContent$lang = textContent.lang) !== null && _textContent$lang !== void 0 ? _textContent$lang : textContent.lang = value.lang;
            Object.assign(textContent.styles, value.styles);
            (_textContent$items = textContent.items).push.apply(_textContent$items, _toConsumableArray(value.items));
            pump();
          }, reject);
        }
        var reader = readableStream.getReader();
        var textContent = {
          items: [],
          styles: Object.create(null),
          lang: null
        };
        pump();
      });
    }
  }, {
    key: "getStructTree",
    value: function getStructTree() {
      return this._transport.getStructTree(this._pageIndex);
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      this.destroyed = true;
      var waitOn = [];
      var _iterator99 = _createForOfIteratorHelper(this._intentStates.values()),
        _step99;
      try {
        for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
          var intentState = _step99.value;
          this._abortOperatorList({
            intentState: intentState,
            reason: new Error("Page was destroyed."),
            force: true
          });
          if (intentState.opListReadCapability) {
            continue;
          }
          var _iterator100 = _createForOfIteratorHelper(intentState.renderTasks),
            _step100;
          try {
            for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
              var internalRenderTask = _step100.value;
              waitOn.push(internalRenderTask.completed);
              internalRenderTask.cancel();
            }
          } catch (err) {
            _iterator100.e(err);
          } finally {
            _iterator100.f();
          }
        }
      } catch (err) {
        _iterator99.e(err);
      } finally {
        _iterator99.f();
      }
      this.objs.clear();
      _classPrivateFieldLooseBase(this, _pendingCleanup)[_pendingCleanup] = false;
      _classPrivateFieldLooseBase(this, _abortDelayedCleanup)[_abortDelayedCleanup]();
      return Promise.all(waitOn);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _classPrivateFieldLooseBase(this, _pendingCleanup)[_pendingCleanup] = true;
      var success = _classPrivateFieldLooseBase(this, _tryCleanup)[_tryCleanup](false);
      if (resetStats && success) {
        this._stats && (this._stats = new StatTimer());
      }
      return success;
    }
  }, {
    key: "_startRenderPage",
    value: function _startRenderPage(transparency, cacheKey) {
      var _this$_stats4, _intentState$displayR;
      var intentState = this._intentStates.get(cacheKey);
      if (!intentState) {
        return;
      }
      (_this$_stats4 = this._stats) === null || _this$_stats4 === void 0 || _this$_stats4.timeEnd("Page Request");
      (_intentState$displayR = intentState.displayReadyCapability) === null || _intentState$displayR === void 0 || _intentState$displayR.resolve(transparency);
    }
  }, {
    key: "_renderPageChunk",
    value: function _renderPageChunk(operatorListChunk, intentState) {
      for (var i = 0, ii = operatorListChunk.length; i < ii; i++) {
        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
      }
      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
      intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
      var _iterator101 = _createForOfIteratorHelper(intentState.renderTasks),
        _step101;
      try {
        for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
          var internalRenderTask = _step101.value;
          internalRenderTask.operatorListChanged();
        }
      } catch (err) {
        _iterator101.e(err);
      } finally {
        _iterator101.f();
      }
      if (operatorListChunk.lastChunk) {
        _classPrivateFieldLooseBase(this, _tryCleanup)[_tryCleanup](true);
      }
    }
  }, {
    key: "_pumpOperatorList",
    value: function _pumpOperatorList(_ref87) {
      var _this41 = this;
      var renderingIntent = _ref87.renderingIntent,
        cacheKey = _ref87.cacheKey,
        annotationStorageSerializable = _ref87.annotationStorageSerializable,
        modifiedIds = _ref87.modifiedIds;
      var map = annotationStorageSerializable.map,
        transfer = annotationStorageSerializable.transfer;
      var readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
        pageIndex: this._pageIndex,
        intent: renderingIntent,
        cacheKey: cacheKey,
        annotationStorage: map,
        modifiedIds: modifiedIds
      }, transfer);
      var reader = readableStream.getReader();
      var intentState = this._intentStates.get(cacheKey);
      intentState.streamReader = reader;
      var _pump2 = function pump() {
        reader.read().then(function (_ref88) {
          var value = _ref88.value,
            done = _ref88.done;
          if (done) {
            intentState.streamReader = null;
            return;
          }
          if (_this41._transport.destroyed) {
            return;
          }
          _this41._renderPageChunk(value, intentState);
          _pump2();
        }, function (reason) {
          intentState.streamReader = null;
          if (_this41._transport.destroyed) {
            return;
          }
          if (intentState.operatorList) {
            intentState.operatorList.lastChunk = true;
            var _iterator102 = _createForOfIteratorHelper(intentState.renderTasks),
              _step102;
            try {
              for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
                var internalRenderTask = _step102.value;
                internalRenderTask.operatorListChanged();
              }
            } catch (err) {
              _iterator102.e(err);
            } finally {
              _iterator102.f();
            }
            _classPrivateFieldLooseBase(_this41, _tryCleanup)[_tryCleanup](true);
          }
          if (intentState.displayReadyCapability) {
            intentState.displayReadyCapability.reject(reason);
          } else if (intentState.opListReadCapability) {
            intentState.opListReadCapability.reject(reason);
          } else {
            throw reason;
          }
        });
      };
      _pump2();
    }
  }, {
    key: "_abortOperatorList",
    value: function _abortOperatorList(_ref89) {
      var _this42 = this;
      var intentState = _ref89.intentState,
        reason = _ref89.reason,
        _ref89$force = _ref89.force,
        force = _ref89$force === void 0 ? false : _ref89$force;
      if (!intentState.streamReader) {
        return;
      }
      if (intentState.streamReaderCancelTimeout) {
        clearTimeout(intentState.streamReaderCancelTimeout);
        intentState.streamReaderCancelTimeout = null;
      }
      if (!force) {
        if (intentState.renderTasks.size > 0) {
          return;
        }
        if (reason instanceof _RenderingCancelledException) {
          var delay = RENDERING_CANCELLED_TIMEOUT;
          if (reason.extraDelay > 0 && reason.extraDelay < 1000) {
            delay += reason.extraDelay;
          }
          intentState.streamReaderCancelTimeout = setTimeout(function () {
            intentState.streamReaderCancelTimeout = null;
            _this42._abortOperatorList({
              intentState: intentState,
              reason: reason,
              force: true
            });
          }, delay);
          return;
        }
      }
      intentState.streamReader.cancel(new _AbortException(reason.message)).catch(function () {});
      intentState.streamReader = null;
      if (this._transport.destroyed) {
        return;
      }
      var _iterator103 = _createForOfIteratorHelper(this._intentStates),
        _step103;
      try {
        for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
          var _ref90 = _step103.value;
          var _ref91 = _slicedToArray(_ref90, 2);
          var curCacheKey = _ref91[0];
          var curIntentState = _ref91[1];
          if (curIntentState === intentState) {
            this._intentStates.delete(curCacheKey);
            break;
          }
        }
      } catch (err) {
        _iterator103.e(err);
      } finally {
        _iterator103.f();
      }
      this.cleanup();
    }
  }, {
    key: "stats",
    get: function get() {
      return this._stats;
    }
  }]);
}();
function _tryCleanup2() {
  var _this94 = this;
  var delayed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  _classPrivateFieldLooseBase(this, _abortDelayedCleanup)[_abortDelayedCleanup]();
  if (!_classPrivateFieldLooseBase(this, _pendingCleanup)[_pendingCleanup] || this.destroyed) {
    return false;
  }
  if (delayed) {
    _classPrivateFieldLooseBase(this, _delayedCleanupTimeout)[_delayedCleanupTimeout] = setTimeout(function () {
      _classPrivateFieldLooseBase(_this94, _delayedCleanupTimeout)[_delayedCleanupTimeout] = null;
      _classPrivateFieldLooseBase(_this94, _tryCleanup)[_tryCleanup](false);
    }, DELAYED_CLEANUP_TIMEOUT);
    return false;
  }
  var _iterator169 = _createForOfIteratorHelper(this._intentStates.values()),
    _step169;
  try {
    for (_iterator169.s(); !(_step169 = _iterator169.n()).done;) {
      var _ref171 = _step169.value;
      var renderTasks = _ref171.renderTasks;
      var operatorList = _ref171.operatorList;
      if (renderTasks.size > 0 || !operatorList.lastChunk) {
        return false;
      }
    }
  } catch (err) {
    _iterator169.e(err);
  } finally {
    _iterator169.f();
  }
  this._intentStates.clear();
  this.objs.clear();
  _classPrivateFieldLooseBase(this, _pendingCleanup)[_pendingCleanup] = false;
  return true;
}
function _abortDelayedCleanup2() {
  if (_classPrivateFieldLooseBase(this, _delayedCleanupTimeout)[_delayedCleanupTimeout]) {
    clearTimeout(_classPrivateFieldLooseBase(this, _delayedCleanupTimeout)[_delayedCleanupTimeout]);
    _classPrivateFieldLooseBase(this, _delayedCleanupTimeout)[_delayedCleanupTimeout] = null;
  }
}
var _listeners = /*#__PURE__*/_classPrivateFieldLooseKey("listeners");
var _deferred = /*#__PURE__*/_classPrivateFieldLooseKey("deferred");
var LoopbackPort = /*#__PURE__*/function () {
  function LoopbackPort() {
    _classCallCheck(this, LoopbackPort);
    Object.defineProperty(this, _listeners, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _deferred, {
      writable: true,
      value: Promise.resolve()
    });
  }
  return _createClass(LoopbackPort, [{
    key: "postMessage",
    value: function postMessage(obj, transfer) {
      var _this43 = this;
      var event = {
        data: structuredClone(obj, transfer ? {
          transfer: transfer
        } : null)
      };
      _classPrivateFieldLooseBase(this, _deferred)[_deferred].then(function () {
        var _iterator104 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(_this43, _listeners)[_listeners]),
          _step104;
        try {
          for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
            var _ref92 = _step104.value;
            var _ref93 = _slicedToArray(_ref92, 1);
            var listener = _ref93[0];
            listener.call(_this43, event);
          }
        } catch (err) {
          _iterator104.e(err);
        } finally {
          _iterator104.f();
        }
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(name, listener) {
      var _this44 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var rmAbort = null;
      if ((options === null || options === void 0 ? void 0 : options.signal) instanceof AbortSignal) {
        var signal = options.signal;
        if (signal.aborted) {
          warn("LoopbackPort - cannot use an `aborted` signal.");
          return;
        }
        var onAbort = function onAbort() {
          return _this44.removeEventListener(name, listener);
        };
        rmAbort = function rmAbort() {
          return signal.removeEventListener("abort", onAbort);
        };
        signal.addEventListener("abort", onAbort);
      }
      _classPrivateFieldLooseBase(this, _listeners)[_listeners].set(listener, rmAbort);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(name, listener) {
      var rmAbort = _classPrivateFieldLooseBase(this, _listeners)[_listeners].get(listener);
      rmAbort === null || rmAbort === void 0 || rmAbort();
      _classPrivateFieldLooseBase(this, _listeners)[_listeners].delete(listener);
    }
  }, {
    key: "terminate",
    value: function terminate() {
      var _iterator105 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _listeners)[_listeners]),
        _step105;
      try {
        for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
          var _ref94 = _step105.value;
          var _ref95 = _slicedToArray(_ref94, 2);
          var rmAbort = _ref95[1];
          rmAbort === null || rmAbort === void 0 || rmAbort();
        }
      } catch (err) {
        _iterator105.e(err);
      } finally {
        _iterator105.f();
      }
      _classPrivateFieldLooseBase(this, _listeners)[_listeners].clear();
    }
  }]);
}();
var _fakeWorkerId = /*#__PURE__*/_classPrivateFieldLooseKey("fakeWorkerId");
var _isWorkerDisabled = /*#__PURE__*/_classPrivateFieldLooseKey("isWorkerDisabled");
var _workerPorts = /*#__PURE__*/_classPrivateFieldLooseKey("workerPorts");
var _resolve = /*#__PURE__*/_classPrivateFieldLooseKey("resolve");
var _mainThreadWorkerMessageHandler = /*#__PURE__*/_classPrivateFieldLooseKey("mainThreadWorkerMessageHandler");
var _PDFWorker = /*#__PURE__*/function () {
  function _PDFWorker() {
    var _ref96 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref96$name = _ref96.name,
      name = _ref96$name === void 0 ? null : _ref96$name,
      _ref96$port = _ref96.port,
      port = _ref96$port === void 0 ? null : _ref96$port,
      _ref96$verbosity = _ref96.verbosity,
      verbosity = _ref96$verbosity === void 0 ? getVerbosityLevel() : _ref96$verbosity;
    _classCallCheck(this, _PDFWorker);
    Object.defineProperty(this, _resolve, {
      value: _resolve2
    });
    this.name = name;
    this.destroyed = false;
    this.verbosity = verbosity;
    this._readyCapability = Promise.withResolvers();
    this._port = null;
    this._webWorker = null;
    this._messageHandler = null;
    if (port) {
      var _classPrivateFieldLoo63, _classPrivateFieldLoo64;
      if ((_classPrivateFieldLoo63 = _classPrivateFieldLooseBase(_PDFWorker, _workerPorts)[_workerPorts]) !== null && _classPrivateFieldLoo63 !== void 0 && _classPrivateFieldLoo63.has(port)) {
        throw new Error("Cannot use more than one PDFWorker per port.");
      }
      ((_classPrivateFieldLoo64 = _classPrivateFieldLooseBase(_PDFWorker, _workerPorts))[_workerPorts] || (_classPrivateFieldLoo64[_workerPorts] = new WeakMap())).set(port, this);
      this._initializeFromPort(port);
      return;
    }
    this._initialize();
  }
  return _createClass(_PDFWorker, [{
    key: "promise",
    get: function get() {
      if (isNodeJS) {
        return Promise.all([NodePackages.promise, this._readyCapability.promise]);
      }
      return this._readyCapability.promise;
    }
  }, {
    key: "port",
    get: function get() {
      return this._port;
    }
  }, {
    key: "messageHandler",
    get: function get() {
      return this._messageHandler;
    }
  }, {
    key: "_initializeFromPort",
    value: function _initializeFromPort(port) {
      this._port = port;
      this._messageHandler = new MessageHandler("main", "worker", port);
      this._messageHandler.on("ready", function () {});
      _classPrivateFieldLooseBase(this, _resolve)[_resolve]();
    }
  }, {
    key: "_initialize",
    value: function _initialize() {
      var _this45 = this;
      if (_classPrivateFieldLooseBase(_PDFWorker, _isWorkerDisabled)[_isWorkerDisabled] || _classPrivateFieldLooseBase(_PDFWorker, _mainThreadWorkerMessageHandler)[_mainThreadWorkerMessageHandler]) {
        this._setupFakeWorker();
        return;
      }
      var workerSrc = _PDFWorker.workerSrc;
      try {
        if (!_PDFWorker._isSameOrigin(window.location.href, workerSrc)) {
          workerSrc = _PDFWorker._createCDNWrapper(new URL(workerSrc, window.location).href);
        }
        var worker = new Worker(workerSrc, {
          type: "module"
        });
        var messageHandler = new MessageHandler("main", "worker", worker);
        var terminateEarly = function terminateEarly() {
          ac.abort();
          messageHandler.destroy();
          worker.terminate();
          if (_this45.destroyed) {
            _this45._readyCapability.reject(new Error("Worker was destroyed"));
          } else {
            _this45._setupFakeWorker();
          }
        };
        var ac = new AbortController();
        worker.addEventListener("error", function () {
          if (!_this45._webWorker) {
            terminateEarly();
          }
        }, {
          signal: ac.signal
        });
        messageHandler.on("test", function (data) {
          ac.abort();
          if (_this45.destroyed || !data) {
            terminateEarly();
            return;
          }
          _this45._messageHandler = messageHandler;
          _this45._port = worker;
          _this45._webWorker = worker;
          _classPrivateFieldLooseBase(_this45, _resolve)[_resolve]();
        });
        messageHandler.on("ready", function (data) {
          ac.abort();
          if (_this45.destroyed) {
            terminateEarly();
            return;
          }
          try {
            sendTest();
          } catch (_unused11) {
            _this45._setupFakeWorker();
          }
        });
        var sendTest = function sendTest() {
          var testObj = new Uint8Array();
          messageHandler.send("test", testObj, [testObj.buffer]);
        };
        sendTest();
        return;
      } catch (_unused12) {
        info("The worker has been disabled.");
      }
      this._setupFakeWorker();
    }
  }, {
    key: "_setupFakeWorker",
    value: function _setupFakeWorker() {
      var _this46 = this;
      if (!_classPrivateFieldLooseBase(_PDFWorker, _isWorkerDisabled)[_isWorkerDisabled]) {
        warn("Setting up fake worker.");
        _classPrivateFieldLooseBase(_PDFWorker, _isWorkerDisabled)[_isWorkerDisabled] = true;
      }
      _PDFWorker._setupFakeWorkerGlobal.then(function (WorkerMessageHandler) {
        if (_this46.destroyed) {
          _this46._readyCapability.reject(new Error("Worker was destroyed"));
          return;
        }
        var port = new LoopbackPort();
        _this46._port = port;
        var id = "fake".concat(_classPrivateFieldLooseBase(_PDFWorker, _fakeWorkerId)[_fakeWorkerId]++);
        var workerHandler = new MessageHandler(id + "_worker", id, port);
        WorkerMessageHandler.setup(workerHandler, port);
        _this46._messageHandler = new MessageHandler(id, id + "_worker", port);
        _classPrivateFieldLooseBase(_this46, _resolve)[_resolve]();
      }).catch(function (reason) {
        _this46._readyCapability.reject(new Error("Setting up fake worker failed: \"".concat(reason.message, "\".")));
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _classPrivateFieldLoo65;
      this.destroyed = true;
      if (this._webWorker) {
        this._webWorker.terminate();
        this._webWorker = null;
      }
      (_classPrivateFieldLoo65 = _classPrivateFieldLooseBase(_PDFWorker, _workerPorts)[_workerPorts]) === null || _classPrivateFieldLoo65 === void 0 || _classPrivateFieldLoo65.delete(this._port);
      this._port = null;
      if (this._messageHandler) {
        this._messageHandler.destroy();
        this._messageHandler = null;
      }
    }
  }], [{
    key: "fromPort",
    value: function fromPort(params) {
      var _classPrivateFieldLoo66;
      if (!(params !== null && params !== void 0 && params.port)) {
        throw new Error("PDFWorker.fromPort - invalid method signature.");
      }
      var cachedPort = (_classPrivateFieldLoo66 = _classPrivateFieldLooseBase(this, _workerPorts)[_workerPorts]) === null || _classPrivateFieldLoo66 === void 0 ? void 0 : _classPrivateFieldLoo66.get(params.port);
      if (cachedPort) {
        if (cachedPort._pendingDestroy) {
          throw new Error("PDFWorker.fromPort - the worker is being destroyed.\n" + "Please remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
        }
        return cachedPort;
      }
      return new _PDFWorker(params);
    }
  }, {
    key: "workerSrc",
    get: function get() {
      if (_GlobalWorkerOptions.workerSrc) {
        return _GlobalWorkerOptions.workerSrc;
      }
      throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
    }
  }, {
    key: "_setupFakeWorkerGlobal",
    get: function get() {
      var _this47 = this;
      var loader = /*#__PURE__*/function () {
        var _ref97 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
          var worker;
          return _regeneratorRuntime().wrap(function _callee35$(_context35) {
            while (1) switch (_context35.prev = _context35.next) {
              case 0:
                if (!_classPrivateFieldLooseBase(_this47, _mainThreadWorkerMessageHandler)[_mainThreadWorkerMessageHandler]) {
                  _context35.next = 2;
                  break;
                }
                return _context35.abrupt("return", _classPrivateFieldLooseBase(_this47, _mainThreadWorkerMessageHandler)[_mainThreadWorkerMessageHandler]);
              case 2:
                _context35.next = 4;
                return import(/*webpackIgnore: true*/_this47.workerSrc);
              case 4:
                worker = _context35.sent;
                return _context35.abrupt("return", worker.WorkerMessageHandler);
              case 6:
              case "end":
                return _context35.stop();
            }
          }, _callee35);
        }));
        return function loader() {
          return _ref97.apply(this, arguments);
        };
      }();
      return _shadow(this, "_setupFakeWorkerGlobal", loader());
    }
  }]);
}();
_PDFWorker2 = _PDFWorker;
function _resolve2() {
  this._readyCapability.resolve();
  this._messageHandler.send("configure", {
    verbosity: this.verbosity
  });
}
function _get_mainThreadWorkerMessageHandler() {
  try {
    var _globalThis$pdfjsWork;
    return ((_globalThis$pdfjsWork = globalThis.pdfjsWorker) === null || _globalThis$pdfjsWork === void 0 ? void 0 : _globalThis$pdfjsWork.WorkerMessageHandler) || null;
  } catch (_unused14) {
    return null;
  }
}
Object.defineProperty(_PDFWorker, _mainThreadWorkerMessageHandler, {
  get: _get_mainThreadWorkerMessageHandler,
  set: void 0
});
Object.defineProperty(_PDFWorker, _fakeWorkerId, {
  writable: true,
  value: 0
});
Object.defineProperty(_PDFWorker, _isWorkerDisabled, {
  writable: true,
  value: false
});
Object.defineProperty(_PDFWorker, _workerPorts, {
  writable: true,
  value: void 0
});
(function () {
  if (isNodeJS) {
    _classPrivateFieldLooseBase(_PDFWorker2, _isWorkerDisabled)[_isWorkerDisabled] = true;
    _GlobalWorkerOptions.workerSrc || (_GlobalWorkerOptions.workerSrc = "./pdf.worker.mjs");
  }
  _PDFWorker2._isSameOrigin = function (baseUrl, otherUrl) {
    var base;
    try {
      base = new URL(baseUrl);
      if (!base.origin || base.origin === "null") {
        return false;
      }
    } catch (_unused13) {
      return false;
    }
    var other = new URL(otherUrl, base);
    return base.origin === other.origin;
  };
  _PDFWorker2._createCDNWrapper = function (url) {
    var wrapper = "await import(\"".concat(url, "\");");
    return URL.createObjectURL(new Blob([wrapper], {
      type: "text/javascript"
    }));
  };
})();
var _methodPromises = /*#__PURE__*/_classPrivateFieldLooseKey("methodPromises");
var _pageCache = /*#__PURE__*/_classPrivateFieldLooseKey("pageCache");
var _pagePromises = /*#__PURE__*/_classPrivateFieldLooseKey("pagePromises");
var _pageRefCache = /*#__PURE__*/_classPrivateFieldLooseKey("pageRefCache");
var _passwordCapability = /*#__PURE__*/_classPrivateFieldLooseKey("passwordCapability");
var _cacheSimpleMethod = /*#__PURE__*/_classPrivateFieldLooseKey("cacheSimpleMethod");
var WorkerTransport = /*#__PURE__*/function () {
  function WorkerTransport(messageHandler, loadingTask, networkStream, params, factory) {
    _classCallCheck(this, WorkerTransport);
    Object.defineProperty(this, _cacheSimpleMethod, {
      value: _cacheSimpleMethod2
    });
    Object.defineProperty(this, _methodPromises, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _pageCache, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _pagePromises, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _pageRefCache, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _passwordCapability, {
      writable: true,
      value: null
    });
    this.messageHandler = messageHandler;
    this.loadingTask = loadingTask;
    this.commonObjs = new PDFObjects();
    this.fontLoader = new FontLoader({
      ownerDocument: params.ownerDocument,
      styleElement: params.styleElement
    });
    this.loadingParams = params.loadingParams;
    this._params = params;
    this.canvasFactory = factory.canvasFactory;
    this.filterFactory = factory.filterFactory;
    this.cMapReaderFactory = factory.cMapReaderFactory;
    this.standardFontDataFactory = factory.standardFontDataFactory;
    this.destroyed = false;
    this.destroyCapability = null;
    this._networkStream = networkStream;
    this._fullReader = null;
    this._lastProgress = null;
    this.downloadInfoCapability = Promise.withResolvers();
    this.setupMessageHandler();
  }
  return _createClass(WorkerTransport, [{
    key: "annotationStorage",
    get: function get() {
      return _shadow(this, "annotationStorage", new AnnotationStorage());
    }
  }, {
    key: "getRenderingIntent",
    value: function getRenderingIntent(intent) {
      var annotationMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _AnnotationMode.ENABLE;
      var printAnnotationStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var isEditing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var isOpList = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var renderingIntent = RenderingIntentFlag.DISPLAY;
      var annotationStorageSerializable = SerializableEmpty;
      switch (intent) {
        case "any":
          renderingIntent = RenderingIntentFlag.ANY;
          break;
        case "display":
          break;
        case "print":
          renderingIntent = RenderingIntentFlag.PRINT;
          break;
        default:
          warn("getRenderingIntent - invalid intent: ".concat(intent));
      }
      var annotationStorage = renderingIntent & RenderingIntentFlag.PRINT && printAnnotationStorage instanceof PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
      switch (annotationMode) {
        case _AnnotationMode.DISABLE:
          renderingIntent += RenderingIntentFlag.ANNOTATIONS_DISABLE;
          break;
        case _AnnotationMode.ENABLE:
          break;
        case _AnnotationMode.ENABLE_FORMS:
          renderingIntent += RenderingIntentFlag.ANNOTATIONS_FORMS;
          break;
        case _AnnotationMode.ENABLE_STORAGE:
          renderingIntent += RenderingIntentFlag.ANNOTATIONS_STORAGE;
          annotationStorageSerializable = annotationStorage.serializable;
          break;
        default:
          warn("getRenderingIntent - invalid annotationMode: ".concat(annotationMode));
      }
      if (isEditing) {
        renderingIntent += RenderingIntentFlag.IS_EDITING;
      }
      if (isOpList) {
        renderingIntent += RenderingIntentFlag.OPLIST;
      }
      var _annotationStorage$mo = annotationStorage.modifiedIds,
        modifiedIds = _annotationStorage$mo.ids,
        modifiedIdsHash = _annotationStorage$mo.hash;
      var cacheKeyBuf = [renderingIntent, annotationStorageSerializable.hash, modifiedIdsHash];
      return {
        renderingIntent: renderingIntent,
        cacheKey: cacheKeyBuf.join("_"),
        annotationStorageSerializable: annotationStorageSerializable,
        modifiedIds: modifiedIds
      };
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _classPrivateFieldLoo67,
        _this48 = this;
      if (this.destroyCapability) {
        return this.destroyCapability.promise;
      }
      this.destroyed = true;
      this.destroyCapability = Promise.withResolvers();
      (_classPrivateFieldLoo67 = _classPrivateFieldLooseBase(this, _passwordCapability)[_passwordCapability]) === null || _classPrivateFieldLoo67 === void 0 || _classPrivateFieldLoo67.reject(new Error("Worker was destroyed during onPassword callback"));
      var waitOn = [];
      var _iterator106 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _pageCache)[_pageCache].values()),
        _step106;
      try {
        for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
          var page = _step106.value;
          waitOn.push(page._destroy());
        }
      } catch (err) {
        _iterator106.e(err);
      } finally {
        _iterator106.f();
      }
      _classPrivateFieldLooseBase(this, _pageCache)[_pageCache].clear();
      _classPrivateFieldLooseBase(this, _pagePromises)[_pagePromises].clear();
      _classPrivateFieldLooseBase(this, _pageRefCache)[_pageRefCache].clear();
      if (this.hasOwnProperty("annotationStorage")) {
        this.annotationStorage.resetModified();
      }
      var terminated = this.messageHandler.sendWithPromise("Terminate", null);
      waitOn.push(terminated);
      Promise.all(waitOn).then(function () {
        var _this48$_networkStrea;
        _this48.commonObjs.clear();
        _this48.fontLoader.clear();
        _classPrivateFieldLooseBase(_this48, _methodPromises)[_methodPromises].clear();
        _this48.filterFactory.destroy();
        _TextLayer.cleanup();
        (_this48$_networkStrea = _this48._networkStream) === null || _this48$_networkStrea === void 0 || _this48$_networkStrea.cancelAllRequests(new _AbortException("Worker was terminated."));
        if (_this48.messageHandler) {
          _this48.messageHandler.destroy();
          _this48.messageHandler = null;
        }
        _this48.destroyCapability.resolve();
      }, this.destroyCapability.reject);
      return this.destroyCapability.promise;
    }
  }, {
    key: "setupMessageHandler",
    value: function setupMessageHandler() {
      var _this49 = this;
      var messageHandler = this.messageHandler,
        loadingTask = this.loadingTask;
      messageHandler.on("GetReader", function (data, sink) {
        assert(_this49._networkStream, "GetReader - no `IPDFStream` instance available.");
        _this49._fullReader = _this49._networkStream.getFullReader();
        _this49._fullReader.onProgress = function (evt) {
          _this49._lastProgress = {
            loaded: evt.loaded,
            total: evt.total
          };
        };
        sink.onPull = function () {
          _this49._fullReader.read().then(function (_ref98) {
            var value = _ref98.value,
              done = _ref98.done;
            if (done) {
              sink.close();
              return;
            }
            assert(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
            sink.enqueue(new Uint8Array(value), 1, [value]);
          }).catch(function (reason) {
            sink.error(reason);
          });
        };
        sink.onCancel = function (reason) {
          _this49._fullReader.cancel(reason);
          sink.ready.catch(function (readyReason) {
            if (_this49.destroyed) {
              return;
            }
            throw readyReason;
          });
        };
      });
      messageHandler.on("ReaderHeadersReady", /*#__PURE__*/function () {
        var _ref99 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36(data) {
          var _this49$_fullReader, isStreamingSupported, isRangeSupported, contentLength, _loadingTask$onProgre;
          return _regeneratorRuntime().wrap(function _callee36$(_context36) {
            while (1) switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return _this49._fullReader.headersReady;
              case 2:
                _this49$_fullReader = _this49._fullReader, isStreamingSupported = _this49$_fullReader.isStreamingSupported, isRangeSupported = _this49$_fullReader.isRangeSupported, contentLength = _this49$_fullReader.contentLength;
                if (!isStreamingSupported || !isRangeSupported) {
                  if (_this49._lastProgress) {
                    (_loadingTask$onProgre = loadingTask.onProgress) === null || _loadingTask$onProgre === void 0 || _loadingTask$onProgre.call(loadingTask, _this49._lastProgress);
                  }
                  _this49._fullReader.onProgress = function (evt) {
                    var _loadingTask$onProgre2;
                    (_loadingTask$onProgre2 = loadingTask.onProgress) === null || _loadingTask$onProgre2 === void 0 || _loadingTask$onProgre2.call(loadingTask, {
                      loaded: evt.loaded,
                      total: evt.total
                    });
                  };
                }
                return _context36.abrupt("return", {
                  isStreamingSupported: isStreamingSupported,
                  isRangeSupported: isRangeSupported,
                  contentLength: contentLength
                });
              case 5:
              case "end":
                return _context36.stop();
            }
          }, _callee36);
        }));
        return function (_x27) {
          return _ref99.apply(this, arguments);
        };
      }());
      messageHandler.on("GetRangeReader", function (data, sink) {
        assert(_this49._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
        var rangeReader = _this49._networkStream.getRangeReader(data.begin, data.end);
        if (!rangeReader) {
          sink.close();
          return;
        }
        sink.onPull = function () {
          rangeReader.read().then(function (_ref100) {
            var value = _ref100.value,
              done = _ref100.done;
            if (done) {
              sink.close();
              return;
            }
            assert(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
            sink.enqueue(new Uint8Array(value), 1, [value]);
          }).catch(function (reason) {
            sink.error(reason);
          });
        };
        sink.onCancel = function (reason) {
          rangeReader.cancel(reason);
          sink.ready.catch(function (readyReason) {
            if (_this49.destroyed) {
              return;
            }
            throw readyReason;
          });
        };
      });
      messageHandler.on("GetDoc", function (_ref101) {
        var pdfInfo = _ref101.pdfInfo;
        _this49._numPages = pdfInfo.numPages;
        _this49._htmlForXfa = pdfInfo.htmlForXfa;
        delete pdfInfo.htmlForXfa;
        loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, _this49));
      });
      messageHandler.on("DocException", function (ex) {
        var reason;
        switch (ex.name) {
          case "PasswordException":
            reason = new PasswordException(ex.message, ex.code);
            break;
          case "InvalidPDFException":
            reason = new _InvalidPDFException(ex.message);
            break;
          case "MissingPDFException":
            reason = new _MissingPDFException(ex.message);
            break;
          case "UnexpectedResponseException":
            reason = new _UnexpectedResponseException(ex.message, ex.status);
            break;
          case "UnknownErrorException":
            reason = new UnknownErrorException(ex.message, ex.details);
            break;
          default:
            unreachable("DocException - expected a valid Error.");
        }
        loadingTask._capability.reject(reason);
      });
      messageHandler.on("PasswordRequest", function (exception) {
        _classPrivateFieldLooseBase(_this49, _passwordCapability)[_passwordCapability] = Promise.withResolvers();
        if (loadingTask.onPassword) {
          var updatePassword = function updatePassword(password) {
            if (password instanceof Error) {
              _classPrivateFieldLooseBase(_this49, _passwordCapability)[_passwordCapability].reject(password);
            } else {
              _classPrivateFieldLooseBase(_this49, _passwordCapability)[_passwordCapability].resolve({
                password: password
              });
            }
          };
          try {
            loadingTask.onPassword(updatePassword, exception.code);
          } catch (ex) {
            _classPrivateFieldLooseBase(_this49, _passwordCapability)[_passwordCapability].reject(ex);
          }
        } else {
          _classPrivateFieldLooseBase(_this49, _passwordCapability)[_passwordCapability].reject(new PasswordException(exception.message, exception.code));
        }
        return _classPrivateFieldLooseBase(_this49, _passwordCapability)[_passwordCapability].promise;
      });
      messageHandler.on("DataLoaded", function (data) {
        var _loadingTask$onProgre3;
        (_loadingTask$onProgre3 = loadingTask.onProgress) === null || _loadingTask$onProgre3 === void 0 || _loadingTask$onProgre3.call(loadingTask, {
          loaded: data.length,
          total: data.length
        });
        _this49.downloadInfoCapability.resolve(data);
      });
      messageHandler.on("StartRenderPage", function (data) {
        if (_this49.destroyed) {
          return;
        }
        var page = _classPrivateFieldLooseBase(_this49, _pageCache)[_pageCache].get(data.pageIndex);
        page._startRenderPage(data.transparency, data.cacheKey);
      });
      messageHandler.on("commonobj", function (_ref102) {
        var _globalThis$FontInspe2;
        var _ref103 = _slicedToArray(_ref102, 3),
          id = _ref103[0],
          type = _ref103[1],
          exportedData = _ref103[2];
        if (_this49.destroyed) {
          return null;
        }
        if (_this49.commonObjs.has(id)) {
          return null;
        }
        switch (type) {
          case "Font":
            var _this49$_params = _this49._params,
              disableFontFace = _this49$_params.disableFontFace,
              fontExtraProperties = _this49$_params.fontExtraProperties,
              pdfBug = _this49$_params.pdfBug;
            if ("error" in exportedData) {
              var exportedError = exportedData.error;
              warn("Error during font loading: ".concat(exportedError));
              _this49.commonObjs.resolve(id, exportedError);
              break;
            }
            var inspectFont = pdfBug && (_globalThis$FontInspe2 = globalThis.FontInspector) !== null && _globalThis$FontInspe2 !== void 0 && _globalThis$FontInspe2.enabled ? function (font, url) {
              return globalThis.FontInspector.fontAdded(font, url);
            } : null;
            var font = new FontFaceObject(exportedData, {
              disableFontFace: disableFontFace,
              inspectFont: inspectFont
            });
            _this49.fontLoader.bind(font).catch(function () {
              return messageHandler.sendWithPromise("FontFallback", {
                id: id
              });
            }).finally(function () {
              if (!fontExtraProperties && font.data) {
                font.data = null;
              }
              _this49.commonObjs.resolve(id, font);
            });
            break;
          case "CopyLocalImage":
            var imageRef = exportedData.imageRef;
            assert(imageRef, "The imageRef must be defined.");
            var _iterator107 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(_this49, _pageCache)[_pageCache].values()),
              _step107;
            try {
              for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
                var pageProxy = _step107.value;
                var _iterator108 = _createForOfIteratorHelper(pageProxy.objs),
                  _step108;
                try {
                  for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
                    var _ref104 = _step108.value;
                    var _ref105 = _slicedToArray(_ref104, 2);
                    var data = _ref105[1];
                    if ((data === null || data === void 0 ? void 0 : data.ref) !== imageRef) {
                      continue;
                    }
                    if (!data.dataLen) {
                      return null;
                    }
                    _this49.commonObjs.resolve(id, structuredClone(data));
                    return data.dataLen;
                  }
                } catch (err) {
                  _iterator108.e(err);
                } finally {
                  _iterator108.f();
                }
              }
            } catch (err) {
              _iterator107.e(err);
            } finally {
              _iterator107.f();
            }
            break;
          case "FontPath":
          case "Image":
          case "Pattern":
            _this49.commonObjs.resolve(id, exportedData);
            break;
          default:
            throw new Error("Got unknown common object type ".concat(type));
        }
        return null;
      });
      messageHandler.on("obj", function (_ref106) {
        var _ref107 = _slicedToArray(_ref106, 4),
          id = _ref107[0],
          pageIndex = _ref107[1],
          type = _ref107[2],
          imageData = _ref107[3];
        if (_this49.destroyed) {
          return;
        }
        var pageProxy = _classPrivateFieldLooseBase(_this49, _pageCache)[_pageCache].get(pageIndex);
        if (pageProxy.objs.has(id)) {
          return;
        }
        if (pageProxy._intentStates.size === 0) {
          var _imageData$bitmap;
          imageData === null || imageData === void 0 || (_imageData$bitmap = imageData.bitmap) === null || _imageData$bitmap === void 0 || _imageData$bitmap.close();
          return;
        }
        switch (type) {
          case "Image":
            pageProxy.objs.resolve(id, imageData);
            if ((imageData === null || imageData === void 0 ? void 0 : imageData.dataLen) > MAX_IMAGE_SIZE_TO_CACHE) {
              pageProxy._maybeCleanupAfterRender = true;
            }
            break;
          case "Pattern":
            pageProxy.objs.resolve(id, imageData);
            break;
          default:
            throw new Error("Got unknown object type ".concat(type));
        }
      });
      messageHandler.on("DocProgress", function (data) {
        var _loadingTask$onProgre4;
        if (_this49.destroyed) {
          return;
        }
        (_loadingTask$onProgre4 = loadingTask.onProgress) === null || _loadingTask$onProgre4 === void 0 || _loadingTask$onProgre4.call(loadingTask, {
          loaded: data.loaded,
          total: data.total
        });
      });
      messageHandler.on("FetchBuiltInCMap", /*#__PURE__*/function () {
        var _ref108 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37(data) {
          return _regeneratorRuntime().wrap(function _callee37$(_context37) {
            while (1) switch (_context37.prev = _context37.next) {
              case 0:
                if (!_this49.destroyed) {
                  _context37.next = 2;
                  break;
                }
                throw new Error("Worker was destroyed.");
              case 2:
                if (_this49.cMapReaderFactory) {
                  _context37.next = 4;
                  break;
                }
                throw new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter.");
              case 4:
                return _context37.abrupt("return", _this49.cMapReaderFactory.fetch(data));
              case 5:
              case "end":
                return _context37.stop();
            }
          }, _callee37);
        }));
        return function (_x28) {
          return _ref108.apply(this, arguments);
        };
      }());
      messageHandler.on("FetchStandardFontData", /*#__PURE__*/function () {
        var _ref109 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(data) {
          return _regeneratorRuntime().wrap(function _callee38$(_context38) {
            while (1) switch (_context38.prev = _context38.next) {
              case 0:
                if (!_this49.destroyed) {
                  _context38.next = 2;
                  break;
                }
                throw new Error("Worker was destroyed.");
              case 2:
                if (_this49.standardFontDataFactory) {
                  _context38.next = 4;
                  break;
                }
                throw new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.");
              case 4:
                return _context38.abrupt("return", _this49.standardFontDataFactory.fetch(data));
              case 5:
              case "end":
                return _context38.stop();
            }
          }, _callee38);
        }));
        return function (_x29) {
          return _ref109.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.messageHandler.sendWithPromise("GetData", null);
    }
  }, {
    key: "saveDocument",
    value: function saveDocument() {
      var _this$_fullReader$fil,
        _this$_fullReader,
        _this50 = this;
      if (this.annotationStorage.size <= 0) {
        warn("saveDocument called while `annotationStorage` is empty, " + "please use the getData-method instead.");
      }
      var _this$annotationStora = this.annotationStorage.serializable,
        map = _this$annotationStora.map,
        transfer = _this$annotationStora.transfer;
      return this.messageHandler.sendWithPromise("SaveDocument", {
        isPureXfa: !!this._htmlForXfa,
        numPages: this._numPages,
        annotationStorage: map,
        filename: (_this$_fullReader$fil = (_this$_fullReader = this._fullReader) === null || _this$_fullReader === void 0 ? void 0 : _this$_fullReader.filename) !== null && _this$_fullReader$fil !== void 0 ? _this$_fullReader$fil : null
      }, transfer).finally(function () {
        _this50.annotationStorage.resetModified();
      });
    }
  }, {
    key: "getPage",
    value: function getPage(pageNumber) {
      var _this51 = this;
      if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
        return Promise.reject(new Error("Invalid page request."));
      }
      var pageIndex = pageNumber - 1,
        cachedPromise = _classPrivateFieldLooseBase(this, _pagePromises)[_pagePromises].get(pageIndex);
      if (cachedPromise) {
        return cachedPromise;
      }
      var promise = this.messageHandler.sendWithPromise("GetPage", {
        pageIndex: pageIndex
      }).then(function (pageInfo) {
        if (_this51.destroyed) {
          throw new Error("Transport destroyed");
        }
        if (pageInfo.refStr) {
          _classPrivateFieldLooseBase(_this51, _pageRefCache)[_pageRefCache].set(pageInfo.refStr, pageNumber);
        }
        var page = new PDFPageProxy(pageIndex, pageInfo, _this51, _this51._params.pdfBug);
        _classPrivateFieldLooseBase(_this51, _pageCache)[_pageCache].set(pageIndex, page);
        return page;
      });
      _classPrivateFieldLooseBase(this, _pagePromises)[_pagePromises].set(pageIndex, promise);
      return promise;
    }
  }, {
    key: "getPageIndex",
    value: function getPageIndex(ref) {
      if (!isRefProxy(ref)) {
        return Promise.reject(new Error("Invalid pageIndex request."));
      }
      return this.messageHandler.sendWithPromise("GetPageIndex", {
        num: ref.num,
        gen: ref.gen
      });
    }
  }, {
    key: "getAnnotations",
    value: function getAnnotations(pageIndex, intent) {
      return this.messageHandler.sendWithPromise("GetAnnotations", {
        pageIndex: pageIndex,
        intent: intent
      });
    }
  }, {
    key: "getFieldObjects",
    value: function getFieldObjects() {
      return _classPrivateFieldLooseBase(this, _cacheSimpleMethod)[_cacheSimpleMethod]("GetFieldObjects");
    }
  }, {
    key: "hasJSActions",
    value: function hasJSActions() {
      return _classPrivateFieldLooseBase(this, _cacheSimpleMethod)[_cacheSimpleMethod]("HasJSActions");
    }
  }, {
    key: "getCalculationOrderIds",
    value: function getCalculationOrderIds() {
      return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
    }
  }, {
    key: "getDestinations",
    value: function getDestinations() {
      return this.messageHandler.sendWithPromise("GetDestinations", null);
    }
  }, {
    key: "getDestination",
    value: function getDestination(id) {
      if (typeof id !== "string") {
        return Promise.reject(new Error("Invalid destination request."));
      }
      return this.messageHandler.sendWithPromise("GetDestination", {
        id: id
      });
    }
  }, {
    key: "getPageLabels",
    value: function getPageLabels() {
      return this.messageHandler.sendWithPromise("GetPageLabels", null);
    }
  }, {
    key: "getPageLayout",
    value: function getPageLayout() {
      return this.messageHandler.sendWithPromise("GetPageLayout", null);
    }
  }, {
    key: "getPageMode",
    value: function getPageMode() {
      return this.messageHandler.sendWithPromise("GetPageMode", null);
    }
  }, {
    key: "getViewerPreferences",
    value: function getViewerPreferences() {
      return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
    }
  }, {
    key: "getOpenAction",
    value: function getOpenAction() {
      return this.messageHandler.sendWithPromise("GetOpenAction", null);
    }
  }, {
    key: "getAttachments",
    value: function getAttachments() {
      return this.messageHandler.sendWithPromise("GetAttachments", null);
    }
  }, {
    key: "getDocJSActions",
    value: function getDocJSActions() {
      return _classPrivateFieldLooseBase(this, _cacheSimpleMethod)[_cacheSimpleMethod]("GetDocJSActions");
    }
  }, {
    key: "getPageJSActions",
    value: function getPageJSActions(pageIndex) {
      return this.messageHandler.sendWithPromise("GetPageJSActions", {
        pageIndex: pageIndex
      });
    }
  }, {
    key: "getStructTree",
    value: function getStructTree(pageIndex) {
      return this.messageHandler.sendWithPromise("GetStructTree", {
        pageIndex: pageIndex
      });
    }
  }, {
    key: "getOutline",
    value: function getOutline() {
      return this.messageHandler.sendWithPromise("GetOutline", null);
    }
  }, {
    key: "getOptionalContentConfig",
    value: function getOptionalContentConfig(renderingIntent) {
      return _classPrivateFieldLooseBase(this, _cacheSimpleMethod)[_cacheSimpleMethod]("GetOptionalContentConfig").then(function (data) {
        return new OptionalContentConfig(data, renderingIntent);
      });
    }
  }, {
    key: "getPermissions",
    value: function getPermissions() {
      return this.messageHandler.sendWithPromise("GetPermissions", null);
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      var _this52 = this;
      var name = "GetMetadata",
        cachedPromise = _classPrivateFieldLooseBase(this, _methodPromises)[_methodPromises].get(name);
      if (cachedPromise) {
        return cachedPromise;
      }
      var promise = this.messageHandler.sendWithPromise(name, null).then(function (results) {
        var _this52$_fullReader$f, _this52$_fullReader, _this52$_fullReader$c, _this52$_fullReader2;
        return {
          info: results[0],
          metadata: results[1] ? new Metadata(results[1]) : null,
          contentDispositionFilename: (_this52$_fullReader$f = (_this52$_fullReader = _this52._fullReader) === null || _this52$_fullReader === void 0 ? void 0 : _this52$_fullReader.filename) !== null && _this52$_fullReader$f !== void 0 ? _this52$_fullReader$f : null,
          contentLength: (_this52$_fullReader$c = (_this52$_fullReader2 = _this52._fullReader) === null || _this52$_fullReader2 === void 0 ? void 0 : _this52$_fullReader2.contentLength) !== null && _this52$_fullReader$c !== void 0 ? _this52$_fullReader$c : null
        };
      });
      _classPrivateFieldLooseBase(this, _methodPromises)[_methodPromises].set(name, promise);
      return promise;
    }
  }, {
    key: "getMarkInfo",
    value: function getMarkInfo() {
      return this.messageHandler.sendWithPromise("GetMarkInfo", null);
    }
  }, {
    key: "startCleanup",
    value: function () {
      var _startCleanup = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var keepLoadedFonts,
          _iterator109,
          _step109,
          page,
          cleanupSuccessful,
          _args39 = arguments;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              keepLoadedFonts = _args39.length > 0 && _args39[0] !== undefined ? _args39[0] : false;
              if (!this.destroyed) {
                _context39.next = 3;
                break;
              }
              return _context39.abrupt("return");
            case 3:
              _context39.next = 5;
              return this.messageHandler.sendWithPromise("Cleanup", null);
            case 5:
              _iterator109 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _pageCache)[_pageCache].values());
              _context39.prev = 6;
              _iterator109.s();
            case 8:
              if ((_step109 = _iterator109.n()).done) {
                _context39.next = 15;
                break;
              }
              page = _step109.value;
              cleanupSuccessful = page.cleanup();
              if (cleanupSuccessful) {
                _context39.next = 13;
                break;
              }
              throw new Error("startCleanup: Page ".concat(page.pageNumber, " is currently rendering."));
            case 13:
              _context39.next = 8;
              break;
            case 15:
              _context39.next = 20;
              break;
            case 17:
              _context39.prev = 17;
              _context39.t0 = _context39["catch"](6);
              _iterator109.e(_context39.t0);
            case 20:
              _context39.prev = 20;
              _iterator109.f();
              return _context39.finish(20);
            case 23:
              this.commonObjs.clear();
              if (!keepLoadedFonts) {
                this.fontLoader.clear();
              }
              _classPrivateFieldLooseBase(this, _methodPromises)[_methodPromises].clear();
              this.filterFactory.destroy(true);
              _TextLayer.cleanup();
            case 28:
            case "end":
              return _context39.stop();
          }
        }, _callee39, this, [[6, 17, 20, 23]]);
      }));
      function startCleanup() {
        return _startCleanup.apply(this, arguments);
      }
      return startCleanup;
    }()
  }, {
    key: "cachedPageNumber",
    value: function cachedPageNumber(ref) {
      var _classPrivateFieldLoo68;
      if (!isRefProxy(ref)) {
        return null;
      }
      var refStr = ref.gen === 0 ? "".concat(ref.num, "R") : "".concat(ref.num, "R").concat(ref.gen);
      return (_classPrivateFieldLoo68 = _classPrivateFieldLooseBase(this, _pageRefCache)[_pageRefCache].get(refStr)) !== null && _classPrivateFieldLoo68 !== void 0 ? _classPrivateFieldLoo68 : null;
    }
  }]);
}();
function _cacheSimpleMethod2(name) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var cachedPromise = _classPrivateFieldLooseBase(this, _methodPromises)[_methodPromises].get(name);
  if (cachedPromise) {
    return cachedPromise;
  }
  var promise = this.messageHandler.sendWithPromise(name, data);
  _classPrivateFieldLooseBase(this, _methodPromises)[_methodPromises].set(name, promise);
  return promise;
}
var INITIAL_DATA = Symbol("INITIAL_DATA");
var _objs = /*#__PURE__*/_classPrivateFieldLooseKey("objs");
var _ensureObj = /*#__PURE__*/_classPrivateFieldLooseKey("ensureObj");
var PDFObjects = /*#__PURE__*/function () {
  function PDFObjects() {
    _classCallCheck(this, PDFObjects);
    Object.defineProperty(this, _ensureObj, {
      value: _ensureObj2
    });
    Object.defineProperty(this, _objs, {
      writable: true,
      value: Object.create(null)
    });
  }
  return _createClass(PDFObjects, [{
    key: "get",
    value: function get(objId) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (callback) {
        var _obj = _classPrivateFieldLooseBase(this, _ensureObj)[_ensureObj](objId);
        _obj.promise.then(function () {
          return callback(_obj.data);
        });
        return null;
      }
      var obj = _classPrivateFieldLooseBase(this, _objs)[_objs][objId];
      if (!obj || obj.data === INITIAL_DATA) {
        throw new Error("Requesting object that isn't resolved yet ".concat(objId, "."));
      }
      return obj.data;
    }
  }, {
    key: "has",
    value: function has(objId) {
      var obj = _classPrivateFieldLooseBase(this, _objs)[_objs][objId];
      return !!obj && obj.data !== INITIAL_DATA;
    }
  }, {
    key: "resolve",
    value: function resolve(objId) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var obj = _classPrivateFieldLooseBase(this, _ensureObj)[_ensureObj](objId);
      obj.data = data;
      obj.resolve();
    }
  }, {
    key: "clear",
    value: function clear() {
      for (var objId in _classPrivateFieldLooseBase(this, _objs)[_objs]) {
        var _data$bitmap;
        var data = _classPrivateFieldLooseBase(this, _objs)[_objs][objId].data;
        data === null || data === void 0 || (_data$bitmap = data.bitmap) === null || _data$bitmap === void 0 || _data$bitmap.close();
      }
      _classPrivateFieldLooseBase(this, _objs)[_objs] = Object.create(null);
    }
  }, {
    key: Symbol.iterator,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      var objId, data;
      return _regeneratorRuntime().wrap(function value$(_context40) {
        while (1) switch (_context40.prev = _context40.next) {
          case 0:
            _context40.t0 = _regeneratorRuntime().keys(_classPrivateFieldLooseBase(this, _objs)[_objs]);
          case 1:
            if ((_context40.t1 = _context40.t0()).done) {
              _context40.next = 10;
              break;
            }
            objId = _context40.t1.value;
            data = _classPrivateFieldLooseBase(this, _objs)[_objs][objId].data;
            if (!(data === INITIAL_DATA)) {
              _context40.next = 6;
              break;
            }
            return _context40.abrupt("continue", 1);
          case 6:
            _context40.next = 8;
            return [objId, data];
          case 8:
            _context40.next = 1;
            break;
          case 10:
          case "end":
            return _context40.stop();
        }
      }, value, this);
    })
  }]);
}();
function _ensureObj2(objId) {
  var _classPrivateFieldLoo141;
  return (_classPrivateFieldLoo141 = _classPrivateFieldLooseBase(this, _objs)[_objs])[objId] || (_classPrivateFieldLoo141[objId] = _objectSpread(_objectSpread({}, Promise.withResolvers()), {}, {
    data: INITIAL_DATA
  }));
}
var _internalRenderTask = /*#__PURE__*/_classPrivateFieldLooseKey("internalRenderTask");
var RenderTask = /*#__PURE__*/function () {
  function RenderTask(internalRenderTask) {
    _classCallCheck(this, RenderTask);
    Object.defineProperty(this, _internalRenderTask, {
      writable: true,
      value: null
    });
    _classPrivateFieldLooseBase(this, _internalRenderTask)[_internalRenderTask] = internalRenderTask;
    this.onContinue = null;
  }
  return _createClass(RenderTask, [{
    key: "promise",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _internalRenderTask)[_internalRenderTask].capability.promise;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var extraDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      _classPrivateFieldLooseBase(this, _internalRenderTask)[_internalRenderTask].cancel(null, extraDelay);
    }
  }, {
    key: "separateAnnots",
    get: function get() {
      var separateAnnots = _classPrivateFieldLooseBase(this, _internalRenderTask)[_internalRenderTask].operatorList.separateAnnots;
      if (!separateAnnots) {
        return false;
      }
      var annotationCanvasMap = _classPrivateFieldLooseBase(this, _internalRenderTask)[_internalRenderTask].annotationCanvasMap;
      return separateAnnots.form || separateAnnots.canvas && (annotationCanvasMap === null || annotationCanvasMap === void 0 ? void 0 : annotationCanvasMap.size) > 0;
    }
  }]);
}();
var _rAF = /*#__PURE__*/_classPrivateFieldLooseKey("rAF");
var _canvasInUse = /*#__PURE__*/_classPrivateFieldLooseKey("canvasInUse");
var InternalRenderTask = /*#__PURE__*/function () {
  function InternalRenderTask(_ref110) {
    var callback = _ref110.callback,
      params = _ref110.params,
      objs = _ref110.objs,
      commonObjs = _ref110.commonObjs,
      annotationCanvasMap = _ref110.annotationCanvasMap,
      operatorList = _ref110.operatorList,
      pageIndex = _ref110.pageIndex,
      canvasFactory = _ref110.canvasFactory,
      filterFactory = _ref110.filterFactory,
      _ref110$useRequestAni = _ref110.useRequestAnimationFrame,
      useRequestAnimationFrame = _ref110$useRequestAni === void 0 ? false : _ref110$useRequestAni,
      _ref110$pdfBug = _ref110.pdfBug,
      pdfBug = _ref110$pdfBug === void 0 ? false : _ref110$pdfBug,
      _ref110$pageColors = _ref110.pageColors,
      pageColors = _ref110$pageColors === void 0 ? null : _ref110$pageColors;
    _classCallCheck(this, InternalRenderTask);
    Object.defineProperty(this, _rAF, {
      writable: true,
      value: null
    });
    this.callback = callback;
    this.params = params;
    this.objs = objs;
    this.commonObjs = commonObjs;
    this.annotationCanvasMap = annotationCanvasMap;
    this.operatorListIdx = null;
    this.operatorList = operatorList;
    this._pageIndex = pageIndex;
    this.canvasFactory = canvasFactory;
    this.filterFactory = filterFactory;
    this._pdfBug = pdfBug;
    this.pageColors = pageColors;
    this.running = false;
    this.graphicsReadyCallback = null;
    this.graphicsReady = false;
    this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
    this.cancelled = false;
    this.capability = Promise.withResolvers();
    this.task = new RenderTask(this);
    this._cancelBound = this.cancel.bind(this);
    this._continueBound = this._continue.bind(this);
    this._scheduleNextBound = this._scheduleNext.bind(this);
    this._nextBound = this._next.bind(this);
    this._canvas = params.canvasContext.canvas;
  }
  return _createClass(InternalRenderTask, [{
    key: "completed",
    get: function get() {
      return this.capability.promise.catch(function () {});
    }
  }, {
    key: "initializeGraphics",
    value: function initializeGraphics(_ref111) {
      var _globalThis$StepperMa, _this$graphicsReadyCa;
      var _ref111$transparency = _ref111.transparency,
        transparency = _ref111$transparency === void 0 ? false : _ref111$transparency,
        optionalContentConfig = _ref111.optionalContentConfig;
      if (this.cancelled) {
        return;
      }
      if (this._canvas) {
        if (_classPrivateFieldLooseBase(InternalRenderTask, _canvasInUse)[_canvasInUse].has(this._canvas)) {
          throw new Error("Cannot use the same canvas during multiple render() operations. " + "Use different canvas or ensure previous operations were " + "cancelled or completed.");
        }
        _classPrivateFieldLooseBase(InternalRenderTask, _canvasInUse)[_canvasInUse].add(this._canvas);
      }
      if (this._pdfBug && (_globalThis$StepperMa = globalThis.StepperManager) !== null && _globalThis$StepperMa !== void 0 && _globalThis$StepperMa.enabled) {
        this.stepper = globalThis.StepperManager.create(this._pageIndex);
        this.stepper.init(this.operatorList);
        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
      }
      var _this$params = this.params,
        canvasContext = _this$params.canvasContext,
        viewport = _this$params.viewport,
        transform = _this$params.transform,
        background = _this$params.background;
      this.gfx = new CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
        optionalContentConfig: optionalContentConfig
      }, this.annotationCanvasMap, this.pageColors);
      this.gfx.beginDrawing({
        transform: transform,
        viewport: viewport,
        transparency: transparency,
        background: background
      });
      this.operatorListIdx = 0;
      this.graphicsReady = true;
      (_this$graphicsReadyCa = this.graphicsReadyCallback) === null || _this$graphicsReadyCa === void 0 || _this$graphicsReadyCa.call(this);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this$gfx;
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var extraDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.running = false;
      this.cancelled = true;
      (_this$gfx = this.gfx) === null || _this$gfx === void 0 || _this$gfx.endDrawing();
      if (_classPrivateFieldLooseBase(this, _rAF)[_rAF]) {
        window.cancelAnimationFrame(_classPrivateFieldLooseBase(this, _rAF)[_rAF]);
        _classPrivateFieldLooseBase(this, _rAF)[_rAF] = null;
      }
      _classPrivateFieldLooseBase(InternalRenderTask, _canvasInUse)[_canvasInUse].delete(this._canvas);
      this.callback(error || new _RenderingCancelledException("Rendering cancelled, page ".concat(this._pageIndex + 1), extraDelay));
    }
  }, {
    key: "operatorListChanged",
    value: function operatorListChanged() {
      var _this$stepper;
      if (!this.graphicsReady) {
        this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
        return;
      }
      (_this$stepper = this.stepper) === null || _this$stepper === void 0 || _this$stepper.updateOperatorList(this.operatorList);
      if (this.running) {
        return;
      }
      this._continue();
    }
  }, {
    key: "_continue",
    value: function _continue() {
      this.running = true;
      if (this.cancelled) {
        return;
      }
      if (this.task.onContinue) {
        this.task.onContinue(this._scheduleNextBound);
      } else {
        this._scheduleNext();
      }
    }
  }, {
    key: "_scheduleNext",
    value: function _scheduleNext() {
      var _this53 = this;
      if (this._useRequestAnimationFrame) {
        _classPrivateFieldLooseBase(this, _rAF)[_rAF] = window.requestAnimationFrame(function () {
          _classPrivateFieldLooseBase(_this53, _rAF)[_rAF] = null;
          _this53._nextBound().catch(_this53._cancelBound);
        });
      } else {
        Promise.resolve().then(this._nextBound).catch(this._cancelBound);
      }
    }
  }, {
    key: "_next",
    value: function () {
      var _next2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        return _regeneratorRuntime().wrap(function _callee40$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              if (!this.cancelled) {
                _context41.next = 2;
                break;
              }
              return _context41.abrupt("return");
            case 2:
              this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
              if (this.operatorListIdx === this.operatorList.argsArray.length) {
                this.running = false;
                if (this.operatorList.lastChunk) {
                  this.gfx.endDrawing();
                  _classPrivateFieldLooseBase(InternalRenderTask, _canvasInUse)[_canvasInUse].delete(this._canvas);
                  this.callback();
                }
              }
            case 4:
            case "end":
              return _context41.stop();
          }
        }, _callee40, this);
      }));
      function _next() {
        return _next2.apply(this, arguments);
      }
      return _next;
    }()
  }]);
}();
Object.defineProperty(InternalRenderTask, _canvasInUse, {
  writable: true,
  value: new WeakSet()
});
var _version = "4.8.69";
var _build = "3634dab10";
; // ./src/shared/scripting_utils.js
function makeColorComp(n) {
  return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
}
function scaleAndClamp(x) {
  return Math.max(0, Math.min(255, 255 * x));
}
var ColorConverters = /*#__PURE__*/function () {
  function ColorConverters() {
    _classCallCheck(this, ColorConverters);
  }
  return _createClass(ColorConverters, null, [{
    key: "CMYK_G",
    value: function CMYK_G(_ref112) {
      var _ref113 = _slicedToArray(_ref112, 4),
        c = _ref113[0],
        y = _ref113[1],
        m = _ref113[2],
        k = _ref113[3];
      return ["G", 1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)];
    }
  }, {
    key: "G_CMYK",
    value: function G_CMYK(_ref114) {
      var _ref115 = _slicedToArray(_ref114, 1),
        g = _ref115[0];
      return ["CMYK", 0, 0, 0, 1 - g];
    }
  }, {
    key: "G_RGB",
    value: function G_RGB(_ref116) {
      var _ref117 = _slicedToArray(_ref116, 1),
        g = _ref117[0];
      return ["RGB", g, g, g];
    }
  }, {
    key: "G_rgb",
    value: function G_rgb(_ref118) {
      var _ref119 = _slicedToArray(_ref118, 1),
        g = _ref119[0];
      g = scaleAndClamp(g);
      return [g, g, g];
    }
  }, {
    key: "G_HTML",
    value: function G_HTML(_ref120) {
      var _ref121 = _slicedToArray(_ref120, 1),
        g = _ref121[0];
      var G = makeColorComp(g);
      return "#".concat(G).concat(G).concat(G);
    }
  }, {
    key: "RGB_G",
    value: function RGB_G(_ref122) {
      var _ref123 = _slicedToArray(_ref122, 3),
        r = _ref123[0],
        g = _ref123[1],
        b = _ref123[2];
      return ["G", 0.3 * r + 0.59 * g + 0.11 * b];
    }
  }, {
    key: "RGB_rgb",
    value: function RGB_rgb(color) {
      return color.map(scaleAndClamp);
    }
  }, {
    key: "RGB_HTML",
    value: function RGB_HTML(color) {
      return "#".concat(color.map(makeColorComp).join(""));
    }
  }, {
    key: "T_HTML",
    value: function T_HTML() {
      return "#00000000";
    }
  }, {
    key: "T_rgb",
    value: function T_rgb() {
      return [null];
    }
  }, {
    key: "CMYK_RGB",
    value: function CMYK_RGB(_ref124) {
      var _ref125 = _slicedToArray(_ref124, 4),
        c = _ref125[0],
        y = _ref125[1],
        m = _ref125[2],
        k = _ref125[3];
      return ["RGB", 1 - Math.min(1, c + k), 1 - Math.min(1, m + k), 1 - Math.min(1, y + k)];
    }
  }, {
    key: "CMYK_rgb",
    value: function CMYK_rgb(_ref126) {
      var _ref127 = _slicedToArray(_ref126, 4),
        c = _ref127[0],
        y = _ref127[1],
        m = _ref127[2],
        k = _ref127[3];
      return [scaleAndClamp(1 - Math.min(1, c + k)), scaleAndClamp(1 - Math.min(1, m + k)), scaleAndClamp(1 - Math.min(1, y + k))];
    }
  }, {
    key: "CMYK_HTML",
    value: function CMYK_HTML(components) {
      var rgb = this.CMYK_RGB(components).slice(1);
      return this.RGB_HTML(rgb);
    }
  }, {
    key: "RGB_CMYK",
    value: function RGB_CMYK(_ref128) {
      var _ref129 = _slicedToArray(_ref128, 3),
        r = _ref129[0],
        g = _ref129[1],
        b = _ref129[2];
      var c = 1 - r;
      var m = 1 - g;
      var y = 1 - b;
      var k = Math.min(c, m, y);
      return ["CMYK", c, m, y, k];
    }
  }]);
}();
; // ./src/display/svg_factory.js
var BaseSVGFactory = /*#__PURE__*/function () {
  function BaseSVGFactory() {
    _classCallCheck(this, BaseSVGFactory);
  }
  return _createClass(BaseSVGFactory, [{
    key: "create",
    value: function create(width, height) {
      var skipDimensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (width <= 0 || height <= 0) {
        throw new Error("Invalid SVG dimensions");
      }
      var svg = this._createSVG("svg:svg");
      svg.setAttribute("version", "1.1");
      if (!skipDimensions) {
        svg.setAttribute("width", "".concat(width, "px"));
        svg.setAttribute("height", "".concat(height, "px"));
      }
      svg.setAttribute("preserveAspectRatio", "none");
      svg.setAttribute("viewBox", "0 0 ".concat(width, " ").concat(height));
      return svg;
    }
  }, {
    key: "createElement",
    value: function createElement(type) {
      if (typeof type !== "string") {
        throw new Error("Invalid SVG element type");
      }
      return this._createSVG(type);
    }
  }, {
    key: "_createSVG",
    value: function _createSVG(type) {
      unreachable("Abstract method `_createSVG` called.");
    }
  }]);
}();
var _DOMSVGFactory = /*#__PURE__*/function (_BaseSVGFactory) {
  function _DOMSVGFactory() {
    _classCallCheck(this, _DOMSVGFactory);
    return _callSuper(this, _DOMSVGFactory, arguments);
  }
  _inherits(_DOMSVGFactory, _BaseSVGFactory);
  return _createClass(_DOMSVGFactory, [{
    key: "_createSVG",
    value: function _createSVG(type) {
      return document.createElementNS(SVG_NS, type);
    }
  }]);
}(BaseSVGFactory);
; // ./src/display/xfa_layer.js
var _XfaLayer = /*#__PURE__*/function () {
  function _XfaLayer() {
    _classCallCheck(this, _XfaLayer);
  }
  return _createClass(_XfaLayer, null, [{
    key: "setupStorage",
    value: function setupStorage(html, id, element, storage, intent) {
      var storedData = storage.getValue(id, {
        value: null
      });
      switch (element.name) {
        case "textarea":
          if (storedData.value !== null) {
            html.textContent = storedData.value;
          }
          if (intent === "print") {
            break;
          }
          html.addEventListener("input", function (event) {
            storage.setValue(id, {
              value: event.target.value
            });
          });
          break;
        case "input":
          if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
            if (storedData.value === element.attributes.xfaOn) {
              html.setAttribute("checked", true);
            } else if (storedData.value === element.attributes.xfaOff) {
              html.removeAttribute("checked");
            }
            if (intent === "print") {
              break;
            }
            html.addEventListener("change", function (event) {
              storage.setValue(id, {
                value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
              });
            });
          } else {
            if (storedData.value !== null) {
              html.setAttribute("value", storedData.value);
            }
            if (intent === "print") {
              break;
            }
            html.addEventListener("input", function (event) {
              storage.setValue(id, {
                value: event.target.value
              });
            });
          }
          break;
        case "select":
          if (storedData.value !== null) {
            html.setAttribute("value", storedData.value);
            var _iterator110 = _createForOfIteratorHelper(element.children),
              _step110;
            try {
              for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
                var option = _step110.value;
                if (option.attributes.value === storedData.value) {
                  option.attributes.selected = true;
                } else if (option.attributes.hasOwnProperty("selected")) {
                  delete option.attributes.selected;
                }
              }
            } catch (err) {
              _iterator110.e(err);
            } finally {
              _iterator110.f();
            }
          }
          html.addEventListener("input", function (event) {
            var options = event.target.options;
            var value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
            storage.setValue(id, {
              value: value
            });
          });
          break;
      }
    }
  }, {
    key: "setAttributes",
    value: function setAttributes(_ref130) {
      var html = _ref130.html,
        element = _ref130.element,
        _ref130$storage = _ref130.storage,
        storage = _ref130$storage === void 0 ? null : _ref130$storage,
        intent = _ref130.intent,
        linkService = _ref130.linkService;
      var attributes = element.attributes;
      var isHTMLAnchorElement = html instanceof HTMLAnchorElement;
      if (attributes.type === "radio") {
        attributes.name = "".concat(attributes.name, "-").concat(intent);
      }
      for (var _i17 = 0, _Object$entries4 = Object.entries(attributes); _i17 < _Object$entries4.length; _i17++) {
        var _ref131 = _Object$entries4[_i17];
        var _ref132 = _slicedToArray(_ref131, 2);
        var key = _ref132[0];
        var value = _ref132[1];
        if (value === null || value === undefined) {
          continue;
        }
        switch (key) {
          case "class":
            if (value.length) {
              html.setAttribute(key, value.join(" "));
            }
            break;
          case "dataId":
            break;
          case "id":
            html.setAttribute("data-element-id", value);
            break;
          case "style":
            Object.assign(html.style, value);
            break;
          case "textContent":
            html.textContent = value;
            break;
          default:
            if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") {
              html.setAttribute(key, value);
            }
        }
      }
      if (isHTMLAnchorElement) {
        linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
      }
      if (storage && attributes.dataId) {
        this.setupStorage(html, attributes.dataId, element, storage);
      }
    }
  }, {
    key: "render",
    value: function render(parameters) {
      var storage = parameters.annotationStorage;
      var linkService = parameters.linkService;
      var root = parameters.xfaHtml;
      var intent = parameters.intent || "display";
      var rootHtml = document.createElement(root.name);
      if (root.attributes) {
        this.setAttributes({
          html: rootHtml,
          element: root,
          intent: intent,
          linkService: linkService
        });
      }
      var isNotForRichText = intent !== "richText";
      var rootDiv = parameters.div;
      rootDiv.append(rootHtml);
      if (parameters.viewport) {
        var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
        rootDiv.style.transform = transform;
      }
      if (isNotForRichText) {
        rootDiv.setAttribute("class", "xfaLayer xfaFont");
      }
      var textDivs = [];
      if (root.children.length === 0) {
        if (root.value) {
          var node = document.createTextNode(root.value);
          rootHtml.append(node);
          if (isNotForRichText && XfaText.shouldBuildText(root.name)) {
            textDivs.push(node);
          }
        }
        return {
          textDivs: textDivs
        };
      }
      var stack = [[root, -1, rootHtml]];
      while (stack.length > 0) {
        var _child$attributes, _child$children;
        var _stack$at = stack.at(-1),
          _stack$at2 = _slicedToArray(_stack$at, 3),
          parent = _stack$at2[0],
          i = _stack$at2[1],
          html = _stack$at2[2];
        if (i + 1 === parent.children.length) {
          stack.pop();
          continue;
        }
        var child = parent.children[++stack.at(-1)[1]];
        if (child === null) {
          continue;
        }
        var name = child.name;
        if (name === "#text") {
          var _node = document.createTextNode(child.value);
          textDivs.push(_node);
          html.append(_node);
          continue;
        }
        var childHtml = child !== null && child !== void 0 && (_child$attributes = child.attributes) !== null && _child$attributes !== void 0 && _child$attributes.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
        html.append(childHtml);
        if (child.attributes) {
          this.setAttributes({
            html: childHtml,
            element: child,
            storage: storage,
            intent: intent,
            linkService: linkService
          });
        }
        if (((_child$children = child.children) === null || _child$children === void 0 ? void 0 : _child$children.length) > 0) {
          stack.push([child, -1, childHtml]);
        } else if (child.value) {
          var _node2 = document.createTextNode(child.value);
          if (isNotForRichText && XfaText.shouldBuildText(name)) {
            textDivs.push(_node2);
          }
          childHtml.append(_node2);
        }
      }
      var _iterator111 = _createForOfIteratorHelper(rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")),
        _step111;
      try {
        for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
          var el = _step111.value;
          el.setAttribute("readOnly", true);
        }
      } catch (err) {
        _iterator111.e(err);
      } finally {
        _iterator111.f();
      }
      return {
        textDivs: textDivs
      };
    }
  }, {
    key: "update",
    value: function update(parameters) {
      var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
      parameters.div.style.transform = transform;
      parameters.div.hidden = false;
    }
  }]);
}();
; // ./src/display/annotation_layer.js

var DEFAULT_TAB_INDEX = 1000;
var annotation_layer_DEFAULT_FONT_SIZE = 9;
var GetElementsByNameSet = new WeakSet();
function getRectDims(rect) {
  return {
    width: rect[2] - rect[0],
    height: rect[3] - rect[1]
  };
}
var AnnotationElementFactory = /*#__PURE__*/function () {
  function AnnotationElementFactory() {
    _classCallCheck(this, AnnotationElementFactory);
  }
  return _createClass(AnnotationElementFactory, null, [{
    key: "create",
    value: function create(parameters) {
      var subtype = parameters.data.annotationType;
      switch (subtype) {
        case AnnotationType.LINK:
          return new LinkAnnotationElement(parameters);
        case AnnotationType.TEXT:
          return new TextAnnotationElement(parameters);
        case AnnotationType.WIDGET:
          var fieldType = parameters.data.fieldType;
          switch (fieldType) {
            case "Tx":
              return new TextWidgetAnnotationElement(parameters);
            case "Btn":
              if (parameters.data.radioButton) {
                return new RadioButtonWidgetAnnotationElement(parameters);
              } else if (parameters.data.checkBox) {
                return new CheckboxWidgetAnnotationElement(parameters);
              }
              return new PushButtonWidgetAnnotationElement(parameters);
            case "Ch":
              return new ChoiceWidgetAnnotationElement(parameters);
            case "Sig":
              return new SignatureWidgetAnnotationElement(parameters);
          }
          return new WidgetAnnotationElement(parameters);
        case AnnotationType.POPUP:
          return new PopupAnnotationElement(parameters);
        case AnnotationType.FREETEXT:
          return new FreeTextAnnotationElement(parameters);
        case AnnotationType.LINE:
          return new LineAnnotationElement(parameters);
        case AnnotationType.SQUARE:
          return new SquareAnnotationElement(parameters);
        case AnnotationType.CIRCLE:
          return new CircleAnnotationElement(parameters);
        case AnnotationType.POLYLINE:
          return new PolylineAnnotationElement(parameters);
        case AnnotationType.CARET:
          return new CaretAnnotationElement(parameters);
        case AnnotationType.INK:
          return new InkAnnotationElement(parameters);
        case AnnotationType.POLYGON:
          return new PolygonAnnotationElement(parameters);
        case AnnotationType.HIGHLIGHT:
          return new HighlightAnnotationElement(parameters);
        case AnnotationType.UNDERLINE:
          return new UnderlineAnnotationElement(parameters);
        case AnnotationType.SQUIGGLY:
          return new SquigglyAnnotationElement(parameters);
        case AnnotationType.STRIKEOUT:
          return new StrikeOutAnnotationElement(parameters);
        case AnnotationType.STAMP:
          return new StampAnnotationElement(parameters);
        case AnnotationType.FILEATTACHMENT:
          return new FileAttachmentAnnotationElement(parameters);
        default:
          return new AnnotationElement(parameters);
      }
    }
  }]);
}();
var _updates = /*#__PURE__*/_classPrivateFieldLooseKey("updates");
var _hasBorder = /*#__PURE__*/_classPrivateFieldLooseKey("hasBorder");
var _popupElement = /*#__PURE__*/_classPrivateFieldLooseKey("popupElement");
var _setRectEdited = /*#__PURE__*/_classPrivateFieldLooseKey("setRectEdited");
var AnnotationElement = /*#__PURE__*/function () {
  function AnnotationElement(parameters) {
    var _ref133 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref133$isRenderable = _ref133.isRenderable,
      isRenderable = _ref133$isRenderable === void 0 ? false : _ref133$isRenderable,
      _ref133$ignoreBorder = _ref133.ignoreBorder,
      ignoreBorder = _ref133$ignoreBorder === void 0 ? false : _ref133$ignoreBorder,
      _ref133$createQuadril = _ref133.createQuadrilaterals,
      createQuadrilaterals = _ref133$createQuadril === void 0 ? false : _ref133$createQuadril;
    _classCallCheck(this, AnnotationElement);
    Object.defineProperty(this, _setRectEdited, {
      value: _setRectEdited2
    });
    Object.defineProperty(this, _updates, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _hasBorder, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _popupElement, {
      writable: true,
      value: null
    });
    this.isRenderable = isRenderable;
    this.data = parameters.data;
    this.layer = parameters.layer;
    this.linkService = parameters.linkService;
    this.downloadManager = parameters.downloadManager;
    this.imageResourcesPath = parameters.imageResourcesPath;
    this.renderForms = parameters.renderForms;
    this.svgFactory = parameters.svgFactory;
    this.annotationStorage = parameters.annotationStorage;
    this.enableScripting = parameters.enableScripting;
    this.hasJSActions = parameters.hasJSActions;
    this._fieldObjects = parameters.fieldObjects;
    this.parent = parameters.parent;
    if (isRenderable) {
      this.container = this._createContainer(ignoreBorder);
    }
    if (createQuadrilaterals) {
      this._createQuadrilaterals();
    }
  }
  return _createClass(AnnotationElement, [{
    key: "_isEditable",
    get: function get() {
      return this.data.isEditable;
    }
  }, {
    key: "hasPopupData",
    get: function get() {
      return AnnotationElement._hasPopupData(this.data);
    }
  }, {
    key: "updateEdited",
    value: function updateEdited(params) {
      var _classPrivateFieldLoo69, _classPrivateFieldLoo70;
      if (!this.container) {
        return;
      }
      (_classPrivateFieldLoo69 = _classPrivateFieldLooseBase(this, _updates))[_updates] || (_classPrivateFieldLoo69[_updates] = {
        rect: this.data.rect.slice(0)
      });
      var rect = params.rect;
      if (rect) {
        _classPrivateFieldLooseBase(this, _setRectEdited)[_setRectEdited](rect);
      }
      (_classPrivateFieldLoo70 = _classPrivateFieldLooseBase(this, _popupElement)[_popupElement]) === null || _classPrivateFieldLoo70 === void 0 || _classPrivateFieldLoo70.popup.updateEdited(params);
    }
  }, {
    key: "resetEdited",
    value: function resetEdited() {
      var _classPrivateFieldLoo71;
      if (!_classPrivateFieldLooseBase(this, _updates)[_updates]) {
        return;
      }
      _classPrivateFieldLooseBase(this, _setRectEdited)[_setRectEdited](_classPrivateFieldLooseBase(this, _updates)[_updates].rect);
      (_classPrivateFieldLoo71 = _classPrivateFieldLooseBase(this, _popupElement)[_popupElement]) === null || _classPrivateFieldLoo71 === void 0 || _classPrivateFieldLoo71.popup.resetEdited();
      _classPrivateFieldLooseBase(this, _updates)[_updates] = null;
    }
  }, {
    key: "_createContainer",
    value: function _createContainer(ignoreBorder) {
      var data = this.data,
        _this$parent2 = this.parent,
        page = _this$parent2.page,
        viewport = _this$parent2.viewport;
      var container = document.createElement("section");
      container.setAttribute("data-annotation-id", data.id);
      if (!(this instanceof WidgetAnnotationElement)) {
        container.tabIndex = DEFAULT_TAB_INDEX;
      }
      var style = container.style;
      style.zIndex = this.parent.zIndex++;
      if (data.alternativeText) {
        container.title = data.alternativeText;
      }
      if (data.noRotate) {
        container.classList.add("norotate");
      }
      if (!data.rect || this instanceof PopupAnnotationElement) {
        var _rotation4 = data.rotation;
        if (!data.hasOwnCanvas && _rotation4 !== 0) {
          this.setRotation(_rotation4, container);
        }
        return container;
      }
      var _getRectDims = getRectDims(data.rect),
        width = _getRectDims.width,
        height = _getRectDims.height;
      if (!ignoreBorder && data.borderStyle.width > 0) {
        style.borderWidth = "".concat(data.borderStyle.width, "px");
        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
        var verticalRadius = data.borderStyle.verticalCornerRadius;
        if (horizontalRadius > 0 || verticalRadius > 0) {
          var radius = "calc(".concat(horizontalRadius, "px * var(--scale-factor)) / calc(").concat(verticalRadius, "px * var(--scale-factor))");
          style.borderRadius = radius;
        } else if (this instanceof RadioButtonWidgetAnnotationElement) {
          var _radius = "calc(".concat(width, "px * var(--scale-factor)) / calc(").concat(height, "px * var(--scale-factor))");
          style.borderRadius = _radius;
        }
        switch (data.borderStyle.style) {
          case AnnotationBorderStyleType.SOLID:
            style.borderStyle = "solid";
            break;
          case AnnotationBorderStyleType.DASHED:
            style.borderStyle = "dashed";
            break;
          case AnnotationBorderStyleType.BEVELED:
            warn("Unimplemented border style: beveled");
            break;
          case AnnotationBorderStyleType.INSET:
            warn("Unimplemented border style: inset");
            break;
          case AnnotationBorderStyleType.UNDERLINE:
            style.borderBottomStyle = "solid";
            break;
          default:
            break;
        }
        var borderColor = data.borderColor || null;
        if (borderColor) {
          _classPrivateFieldLooseBase(this, _hasBorder)[_hasBorder] = true;
          style.borderColor = _Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
        } else {
          style.borderWidth = 0;
        }
      }
      var rect = _Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
      var _viewport$rawDims3 = viewport.rawDims,
        pageWidth = _viewport$rawDims3.pageWidth,
        pageHeight = _viewport$rawDims3.pageHeight,
        pageX = _viewport$rawDims3.pageX,
        pageY = _viewport$rawDims3.pageY;
      style.left = "".concat(100 * (rect[0] - pageX) / pageWidth, "%");
      style.top = "".concat(100 * (rect[1] - pageY) / pageHeight, "%");
      var rotation = data.rotation;
      if (data.hasOwnCanvas || rotation === 0) {
        style.width = "".concat(100 * width / pageWidth, "%");
        style.height = "".concat(100 * height / pageHeight, "%");
      } else {
        this.setRotation(rotation, container);
      }
      return container;
    }
  }, {
    key: "setRotation",
    value: function setRotation(angle) {
      var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.container;
      if (!this.data.rect) {
        return;
      }
      var _this$parent$viewport3 = this.parent.viewport.rawDims,
        pageWidth = _this$parent$viewport3.pageWidth,
        pageHeight = _this$parent$viewport3.pageHeight;
      var _getRectDims2 = getRectDims(this.data.rect),
        width = _getRectDims2.width,
        height = _getRectDims2.height;
      var elementWidth, elementHeight;
      if (angle % 180 === 0) {
        elementWidth = 100 * width / pageWidth;
        elementHeight = 100 * height / pageHeight;
      } else {
        elementWidth = 100 * height / pageWidth;
        elementHeight = 100 * width / pageHeight;
      }
      container.style.width = "".concat(elementWidth, "%");
      container.style.height = "".concat(elementHeight, "%");
      container.setAttribute("data-main-rotation", (360 - angle) % 360);
    }
  }, {
    key: "_commonActions",
    get: function get() {
      var _this54 = this;
      var setColor = function setColor(jsName, styleName, event) {
        var color = event.detail[jsName];
        var colorType = color[0];
        var colorArray = color.slice(1);
        event.target.style[styleName] = ColorConverters["".concat(colorType, "_HTML")](colorArray);
        _this54.annotationStorage.setValue(_this54.data.id, _defineProperty({}, styleName, ColorConverters["".concat(colorType, "_rgb")](colorArray)));
      };
      return _shadow(this, "_commonActions", {
        display: function display(event) {
          var display = event.detail.display;
          var hidden = display % 2 === 1;
          _this54.container.style.visibility = hidden ? "hidden" : "visible";
          _this54.annotationStorage.setValue(_this54.data.id, {
            noView: hidden,
            noPrint: display === 1 || display === 2
          });
        },
        print: function print(event) {
          _this54.annotationStorage.setValue(_this54.data.id, {
            noPrint: !event.detail.print
          });
        },
        hidden: function hidden(event) {
          var hidden = event.detail.hidden;
          _this54.container.style.visibility = hidden ? "hidden" : "visible";
          _this54.annotationStorage.setValue(_this54.data.id, {
            noPrint: hidden,
            noView: hidden
          });
        },
        focus: function focus(event) {
          setTimeout(function () {
            return event.target.focus({
              preventScroll: false
            });
          }, 0);
        },
        userName: function userName(event) {
          event.target.title = event.detail.userName;
        },
        readonly: function readonly(event) {
          event.target.disabled = event.detail.readonly;
        },
        required: function required(event) {
          _this54._setRequired(event.target, event.detail.required);
        },
        bgColor: function bgColor(event) {
          setColor("bgColor", "backgroundColor", event);
        },
        fillColor: function fillColor(event) {
          setColor("fillColor", "backgroundColor", event);
        },
        fgColor: function fgColor(event) {
          setColor("fgColor", "color", event);
        },
        textColor: function textColor(event) {
          setColor("textColor", "color", event);
        },
        borderColor: function borderColor(event) {
          setColor("borderColor", "borderColor", event);
        },
        strokeColor: function strokeColor(event) {
          setColor("strokeColor", "borderColor", event);
        },
        rotation: function rotation(event) {
          var angle = event.detail.rotation;
          _this54.setRotation(angle);
          _this54.annotationStorage.setValue(_this54.data.id, {
            rotation: angle
          });
        }
      });
    }
  }, {
    key: "_dispatchEventFromSandbox",
    value: function _dispatchEventFromSandbox(actions, jsEvent) {
      var commonActions = this._commonActions;
      for (var _i18 = 0, _Object$keys = Object.keys(jsEvent.detail); _i18 < _Object$keys.length; _i18++) {
        var name = _Object$keys[_i18];
        var action = actions[name] || commonActions[name];
        action === null || action === void 0 || action(jsEvent);
      }
    }
  }, {
    key: "_setDefaultPropertiesFromJS",
    value: function _setDefaultPropertiesFromJS(element) {
      if (!this.enableScripting) {
        return;
      }
      var storedData = this.annotationStorage.getRawValue(this.data.id);
      if (!storedData) {
        return;
      }
      var commonActions = this._commonActions;
      for (var _i19 = 0, _Object$entries5 = Object.entries(storedData); _i19 < _Object$entries5.length; _i19++) {
        var _ref134 = _Object$entries5[_i19];
        var _ref135 = _slicedToArray(_ref134, 2);
        var actionName = _ref135[0];
        var detail = _ref135[1];
        var action = commonActions[actionName];
        if (action) {
          var eventProxy = {
            detail: _defineProperty({}, actionName, detail),
            target: element
          };
          action(eventProxy);
          delete storedData[actionName];
        }
      }
    }
  }, {
    key: "_createQuadrilaterals",
    value: function _createQuadrilaterals() {
      if (!this.container) {
        return;
      }
      var quadPoints = this.data.quadPoints;
      if (!quadPoints) {
        return;
      }
      var _this$data$rect$map = this.data.rect.map(function (x) {
          return Math.fround(x);
        }),
        _this$data$rect$map2 = _slicedToArray(_this$data$rect$map, 4),
        rectBlX = _this$data$rect$map2[0],
        rectBlY = _this$data$rect$map2[1],
        rectTrX = _this$data$rect$map2[2],
        rectTrY = _this$data$rect$map2[3];
      if (quadPoints.length === 8) {
        var _quadPoints$subarray = quadPoints.subarray(2, 6),
          _quadPoints$subarray2 = _slicedToArray(_quadPoints$subarray, 4),
          trX = _quadPoints$subarray2[0],
          trY = _quadPoints$subarray2[1],
          blX = _quadPoints$subarray2[2],
          blY = _quadPoints$subarray2[3];
        if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) {
          return;
        }
      }
      var style = this.container.style;
      var svgBuffer;
      if (_classPrivateFieldLooseBase(this, _hasBorder)[_hasBorder]) {
        var borderColor = style.borderColor,
          borderWidth = style.borderWidth;
        style.borderWidth = 0;
        svgBuffer = ["url('data:image/svg+xml;utf8,", "<svg xmlns=\"http://www.w3.org/2000/svg\"", " preserveAspectRatio=\"none\" viewBox=\"0 0 1 1\">", "<g fill=\"transparent\" stroke=\"".concat(borderColor, "\" stroke-width=\"").concat(borderWidth, "\">")];
        this.container.classList.add("hasBorder");
      }
      var width = rectTrX - rectBlX;
      var height = rectTrY - rectBlY;
      var svgFactory = this.svgFactory;
      var svg = svgFactory.createElement("svg");
      svg.classList.add("quadrilateralsContainer");
      svg.setAttribute("width", 0);
      svg.setAttribute("height", 0);
      var defs = svgFactory.createElement("defs");
      svg.append(defs);
      var clipPath = svgFactory.createElement("clipPath");
      var id = "clippath_".concat(this.data.id);
      clipPath.setAttribute("id", id);
      clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
      defs.append(clipPath);
      for (var i = 2, ii = quadPoints.length; i < ii; i += 8) {
        var _svgBuffer;
        var _trX = quadPoints[i];
        var _trY = quadPoints[i + 1];
        var _blX = quadPoints[i + 2];
        var _blY = quadPoints[i + 3];
        var rect = svgFactory.createElement("rect");
        var x = (_blX - rectBlX) / width;
        var y = (rectTrY - _trY) / height;
        var rectWidth = (_trX - _blX) / width;
        var rectHeight = (_trY - _blY) / height;
        rect.setAttribute("x", x);
        rect.setAttribute("y", y);
        rect.setAttribute("width", rectWidth);
        rect.setAttribute("height", rectHeight);
        clipPath.append(rect);
        (_svgBuffer = svgBuffer) === null || _svgBuffer === void 0 || _svgBuffer.push("<rect vector-effect=\"non-scaling-stroke\" x=\"".concat(x, "\" y=\"").concat(y, "\" width=\"").concat(rectWidth, "\" height=\"").concat(rectHeight, "\"/>"));
      }
      if (_classPrivateFieldLooseBase(this, _hasBorder)[_hasBorder]) {
        svgBuffer.push("</g></svg>')");
        style.backgroundImage = svgBuffer.join("");
      }
      this.container.append(svg);
      this.container.style.clipPath = "url(#".concat(id, ")");
    }
  }, {
    key: "_createPopup",
    value: function _createPopup() {
      var data = this.data;
      var popup = _classPrivateFieldLooseBase(this, _popupElement)[_popupElement] = new PopupAnnotationElement({
        data: {
          color: data.color,
          titleObj: data.titleObj,
          modificationDate: data.modificationDate,
          contentsObj: data.contentsObj,
          richText: data.richText,
          parentRect: data.rect,
          borderStyle: 0,
          id: "popup_".concat(data.id),
          rotation: data.rotation
        },
        parent: this.parent,
        elements: [this]
      });
      this.parent.div.append(popup.render());
    }
  }, {
    key: "render",
    value: function render() {
      unreachable("Abstract method `AnnotationElement.render` called");
    }
  }, {
    key: "_getElementsByName",
    value: function _getElementsByName(name) {
      var skipId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var fields = [];
      if (this._fieldObjects) {
        var fieldObj = this._fieldObjects[name];
        if (fieldObj) {
          var _iterator112 = _createForOfIteratorHelper(fieldObj),
            _step112;
          try {
            for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
              var _ref136 = _step112.value;
              var page = _ref136.page;
              var _id10 = _ref136.id;
              var exportValues = _ref136.exportValues;
              if (page === -1) {
                continue;
              }
              if (_id10 === skipId) {
                continue;
              }
              var exportValue = typeof exportValues === "string" ? exportValues : null;
              var domElement = document.querySelector("[data-element-id=\"".concat(_id10, "\"]"));
              if (domElement && !GetElementsByNameSet.has(domElement)) {
                warn("_getElementsByName - element not allowed: ".concat(_id10));
                continue;
              }
              fields.push({
                id: _id10,
                exportValue: exportValue,
                domElement: domElement
              });
            }
          } catch (err) {
            _iterator112.e(err);
          } finally {
            _iterator112.f();
          }
        }
        return fields;
      }
      var _iterator113 = _createForOfIteratorHelper(document.getElementsByName(name)),
        _step113;
      try {
        for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
          var _domElement = _step113.value;
          var _exportValue = _domElement.exportValue;
          var _id11 = _domElement.getAttribute("data-element-id");
          if (_id11 === skipId) {
            continue;
          }
          if (!GetElementsByNameSet.has(_domElement)) {
            continue;
          }
          fields.push({
            id: _id11,
            exportValue: _exportValue,
            domElement: _domElement
          });
        }
      } catch (err) {
        _iterator113.e(err);
      } finally {
        _iterator113.f();
      }
      return fields;
    }
  }, {
    key: "show",
    value: function show() {
      var _this$popup;
      if (this.container) {
        this.container.hidden = false;
      }
      (_this$popup = this.popup) === null || _this$popup === void 0 || _this$popup.maybeShow();
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this$popup2;
      if (this.container) {
        this.container.hidden = true;
      }
      (_this$popup2 = this.popup) === null || _this$popup2 === void 0 || _this$popup2.forceHide();
    }
  }, {
    key: "getElementsToTriggerPopup",
    value: function getElementsToTriggerPopup() {
      return this.container;
    }
  }, {
    key: "addHighlightArea",
    value: function addHighlightArea() {
      var triggers = this.getElementsToTriggerPopup();
      if (Array.isArray(triggers)) {
        var _iterator114 = _createForOfIteratorHelper(triggers),
          _step114;
        try {
          for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
            var element = _step114.value;
            element.classList.add("highlightArea");
          }
        } catch (err) {
          _iterator114.e(err);
        } finally {
          _iterator114.f();
        }
      } else {
        triggers.classList.add("highlightArea");
      }
    }
  }, {
    key: "_editOnDoubleClick",
    value: function _editOnDoubleClick() {
      var _this55 = this;
      if (!this._isEditable) {
        return;
      }
      var mode = this.annotationEditorType,
        editId = this.data.id;
      this.container.addEventListener("dblclick", function () {
        var _this55$linkService$e;
        (_this55$linkService$e = _this55.linkService.eventBus) === null || _this55$linkService$e === void 0 || _this55$linkService$e.dispatch("switchannotationeditormode", {
          source: _this55,
          mode: mode,
          editId: editId
        });
      });
    }
  }], [{
    key: "_hasPopupData",
    value: function _hasPopupData(_ref137) {
      var titleObj = _ref137.titleObj,
        contentsObj = _ref137.contentsObj,
        richText = _ref137.richText;
      return !!(titleObj !== null && titleObj !== void 0 && titleObj.str || contentsObj !== null && contentsObj !== void 0 && contentsObj.str || richText !== null && richText !== void 0 && richText.str);
    }
  }]);
}();
function _setRectEdited2(rect) {
  var style = this.container.style,
    _this$data3 = this.data,
    currentRect = _this$data3.rect,
    rotation = _this$data3.rotation,
    _this$parent$viewport4 = this.parent.viewport.rawDims,
    pageWidth = _this$parent$viewport4.pageWidth,
    pageHeight = _this$parent$viewport4.pageHeight,
    pageX = _this$parent$viewport4.pageX,
    pageY = _this$parent$viewport4.pageY;
  currentRect === null || currentRect === void 0 || currentRect.splice.apply(currentRect, [0, 4].concat(_toConsumableArray(rect)));
  var _getRectDims9 = getRectDims(rect),
    width = _getRectDims9.width,
    height = _getRectDims9.height;
  style.left = "".concat(100 * (rect[0] - pageX) / pageWidth, "%");
  style.top = "".concat(100 * (pageHeight - rect[3] + pageY) / pageHeight, "%");
  if (rotation === 0) {
    style.width = "".concat(100 * width / pageWidth, "%");
    style.height = "".concat(100 * height / pageHeight, "%");
  } else {
    this.setRotation(rotation);
  }
}
var _setInternalLink = /*#__PURE__*/_classPrivateFieldLooseKey("setInternalLink");
var _bindAttachment = /*#__PURE__*/_classPrivateFieldLooseKey("bindAttachment");
var _bindSetOCGState = /*#__PURE__*/_classPrivateFieldLooseKey("bindSetOCGState");
var LinkAnnotationElement = /*#__PURE__*/function (_AnnotationElement2) {
  function LinkAnnotationElement(parameters) {
    var _this56;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, LinkAnnotationElement);
    _this56 = _callSuper(this, LinkAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: !!(options !== null && options !== void 0 && options.ignoreBorder),
      createQuadrilaterals: true
    }]);
    Object.defineProperty(_this56, _bindSetOCGState, {
      value: _bindSetOCGState2
    });
    Object.defineProperty(_this56, _bindAttachment, {
      value: _bindAttachment2
    });
    Object.defineProperty(_this56, _setInternalLink, {
      value: _setInternalLink2
    });
    _this56.isTooltipOnly = parameters.data.isTooltipOnly;
    return _this56;
  }
  _inherits(LinkAnnotationElement, _AnnotationElement2);
  return _createClass(LinkAnnotationElement, [{
    key: "render",
    value: function render() {
      var data = this.data,
        linkService = this.linkService;
      var link = document.createElement("a");
      link.setAttribute("data-element-id", data.id);
      var isBound = false;
      if (data.url) {
        linkService.addLinkAttributes(link, data.url, data.newWindow);
        isBound = true;
      } else if (data.action) {
        this._bindNamedAction(link, data.action);
        isBound = true;
      } else if (data.attachment) {
        _classPrivateFieldLooseBase(this, _bindAttachment)[_bindAttachment](link, data.attachment, data.attachmentDest);
        isBound = true;
      } else if (data.setOCGState) {
        _classPrivateFieldLooseBase(this, _bindSetOCGState)[_bindSetOCGState](link, data.setOCGState);
        isBound = true;
      } else if (data.dest) {
        this._bindLink(link, data.dest);
        isBound = true;
      } else {
        if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
          this._bindJSAction(link, data);
          isBound = true;
        }
        if (data.resetForm) {
          this._bindResetFormAction(link, data.resetForm);
          isBound = true;
        } else if (this.isTooltipOnly && !isBound) {
          this._bindLink(link, "");
          isBound = true;
        }
      }
      this.container.classList.add("linkAnnotation");
      if (isBound) {
        this.container.append(link);
      }
      return this.container;
    }
  }, {
    key: "_bindLink",
    value: function _bindLink(link, destination) {
      var _this57 = this;
      link.href = this.linkService.getDestinationHash(destination);
      link.onclick = function () {
        if (destination) {
          _this57.linkService.goToDestination(destination);
        }
        return false;
      };
      if (destination || destination === "") {
        _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
      }
    }
  }, {
    key: "_bindNamedAction",
    value: function _bindNamedAction(link, action) {
      var _this58 = this;
      link.href = this.linkService.getAnchorUrl("");
      link.onclick = function () {
        _this58.linkService.executeNamedAction(action);
        return false;
      };
      _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
    }
  }, {
    key: "_bindJSAction",
    value: function _bindJSAction(link, data) {
      var _this59 = this;
      link.href = this.linkService.getAnchorUrl("");
      var map = new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
      var _loop2 = function _loop2() {
        var name = _Object$keys2[_i20];
        var jsName = map.get(name);
        if (!jsName) {
          return 1; // continue
        }
        link[jsName] = function () {
          var _this59$linkService$e;
          (_this59$linkService$e = _this59.linkService.eventBus) === null || _this59$linkService$e === void 0 || _this59$linkService$e.dispatch("dispatcheventinsandbox", {
            source: _this59,
            detail: {
              id: data.id,
              name: name
            }
          });
          return false;
        };
      };
      for (var _i20 = 0, _Object$keys2 = Object.keys(data.actions); _i20 < _Object$keys2.length; _i20++) {
        if (_loop2()) continue;
      }
      if (!link.onclick) {
        link.onclick = function () {
          return false;
        };
      }
      _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
    }
  }, {
    key: "_bindResetFormAction",
    value: function _bindResetFormAction(link, resetForm) {
      var _this60 = this;
      var otherClickAction = link.onclick;
      if (!otherClickAction) {
        link.href = this.linkService.getAnchorUrl("");
      }
      _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
      if (!this._fieldObjects) {
        warn("_bindResetFormAction - \"resetForm\" action not supported, " + "ensure that the `fieldObjects` parameter is provided.");
        if (!otherClickAction) {
          link.onclick = function () {
            return false;
          };
        }
        return;
      }
      link.onclick = function () {
        otherClickAction === null || otherClickAction === void 0 || otherClickAction();
        var resetFormFields = resetForm.fields,
          resetFormRefs = resetForm.refs,
          include = resetForm.include;
        var allFields = [];
        if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
          var fieldIds = new Set(resetFormRefs);
          var _iterator115 = _createForOfIteratorHelper(resetFormFields),
            _step115;
          try {
            for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
              var fieldName = _step115.value;
              var _fields = _this60._fieldObjects[fieldName] || [];
              var _iterator117 = _createForOfIteratorHelper(_fields),
                _step117;
              try {
                for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
                  var _ref138 = _step117.value;
                  var _id12 = _ref138.id;
                  fieldIds.add(_id12);
                }
              } catch (err) {
                _iterator117.e(err);
              } finally {
                _iterator117.f();
              }
            }
          } catch (err) {
            _iterator115.e(err);
          } finally {
            _iterator115.f();
          }
          for (var _i21 = 0, _Object$values = Object.values(_this60._fieldObjects); _i21 < _Object$values.length; _i21++) {
            var fields = _Object$values[_i21];
            var _iterator116 = _createForOfIteratorHelper(fields),
              _step116;
            try {
              for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
                var field = _step116.value;
                if (fieldIds.has(field.id) === include) {
                  allFields.push(field);
                }
              }
            } catch (err) {
              _iterator116.e(err);
            } finally {
              _iterator116.f();
            }
          }
        } else {
          for (var _i22 = 0, _Object$values2 = Object.values(_this60._fieldObjects); _i22 < _Object$values2.length; _i22++) {
            var _fields2 = _Object$values2[_i22];
            allFields.push.apply(allFields, _toConsumableArray(_fields2));
          }
        }
        var storage = _this60.annotationStorage;
        var allIds = [];
        for (var _i23 = 0, _allFields = allFields; _i23 < _allFields.length; _i23++) {
          var _field = _allFields[_i23];
          var _id13 = _field.id;
          allIds.push(_id13);
          switch (_field.type) {
            case "text":
              {
                var value = _field.defaultValue || "";
                storage.setValue(_id13, {
                  value: value
                });
                break;
              }
            case "checkbox":
            case "radiobutton":
              {
                var _value2 = _field.defaultValue === _field.exportValues;
                storage.setValue(_id13, {
                  value: _value2
                });
                break;
              }
            case "combobox":
            case "listbox":
              {
                var _value3 = _field.defaultValue || "";
                storage.setValue(_id13, {
                  value: _value3
                });
                break;
              }
            default:
              continue;
          }
          var domElement = document.querySelector("[data-element-id=\"".concat(_id13, "\"]"));
          if (!domElement) {
            continue;
          } else if (!GetElementsByNameSet.has(domElement)) {
            warn("_bindResetFormAction - element not allowed: ".concat(_id13));
            continue;
          }
          domElement.dispatchEvent(new Event("resetform"));
        }
        if (_this60.enableScripting) {
          var _this60$linkService$e;
          (_this60$linkService$e = _this60.linkService.eventBus) === null || _this60$linkService$e === void 0 || _this60$linkService$e.dispatch("dispatcheventinsandbox", {
            source: _this60,
            detail: {
              id: "app",
              ids: allIds,
              name: "ResetForm"
            }
          });
        }
        return false;
      };
    }
  }]);
}(AnnotationElement);
function _setInternalLink2() {
  this.container.setAttribute("data-internal-link", "");
}
function _bindAttachment2(link, attachment) {
  var _this95 = this;
  var dest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  link.href = this.linkService.getAnchorUrl("");
  if (attachment.description) {
    link.title = attachment.description;
  }
  link.onclick = function () {
    var _this95$downloadManag;
    (_this95$downloadManag = _this95.downloadManager) === null || _this95$downloadManag === void 0 || _this95$downloadManag.openOrDownloadData(attachment.content, attachment.filename, dest);
    return false;
  };
  _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
}
function _bindSetOCGState2(link, action) {
  var _this96 = this;
  link.href = this.linkService.getAnchorUrl("");
  link.onclick = function () {
    _this96.linkService.executeSetOCGState(action);
    return false;
  };
  _classPrivateFieldLooseBase(this, _setInternalLink)[_setInternalLink]();
}
var TextAnnotationElement = /*#__PURE__*/function (_AnnotationElement3) {
  function TextAnnotationElement(parameters) {
    _classCallCheck(this, TextAnnotationElement);
    return _callSuper(this, TextAnnotationElement, [parameters, {
      isRenderable: true
    }]);
  }
  _inherits(TextAnnotationElement, _AnnotationElement3);
  return _createClass(TextAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.classList.add("textAnnotation");
      var image = document.createElement("img");
      image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
      image.setAttribute("data-l10n-id", "pdfjs-text-annotation-type");
      image.setAttribute("data-l10n-args", JSON.stringify({
        type: this.data.name
      }));
      if (!this.data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      this.container.append(image);
      return this.container;
    }
  }]);
}(AnnotationElement);
var WidgetAnnotationElement = /*#__PURE__*/function (_AnnotationElement4) {
  function WidgetAnnotationElement() {
    _classCallCheck(this, WidgetAnnotationElement);
    return _callSuper(this, WidgetAnnotationElement, arguments);
  }
  _inherits(WidgetAnnotationElement, _AnnotationElement4);
  return _createClass(WidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      return this.container;
    }
  }, {
    key: "showElementAndHideCanvas",
    value: function showElementAndHideCanvas(element) {
      if (this.data.hasOwnCanvas) {
        var _element$previousSibl;
        if (((_element$previousSibl = element.previousSibling) === null || _element$previousSibl === void 0 ? void 0 : _element$previousSibl.nodeName) === "CANVAS") {
          element.previousSibling.hidden = true;
        }
        element.hidden = false;
      }
    }
  }, {
    key: "_getKeyModifier",
    value: function _getKeyModifier(event) {
      return util_FeatureTest.platform.isMac ? event.metaKey : event.ctrlKey;
    }
  }, {
    key: "_setEventListener",
    value: function _setEventListener(element, elementData, baseName, eventName, valueGetter) {
      var _this61 = this;
      if (baseName.includes("mouse")) {
        element.addEventListener(baseName, function (event) {
          var _this61$linkService$e;
          (_this61$linkService$e = _this61.linkService.eventBus) === null || _this61$linkService$e === void 0 || _this61$linkService$e.dispatch("dispatcheventinsandbox", {
            source: _this61,
            detail: {
              id: _this61.data.id,
              name: eventName,
              value: valueGetter(event),
              shift: event.shiftKey,
              modifier: _this61._getKeyModifier(event)
            }
          });
        });
      } else {
        element.addEventListener(baseName, function (event) {
          var _this61$linkService$e2;
          if (baseName === "blur") {
            if (!elementData.focused || !event.relatedTarget) {
              return;
            }
            elementData.focused = false;
          } else if (baseName === "focus") {
            if (elementData.focused) {
              return;
            }
            elementData.focused = true;
          }
          if (!valueGetter) {
            return;
          }
          (_this61$linkService$e2 = _this61.linkService.eventBus) === null || _this61$linkService$e2 === void 0 || _this61$linkService$e2.dispatch("dispatcheventinsandbox", {
            source: _this61,
            detail: {
              id: _this61.data.id,
              name: eventName,
              value: valueGetter(event)
            }
          });
        });
      }
    }
  }, {
    key: "_setEventListeners",
    value: function _setEventListeners(element, elementData, names, getter) {
      var _iterator118 = _createForOfIteratorHelper(names),
        _step118;
      try {
        for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
          var _this$data$actions;
          var _ref139 = _step118.value;
          var _ref140 = _slicedToArray(_ref139, 2);
          var baseName = _ref140[0];
          var eventName = _ref140[1];
          if (eventName === "Action" || (_this$data$actions = this.data.actions) !== null && _this$data$actions !== void 0 && _this$data$actions[eventName]) {
            var _this$data$actions2, _this$data$actions3;
            if (eventName === "Focus" || eventName === "Blur") {
              elementData || (elementData = {
                focused: false
              });
            }
            this._setEventListener(element, elementData, baseName, eventName, getter);
            if (eventName === "Focus" && !((_this$data$actions2 = this.data.actions) !== null && _this$data$actions2 !== void 0 && _this$data$actions2.Blur)) {
              this._setEventListener(element, elementData, "blur", "Blur", null);
            } else if (eventName === "Blur" && !((_this$data$actions3 = this.data.actions) !== null && _this$data$actions3 !== void 0 && _this$data$actions3.Focus)) {
              this._setEventListener(element, elementData, "focus", "Focus", null);
            }
          }
        }
      } catch (err) {
        _iterator118.e(err);
      } finally {
        _iterator118.f();
      }
    }
  }, {
    key: "_setBackgroundColor",
    value: function _setBackgroundColor(element) {
      var color = this.data.backgroundColor || null;
      element.style.backgroundColor = color === null ? "transparent" : _Util.makeHexColor(color[0], color[1], color[2]);
    }
  }, {
    key: "_setTextStyle",
    value: function _setTextStyle(element) {
      var TEXT_ALIGNMENT = ["left", "center", "right"];
      var fontColor = this.data.defaultAppearanceData.fontColor;
      var fontSize = this.data.defaultAppearanceData.fontSize || annotation_layer_DEFAULT_FONT_SIZE;
      var style = element.style;
      var computedFontSize;
      var BORDER_SIZE = 2;
      var roundToOneDecimal = function roundToOneDecimal(x) {
        return Math.round(10 * x) / 10;
      };
      if (this.data.multiLine) {
        var height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
        var numberOfLines = Math.round(height / (LINE_FACTOR * fontSize)) || 1;
        var lineHeight = height / numberOfLines;
        computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / LINE_FACTOR));
      } else {
        var _height2 = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
        computedFontSize = Math.min(fontSize, roundToOneDecimal(_height2 / LINE_FACTOR));
      }
      style.fontSize = "calc(".concat(computedFontSize, "px * var(--scale-factor))");
      style.color = _Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
      if (this.data.textAlignment !== null) {
        style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
      }
    }
  }, {
    key: "_setRequired",
    value: function _setRequired(element, isRequired) {
      if (isRequired) {
        element.setAttribute("required", true);
      } else {
        element.removeAttribute("required");
      }
      element.setAttribute("aria-required", isRequired);
    }
  }]);
}(AnnotationElement);
var TextWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem) {
  function TextWidgetAnnotationElement(parameters) {
    _classCallCheck(this, TextWidgetAnnotationElement);
    var isRenderable = parameters.renderForms || parameters.data.hasOwnCanvas || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
    return _callSuper(this, TextWidgetAnnotationElement, [parameters, {
      isRenderable: isRenderable
    }]);
  }
  _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);
  return _createClass(TextWidgetAnnotationElement, [{
    key: "setPropertyOnSiblings",
    value: function setPropertyOnSiblings(base, key, value, keyInStorage) {
      var storage = this.annotationStorage;
      var _iterator119 = _createForOfIteratorHelper(this._getElementsByName(base.name, base.id)),
        _step119;
      try {
        for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
          var element = _step119.value;
          if (element.domElement) {
            element.domElement[key] = value;
          }
          storage.setValue(element.id, _defineProperty({}, keyInStorage, value));
        }
      } catch (err) {
        _iterator119.e(err);
      } finally {
        _iterator119.f();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this62 = this;
      var storage = this.annotationStorage;
      var id = this.data.id;
      this.container.classList.add("textWidgetAnnotation");
      var element = null;
      if (this.renderForms) {
        var _this$data$textConten;
        var storedData = storage.getValue(id, {
          value: this.data.fieldValue
        });
        var textContent = storedData.value || "";
        var maxLen = storage.getValue(id, {
          charLimit: this.data.maxLen
        }).charLimit;
        if (maxLen && textContent.length > maxLen) {
          textContent = textContent.slice(0, maxLen);
        }
        var fieldFormattedValues = storedData.formattedValue || ((_this$data$textConten = this.data.textContent) === null || _this$data$textConten === void 0 ? void 0 : _this$data$textConten.join("\n")) || null;
        if (fieldFormattedValues && this.data.comb) {
          fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
        }
        var elementData = {
          userValue: textContent,
          formattedValue: fieldFormattedValues,
          lastCommittedValue: null,
          commitKey: 1,
          focused: false
        };
        if (this.data.multiLine) {
          element = document.createElement("textarea");
          element.textContent = fieldFormattedValues !== null && fieldFormattedValues !== void 0 ? fieldFormattedValues : textContent;
          if (this.data.doNotScroll) {
            element.style.overflowY = "hidden";
          }
        } else {
          element = document.createElement("input");
          element.type = "text";
          element.setAttribute("value", fieldFormattedValues !== null && fieldFormattedValues !== void 0 ? fieldFormattedValues : textContent);
          if (this.data.doNotScroll) {
            element.style.overflowX = "hidden";
          }
        }
        if (this.data.hasOwnCanvas) {
          element.hidden = true;
        }
        GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = this.data.readOnly;
        element.name = this.data.fieldName;
        element.tabIndex = DEFAULT_TAB_INDEX;
        this._setRequired(element, this.data.required);
        if (maxLen) {
          element.maxLength = maxLen;
        }
        element.addEventListener("input", function (event) {
          storage.setValue(id, {
            value: event.target.value
          });
          _this62.setPropertyOnSiblings(element, "value", event.target.value, "value");
          elementData.formattedValue = null;
        });
        element.addEventListener("resetform", function (event) {
          var _this62$data$defaultF;
          var defaultValue = (_this62$data$defaultF = _this62.data.defaultFieldValue) !== null && _this62$data$defaultF !== void 0 ? _this62$data$defaultF : "";
          element.value = elementData.userValue = defaultValue;
          elementData.formattedValue = null;
        });
        var blurListener = function blurListener(event) {
          var formattedValue = elementData.formattedValue;
          if (formattedValue !== null && formattedValue !== undefined) {
            event.target.value = formattedValue;
          }
          event.target.scrollLeft = 0;
        };
        if (this.enableScripting && this.hasJSActions) {
          var _this$data$actions4;
          element.addEventListener("focus", function (event) {
            var _this62$data$actions;
            if (elementData.focused) {
              return;
            }
            var target = event.target;
            if (elementData.userValue) {
              target.value = elementData.userValue;
            }
            elementData.lastCommittedValue = target.value;
            elementData.commitKey = 1;
            if (!((_this62$data$actions = _this62.data.actions) !== null && _this62$data$actions !== void 0 && _this62$data$actions.Focus)) {
              elementData.focused = true;
            }
          });
          element.addEventListener("updatefromsandbox", function (jsEvent) {
            _this62.showElementAndHideCanvas(jsEvent.target);
            var actions = {
              value: function value(event) {
                var _event$detail$value;
                elementData.userValue = (_event$detail$value = event.detail.value) !== null && _event$detail$value !== void 0 ? _event$detail$value : "";
                storage.setValue(id, {
                  value: elementData.userValue.toString()
                });
                event.target.value = elementData.userValue;
              },
              formattedValue: function formattedValue(event) {
                var formattedValue = event.detail.formattedValue;
                elementData.formattedValue = formattedValue;
                if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) {
                  event.target.value = formattedValue;
                }
                storage.setValue(id, {
                  formattedValue: formattedValue
                });
              },
              selRange: function selRange(event) {
                var _event$target;
                (_event$target = event.target).setSelectionRange.apply(_event$target, _toConsumableArray(event.detail.selRange));
              },
              charLimit: function charLimit(event) {
                var _this62$linkService$e;
                var charLimit = event.detail.charLimit;
                var target = event.target;
                if (charLimit === 0) {
                  target.removeAttribute("maxLength");
                  return;
                }
                target.setAttribute("maxLength", charLimit);
                var value = elementData.userValue;
                if (!value || value.length <= charLimit) {
                  return;
                }
                value = value.slice(0, charLimit);
                target.value = elementData.userValue = value;
                storage.setValue(id, {
                  value: value
                });
                (_this62$linkService$e = _this62.linkService.eventBus) === null || _this62$linkService$e === void 0 || _this62$linkService$e.dispatch("dispatcheventinsandbox", {
                  source: _this62,
                  detail: {
                    id: id,
                    name: "Keystroke",
                    value: value,
                    willCommit: true,
                    commitKey: 1,
                    selStart: target.selectionStart,
                    selEnd: target.selectionEnd
                  }
                });
              }
            };
            _this62._dispatchEventFromSandbox(actions, jsEvent);
          });
          element.addEventListener("keydown", function (event) {
            var _this62$linkService$e2;
            elementData.commitKey = 1;
            var commitKey = -1;
            if (event.key === "Escape") {
              commitKey = 0;
            } else if (event.key === "Enter" && !_this62.data.multiLine) {
              commitKey = 2;
            } else if (event.key === "Tab") {
              elementData.commitKey = 3;
            }
            if (commitKey === -1) {
              return;
            }
            var value = event.target.value;
            if (elementData.lastCommittedValue === value) {
              return;
            }
            elementData.lastCommittedValue = value;
            elementData.userValue = value;
            (_this62$linkService$e2 = _this62.linkService.eventBus) === null || _this62$linkService$e2 === void 0 || _this62$linkService$e2.dispatch("dispatcheventinsandbox", {
              source: _this62,
              detail: {
                id: id,
                name: "Keystroke",
                value: value,
                willCommit: true,
                commitKey: commitKey,
                selStart: event.target.selectionStart,
                selEnd: event.target.selectionEnd
              }
            });
          });
          var _blurListener = blurListener;
          blurListener = null;
          element.addEventListener("blur", function (event) {
            var _this62$data$actions2;
            if (!elementData.focused || !event.relatedTarget) {
              return;
            }
            if (!((_this62$data$actions2 = _this62.data.actions) !== null && _this62$data$actions2 !== void 0 && _this62$data$actions2.Blur)) {
              elementData.focused = false;
            }
            var value = event.target.value;
            elementData.userValue = value;
            if (elementData.lastCommittedValue !== value) {
              var _this62$linkService$e3;
              (_this62$linkService$e3 = _this62.linkService.eventBus) === null || _this62$linkService$e3 === void 0 || _this62$linkService$e3.dispatch("dispatcheventinsandbox", {
                source: _this62,
                detail: {
                  id: id,
                  name: "Keystroke",
                  value: value,
                  willCommit: true,
                  commitKey: elementData.commitKey,
                  selStart: event.target.selectionStart,
                  selEnd: event.target.selectionEnd
                }
              });
            }
            _blurListener(event);
          });
          if ((_this$data$actions4 = this.data.actions) !== null && _this$data$actions4 !== void 0 && _this$data$actions4.Keystroke) {
            element.addEventListener("beforeinput", function (event) {
              var _this62$linkService$e4;
              elementData.lastCommittedValue = null;
              var data = event.data,
                target = event.target;
              var value = target.value,
                selectionStart = target.selectionStart,
                selectionEnd = target.selectionEnd;
              var selStart = selectionStart,
                selEnd = selectionEnd;
              switch (event.inputType) {
                case "deleteWordBackward":
                  {
                    var match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                    if (match) {
                      selStart -= match[0].length;
                    }
                    break;
                  }
                case "deleteWordForward":
                  {
                    var _match3 = value.substring(selectionStart).match(/^[^\w]*\w*/);
                    if (_match3) {
                      selEnd += _match3[0].length;
                    }
                    break;
                  }
                case "deleteContentBackward":
                  if (selectionStart === selectionEnd) {
                    selStart -= 1;
                  }
                  break;
                case "deleteContentForward":
                  if (selectionStart === selectionEnd) {
                    selEnd += 1;
                  }
                  break;
              }
              event.preventDefault();
              (_this62$linkService$e4 = _this62.linkService.eventBus) === null || _this62$linkService$e4 === void 0 || _this62$linkService$e4.dispatch("dispatcheventinsandbox", {
                source: _this62,
                detail: {
                  id: id,
                  name: "Keystroke",
                  value: value,
                  change: data || "",
                  willCommit: false,
                  selStart: selStart,
                  selEnd: selEnd
                }
              });
            });
          }
          this._setEventListeners(element, elementData, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function (event) {
            return event.target.value;
          });
        }
        if (blurListener) {
          element.addEventListener("blur", blurListener);
        }
        if (this.data.comb) {
          var fieldWidth = this.data.rect[2] - this.data.rect[0];
          var combWidth = fieldWidth / maxLen;
          element.classList.add("comb");
          element.style.letterSpacing = "calc(".concat(combWidth, "px * var(--scale-factor) - 1ch)");
        }
      } else {
        element = document.createElement("div");
        element.textContent = this.data.fieldValue;
        element.style.verticalAlign = "middle";
        element.style.display = "table-cell";
        if (this.data.hasOwnCanvas) {
          element.hidden = true;
        }
      }
      this._setTextStyle(element);
      this._setBackgroundColor(element);
      this._setDefaultPropertiesFromJS(element);
      this.container.append(element);
      return this.container;
    }
  }]);
}(WidgetAnnotationElement);
var SignatureWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem2) {
  function SignatureWidgetAnnotationElement(parameters) {
    _classCallCheck(this, SignatureWidgetAnnotationElement);
    return _callSuper(this, SignatureWidgetAnnotationElement, [parameters, {
      isRenderable: !!parameters.data.hasOwnCanvas
    }]);
  }
  _inherits(SignatureWidgetAnnotationElement, _WidgetAnnotationElem2);
  return _createClass(SignatureWidgetAnnotationElement);
}(WidgetAnnotationElement);
var CheckboxWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem3) {
  function CheckboxWidgetAnnotationElement(parameters) {
    _classCallCheck(this, CheckboxWidgetAnnotationElement);
    return _callSuper(this, CheckboxWidgetAnnotationElement, [parameters, {
      isRenderable: parameters.renderForms
    }]);
  }
  _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem3);
  return _createClass(CheckboxWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      var _this63 = this;
      var storage = this.annotationStorage;
      var data = this.data;
      var id = data.id;
      var value = storage.getValue(id, {
        value: data.exportValue === data.fieldValue
      }).value;
      if (typeof value === "string") {
        value = value !== "Off";
        storage.setValue(id, {
          value: value
        });
      }
      this.container.classList.add("buttonWidgetAnnotation", "checkBox");
      var element = document.createElement("input");
      GetElementsByNameSet.add(element);
      element.setAttribute("data-element-id", id);
      element.disabled = data.readOnly;
      this._setRequired(element, this.data.required);
      element.type = "checkbox";
      element.name = data.fieldName;
      if (value) {
        element.setAttribute("checked", true);
      }
      element.setAttribute("exportValue", data.exportValue);
      element.tabIndex = DEFAULT_TAB_INDEX;
      element.addEventListener("change", function (event) {
        var _event$target2 = event.target,
          name = _event$target2.name,
          checked = _event$target2.checked;
        var _iterator120 = _createForOfIteratorHelper(_this63._getElementsByName(name, id)),
          _step120;
        try {
          for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
            var checkbox = _step120.value;
            var curChecked = checked && checkbox.exportValue === data.exportValue;
            if (checkbox.domElement) {
              checkbox.domElement.checked = curChecked;
            }
            storage.setValue(checkbox.id, {
              value: curChecked
            });
          }
        } catch (err) {
          _iterator120.e(err);
        } finally {
          _iterator120.f();
        }
        storage.setValue(id, {
          value: checked
        });
      });
      element.addEventListener("resetform", function (event) {
        var defaultValue = data.defaultFieldValue || "Off";
        event.target.checked = defaultValue === data.exportValue;
      });
      if (this.enableScripting && this.hasJSActions) {
        element.addEventListener("updatefromsandbox", function (jsEvent) {
          var actions = {
            value: function value(event) {
              event.target.checked = event.detail.value !== "Off";
              storage.setValue(id, {
                value: event.target.checked
              });
            }
          };
          _this63._dispatchEventFromSandbox(actions, jsEvent);
        });
        this._setEventListeners(element, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function (event) {
          return event.target.checked;
        });
      }
      this._setBackgroundColor(element);
      this._setDefaultPropertiesFromJS(element);
      this.container.append(element);
      return this.container;
    }
  }]);
}(WidgetAnnotationElement);
var RadioButtonWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem4) {
  function RadioButtonWidgetAnnotationElement(parameters) {
    _classCallCheck(this, RadioButtonWidgetAnnotationElement);
    return _callSuper(this, RadioButtonWidgetAnnotationElement, [parameters, {
      isRenderable: parameters.renderForms
    }]);
  }
  _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem4);
  return _createClass(RadioButtonWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      var _this64 = this;
      this.container.classList.add("buttonWidgetAnnotation", "radioButton");
      var storage = this.annotationStorage;
      var data = this.data;
      var id = data.id;
      var value = storage.getValue(id, {
        value: data.fieldValue === data.buttonValue
      }).value;
      if (typeof value === "string") {
        value = value !== data.buttonValue;
        storage.setValue(id, {
          value: value
        });
      }
      if (value) {
        var _iterator121 = _createForOfIteratorHelper(this._getElementsByName(data.fieldName, id)),
          _step121;
        try {
          for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
            var radio = _step121.value;
            storage.setValue(radio.id, {
              value: false
            });
          }
        } catch (err) {
          _iterator121.e(err);
        } finally {
          _iterator121.f();
        }
      }
      var element = document.createElement("input");
      GetElementsByNameSet.add(element);
      element.setAttribute("data-element-id", id);
      element.disabled = data.readOnly;
      this._setRequired(element, this.data.required);
      element.type = "radio";
      element.name = data.fieldName;
      if (value) {
        element.setAttribute("checked", true);
      }
      element.tabIndex = DEFAULT_TAB_INDEX;
      element.addEventListener("change", function (event) {
        var _event$target3 = event.target,
          name = _event$target3.name,
          checked = _event$target3.checked;
        var _iterator122 = _createForOfIteratorHelper(_this64._getElementsByName(name, id)),
          _step122;
        try {
          for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
            var _radio = _step122.value;
            storage.setValue(_radio.id, {
              value: false
            });
          }
        } catch (err) {
          _iterator122.e(err);
        } finally {
          _iterator122.f();
        }
        storage.setValue(id, {
          value: checked
        });
      });
      element.addEventListener("resetform", function (event) {
        var defaultValue = data.defaultFieldValue;
        event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
      });
      if (this.enableScripting && this.hasJSActions) {
        var pdfButtonValue = data.buttonValue;
        element.addEventListener("updatefromsandbox", function (jsEvent) {
          var actions = {
            value: function value(event) {
              var checked = pdfButtonValue === event.detail.value;
              var _iterator123 = _createForOfIteratorHelper(_this64._getElementsByName(event.target.name)),
                _step123;
              try {
                for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
                  var _radio2 = _step123.value;
                  var curChecked = checked && _radio2.id === id;
                  if (_radio2.domElement) {
                    _radio2.domElement.checked = curChecked;
                  }
                  storage.setValue(_radio2.id, {
                    value: curChecked
                  });
                }
              } catch (err) {
                _iterator123.e(err);
              } finally {
                _iterator123.f();
              }
            }
          };
          _this64._dispatchEventFromSandbox(actions, jsEvent);
        });
        this._setEventListeners(element, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function (event) {
          return event.target.checked;
        });
      }
      this._setBackgroundColor(element);
      this._setDefaultPropertiesFromJS(element);
      this.container.append(element);
      return this.container;
    }
  }]);
}(WidgetAnnotationElement);
var PushButtonWidgetAnnotationElement = /*#__PURE__*/function (_LinkAnnotationElemen) {
  function PushButtonWidgetAnnotationElement(parameters) {
    _classCallCheck(this, PushButtonWidgetAnnotationElement);
    return _callSuper(this, PushButtonWidgetAnnotationElement, [parameters, {
      ignoreBorder: parameters.data.hasAppearance
    }]);
  }
  _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);
  return _createClass(PushButtonWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      var _this65 = this;
      var container = _superPropGet(PushButtonWidgetAnnotationElement, "render", this, 3)([]);
      container.classList.add("buttonWidgetAnnotation", "pushButton");
      var linkElement = container.lastChild;
      if (this.enableScripting && this.hasJSActions && linkElement) {
        this._setDefaultPropertiesFromJS(linkElement);
        linkElement.addEventListener("updatefromsandbox", function (jsEvent) {
          _this65._dispatchEventFromSandbox({}, jsEvent);
        });
      }
      return container;
    }
  }]);
}(LinkAnnotationElement);
var ChoiceWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem5) {
  function ChoiceWidgetAnnotationElement(parameters) {
    _classCallCheck(this, ChoiceWidgetAnnotationElement);
    return _callSuper(this, ChoiceWidgetAnnotationElement, [parameters, {
      isRenderable: parameters.renderForms
    }]);
  }
  _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem5);
  return _createClass(ChoiceWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      var _this66 = this;
      this.container.classList.add("choiceWidgetAnnotation");
      var storage = this.annotationStorage;
      var id = this.data.id;
      var storedData = storage.getValue(id, {
        value: this.data.fieldValue
      });
      var selectElement = document.createElement("select");
      GetElementsByNameSet.add(selectElement);
      selectElement.setAttribute("data-element-id", id);
      selectElement.disabled = this.data.readOnly;
      this._setRequired(selectElement, this.data.required);
      selectElement.name = this.data.fieldName;
      selectElement.tabIndex = DEFAULT_TAB_INDEX;
      var addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
      if (!this.data.combo) {
        selectElement.size = this.data.options.length;
        if (this.data.multiSelect) {
          selectElement.multiple = true;
        }
      }
      selectElement.addEventListener("resetform", function (event) {
        var defaultValue = _this66.data.defaultFieldValue;
        var _iterator124 = _createForOfIteratorHelper(selectElement.options),
          _step124;
        try {
          for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
            var option = _step124.value;
            option.selected = option.value === defaultValue;
          }
        } catch (err) {
          _iterator124.e(err);
        } finally {
          _iterator124.f();
        }
      });
      var _iterator125 = _createForOfIteratorHelper(this.data.options),
        _step125;
      try {
        for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
          var option = _step125.value;
          var optionElement = document.createElement("option");
          optionElement.textContent = option.displayValue;
          optionElement.value = option.exportValue;
          if (storedData.value.includes(option.exportValue)) {
            optionElement.setAttribute("selected", true);
            addAnEmptyEntry = false;
          }
          selectElement.append(optionElement);
        }
      } catch (err) {
        _iterator125.e(err);
      } finally {
        _iterator125.f();
      }
      var _removeEmptyEntry = null;
      if (addAnEmptyEntry) {
        var noneOptionElement = document.createElement("option");
        noneOptionElement.value = " ";
        noneOptionElement.setAttribute("hidden", true);
        noneOptionElement.setAttribute("selected", true);
        selectElement.prepend(noneOptionElement);
        _removeEmptyEntry = function removeEmptyEntry() {
          noneOptionElement.remove();
          selectElement.removeEventListener("input", _removeEmptyEntry);
          _removeEmptyEntry = null;
        };
        selectElement.addEventListener("input", _removeEmptyEntry);
      }
      var getValue = function getValue(isExport) {
        var name = isExport ? "value" : "textContent";
        var options = selectElement.options,
          multiple = selectElement.multiple;
        if (!multiple) {
          return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
        }
        return Array.prototype.filter.call(options, function (option) {
          return option.selected;
        }).map(function (option) {
          return option[name];
        });
      };
      var selectedValues = getValue(false);
      var getItems = function getItems(event) {
        var options = event.target.options;
        return Array.prototype.map.call(options, function (option) {
          return {
            displayValue: option.textContent,
            exportValue: option.value
          };
        });
      };
      if (this.enableScripting && this.hasJSActions) {
        selectElement.addEventListener("updatefromsandbox", function (jsEvent) {
          var actions = {
            value: function value(event) {
              var _removeEmptyEntry2;
              (_removeEmptyEntry2 = _removeEmptyEntry) === null || _removeEmptyEntry2 === void 0 || _removeEmptyEntry2();
              var value = event.detail.value;
              var values = new Set(Array.isArray(value) ? value : [value]);
              var _iterator126 = _createForOfIteratorHelper(selectElement.options),
                _step126;
              try {
                for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
                  var option = _step126.value;
                  option.selected = values.has(option.value);
                }
              } catch (err) {
                _iterator126.e(err);
              } finally {
                _iterator126.f();
              }
              storage.setValue(id, {
                value: getValue(true)
              });
              selectedValues = getValue(false);
            },
            multipleSelection: function multipleSelection(event) {
              selectElement.multiple = true;
            },
            remove: function remove(event) {
              var options = selectElement.options;
              var index = event.detail.remove;
              options[index].selected = false;
              selectElement.remove(index);
              if (options.length > 0) {
                var i = Array.prototype.findIndex.call(options, function (option) {
                  return option.selected;
                });
                if (i === -1) {
                  options[0].selected = true;
                }
              }
              storage.setValue(id, {
                value: getValue(true),
                items: getItems(event)
              });
              selectedValues = getValue(false);
            },
            clear: function clear(event) {
              while (selectElement.length !== 0) {
                selectElement.remove(0);
              }
              storage.setValue(id, {
                value: null,
                items: []
              });
              selectedValues = getValue(false);
            },
            insert: function insert(event) {
              var _event$detail$insert = event.detail.insert,
                index = _event$detail$insert.index,
                displayValue = _event$detail$insert.displayValue,
                exportValue = _event$detail$insert.exportValue;
              var selectChild = selectElement.children[index];
              var optionElement = document.createElement("option");
              optionElement.textContent = displayValue;
              optionElement.value = exportValue;
              if (selectChild) {
                selectChild.before(optionElement);
              } else {
                selectElement.append(optionElement);
              }
              storage.setValue(id, {
                value: getValue(true),
                items: getItems(event)
              });
              selectedValues = getValue(false);
            },
            items: function items(event) {
              var items = event.detail.items;
              while (selectElement.length !== 0) {
                selectElement.remove(0);
              }
              var _iterator127 = _createForOfIteratorHelper(items),
                _step127;
              try {
                for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
                  var item = _step127.value;
                  var displayValue = item.displayValue,
                    exportValue = item.exportValue;
                  var optionElement = document.createElement("option");
                  optionElement.textContent = displayValue;
                  optionElement.value = exportValue;
                  selectElement.append(optionElement);
                }
              } catch (err) {
                _iterator127.e(err);
              } finally {
                _iterator127.f();
              }
              if (selectElement.options.length > 0) {
                selectElement.options[0].selected = true;
              }
              storage.setValue(id, {
                value: getValue(true),
                items: getItems(event)
              });
              selectedValues = getValue(false);
            },
            indices: function indices(event) {
              var indices = new Set(event.detail.indices);
              var _iterator128 = _createForOfIteratorHelper(event.target.options),
                _step128;
              try {
                for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
                  var option = _step128.value;
                  option.selected = indices.has(option.index);
                }
              } catch (err) {
                _iterator128.e(err);
              } finally {
                _iterator128.f();
              }
              storage.setValue(id, {
                value: getValue(true)
              });
              selectedValues = getValue(false);
            },
            editable: function editable(event) {
              event.target.disabled = !event.detail.editable;
            }
          };
          _this66._dispatchEventFromSandbox(actions, jsEvent);
        });
        selectElement.addEventListener("input", function (event) {
          var _this66$linkService$e;
          var exportValue = getValue(true);
          var change = getValue(false);
          storage.setValue(id, {
            value: exportValue
          });
          event.preventDefault();
          (_this66$linkService$e = _this66.linkService.eventBus) === null || _this66$linkService$e === void 0 || _this66$linkService$e.dispatch("dispatcheventinsandbox", {
            source: _this66,
            detail: {
              id: id,
              name: "Keystroke",
              value: selectedValues,
              change: change,
              changeEx: exportValue,
              willCommit: false,
              commitKey: 1,
              keyDown: false
            }
          });
        });
        this._setEventListeners(selectElement, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], function (event) {
          return event.target.value;
        });
      } else {
        selectElement.addEventListener("input", function (event) {
          storage.setValue(id, {
            value: getValue(true)
          });
        });
      }
      if (this.data.combo) {
        this._setTextStyle(selectElement);
      } else {}
      this._setBackgroundColor(selectElement);
      this._setDefaultPropertiesFromJS(selectElement);
      this.container.append(selectElement);
      return this.container;
    }
  }]);
}(WidgetAnnotationElement);
var PopupAnnotationElement = /*#__PURE__*/function (_AnnotationElement5) {
  function PopupAnnotationElement(parameters) {
    var _this67;
    _classCallCheck(this, PopupAnnotationElement);
    var data = parameters.data,
      elements = parameters.elements;
    _this67 = _callSuper(this, PopupAnnotationElement, [parameters, {
      isRenderable: AnnotationElement._hasPopupData(data)
    }]);
    _this67.elements = elements;
    _this67.popup = null;
    return _this67;
  }
  _inherits(PopupAnnotationElement, _AnnotationElement5);
  return _createClass(PopupAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.classList.add("popupAnnotation");
      var popup = this.popup = new PopupElement({
        container: this.container,
        color: this.data.color,
        titleObj: this.data.titleObj,
        modificationDate: this.data.modificationDate,
        contentsObj: this.data.contentsObj,
        richText: this.data.richText,
        rect: this.data.rect,
        parentRect: this.data.parentRect || null,
        parent: this.parent,
        elements: this.elements,
        open: this.data.open
      });
      var elementIds = [];
      var _iterator129 = _createForOfIteratorHelper(this.elements),
        _step129;
      try {
        for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
          var element = _step129.value;
          element.popup = popup;
          element.container.ariaHasPopup = "dialog";
          elementIds.push(element.data.id);
          element.addHighlightArea();
        }
      } catch (err) {
        _iterator129.e(err);
      } finally {
        _iterator129.f();
      }
      this.container.setAttribute("aria-controls", elementIds.map(function (id) {
        return "".concat(AnnotationPrefix).concat(id);
      }).join(","));
      return this.container;
    }
  }]);
}(AnnotationElement);
var _boundKeyDown = /*#__PURE__*/_classPrivateFieldLooseKey("boundKeyDown");
var _boundHide = /*#__PURE__*/_classPrivateFieldLooseKey("boundHide");
var _boundShow = /*#__PURE__*/_classPrivateFieldLooseKey("boundShow");
var _boundToggle = /*#__PURE__*/_classPrivateFieldLooseKey("boundToggle");
var _color = /*#__PURE__*/_classPrivateFieldLooseKey("color");
var _container3 = /*#__PURE__*/_classPrivateFieldLooseKey("container");
var _contentsObj = /*#__PURE__*/_classPrivateFieldLooseKey("contentsObj");
var _dateObj = /*#__PURE__*/_classPrivateFieldLooseKey("dateObj");
var _elements = /*#__PURE__*/_classPrivateFieldLooseKey("elements");
var _parent = /*#__PURE__*/_classPrivateFieldLooseKey("parent");
var _parentRect = /*#__PURE__*/_classPrivateFieldLooseKey("parentRect");
var _pinned = /*#__PURE__*/_classPrivateFieldLooseKey("pinned");
var _popup = /*#__PURE__*/_classPrivateFieldLooseKey("popup");
var _position2 = /*#__PURE__*/_classPrivateFieldLooseKey("position");
var _rect2 = /*#__PURE__*/_classPrivateFieldLooseKey("rect");
var _richText = /*#__PURE__*/_classPrivateFieldLooseKey("richText");
var _titleObj = /*#__PURE__*/_classPrivateFieldLooseKey("titleObj");
var _updates2 = /*#__PURE__*/_classPrivateFieldLooseKey("updates");
var _wasVisible = /*#__PURE__*/_classPrivateFieldLooseKey("wasVisible");
var _html = /*#__PURE__*/_classPrivateFieldLooseKey("html");
var _fontSize = /*#__PURE__*/_classPrivateFieldLooseKey("fontSize");
var _fontColor = /*#__PURE__*/_classPrivateFieldLooseKey("fontColor");
var _makePopupContent = /*#__PURE__*/_classPrivateFieldLooseKey("makePopupContent");
var _keyDown = /*#__PURE__*/_classPrivateFieldLooseKey("keyDown");
var _setPosition = /*#__PURE__*/_classPrivateFieldLooseKey("setPosition");
var _toggle = /*#__PURE__*/_classPrivateFieldLooseKey("toggle");
var _show = /*#__PURE__*/_classPrivateFieldLooseKey("show");
var _hide = /*#__PURE__*/_classPrivateFieldLooseKey("hide");
var PopupElement = /*#__PURE__*/function () {
  function PopupElement(_ref141) {
    var container = _ref141.container,
      color = _ref141.color,
      elements = _ref141.elements,
      titleObj = _ref141.titleObj,
      modificationDate = _ref141.modificationDate,
      _contentsObj2 = _ref141.contentsObj,
      _richText2 = _ref141.richText,
      parent = _ref141.parent,
      _rect3 = _ref141.rect,
      parentRect = _ref141.parentRect,
      open = _ref141.open;
    _classCallCheck(this, PopupElement);
    Object.defineProperty(this, _hide, {
      value: _hide2
    });
    Object.defineProperty(this, _show, {
      value: _show2
    });
    Object.defineProperty(this, _toggle, {
      value: _toggle2
    });
    Object.defineProperty(this, _setPosition, {
      value: _setPosition2
    });
    Object.defineProperty(this, _keyDown, {
      value: _keyDown2
    });
    Object.defineProperty(this, _makePopupContent, {
      value: _makePopupContent2
    });
    Object.defineProperty(this, _fontColor, {
      get: _get_fontColor,
      set: void 0
    });
    Object.defineProperty(this, _fontSize, {
      get: _get_fontSize,
      set: void 0
    });
    Object.defineProperty(this, _html, {
      get: _get_html,
      set: void 0
    });
    Object.defineProperty(this, _boundKeyDown, {
      writable: true,
      value: _classPrivateFieldLooseBase(this, _keyDown)[_keyDown].bind(this)
    });
    Object.defineProperty(this, _boundHide, {
      writable: true,
      value: _classPrivateFieldLooseBase(this, _hide)[_hide].bind(this)
    });
    Object.defineProperty(this, _boundShow, {
      writable: true,
      value: _classPrivateFieldLooseBase(this, _show)[_show].bind(this)
    });
    Object.defineProperty(this, _boundToggle, {
      writable: true,
      value: _classPrivateFieldLooseBase(this, _toggle)[_toggle].bind(this)
    });
    Object.defineProperty(this, _color, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _container3, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _contentsObj, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _dateObj, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _elements, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _parent, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _parentRect, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _pinned, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _popup, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _position2, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _rect2, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _richText, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _titleObj, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _updates2, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _wasVisible, {
      writable: true,
      value: false
    });
    _classPrivateFieldLooseBase(this, _container3)[_container3] = container;
    _classPrivateFieldLooseBase(this, _titleObj)[_titleObj] = titleObj;
    _classPrivateFieldLooseBase(this, _contentsObj)[_contentsObj] = _contentsObj2;
    _classPrivateFieldLooseBase(this, _richText)[_richText] = _richText2;
    _classPrivateFieldLooseBase(this, _parent)[_parent] = parent;
    _classPrivateFieldLooseBase(this, _color)[_color] = color;
    _classPrivateFieldLooseBase(this, _rect2)[_rect2] = _rect3;
    _classPrivateFieldLooseBase(this, _parentRect)[_parentRect] = parentRect;
    _classPrivateFieldLooseBase(this, _elements)[_elements] = elements;
    _classPrivateFieldLooseBase(this, _dateObj)[_dateObj] = _PDFDateString.toDateObject(modificationDate);
    this.trigger = elements.flatMap(function (e) {
      return e.getElementsToTriggerPopup();
    });
    var _iterator130 = _createForOfIteratorHelper(this.trigger),
      _step130;
    try {
      for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
        var element = _step130.value;
        element.addEventListener("click", _classPrivateFieldLooseBase(this, _boundToggle)[_boundToggle]);
        element.addEventListener("mouseenter", _classPrivateFieldLooseBase(this, _boundShow)[_boundShow]);
        element.addEventListener("mouseleave", _classPrivateFieldLooseBase(this, _boundHide)[_boundHide]);
        element.classList.add("popupTriggerArea");
      }
    } catch (err) {
      _iterator130.e(err);
    } finally {
      _iterator130.f();
    }
    var _iterator131 = _createForOfIteratorHelper(elements),
      _step131;
    try {
      for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
        var _element$container;
        var _element = _step131.value;
        (_element$container = _element.container) === null || _element$container === void 0 || _element$container.addEventListener("keydown", _classPrivateFieldLooseBase(this, _boundKeyDown)[_boundKeyDown]);
      }
    } catch (err) {
      _iterator131.e(err);
    } finally {
      _iterator131.f();
    }
    _classPrivateFieldLooseBase(this, _container3)[_container3].hidden = true;
    if (open) {
      _classPrivateFieldLooseBase(this, _toggle)[_toggle]();
    }
  }
  return _createClass(PopupElement, [{
    key: "render",
    value: function render() {
      if (_classPrivateFieldLooseBase(this, _popup)[_popup]) {
        return;
      }
      var popup = _classPrivateFieldLooseBase(this, _popup)[_popup] = document.createElement("div");
      popup.className = "popup";
      if (_classPrivateFieldLooseBase(this, _color)[_color]) {
        var baseColor = popup.style.outlineColor = _Util.makeHexColor.apply(_Util, _toConsumableArray(_classPrivateFieldLooseBase(this, _color)[_color]));
        if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) {
          popup.style.backgroundColor = "color-mix(in srgb, ".concat(baseColor, " 30%, white)");
        } else {
          var BACKGROUND_ENLIGHT = 0.7;
          popup.style.backgroundColor = _Util.makeHexColor.apply(_Util, _toConsumableArray(_classPrivateFieldLooseBase(this, _color)[_color].map(function (c) {
            return Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c);
          })));
        }
      }
      var header = document.createElement("span");
      header.className = "header";
      var title = document.createElement("h1");
      header.append(title);
      var _classPrivateFieldLoo72 = _classPrivateFieldLooseBase(this, _titleObj)[_titleObj];
      title.dir = _classPrivateFieldLoo72.dir;
      title.textContent = _classPrivateFieldLoo72.str;
      popup.append(header);
      if (_classPrivateFieldLooseBase(this, _dateObj)[_dateObj]) {
        var modificationDate = document.createElement("span");
        modificationDate.classList.add("popupDate");
        modificationDate.setAttribute("data-l10n-id", "pdfjs-annotation-date-time-string");
        modificationDate.setAttribute("data-l10n-args", JSON.stringify({
          dateObj: _classPrivateFieldLooseBase(this, _dateObj)[_dateObj].valueOf()
        }));
        header.append(modificationDate);
      }
      var html = _classPrivateFieldLooseBase(this, _html)[_html];
      if (html) {
        _XfaLayer.render({
          xfaHtml: html,
          intent: "richText",
          div: popup
        });
        popup.lastChild.classList.add("richText", "popupContent");
      } else {
        var contents = this._formatContents(_classPrivateFieldLooseBase(this, _contentsObj)[_contentsObj]);
        popup.append(contents);
      }
      _classPrivateFieldLooseBase(this, _container3)[_container3].append(popup);
    }
  }, {
    key: "_formatContents",
    value: function _formatContents(_ref142) {
      var str = _ref142.str,
        dir = _ref142.dir;
      var p = document.createElement("p");
      p.classList.add("popupContent");
      p.dir = dir;
      var lines = str.split(/(?:\r\n?|\n)/);
      for (var i = 0, ii = lines.length; i < ii; ++i) {
        var line = lines[i];
        p.append(document.createTextNode(line));
        if (i < ii - 1) {
          p.append(document.createElement("br"));
        }
      }
      return p;
    }
  }, {
    key: "updateEdited",
    value: function updateEdited(_ref143) {
      var _classPrivateFieldLoo73, _classPrivateFieldLoo74;
      var rect = _ref143.rect,
        popupContent = _ref143.popupContent;
      (_classPrivateFieldLoo73 = _classPrivateFieldLooseBase(this, _updates2))[_updates2] || (_classPrivateFieldLoo73[_updates2] = {
        contentsObj: _classPrivateFieldLooseBase(this, _contentsObj)[_contentsObj],
        richText: _classPrivateFieldLooseBase(this, _richText)[_richText]
      });
      if (rect) {
        _classPrivateFieldLooseBase(this, _position2)[_position2] = null;
      }
      if (popupContent) {
        _classPrivateFieldLooseBase(this, _richText)[_richText] = _classPrivateFieldLooseBase(this, _makePopupContent)[_makePopupContent](popupContent);
        _classPrivateFieldLooseBase(this, _contentsObj)[_contentsObj] = null;
      }
      (_classPrivateFieldLoo74 = _classPrivateFieldLooseBase(this, _popup)[_popup]) === null || _classPrivateFieldLoo74 === void 0 || _classPrivateFieldLoo74.remove();
      _classPrivateFieldLooseBase(this, _popup)[_popup] = null;
    }
  }, {
    key: "resetEdited",
    value: function resetEdited() {
      var _classPrivateFieldLoo76;
      if (!_classPrivateFieldLooseBase(this, _updates2)[_updates2]) {
        return;
      }
      var _classPrivateFieldLoo75 = _classPrivateFieldLooseBase(this, _updates2)[_updates2];
      _classPrivateFieldLooseBase(this, _contentsObj)[_contentsObj] = _classPrivateFieldLoo75.contentsObj;
      _classPrivateFieldLooseBase(this, _richText)[_richText] = _classPrivateFieldLoo75.richText;
      _classPrivateFieldLooseBase(this, _updates2)[_updates2] = null;
      (_classPrivateFieldLoo76 = _classPrivateFieldLooseBase(this, _popup)[_popup]) === null || _classPrivateFieldLoo76 === void 0 || _classPrivateFieldLoo76.remove();
      _classPrivateFieldLooseBase(this, _popup)[_popup] = null;
      _classPrivateFieldLooseBase(this, _position2)[_position2] = null;
    }
  }, {
    key: "forceHide",
    value: function forceHide() {
      _classPrivateFieldLooseBase(this, _wasVisible)[_wasVisible] = this.isVisible;
      if (!_classPrivateFieldLooseBase(this, _wasVisible)[_wasVisible]) {
        return;
      }
      _classPrivateFieldLooseBase(this, _container3)[_container3].hidden = true;
    }
  }, {
    key: "maybeShow",
    value: function maybeShow() {
      if (!_classPrivateFieldLooseBase(this, _wasVisible)[_wasVisible]) {
        return;
      }
      if (!_classPrivateFieldLooseBase(this, _popup)[_popup]) {
        _classPrivateFieldLooseBase(this, _show)[_show]();
      }
      _classPrivateFieldLooseBase(this, _wasVisible)[_wasVisible] = false;
      _classPrivateFieldLooseBase(this, _container3)[_container3].hidden = false;
    }
  }, {
    key: "isVisible",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _container3)[_container3].hidden === false;
    }
  }]);
}();
function _get_html() {
  var richText = _classPrivateFieldLooseBase(this, _richText)[_richText];
  var contentsObj = _classPrivateFieldLooseBase(this, _contentsObj)[_contentsObj];
  if (richText !== null && richText !== void 0 && richText.str && (!(contentsObj !== null && contentsObj !== void 0 && contentsObj.str) || contentsObj.str === richText.str)) {
    return _classPrivateFieldLooseBase(this, _richText)[_richText].html || null;
  }
  return null;
}
function _get_fontSize() {
  var _classPrivateFieldLoo142;
  return ((_classPrivateFieldLoo142 = _classPrivateFieldLooseBase(this, _html)[_html]) === null || _classPrivateFieldLoo142 === void 0 || (_classPrivateFieldLoo142 = _classPrivateFieldLoo142.attributes) === null || _classPrivateFieldLoo142 === void 0 || (_classPrivateFieldLoo142 = _classPrivateFieldLoo142.style) === null || _classPrivateFieldLoo142 === void 0 ? void 0 : _classPrivateFieldLoo142.fontSize) || 0;
}
function _get_fontColor() {
  var _classPrivateFieldLoo143;
  return ((_classPrivateFieldLoo143 = _classPrivateFieldLooseBase(this, _html)[_html]) === null || _classPrivateFieldLoo143 === void 0 || (_classPrivateFieldLoo143 = _classPrivateFieldLoo143.attributes) === null || _classPrivateFieldLoo143 === void 0 || (_classPrivateFieldLoo143 = _classPrivateFieldLoo143.style) === null || _classPrivateFieldLoo143 === void 0 ? void 0 : _classPrivateFieldLoo143.color) || null;
}
function _makePopupContent2(text) {
  var popupLines = [];
  var popupContent = {
    str: text,
    html: {
      name: "div",
      attributes: {
        dir: "auto"
      },
      children: [{
        name: "p",
        children: popupLines
      }]
    }
  };
  var lineAttributes = {
    style: {
      color: _classPrivateFieldLooseBase(this, _fontColor)[_fontColor],
      fontSize: _classPrivateFieldLooseBase(this, _fontSize)[_fontSize] ? "calc(".concat(_classPrivateFieldLooseBase(this, _fontSize)[_fontSize], "px * var(--scale-factor))") : ""
    }
  };
  var _iterator170 = _createForOfIteratorHelper(text.split("\n")),
    _step170;
  try {
    for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
      var line = _step170.value;
      popupLines.push({
        name: "span",
        value: line,
        attributes: lineAttributes
      });
    }
  } catch (err) {
    _iterator170.e(err);
  } finally {
    _iterator170.f();
  }
  return popupContent;
}
function _keyDown2(event) {
  if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) {
    return;
  }
  if (event.key === "Enter" || event.key === "Escape" && _classPrivateFieldLooseBase(this, _pinned)[_pinned]) {
    _classPrivateFieldLooseBase(this, _toggle)[_toggle]();
  }
}
function _setPosition2() {
  if (_classPrivateFieldLooseBase(this, _position2)[_position2] !== null) {
    return;
  }
  var _classPrivateFieldLoo144 = _classPrivateFieldLooseBase(this, _parent)[_parent],
    view = _classPrivateFieldLoo144.page.view,
    _classPrivateFieldLoo145 = _classPrivateFieldLoo144.viewport.rawDims,
    pageWidth = _classPrivateFieldLoo145.pageWidth,
    pageHeight = _classPrivateFieldLoo145.pageHeight,
    pageX = _classPrivateFieldLoo145.pageX,
    pageY = _classPrivateFieldLoo145.pageY;
  var useParentRect = !!_classPrivateFieldLooseBase(this, _parentRect)[_parentRect];
  var rect = useParentRect ? _classPrivateFieldLooseBase(this, _parentRect)[_parentRect] : _classPrivateFieldLooseBase(this, _rect2)[_rect2];
  var _iterator171 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _elements)[_elements]),
    _step171;
  try {
    for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
      var element = _step171.value;
      if (!rect || _Util.intersect(element.data.rect, rect) !== null) {
        rect = element.data.rect;
        useParentRect = true;
        break;
      }
    }
  } catch (err) {
    _iterator171.e(err);
  } finally {
    _iterator171.f();
  }
  var normalizedRect = _Util.normalizeRect([rect[0], view[3] - rect[1] + view[1], rect[2], view[3] - rect[3] + view[1]]);
  var HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
  var parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
  var popupLeft = normalizedRect[0] + parentWidth;
  var popupTop = normalizedRect[1];
  _classPrivateFieldLooseBase(this, _position2)[_position2] = [100 * (popupLeft - pageX) / pageWidth, 100 * (popupTop - pageY) / pageHeight];
  var style = _classPrivateFieldLooseBase(this, _container3)[_container3].style;
  style.left = "".concat(_classPrivateFieldLooseBase(this, _position2)[_position2][0], "%");
  style.top = "".concat(_classPrivateFieldLooseBase(this, _position2)[_position2][1], "%");
}
function _toggle2() {
  _classPrivateFieldLooseBase(this, _pinned)[_pinned] = !_classPrivateFieldLooseBase(this, _pinned)[_pinned];
  if (_classPrivateFieldLooseBase(this, _pinned)[_pinned]) {
    _classPrivateFieldLooseBase(this, _show)[_show]();
    _classPrivateFieldLooseBase(this, _container3)[_container3].addEventListener("click", _classPrivateFieldLooseBase(this, _boundToggle)[_boundToggle]);
    _classPrivateFieldLooseBase(this, _container3)[_container3].addEventListener("keydown", _classPrivateFieldLooseBase(this, _boundKeyDown)[_boundKeyDown]);
  } else {
    _classPrivateFieldLooseBase(this, _hide)[_hide]();
    _classPrivateFieldLooseBase(this, _container3)[_container3].removeEventListener("click", _classPrivateFieldLooseBase(this, _boundToggle)[_boundToggle]);
    _classPrivateFieldLooseBase(this, _container3)[_container3].removeEventListener("keydown", _classPrivateFieldLooseBase(this, _boundKeyDown)[_boundKeyDown]);
  }
}
function _show2() {
  if (!_classPrivateFieldLooseBase(this, _popup)[_popup]) {
    this.render();
  }
  if (!this.isVisible) {
    _classPrivateFieldLooseBase(this, _setPosition)[_setPosition]();
    _classPrivateFieldLooseBase(this, _container3)[_container3].hidden = false;
    _classPrivateFieldLooseBase(this, _container3)[_container3].style.zIndex = parseInt(_classPrivateFieldLooseBase(this, _container3)[_container3].style.zIndex) + 1000;
  } else if (_classPrivateFieldLooseBase(this, _pinned)[_pinned]) {
    _classPrivateFieldLooseBase(this, _container3)[_container3].classList.add("focused");
  }
}
function _hide2() {
  _classPrivateFieldLooseBase(this, _container3)[_container3].classList.remove("focused");
  if (_classPrivateFieldLooseBase(this, _pinned)[_pinned] || !this.isVisible) {
    return;
  }
  _classPrivateFieldLooseBase(this, _container3)[_container3].hidden = true;
  _classPrivateFieldLooseBase(this, _container3)[_container3].style.zIndex = parseInt(_classPrivateFieldLooseBase(this, _container3)[_container3].style.zIndex) - 1000;
}
var FreeTextAnnotationElement = /*#__PURE__*/function (_AnnotationElement6) {
  function FreeTextAnnotationElement(parameters) {
    var _this68;
    _classCallCheck(this, FreeTextAnnotationElement);
    _this68 = _callSuper(this, FreeTextAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true
    }]);
    _this68.textContent = parameters.data.textContent;
    _this68.textPosition = parameters.data.textPosition;
    _this68.annotationEditorType = _AnnotationEditorType.FREETEXT;
    return _this68;
  }
  _inherits(FreeTextAnnotationElement, _AnnotationElement6);
  return _createClass(FreeTextAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.classList.add("freeTextAnnotation");
      if (this.textContent) {
        var content = document.createElement("div");
        content.classList.add("annotationTextContent");
        content.setAttribute("role", "comment");
        var _iterator132 = _createForOfIteratorHelper(this.textContent),
          _step132;
        try {
          for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
            var line = _step132.value;
            var lineSpan = document.createElement("span");
            lineSpan.textContent = line;
            content.append(lineSpan);
          }
        } catch (err) {
          _iterator132.e(err);
        } finally {
          _iterator132.f();
        }
        this.container.append(content);
      }
      if (!this.data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      this._editOnDoubleClick();
      return this.container;
    }
  }]);
}(AnnotationElement);
var _line = /*#__PURE__*/_classPrivateFieldLooseKey("line");
var LineAnnotationElement = /*#__PURE__*/function (_AnnotationElement7) {
  function LineAnnotationElement(parameters) {
    var _this69;
    _classCallCheck(this, LineAnnotationElement);
    _this69 = _callSuper(this, LineAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true
    }]);
    Object.defineProperty(_this69, _line, {
      writable: true,
      value: null
    });
    return _this69;
  }
  _inherits(LineAnnotationElement, _AnnotationElement7);
  return _createClass(LineAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.classList.add("lineAnnotation");
      var data = this.data;
      var _getRectDims3 = getRectDims(data.rect),
        width = _getRectDims3.width,
        height = _getRectDims3.height;
      var svg = this.svgFactory.create(width, height, true);
      var line = _classPrivateFieldLooseBase(this, _line)[_line] = this.svgFactory.createElement("svg:line");
      line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
      line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
      line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
      line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
      line.setAttribute("stroke-width", data.borderStyle.width || 1);
      line.setAttribute("stroke", "transparent");
      line.setAttribute("fill", "transparent");
      svg.append(line);
      this.container.append(svg);
      if (!data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      return this.container;
    }
  }, {
    key: "getElementsToTriggerPopup",
    value: function getElementsToTriggerPopup() {
      return _classPrivateFieldLooseBase(this, _line)[_line];
    }
  }, {
    key: "addHighlightArea",
    value: function addHighlightArea() {
      this.container.classList.add("highlightArea");
    }
  }]);
}(AnnotationElement);
var _square = /*#__PURE__*/_classPrivateFieldLooseKey("square");
var SquareAnnotationElement = /*#__PURE__*/function (_AnnotationElement8) {
  function SquareAnnotationElement(parameters) {
    var _this70;
    _classCallCheck(this, SquareAnnotationElement);
    _this70 = _callSuper(this, SquareAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true
    }]);
    Object.defineProperty(_this70, _square, {
      writable: true,
      value: null
    });
    return _this70;
  }
  _inherits(SquareAnnotationElement, _AnnotationElement8);
  return _createClass(SquareAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.classList.add("squareAnnotation");
      var data = this.data;
      var _getRectDims4 = getRectDims(data.rect),
        width = _getRectDims4.width,
        height = _getRectDims4.height;
      var svg = this.svgFactory.create(width, height, true);
      var borderWidth = data.borderStyle.width;
      var square = _classPrivateFieldLooseBase(this, _square)[_square] = this.svgFactory.createElement("svg:rect");
      square.setAttribute("x", borderWidth / 2);
      square.setAttribute("y", borderWidth / 2);
      square.setAttribute("width", width - borderWidth);
      square.setAttribute("height", height - borderWidth);
      square.setAttribute("stroke-width", borderWidth || 1);
      square.setAttribute("stroke", "transparent");
      square.setAttribute("fill", "transparent");
      svg.append(square);
      this.container.append(svg);
      if (!data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      return this.container;
    }
  }, {
    key: "getElementsToTriggerPopup",
    value: function getElementsToTriggerPopup() {
      return _classPrivateFieldLooseBase(this, _square)[_square];
    }
  }, {
    key: "addHighlightArea",
    value: function addHighlightArea() {
      this.container.classList.add("highlightArea");
    }
  }]);
}(AnnotationElement);
var _circle = /*#__PURE__*/_classPrivateFieldLooseKey("circle");
var CircleAnnotationElement = /*#__PURE__*/function (_AnnotationElement9) {
  function CircleAnnotationElement(parameters) {
    var _this71;
    _classCallCheck(this, CircleAnnotationElement);
    _this71 = _callSuper(this, CircleAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true
    }]);
    Object.defineProperty(_this71, _circle, {
      writable: true,
      value: null
    });
    return _this71;
  }
  _inherits(CircleAnnotationElement, _AnnotationElement9);
  return _createClass(CircleAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.classList.add("circleAnnotation");
      var data = this.data;
      var _getRectDims5 = getRectDims(data.rect),
        width = _getRectDims5.width,
        height = _getRectDims5.height;
      var svg = this.svgFactory.create(width, height, true);
      var borderWidth = data.borderStyle.width;
      var circle = _classPrivateFieldLooseBase(this, _circle)[_circle] = this.svgFactory.createElement("svg:ellipse");
      circle.setAttribute("cx", width / 2);
      circle.setAttribute("cy", height / 2);
      circle.setAttribute("rx", width / 2 - borderWidth / 2);
      circle.setAttribute("ry", height / 2 - borderWidth / 2);
      circle.setAttribute("stroke-width", borderWidth || 1);
      circle.setAttribute("stroke", "transparent");
      circle.setAttribute("fill", "transparent");
      svg.append(circle);
      this.container.append(svg);
      if (!data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      return this.container;
    }
  }, {
    key: "getElementsToTriggerPopup",
    value: function getElementsToTriggerPopup() {
      return _classPrivateFieldLooseBase(this, _circle)[_circle];
    }
  }, {
    key: "addHighlightArea",
    value: function addHighlightArea() {
      this.container.classList.add("highlightArea");
    }
  }]);
}(AnnotationElement);
var _polyline = /*#__PURE__*/_classPrivateFieldLooseKey("polyline");
var PolylineAnnotationElement = /*#__PURE__*/function (_AnnotationElement10) {
  function PolylineAnnotationElement(parameters) {
    var _this72;
    _classCallCheck(this, PolylineAnnotationElement);
    _this72 = _callSuper(this, PolylineAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true
    }]);
    Object.defineProperty(_this72, _polyline, {
      writable: true,
      value: null
    });
    _this72.containerClassName = "polylineAnnotation";
    _this72.svgElementName = "svg:polyline";
    return _this72;
  }
  _inherits(PolylineAnnotationElement, _AnnotationElement10);
  return _createClass(PolylineAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.classList.add(this.containerClassName);
      var _this$data = this.data,
        rect = _this$data.rect,
        vertices = _this$data.vertices,
        borderStyle = _this$data.borderStyle,
        popupRef = _this$data.popupRef;
      if (!vertices) {
        return this.container;
      }
      var _getRectDims6 = getRectDims(rect),
        width = _getRectDims6.width,
        height = _getRectDims6.height;
      var svg = this.svgFactory.create(width, height, true);
      var points = [];
      for (var i = 0, ii = vertices.length; i < ii; i += 2) {
        var x = vertices[i] - rect[0];
        var y = rect[3] - vertices[i + 1];
        points.push("".concat(x, ",").concat(y));
      }
      points = points.join(" ");
      var polyline = _classPrivateFieldLooseBase(this, _polyline)[_polyline] = this.svgFactory.createElement(this.svgElementName);
      polyline.setAttribute("points", points);
      polyline.setAttribute("stroke-width", borderStyle.width || 1);
      polyline.setAttribute("stroke", "transparent");
      polyline.setAttribute("fill", "transparent");
      svg.append(polyline);
      this.container.append(svg);
      if (!popupRef && this.hasPopupData) {
        this._createPopup();
      }
      return this.container;
    }
  }, {
    key: "getElementsToTriggerPopup",
    value: function getElementsToTriggerPopup() {
      return _classPrivateFieldLooseBase(this, _polyline)[_polyline];
    }
  }, {
    key: "addHighlightArea",
    value: function addHighlightArea() {
      this.container.classList.add("highlightArea");
    }
  }]);
}(AnnotationElement);
var PolygonAnnotationElement = /*#__PURE__*/function (_PolylineAnnotationEl) {
  function PolygonAnnotationElement(parameters) {
    var _this73;
    _classCallCheck(this, PolygonAnnotationElement);
    _this73 = _callSuper(this, PolygonAnnotationElement, [parameters]);
    _this73.containerClassName = "polygonAnnotation";
    _this73.svgElementName = "svg:polygon";
    return _this73;
  }
  _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);
  return _createClass(PolygonAnnotationElement);
}(PolylineAnnotationElement);
var CaretAnnotationElement = /*#__PURE__*/function (_AnnotationElement11) {
  function CaretAnnotationElement(parameters) {
    _classCallCheck(this, CaretAnnotationElement);
    return _callSuper(this, CaretAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true
    }]);
  }
  _inherits(CaretAnnotationElement, _AnnotationElement11);
  return _createClass(CaretAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.classList.add("caretAnnotation");
      if (!this.data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      return this.container;
    }
  }]);
}(AnnotationElement);
var _polylines = /*#__PURE__*/_classPrivateFieldLooseKey("polylines");
var InkAnnotationElement = /*#__PURE__*/function (_AnnotationElement12) {
  function InkAnnotationElement(parameters) {
    var _this74;
    _classCallCheck(this, InkAnnotationElement);
    _this74 = _callSuper(this, InkAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true
    }]);
    Object.defineProperty(_this74, _polylines, {
      writable: true,
      value: []
    });
    _this74.containerClassName = "inkAnnotation";
    _this74.svgElementName = "svg:polyline";
    _this74.annotationEditorType = _this74.data.it === "InkHighlight" ? _AnnotationEditorType.HIGHLIGHT : _AnnotationEditorType.INK;
    return _this74;
  }
  _inherits(InkAnnotationElement, _AnnotationElement12);
  return _createClass(InkAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.classList.add(this.containerClassName);
      var _this$data2 = this.data,
        rect = _this$data2.rect,
        inkLists = _this$data2.inkLists,
        borderStyle = _this$data2.borderStyle,
        popupRef = _this$data2.popupRef;
      var _getRectDims7 = getRectDims(rect),
        width = _getRectDims7.width,
        height = _getRectDims7.height;
      var svg = this.svgFactory.create(width, height, true);
      var _iterator133 = _createForOfIteratorHelper(inkLists),
        _step133;
      try {
        for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
          var inkList = _step133.value;
          var points = [];
          for (var i = 0, ii = inkList.length; i < ii; i += 2) {
            var x = inkList[i] - rect[0];
            var y = rect[3] - inkList[i + 1];
            points.push("".concat(x, ",").concat(y));
          }
          points = points.join(" ");
          var polyline = this.svgFactory.createElement(this.svgElementName);
          _classPrivateFieldLooseBase(this, _polylines)[_polylines].push(polyline);
          polyline.setAttribute("points", points);
          polyline.setAttribute("stroke-width", borderStyle.width || 1);
          polyline.setAttribute("stroke", "transparent");
          polyline.setAttribute("fill", "transparent");
          svg.append(polyline);
        }
      } catch (err) {
        _iterator133.e(err);
      } finally {
        _iterator133.f();
      }
      if (!popupRef && this.hasPopupData) {
        this._createPopup();
      }
      this.container.append(svg);
      this._editOnDoubleClick();
      return this.container;
    }
  }, {
    key: "getElementsToTriggerPopup",
    value: function getElementsToTriggerPopup() {
      return _classPrivateFieldLooseBase(this, _polylines)[_polylines];
    }
  }, {
    key: "addHighlightArea",
    value: function addHighlightArea() {
      this.container.classList.add("highlightArea");
    }
  }]);
}(AnnotationElement);
var HighlightAnnotationElement = /*#__PURE__*/function (_AnnotationElement13) {
  function HighlightAnnotationElement(parameters) {
    var _this75;
    _classCallCheck(this, HighlightAnnotationElement);
    _this75 = _callSuper(this, HighlightAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true,
      createQuadrilaterals: true
    }]);
    _this75.annotationEditorType = _AnnotationEditorType.HIGHLIGHT;
    return _this75;
  }
  _inherits(HighlightAnnotationElement, _AnnotationElement13);
  return _createClass(HighlightAnnotationElement, [{
    key: "render",
    value: function render() {
      if (!this.data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      this.container.classList.add("highlightAnnotation");
      this._editOnDoubleClick();
      return this.container;
    }
  }]);
}(AnnotationElement);
var UnderlineAnnotationElement = /*#__PURE__*/function (_AnnotationElement14) {
  function UnderlineAnnotationElement(parameters) {
    _classCallCheck(this, UnderlineAnnotationElement);
    return _callSuper(this, UnderlineAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true,
      createQuadrilaterals: true
    }]);
  }
  _inherits(UnderlineAnnotationElement, _AnnotationElement14);
  return _createClass(UnderlineAnnotationElement, [{
    key: "render",
    value: function render() {
      if (!this.data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      this.container.classList.add("underlineAnnotation");
      return this.container;
    }
  }]);
}(AnnotationElement);
var SquigglyAnnotationElement = /*#__PURE__*/function (_AnnotationElement15) {
  function SquigglyAnnotationElement(parameters) {
    _classCallCheck(this, SquigglyAnnotationElement);
    return _callSuper(this, SquigglyAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true,
      createQuadrilaterals: true
    }]);
  }
  _inherits(SquigglyAnnotationElement, _AnnotationElement15);
  return _createClass(SquigglyAnnotationElement, [{
    key: "render",
    value: function render() {
      if (!this.data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      this.container.classList.add("squigglyAnnotation");
      return this.container;
    }
  }]);
}(AnnotationElement);
var StrikeOutAnnotationElement = /*#__PURE__*/function (_AnnotationElement16) {
  function StrikeOutAnnotationElement(parameters) {
    _classCallCheck(this, StrikeOutAnnotationElement);
    return _callSuper(this, StrikeOutAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true,
      createQuadrilaterals: true
    }]);
  }
  _inherits(StrikeOutAnnotationElement, _AnnotationElement16);
  return _createClass(StrikeOutAnnotationElement, [{
    key: "render",
    value: function render() {
      if (!this.data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      this.container.classList.add("strikeoutAnnotation");
      return this.container;
    }
  }]);
}(AnnotationElement);
var StampAnnotationElement = /*#__PURE__*/function (_AnnotationElement17) {
  function StampAnnotationElement(parameters) {
    var _this76;
    _classCallCheck(this, StampAnnotationElement);
    _this76 = _callSuper(this, StampAnnotationElement, [parameters, {
      isRenderable: true,
      ignoreBorder: true
    }]);
    _this76.annotationEditorType = _AnnotationEditorType.STAMP;
    return _this76;
  }
  _inherits(StampAnnotationElement, _AnnotationElement17);
  return _createClass(StampAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.classList.add("stampAnnotation");
      this.container.setAttribute("role", "img");
      if (!this.data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      this._editOnDoubleClick();
      return this.container;
    }
  }]);
}(AnnotationElement);
var _trigger = /*#__PURE__*/_classPrivateFieldLooseKey("trigger");
var _download = /*#__PURE__*/_classPrivateFieldLooseKey("download");
var FileAttachmentAnnotationElement = /*#__PURE__*/function (_AnnotationElement18) {
  function FileAttachmentAnnotationElement(parameters) {
    var _this77$linkService$e;
    var _this77;
    _classCallCheck(this, FileAttachmentAnnotationElement);
    _this77 = _callSuper(this, FileAttachmentAnnotationElement, [parameters, {
      isRenderable: true
    }]);
    Object.defineProperty(_this77, _download, {
      value: _download2
    });
    Object.defineProperty(_this77, _trigger, {
      writable: true,
      value: null
    });
    var file = _this77.data.file;
    _this77.filename = file.filename;
    _this77.content = file.content;
    (_this77$linkService$e = _this77.linkService.eventBus) === null || _this77$linkService$e === void 0 || _this77$linkService$e.dispatch("fileattachmentannotation", _objectSpread({
      source: _this77
    }, file));
    return _this77;
  }
  _inherits(FileAttachmentAnnotationElement, _AnnotationElement18);
  return _createClass(FileAttachmentAnnotationElement, [{
    key: "render",
    value: function render() {
      var _this78 = this;
      this.container.classList.add("fileAttachmentAnnotation");
      var container = this.container,
        data = this.data;
      var trigger;
      if (data.hasAppearance || data.fillAlpha === 0) {
        trigger = document.createElement("div");
      } else {
        trigger = document.createElement("img");
        trigger.src = "".concat(this.imageResourcesPath, "annotation-").concat(/paperclip/i.test(data.name) ? "paperclip" : "pushpin", ".svg");
        if (data.fillAlpha && data.fillAlpha < 1) {
          trigger.style = "filter: opacity(".concat(Math.round(data.fillAlpha * 100), "%);");
        }
      }
      trigger.addEventListener("dblclick", _classPrivateFieldLooseBase(this, _download)[_download].bind(this));
      _classPrivateFieldLooseBase(this, _trigger)[_trigger] = trigger;
      var isMac = util_FeatureTest.platform.isMac;
      container.addEventListener("keydown", function (evt) {
        if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) {
          _classPrivateFieldLooseBase(_this78, _download)[_download]();
        }
      });
      if (!data.popupRef && this.hasPopupData) {
        this._createPopup();
      } else {
        trigger.classList.add("popupTriggerArea");
      }
      container.append(trigger);
      return container;
    }
  }, {
    key: "getElementsToTriggerPopup",
    value: function getElementsToTriggerPopup() {
      return _classPrivateFieldLooseBase(this, _trigger)[_trigger];
    }
  }, {
    key: "addHighlightArea",
    value: function addHighlightArea() {
      this.container.classList.add("highlightArea");
    }
  }]);
}(AnnotationElement);
function _download2() {
  var _this$downloadManager;
  (_this$downloadManager = this.downloadManager) === null || _this$downloadManager === void 0 || _this$downloadManager.openOrDownloadData(this.content, this.filename);
}
var _accessibilityManager = /*#__PURE__*/_classPrivateFieldLooseKey("accessibilityManager");
var _annotationCanvasMap = /*#__PURE__*/_classPrivateFieldLooseKey("annotationCanvasMap");
var _editableAnnotations = /*#__PURE__*/_classPrivateFieldLooseKey("editableAnnotations");
var _structTreeLayer = /*#__PURE__*/_classPrivateFieldLooseKey("structTreeLayer");
var _appendElement = /*#__PURE__*/_classPrivateFieldLooseKey("appendElement");
var _setAnnotationCanvasMap = /*#__PURE__*/_classPrivateFieldLooseKey("setAnnotationCanvasMap");
var _AnnotationLayer = /*#__PURE__*/function () {
  function _AnnotationLayer(_ref144) {
    var div = _ref144.div,
      accessibilityManager = _ref144.accessibilityManager,
      annotationCanvasMap = _ref144.annotationCanvasMap,
      annotationEditorUIManager = _ref144.annotationEditorUIManager,
      page = _ref144.page,
      viewport = _ref144.viewport,
      structTreeLayer = _ref144.structTreeLayer;
    _classCallCheck(this, _AnnotationLayer);
    Object.defineProperty(this, _setAnnotationCanvasMap, {
      value: _setAnnotationCanvasMap2
    });
    Object.defineProperty(this, _appendElement, {
      value: _appendElement2
    });
    Object.defineProperty(this, _accessibilityManager, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _annotationCanvasMap, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _editableAnnotations, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _structTreeLayer, {
      writable: true,
      value: null
    });
    this.div = div;
    _classPrivateFieldLooseBase(this, _accessibilityManager)[_accessibilityManager] = accessibilityManager;
    _classPrivateFieldLooseBase(this, _annotationCanvasMap)[_annotationCanvasMap] = annotationCanvasMap;
    _classPrivateFieldLooseBase(this, _structTreeLayer)[_structTreeLayer] = structTreeLayer || null;
    this.page = page;
    this.viewport = viewport;
    this.zIndex = 0;
    this._annotationEditorUIManager = annotationEditorUIManager;
  }
  return _createClass(_AnnotationLayer, [{
    key: "hasEditableAnnotations",
    value: function hasEditableAnnotations() {
      return _classPrivateFieldLooseBase(this, _editableAnnotations)[_editableAnnotations].size > 0;
    }
  }, {
    key: "render",
    value: function () {
      var _render4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee41(params) {
        var annotations, layer, popupToElements, elementParams, _iterator134, _step134, data, isPopupAnnotation, _getRectDims8, width, height, elements, element, _elements2, rendered, _this$_annotationEdit;
        return _regeneratorRuntime().wrap(function _callee41$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              annotations = params.annotations;
              layer = this.div;
              _setLayerDimensions(layer, this.viewport);
              popupToElements = new Map();
              elementParams = {
                data: null,
                layer: layer,
                linkService: params.linkService,
                downloadManager: params.downloadManager,
                imageResourcesPath: params.imageResourcesPath || "",
                renderForms: params.renderForms !== false,
                svgFactory: new _DOMSVGFactory(),
                annotationStorage: params.annotationStorage || new AnnotationStorage(),
                enableScripting: params.enableScripting === true,
                hasJSActions: params.hasJSActions,
                fieldObjects: params.fieldObjects,
                parent: this,
                elements: null
              };
              _iterator134 = _createForOfIteratorHelper(annotations);
              _context42.prev = 6;
              _iterator134.s();
            case 8:
              if ((_step134 = _iterator134.n()).done) {
                _context42.next = 35;
                break;
              }
              data = _step134.value;
              if (!data.noHTML) {
                _context42.next = 12;
                break;
              }
              return _context42.abrupt("continue", 33);
            case 12:
              isPopupAnnotation = data.annotationType === AnnotationType.POPUP;
              if (isPopupAnnotation) {
                _context42.next = 19;
                break;
              }
              _getRectDims8 = getRectDims(data.rect), width = _getRectDims8.width, height = _getRectDims8.height;
              if (!(width <= 0 || height <= 0)) {
                _context42.next = 17;
                break;
              }
              return _context42.abrupt("continue", 33);
            case 17:
              _context42.next = 23;
              break;
            case 19:
              elements = popupToElements.get(data.id);
              if (elements) {
                _context42.next = 22;
                break;
              }
              return _context42.abrupt("continue", 33);
            case 22:
              elementParams.elements = elements;
            case 23:
              elementParams.data = data;
              element = AnnotationElementFactory.create(elementParams);
              if (element.isRenderable) {
                _context42.next = 27;
                break;
              }
              return _context42.abrupt("continue", 33);
            case 27:
              if (!isPopupAnnotation && data.popupRef) {
                _elements2 = popupToElements.get(data.popupRef);
                if (!_elements2) {
                  popupToElements.set(data.popupRef, [element]);
                } else {
                  _elements2.push(element);
                }
              }
              rendered = element.render();
              if (data.hidden) {
                rendered.style.visibility = "hidden";
              }
              _context42.next = 32;
              return _classPrivateFieldLooseBase(this, _appendElement)[_appendElement](rendered, data.id);
            case 32:
              if (element._isEditable) {
                _classPrivateFieldLooseBase(this, _editableAnnotations)[_editableAnnotations].set(element.data.id, element);
                (_this$_annotationEdit = this._annotationEditorUIManager) === null || _this$_annotationEdit === void 0 || _this$_annotationEdit.renderAnnotationElement(element);
              }
            case 33:
              _context42.next = 8;
              break;
            case 35:
              _context42.next = 40;
              break;
            case 37:
              _context42.prev = 37;
              _context42.t0 = _context42["catch"](6);
              _iterator134.e(_context42.t0);
            case 40:
              _context42.prev = 40;
              _iterator134.f();
              return _context42.finish(40);
            case 43:
              _classPrivateFieldLooseBase(this, _setAnnotationCanvasMap)[_setAnnotationCanvasMap]();
            case 44:
            case "end":
              return _context42.stop();
          }
        }, _callee41, this, [[6, 37, 40, 43]]);
      }));
      function render(_x30) {
        return _render4.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "update",
    value: function update(_ref145) {
      var viewport = _ref145.viewport;
      var layer = this.div;
      this.viewport = viewport;
      _setLayerDimensions(layer, {
        rotation: viewport.rotation
      });
      _classPrivateFieldLooseBase(this, _setAnnotationCanvasMap)[_setAnnotationCanvasMap]();
      layer.hidden = false;
    }
  }, {
    key: "getEditableAnnotations",
    value: function getEditableAnnotations() {
      return Array.from(_classPrivateFieldLooseBase(this, _editableAnnotations)[_editableAnnotations].values());
    }
  }, {
    key: "getEditableAnnotation",
    value: function getEditableAnnotation(id) {
      return _classPrivateFieldLooseBase(this, _editableAnnotations)[_editableAnnotations].get(id);
    }
  }]);
}();
function _appendElement2(_x51, _x52) {
  return _appendElement3.apply(this, arguments);
}
function _appendElement3() {
  _appendElement3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee58(element, id) {
    var _classPrivateFieldLoo178, _classPrivateFieldLoo179;
    var contentElement, annotationId, ariaAttributes, _iterator186, _step186, _ref190, _ref191, key, value;
    return _regeneratorRuntime().wrap(function _callee58$(_context59) {
      while (1) switch (_context59.prev = _context59.next) {
        case 0:
          contentElement = element.firstChild || element;
          annotationId = contentElement.id = "".concat(AnnotationPrefix).concat(id);
          _context59.next = 4;
          return (_classPrivateFieldLoo178 = _classPrivateFieldLooseBase(this, _structTreeLayer)[_structTreeLayer]) === null || _classPrivateFieldLoo178 === void 0 ? void 0 : _classPrivateFieldLoo178.getAriaAttributes(annotationId);
        case 4:
          ariaAttributes = _context59.sent;
          if (ariaAttributes) {
            _iterator186 = _createForOfIteratorHelper(ariaAttributes);
            try {
              for (_iterator186.s(); !(_step186 = _iterator186.n()).done;) {
                _ref190 = _step186.value;
                _ref191 = _slicedToArray(_ref190, 2);
                key = _ref191[0];
                value = _ref191[1];
                contentElement.setAttribute(key, value);
              }
            } catch (err) {
              _iterator186.e(err);
            } finally {
              _iterator186.f();
            }
          }
          this.div.append(element);
          (_classPrivateFieldLoo179 = _classPrivateFieldLooseBase(this, _accessibilityManager)[_accessibilityManager]) === null || _classPrivateFieldLoo179 === void 0 || _classPrivateFieldLoo179.moveElementInDOM(this.div, element, contentElement, false);
        case 8:
        case "end":
          return _context59.stop();
      }
    }, _callee58, this);
  }));
  return _appendElement3.apply(this, arguments);
}
function _setAnnotationCanvasMap2() {
  if (!_classPrivateFieldLooseBase(this, _annotationCanvasMap)[_annotationCanvasMap]) {
    return;
  }
  var layer = this.div;
  var _iterator172 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _annotationCanvasMap)[_annotationCanvasMap]),
    _step172;
  try {
    for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
      var _ref172 = _step172.value;
      var _ref173 = _slicedToArray(_ref172, 2);
      var _id22 = _ref173[0];
      var canvas = _ref173[1];
      var element = layer.querySelector("[data-annotation-id=\"".concat(_id22, "\"]"));
      if (!element) {
        continue;
      }
      canvas.className = "annotationContent";
      var firstChild = element.firstChild;
      if (!firstChild) {
        element.append(canvas);
      } else if (firstChild.nodeName === "CANVAS") {
        firstChild.replaceWith(canvas);
      } else if (!firstChild.classList.contains("annotationContent")) {
        firstChild.before(canvas);
      } else {
        firstChild.after(canvas);
      }
    }
  } catch (err) {
    _iterator172.e(err);
  } finally {
    _iterator172.f();
  }
  _classPrivateFieldLooseBase(this, _annotationCanvasMap)[_annotationCanvasMap].clear();
}
; // ./src/display/editor/freetext.js

var EOL_PATTERN = /\r\n?|\n/g;
var _color2 = /*#__PURE__*/_classPrivateFieldLooseKey("color");
var _content = /*#__PURE__*/_classPrivateFieldLooseKey("content");
var _editorDivId = /*#__PURE__*/_classPrivateFieldLooseKey("editorDivId");
var _editModeAC = /*#__PURE__*/_classPrivateFieldLooseKey("editModeAC");
var _fontSize2 = /*#__PURE__*/_classPrivateFieldLooseKey("fontSize");
var _updateFontSize = /*#__PURE__*/_classPrivateFieldLooseKey("updateFontSize");
var _updateColor = /*#__PURE__*/_classPrivateFieldLooseKey("updateColor");
var _extractText = /*#__PURE__*/_classPrivateFieldLooseKey("extractText");
var _setEditorDimensions = /*#__PURE__*/_classPrivateFieldLooseKey("setEditorDimensions");
var _getNodeContent = /*#__PURE__*/_classPrivateFieldLooseKey("getNodeContent");
var _setContent = /*#__PURE__*/_classPrivateFieldLooseKey("setContent");
var _serializeContent = /*#__PURE__*/_classPrivateFieldLooseKey("serializeContent");
var _deserializeContent = /*#__PURE__*/_classPrivateFieldLooseKey("deserializeContent");
var _hasElementChanged = /*#__PURE__*/_classPrivateFieldLooseKey("hasElementChanged");
var FreeTextEditor = /*#__PURE__*/function (_AnnotationEditor3) {
  function FreeTextEditor(params) {
    var _this79;
    _classCallCheck(this, FreeTextEditor);
    _this79 = _callSuper(this, FreeTextEditor, [_objectSpread(_objectSpread({}, params), {}, {
      name: "freeTextEditor"
    })]);
    Object.defineProperty(_this79, _hasElementChanged, {
      value: _hasElementChanged2
    });
    Object.defineProperty(_this79, _serializeContent, {
      value: _serializeContent2
    });
    Object.defineProperty(_this79, _setContent, {
      value: _setContent2
    });
    Object.defineProperty(_this79, _setEditorDimensions, {
      value: _setEditorDimensions2
    });
    Object.defineProperty(_this79, _extractText, {
      value: _extractText2
    });
    Object.defineProperty(_this79, _updateColor, {
      value: _updateColor2
    });
    Object.defineProperty(_this79, _updateFontSize, {
      value: _updateFontSize2
    });
    Object.defineProperty(_this79, _color2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this79, _content, {
      writable: true,
      value: ""
    });
    Object.defineProperty(_this79, _editorDivId, {
      writable: true,
      value: "".concat(_this79.id, "-editor")
    });
    Object.defineProperty(_this79, _editModeAC, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this79, _fontSize2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(_this79, _color2)[_color2] = params.color || FreeTextEditor._defaultColor || AnnotationEditor._defaultLineColor;
    _classPrivateFieldLooseBase(_this79, _fontSize2)[_fontSize2] = params.fontSize || FreeTextEditor._defaultFontSize;
    return _this79;
  }
  _inherits(FreeTextEditor, _AnnotationEditor3);
  return _createClass(FreeTextEditor, [{
    key: "updateParams",
    value: function updateParams(type, value) {
      switch (type) {
        case _AnnotationEditorParamsType.FREETEXT_SIZE:
          _classPrivateFieldLooseBase(this, _updateFontSize)[_updateFontSize](value);
          break;
        case _AnnotationEditorParamsType.FREETEXT_COLOR:
          _classPrivateFieldLooseBase(this, _updateColor)[_updateColor](value);
          break;
      }
    }
  }, {
    key: "propertiesToUpdate",
    get: function get() {
      return [[_AnnotationEditorParamsType.FREETEXT_SIZE, _classPrivateFieldLooseBase(this, _fontSize2)[_fontSize2]], [_AnnotationEditorParamsType.FREETEXT_COLOR, _classPrivateFieldLooseBase(this, _color2)[_color2]]];
    }
  }, {
    key: "_translateEmpty",
    value: function _translateEmpty(x, y) {
      this._uiManager.translateSelectedEditors(x, y, true);
    }
  }, {
    key: "getInitialTranslation",
    value: function getInitialTranslation() {
      var scale = this.parentScale;
      return [-FreeTextEditor._internalPadding * scale, -(FreeTextEditor._internalPadding + _classPrivateFieldLooseBase(this, _fontSize2)[_fontSize2]) * scale];
    }
  }, {
    key: "rebuild",
    value: function rebuild() {
      if (!this.parent) {
        return;
      }
      _superPropGet(FreeTextEditor, "rebuild", this, 3)([]);
      if (this.div === null) {
        return;
      }
      if (!this.isAttachedToDOM) {
        this.parent.add(this);
      }
    }
  }, {
    key: "enableEditMode",
    value: function enableEditMode() {
      if (this.isInEditMode()) {
        return;
      }
      this.parent.setEditingState(false);
      this.parent.updateToolbar(_AnnotationEditorType.FREETEXT);
      _superPropGet(FreeTextEditor, "enableEditMode", this, 3)([]);
      this.overlayDiv.classList.remove("enabled");
      this.editorDiv.contentEditable = true;
      this._isDraggable = false;
      this.div.removeAttribute("aria-activedescendant");
      _classPrivateFieldLooseBase(this, _editModeAC)[_editModeAC] = new AbortController();
      var signal = this._uiManager.combinedSignal(_classPrivateFieldLooseBase(this, _editModeAC)[_editModeAC]);
      this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), {
        signal: signal
      });
      this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
        signal: signal
      });
      this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
        signal: signal
      });
      this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
        signal: signal
      });
      this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
        signal: signal
      });
    }
  }, {
    key: "disableEditMode",
    value: function disableEditMode() {
      var _classPrivateFieldLoo77;
      if (!this.isInEditMode()) {
        return;
      }
      this.parent.setEditingState(true);
      _superPropGet(FreeTextEditor, "disableEditMode", this, 3)([]);
      this.overlayDiv.classList.add("enabled");
      this.editorDiv.contentEditable = false;
      this.div.setAttribute("aria-activedescendant", _classPrivateFieldLooseBase(this, _editorDivId)[_editorDivId]);
      this._isDraggable = true;
      (_classPrivateFieldLoo77 = _classPrivateFieldLooseBase(this, _editModeAC)[_editModeAC]) === null || _classPrivateFieldLoo77 === void 0 || _classPrivateFieldLoo77.abort();
      _classPrivateFieldLooseBase(this, _editModeAC)[_editModeAC] = null;
      this.div.focus({
        preventScroll: true
      });
      this.isEditing = false;
      this.parent.div.classList.add("freetextEditing");
    }
  }, {
    key: "focusin",
    value: function focusin(event) {
      if (!this._focusEventsAllowed) {
        return;
      }
      _superPropGet(FreeTextEditor, "focusin", this, 3)([event]);
      if (event.target !== this.editorDiv) {
        this.editorDiv.focus();
      }
    }
  }, {
    key: "onceAdded",
    value: function onceAdded() {
      var _this$_initialOptions;
      if (this.width) {
        return;
      }
      this.enableEditMode();
      this.editorDiv.focus();
      if ((_this$_initialOptions = this._initialOptions) !== null && _this$_initialOptions !== void 0 && _this$_initialOptions.isCentered) {
        this.center();
      }
      this._initialOptions = null;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !this.editorDiv || this.editorDiv.innerText.trim() === "";
    }
  }, {
    key: "remove",
    value: function remove() {
      this.isEditing = false;
      if (this.parent) {
        this.parent.setEditingState(true);
        this.parent.div.classList.add("freetextEditing");
      }
      _superPropGet(FreeTextEditor, "remove", this, 3)([]);
    }
  }, {
    key: "commit",
    value: function commit() {
      var _this80 = this;
      if (!this.isInEditMode()) {
        return;
      }
      _superPropGet(FreeTextEditor, "commit", this, 3)([]);
      this.disableEditMode();
      var savedText = _classPrivateFieldLooseBase(this, _content)[_content];
      var newText = _classPrivateFieldLooseBase(this, _content)[_content] = _classPrivateFieldLooseBase(this, _extractText)[_extractText]().trimEnd();
      if (savedText === newText) {
        return;
      }
      var setText = function setText(text) {
        _classPrivateFieldLooseBase(_this80, _content)[_content] = text;
        if (!text) {
          _this80.remove();
          return;
        }
        _classPrivateFieldLooseBase(_this80, _setContent)[_setContent]();
        _this80._uiManager.rebuild(_this80);
        _classPrivateFieldLooseBase(_this80, _setEditorDimensions)[_setEditorDimensions]();
      };
      this.addCommands({
        cmd: function cmd() {
          setText(newText);
        },
        undo: function undo() {
          setText(savedText);
        },
        mustExec: false
      });
      _classPrivateFieldLooseBase(this, _setEditorDimensions)[_setEditorDimensions]();
    }
  }, {
    key: "shouldGetKeyboardEvents",
    value: function shouldGetKeyboardEvents() {
      return this.isInEditMode();
    }
  }, {
    key: "enterInEditMode",
    value: function enterInEditMode() {
      this.enableEditMode();
      this.editorDiv.focus();
    }
  }, {
    key: "dblclick",
    value: function dblclick(event) {
      this.enterInEditMode();
    }
  }, {
    key: "keydown",
    value: function keydown(event) {
      if (event.target === this.div && event.key === "Enter") {
        this.enterInEditMode();
        event.preventDefault();
      }
    }
  }, {
    key: "editorDivKeydown",
    value: function editorDivKeydown(event) {
      FreeTextEditor._keyboardManager.exec(this, event);
    }
  }, {
    key: "editorDivFocus",
    value: function editorDivFocus(event) {
      this.isEditing = true;
    }
  }, {
    key: "editorDivBlur",
    value: function editorDivBlur(event) {
      this.isEditing = false;
    }
  }, {
    key: "editorDivInput",
    value: function editorDivInput(event) {
      this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
    }
  }, {
    key: "disableEditing",
    value: function disableEditing() {
      this.editorDiv.setAttribute("role", "comment");
      this.editorDiv.removeAttribute("aria-multiline");
    }
  }, {
    key: "enableEditing",
    value: function enableEditing() {
      this.editorDiv.setAttribute("role", "textbox");
      this.editorDiv.setAttribute("aria-multiline", true);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.div) {
        return this.div;
      }
      var baseX, baseY;
      if (this.width) {
        baseX = this.x;
        baseY = this.y;
      }
      _superPropGet(FreeTextEditor, "render", this, 3)([]);
      this.editorDiv = document.createElement("div");
      this.editorDiv.className = "internal";
      this.editorDiv.setAttribute("id", _classPrivateFieldLooseBase(this, _editorDivId)[_editorDivId]);
      this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text2");
      this.editorDiv.setAttribute("data-l10n-attrs", "default-content");
      this.enableEditing();
      this.editorDiv.contentEditable = true;
      var style = this.editorDiv.style;
      style.fontSize = "calc(".concat(_classPrivateFieldLooseBase(this, _fontSize2)[_fontSize2], "px * var(--scale-factor))");
      style.color = _classPrivateFieldLooseBase(this, _color2)[_color2];
      this.div.append(this.editorDiv);
      this.overlayDiv = document.createElement("div");
      this.overlayDiv.classList.add("overlay", "enabled");
      this.div.append(this.overlayDiv);
      bindEvents(this, this.div, ["dblclick", "keydown"]);
      if (this.width) {
        var _this$parentDimension8 = _slicedToArray(this.parentDimensions, 2),
          parentWidth = _this$parentDimension8[0],
          parentHeight = _this$parentDimension8[1];
        if (this.annotationElementId) {
          var position = this._initialData.position;
          var _this$getInitialTrans3 = this.getInitialTranslation(),
            _this$getInitialTrans4 = _slicedToArray(_this$getInitialTrans3, 2),
            tx = _this$getInitialTrans4[0],
            ty = _this$getInitialTrans4[1];
          var _this$pageTranslation2 = this.pageTranslationToScreen(tx, ty);
          var _this$pageTranslation3 = _slicedToArray(_this$pageTranslation2, 2);
          tx = _this$pageTranslation3[0];
          ty = _this$pageTranslation3[1];
          var _this$pageDimensions5 = _slicedToArray(this.pageDimensions, 2),
            pageWidth = _this$pageDimensions5[0],
            pageHeight = _this$pageDimensions5[1];
          var _this$pageTranslation4 = _slicedToArray(this.pageTranslation, 2),
            pageX = _this$pageTranslation4[0],
            pageY = _this$pageTranslation4[1];
          var posX, posY;
          switch (this.rotation) {
            case 0:
              posX = baseX + (position[0] - pageX) / pageWidth;
              posY = baseY + this.height - (position[1] - pageY) / pageHeight;
              break;
            case 90:
              posX = baseX + (position[0] - pageX) / pageWidth;
              posY = baseY - (position[1] - pageY) / pageHeight;
              var _ref146 = [ty, -tx];
              tx = _ref146[0];
              ty = _ref146[1];
              break;
            case 180:
              posX = baseX - this.width + (position[0] - pageX) / pageWidth;
              posY = baseY - (position[1] - pageY) / pageHeight;
              var _ref147 = [-tx, -ty];
              tx = _ref147[0];
              ty = _ref147[1];
              break;
            case 270:
              posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
              posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
              var _ref148 = [-ty, tx];
              tx = _ref148[0];
              ty = _ref148[1];
              break;
          }
          this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
        } else {
          this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
        }
        _classPrivateFieldLooseBase(this, _setContent)[_setContent]();
        this._isDraggable = true;
        this.editorDiv.contentEditable = false;
      } else {
        this._isDraggable = false;
        this.editorDiv.contentEditable = true;
      }
      return this.div;
    }
  }, {
    key: "editorDivPaste",
    value: function editorDivPaste(event) {
      var clipboardData = event.clipboardData || window.clipboardData;
      var types = clipboardData.types;
      if (types.length === 1 && types[0] === "text/plain") {
        return;
      }
      event.preventDefault();
      var paste = _classPrivateFieldLooseBase(FreeTextEditor, _deserializeContent)[_deserializeContent](clipboardData.getData("text") || "").replaceAll(EOL_PATTERN, "\n");
      if (!paste) {
        return;
      }
      var selection = window.getSelection();
      if (!selection.rangeCount) {
        return;
      }
      this.editorDiv.normalize();
      selection.deleteFromDocument();
      var range = selection.getRangeAt(0);
      if (!paste.includes("\n")) {
        range.insertNode(document.createTextNode(paste));
        this.editorDiv.normalize();
        selection.collapseToStart();
        return;
      }
      var startContainer = range.startContainer,
        startOffset = range.startOffset;
      var bufferBefore = [];
      var bufferAfter = [];
      if (startContainer.nodeType === Node.TEXT_NODE) {
        var parent = startContainer.parentElement;
        bufferAfter.push(startContainer.nodeValue.slice(startOffset).replaceAll(EOL_PATTERN, ""));
        if (parent !== this.editorDiv) {
          var buffer = bufferBefore;
          var _iterator135 = _createForOfIteratorHelper(this.editorDiv.childNodes),
            _step135;
          try {
            for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
              var child = _step135.value;
              if (child === parent) {
                buffer = bufferAfter;
                continue;
              }
              buffer.push(_classPrivateFieldLooseBase(FreeTextEditor, _getNodeContent)[_getNodeContent](child));
            }
          } catch (err) {
            _iterator135.e(err);
          } finally {
            _iterator135.f();
          }
        }
        bufferBefore.push(startContainer.nodeValue.slice(0, startOffset).replaceAll(EOL_PATTERN, ""));
      } else if (startContainer === this.editorDiv) {
        var _buffer = bufferBefore;
        var i = 0;
        var _iterator136 = _createForOfIteratorHelper(this.editorDiv.childNodes),
          _step136;
        try {
          for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
            var _child = _step136.value;
            if (i++ === startOffset) {
              _buffer = bufferAfter;
            }
            _buffer.push(_classPrivateFieldLooseBase(FreeTextEditor, _getNodeContent)[_getNodeContent](_child));
          }
        } catch (err) {
          _iterator136.e(err);
        } finally {
          _iterator136.f();
        }
      }
      _classPrivateFieldLooseBase(this, _content)[_content] = "".concat(bufferBefore.join("\n")).concat(paste).concat(bufferAfter.join("\n"));
      _classPrivateFieldLooseBase(this, _setContent)[_setContent]();
      var newRange = new Range();
      var beforeLength = bufferBefore.reduce(function (acc, line) {
        return acc + line.length;
      }, 0);
      var _iterator137 = _createForOfIteratorHelper(this.editorDiv.childNodes),
        _step137;
      try {
        for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
          var _ref149 = _step137.value;
          var firstChild = _ref149.firstChild;
          if (firstChild.nodeType === Node.TEXT_NODE) {
            var length = firstChild.nodeValue.length;
            if (beforeLength <= length) {
              newRange.setStart(firstChild, beforeLength);
              newRange.setEnd(firstChild, beforeLength);
              break;
            }
            beforeLength -= length;
          }
        }
      } catch (err) {
        _iterator137.e(err);
      } finally {
        _iterator137.f();
      }
      selection.removeAllRanges();
      selection.addRange(newRange);
    }
  }, {
    key: "contentDiv",
    get: function get() {
      return this.editorDiv;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var isForCopying = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.isEmpty()) {
        return null;
      }
      if (this.deleted) {
        return this.serializeDeleted();
      }
      var padding = FreeTextEditor._internalPadding * this.parentScale;
      var rect = this.getRect(padding, padding);
      var color = AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : _classPrivateFieldLooseBase(this, _color2)[_color2]);
      var serialized = {
        annotationType: _AnnotationEditorType.FREETEXT,
        color: color,
        fontSize: _classPrivateFieldLooseBase(this, _fontSize2)[_fontSize2],
        value: _classPrivateFieldLooseBase(this, _serializeContent)[_serializeContent](),
        pageIndex: this.pageIndex,
        rect: rect,
        rotation: this.rotation,
        structTreeParentId: this._structTreeParentId
      };
      if (isForCopying) {
        return serialized;
      }
      if (this.annotationElementId && !_classPrivateFieldLooseBase(this, _hasElementChanged)[_hasElementChanged](serialized)) {
        return null;
      }
      serialized.id = this.annotationElementId;
      return serialized;
    }
  }, {
    key: "renderAnnotationElement",
    value: function renderAnnotationElement(annotation) {
      var content = _superPropGet(FreeTextEditor, "renderAnnotationElement", this, 3)([annotation]);
      if (this.deleted) {
        return content;
      }
      var style = content.style;
      style.fontSize = "calc(".concat(_classPrivateFieldLooseBase(this, _fontSize2)[_fontSize2], "px * var(--scale-factor))");
      style.color = _classPrivateFieldLooseBase(this, _color2)[_color2];
      content.replaceChildren();
      var _iterator138 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _content)[_content].split("\n")),
        _step138;
      try {
        for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
          var line = _step138.value;
          var div = document.createElement("div");
          div.append(line ? document.createTextNode(line) : document.createElement("br"));
          content.append(div);
        }
      } catch (err) {
        _iterator138.e(err);
      } finally {
        _iterator138.f();
      }
      var padding = FreeTextEditor._internalPadding * this.parentScale;
      annotation.updateEdited({
        rect: this.getRect(padding, padding),
        popupContent: _classPrivateFieldLooseBase(this, _content)[_content]
      });
      return content;
    }
  }, {
    key: "resetAnnotationElement",
    value: function resetAnnotationElement(annotation) {
      _superPropGet(FreeTextEditor, "resetAnnotationElement", this, 3)([annotation]);
      annotation.resetEdited();
    }
  }], [{
    key: "_keyboardManager",
    get: function get() {
      var proto = FreeTextEditor.prototype;
      var arrowChecker = function arrowChecker(self) {
        return self.isEmpty();
      };
      var small = _AnnotationEditorUIManager.TRANSLATE_SMALL;
      var big = _AnnotationEditorUIManager.TRANSLATE_BIG;
      return _shadow(this, "_keyboardManager", new KeyboardManager([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], proto.commitOrRemove, {
        bubbles: true
      }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], proto.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], proto._translateEmpty, {
        args: [-small, 0],
        checker: arrowChecker
      }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], proto._translateEmpty, {
        args: [-big, 0],
        checker: arrowChecker
      }], [["ArrowRight", "mac+ArrowRight"], proto._translateEmpty, {
        args: [small, 0],
        checker: arrowChecker
      }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], proto._translateEmpty, {
        args: [big, 0],
        checker: arrowChecker
      }], [["ArrowUp", "mac+ArrowUp"], proto._translateEmpty, {
        args: [0, -small],
        checker: arrowChecker
      }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], proto._translateEmpty, {
        args: [0, -big],
        checker: arrowChecker
      }], [["ArrowDown", "mac+ArrowDown"], proto._translateEmpty, {
        args: [0, small],
        checker: arrowChecker
      }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], proto._translateEmpty, {
        args: [0, big],
        checker: arrowChecker
      }]]));
    }
  }, {
    key: "initialize",
    value: function initialize(l10n, uiManager) {
      AnnotationEditor.initialize(l10n, uiManager);
      var style = getComputedStyle(document.documentElement);
      this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
    }
  }, {
    key: "updateDefaultParams",
    value: function updateDefaultParams(type, value) {
      switch (type) {
        case _AnnotationEditorParamsType.FREETEXT_SIZE:
          FreeTextEditor._defaultFontSize = value;
          break;
        case _AnnotationEditorParamsType.FREETEXT_COLOR:
          FreeTextEditor._defaultColor = value;
          break;
      }
    }
  }, {
    key: "defaultPropertiesToUpdate",
    get: function get() {
      return [[_AnnotationEditorParamsType.FREETEXT_SIZE, FreeTextEditor._defaultFontSize], [_AnnotationEditorParamsType.FREETEXT_COLOR, FreeTextEditor._defaultColor || AnnotationEditor._defaultLineColor]];
    }
  }, {
    key: "deserialize",
    value: function () {
      var _deserialize2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee42(data, parent, uiManager) {
        var initialData, _data3, _data3$data, _data3$data$defaultAp, fontSize, fontColor, rect, rotation, _id14, popupRef, textContent, textPosition, pageNumber, editor;
        return _regeneratorRuntime().wrap(function _callee42$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              initialData = null;
              if (!(data instanceof FreeTextAnnotationElement)) {
                _context43.next = 6;
                break;
              }
              _data3 = data, _data3$data = _data3.data, _data3$data$defaultAp = _data3$data.defaultAppearanceData, fontSize = _data3$data$defaultAp.fontSize, fontColor = _data3$data$defaultAp.fontColor, rect = _data3$data.rect, rotation = _data3$data.rotation, _id14 = _data3$data.id, popupRef = _data3$data.popupRef, textContent = _data3.textContent, textPosition = _data3.textPosition, pageNumber = _data3.parent.page.pageNumber;
              if (!(!textContent || textContent.length === 0)) {
                _context43.next = 5;
                break;
              }
              return _context43.abrupt("return", null);
            case 5:
              initialData = data = {
                annotationType: _AnnotationEditorType.FREETEXT,
                color: Array.from(fontColor),
                fontSize: fontSize,
                value: textContent.join("\n"),
                position: textPosition,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                id: _id14,
                deleted: false,
                popupRef: popupRef
              };
            case 6:
              _context43.next = 8;
              return _superPropGet(FreeTextEditor, "deserialize", this, 2)([data, parent, uiManager]);
            case 8:
              editor = _context43.sent;
              _classPrivateFieldLooseBase(editor, _fontSize2)[_fontSize2] = data.fontSize;
              _classPrivateFieldLooseBase(editor, _color2)[_color2] = _Util.makeHexColor.apply(_Util, _toConsumableArray(data.color));
              _classPrivateFieldLooseBase(editor, _content)[_content] = _classPrivateFieldLooseBase(FreeTextEditor, _deserializeContent)[_deserializeContent](data.value);
              editor.annotationElementId = data.id || null;
              editor._initialData = initialData;
              return _context43.abrupt("return", editor);
            case 15:
            case "end":
              return _context43.stop();
          }
        }, _callee42, this);
      }));
      function deserialize(_x31, _x32, _x33) {
        return _deserialize2.apply(this, arguments);
      }
      return deserialize;
    }()
  }]);
}(AnnotationEditor);
_FreeTextEditor = FreeTextEditor;
function _updateFontSize2(fontSize) {
  var _this97 = this;
  var setFontsize = function setFontsize(size) {
    _this97.editorDiv.style.fontSize = "calc(".concat(size, "px * var(--scale-factor))");
    _this97.translate(0, -(size - _classPrivateFieldLooseBase(_this97, _fontSize2)[_fontSize2]) * _this97.parentScale);
    _classPrivateFieldLooseBase(_this97, _fontSize2)[_fontSize2] = size;
    _classPrivateFieldLooseBase(_this97, _setEditorDimensions)[_setEditorDimensions]();
  };
  var savedFontsize = _classPrivateFieldLooseBase(this, _fontSize2)[_fontSize2];
  this.addCommands({
    cmd: setFontsize.bind(this, fontSize),
    undo: setFontsize.bind(this, savedFontsize),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: true,
    type: _AnnotationEditorParamsType.FREETEXT_SIZE,
    overwriteIfSameType: true,
    keepUndo: true
  });
}
function _updateColor2(color) {
  var _this98 = this;
  var setColor = function setColor(col) {
    _classPrivateFieldLooseBase(_this98, _color2)[_color2] = _this98.editorDiv.style.color = col;
  };
  var savedColor = _classPrivateFieldLooseBase(this, _color2)[_color2];
  this.addCommands({
    cmd: setColor.bind(this, color),
    undo: setColor.bind(this, savedColor),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: true,
    type: _AnnotationEditorParamsType.FREETEXT_COLOR,
    overwriteIfSameType: true,
    keepUndo: true
  });
}
function _extractText2() {
  var buffer = [];
  this.editorDiv.normalize();
  var prevChild = null;
  var _iterator173 = _createForOfIteratorHelper(this.editorDiv.childNodes),
    _step173;
  try {
    for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
      var _prevChild;
      var child = _step173.value;
      if (((_prevChild = prevChild) === null || _prevChild === void 0 ? void 0 : _prevChild.nodeType) === Node.TEXT_NODE && child.nodeName === "BR") {
        continue;
      }
      buffer.push(_classPrivateFieldLooseBase(_FreeTextEditor, _getNodeContent)[_getNodeContent](child));
      prevChild = child;
    }
  } catch (err) {
    _iterator173.e(err);
  } finally {
    _iterator173.f();
  }
  return buffer.join("\n");
}
function _setEditorDimensions2() {
  var _this$parentDimension15 = _slicedToArray(this.parentDimensions, 2),
    parentWidth = _this$parentDimension15[0],
    parentHeight = _this$parentDimension15[1];
  var rect;
  if (this.isAttachedToDOM) {
    rect = this.div.getBoundingClientRect();
  } else {
    var currentLayer = this.currentLayer,
      div = this.div;
    var savedDisplay = div.style.display;
    var savedVisibility = div.classList.contains("hidden");
    div.classList.remove("hidden");
    div.style.display = "hidden";
    currentLayer.div.append(this.div);
    rect = div.getBoundingClientRect();
    div.remove();
    div.style.display = savedDisplay;
    div.classList.toggle("hidden", savedVisibility);
  }
  if (this.rotation % 180 === this.parentRotation % 180) {
    this.width = rect.width / parentWidth;
    this.height = rect.height / parentHeight;
  } else {
    this.width = rect.height / parentWidth;
    this.height = rect.width / parentHeight;
  }
  this.fixAndSetPosition();
}
function _getNodeContent2(node) {
  return (node.nodeType === Node.TEXT_NODE ? node.nodeValue : node.innerText).replaceAll(EOL_PATTERN, "");
}
function _setContent2() {
  this.editorDiv.replaceChildren();
  if (!_classPrivateFieldLooseBase(this, _content)[_content]) {
    return;
  }
  var _iterator174 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _content)[_content].split("\n")),
    _step174;
  try {
    for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
      var line = _step174.value;
      var div = document.createElement("div");
      div.append(line ? document.createTextNode(line) : document.createElement("br"));
      this.editorDiv.append(div);
    }
  } catch (err) {
    _iterator174.e(err);
  } finally {
    _iterator174.f();
  }
}
function _serializeContent2() {
  return _classPrivateFieldLooseBase(this, _content)[_content].replaceAll("\xa0", " ");
}
function _deserializeContent2(content) {
  return content.replaceAll(" ", "\xa0");
}
function _hasElementChanged2(serialized) {
  var _this$_initialData2 = this._initialData,
    value = _this$_initialData2.value,
    fontSize = _this$_initialData2.fontSize,
    color = _this$_initialData2.color,
    pageIndex = _this$_initialData2.pageIndex;
  return this._hasBeenMoved || serialized.value !== value || serialized.fontSize !== fontSize || serialized.color.some(function (c, i) {
    return c !== color[i];
  }) || serialized.pageIndex !== pageIndex;
}
Object.defineProperty(FreeTextEditor, _deserializeContent, {
  value: _deserializeContent2
});
Object.defineProperty(FreeTextEditor, _getNodeContent, {
  value: _getNodeContent2
});
FreeTextEditor._freeTextDefaultContent = "";
FreeTextEditor._internalPadding = 0;
FreeTextEditor._defaultColor = null;
FreeTextEditor._defaultFontSize = 10;
FreeTextEditor._type = "freetext";
FreeTextEditor._editorType = _AnnotationEditorType.FREETEXT;
; // ./src/display/editor/drawers/outline.js
var Outline = /*#__PURE__*/function () {
  function Outline() {
    _classCallCheck(this, Outline);
  }
  return _createClass(Outline, [{
    key: "toSVGPath",
    value: function toSVGPath() {
      unreachable("Abstract method `toSVGPath` must be implemented.");
    }
  }, {
    key: "box",
    get: function get() {
      unreachable("Abstract getter `box` must be implemented.");
    }
  }, {
    key: "serialize",
    value: function serialize(_bbox, _rotation) {
      unreachable("Abstract method `serialize` must be implemented.");
    }
  }, {
    key: "classNamesForDrawing",
    get: function get() {
      unreachable("Abstract getter `classNamesForDrawing` must be implemented.");
    }
  }, {
    key: "classNamesForOutlining",
    get: function get() {
      unreachable("Abstract getter `classNamesForOutlining` must be implemented.");
    }
  }, {
    key: "mustRemoveSelfIntersections",
    get: function get() {
      return false;
    }
  }]);
}();
; // ./src/display/editor/drawers/freedraw.js
var _box = /*#__PURE__*/_classPrivateFieldLooseKey("box");
var _bottom = /*#__PURE__*/_classPrivateFieldLooseKey("bottom");
var _innerMargin = /*#__PURE__*/_classPrivateFieldLooseKey("innerMargin");
var _isLTR = /*#__PURE__*/_classPrivateFieldLooseKey("isLTR");
var _top = /*#__PURE__*/_classPrivateFieldLooseKey("top");
var _last = /*#__PURE__*/_classPrivateFieldLooseKey("last");
var _lastX = /*#__PURE__*/_classPrivateFieldLooseKey("lastX");
var _lastY = /*#__PURE__*/_classPrivateFieldLooseKey("lastY");
var _min = /*#__PURE__*/_classPrivateFieldLooseKey("min");
var _min_dist = /*#__PURE__*/_classPrivateFieldLooseKey("min_dist");
var _scaleFactor = /*#__PURE__*/_classPrivateFieldLooseKey("scaleFactor");
var _thickness = /*#__PURE__*/_classPrivateFieldLooseKey("thickness");
var _points = /*#__PURE__*/_classPrivateFieldLooseKey("points");
var _MIN_DIST = /*#__PURE__*/_classPrivateFieldLooseKey("MIN_DIST");
var _MIN_DIFF = /*#__PURE__*/_classPrivateFieldLooseKey("MIN_DIFF");
var _MIN = /*#__PURE__*/_classPrivateFieldLooseKey("MIN");
var _getLastCoords = /*#__PURE__*/_classPrivateFieldLooseKey("getLastCoords");
var _toSVGPathTwoPoints = /*#__PURE__*/_classPrivateFieldLooseKey("toSVGPathTwoPoints");
var _toSVGPathStart = /*#__PURE__*/_classPrivateFieldLooseKey("toSVGPathStart");
var _toSVGPathEnd = /*#__PURE__*/_classPrivateFieldLooseKey("toSVGPathEnd");
var _getOutlineTwoPoints = /*#__PURE__*/_classPrivateFieldLooseKey("getOutlineTwoPoints");
var _getOutlineStart = /*#__PURE__*/_classPrivateFieldLooseKey("getOutlineStart");
var _getOutlineEnd = /*#__PURE__*/_classPrivateFieldLooseKey("getOutlineEnd");
var FreeDrawOutliner = /*#__PURE__*/function () {
  function FreeDrawOutliner(_ref150, box, scaleFactor, thickness, isLTR) {
    var _x34 = _ref150.x,
      _y2 = _ref150.y;
    var innerMargin = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    _classCallCheck(this, FreeDrawOutliner);
    Object.defineProperty(this, _getOutlineEnd, {
      value: _getOutlineEnd2
    });
    Object.defineProperty(this, _getOutlineStart, {
      value: _getOutlineStart2
    });
    Object.defineProperty(this, _getOutlineTwoPoints, {
      value: _getOutlineTwoPoints2
    });
    Object.defineProperty(this, _toSVGPathEnd, {
      value: _toSVGPathEnd2
    });
    Object.defineProperty(this, _toSVGPathStart, {
      value: _toSVGPathStart2
    });
    Object.defineProperty(this, _toSVGPathTwoPoints, {
      value: _toSVGPathTwoPoints2
    });
    Object.defineProperty(this, _getLastCoords, {
      value: _getLastCoords2
    });
    Object.defineProperty(this, _box, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _bottom, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _innerMargin, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _isLTR, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _top, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _last, {
      writable: true,
      value: new Float64Array(18)
    });
    Object.defineProperty(this, _lastX, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _lastY, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _min, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _min_dist, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _scaleFactor, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _thickness, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _points, {
      writable: true,
      value: []
    });
    _classPrivateFieldLooseBase(this, _box)[_box] = box;
    _classPrivateFieldLooseBase(this, _thickness)[_thickness] = thickness * scaleFactor;
    _classPrivateFieldLooseBase(this, _isLTR)[_isLTR] = isLTR;
    _classPrivateFieldLooseBase(this, _last)[_last].set([NaN, NaN, NaN, NaN, _x34, _y2], 6);
    _classPrivateFieldLooseBase(this, _innerMargin)[_innerMargin] = innerMargin;
    _classPrivateFieldLooseBase(this, _min_dist)[_min_dist] = _classPrivateFieldLooseBase(FreeDrawOutliner, _MIN_DIST)[_MIN_DIST] * scaleFactor;
    _classPrivateFieldLooseBase(this, _min)[_min] = _classPrivateFieldLooseBase(FreeDrawOutliner, _MIN)[_MIN] * scaleFactor;
    _classPrivateFieldLooseBase(this, _scaleFactor)[_scaleFactor] = scaleFactor;
    _classPrivateFieldLooseBase(this, _points)[_points].push(_x34, _y2);
  }
  return _createClass(FreeDrawOutliner, [{
    key: "isEmpty",
    value: function isEmpty() {
      return isNaN(_classPrivateFieldLooseBase(this, _last)[_last][8]);
    }
  }, {
    key: "add",
    value: function add(_ref151) {
      var _classPrivateFieldLoo81;
      var x = _ref151.x,
        y = _ref151.y;
      _classPrivateFieldLooseBase(this, _lastX)[_lastX] = x;
      _classPrivateFieldLooseBase(this, _lastY)[_lastY] = y;
      var _classPrivateFieldLoo78 = _slicedToArray(_classPrivateFieldLooseBase(this, _box)[_box], 4),
        layerX = _classPrivateFieldLoo78[0],
        layerY = _classPrivateFieldLoo78[1],
        layerWidth = _classPrivateFieldLoo78[2],
        layerHeight = _classPrivateFieldLoo78[3];
      var _classPrivateFieldLoo79 = _classPrivateFieldLooseBase(this, _last)[_last].subarray(8, 12),
        _classPrivateFieldLoo80 = _slicedToArray(_classPrivateFieldLoo79, 4),
        x1 = _classPrivateFieldLoo80[0],
        y1 = _classPrivateFieldLoo80[1],
        x2 = _classPrivateFieldLoo80[2],
        y2 = _classPrivateFieldLoo80[3];
      var diffX = x - x2;
      var diffY = y - y2;
      var d = Math.hypot(diffX, diffY);
      if (d < _classPrivateFieldLooseBase(this, _min)[_min]) {
        return false;
      }
      var diffD = d - _classPrivateFieldLooseBase(this, _min_dist)[_min_dist];
      var K = diffD / d;
      var shiftX = K * diffX;
      var shiftY = K * diffY;
      var x0 = x1;
      var y0 = y1;
      x1 = x2;
      y1 = y2;
      x2 += shiftX;
      y2 += shiftY;
      (_classPrivateFieldLoo81 = _classPrivateFieldLooseBase(this, _points)[_points]) === null || _classPrivateFieldLoo81 === void 0 || _classPrivateFieldLoo81.push(x, y);
      var nX = -shiftY / diffD;
      var nY = shiftX / diffD;
      var thX = nX * _classPrivateFieldLooseBase(this, _thickness)[_thickness];
      var thY = nY * _classPrivateFieldLooseBase(this, _thickness)[_thickness];
      _classPrivateFieldLooseBase(this, _last)[_last].set(_classPrivateFieldLooseBase(this, _last)[_last].subarray(2, 8), 0);
      _classPrivateFieldLooseBase(this, _last)[_last].set([x2 + thX, y2 + thY], 4);
      _classPrivateFieldLooseBase(this, _last)[_last].set(_classPrivateFieldLooseBase(this, _last)[_last].subarray(14, 18), 12);
      _classPrivateFieldLooseBase(this, _last)[_last].set([x2 - thX, y2 - thY], 16);
      if (isNaN(_classPrivateFieldLooseBase(this, _last)[_last][6])) {
        if (_classPrivateFieldLooseBase(this, _top)[_top].length === 0) {
          _classPrivateFieldLooseBase(this, _last)[_last].set([x1 + thX, y1 + thY], 2);
          _classPrivateFieldLooseBase(this, _top)[_top].push(NaN, NaN, NaN, NaN, (x1 + thX - layerX) / layerWidth, (y1 + thY - layerY) / layerHeight);
          _classPrivateFieldLooseBase(this, _last)[_last].set([x1 - thX, y1 - thY], 14);
          _classPrivateFieldLooseBase(this, _bottom)[_bottom].push(NaN, NaN, NaN, NaN, (x1 - thX - layerX) / layerWidth, (y1 - thY - layerY) / layerHeight);
        }
        _classPrivateFieldLooseBase(this, _last)[_last].set([x0, y0, x1, y1, x2, y2], 6);
        return !this.isEmpty();
      }
      _classPrivateFieldLooseBase(this, _last)[_last].set([x0, y0, x1, y1, x2, y2], 6);
      var angle = Math.abs(Math.atan2(y0 - y1, x0 - x1) - Math.atan2(shiftY, shiftX));
      if (angle < Math.PI / 2) {
        var _classPrivateFieldLoo82 = _classPrivateFieldLooseBase(this, _last)[_last].subarray(2, 6);
        var _classPrivateFieldLoo83 = _slicedToArray(_classPrivateFieldLoo82, 4);
        x1 = _classPrivateFieldLoo83[0];
        y1 = _classPrivateFieldLoo83[1];
        x2 = _classPrivateFieldLoo83[2];
        y2 = _classPrivateFieldLoo83[3];
        _classPrivateFieldLooseBase(this, _top)[_top].push(NaN, NaN, NaN, NaN, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        var _classPrivateFieldLoo84 = _classPrivateFieldLooseBase(this, _last)[_last].subarray(14, 18);
        var _classPrivateFieldLoo85 = _slicedToArray(_classPrivateFieldLoo84, 4);
        x1 = _classPrivateFieldLoo85[0];
        y1 = _classPrivateFieldLoo85[1];
        x0 = _classPrivateFieldLoo85[2];
        y0 = _classPrivateFieldLoo85[3];
        _classPrivateFieldLooseBase(this, _bottom)[_bottom].push(NaN, NaN, NaN, NaN, ((x0 + x1) / 2 - layerX) / layerWidth, ((y0 + y1) / 2 - layerY) / layerHeight);
        return true;
      }
      var _classPrivateFieldLoo86 = _classPrivateFieldLooseBase(this, _last)[_last].subarray(0, 6);
      var _classPrivateFieldLoo87 = _slicedToArray(_classPrivateFieldLoo86, 6);
      x0 = _classPrivateFieldLoo87[0];
      y0 = _classPrivateFieldLoo87[1];
      x1 = _classPrivateFieldLoo87[2];
      y1 = _classPrivateFieldLoo87[3];
      x2 = _classPrivateFieldLoo87[4];
      y2 = _classPrivateFieldLoo87[5];
      _classPrivateFieldLooseBase(this, _top)[_top].push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
      var _classPrivateFieldLoo88 = _classPrivateFieldLooseBase(this, _last)[_last].subarray(12, 18);
      var _classPrivateFieldLoo89 = _slicedToArray(_classPrivateFieldLoo88, 6);
      x2 = _classPrivateFieldLoo89[0];
      y2 = _classPrivateFieldLoo89[1];
      x1 = _classPrivateFieldLoo89[2];
      y1 = _classPrivateFieldLoo89[3];
      x0 = _classPrivateFieldLoo89[4];
      y0 = _classPrivateFieldLoo89[5];
      _classPrivateFieldLooseBase(this, _bottom)[_bottom].push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
      return true;
    }
  }, {
    key: "toSVGPath",
    value: function toSVGPath() {
      if (this.isEmpty()) {
        return "";
      }
      var top = _classPrivateFieldLooseBase(this, _top)[_top];
      var bottom = _classPrivateFieldLooseBase(this, _bottom)[_bottom];
      if (isNaN(_classPrivateFieldLooseBase(this, _last)[_last][6]) && !this.isEmpty()) {
        return _classPrivateFieldLooseBase(this, _toSVGPathTwoPoints)[_toSVGPathTwoPoints]();
      }
      var buffer = [];
      buffer.push("M".concat(top[4], " ").concat(top[5]));
      for (var i = 6; i < top.length; i += 6) {
        if (isNaN(top[i])) {
          buffer.push("L".concat(top[i + 4], " ").concat(top[i + 5]));
        } else {
          buffer.push("C".concat(top[i], " ").concat(top[i + 1], " ").concat(top[i + 2], " ").concat(top[i + 3], " ").concat(top[i + 4], " ").concat(top[i + 5]));
        }
      }
      _classPrivateFieldLooseBase(this, _toSVGPathEnd)[_toSVGPathEnd](buffer);
      for (var _i24 = bottom.length - 6; _i24 >= 6; _i24 -= 6) {
        if (isNaN(bottom[_i24])) {
          buffer.push("L".concat(bottom[_i24 + 4], " ").concat(bottom[_i24 + 5]));
        } else {
          buffer.push("C".concat(bottom[_i24], " ").concat(bottom[_i24 + 1], " ").concat(bottom[_i24 + 2], " ").concat(bottom[_i24 + 3], " ").concat(bottom[_i24 + 4], " ").concat(bottom[_i24 + 5]));
        }
      }
      _classPrivateFieldLooseBase(this, _toSVGPathStart)[_toSVGPathStart](buffer);
      return buffer.join(" ");
    }
  }, {
    key: "newFreeDrawOutline",
    value: function newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
      return new FreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
  }, {
    key: "getOutlines",
    value: function getOutlines() {
      var _classPrivateFieldLoo91, _classPrivateFieldLoo92;
      var top = _classPrivateFieldLooseBase(this, _top)[_top];
      var bottom = _classPrivateFieldLooseBase(this, _bottom)[_bottom];
      var last = _classPrivateFieldLooseBase(this, _last)[_last];
      var _classPrivateFieldLoo90 = _slicedToArray(_classPrivateFieldLooseBase(this, _box)[_box], 4),
        layerX = _classPrivateFieldLoo90[0],
        layerY = _classPrivateFieldLoo90[1],
        layerWidth = _classPrivateFieldLoo90[2],
        layerHeight = _classPrivateFieldLoo90[3];
      var points = new Float64Array(((_classPrivateFieldLoo91 = (_classPrivateFieldLoo92 = _classPrivateFieldLooseBase(this, _points)[_points]) === null || _classPrivateFieldLoo92 === void 0 ? void 0 : _classPrivateFieldLoo92.length) !== null && _classPrivateFieldLoo91 !== void 0 ? _classPrivateFieldLoo91 : 0) + 2);
      for (var i = 0, ii = points.length - 2; i < ii; i += 2) {
        points[i] = (_classPrivateFieldLooseBase(this, _points)[_points][i] - layerX) / layerWidth;
        points[i + 1] = (_classPrivateFieldLooseBase(this, _points)[_points][i + 1] - layerY) / layerHeight;
      }
      points[points.length - 2] = (_classPrivateFieldLooseBase(this, _lastX)[_lastX] - layerX) / layerWidth;
      points[points.length - 1] = (_classPrivateFieldLooseBase(this, _lastY)[_lastY] - layerY) / layerHeight;
      if (isNaN(last[6]) && !this.isEmpty()) {
        return _classPrivateFieldLooseBase(this, _getOutlineTwoPoints)[_getOutlineTwoPoints](points);
      }
      var outline = new Float64Array(_classPrivateFieldLooseBase(this, _top)[_top].length + 24 + _classPrivateFieldLooseBase(this, _bottom)[_bottom].length);
      var N = top.length;
      for (var _i25 = 0; _i25 < N; _i25 += 2) {
        if (isNaN(top[_i25])) {
          outline[_i25] = outline[_i25 + 1] = NaN;
          continue;
        }
        outline[_i25] = top[_i25];
        outline[_i25 + 1] = top[_i25 + 1];
      }
      N = _classPrivateFieldLooseBase(this, _getOutlineEnd)[_getOutlineEnd](outline, N);
      for (var _i26 = bottom.length - 6; _i26 >= 6; _i26 -= 6) {
        for (var j = 0; j < 6; j += 2) {
          if (isNaN(bottom[_i26 + j])) {
            outline[N] = outline[N + 1] = NaN;
            N += 2;
            continue;
          }
          outline[N] = bottom[_i26 + j];
          outline[N + 1] = bottom[_i26 + j + 1];
          N += 2;
        }
      }
      _classPrivateFieldLooseBase(this, _getOutlineStart)[_getOutlineStart](outline, N);
      return this.newFreeDrawOutline(outline, points, _classPrivateFieldLooseBase(this, _box)[_box], _classPrivateFieldLooseBase(this, _scaleFactor)[_scaleFactor], _classPrivateFieldLooseBase(this, _innerMargin)[_innerMargin], _classPrivateFieldLooseBase(this, _isLTR)[_isLTR]);
    }
  }]);
}();
_FreeDrawOutliner = FreeDrawOutliner;
function _getLastCoords2() {
  var lastTop = _classPrivateFieldLooseBase(this, _last)[_last].subarray(4, 6);
  var lastBottom = _classPrivateFieldLooseBase(this, _last)[_last].subarray(16, 18);
  var _classPrivateFieldLoo146 = _slicedToArray(_classPrivateFieldLooseBase(this, _box)[_box], 4),
    x = _classPrivateFieldLoo146[0],
    y = _classPrivateFieldLoo146[1],
    width = _classPrivateFieldLoo146[2],
    height = _classPrivateFieldLoo146[3];
  return [(_classPrivateFieldLooseBase(this, _lastX)[_lastX] + (lastTop[0] - lastBottom[0]) / 2 - x) / width, (_classPrivateFieldLooseBase(this, _lastY)[_lastY] + (lastTop[1] - lastBottom[1]) / 2 - y) / height, (_classPrivateFieldLooseBase(this, _lastX)[_lastX] + (lastBottom[0] - lastTop[0]) / 2 - x) / width, (_classPrivateFieldLooseBase(this, _lastY)[_lastY] + (lastBottom[1] - lastTop[1]) / 2 - y) / height];
}
function _toSVGPathTwoPoints2() {
  var _classPrivateFieldLoo147 = _slicedToArray(_classPrivateFieldLooseBase(this, _box)[_box], 4),
    x = _classPrivateFieldLoo147[0],
    y = _classPrivateFieldLoo147[1],
    width = _classPrivateFieldLoo147[2],
    height = _classPrivateFieldLoo147[3];
  var _classPrivateFieldLoo148 = _classPrivateFieldLooseBase(this, _getLastCoords)[_getLastCoords](),
    _classPrivateFieldLoo149 = _slicedToArray(_classPrivateFieldLoo148, 4),
    lastTopX = _classPrivateFieldLoo149[0],
    lastTopY = _classPrivateFieldLoo149[1],
    lastBottomX = _classPrivateFieldLoo149[2],
    lastBottomY = _classPrivateFieldLoo149[3];
  return "M".concat((_classPrivateFieldLooseBase(this, _last)[_last][2] - x) / width, " ").concat((_classPrivateFieldLooseBase(this, _last)[_last][3] - y) / height, " L").concat((_classPrivateFieldLooseBase(this, _last)[_last][4] - x) / width, " ").concat((_classPrivateFieldLooseBase(this, _last)[_last][5] - y) / height, " L").concat(lastTopX, " ").concat(lastTopY, " L").concat(lastBottomX, " ").concat(lastBottomY, " L").concat((_classPrivateFieldLooseBase(this, _last)[_last][16] - x) / width, " ").concat((_classPrivateFieldLooseBase(this, _last)[_last][17] - y) / height, " L").concat((_classPrivateFieldLooseBase(this, _last)[_last][14] - x) / width, " ").concat((_classPrivateFieldLooseBase(this, _last)[_last][15] - y) / height, " Z");
}
function _toSVGPathStart2(buffer) {
  var bottom = _classPrivateFieldLooseBase(this, _bottom)[_bottom];
  buffer.push("L".concat(bottom[4], " ").concat(bottom[5], " Z"));
}
function _toSVGPathEnd2(buffer) {
  var _classPrivateFieldLoo150 = _slicedToArray(_classPrivateFieldLooseBase(this, _box)[_box], 4),
    x = _classPrivateFieldLoo150[0],
    y = _classPrivateFieldLoo150[1],
    width = _classPrivateFieldLoo150[2],
    height = _classPrivateFieldLoo150[3];
  var lastTop = _classPrivateFieldLooseBase(this, _last)[_last].subarray(4, 6);
  var lastBottom = _classPrivateFieldLooseBase(this, _last)[_last].subarray(16, 18);
  var _classPrivateFieldLoo151 = _classPrivateFieldLooseBase(this, _getLastCoords)[_getLastCoords](),
    _classPrivateFieldLoo152 = _slicedToArray(_classPrivateFieldLoo151, 4),
    lastTopX = _classPrivateFieldLoo152[0],
    lastTopY = _classPrivateFieldLoo152[1],
    lastBottomX = _classPrivateFieldLoo152[2],
    lastBottomY = _classPrivateFieldLoo152[3];
  buffer.push("L".concat((lastTop[0] - x) / width, " ").concat((lastTop[1] - y) / height, " L").concat(lastTopX, " ").concat(lastTopY, " L").concat(lastBottomX, " ").concat(lastBottomY, " L").concat((lastBottom[0] - x) / width, " ").concat((lastBottom[1] - y) / height));
}
function _getOutlineTwoPoints2(points) {
  var last = _classPrivateFieldLooseBase(this, _last)[_last];
  var _classPrivateFieldLoo153 = _slicedToArray(_classPrivateFieldLooseBase(this, _box)[_box], 4),
    layerX = _classPrivateFieldLoo153[0],
    layerY = _classPrivateFieldLoo153[1],
    layerWidth = _classPrivateFieldLoo153[2],
    layerHeight = _classPrivateFieldLoo153[3];
  var _classPrivateFieldLoo154 = _classPrivateFieldLooseBase(this, _getLastCoords)[_getLastCoords](),
    _classPrivateFieldLoo155 = _slicedToArray(_classPrivateFieldLoo154, 4),
    lastTopX = _classPrivateFieldLoo155[0],
    lastTopY = _classPrivateFieldLoo155[1],
    lastBottomX = _classPrivateFieldLoo155[2],
    lastBottomY = _classPrivateFieldLoo155[3];
  var outline = new Float64Array(36);
  outline.set([NaN, NaN, NaN, NaN, (last[2] - layerX) / layerWidth, (last[3] - layerY) / layerHeight, NaN, NaN, NaN, NaN, (last[4] - layerX) / layerWidth, (last[5] - layerY) / layerHeight, NaN, NaN, NaN, NaN, lastTopX, lastTopY, NaN, NaN, NaN, NaN, lastBottomX, lastBottomY, NaN, NaN, NaN, NaN, (last[16] - layerX) / layerWidth, (last[17] - layerY) / layerHeight, NaN, NaN, NaN, NaN, (last[14] - layerX) / layerWidth, (last[15] - layerY) / layerHeight], 0);
  return this.newFreeDrawOutline(outline, points, _classPrivateFieldLooseBase(this, _box)[_box], _classPrivateFieldLooseBase(this, _scaleFactor)[_scaleFactor], _classPrivateFieldLooseBase(this, _innerMargin)[_innerMargin], _classPrivateFieldLooseBase(this, _isLTR)[_isLTR]);
}
function _getOutlineStart2(outline, pos) {
  var bottom = _classPrivateFieldLooseBase(this, _bottom)[_bottom];
  outline.set([NaN, NaN, NaN, NaN, bottom[4], bottom[5]], pos);
  return pos += 6;
}
function _getOutlineEnd2(outline, pos) {
  var lastTop = _classPrivateFieldLooseBase(this, _last)[_last].subarray(4, 6);
  var lastBottom = _classPrivateFieldLooseBase(this, _last)[_last].subarray(16, 18);
  var _classPrivateFieldLoo156 = _slicedToArray(_classPrivateFieldLooseBase(this, _box)[_box], 4),
    layerX = _classPrivateFieldLoo156[0],
    layerY = _classPrivateFieldLoo156[1],
    layerWidth = _classPrivateFieldLoo156[2],
    layerHeight = _classPrivateFieldLoo156[3];
  var _classPrivateFieldLoo157 = _classPrivateFieldLooseBase(this, _getLastCoords)[_getLastCoords](),
    _classPrivateFieldLoo158 = _slicedToArray(_classPrivateFieldLoo157, 4),
    lastTopX = _classPrivateFieldLoo158[0],
    lastTopY = _classPrivateFieldLoo158[1],
    lastBottomX = _classPrivateFieldLoo158[2],
    lastBottomY = _classPrivateFieldLoo158[3];
  outline.set([NaN, NaN, NaN, NaN, (lastTop[0] - layerX) / layerWidth, (lastTop[1] - layerY) / layerHeight, NaN, NaN, NaN, NaN, lastTopX, lastTopY, NaN, NaN, NaN, NaN, lastBottomX, lastBottomY, NaN, NaN, NaN, NaN, (lastBottom[0] - layerX) / layerWidth, (lastBottom[1] - layerY) / layerHeight], pos);
  return pos += 24;
}
Object.defineProperty(FreeDrawOutliner, _MIN_DIST, {
  writable: true,
  value: 8
});
Object.defineProperty(FreeDrawOutliner, _MIN_DIFF, {
  writable: true,
  value: 2
});
Object.defineProperty(FreeDrawOutliner, _MIN, {
  writable: true,
  value: _classPrivateFieldLooseBase(_FreeDrawOutliner, _MIN_DIST)[_MIN_DIST] + _classPrivateFieldLooseBase(_FreeDrawOutliner, _MIN_DIFF)[_MIN_DIFF]
});
var _box2 = /*#__PURE__*/_classPrivateFieldLooseKey("box");
var _bbox2 = /*#__PURE__*/_classPrivateFieldLooseKey("bbox");
var _innerMargin2 = /*#__PURE__*/_classPrivateFieldLooseKey("innerMargin");
var _isLTR2 = /*#__PURE__*/_classPrivateFieldLooseKey("isLTR");
var _points2 = /*#__PURE__*/_classPrivateFieldLooseKey("points");
var _scaleFactor2 = /*#__PURE__*/_classPrivateFieldLooseKey("scaleFactor");
var _outline = /*#__PURE__*/_classPrivateFieldLooseKey("outline");
var _rescale = /*#__PURE__*/_classPrivateFieldLooseKey("rescale");
var _rescaleAndSwap = /*#__PURE__*/_classPrivateFieldLooseKey("rescaleAndSwap");
var _computeMinMax = /*#__PURE__*/_classPrivateFieldLooseKey("computeMinMax");
var FreeDrawOutline = /*#__PURE__*/function (_Outline) {
  function FreeDrawOutline(_outline2, points, box, scaleFactor, innerMargin, _isLTR3) {
    var _this81;
    _classCallCheck(this, FreeDrawOutline);
    _this81 = _callSuper(this, FreeDrawOutline);
    Object.defineProperty(_this81, _computeMinMax, {
      value: _computeMinMax2
    });
    Object.defineProperty(_this81, _rescaleAndSwap, {
      value: _rescaleAndSwap2
    });
    Object.defineProperty(_this81, _rescale, {
      value: _rescale2
    });
    Object.defineProperty(_this81, _box2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this81, _bbox2, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this81, _innerMargin2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this81, _isLTR2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this81, _points2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this81, _scaleFactor2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this81, _outline, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(_this81, _outline)[_outline] = _outline2;
    _classPrivateFieldLooseBase(_this81, _points2)[_points2] = points;
    _classPrivateFieldLooseBase(_this81, _box2)[_box2] = box;
    _classPrivateFieldLooseBase(_this81, _scaleFactor2)[_scaleFactor2] = scaleFactor;
    _classPrivateFieldLooseBase(_this81, _innerMargin2)[_innerMargin2] = innerMargin;
    _classPrivateFieldLooseBase(_this81, _isLTR2)[_isLTR2] = _isLTR3;
    _classPrivateFieldLooseBase(_this81, _computeMinMax)[_computeMinMax](_isLTR3);
    var _classPrivateFieldLoo93 = _classPrivateFieldLooseBase(_this81, _bbox2)[_bbox2],
      _x35 = _classPrivateFieldLoo93.x,
      _y3 = _classPrivateFieldLoo93.y,
      _width3 = _classPrivateFieldLoo93.width,
      _height3 = _classPrivateFieldLoo93.height;
    for (var i = 0, ii = _outline2.length; i < ii; i += 2) {
      _outline2[i] = (_outline2[i] - _x35) / _width3;
      _outline2[i + 1] = (_outline2[i + 1] - _y3) / _height3;
    }
    for (var _i27 = 0, _ii4 = points.length; _i27 < _ii4; _i27 += 2) {
      points[_i27] = (points[_i27] - _x35) / _width3;
      points[_i27 + 1] = (points[_i27 + 1] - _y3) / _height3;
    }
    return _this81;
  }
  _inherits(FreeDrawOutline, _Outline);
  return _createClass(FreeDrawOutline, [{
    key: "toSVGPath",
    value: function toSVGPath() {
      var buffer = ["M".concat(_classPrivateFieldLooseBase(this, _outline)[_outline][4], " ").concat(_classPrivateFieldLooseBase(this, _outline)[_outline][5])];
      for (var i = 6, ii = _classPrivateFieldLooseBase(this, _outline)[_outline].length; i < ii; i += 6) {
        if (isNaN(_classPrivateFieldLooseBase(this, _outline)[_outline][i])) {
          buffer.push("L".concat(_classPrivateFieldLooseBase(this, _outline)[_outline][i + 4], " ").concat(_classPrivateFieldLooseBase(this, _outline)[_outline][i + 5]));
          continue;
        }
        buffer.push("C".concat(_classPrivateFieldLooseBase(this, _outline)[_outline][i], " ").concat(_classPrivateFieldLooseBase(this, _outline)[_outline][i + 1], " ").concat(_classPrivateFieldLooseBase(this, _outline)[_outline][i + 2], " ").concat(_classPrivateFieldLooseBase(this, _outline)[_outline][i + 3], " ").concat(_classPrivateFieldLooseBase(this, _outline)[_outline][i + 4], " ").concat(_classPrivateFieldLooseBase(this, _outline)[_outline][i + 5]));
      }
      buffer.push("Z");
      return buffer.join(" ");
    }
  }, {
    key: "serialize",
    value: function serialize(_ref152, rotation) {
      var _ref153 = _slicedToArray(_ref152, 4),
        blX = _ref153[0],
        blY = _ref153[1],
        trX = _ref153[2],
        trY = _ref153[3];
      var width = trX - blX;
      var height = trY - blY;
      var outline;
      var points;
      switch (rotation) {
        case 0:
          outline = _classPrivateFieldLooseBase(this, _rescale)[_rescale](_classPrivateFieldLooseBase(this, _outline)[_outline], blX, trY, width, -height);
          points = _classPrivateFieldLooseBase(this, _rescale)[_rescale](_classPrivateFieldLooseBase(this, _points2)[_points2], blX, trY, width, -height);
          break;
        case 90:
          outline = _classPrivateFieldLooseBase(this, _rescaleAndSwap)[_rescaleAndSwap](_classPrivateFieldLooseBase(this, _outline)[_outline], blX, blY, width, height);
          points = _classPrivateFieldLooseBase(this, _rescaleAndSwap)[_rescaleAndSwap](_classPrivateFieldLooseBase(this, _points2)[_points2], blX, blY, width, height);
          break;
        case 180:
          outline = _classPrivateFieldLooseBase(this, _rescale)[_rescale](_classPrivateFieldLooseBase(this, _outline)[_outline], trX, blY, -width, height);
          points = _classPrivateFieldLooseBase(this, _rescale)[_rescale](_classPrivateFieldLooseBase(this, _points2)[_points2], trX, blY, -width, height);
          break;
        case 270:
          outline = _classPrivateFieldLooseBase(this, _rescaleAndSwap)[_rescaleAndSwap](_classPrivateFieldLooseBase(this, _outline)[_outline], trX, trY, -width, -height);
          points = _classPrivateFieldLooseBase(this, _rescaleAndSwap)[_rescaleAndSwap](_classPrivateFieldLooseBase(this, _points2)[_points2], trX, trY, -width, -height);
          break;
      }
      return {
        outline: Array.from(outline),
        points: [Array.from(points)]
      };
    }
  }, {
    key: "box",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _bbox2)[_bbox2];
    }
  }, {
    key: "newOutliner",
    value: function newOutliner(point, box, scaleFactor, thickness, isLTR) {
      var innerMargin = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
      return new FreeDrawOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
  }, {
    key: "getNewOutline",
    value: function getNewOutline(thickness, innerMargin) {
      var _classPrivateFieldLoo94 = _classPrivateFieldLooseBase(this, _bbox2)[_bbox2],
        x = _classPrivateFieldLoo94.x,
        y = _classPrivateFieldLoo94.y,
        width = _classPrivateFieldLoo94.width,
        height = _classPrivateFieldLoo94.height;
      var _classPrivateFieldLoo95 = _slicedToArray(_classPrivateFieldLooseBase(this, _box2)[_box2], 4),
        layerX = _classPrivateFieldLoo95[0],
        layerY = _classPrivateFieldLoo95[1],
        layerWidth = _classPrivateFieldLoo95[2],
        layerHeight = _classPrivateFieldLoo95[3];
      var sx = width * layerWidth;
      var sy = height * layerHeight;
      var tx = x * layerWidth + layerX;
      var ty = y * layerHeight + layerY;
      var outliner = this.newOutliner({
        x: _classPrivateFieldLooseBase(this, _points2)[_points2][0] * sx + tx,
        y: _classPrivateFieldLooseBase(this, _points2)[_points2][1] * sy + ty
      }, _classPrivateFieldLooseBase(this, _box2)[_box2], _classPrivateFieldLooseBase(this, _scaleFactor2)[_scaleFactor2], thickness, _classPrivateFieldLooseBase(this, _isLTR2)[_isLTR2], innerMargin !== null && innerMargin !== void 0 ? innerMargin : _classPrivateFieldLooseBase(this, _innerMargin2)[_innerMargin2]);
      for (var i = 2; i < _classPrivateFieldLooseBase(this, _points2)[_points2].length; i += 2) {
        outliner.add({
          x: _classPrivateFieldLooseBase(this, _points2)[_points2][i] * sx + tx,
          y: _classPrivateFieldLooseBase(this, _points2)[_points2][i + 1] * sy + ty
        });
      }
      return outliner.getOutlines();
    }
  }, {
    key: "mustRemoveSelfIntersections",
    get: function get() {
      return true;
    }
  }]);
}(Outline);
function _rescale2(src, tx, ty, sx, sy) {
  var dest = new Float64Array(src.length);
  for (var i = 0, ii = src.length; i < ii; i += 2) {
    dest[i] = tx + src[i] * sx;
    dest[i + 1] = ty + src[i + 1] * sy;
  }
  return dest;
}
function _rescaleAndSwap2(src, tx, ty, sx, sy) {
  var dest = new Float64Array(src.length);
  for (var i = 0, ii = src.length; i < ii; i += 2) {
    dest[i] = tx + src[i + 1] * sx;
    dest[i + 1] = ty + src[i] * sy;
  }
  return dest;
}
function _computeMinMax2(isLTR) {
  var outline = _classPrivateFieldLooseBase(this, _outline)[_outline];
  var lastX = outline[4];
  var lastY = outline[5];
  var minX = lastX;
  var minY = lastY;
  var maxX = lastX;
  var maxY = lastY;
  var lastPointX = lastX;
  var lastPointY = lastY;
  var ltrCallback = isLTR ? Math.max : Math.min;
  for (var i = 6, ii = outline.length; i < ii; i += 6) {
    if (isNaN(outline[i])) {
      minX = Math.min(minX, outline[i + 4]);
      minY = Math.min(minY, outline[i + 5]);
      maxX = Math.max(maxX, outline[i + 4]);
      maxY = Math.max(maxY, outline[i + 5]);
      if (lastPointY < outline[i + 5]) {
        lastPointX = outline[i + 4];
        lastPointY = outline[i + 5];
      } else if (lastPointY === outline[i + 5]) {
        lastPointX = ltrCallback(lastPointX, outline[i + 4]);
      }
    } else {
      var bbox = _Util.bezierBoundingBox.apply(_Util, [lastX, lastY].concat(_toConsumableArray(outline.slice(i, i + 6))));
      minX = Math.min(minX, bbox[0]);
      minY = Math.min(minY, bbox[1]);
      maxX = Math.max(maxX, bbox[2]);
      maxY = Math.max(maxY, bbox[3]);
      if (lastPointY < bbox[3]) {
        lastPointX = bbox[2];
        lastPointY = bbox[3];
      } else if (lastPointY === bbox[3]) {
        lastPointX = ltrCallback(lastPointX, bbox[2]);
      }
    }
    lastX = outline[i + 4];
    lastY = outline[i + 5];
  }
  var x = minX - _classPrivateFieldLooseBase(this, _innerMargin2)[_innerMargin2],
    y = minY - _classPrivateFieldLooseBase(this, _innerMargin2)[_innerMargin2],
    width = maxX - minX + 2 * _classPrivateFieldLooseBase(this, _innerMargin2)[_innerMargin2],
    height = maxY - minY + 2 * _classPrivateFieldLooseBase(this, _innerMargin2)[_innerMargin2];
  _classPrivateFieldLooseBase(this, _bbox2)[_bbox2] = {
    x: x,
    y: y,
    width: width,
    height: height,
    lastPoint: [lastPointX, lastPointY]
  };
}
; // ./src/display/editor/drawers/highlight.js
var _box3 = /*#__PURE__*/_classPrivateFieldLooseKey("box");
var _verticalEdges = /*#__PURE__*/_classPrivateFieldLooseKey("verticalEdges");
var _intervals = /*#__PURE__*/_classPrivateFieldLooseKey("intervals");
var _getOutlines = /*#__PURE__*/_classPrivateFieldLooseKey("getOutlines");
var _binarySearch = /*#__PURE__*/_classPrivateFieldLooseKey("binarySearch");
var _insert = /*#__PURE__*/_classPrivateFieldLooseKey("insert");
var _remove = /*#__PURE__*/_classPrivateFieldLooseKey("remove");
var _breakEdge = /*#__PURE__*/_classPrivateFieldLooseKey("breakEdge");
var HighlightOutliner = /*#__PURE__*/function () {
  function HighlightOutliner(boxes) {
    var borderWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var innerMargin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var isLTR = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    _classCallCheck(this, HighlightOutliner);
    Object.defineProperty(this, _breakEdge, {
      value: _breakEdge2
    });
    Object.defineProperty(this, _remove, {
      value: _remove2
    });
    Object.defineProperty(this, _insert, {
      value: _insert2
    });
    Object.defineProperty(this, _binarySearch, {
      value: _binarySearch2
    });
    Object.defineProperty(this, _getOutlines, {
      value: _getOutlines2
    });
    Object.defineProperty(this, _box3, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _verticalEdges, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _intervals, {
      writable: true,
      value: []
    });
    var minX = Infinity;
    var maxX = -Infinity;
    var minY = Infinity;
    var maxY = -Infinity;
    var NUMBER_OF_DIGITS = 4;
    var EPSILON = Math.pow(10, -NUMBER_OF_DIGITS);
    var _iterator139 = _createForOfIteratorHelper(boxes),
      _step139;
    try {
      for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
        var _ref154 = _step139.value;
        var x = _ref154.x;
        var y = _ref154.y;
        var width = _ref154.width;
        var height = _ref154.height;
        var x1 = Math.floor((x - borderWidth) / EPSILON) * EPSILON;
        var x2 = Math.ceil((x + width + borderWidth) / EPSILON) * EPSILON;
        var y1 = Math.floor((y - borderWidth) / EPSILON) * EPSILON;
        var y2 = Math.ceil((y + height + borderWidth) / EPSILON) * EPSILON;
        var left = [x1, y1, y2, true];
        var right = [x2, y1, y2, false];
        _classPrivateFieldLooseBase(this, _verticalEdges)[_verticalEdges].push(left, right);
        minX = Math.min(minX, x1);
        maxX = Math.max(maxX, x2);
        minY = Math.min(minY, y1);
        maxY = Math.max(maxY, y2);
      }
    } catch (err) {
      _iterator139.e(err);
    } finally {
      _iterator139.f();
    }
    var bboxWidth = maxX - minX + 2 * innerMargin;
    var bboxHeight = maxY - minY + 2 * innerMargin;
    var shiftedMinX = minX - innerMargin;
    var shiftedMinY = minY - innerMargin;
    var lastEdge = _classPrivateFieldLooseBase(this, _verticalEdges)[_verticalEdges].at(isLTR ? -1 : -2);
    var lastPoint = [lastEdge[0], lastEdge[2]];
    var _iterator140 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _verticalEdges)[_verticalEdges]),
      _step140;
    try {
      for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
        var edge = _step140.value;
        var _edge = _slicedToArray(edge, 3),
          _x36 = _edge[0],
          _y4 = _edge[1],
          _y5 = _edge[2];
        edge[0] = (_x36 - shiftedMinX) / bboxWidth;
        edge[1] = (_y4 - shiftedMinY) / bboxHeight;
        edge[2] = (_y5 - shiftedMinY) / bboxHeight;
      }
    } catch (err) {
      _iterator140.e(err);
    } finally {
      _iterator140.f();
    }
    _classPrivateFieldLooseBase(this, _box3)[_box3] = {
      x: shiftedMinX,
      y: shiftedMinY,
      width: bboxWidth,
      height: bboxHeight,
      lastPoint: lastPoint
    };
  }
  return _createClass(HighlightOutliner, [{
    key: "getOutlines",
    value: function getOutlines() {
      _classPrivateFieldLooseBase(this, _verticalEdges)[_verticalEdges].sort(function (a, b) {
        return a[0] - b[0] || a[1] - b[1] || a[2] - b[2];
      });
      var outlineVerticalEdges = [];
      var _iterator141 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _verticalEdges)[_verticalEdges]),
        _step141;
      try {
        for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
          var edge = _step141.value;
          if (edge[3]) {
            outlineVerticalEdges.push.apply(outlineVerticalEdges, _toConsumableArray(_classPrivateFieldLooseBase(this, _breakEdge)[_breakEdge](edge)));
            _classPrivateFieldLooseBase(this, _insert)[_insert](edge);
          } else {
            _classPrivateFieldLooseBase(this, _remove)[_remove](edge);
            outlineVerticalEdges.push.apply(outlineVerticalEdges, _toConsumableArray(_classPrivateFieldLooseBase(this, _breakEdge)[_breakEdge](edge)));
          }
        }
      } catch (err) {
        _iterator141.e(err);
      } finally {
        _iterator141.f();
      }
      return _classPrivateFieldLooseBase(this, _getOutlines)[_getOutlines](outlineVerticalEdges);
    }
  }]);
}();
function _getOutlines2(outlineVerticalEdges) {
  var edges = [];
  var allEdges = new Set();
  var _iterator175 = _createForOfIteratorHelper(outlineVerticalEdges),
    _step175;
  try {
    for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
      var _edge5 = _step175.value;
      var _edge6 = _slicedToArray(_edge5, 3),
        _x53 = _edge6[0],
        _y6 = _edge6[1],
        _y7 = _edge6[2];
      edges.push([_x53, _y6, _edge5], [_x53, _y7, _edge5]);
    }
  } catch (err) {
    _iterator175.e(err);
  } finally {
    _iterator175.f();
  }
  edges.sort(function (a, b) {
    return a[1] - b[1] || a[0] - b[0];
  });
  for (var i = 0, ii = edges.length; i < ii; i += 2) {
    var edge1 = edges[i][2];
    var edge2 = edges[i + 1][2];
    edge1.push(edge2);
    edge2.push(edge1);
    allEdges.add(edge1);
    allEdges.add(edge2);
  }
  var outlines = [];
  var outline;
  while (allEdges.size > 0) {
    var edge = allEdges.values().next().value;
    var _edge2 = _slicedToArray(edge, 5),
      x = _edge2[0],
      y1 = _edge2[1],
      y2 = _edge2[2],
      _edge3 = _edge2[3],
      _edge4 = _edge2[4];
    allEdges.delete(edge);
    var lastPointX = x;
    var lastPointY = y1;
    outline = [x, y2];
    outlines.push(outline);
    while (true) {
      var e = void 0;
      if (allEdges.has(_edge3)) {
        e = _edge3;
      } else if (allEdges.has(_edge4)) {
        e = _edge4;
      } else {
        break;
      }
      allEdges.delete(e);
      var _e2 = e;
      var _e3 = _slicedToArray(_e2, 5);
      x = _e3[0];
      y1 = _e3[1];
      y2 = _e3[2];
      _edge3 = _e3[3];
      _edge4 = _e3[4];
      if (lastPointX !== x) {
        outline.push(lastPointX, lastPointY, x, lastPointY === y1 ? y1 : y2);
        lastPointX = x;
      }
      lastPointY = lastPointY === y1 ? y2 : y1;
    }
    outline.push(lastPointX, lastPointY);
  }
  return new HighlightOutline(outlines, _classPrivateFieldLooseBase(this, _box3)[_box3]);
}
function _binarySearch2(y) {
  var array = _classPrivateFieldLooseBase(this, _intervals)[_intervals];
  var start = 0;
  var end = array.length - 1;
  while (start <= end) {
    var middle = start + end >> 1;
    var y1 = array[middle][0];
    if (y1 === y) {
      return middle;
    }
    if (y1 < y) {
      start = middle + 1;
    } else {
      end = middle - 1;
    }
  }
  return end + 1;
}
function _insert2(_ref174) {
  var _ref175 = _slicedToArray(_ref174, 3),
    y1 = _ref175[1],
    y2 = _ref175[2];
  var index = _classPrivateFieldLooseBase(this, _binarySearch)[_binarySearch](y1);
  _classPrivateFieldLooseBase(this, _intervals)[_intervals].splice(index, 0, [y1, y2]);
}
function _remove2(_ref176) {
  var _ref177 = _slicedToArray(_ref176, 3),
    y1 = _ref177[1],
    y2 = _ref177[2];
  var index = _classPrivateFieldLooseBase(this, _binarySearch)[_binarySearch](y1);
  for (var i = index; i < _classPrivateFieldLooseBase(this, _intervals)[_intervals].length; i++) {
    var _classPrivateFieldLoo159 = _slicedToArray(_classPrivateFieldLooseBase(this, _intervals)[_intervals][i], 2),
      start = _classPrivateFieldLoo159[0],
      end = _classPrivateFieldLoo159[1];
    if (start !== y1) {
      break;
    }
    if (start === y1 && end === y2) {
      _classPrivateFieldLooseBase(this, _intervals)[_intervals].splice(i, 1);
      return;
    }
  }
  for (var _i32 = index - 1; _i32 >= 0; _i32--) {
    var _classPrivateFieldLoo160 = _slicedToArray(_classPrivateFieldLooseBase(this, _intervals)[_intervals][_i32], 2),
      _start = _classPrivateFieldLoo160[0],
      _end = _classPrivateFieldLoo160[1];
    if (_start !== y1) {
      break;
    }
    if (_start === y1 && _end === y2) {
      _classPrivateFieldLooseBase(this, _intervals)[_intervals].splice(_i32, 1);
      return;
    }
  }
}
function _breakEdge2(edge) {
  var _edge7 = _slicedToArray(edge, 3),
    x = _edge7[0],
    y1 = _edge7[1],
    y2 = _edge7[2];
  var results = [[x, y1, y2]];
  var index = _classPrivateFieldLooseBase(this, _binarySearch)[_binarySearch](y2);
  for (var i = 0; i < index; i++) {
    var _classPrivateFieldLoo161 = _slicedToArray(_classPrivateFieldLooseBase(this, _intervals)[_intervals][i], 2),
      start = _classPrivateFieldLoo161[0],
      end = _classPrivateFieldLoo161[1];
    for (var j = 0, jj = results.length; j < jj; j++) {
      var _results$j = _slicedToArray(results[j], 3),
        y3 = _results$j[1],
        y4 = _results$j[2];
      if (end <= y3 || y4 <= start) {
        continue;
      }
      if (y3 >= start) {
        if (y4 > end) {
          results[j][1] = end;
        } else {
          if (jj === 1) {
            return [];
          }
          results.splice(j, 1);
          j--;
          jj--;
        }
        continue;
      }
      results[j][2] = start;
      if (y4 > end) {
        results.push([x, end, y4]);
      }
    }
  }
  return results;
}
var _box4 = /*#__PURE__*/_classPrivateFieldLooseKey("box");
var _outlines = /*#__PURE__*/_classPrivateFieldLooseKey("outlines");
var HighlightOutline = /*#__PURE__*/function (_Outline2) {
  function HighlightOutline(outlines, box) {
    var _this82;
    _classCallCheck(this, HighlightOutline);
    _this82 = _callSuper(this, HighlightOutline);
    Object.defineProperty(_this82, _box4, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this82, _outlines, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(_this82, _outlines)[_outlines] = outlines;
    _classPrivateFieldLooseBase(_this82, _box4)[_box4] = box;
    return _this82;
  }
  _inherits(HighlightOutline, _Outline2);
  return _createClass(HighlightOutline, [{
    key: "toSVGPath",
    value: function toSVGPath() {
      var buffer = [];
      var _iterator142 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _outlines)[_outlines]),
        _step142;
      try {
        for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
          var polygon = _step142.value;
          var _polygon = _slicedToArray(polygon, 2),
            prevX = _polygon[0],
            prevY = _polygon[1];
          buffer.push("M".concat(prevX, " ").concat(prevY));
          for (var i = 2; i < polygon.length; i += 2) {
            var x = polygon[i];
            var y = polygon[i + 1];
            if (x === prevX) {
              buffer.push("V".concat(y));
              prevY = y;
            } else if (y === prevY) {
              buffer.push("H".concat(x));
              prevX = x;
            }
          }
          buffer.push("Z");
        }
      } catch (err) {
        _iterator142.e(err);
      } finally {
        _iterator142.f();
      }
      return buffer.join(" ");
    }
  }, {
    key: "serialize",
    value: function serialize(_ref155, _rotation) {
      var _ref156 = _slicedToArray(_ref155, 4),
        blX = _ref156[0],
        blY = _ref156[1],
        trX = _ref156[2],
        trY = _ref156[3];
      var outlines = [];
      var width = trX - blX;
      var height = trY - blY;
      var _iterator143 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _outlines)[_outlines]),
        _step143;
      try {
        for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
          var outline = _step143.value;
          var points = new Array(outline.length);
          for (var i = 0; i < outline.length; i += 2) {
            points[i] = blX + outline[i] * width;
            points[i + 1] = trY - outline[i + 1] * height;
          }
          outlines.push(points);
        }
      } catch (err) {
        _iterator143.e(err);
      } finally {
        _iterator143.f();
      }
      return outlines;
    }
  }, {
    key: "box",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _box4)[_box4];
    }
  }, {
    key: "classNamesForDrawing",
    get: function get() {
      return ["highlight"];
    }
  }, {
    key: "classNamesForOutlining",
    get: function get() {
      return ["highlightOutline"];
    }
  }]);
}(Outline);
var FreeHighlightOutliner = /*#__PURE__*/function (_FreeDrawOutliner2) {
  function FreeHighlightOutliner() {
    _classCallCheck(this, FreeHighlightOutliner);
    return _callSuper(this, FreeHighlightOutliner, arguments);
  }
  _inherits(FreeHighlightOutliner, _FreeDrawOutliner2);
  return _createClass(FreeHighlightOutliner, [{
    key: "newFreeDrawOutline",
    value: function newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
      return new FreeHighlightOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
  }, {
    key: "classNamesForDrawing",
    get: function get() {
      return ["highlight", "free"];
    }
  }]);
}(FreeDrawOutliner);
var FreeHighlightOutline = /*#__PURE__*/function (_FreeDrawOutline2) {
  function FreeHighlightOutline() {
    _classCallCheck(this, FreeHighlightOutline);
    return _callSuper(this, FreeHighlightOutline, arguments);
  }
  _inherits(FreeHighlightOutline, _FreeDrawOutline2);
  return _createClass(FreeHighlightOutline, [{
    key: "classNamesForDrawing",
    get: function get() {
      return ["highlight", "free"];
    }
  }, {
    key: "classNamesForOutlining",
    get: function get() {
      return ["highlightOutline", "free"];
    }
  }, {
    key: "newOutliner",
    value: function newOutliner(point, box, scaleFactor, thickness, isLTR) {
      var innerMargin = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
      return new FreeHighlightOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
  }]);
}(FreeDrawOutline);
; // ./src/display/editor/color_picker.js
var _button = /*#__PURE__*/_classPrivateFieldLooseKey("button");
var _buttonSwatch = /*#__PURE__*/_classPrivateFieldLooseKey("buttonSwatch");
var _defaultColor = /*#__PURE__*/_classPrivateFieldLooseKey("defaultColor");
var _dropdown = /*#__PURE__*/_classPrivateFieldLooseKey("dropdown");
var _dropdownWasFromKeyboard = /*#__PURE__*/_classPrivateFieldLooseKey("dropdownWasFromKeyboard");
var _isMainColorPicker = /*#__PURE__*/_classPrivateFieldLooseKey("isMainColorPicker");
var _editor3 = /*#__PURE__*/_classPrivateFieldLooseKey("editor");
var _eventBus = /*#__PURE__*/_classPrivateFieldLooseKey("eventBus");
var _openDropdownAC = /*#__PURE__*/_classPrivateFieldLooseKey("openDropdownAC");
var _uiManager3 = /*#__PURE__*/_classPrivateFieldLooseKey("uiManager");
var _type3 = /*#__PURE__*/_classPrivateFieldLooseKey("type");
var _l10nColor = /*#__PURE__*/_classPrivateFieldLooseKey("l10nColor");
var _getDropdownRoot = /*#__PURE__*/_classPrivateFieldLooseKey("getDropdownRoot");
var _colorSelect = /*#__PURE__*/_classPrivateFieldLooseKey("colorSelect");
var _keyDown3 = /*#__PURE__*/_classPrivateFieldLooseKey("keyDown");
var _openDropdown = /*#__PURE__*/_classPrivateFieldLooseKey("openDropdown");
var _pointerDown3 = /*#__PURE__*/_classPrivateFieldLooseKey("pointerDown");
var _isDropdownVisible = /*#__PURE__*/_classPrivateFieldLooseKey("isDropdownVisible");
var _ColorPicker = /*#__PURE__*/function () {
  function _ColorPicker(_ref157) {
    var _classPrivateFieldLoo96, _classPrivateFieldLoo97;
    var _ref157$editor = _ref157.editor,
      editor = _ref157$editor === void 0 ? null : _ref157$editor,
      _ref157$uiManager = _ref157.uiManager,
      uiManager = _ref157$uiManager === void 0 ? null : _ref157$uiManager;
    _classCallCheck(this, _ColorPicker);
    Object.defineProperty(this, _isDropdownVisible, {
      get: _get_isDropdownVisible,
      set: void 0
    });
    Object.defineProperty(this, _pointerDown3, {
      value: _pointerDown4
    });
    Object.defineProperty(this, _openDropdown, {
      value: _openDropdown2
    });
    Object.defineProperty(this, _keyDown3, {
      value: _keyDown4
    });
    Object.defineProperty(this, _colorSelect, {
      value: _colorSelect2
    });
    Object.defineProperty(this, _getDropdownRoot, {
      value: _getDropdownRoot2
    });
    Object.defineProperty(this, _button, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _buttonSwatch, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _defaultColor, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _dropdown, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _dropdownWasFromKeyboard, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _isMainColorPicker, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _editor3, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _eventBus, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _openDropdownAC, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _uiManager3, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _type3, {
      writable: true,
      value: void 0
    });
    if (editor) {
      _classPrivateFieldLooseBase(this, _isMainColorPicker)[_isMainColorPicker] = false;
      _classPrivateFieldLooseBase(this, _type3)[_type3] = _AnnotationEditorParamsType.HIGHLIGHT_COLOR;
      _classPrivateFieldLooseBase(this, _editor3)[_editor3] = editor;
    } else {
      _classPrivateFieldLooseBase(this, _isMainColorPicker)[_isMainColorPicker] = true;
      _classPrivateFieldLooseBase(this, _type3)[_type3] = _AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR;
    }
    _classPrivateFieldLooseBase(this, _uiManager3)[_uiManager3] = (editor === null || editor === void 0 ? void 0 : editor._uiManager) || uiManager;
    _classPrivateFieldLooseBase(this, _eventBus)[_eventBus] = _classPrivateFieldLooseBase(this, _uiManager3)[_uiManager3]._eventBus;
    _classPrivateFieldLooseBase(this, _defaultColor)[_defaultColor] = (editor === null || editor === void 0 ? void 0 : editor.color) || ((_classPrivateFieldLoo96 = _classPrivateFieldLooseBase(this, _uiManager3)[_uiManager3]) === null || _classPrivateFieldLoo96 === void 0 ? void 0 : _classPrivateFieldLoo96.highlightColors.values().next().value) || "#FFFF98";
    (_classPrivateFieldLoo97 = _classPrivateFieldLooseBase(_ColorPicker, _l10nColor))[_l10nColor] || (_classPrivateFieldLoo97[_l10nColor] = Object.freeze({
      blue: "pdfjs-editor-colorpicker-blue",
      green: "pdfjs-editor-colorpicker-green",
      pink: "pdfjs-editor-colorpicker-pink",
      red: "pdfjs-editor-colorpicker-red",
      yellow: "pdfjs-editor-colorpicker-yellow"
    }));
  }
  return _createClass(_ColorPicker, [{
    key: "renderButton",
    value: function renderButton() {
      var button = _classPrivateFieldLooseBase(this, _button)[_button] = document.createElement("button");
      button.className = "colorPicker";
      button.tabIndex = "0";
      button.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button");
      button.setAttribute("aria-haspopup", true);
      var signal = _classPrivateFieldLooseBase(this, _uiManager3)[_uiManager3]._signal;
      button.addEventListener("click", _classPrivateFieldLooseBase(this, _openDropdown)[_openDropdown].bind(this), {
        signal: signal
      });
      button.addEventListener("keydown", _classPrivateFieldLooseBase(this, _keyDown3)[_keyDown3].bind(this), {
        signal: signal
      });
      var swatch = _classPrivateFieldLooseBase(this, _buttonSwatch)[_buttonSwatch] = document.createElement("span");
      swatch.className = "swatch";
      swatch.setAttribute("aria-hidden", true);
      swatch.style.backgroundColor = _classPrivateFieldLooseBase(this, _defaultColor)[_defaultColor];
      button.append(swatch);
      return button;
    }
  }, {
    key: "renderMainDropdown",
    value: function renderMainDropdown() {
      var dropdown = _classPrivateFieldLooseBase(this, _dropdown)[_dropdown] = _classPrivateFieldLooseBase(this, _getDropdownRoot)[_getDropdownRoot]();
      dropdown.setAttribute("aria-orientation", "horizontal");
      dropdown.setAttribute("aria-labelledby", "highlightColorPickerLabel");
      return dropdown;
    }
  }, {
    key: "_colorSelectFromKeyboard",
    value: function _colorSelectFromKeyboard(event) {
      if (event.target === _classPrivateFieldLooseBase(this, _button)[_button]) {
        _classPrivateFieldLooseBase(this, _openDropdown)[_openDropdown](event);
        return;
      }
      var color = event.target.getAttribute("data-color");
      if (!color) {
        return;
      }
      _classPrivateFieldLooseBase(this, _colorSelect)[_colorSelect](color, event);
    }
  }, {
    key: "_moveToNext",
    value: function _moveToNext(event) {
      var _event$target$nextSib;
      if (!_classPrivateFieldLooseBase(this, _isDropdownVisible)[_isDropdownVisible]) {
        _classPrivateFieldLooseBase(this, _openDropdown)[_openDropdown](event);
        return;
      }
      if (event.target === _classPrivateFieldLooseBase(this, _button)[_button]) {
        var _classPrivateFieldLoo98;
        (_classPrivateFieldLoo98 = _classPrivateFieldLooseBase(this, _dropdown)[_dropdown].firstChild) === null || _classPrivateFieldLoo98 === void 0 || _classPrivateFieldLoo98.focus();
        return;
      }
      (_event$target$nextSib = event.target.nextSibling) === null || _event$target$nextSib === void 0 || _event$target$nextSib.focus();
    }
  }, {
    key: "_moveToPrevious",
    value: function _moveToPrevious(event) {
      var _classPrivateFieldLoo99, _event$target$previou;
      if (event.target === ((_classPrivateFieldLoo99 = _classPrivateFieldLooseBase(this, _dropdown)[_dropdown]) === null || _classPrivateFieldLoo99 === void 0 ? void 0 : _classPrivateFieldLoo99.firstChild) || event.target === _classPrivateFieldLooseBase(this, _button)[_button]) {
        if (_classPrivateFieldLooseBase(this, _isDropdownVisible)[_isDropdownVisible]) {
          this._hideDropdownFromKeyboard();
        }
        return;
      }
      if (!_classPrivateFieldLooseBase(this, _isDropdownVisible)[_isDropdownVisible]) {
        _classPrivateFieldLooseBase(this, _openDropdown)[_openDropdown](event);
      }
      (_event$target$previou = event.target.previousSibling) === null || _event$target$previou === void 0 || _event$target$previou.focus();
    }
  }, {
    key: "_moveToBeginning",
    value: function _moveToBeginning(event) {
      var _classPrivateFieldLoo100;
      if (!_classPrivateFieldLooseBase(this, _isDropdownVisible)[_isDropdownVisible]) {
        _classPrivateFieldLooseBase(this, _openDropdown)[_openDropdown](event);
        return;
      }
      (_classPrivateFieldLoo100 = _classPrivateFieldLooseBase(this, _dropdown)[_dropdown].firstChild) === null || _classPrivateFieldLoo100 === void 0 || _classPrivateFieldLoo100.focus();
    }
  }, {
    key: "_moveToEnd",
    value: function _moveToEnd(event) {
      var _classPrivateFieldLoo101;
      if (!_classPrivateFieldLooseBase(this, _isDropdownVisible)[_isDropdownVisible]) {
        _classPrivateFieldLooseBase(this, _openDropdown)[_openDropdown](event);
        return;
      }
      (_classPrivateFieldLoo101 = _classPrivateFieldLooseBase(this, _dropdown)[_dropdown].lastChild) === null || _classPrivateFieldLoo101 === void 0 || _classPrivateFieldLoo101.focus();
    }
  }, {
    key: "hideDropdown",
    value: function hideDropdown() {
      var _classPrivateFieldLoo102, _classPrivateFieldLoo103;
      (_classPrivateFieldLoo102 = _classPrivateFieldLooseBase(this, _dropdown)[_dropdown]) === null || _classPrivateFieldLoo102 === void 0 || _classPrivateFieldLoo102.classList.add("hidden");
      (_classPrivateFieldLoo103 = _classPrivateFieldLooseBase(this, _openDropdownAC)[_openDropdownAC]) === null || _classPrivateFieldLoo103 === void 0 || _classPrivateFieldLoo103.abort();
      _classPrivateFieldLooseBase(this, _openDropdownAC)[_openDropdownAC] = null;
    }
  }, {
    key: "_hideDropdownFromKeyboard",
    value: function _hideDropdownFromKeyboard() {
      if (_classPrivateFieldLooseBase(this, _isMainColorPicker)[_isMainColorPicker]) {
        return;
      }
      if (!_classPrivateFieldLooseBase(this, _isDropdownVisible)[_isDropdownVisible]) {
        var _classPrivateFieldLoo104;
        (_classPrivateFieldLoo104 = _classPrivateFieldLooseBase(this, _editor3)[_editor3]) === null || _classPrivateFieldLoo104 === void 0 || _classPrivateFieldLoo104.unselect();
        return;
      }
      this.hideDropdown();
      _classPrivateFieldLooseBase(this, _button)[_button].focus({
        preventScroll: true,
        focusVisible: _classPrivateFieldLooseBase(this, _dropdownWasFromKeyboard)[_dropdownWasFromKeyboard]
      });
    }
  }, {
    key: "updateColor",
    value: function updateColor(color) {
      if (_classPrivateFieldLooseBase(this, _buttonSwatch)[_buttonSwatch]) {
        _classPrivateFieldLooseBase(this, _buttonSwatch)[_buttonSwatch].style.backgroundColor = color;
      }
      if (!_classPrivateFieldLooseBase(this, _dropdown)[_dropdown]) {
        return;
      }
      var i = _classPrivateFieldLooseBase(this, _uiManager3)[_uiManager3].highlightColors.values();
      var _iterator144 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _dropdown)[_dropdown].children),
        _step144;
      try {
        for (_iterator144.s(); !(_step144 = _iterator144.n()).done;) {
          var child = _step144.value;
          child.setAttribute("aria-selected", i.next().value === color);
        }
      } catch (err) {
        _iterator144.e(err);
      } finally {
        _iterator144.f();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _classPrivateFieldLoo105, _classPrivateFieldLoo106;
      (_classPrivateFieldLoo105 = _classPrivateFieldLooseBase(this, _button)[_button]) === null || _classPrivateFieldLoo105 === void 0 || _classPrivateFieldLoo105.remove();
      _classPrivateFieldLooseBase(this, _button)[_button] = null;
      _classPrivateFieldLooseBase(this, _buttonSwatch)[_buttonSwatch] = null;
      (_classPrivateFieldLoo106 = _classPrivateFieldLooseBase(this, _dropdown)[_dropdown]) === null || _classPrivateFieldLoo106 === void 0 || _classPrivateFieldLoo106.remove();
      _classPrivateFieldLooseBase(this, _dropdown)[_dropdown] = null;
    }
  }], [{
    key: "_keyboardManager",
    get: function get() {
      return _shadow(this, "_keyboardManager", new KeyboardManager([[["Escape", "mac+Escape"], _ColorPicker.prototype._hideDropdownFromKeyboard], [[" ", "mac+ "], _ColorPicker.prototype._colorSelectFromKeyboard], [["ArrowDown", "ArrowRight", "mac+ArrowDown", "mac+ArrowRight"], _ColorPicker.prototype._moveToNext], [["ArrowUp", "ArrowLeft", "mac+ArrowUp", "mac+ArrowLeft"], _ColorPicker.prototype._moveToPrevious], [["Home", "mac+Home"], _ColorPicker.prototype._moveToBeginning], [["End", "mac+End"], _ColorPicker.prototype._moveToEnd]]));
    }
  }]);
}();
_ColorPicker2 = _ColorPicker;
function _getDropdownRoot2() {
  var div = document.createElement("div");
  var signal = _classPrivateFieldLooseBase(this, _uiManager3)[_uiManager3]._signal;
  div.addEventListener("contextmenu", _noContextMenu, {
    signal: signal
  });
  div.className = "dropdown";
  div.role = "listbox";
  div.setAttribute("aria-multiselectable", false);
  div.setAttribute("aria-orientation", "vertical");
  div.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown");
  var _iterator176 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _uiManager3)[_uiManager3].highlightColors),
    _step176;
  try {
    for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
      var _ref178 = _step176.value;
      var _ref179 = _slicedToArray(_ref178, 2);
      var name = _ref179[0];
      var color = _ref179[1];
      var button = document.createElement("button");
      button.tabIndex = "0";
      button.role = "option";
      button.setAttribute("data-color", color);
      button.title = name;
      button.setAttribute("data-l10n-id", _classPrivateFieldLooseBase(_ColorPicker2, _l10nColor)[_l10nColor][name]);
      var swatch = document.createElement("span");
      button.append(swatch);
      swatch.className = "swatch";
      swatch.style.backgroundColor = color;
      button.setAttribute("aria-selected", color === _classPrivateFieldLooseBase(this, _defaultColor)[_defaultColor]);
      button.addEventListener("click", _classPrivateFieldLooseBase(this, _colorSelect)[_colorSelect].bind(this, color), {
        signal: signal
      });
      div.append(button);
    }
  } catch (err) {
    _iterator176.e(err);
  } finally {
    _iterator176.f();
  }
  div.addEventListener("keydown", _classPrivateFieldLooseBase(this, _keyDown3)[_keyDown3].bind(this), {
    signal: signal
  });
  return div;
}
function _colorSelect2(color, event) {
  event.stopPropagation();
  _classPrivateFieldLooseBase(this, _eventBus)[_eventBus].dispatch("switchannotationeditorparams", {
    source: this,
    type: _classPrivateFieldLooseBase(this, _type3)[_type3],
    value: color
  });
}
function _keyDown4(event) {
  _ColorPicker2._keyboardManager.exec(this, event);
}
function _openDropdown2(event) {
  if (_classPrivateFieldLooseBase(this, _isDropdownVisible)[_isDropdownVisible]) {
    this.hideDropdown();
    return;
  }
  _classPrivateFieldLooseBase(this, _dropdownWasFromKeyboard)[_dropdownWasFromKeyboard] = event.detail === 0;
  if (!_classPrivateFieldLooseBase(this, _openDropdownAC)[_openDropdownAC]) {
    _classPrivateFieldLooseBase(this, _openDropdownAC)[_openDropdownAC] = new AbortController();
    window.addEventListener("pointerdown", _classPrivateFieldLooseBase(this, _pointerDown3)[_pointerDown3].bind(this), {
      signal: _classPrivateFieldLooseBase(this, _uiManager3)[_uiManager3].combinedSignal(_classPrivateFieldLooseBase(this, _openDropdownAC)[_openDropdownAC])
    });
  }
  if (_classPrivateFieldLooseBase(this, _dropdown)[_dropdown]) {
    _classPrivateFieldLooseBase(this, _dropdown)[_dropdown].classList.remove("hidden");
    return;
  }
  var root = _classPrivateFieldLooseBase(this, _dropdown)[_dropdown] = _classPrivateFieldLooseBase(this, _getDropdownRoot)[_getDropdownRoot]();
  _classPrivateFieldLooseBase(this, _button)[_button].append(root);
}
function _pointerDown4(event) {
  var _classPrivateFieldLoo162;
  if ((_classPrivateFieldLoo162 = _classPrivateFieldLooseBase(this, _dropdown)[_dropdown]) !== null && _classPrivateFieldLoo162 !== void 0 && _classPrivateFieldLoo162.contains(event.target)) {
    return;
  }
  this.hideDropdown();
}
function _get_isDropdownVisible() {
  return _classPrivateFieldLooseBase(this, _dropdown)[_dropdown] && !_classPrivateFieldLooseBase(this, _dropdown)[_dropdown].classList.contains("hidden");
}
Object.defineProperty(_ColorPicker, _l10nColor, {
  writable: true,
  value: null
});
; // ./src/display/editor/highlight.js
var _anchorNode = /*#__PURE__*/_classPrivateFieldLooseKey("anchorNode");
var _anchorOffset = /*#__PURE__*/_classPrivateFieldLooseKey("anchorOffset");
var _boxes = /*#__PURE__*/_classPrivateFieldLooseKey("boxes");
var _clipPathId = /*#__PURE__*/_classPrivateFieldLooseKey("clipPathId");
var _colorPicker2 = /*#__PURE__*/_classPrivateFieldLooseKey("colorPicker");
var _focusOutlines = /*#__PURE__*/_classPrivateFieldLooseKey("focusOutlines");
var _focusNode = /*#__PURE__*/_classPrivateFieldLooseKey("focusNode");
var _focusOffset = /*#__PURE__*/_classPrivateFieldLooseKey("focusOffset");
var _highlightDiv = /*#__PURE__*/_classPrivateFieldLooseKey("highlightDiv");
var _highlightOutlines = /*#__PURE__*/_classPrivateFieldLooseKey("highlightOutlines");
var _id15 = /*#__PURE__*/_classPrivateFieldLooseKey("id");
var _isFreeHighlight = /*#__PURE__*/_classPrivateFieldLooseKey("isFreeHighlight");
var _lastPoint = /*#__PURE__*/_classPrivateFieldLooseKey("lastPoint");
var _opacity = /*#__PURE__*/_classPrivateFieldLooseKey("opacity");
var _outlineId = /*#__PURE__*/_classPrivateFieldLooseKey("outlineId");
var _text = /*#__PURE__*/_classPrivateFieldLooseKey("text");
var _thickness2 = /*#__PURE__*/_classPrivateFieldLooseKey("thickness");
var _methodOfCreation = /*#__PURE__*/_classPrivateFieldLooseKey("methodOfCreation");
var _createOutlines = /*#__PURE__*/_classPrivateFieldLooseKey("createOutlines");
var _createFreeOutlines = /*#__PURE__*/_classPrivateFieldLooseKey("createFreeOutlines");
var _updateColor3 = /*#__PURE__*/_classPrivateFieldLooseKey("updateColor");
var _updateThickness = /*#__PURE__*/_classPrivateFieldLooseKey("updateThickness");
var _changeThickness = /*#__PURE__*/_classPrivateFieldLooseKey("changeThickness");
var _cleanDrawLayer = /*#__PURE__*/_classPrivateFieldLooseKey("cleanDrawLayer");
var _addToDrawLayer = /*#__PURE__*/_classPrivateFieldLooseKey("addToDrawLayer");
var _rotateBbox = /*#__PURE__*/_classPrivateFieldLooseKey("rotateBbox");
var _keydown = /*#__PURE__*/_classPrivateFieldLooseKey("keydown");
var _setCaret = /*#__PURE__*/_classPrivateFieldLooseKey("setCaret");
var _getRotation = /*#__PURE__*/_classPrivateFieldLooseKey("getRotation");
var _serializeBoxes = /*#__PURE__*/_classPrivateFieldLooseKey("serializeBoxes");
var _serializeOutlines = /*#__PURE__*/_classPrivateFieldLooseKey("serializeOutlines");
var _highlightMove = /*#__PURE__*/_classPrivateFieldLooseKey("highlightMove");
var _endHighlight = /*#__PURE__*/_classPrivateFieldLooseKey("endHighlight");
var _hasElementChanged3 = /*#__PURE__*/_classPrivateFieldLooseKey("hasElementChanged");
var HighlightEditor = /*#__PURE__*/function (_AnnotationEditor4) {
  function HighlightEditor(params) {
    var _this83;
    _classCallCheck(this, HighlightEditor);
    _this83 = _callSuper(this, HighlightEditor, [_objectSpread(_objectSpread({}, params), {}, {
      name: "highlightEditor"
    })]);
    Object.defineProperty(_this83, _hasElementChanged3, {
      value: _hasElementChanged4
    });
    Object.defineProperty(_this83, _serializeOutlines, {
      value: _serializeOutlines2
    });
    Object.defineProperty(_this83, _serializeBoxes, {
      value: _serializeBoxes2
    });
    Object.defineProperty(_this83, _getRotation, {
      value: _getRotation2
    });
    Object.defineProperty(_this83, _setCaret, {
      value: _setCaret2
    });
    Object.defineProperty(_this83, _keydown, {
      value: _keydown2
    });
    Object.defineProperty(_this83, _addToDrawLayer, {
      value: _addToDrawLayer2
    });
    Object.defineProperty(_this83, _cleanDrawLayer, {
      value: _cleanDrawLayer2
    });
    Object.defineProperty(_this83, _changeThickness, {
      value: _changeThickness2
    });
    Object.defineProperty(_this83, _updateThickness, {
      value: _updateThickness2
    });
    Object.defineProperty(_this83, _updateColor3, {
      value: _updateColor4
    });
    Object.defineProperty(_this83, _createFreeOutlines, {
      value: _createFreeOutlines2
    });
    Object.defineProperty(_this83, _createOutlines, {
      value: _createOutlines2
    });
    Object.defineProperty(_this83, _anchorNode, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this83, _anchorOffset, {
      writable: true,
      value: 0
    });
    Object.defineProperty(_this83, _boxes, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this83, _clipPathId, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this83, _colorPicker2, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this83, _focusOutlines, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this83, _focusNode, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this83, _focusOffset, {
      writable: true,
      value: 0
    });
    Object.defineProperty(_this83, _highlightDiv, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this83, _highlightOutlines, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this83, _id15, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this83, _isFreeHighlight, {
      writable: true,
      value: false
    });
    Object.defineProperty(_this83, _lastPoint, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this83, _opacity, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this83, _outlineId, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this83, _text, {
      writable: true,
      value: ""
    });
    Object.defineProperty(_this83, _thickness2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this83, _methodOfCreation, {
      writable: true,
      value: ""
    });
    _this83.color = params.color || HighlightEditor._defaultColor;
    _classPrivateFieldLooseBase(_this83, _thickness2)[_thickness2] = params.thickness || HighlightEditor._defaultThickness;
    _classPrivateFieldLooseBase(_this83, _opacity)[_opacity] = params.opacity || HighlightEditor._defaultOpacity;
    _classPrivateFieldLooseBase(_this83, _boxes)[_boxes] = params.boxes || null;
    _classPrivateFieldLooseBase(_this83, _methodOfCreation)[_methodOfCreation] = params.methodOfCreation || "";
    _classPrivateFieldLooseBase(_this83, _text)[_text] = params.text || "";
    _this83._isDraggable = false;
    if (params.highlightId > -1) {
      _classPrivateFieldLooseBase(_this83, _isFreeHighlight)[_isFreeHighlight] = true;
      _classPrivateFieldLooseBase(_this83, _createFreeOutlines)[_createFreeOutlines](params);
      _classPrivateFieldLooseBase(_this83, _addToDrawLayer)[_addToDrawLayer]();
    } else if (_classPrivateFieldLooseBase(_this83, _boxes)[_boxes]) {
      _classPrivateFieldLooseBase(_this83, _anchorNode)[_anchorNode] = params.anchorNode;
      _classPrivateFieldLooseBase(_this83, _anchorOffset)[_anchorOffset] = params.anchorOffset;
      _classPrivateFieldLooseBase(_this83, _focusNode)[_focusNode] = params.focusNode;
      _classPrivateFieldLooseBase(_this83, _focusOffset)[_focusOffset] = params.focusOffset;
      _classPrivateFieldLooseBase(_this83, _createOutlines)[_createOutlines]();
      _classPrivateFieldLooseBase(_this83, _addToDrawLayer)[_addToDrawLayer]();
      _this83.rotate(_this83.rotation);
    }
    return _this83;
  }
  _inherits(HighlightEditor, _AnnotationEditor4);
  return _createClass(HighlightEditor, [{
    key: "telemetryInitialData",
    get: function get() {
      return {
        action: "added",
        type: _classPrivateFieldLooseBase(this, _isFreeHighlight)[_isFreeHighlight] ? "free_highlight" : "highlight",
        color: this._uiManager.highlightColorNames.get(this.color),
        thickness: _classPrivateFieldLooseBase(this, _thickness2)[_thickness2],
        methodOfCreation: _classPrivateFieldLooseBase(this, _methodOfCreation)[_methodOfCreation]
      };
    }
  }, {
    key: "telemetryFinalData",
    get: function get() {
      return {
        type: "highlight",
        color: this._uiManager.highlightColorNames.get(this.color)
      };
    }
  }, {
    key: "translateInPage",
    value: function translateInPage(x, y) {}
  }, {
    key: "toolbarPosition",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _lastPoint)[_lastPoint];
    }
  }, {
    key: "updateParams",
    value: function updateParams(type, value) {
      switch (type) {
        case _AnnotationEditorParamsType.HIGHLIGHT_COLOR:
          _classPrivateFieldLooseBase(this, _updateColor3)[_updateColor3](value);
          break;
        case _AnnotationEditorParamsType.HIGHLIGHT_THICKNESS:
          _classPrivateFieldLooseBase(this, _updateThickness)[_updateThickness](value);
          break;
      }
    }
  }, {
    key: "propertiesToUpdate",
    get: function get() {
      return [[_AnnotationEditorParamsType.HIGHLIGHT_COLOR, this.color || HighlightEditor._defaultColor], [_AnnotationEditorParamsType.HIGHLIGHT_THICKNESS, _classPrivateFieldLooseBase(this, _thickness2)[_thickness2] || HighlightEditor._defaultThickness], [_AnnotationEditorParamsType.HIGHLIGHT_FREE, _classPrivateFieldLooseBase(this, _isFreeHighlight)[_isFreeHighlight]]];
    }
  }, {
    key: "addEditToolbar",
    value: function () {
      var _addEditToolbar2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        var toolbar;
        return _regeneratorRuntime().wrap(function _callee43$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              _context44.next = 2;
              return _superPropGet(HighlightEditor, "addEditToolbar", this, 3)([]);
            case 2:
              toolbar = _context44.sent;
              if (toolbar) {
                _context44.next = 5;
                break;
              }
              return _context44.abrupt("return", null);
            case 5:
              if (this._uiManager.highlightColors) {
                _classPrivateFieldLooseBase(this, _colorPicker2)[_colorPicker2] = new _ColorPicker({
                  editor: this
                });
                toolbar.addColorPicker(_classPrivateFieldLooseBase(this, _colorPicker2)[_colorPicker2]);
              }
              return _context44.abrupt("return", toolbar);
            case 7:
            case "end":
              return _context44.stop();
          }
        }, _callee43, this);
      }));
      function addEditToolbar() {
        return _addEditToolbar2.apply(this, arguments);
      }
      return addEditToolbar;
    }()
  }, {
    key: "disableEditing",
    value: function disableEditing() {
      _superPropGet(HighlightEditor, "disableEditing", this, 3)([]);
      this.div.classList.toggle("disabled", true);
    }
  }, {
    key: "enableEditing",
    value: function enableEditing() {
      _superPropGet(HighlightEditor, "enableEditing", this, 3)([]);
      this.div.classList.toggle("disabled", false);
    }
  }, {
    key: "fixAndSetPosition",
    value: function fixAndSetPosition() {
      return _superPropGet(HighlightEditor, "fixAndSetPosition", this, 3)([_classPrivateFieldLooseBase(this, _getRotation)[_getRotation]()]);
    }
  }, {
    key: "getBaseTranslation",
    value: function getBaseTranslation() {
      return [0, 0];
    }
  }, {
    key: "getRect",
    value: function getRect(tx, ty) {
      return _superPropGet(HighlightEditor, "getRect", this, 3)([tx, ty, _classPrivateFieldLooseBase(this, _getRotation)[_getRotation]()]);
    }
  }, {
    key: "onceAdded",
    value: function onceAdded() {
      if (!this.annotationElementId) {
        this.parent.addUndoableEditor(this);
      }
      this.div.focus();
    }
  }, {
    key: "remove",
    value: function remove() {
      _classPrivateFieldLooseBase(this, _cleanDrawLayer)[_cleanDrawLayer]();
      this._reportTelemetry({
        action: "deleted"
      });
      _superPropGet(HighlightEditor, "remove", this, 3)([]);
    }
  }, {
    key: "rebuild",
    value: function rebuild() {
      if (!this.parent) {
        return;
      }
      _superPropGet(HighlightEditor, "rebuild", this, 3)([]);
      if (this.div === null) {
        return;
      }
      _classPrivateFieldLooseBase(this, _addToDrawLayer)[_addToDrawLayer]();
      if (!this.isAttachedToDOM) {
        this.parent.add(this);
      }
    }
  }, {
    key: "setParent",
    value: function setParent(parent) {
      var mustBeSelected = false;
      if (this.parent && !parent) {
        _classPrivateFieldLooseBase(this, _cleanDrawLayer)[_cleanDrawLayer]();
      } else if (parent) {
        var _this$div5;
        _classPrivateFieldLooseBase(this, _addToDrawLayer)[_addToDrawLayer](parent);
        mustBeSelected = !this.parent && ((_this$div5 = this.div) === null || _this$div5 === void 0 ? void 0 : _this$div5.classList.contains("selectedEditor"));
      }
      _superPropGet(HighlightEditor, "setParent", this, 3)([parent]);
      this.show(this._isVisible);
      if (mustBeSelected) {
        this.select();
      }
    }
  }, {
    key: "rotate",
    value: function rotate(angle) {
      var drawLayer = this.parent.drawLayer;
      var box;
      if (_classPrivateFieldLooseBase(this, _isFreeHighlight)[_isFreeHighlight]) {
        angle = (angle - this.rotation + 360) % 360;
        box = _classPrivateFieldLooseBase(HighlightEditor, _rotateBbox)[_rotateBbox](_classPrivateFieldLooseBase(this, _highlightOutlines)[_highlightOutlines].box, angle);
      } else {
        box = _classPrivateFieldLooseBase(HighlightEditor, _rotateBbox)[_rotateBbox](this, angle);
      }
      drawLayer.rotate(_classPrivateFieldLooseBase(this, _id15)[_id15], angle);
      drawLayer.rotate(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId], angle);
      drawLayer.updateBox(_classPrivateFieldLooseBase(this, _id15)[_id15], box);
      drawLayer.updateBox(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId], _classPrivateFieldLooseBase(HighlightEditor, _rotateBbox)[_rotateBbox](_classPrivateFieldLooseBase(this, _focusOutlines)[_focusOutlines].box, angle));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.div) {
        return this.div;
      }
      var div = _superPropGet(HighlightEditor, "render", this, 3)([]);
      if (_classPrivateFieldLooseBase(this, _text)[_text]) {
        div.setAttribute("aria-label", _classPrivateFieldLooseBase(this, _text)[_text]);
        div.setAttribute("role", "mark");
      }
      if (_classPrivateFieldLooseBase(this, _isFreeHighlight)[_isFreeHighlight]) {
        div.classList.add("free");
      } else {
        this.div.addEventListener("keydown", _classPrivateFieldLooseBase(this, _keydown)[_keydown].bind(this), {
          signal: this._uiManager._signal
        });
      }
      var highlightDiv = _classPrivateFieldLooseBase(this, _highlightDiv)[_highlightDiv] = document.createElement("div");
      div.append(highlightDiv);
      highlightDiv.setAttribute("aria-hidden", "true");
      highlightDiv.className = "internal";
      highlightDiv.style.clipPath = _classPrivateFieldLooseBase(this, _clipPathId)[_clipPathId];
      var _this$parentDimension9 = _slicedToArray(this.parentDimensions, 2),
        parentWidth = _this$parentDimension9[0],
        parentHeight = _this$parentDimension9[1];
      this.setDims(this.width * parentWidth, this.height * parentHeight);
      bindEvents(this, _classPrivateFieldLooseBase(this, _highlightDiv)[_highlightDiv], ["pointerover", "pointerleave"]);
      this.enableEditing();
      return div;
    }
  }, {
    key: "pointerover",
    value: function pointerover() {
      if (!this.isSelected) {
        this.parent.drawLayer.addClass(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId], "hovered");
      }
    }
  }, {
    key: "pointerleave",
    value: function pointerleave() {
      if (!this.isSelected) {
        this.parent.drawLayer.removeClass(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId], "hovered");
      }
    }
  }, {
    key: "_moveCaret",
    value: function _moveCaret(direction) {
      this.parent.unselect(this);
      switch (direction) {
        case 0:
        case 2:
          _classPrivateFieldLooseBase(this, _setCaret)[_setCaret](true);
          break;
        case 1:
        case 3:
          _classPrivateFieldLooseBase(this, _setCaret)[_setCaret](false);
          break;
      }
    }
  }, {
    key: "select",
    value: function select() {
      var _this$parent3, _this$parent4;
      _superPropGet(HighlightEditor, "select", this, 3)([]);
      if (!_classPrivateFieldLooseBase(this, _outlineId)[_outlineId]) {
        return;
      }
      (_this$parent3 = this.parent) === null || _this$parent3 === void 0 || _this$parent3.drawLayer.removeClass(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId], "hovered");
      (_this$parent4 = this.parent) === null || _this$parent4 === void 0 || _this$parent4.drawLayer.addClass(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId], "selected");
    }
  }, {
    key: "unselect",
    value: function unselect() {
      var _this$parent5;
      _superPropGet(HighlightEditor, "unselect", this, 3)([]);
      if (!_classPrivateFieldLooseBase(this, _outlineId)[_outlineId]) {
        return;
      }
      (_this$parent5 = this.parent) === null || _this$parent5 === void 0 || _this$parent5.drawLayer.removeClass(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId], "selected");
      if (!_classPrivateFieldLooseBase(this, _isFreeHighlight)[_isFreeHighlight]) {
        _classPrivateFieldLooseBase(this, _setCaret)[_setCaret](false);
      }
    }
  }, {
    key: "_mustFixPosition",
    get: function get() {
      return !_classPrivateFieldLooseBase(this, _isFreeHighlight)[_isFreeHighlight];
    }
  }, {
    key: "show",
    value: function show() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._isVisible;
      _superPropGet(HighlightEditor, "show", this, 3)([visible]);
      if (this.parent) {
        this.parent.drawLayer.show(_classPrivateFieldLooseBase(this, _id15)[_id15], visible);
        this.parent.drawLayer.show(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId], visible);
      }
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var isForCopying = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.isEmpty() || isForCopying) {
        return null;
      }
      if (this.deleted) {
        return this.serializeDeleted();
      }
      var rect = this.getRect(0, 0);
      var color = AnnotationEditor._colorManager.convert(this.color);
      var serialized = {
        annotationType: _AnnotationEditorType.HIGHLIGHT,
        color: color,
        opacity: _classPrivateFieldLooseBase(this, _opacity)[_opacity],
        thickness: _classPrivateFieldLooseBase(this, _thickness2)[_thickness2],
        quadPoints: _classPrivateFieldLooseBase(this, _serializeBoxes)[_serializeBoxes](),
        outlines: _classPrivateFieldLooseBase(this, _serializeOutlines)[_serializeOutlines](rect),
        pageIndex: this.pageIndex,
        rect: rect,
        rotation: _classPrivateFieldLooseBase(this, _getRotation)[_getRotation](),
        structTreeParentId: this._structTreeParentId
      };
      if (this.annotationElementId && !_classPrivateFieldLooseBase(this, _hasElementChanged3)[_hasElementChanged3](serialized)) {
        return null;
      }
      serialized.id = this.annotationElementId;
      return serialized;
    }
  }, {
    key: "renderAnnotationElement",
    value: function renderAnnotationElement(annotation) {
      annotation.updateEdited({
        rect: this.getRect(0, 0)
      });
      return null;
    }
  }], [{
    key: "_keyboardManager",
    get: function get() {
      var proto = HighlightEditor.prototype;
      return _shadow(this, "_keyboardManager", new KeyboardManager([[["ArrowLeft", "mac+ArrowLeft"], proto._moveCaret, {
        args: [0]
      }], [["ArrowRight", "mac+ArrowRight"], proto._moveCaret, {
        args: [1]
      }], [["ArrowUp", "mac+ArrowUp"], proto._moveCaret, {
        args: [2]
      }], [["ArrowDown", "mac+ArrowDown"], proto._moveCaret, {
        args: [3]
      }]]));
    }
  }, {
    key: "computeTelemetryFinalData",
    value: function computeTelemetryFinalData(data) {
      return {
        numberOfColors: data.get("color").size
      };
    }
  }, {
    key: "initialize",
    value: function initialize(l10n, uiManager) {
      var _uiManager$highlightC;
      AnnotationEditor.initialize(l10n, uiManager);
      HighlightEditor._defaultColor || (HighlightEditor._defaultColor = ((_uiManager$highlightC = uiManager.highlightColors) === null || _uiManager$highlightC === void 0 ? void 0 : _uiManager$highlightC.values().next().value) || "#fff066");
    }
  }, {
    key: "updateDefaultParams",
    value: function updateDefaultParams(type, value) {
      switch (type) {
        case _AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR:
          HighlightEditor._defaultColor = value;
          break;
        case _AnnotationEditorParamsType.HIGHLIGHT_THICKNESS:
          HighlightEditor._defaultThickness = value;
          break;
      }
    }
  }, {
    key: "defaultPropertiesToUpdate",
    get: function get() {
      return [[_AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR, HighlightEditor._defaultColor], [_AnnotationEditorParamsType.HIGHLIGHT_THICKNESS, HighlightEditor._defaultThickness]];
    }
  }, {
    key: "startHighlighting",
    value: function startHighlighting(parent, isLTR, _ref158) {
      var _this84 = this;
      var textLayer = _ref158.target,
        x = _ref158.x,
        y = _ref158.y;
      var _textLayer$getBoundin2 = textLayer.getBoundingClientRect(),
        layerX = _textLayer$getBoundin2.x,
        layerY = _textLayer$getBoundin2.y,
        parentWidth = _textLayer$getBoundin2.width,
        parentHeight = _textLayer$getBoundin2.height;
      var ac = new AbortController();
      var signal = parent.combinedSignal(ac);
      var pointerDown = function pointerDown(e) {
        e.preventDefault();
        e.stopPropagation();
      };
      var pointerUpCallback = function pointerUpCallback(e) {
        ac.abort();
        _classPrivateFieldLooseBase(_this84, _endHighlight)[_endHighlight](parent, e);
      };
      window.addEventListener("blur", pointerUpCallback, {
        signal: signal
      });
      window.addEventListener("pointerup", pointerUpCallback, {
        signal: signal
      });
      window.addEventListener("pointerdown", pointerDown, {
        capture: true,
        passive: false,
        signal: signal
      });
      window.addEventListener("contextmenu", _noContextMenu, {
        signal: signal
      });
      textLayer.addEventListener("pointermove", _classPrivateFieldLooseBase(this, _highlightMove)[_highlightMove].bind(this, parent), {
        signal: signal
      });
      this._freeHighlight = new FreeHighlightOutliner({
        x: x,
        y: y
      }, [layerX, layerY, parentWidth, parentHeight], parent.scale, this._defaultThickness / 2, isLTR, 0.001);
      var _parent$drawLayer$dra = parent.drawLayer.draw(this._freeHighlight, this._defaultColor, this._defaultOpacity, true);
      this._freeHighlightId = _parent$drawLayer$dra.id;
      this._freeHighlightClipId = _parent$drawLayer$dra.clipPathId;
    }
  }, {
    key: "deserialize",
    value: function () {
      var _deserialize3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee44(data, parent, uiManager) {
        var initialData, _data4, _data4$data, _quadPoints, rect, rotation, _id16, _color3, _opacity2, popupRef, pageNumber, _data5, _data5$data, _inkLists, _rect4, _rotation5, _id17, _color4, thickness, _popupRef, _pageNumber, _data6, color, quadPoints, inkLists, opacity, editor, _editor$pageDimension2, pageWidth, pageHeight, _editor$pageTranslati, pageX, pageY, boxes, i, points, point, outliner, _i28, ii, _parent$drawLayer$dra2, _id18, clipPathId;
        return _regeneratorRuntime().wrap(function _callee44$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              initialData = null;
              if (data instanceof HighlightAnnotationElement) {
                _data4 = data, _data4$data = _data4.data, _quadPoints = _data4$data.quadPoints, rect = _data4$data.rect, rotation = _data4$data.rotation, _id16 = _data4$data.id, _color3 = _data4$data.color, _opacity2 = _data4$data.opacity, popupRef = _data4$data.popupRef, pageNumber = _data4.parent.page.pageNumber;
                initialData = data = {
                  annotationType: _AnnotationEditorType.HIGHLIGHT,
                  color: Array.from(_color3),
                  opacity: _opacity2,
                  quadPoints: _quadPoints,
                  boxes: null,
                  pageIndex: pageNumber - 1,
                  rect: rect.slice(0),
                  rotation: rotation,
                  id: _id16,
                  deleted: false,
                  popupRef: popupRef
                };
              } else if (data instanceof InkAnnotationElement) {
                _data5 = data, _data5$data = _data5.data, _inkLists = _data5$data.inkLists, _rect4 = _data5$data.rect, _rotation5 = _data5$data.rotation, _id17 = _data5$data.id, _color4 = _data5$data.color, thickness = _data5$data.borderStyle.rawWidth, _popupRef = _data5$data.popupRef, _pageNumber = _data5.parent.page.pageNumber;
                initialData = data = {
                  annotationType: _AnnotationEditorType.HIGHLIGHT,
                  color: Array.from(_color4),
                  thickness: thickness,
                  inkLists: _inkLists,
                  boxes: null,
                  pageIndex: _pageNumber - 1,
                  rect: _rect4.slice(0),
                  rotation: _rotation5,
                  id: _id17,
                  deleted: false,
                  popupRef: _popupRef
                };
              }
              _data6 = data, color = _data6.color, quadPoints = _data6.quadPoints, inkLists = _data6.inkLists, opacity = _data6.opacity;
              _context45.next = 5;
              return _superPropGet(HighlightEditor, "deserialize", this, 2)([data, parent, uiManager]);
            case 5:
              editor = _context45.sent;
              editor.color = _Util.makeHexColor.apply(_Util, _toConsumableArray(color));
              _classPrivateFieldLooseBase(editor, _opacity)[_opacity] = opacity || 1;
              if (inkLists) {
                _classPrivateFieldLooseBase(editor, _thickness2)[_thickness2] = data.thickness;
              }
              editor.annotationElementId = data.id || null;
              editor._initialData = initialData;
              _editor$pageDimension2 = _slicedToArray(editor.pageDimensions, 2), pageWidth = _editor$pageDimension2[0], pageHeight = _editor$pageDimension2[1];
              _editor$pageTranslati = _slicedToArray(editor.pageTranslation, 2), pageX = _editor$pageTranslati[0], pageY = _editor$pageTranslati[1];
              if (quadPoints) {
                boxes = _classPrivateFieldLooseBase(editor, _boxes)[_boxes] = [];
                for (i = 0; i < quadPoints.length; i += 8) {
                  boxes.push({
                    x: (quadPoints[i] - pageX) / pageWidth,
                    y: 1 - (quadPoints[i + 1] - pageY) / pageHeight,
                    width: (quadPoints[i + 2] - quadPoints[i]) / pageWidth,
                    height: (quadPoints[i + 1] - quadPoints[i + 5]) / pageHeight
                  });
                }
                _classPrivateFieldLooseBase(editor, _createOutlines)[_createOutlines]();
                _classPrivateFieldLooseBase(editor, _addToDrawLayer)[_addToDrawLayer]();
                editor.rotate(editor.rotation);
              } else if (inkLists) {
                _classPrivateFieldLooseBase(editor, _isFreeHighlight)[_isFreeHighlight] = true;
                points = inkLists[0];
                point = {
                  x: points[0] - pageX,
                  y: pageHeight - (points[1] - pageY)
                };
                outliner = new FreeHighlightOutliner(point, [0, 0, pageWidth, pageHeight], 1, _classPrivateFieldLooseBase(editor, _thickness2)[_thickness2] / 2, true, 0.001);
                for (_i28 = 0, ii = points.length; _i28 < ii; _i28 += 2) {
                  point.x = points[_i28] - pageX;
                  point.y = pageHeight - (points[_i28 + 1] - pageY);
                  outliner.add(point);
                }
                _parent$drawLayer$dra2 = parent.drawLayer.draw(outliner, editor.color, editor._defaultOpacity, true), _id18 = _parent$drawLayer$dra2.id, clipPathId = _parent$drawLayer$dra2.clipPathId;
                _classPrivateFieldLooseBase(editor, _createFreeOutlines)[_createFreeOutlines]({
                  highlightOutlines: outliner.getOutlines(),
                  highlightId: _id18,
                  clipPathId: clipPathId
                });
                _classPrivateFieldLooseBase(editor, _addToDrawLayer)[_addToDrawLayer]();
              }
              return _context45.abrupt("return", editor);
            case 15:
            case "end":
              return _context45.stop();
          }
        }, _callee44, this);
      }));
      function deserialize(_x37, _x38, _x39) {
        return _deserialize3.apply(this, arguments);
      }
      return deserialize;
    }()
  }, {
    key: "canCreateNewEmptyEditor",
    value: function canCreateNewEmptyEditor() {
      return false;
    }
  }]);
}(AnnotationEditor);
_HighlightEditor = HighlightEditor;
function _createOutlines2() {
  var outliner = new HighlightOutliner(_classPrivateFieldLooseBase(this, _boxes)[_boxes], 0.001);
  _classPrivateFieldLooseBase(this, _highlightOutlines)[_highlightOutlines] = outliner.getOutlines();
  var _classPrivateFieldLoo163 = _classPrivateFieldLooseBase(this, _highlightOutlines)[_highlightOutlines].box;
  this.x = _classPrivateFieldLoo163.x;
  this.y = _classPrivateFieldLoo163.y;
  this.width = _classPrivateFieldLoo163.width;
  this.height = _classPrivateFieldLoo163.height;
  var outlinerForOutline = new HighlightOutliner(_classPrivateFieldLooseBase(this, _boxes)[_boxes], 0.0025, 0.001, this._uiManager.direction === "ltr");
  _classPrivateFieldLooseBase(this, _focusOutlines)[_focusOutlines] = outlinerForOutline.getOutlines();
  var lastPoint = _classPrivateFieldLooseBase(this, _focusOutlines)[_focusOutlines].box.lastPoint;
  _classPrivateFieldLooseBase(this, _lastPoint)[_lastPoint] = [(lastPoint[0] - this.x) / this.width, (lastPoint[1] - this.y) / this.height];
}
function _createFreeOutlines2(_ref180) {
  var highlightOutlines = _ref180.highlightOutlines,
    highlightId = _ref180.highlightId,
    clipPathId = _ref180.clipPathId;
  _classPrivateFieldLooseBase(this, _highlightOutlines)[_highlightOutlines] = highlightOutlines;
  var extraThickness = 1.5;
  _classPrivateFieldLooseBase(this, _focusOutlines)[_focusOutlines] = highlightOutlines.getNewOutline(_classPrivateFieldLooseBase(this, _thickness2)[_thickness2] / 2 + extraThickness, 0.0025);
  if (highlightId >= 0) {
    _classPrivateFieldLooseBase(this, _id15)[_id15] = highlightId;
    _classPrivateFieldLooseBase(this, _clipPathId)[_clipPathId] = clipPathId;
    this.parent.drawLayer.finalizeLine(highlightId, highlightOutlines);
    _classPrivateFieldLooseBase(this, _outlineId)[_outlineId] = this.parent.drawLayer.drawOutline(_classPrivateFieldLooseBase(this, _focusOutlines)[_focusOutlines]);
  } else if (this.parent) {
    var angle = this.parent.viewport.rotation;
    this.parent.drawLayer.updateLine(_classPrivateFieldLooseBase(this, _id15)[_id15], highlightOutlines);
    this.parent.drawLayer.updateBox(_classPrivateFieldLooseBase(this, _id15)[_id15], _classPrivateFieldLooseBase(_HighlightEditor, _rotateBbox)[_rotateBbox](_classPrivateFieldLooseBase(this, _highlightOutlines)[_highlightOutlines].box, (angle - this.rotation + 360) % 360));
    this.parent.drawLayer.updateLine(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId], _classPrivateFieldLooseBase(this, _focusOutlines)[_focusOutlines]);
    this.parent.drawLayer.updateBox(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId], _classPrivateFieldLooseBase(_HighlightEditor, _rotateBbox)[_rotateBbox](_classPrivateFieldLooseBase(this, _focusOutlines)[_focusOutlines].box, angle));
  }
  var _highlightOutlines$bo = highlightOutlines.box,
    x = _highlightOutlines$bo.x,
    y = _highlightOutlines$bo.y,
    width = _highlightOutlines$bo.width,
    height = _highlightOutlines$bo.height;
  switch (this.rotation) {
    case 0:
      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
      break;
    case 90:
      {
        var _this$parentDimension16 = _slicedToArray(this.parentDimensions, 2),
          pageWidth = _this$parentDimension16[0],
          pageHeight = _this$parentDimension16[1];
        this.x = y;
        this.y = 1 - x;
        this.width = width * pageHeight / pageWidth;
        this.height = height * pageWidth / pageHeight;
        break;
      }
    case 180:
      this.x = 1 - x;
      this.y = 1 - y;
      this.width = width;
      this.height = height;
      break;
    case 270:
      {
        var _this$parentDimension17 = _slicedToArray(this.parentDimensions, 2),
          _pageWidth4 = _this$parentDimension17[0],
          _pageHeight4 = _this$parentDimension17[1];
        this.x = 1 - y;
        this.y = x;
        this.width = width * _pageHeight4 / _pageWidth4;
        this.height = height * _pageWidth4 / _pageHeight4;
        break;
      }
  }
  var lastPoint = _classPrivateFieldLooseBase(this, _focusOutlines)[_focusOutlines].box.lastPoint;
  _classPrivateFieldLooseBase(this, _lastPoint)[_lastPoint] = [(lastPoint[0] - x) / width, (lastPoint[1] - y) / height];
}
function _updateColor4(color) {
  var _this99 = this;
  var setColorAndOpacity = function setColorAndOpacity(col, opa) {
    var _this99$parent, _classPrivateFieldLoo164, _this99$parent2;
    _this99.color = col;
    (_this99$parent = _this99.parent) === null || _this99$parent === void 0 || _this99$parent.drawLayer.changeColor(_classPrivateFieldLooseBase(_this99, _id15)[_id15], col);
    (_classPrivateFieldLoo164 = _classPrivateFieldLooseBase(_this99, _colorPicker2)[_colorPicker2]) === null || _classPrivateFieldLoo164 === void 0 || _classPrivateFieldLoo164.updateColor(col);
    _classPrivateFieldLooseBase(_this99, _opacity)[_opacity] = opa;
    (_this99$parent2 = _this99.parent) === null || _this99$parent2 === void 0 || _this99$parent2.drawLayer.changeOpacity(_classPrivateFieldLooseBase(_this99, _id15)[_id15], opa);
  };
  var savedColor = this.color;
  var savedOpacity = _classPrivateFieldLooseBase(this, _opacity)[_opacity];
  this.addCommands({
    cmd: setColorAndOpacity.bind(this, color, _HighlightEditor._defaultOpacity),
    undo: setColorAndOpacity.bind(this, savedColor, savedOpacity),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: true,
    type: _AnnotationEditorParamsType.HIGHLIGHT_COLOR,
    overwriteIfSameType: true,
    keepUndo: true
  });
  this._reportTelemetry({
    action: "color_changed",
    color: this._uiManager.highlightColorNames.get(color)
  }, true);
}
function _updateThickness2(thickness) {
  var _this100 = this;
  var savedThickness = _classPrivateFieldLooseBase(this, _thickness2)[_thickness2];
  var setThickness = function setThickness(th) {
    _classPrivateFieldLooseBase(_this100, _thickness2)[_thickness2] = th;
    _classPrivateFieldLooseBase(_this100, _changeThickness)[_changeThickness](th);
  };
  this.addCommands({
    cmd: setThickness.bind(this, thickness),
    undo: setThickness.bind(this, savedThickness),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: true,
    type: _AnnotationEditorParamsType.INK_THICKNESS,
    overwriteIfSameType: true,
    keepUndo: true
  });
  this._reportTelemetry({
    action: "thickness_changed",
    thickness: thickness
  }, true);
}
function _changeThickness2(thickness) {
  if (!_classPrivateFieldLooseBase(this, _isFreeHighlight)[_isFreeHighlight]) {
    return;
  }
  _classPrivateFieldLooseBase(this, _createFreeOutlines)[_createFreeOutlines]({
    highlightOutlines: _classPrivateFieldLooseBase(this, _highlightOutlines)[_highlightOutlines].getNewOutline(thickness / 2)
  });
  this.fixAndSetPosition();
  var _this$parentDimension18 = _slicedToArray(this.parentDimensions, 2),
    parentWidth = _this$parentDimension18[0],
    parentHeight = _this$parentDimension18[1];
  this.setDims(this.width * parentWidth, this.height * parentHeight);
}
function _cleanDrawLayer2() {
  if (_classPrivateFieldLooseBase(this, _id15)[_id15] === null || !this.parent) {
    return;
  }
  this.parent.drawLayer.remove(_classPrivateFieldLooseBase(this, _id15)[_id15]);
  _classPrivateFieldLooseBase(this, _id15)[_id15] = null;
  this.parent.drawLayer.remove(_classPrivateFieldLooseBase(this, _outlineId)[_outlineId]);
  _classPrivateFieldLooseBase(this, _outlineId)[_outlineId] = null;
}
function _addToDrawLayer2() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.parent;
  if (_classPrivateFieldLooseBase(this, _id15)[_id15] !== null) {
    return;
  }
  var _parent$drawLayer$dra3 = parent.drawLayer.draw(_classPrivateFieldLooseBase(this, _highlightOutlines)[_highlightOutlines], this.color, _classPrivateFieldLooseBase(this, _opacity)[_opacity]);
  _classPrivateFieldLooseBase(this, _id15)[_id15] = _parent$drawLayer$dra3.id;
  _classPrivateFieldLooseBase(this, _clipPathId)[_clipPathId] = _parent$drawLayer$dra3.clipPathId;
  _classPrivateFieldLooseBase(this, _outlineId)[_outlineId] = parent.drawLayer.drawOutline(_classPrivateFieldLooseBase(this, _focusOutlines)[_focusOutlines]);
  if (_classPrivateFieldLooseBase(this, _highlightDiv)[_highlightDiv]) {
    _classPrivateFieldLooseBase(this, _highlightDiv)[_highlightDiv].style.clipPath = _classPrivateFieldLooseBase(this, _clipPathId)[_clipPathId];
  }
}
function _rotateBbox2(_ref181, angle) {
  var x = _ref181.x,
    y = _ref181.y,
    width = _ref181.width,
    height = _ref181.height;
  switch (angle) {
    case 90:
      return {
        x: 1 - y - height,
        y: x,
        width: height,
        height: width
      };
    case 180:
      return {
        x: 1 - x - width,
        y: 1 - y - height,
        width: width,
        height: height
      };
    case 270:
      return {
        x: y,
        y: 1 - x - width,
        width: height,
        height: width
      };
  }
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}
function _keydown2(event) {
  _HighlightEditor._keyboardManager.exec(this, event);
}
function _setCaret2(start) {
  if (!_classPrivateFieldLooseBase(this, _anchorNode)[_anchorNode]) {
    return;
  }
  var selection = window.getSelection();
  if (start) {
    selection.setPosition(_classPrivateFieldLooseBase(this, _anchorNode)[_anchorNode], _classPrivateFieldLooseBase(this, _anchorOffset)[_anchorOffset]);
  } else {
    selection.setPosition(_classPrivateFieldLooseBase(this, _focusNode)[_focusNode], _classPrivateFieldLooseBase(this, _focusOffset)[_focusOffset]);
  }
}
function _getRotation2() {
  return _classPrivateFieldLooseBase(this, _isFreeHighlight)[_isFreeHighlight] ? this.rotation : 0;
}
function _serializeBoxes2() {
  if (_classPrivateFieldLooseBase(this, _isFreeHighlight)[_isFreeHighlight]) {
    return null;
  }
  var _this$pageDimensions8 = _slicedToArray(this.pageDimensions, 2),
    pageWidth = _this$pageDimensions8[0],
    pageHeight = _this$pageDimensions8[1];
  var _this$pageTranslation5 = _slicedToArray(this.pageTranslation, 2),
    pageX = _this$pageTranslation5[0],
    pageY = _this$pageTranslation5[1];
  var boxes = _classPrivateFieldLooseBase(this, _boxes)[_boxes];
  var quadPoints = new Float32Array(boxes.length * 8);
  var i = 0;
  var _iterator177 = _createForOfIteratorHelper(boxes),
    _step177;
  try {
    for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
      var _ref182 = _step177.value;
      var x = _ref182.x;
      var y = _ref182.y;
      var width = _ref182.width;
      var height = _ref182.height;
      var sx = x * pageWidth + pageX;
      var sy = (1 - y - height) * pageHeight + pageY;
      quadPoints[i] = quadPoints[i + 4] = sx;
      quadPoints[i + 1] = quadPoints[i + 3] = sy;
      quadPoints[i + 2] = quadPoints[i + 6] = sx + width * pageWidth;
      quadPoints[i + 5] = quadPoints[i + 7] = sy + height * pageHeight;
      i += 8;
    }
  } catch (err) {
    _iterator177.e(err);
  } finally {
    _iterator177.f();
  }
  return quadPoints;
}
function _serializeOutlines2(rect) {
  return _classPrivateFieldLooseBase(this, _highlightOutlines)[_highlightOutlines].serialize(rect, _classPrivateFieldLooseBase(this, _getRotation)[_getRotation]());
}
function _highlightMove2(parent, event) {
  if (this._freeHighlight.add(event)) {
    parent.drawLayer.updatePath(this._freeHighlightId, this._freeHighlight);
  }
}
function _endHighlight2(parent, event) {
  if (!this._freeHighlight.isEmpty()) {
    parent.createAndAddNewEditor(event, false, {
      highlightId: this._freeHighlightId,
      highlightOutlines: this._freeHighlight.getOutlines(),
      clipPathId: this._freeHighlightClipId,
      methodOfCreation: "main_toolbar"
    });
  } else {
    parent.drawLayer.remove(this._freeHighlightId);
  }
  this._freeHighlightId = -1;
  this._freeHighlight = null;
  this._freeHighlightClipId = "";
}
function _hasElementChanged4(serialized) {
  var color = this._initialData.color;
  return serialized.color.some(function (c, i) {
    return c !== color[i];
  });
}
Object.defineProperty(HighlightEditor, _endHighlight, {
  value: _endHighlight2
});
Object.defineProperty(HighlightEditor, _highlightMove, {
  value: _highlightMove2
});
Object.defineProperty(HighlightEditor, _rotateBbox, {
  value: _rotateBbox2
});
HighlightEditor._defaultColor = null;
HighlightEditor._defaultOpacity = 1;
HighlightEditor._defaultThickness = 12;
HighlightEditor._type = "highlight";
HighlightEditor._editorType = _AnnotationEditorType.HIGHLIGHT;
HighlightEditor._freeHighlightId = -1;
HighlightEditor._freeHighlight = null;
HighlightEditor._freeHighlightClipId = "";
; // ./src/display/editor/ink.js
var _baseHeight = /*#__PURE__*/_classPrivateFieldLooseKey("baseHeight");
var _baseWidth = /*#__PURE__*/_classPrivateFieldLooseKey("baseWidth");
var _canvasContextMenuTimeoutId = /*#__PURE__*/_classPrivateFieldLooseKey("canvasContextMenuTimeoutId");
var _currentPath2D = /*#__PURE__*/_classPrivateFieldLooseKey("currentPath2D");
var _disableEditing = /*#__PURE__*/_classPrivateFieldLooseKey("disableEditing");
var _drawingAC = /*#__PURE__*/_classPrivateFieldLooseKey("drawingAC");
var _hasSomethingToDraw = /*#__PURE__*/_classPrivateFieldLooseKey("hasSomethingToDraw");
var _isCanvasInitialized = /*#__PURE__*/_classPrivateFieldLooseKey("isCanvasInitialized");
var _observer = /*#__PURE__*/_classPrivateFieldLooseKey("observer");
var _pointerdownAC = /*#__PURE__*/_classPrivateFieldLooseKey("pointerdownAC");
var _realWidth = /*#__PURE__*/_classPrivateFieldLooseKey("realWidth");
var _realHeight = /*#__PURE__*/_classPrivateFieldLooseKey("realHeight");
var _requestFrameCallback = /*#__PURE__*/_classPrivateFieldLooseKey("requestFrameCallback");
var _updateThickness3 = /*#__PURE__*/_classPrivateFieldLooseKey("updateThickness");
var _updateColor5 = /*#__PURE__*/_classPrivateFieldLooseKey("updateColor");
var _updateOpacity = /*#__PURE__*/_classPrivateFieldLooseKey("updateOpacity");
var _getInitialBBox = /*#__PURE__*/_classPrivateFieldLooseKey("getInitialBBox");
var _setStroke = /*#__PURE__*/_classPrivateFieldLooseKey("setStroke");
var _startDrawing = /*#__PURE__*/_classPrivateFieldLooseKey("startDrawing");
var _draw = /*#__PURE__*/_classPrivateFieldLooseKey("draw");
var _endPath = /*#__PURE__*/_classPrivateFieldLooseKey("endPath");
var _stopDrawing = /*#__PURE__*/_classPrivateFieldLooseKey("stopDrawing");
var _drawPoints = /*#__PURE__*/_classPrivateFieldLooseKey("drawPoints");
var _makeBezierCurve = /*#__PURE__*/_classPrivateFieldLooseKey("makeBezierCurve");
var _generateBezierPoints = /*#__PURE__*/_classPrivateFieldLooseKey("generateBezierPoints");
var _redraw = /*#__PURE__*/_classPrivateFieldLooseKey("redraw");
var _addPointerdownListener = /*#__PURE__*/_classPrivateFieldLooseKey("addPointerdownListener");
var _removePointerdownListener = /*#__PURE__*/_classPrivateFieldLooseKey("removePointerdownListener");
var _endDrawing = /*#__PURE__*/_classPrivateFieldLooseKey("endDrawing");
var _createCanvas2 = /*#__PURE__*/_classPrivateFieldLooseKey("createCanvas");
var _createObserver = /*#__PURE__*/_classPrivateFieldLooseKey("createObserver");
var _setCanvasDims = /*#__PURE__*/_classPrivateFieldLooseKey("setCanvasDims");
var _setScaleFactor = /*#__PURE__*/_classPrivateFieldLooseKey("setScaleFactor");
var _updateTransform = /*#__PURE__*/_classPrivateFieldLooseKey("updateTransform");
var _buildPath2D = /*#__PURE__*/_classPrivateFieldLooseKey("buildPath2D");
var _toPDFCoordinates = /*#__PURE__*/_classPrivateFieldLooseKey("toPDFCoordinates");
var _fromPDFCoordinates = /*#__PURE__*/_classPrivateFieldLooseKey("fromPDFCoordinates");
var _serializePaths = /*#__PURE__*/_classPrivateFieldLooseKey("serializePaths");
var _getBbox = /*#__PURE__*/_classPrivateFieldLooseKey("getBbox");
var _getPadding = /*#__PURE__*/_classPrivateFieldLooseKey("getPadding");
var _fitToContent = /*#__PURE__*/_classPrivateFieldLooseKey("fitToContent");
var InkEditor = /*#__PURE__*/function (_AnnotationEditor5) {
  function InkEditor(params) {
    var _this85;
    _classCallCheck(this, InkEditor);
    _this85 = _callSuper(this, InkEditor, [_objectSpread(_objectSpread({}, params), {}, {
      name: "inkEditor"
    })]);
    Object.defineProperty(_this85, _fitToContent, {
      value: _fitToContent2
    });
    Object.defineProperty(_this85, _getPadding, {
      value: _getPadding2
    });
    Object.defineProperty(_this85, _getBbox, {
      value: _getBbox2
    });
    Object.defineProperty(_this85, _serializePaths, {
      value: _serializePaths2
    });
    Object.defineProperty(_this85, _updateTransform, {
      value: _updateTransform2
    });
    Object.defineProperty(_this85, _setScaleFactor, {
      value: _setScaleFactor2
    });
    Object.defineProperty(_this85, _setCanvasDims, {
      value: _setCanvasDims2
    });
    Object.defineProperty(_this85, _createObserver, {
      value: _createObserver2
    });
    Object.defineProperty(_this85, _createCanvas2, {
      value: _createCanvas3
    });
    Object.defineProperty(_this85, _endDrawing, {
      value: _endDrawing2
    });
    Object.defineProperty(_this85, _removePointerdownListener, {
      value: _removePointerdownListener2
    });
    Object.defineProperty(_this85, _addPointerdownListener, {
      value: _addPointerdownListener2
    });
    Object.defineProperty(_this85, _redraw, {
      value: _redraw2
    });
    Object.defineProperty(_this85, _generateBezierPoints, {
      value: _generateBezierPoints2
    });
    Object.defineProperty(_this85, _makeBezierCurve, {
      value: _makeBezierCurve2
    });
    Object.defineProperty(_this85, _drawPoints, {
      value: _drawPoints2
    });
    Object.defineProperty(_this85, _stopDrawing, {
      value: _stopDrawing2
    });
    Object.defineProperty(_this85, _endPath, {
      value: _endPath2
    });
    Object.defineProperty(_this85, _draw, {
      value: _draw2
    });
    Object.defineProperty(_this85, _startDrawing, {
      value: _startDrawing2
    });
    Object.defineProperty(_this85, _setStroke, {
      value: _setStroke2
    });
    Object.defineProperty(_this85, _getInitialBBox, {
      value: _getInitialBBox2
    });
    Object.defineProperty(_this85, _updateOpacity, {
      value: _updateOpacity2
    });
    Object.defineProperty(_this85, _updateColor5, {
      value: _updateColor6
    });
    Object.defineProperty(_this85, _updateThickness3, {
      value: _updateThickness4
    });
    Object.defineProperty(_this85, _baseHeight, {
      writable: true,
      value: 0
    });
    Object.defineProperty(_this85, _baseWidth, {
      writable: true,
      value: 0
    });
    Object.defineProperty(_this85, _canvasContextMenuTimeoutId, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this85, _currentPath2D, {
      writable: true,
      value: new Path2D()
    });
    Object.defineProperty(_this85, _disableEditing, {
      writable: true,
      value: false
    });
    Object.defineProperty(_this85, _drawingAC, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this85, _hasSomethingToDraw, {
      writable: true,
      value: false
    });
    Object.defineProperty(_this85, _isCanvasInitialized, {
      writable: true,
      value: false
    });
    Object.defineProperty(_this85, _observer, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this85, _pointerdownAC, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this85, _realWidth, {
      writable: true,
      value: 0
    });
    Object.defineProperty(_this85, _realHeight, {
      writable: true,
      value: 0
    });
    Object.defineProperty(_this85, _requestFrameCallback, {
      writable: true,
      value: null
    });
    _this85.color = params.color || null;
    _this85.thickness = params.thickness || null;
    _this85.opacity = params.opacity || null;
    _this85.paths = [];
    _this85.bezierPath2D = [];
    _this85.allRawPaths = [];
    _this85.currentPath = [];
    _this85.scaleFactor = 1;
    _this85.translationX = _this85.translationY = 0;
    _this85.x = 0;
    _this85.y = 0;
    _this85._willKeepAspectRatio = true;
    return _this85;
  }
  _inherits(InkEditor, _AnnotationEditor5);
  return _createClass(InkEditor, [{
    key: "updateParams",
    value: function updateParams(type, value) {
      switch (type) {
        case _AnnotationEditorParamsType.INK_THICKNESS:
          _classPrivateFieldLooseBase(this, _updateThickness3)[_updateThickness3](value);
          break;
        case _AnnotationEditorParamsType.INK_COLOR:
          _classPrivateFieldLooseBase(this, _updateColor5)[_updateColor5](value);
          break;
        case _AnnotationEditorParamsType.INK_OPACITY:
          _classPrivateFieldLooseBase(this, _updateOpacity)[_updateOpacity](value);
          break;
      }
    }
  }, {
    key: "propertiesToUpdate",
    get: function get() {
      var _this$opacity;
      return [[_AnnotationEditorParamsType.INK_THICKNESS, this.thickness || InkEditor._defaultThickness], [_AnnotationEditorParamsType.INK_COLOR, this.color || InkEditor._defaultColor || AnnotationEditor._defaultLineColor], [_AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * ((_this$opacity = this.opacity) !== null && _this$opacity !== void 0 ? _this$opacity : InkEditor._defaultOpacity))]];
    }
  }, {
    key: "rebuild",
    value: function rebuild() {
      if (!this.parent) {
        return;
      }
      _superPropGet(InkEditor, "rebuild", this, 3)([]);
      if (this.div === null) {
        return;
      }
      if (!this.canvas) {
        _classPrivateFieldLooseBase(this, _createCanvas2)[_createCanvas2]();
        _classPrivateFieldLooseBase(this, _createObserver)[_createObserver]();
      }
      if (!this.isAttachedToDOM) {
        this.parent.add(this);
        _classPrivateFieldLooseBase(this, _setCanvasDims)[_setCanvasDims]();
      }
      _classPrivateFieldLooseBase(this, _fitToContent)[_fitToContent]();
    }
  }, {
    key: "remove",
    value: function remove() {
      var _classPrivateFieldLoo107;
      if (this.canvas === null) {
        return;
      }
      if (!this.isEmpty()) {
        this.commit();
      }
      this.canvas.width = this.canvas.height = 0;
      this.canvas.remove();
      this.canvas = null;
      if (_classPrivateFieldLooseBase(this, _canvasContextMenuTimeoutId)[_canvasContextMenuTimeoutId]) {
        clearTimeout(_classPrivateFieldLooseBase(this, _canvasContextMenuTimeoutId)[_canvasContextMenuTimeoutId]);
        _classPrivateFieldLooseBase(this, _canvasContextMenuTimeoutId)[_canvasContextMenuTimeoutId] = null;
      }
      (_classPrivateFieldLoo107 = _classPrivateFieldLooseBase(this, _observer)[_observer]) === null || _classPrivateFieldLoo107 === void 0 || _classPrivateFieldLoo107.disconnect();
      _classPrivateFieldLooseBase(this, _observer)[_observer] = null;
      _superPropGet(InkEditor, "remove", this, 3)([]);
    }
  }, {
    key: "setParent",
    value: function setParent(parent) {
      if (!this.parent && parent) {
        this._uiManager.removeShouldRescale(this);
      } else if (this.parent && parent === null) {
        this._uiManager.addShouldRescale(this);
      }
      _superPropGet(InkEditor, "setParent", this, 3)([parent]);
    }
  }, {
    key: "onScaleChanging",
    value: function onScaleChanging() {
      var _this$parentDimension10 = _slicedToArray(this.parentDimensions, 2),
        parentWidth = _this$parentDimension10[0],
        parentHeight = _this$parentDimension10[1];
      var width = this.width * parentWidth;
      var height = this.height * parentHeight;
      this.setDimensions(width, height);
    }
  }, {
    key: "enableEditMode",
    value: function enableEditMode() {
      if (_classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing] || this.canvas === null) {
        return;
      }
      _superPropGet(InkEditor, "enableEditMode", this, 3)([]);
      this._isDraggable = false;
      _classPrivateFieldLooseBase(this, _addPointerdownListener)[_addPointerdownListener]();
    }
  }, {
    key: "disableEditMode",
    value: function disableEditMode() {
      if (!this.isInEditMode() || this.canvas === null) {
        return;
      }
      _superPropGet(InkEditor, "disableEditMode", this, 3)([]);
      this._isDraggable = !this.isEmpty();
      this.div.classList.remove("editing");
      _classPrivateFieldLooseBase(this, _removePointerdownListener)[_removePointerdownListener]();
    }
  }, {
    key: "onceAdded",
    value: function onceAdded() {
      this._isDraggable = !this.isEmpty();
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
    }
  }, {
    key: "commit",
    value: function commit() {
      if (_classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing]) {
        return;
      }
      _superPropGet(InkEditor, "commit", this, 3)([]);
      this.isEditing = false;
      this.disableEditMode();
      this.setInForeground();
      _classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing] = true;
      this.div.classList.add("disabled");
      _classPrivateFieldLooseBase(this, _fitToContent)[_fitToContent](true);
      this.select();
      this.parent.addInkEditorIfNeeded(true);
      this.moveInDOM();
      this.div.focus({
        preventScroll: true
      });
    }
  }, {
    key: "focusin",
    value: function focusin(event) {
      if (!this._focusEventsAllowed) {
        return;
      }
      _superPropGet(InkEditor, "focusin", this, 3)([event]);
      this.enableEditMode();
    }
  }, {
    key: "canvasPointerdown",
    value: function canvasPointerdown(event) {
      if (event.button !== 0 || !this.isInEditMode() || _classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing]) {
        return;
      }
      this.setInForeground();
      event.preventDefault();
      if (!this.div.contains(document.activeElement)) {
        this.div.focus({
          preventScroll: true
        });
      }
      _classPrivateFieldLooseBase(this, _startDrawing)[_startDrawing](event.offsetX, event.offsetY);
    }
  }, {
    key: "canvasPointermove",
    value: function canvasPointermove(event) {
      event.preventDefault();
      _classPrivateFieldLooseBase(this, _draw)[_draw](event.offsetX, event.offsetY);
    }
  }, {
    key: "canvasPointerup",
    value: function canvasPointerup(event) {
      event.preventDefault();
      _classPrivateFieldLooseBase(this, _endDrawing)[_endDrawing](event);
    }
  }, {
    key: "canvasPointerleave",
    value: function canvasPointerleave(event) {
      _classPrivateFieldLooseBase(this, _endDrawing)[_endDrawing](event);
    }
  }, {
    key: "isResizable",
    get: function get() {
      return !this.isEmpty() && _classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing];
    }
  }, {
    key: "render",
    value: function render() {
      if (this.div) {
        return this.div;
      }
      var baseX, baseY;
      if (this.width) {
        baseX = this.x;
        baseY = this.y;
      }
      _superPropGet(InkEditor, "render", this, 3)([]);
      this.div.setAttribute("data-l10n-id", "pdfjs-ink");
      var _classPrivateFieldLoo108 = _classPrivateFieldLooseBase(this, _getInitialBBox)[_getInitialBBox](),
        _classPrivateFieldLoo109 = _slicedToArray(_classPrivateFieldLoo108, 4),
        x = _classPrivateFieldLoo109[0],
        y = _classPrivateFieldLoo109[1],
        w = _classPrivateFieldLoo109[2],
        h = _classPrivateFieldLoo109[3];
      this.setAt(x, y, 0, 0);
      this.setDims(w, h);
      _classPrivateFieldLooseBase(this, _createCanvas2)[_createCanvas2]();
      if (this.width) {
        var _this$parentDimension11 = _slicedToArray(this.parentDimensions, 2),
          parentWidth = _this$parentDimension11[0],
          parentHeight = _this$parentDimension11[1];
        this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
        this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
        _classPrivateFieldLooseBase(this, _isCanvasInitialized)[_isCanvasInitialized] = true;
        _classPrivateFieldLooseBase(this, _setCanvasDims)[_setCanvasDims]();
        this.setDims(this.width * parentWidth, this.height * parentHeight);
        _classPrivateFieldLooseBase(this, _redraw)[_redraw]();
        this.div.classList.add("disabled");
      } else {
        this.div.classList.add("editing");
        this.enableEditMode();
      }
      _classPrivateFieldLooseBase(this, _createObserver)[_createObserver]();
      return this.div;
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(width, height) {
      var roundedWidth = Math.round(width);
      var roundedHeight = Math.round(height);
      if (_classPrivateFieldLooseBase(this, _realWidth)[_realWidth] === roundedWidth && _classPrivateFieldLooseBase(this, _realHeight)[_realHeight] === roundedHeight) {
        return;
      }
      _classPrivateFieldLooseBase(this, _realWidth)[_realWidth] = roundedWidth;
      _classPrivateFieldLooseBase(this, _realHeight)[_realHeight] = roundedHeight;
      this.canvas.style.visibility = "hidden";
      var _this$parentDimension12 = _slicedToArray(this.parentDimensions, 2),
        parentWidth = _this$parentDimension12[0],
        parentHeight = _this$parentDimension12[1];
      this.width = width / parentWidth;
      this.height = height / parentHeight;
      this.fixAndSetPosition();
      if (_classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing]) {
        _classPrivateFieldLooseBase(this, _setScaleFactor)[_setScaleFactor](width, height);
      }
      _classPrivateFieldLooseBase(this, _setCanvasDims)[_setCanvasDims]();
      _classPrivateFieldLooseBase(this, _redraw)[_redraw]();
      this.canvas.style.visibility = "visible";
      this.fixDims();
    }
  }, {
    key: "serialize",
    value: function serialize() {
      if (this.isEmpty()) {
        return null;
      }
      var rect = this.getRect(0, 0);
      var color = AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
      return {
        annotationType: _AnnotationEditorType.INK,
        color: color,
        thickness: this.thickness,
        opacity: this.opacity,
        paths: _classPrivateFieldLooseBase(this, _serializePaths)[_serializePaths](this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
        pageIndex: this.pageIndex,
        rect: rect,
        rotation: this.rotation,
        structTreeParentId: this._structTreeParentId
      };
    }
  }], [{
    key: "initialize",
    value: function initialize(l10n, uiManager) {
      AnnotationEditor.initialize(l10n, uiManager);
    }
  }, {
    key: "updateDefaultParams",
    value: function updateDefaultParams(type, value) {
      switch (type) {
        case _AnnotationEditorParamsType.INK_THICKNESS:
          InkEditor._defaultThickness = value;
          break;
        case _AnnotationEditorParamsType.INK_COLOR:
          InkEditor._defaultColor = value;
          break;
        case _AnnotationEditorParamsType.INK_OPACITY:
          InkEditor._defaultOpacity = value / 100;
          break;
      }
    }
  }, {
    key: "defaultPropertiesToUpdate",
    get: function get() {
      return [[_AnnotationEditorParamsType.INK_THICKNESS, InkEditor._defaultThickness], [_AnnotationEditorParamsType.INK_COLOR, InkEditor._defaultColor || AnnotationEditor._defaultLineColor], [_AnnotationEditorParamsType.INK_OPACITY, Math.round(InkEditor._defaultOpacity * 100)]];
    }
  }, {
    key: "deserialize",
    value: function () {
      var _deserialize4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee45(data, parent, uiManager) {
        var editor, _editor$pageDimension3, pageWidth, pageHeight, width, height, scaleFactor, padding, paths, rect, rotation, _iterator145, _step145, _ref159, bezier, path, p0, p1, i, ii, p10, p11, p20, p21, p30, p31, path2D, bbox;
        return _regeneratorRuntime().wrap(function _callee45$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              if (!(data instanceof InkAnnotationElement)) {
                _context46.next = 2;
                break;
              }
              return _context46.abrupt("return", null);
            case 2:
              _context46.next = 4;
              return _superPropGet(InkEditor, "deserialize", this, 2)([data, parent, uiManager]);
            case 4:
              editor = _context46.sent;
              editor.thickness = data.thickness;
              editor.color = _Util.makeHexColor.apply(_Util, _toConsumableArray(data.color));
              editor.opacity = data.opacity;
              _editor$pageDimension3 = _slicedToArray(editor.pageDimensions, 2), pageWidth = _editor$pageDimension3[0], pageHeight = _editor$pageDimension3[1];
              width = editor.width * pageWidth;
              height = editor.height * pageHeight;
              scaleFactor = editor.parentScale;
              padding = data.thickness / 2;
              _classPrivateFieldLooseBase(editor, _disableEditing)[_disableEditing] = true;
              _classPrivateFieldLooseBase(editor, _realWidth)[_realWidth] = Math.round(width);
              _classPrivateFieldLooseBase(editor, _realHeight)[_realHeight] = Math.round(height);
              paths = data.paths, rect = data.rect, rotation = data.rotation;
              _iterator145 = _createForOfIteratorHelper(paths);
              try {
                for (_iterator145.s(); !(_step145 = _iterator145.n()).done;) {
                  _ref159 = _step145.value;
                  bezier = _ref159.bezier;
                  bezier = _classPrivateFieldLooseBase(InkEditor, _fromPDFCoordinates)[_fromPDFCoordinates](bezier, rect, rotation);
                  path = [];
                  editor.paths.push(path);
                  p0 = scaleFactor * (bezier[0] - padding);
                  p1 = scaleFactor * (bezier[1] - padding);
                  for (i = 2, ii = bezier.length; i < ii; i += 6) {
                    p10 = scaleFactor * (bezier[i] - padding);
                    p11 = scaleFactor * (bezier[i + 1] - padding);
                    p20 = scaleFactor * (bezier[i + 2] - padding);
                    p21 = scaleFactor * (bezier[i + 3] - padding);
                    p30 = scaleFactor * (bezier[i + 4] - padding);
                    p31 = scaleFactor * (bezier[i + 5] - padding);
                    path.push([[p0, p1], [p10, p11], [p20, p21], [p30, p31]]);
                    p0 = p30;
                    p1 = p31;
                  }
                  path2D = _classPrivateFieldLooseBase(this, _buildPath2D)[_buildPath2D](path);
                  editor.bezierPath2D.push(path2D);
                }
              } catch (err) {
                _iterator145.e(err);
              } finally {
                _iterator145.f();
              }
              bbox = _classPrivateFieldLooseBase(editor, _getBbox)[_getBbox]();
              _classPrivateFieldLooseBase(editor, _baseWidth)[_baseWidth] = Math.max(AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
              _classPrivateFieldLooseBase(editor, _baseHeight)[_baseHeight] = Math.max(AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
              _classPrivateFieldLooseBase(editor, _setScaleFactor)[_setScaleFactor](width, height);
              return _context46.abrupt("return", editor);
            case 24:
            case "end":
              return _context46.stop();
          }
        }, _callee45, this);
      }));
      function deserialize(_x40, _x41, _x42) {
        return _deserialize4.apply(this, arguments);
      }
      return deserialize;
    }()
  }]);
}(AnnotationEditor);
_InkEditor = InkEditor;
function _updateThickness4(thickness) {
  var _this101 = this;
  var setThickness = function setThickness(th) {
    _this101.thickness = th;
    _classPrivateFieldLooseBase(_this101, _fitToContent)[_fitToContent]();
  };
  var savedThickness = this.thickness;
  this.addCommands({
    cmd: setThickness.bind(this, thickness),
    undo: setThickness.bind(this, savedThickness),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: true,
    type: _AnnotationEditorParamsType.INK_THICKNESS,
    overwriteIfSameType: true,
    keepUndo: true
  });
}
function _updateColor6(color) {
  var _this102 = this;
  var setColor = function setColor(col) {
    _this102.color = col;
    _classPrivateFieldLooseBase(_this102, _redraw)[_redraw]();
  };
  var savedColor = this.color;
  this.addCommands({
    cmd: setColor.bind(this, color),
    undo: setColor.bind(this, savedColor),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: true,
    type: _AnnotationEditorParamsType.INK_COLOR,
    overwriteIfSameType: true,
    keepUndo: true
  });
}
function _updateOpacity2(opacity) {
  var _this103 = this;
  var setOpacity = function setOpacity(op) {
    _this103.opacity = op;
    _classPrivateFieldLooseBase(_this103, _redraw)[_redraw]();
  };
  opacity /= 100;
  var savedOpacity = this.opacity;
  this.addCommands({
    cmd: setOpacity.bind(this, opacity),
    undo: setOpacity.bind(this, savedOpacity),
    post: this._uiManager.updateUI.bind(this._uiManager, this),
    mustExec: true,
    type: _AnnotationEditorParamsType.INK_OPACITY,
    overwriteIfSameType: true,
    keepUndo: true
  });
}
function _getInitialBBox2() {
  var parentRotation = this.parentRotation,
    _this$parentDimension19 = _slicedToArray(this.parentDimensions, 2),
    width = _this$parentDimension19[0],
    height = _this$parentDimension19[1];
  switch (parentRotation) {
    case 90:
      return [0, height, height, width];
    case 180:
      return [width, height, width, height];
    case 270:
      return [width, 0, height, width];
    default:
      return [0, 0, width, height];
  }
}
function _setStroke2() {
  var ctx = this.ctx,
    color = this.color,
    opacity = this.opacity,
    thickness = this.thickness,
    parentScale = this.parentScale,
    scaleFactor = this.scaleFactor;
  ctx.lineWidth = thickness * parentScale / scaleFactor;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
  ctx.miterLimit = 10;
  ctx.strokeStyle = "".concat(color).concat(opacityToHex(opacity));
}
function _startDrawing2(x, y) {
  var _this104 = this;
  this.canvas.addEventListener("contextmenu", _noContextMenu, {
    signal: this._uiManager._signal
  });
  _classPrivateFieldLooseBase(this, _removePointerdownListener)[_removePointerdownListener]();
  _classPrivateFieldLooseBase(this, _drawingAC)[_drawingAC] = new AbortController();
  var signal = this._uiManager.combinedSignal(_classPrivateFieldLooseBase(this, _drawingAC)[_drawingAC]);
  this.canvas.addEventListener("pointerleave", this.canvasPointerleave.bind(this), {
    signal: signal
  });
  this.canvas.addEventListener("pointermove", this.canvasPointermove.bind(this), {
    signal: signal
  });
  this.canvas.addEventListener("pointerup", this.canvasPointerup.bind(this), {
    signal: signal
  });
  this.isEditing = true;
  if (!_classPrivateFieldLooseBase(this, _isCanvasInitialized)[_isCanvasInitialized]) {
    var _this$opacity2;
    _classPrivateFieldLooseBase(this, _isCanvasInitialized)[_isCanvasInitialized] = true;
    _classPrivateFieldLooseBase(this, _setCanvasDims)[_setCanvasDims]();
    this.thickness || (this.thickness = _InkEditor._defaultThickness);
    this.color || (this.color = _InkEditor._defaultColor || AnnotationEditor._defaultLineColor);
    (_this$opacity2 = this.opacity) !== null && _this$opacity2 !== void 0 ? _this$opacity2 : this.opacity = _InkEditor._defaultOpacity;
  }
  this.currentPath.push([x, y]);
  _classPrivateFieldLooseBase(this, _hasSomethingToDraw)[_hasSomethingToDraw] = false;
  _classPrivateFieldLooseBase(this, _setStroke)[_setStroke]();
  _classPrivateFieldLooseBase(this, _requestFrameCallback)[_requestFrameCallback] = function () {
    _classPrivateFieldLooseBase(_this104, _drawPoints)[_drawPoints]();
    if (_classPrivateFieldLooseBase(_this104, _requestFrameCallback)[_requestFrameCallback]) {
      window.requestAnimationFrame(_classPrivateFieldLooseBase(_this104, _requestFrameCallback)[_requestFrameCallback]);
    }
  };
  window.requestAnimationFrame(_classPrivateFieldLooseBase(this, _requestFrameCallback)[_requestFrameCallback]);
}
function _draw2(x, y) {
  var _classPrivateFieldLoo165;
  var _this$currentPath$at = this.currentPath.at(-1),
    _this$currentPath$at2 = _slicedToArray(_this$currentPath$at, 2),
    lastX = _this$currentPath$at2[0],
    lastY = _this$currentPath$at2[1];
  if (this.currentPath.length > 1 && x === lastX && y === lastY) {
    return;
  }
  var currentPath = this.currentPath;
  var path2D = _classPrivateFieldLooseBase(this, _currentPath2D)[_currentPath2D];
  currentPath.push([x, y]);
  _classPrivateFieldLooseBase(this, _hasSomethingToDraw)[_hasSomethingToDraw] = true;
  if (currentPath.length <= 2) {
    var _path2D;
    (_path2D = path2D).moveTo.apply(_path2D, _toConsumableArray(currentPath[0]));
    path2D.lineTo(x, y);
    return;
  }
  if (currentPath.length === 3) {
    var _path2D2;
    _classPrivateFieldLooseBase(this, _currentPath2D)[_currentPath2D] = path2D = new Path2D();
    (_path2D2 = path2D).moveTo.apply(_path2D2, _toConsumableArray(currentPath[0]));
  }
  (_classPrivateFieldLoo165 = _classPrivateFieldLooseBase(this, _makeBezierCurve))[_makeBezierCurve].apply(_classPrivateFieldLoo165, [path2D].concat(_toConsumableArray(currentPath.at(-3)), _toConsumableArray(currentPath.at(-2)), [x, y]));
}
function _endPath2() {
  var _classPrivateFieldLoo166;
  if (this.currentPath.length === 0) {
    return;
  }
  var lastPoint = this.currentPath.at(-1);
  (_classPrivateFieldLoo166 = _classPrivateFieldLooseBase(this, _currentPath2D)[_currentPath2D]).lineTo.apply(_classPrivateFieldLoo166, _toConsumableArray(lastPoint));
}
function _stopDrawing2(x, y) {
  var _this105 = this;
  _classPrivateFieldLooseBase(this, _requestFrameCallback)[_requestFrameCallback] = null;
  x = Math.min(Math.max(x, 0), this.canvas.width);
  y = Math.min(Math.max(y, 0), this.canvas.height);
  _classPrivateFieldLooseBase(this, _draw)[_draw](x, y);
  _classPrivateFieldLooseBase(this, _endPath)[_endPath]();
  var bezier;
  if (this.currentPath.length !== 1) {
    bezier = _classPrivateFieldLooseBase(this, _generateBezierPoints)[_generateBezierPoints]();
  } else {
    var xy = [x, y];
    bezier = [[xy, xy.slice(), xy.slice(), xy]];
  }
  var path2D = _classPrivateFieldLooseBase(this, _currentPath2D)[_currentPath2D];
  var currentPath = this.currentPath;
  this.currentPath = [];
  _classPrivateFieldLooseBase(this, _currentPath2D)[_currentPath2D] = new Path2D();
  var cmd = function cmd() {
    _this105.allRawPaths.push(currentPath);
    _this105.paths.push(bezier);
    _this105.bezierPath2D.push(path2D);
    _this105._uiManager.rebuild(_this105);
  };
  var undo = function undo() {
    _this105.allRawPaths.pop();
    _this105.paths.pop();
    _this105.bezierPath2D.pop();
    if (_this105.paths.length === 0) {
      _this105.remove();
    } else {
      if (!_this105.canvas) {
        _classPrivateFieldLooseBase(_this105, _createCanvas2)[_createCanvas2]();
        _classPrivateFieldLooseBase(_this105, _createObserver)[_createObserver]();
      }
      _classPrivateFieldLooseBase(_this105, _fitToContent)[_fitToContent]();
    }
  };
  this.addCommands({
    cmd: cmd,
    undo: undo,
    mustExec: true
  });
}
function _drawPoints2() {
  if (!_classPrivateFieldLooseBase(this, _hasSomethingToDraw)[_hasSomethingToDraw]) {
    return;
  }
  _classPrivateFieldLooseBase(this, _hasSomethingToDraw)[_hasSomethingToDraw] = false;
  var thickness = Math.ceil(this.thickness * this.parentScale);
  var lastPoints = this.currentPath.slice(-3);
  var x = lastPoints.map(function (xy) {
    return xy[0];
  });
  var y = lastPoints.map(function (xy) {
    return xy[1];
  });
  var xMin = Math.min.apply(Math, _toConsumableArray(x)) - thickness;
  var xMax = Math.max.apply(Math, _toConsumableArray(x)) + thickness;
  var yMin = Math.min.apply(Math, _toConsumableArray(y)) - thickness;
  var yMax = Math.max.apply(Math, _toConsumableArray(y)) + thickness;
  var ctx = this.ctx;
  ctx.save();
  ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
  var _iterator178 = _createForOfIteratorHelper(this.bezierPath2D),
    _step178;
  try {
    for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
      var path = _step178.value;
      ctx.stroke(path);
    }
  } catch (err) {
    _iterator178.e(err);
  } finally {
    _iterator178.f();
  }
  ctx.stroke(_classPrivateFieldLooseBase(this, _currentPath2D)[_currentPath2D]);
  ctx.restore();
}
function _makeBezierCurve2(path2D, x0, y0, x1, y1, x2, y2) {
  var prevX = (x0 + x1) / 2;
  var prevY = (y0 + y1) / 2;
  var x3 = (x1 + x2) / 2;
  var y3 = (y1 + y2) / 2;
  path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
}
function _generateBezierPoints2() {
  var path = this.currentPath;
  if (path.length <= 2) {
    return [[path[0], path[0], path.at(-1), path.at(-1)]];
  }
  var bezierPoints = [];
  var i;
  var _path$ = _slicedToArray(path[0], 2),
    x0 = _path$[0],
    y0 = _path$[1];
  for (i = 1; i < path.length - 2; i++) {
    var _path$i = _slicedToArray(path[i], 2),
      _x54 = _path$i[0],
      _y8 = _path$i[1];
    var _path = _slicedToArray(path[i + 1], 2),
      _x55 = _path[0],
      _y9 = _path[1];
    var x3 = (_x54 + _x55) / 2;
    var y3 = (_y8 + _y9) / 2;
    var _control = [x0 + 2 * (_x54 - x0) / 3, y0 + 2 * (_y8 - y0) / 3];
    var _control2 = [x3 + 2 * (_x54 - x3) / 3, y3 + 2 * (_y8 - y3) / 3];
    bezierPoints.push([[x0, y0], _control, _control2, [x3, y3]]);
    x0 = x3;
    y0 = y3;
  }
  var _path$i2 = _slicedToArray(path[i], 2),
    x1 = _path$i2[0],
    y1 = _path$i2[1];
  var _path2 = _slicedToArray(path[i + 1], 2),
    x2 = _path2[0],
    y2 = _path2[1];
  var control1 = [x0 + 2 * (x1 - x0) / 3, y0 + 2 * (y1 - y0) / 3];
  var control2 = [x2 + 2 * (x1 - x2) / 3, y2 + 2 * (y1 - y2) / 3];
  bezierPoints.push([[x0, y0], control1, control2, [x2, y2]]);
  return bezierPoints;
}
function _redraw2() {
  if (this.isEmpty()) {
    _classPrivateFieldLooseBase(this, _updateTransform)[_updateTransform]();
    return;
  }
  _classPrivateFieldLooseBase(this, _setStroke)[_setStroke]();
  var canvas = this.canvas,
    ctx = this.ctx;
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  _classPrivateFieldLooseBase(this, _updateTransform)[_updateTransform]();
  var _iterator179 = _createForOfIteratorHelper(this.bezierPath2D),
    _step179;
  try {
    for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
      var path = _step179.value;
      ctx.stroke(path);
    }
  } catch (err) {
    _iterator179.e(err);
  } finally {
    _iterator179.f();
  }
}
function _addPointerdownListener2() {
  if (_classPrivateFieldLooseBase(this, _pointerdownAC)[_pointerdownAC]) {
    return;
  }
  _classPrivateFieldLooseBase(this, _pointerdownAC)[_pointerdownAC] = new AbortController();
  var signal = this._uiManager.combinedSignal(_classPrivateFieldLooseBase(this, _pointerdownAC)[_pointerdownAC]);
  this.canvas.addEventListener("pointerdown", this.canvasPointerdown.bind(this), {
    signal: signal
  });
}
function _removePointerdownListener2() {
  var _this$pointerdownAC;
  (_this$pointerdownAC = this.pointerdownAC) === null || _this$pointerdownAC === void 0 || _this$pointerdownAC.abort();
  this.pointerdownAC = null;
}
function _endDrawing2(event) {
  var _classPrivateFieldLoo167,
    _this106 = this;
  (_classPrivateFieldLoo167 = _classPrivateFieldLooseBase(this, _drawingAC)[_drawingAC]) === null || _classPrivateFieldLoo167 === void 0 || _classPrivateFieldLoo167.abort();
  _classPrivateFieldLooseBase(this, _drawingAC)[_drawingAC] = null;
  _classPrivateFieldLooseBase(this, _addPointerdownListener)[_addPointerdownListener]();
  if (_classPrivateFieldLooseBase(this, _canvasContextMenuTimeoutId)[_canvasContextMenuTimeoutId]) {
    clearTimeout(_classPrivateFieldLooseBase(this, _canvasContextMenuTimeoutId)[_canvasContextMenuTimeoutId]);
  }
  _classPrivateFieldLooseBase(this, _canvasContextMenuTimeoutId)[_canvasContextMenuTimeoutId] = setTimeout(function () {
    _classPrivateFieldLooseBase(_this106, _canvasContextMenuTimeoutId)[_canvasContextMenuTimeoutId] = null;
    _this106.canvas.removeEventListener("contextmenu", _noContextMenu);
  }, 10);
  _classPrivateFieldLooseBase(this, _stopDrawing)[_stopDrawing](event.offsetX, event.offsetY);
  this.addToAnnotationStorage();
  this.setInBackground();
}
function _createCanvas3() {
  this.canvas = document.createElement("canvas");
  this.canvas.width = this.canvas.height = 0;
  this.canvas.className = "inkEditorCanvas";
  this.canvas.setAttribute("data-l10n-id", "pdfjs-ink-canvas");
  this.div.append(this.canvas);
  this.ctx = this.canvas.getContext("2d");
}
function _createObserver2() {
  var _this107 = this;
  _classPrivateFieldLooseBase(this, _observer)[_observer] = new ResizeObserver(function (entries) {
    var rect = entries[0].contentRect;
    if (rect.width && rect.height) {
      _this107.setDimensions(rect.width, rect.height);
    }
  });
  _classPrivateFieldLooseBase(this, _observer)[_observer].observe(this.div);
  this._uiManager._signal.addEventListener("abort", function () {
    var _classPrivateFieldLoo168;
    (_classPrivateFieldLoo168 = _classPrivateFieldLooseBase(_this107, _observer)[_observer]) === null || _classPrivateFieldLoo168 === void 0 || _classPrivateFieldLoo168.disconnect();
    _classPrivateFieldLooseBase(_this107, _observer)[_observer] = null;
  }, {
    once: true
  });
}
function _setCanvasDims2() {
  if (!_classPrivateFieldLooseBase(this, _isCanvasInitialized)[_isCanvasInitialized]) {
    return;
  }
  var _this$parentDimension20 = _slicedToArray(this.parentDimensions, 2),
    parentWidth = _this$parentDimension20[0],
    parentHeight = _this$parentDimension20[1];
  this.canvas.width = Math.ceil(this.width * parentWidth);
  this.canvas.height = Math.ceil(this.height * parentHeight);
  _classPrivateFieldLooseBase(this, _updateTransform)[_updateTransform]();
}
function _setScaleFactor2(width, height) {
  var padding = _classPrivateFieldLooseBase(this, _getPadding)[_getPadding]();
  var scaleFactorW = (width - padding) / _classPrivateFieldLooseBase(this, _baseWidth)[_baseWidth];
  var scaleFactorH = (height - padding) / _classPrivateFieldLooseBase(this, _baseHeight)[_baseHeight];
  this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
}
function _updateTransform2() {
  var padding = _classPrivateFieldLooseBase(this, _getPadding)[_getPadding]() / 2;
  this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
}
function _buildPath2D2(bezier) {
  var path2D = new Path2D();
  for (var i = 0, ii = bezier.length; i < ii; i++) {
    var _bezier$i = _slicedToArray(bezier[i], 4),
      first = _bezier$i[0],
      control1 = _bezier$i[1],
      control2 = _bezier$i[2],
      second = _bezier$i[3];
    if (i === 0) {
      path2D.moveTo.apply(path2D, _toConsumableArray(first));
    }
    path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
  }
  return path2D;
}
function _toPDFCoordinates2(points, rect, rotation) {
  var _rect6 = _slicedToArray(rect, 4),
    blX = _rect6[0],
    blY = _rect6[1],
    trX = _rect6[2],
    trY = _rect6[3];
  switch (rotation) {
    case 0:
      for (var i = 0, ii = points.length; i < ii; i += 2) {
        points[i] += blX;
        points[i + 1] = trY - points[i + 1];
      }
      break;
    case 90:
      for (var _i33 = 0, _ii5 = points.length; _i33 < _ii5; _i33 += 2) {
        var x = points[_i33];
        points[_i33] = points[_i33 + 1] + blX;
        points[_i33 + 1] = x + blY;
      }
      break;
    case 180:
      for (var _i34 = 0, _ii6 = points.length; _i34 < _ii6; _i34 += 2) {
        points[_i34] = trX - points[_i34];
        points[_i34 + 1] += blY;
      }
      break;
    case 270:
      for (var _i35 = 0, _ii7 = points.length; _i35 < _ii7; _i35 += 2) {
        var _x56 = points[_i35];
        points[_i35] = trX - points[_i35 + 1];
        points[_i35 + 1] = trY - _x56;
      }
      break;
    default:
      throw new Error("Invalid rotation");
  }
  return points;
}
function _fromPDFCoordinates2(points, rect, rotation) {
  var _rect7 = _slicedToArray(rect, 4),
    blX = _rect7[0],
    blY = _rect7[1],
    trX = _rect7[2],
    trY = _rect7[3];
  switch (rotation) {
    case 0:
      for (var i = 0, ii = points.length; i < ii; i += 2) {
        points[i] -= blX;
        points[i + 1] = trY - points[i + 1];
      }
      break;
    case 90:
      for (var _i36 = 0, _ii8 = points.length; _i36 < _ii8; _i36 += 2) {
        var x = points[_i36];
        points[_i36] = points[_i36 + 1] - blY;
        points[_i36 + 1] = x - blX;
      }
      break;
    case 180:
      for (var _i37 = 0, _ii9 = points.length; _i37 < _ii9; _i37 += 2) {
        points[_i37] = trX - points[_i37];
        points[_i37 + 1] -= blY;
      }
      break;
    case 270:
      for (var _i38 = 0, _ii10 = points.length; _i38 < _ii10; _i38 += 2) {
        var _x57 = points[_i38];
        points[_i38] = trY - points[_i38 + 1];
        points[_i38 + 1] = trX - _x57;
      }
      break;
    default:
      throw new Error("Invalid rotation");
  }
  return points;
}
function _serializePaths2(s, tx, ty, rect) {
  var paths = [];
  var padding = this.thickness / 2;
  var shiftX = s * tx + padding;
  var shiftY = s * ty + padding;
  var _iterator180 = _createForOfIteratorHelper(this.paths),
    _step180;
  try {
    for (_iterator180.s(); !(_step180 = _iterator180.n()).done;) {
      var bezier = _step180.value;
      var buffer = [];
      var points = [];
      for (var j = 0, jj = bezier.length; j < jj; j++) {
        var _bezier$j = _slicedToArray(bezier[j], 4),
          first = _bezier$j[0],
          control1 = _bezier$j[1],
          control2 = _bezier$j[2],
          second = _bezier$j[3];
        if (first[0] === second[0] && first[1] === second[1] && jj === 1) {
          var p0 = s * first[0] + shiftX;
          var p1 = s * first[1] + shiftY;
          buffer.push(p0, p1);
          points.push(p0, p1);
          break;
        }
        var p10 = s * first[0] + shiftX;
        var p11 = s * first[1] + shiftY;
        var p20 = s * control1[0] + shiftX;
        var p21 = s * control1[1] + shiftY;
        var p30 = s * control2[0] + shiftX;
        var p31 = s * control2[1] + shiftY;
        var p40 = s * second[0] + shiftX;
        var p41 = s * second[1] + shiftY;
        if (j === 0) {
          buffer.push(p10, p11);
          points.push(p10, p11);
        }
        buffer.push(p20, p21, p30, p31, p40, p41);
        points.push(p20, p21);
        if (j === jj - 1) {
          points.push(p40, p41);
        }
      }
      paths.push({
        bezier: _classPrivateFieldLooseBase(_InkEditor, _toPDFCoordinates)[_toPDFCoordinates](buffer, rect, this.rotation),
        points: _classPrivateFieldLooseBase(_InkEditor, _toPDFCoordinates)[_toPDFCoordinates](points, rect, this.rotation)
      });
    }
  } catch (err) {
    _iterator180.e(err);
  } finally {
    _iterator180.f();
  }
  return paths;
}
function _getBbox2() {
  var xMin = Infinity;
  var xMax = -Infinity;
  var yMin = Infinity;
  var yMax = -Infinity;
  var _iterator181 = _createForOfIteratorHelper(this.paths),
    _step181;
  try {
    for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
      var path = _step181.value;
      var _iterator182 = _createForOfIteratorHelper(path),
        _step182;
      try {
        for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
          var _ref183 = _step182.value;
          var _ref184 = _slicedToArray(_ref183, 4);
          var first = _ref184[0];
          var control1 = _ref184[1];
          var control2 = _ref184[2];
          var second = _ref184[3];
          var bbox = _Util.bezierBoundingBox.apply(_Util, _toConsumableArray(first).concat(_toConsumableArray(control1), _toConsumableArray(control2), _toConsumableArray(second)));
          xMin = Math.min(xMin, bbox[0]);
          yMin = Math.min(yMin, bbox[1]);
          xMax = Math.max(xMax, bbox[2]);
          yMax = Math.max(yMax, bbox[3]);
        }
      } catch (err) {
        _iterator182.e(err);
      } finally {
        _iterator182.f();
      }
    }
  } catch (err) {
    _iterator181.e(err);
  } finally {
    _iterator181.f();
  }
  return [xMin, yMin, xMax, yMax];
}
function _getPadding2() {
  return _classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing] ? Math.ceil(this.thickness * this.parentScale) : 0;
}
function _fitToContent2() {
  var firstTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (this.isEmpty()) {
    return;
  }
  if (!_classPrivateFieldLooseBase(this, _disableEditing)[_disableEditing]) {
    _classPrivateFieldLooseBase(this, _redraw)[_redraw]();
    return;
  }
  var bbox = _classPrivateFieldLooseBase(this, _getBbox)[_getBbox]();
  var padding = _classPrivateFieldLooseBase(this, _getPadding)[_getPadding]();
  _classPrivateFieldLooseBase(this, _baseWidth)[_baseWidth] = Math.max(AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
  _classPrivateFieldLooseBase(this, _baseHeight)[_baseHeight] = Math.max(AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
  var width = Math.ceil(padding + _classPrivateFieldLooseBase(this, _baseWidth)[_baseWidth] * this.scaleFactor);
  var height = Math.ceil(padding + _classPrivateFieldLooseBase(this, _baseHeight)[_baseHeight] * this.scaleFactor);
  var _this$parentDimension21 = _slicedToArray(this.parentDimensions, 2),
    parentWidth = _this$parentDimension21[0],
    parentHeight = _this$parentDimension21[1];
  this.width = width / parentWidth;
  this.height = height / parentHeight;
  this.setAspectRatio(width, height);
  var prevTranslationX = this.translationX;
  var prevTranslationY = this.translationY;
  this.translationX = -bbox[0];
  this.translationY = -bbox[1];
  _classPrivateFieldLooseBase(this, _setCanvasDims)[_setCanvasDims]();
  _classPrivateFieldLooseBase(this, _redraw)[_redraw]();
  _classPrivateFieldLooseBase(this, _realWidth)[_realWidth] = width;
  _classPrivateFieldLooseBase(this, _realHeight)[_realHeight] = height;
  this.setDims(width, height);
  var unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
  this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
}
Object.defineProperty(InkEditor, _fromPDFCoordinates, {
  value: _fromPDFCoordinates2
});
Object.defineProperty(InkEditor, _toPDFCoordinates, {
  value: _toPDFCoordinates2
});
Object.defineProperty(InkEditor, _buildPath2D, {
  value: _buildPath2D2
});
InkEditor._defaultColor = null;
InkEditor._defaultOpacity = 1;
InkEditor._defaultThickness = 1;
InkEditor._type = "ink";
InkEditor._editorType = _AnnotationEditorType.INK;
; // ./src/display/editor/stamp.js
var _bitmap = /*#__PURE__*/_classPrivateFieldLooseKey("bitmap");
var _bitmapId = /*#__PURE__*/_classPrivateFieldLooseKey("bitmapId");
var _bitmapPromise = /*#__PURE__*/_classPrivateFieldLooseKey("bitmapPromise");
var _bitmapUrl = /*#__PURE__*/_classPrivateFieldLooseKey("bitmapUrl");
var _bitmapFile = /*#__PURE__*/_classPrivateFieldLooseKey("bitmapFile");
var _bitmapFileName = /*#__PURE__*/_classPrivateFieldLooseKey("bitmapFileName");
var _canvas = /*#__PURE__*/_classPrivateFieldLooseKey("canvas");
var _observer2 = /*#__PURE__*/_classPrivateFieldLooseKey("observer");
var _resizeTimeoutId = /*#__PURE__*/_classPrivateFieldLooseKey("resizeTimeoutId");
var _isSvg = /*#__PURE__*/_classPrivateFieldLooseKey("isSvg");
var _hasBeenAddedInUndoStack = /*#__PURE__*/_classPrivateFieldLooseKey("hasBeenAddedInUndoStack");
var _getBitmapFetched = /*#__PURE__*/_classPrivateFieldLooseKey("getBitmapFetched");
var _getBitmapDone = /*#__PURE__*/_classPrivateFieldLooseKey("getBitmapDone");
var _getBitmap = /*#__PURE__*/_classPrivateFieldLooseKey("getBitmap");
var _createCanvas4 = /*#__PURE__*/_classPrivateFieldLooseKey("createCanvas");
var _setDimensions = /*#__PURE__*/_classPrivateFieldLooseKey("setDimensions");
var _scaleBitmap = /*#__PURE__*/_classPrivateFieldLooseKey("scaleBitmap");
var _drawBitmap = /*#__PURE__*/_classPrivateFieldLooseKey("drawBitmap");
var _serializeBitmap = /*#__PURE__*/_classPrivateFieldLooseKey("serializeBitmap");
var _createObserver3 = /*#__PURE__*/_classPrivateFieldLooseKey("createObserver");
var _hasElementChanged5 = /*#__PURE__*/_classPrivateFieldLooseKey("hasElementChanged");
var StampEditor = /*#__PURE__*/function (_AnnotationEditor6) {
  function StampEditor(params) {
    var _this86;
    _classCallCheck(this, StampEditor);
    _this86 = _callSuper(this, StampEditor, [_objectSpread(_objectSpread({}, params), {}, {
      name: "stampEditor"
    })]);
    Object.defineProperty(_this86, _hasElementChanged5, {
      value: _hasElementChanged6
    });
    Object.defineProperty(_this86, _createObserver3, {
      value: _createObserver4
    });
    Object.defineProperty(_this86, _serializeBitmap, {
      value: _serializeBitmap2
    });
    Object.defineProperty(_this86, _drawBitmap, {
      value: _drawBitmap2
    });
    Object.defineProperty(_this86, _scaleBitmap, {
      value: _scaleBitmap2
    });
    Object.defineProperty(_this86, _setDimensions, {
      value: _setDimensions2
    });
    Object.defineProperty(_this86, _createCanvas4, {
      value: _createCanvas5
    });
    Object.defineProperty(_this86, _getBitmap, {
      value: _getBitmap2
    });
    Object.defineProperty(_this86, _getBitmapDone, {
      value: _getBitmapDone2
    });
    Object.defineProperty(_this86, _getBitmapFetched, {
      value: _getBitmapFetched2
    });
    Object.defineProperty(_this86, _bitmap, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this86, _bitmapId, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this86, _bitmapPromise, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this86, _bitmapUrl, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this86, _bitmapFile, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this86, _bitmapFileName, {
      writable: true,
      value: ""
    });
    Object.defineProperty(_this86, _canvas, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this86, _observer2, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this86, _resizeTimeoutId, {
      writable: true,
      value: null
    });
    Object.defineProperty(_this86, _isSvg, {
      writable: true,
      value: false
    });
    Object.defineProperty(_this86, _hasBeenAddedInUndoStack, {
      writable: true,
      value: false
    });
    _classPrivateFieldLooseBase(_this86, _bitmapUrl)[_bitmapUrl] = params.bitmapUrl;
    _classPrivateFieldLooseBase(_this86, _bitmapFile)[_bitmapFile] = params.bitmapFile;
    return _this86;
  }
  _inherits(StampEditor, _AnnotationEditor6);
  return _createClass(StampEditor, [{
    key: "altTextFinish",
    value: function altTextFinish() {
      if (this._uiManager.useNewAltTextFlow) {
        this.div.hidden = false;
      }
      _superPropGet(StampEditor, "altTextFinish", this, 3)([]);
    }
  }, {
    key: "telemetryFinalData",
    get: function get() {
      var _this$altTextData;
      return {
        type: "stamp",
        hasAltText: !!((_this$altTextData = this.altTextData) !== null && _this$altTextData !== void 0 && _this$altTextData.altText)
      };
    }
  }, {
    key: "mlGuessAltText",
    value: function () {
      var _mlGuessAltText = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        var imageData,
          updateAltTextData,
          mlManager,
          _ref160,
          data,
          width,
          height,
          response,
          altText,
          _args47 = arguments;
        return _regeneratorRuntime().wrap(function _callee46$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              imageData = _args47.length > 0 && _args47[0] !== undefined ? _args47[0] : null;
              updateAltTextData = _args47.length > 1 && _args47[1] !== undefined ? _args47[1] : true;
              if (!this.hasAltTextData()) {
                _context47.next = 4;
                break;
              }
              return _context47.abrupt("return", null);
            case 4:
              mlManager = this._uiManager.mlManager;
              if (mlManager) {
                _context47.next = 7;
                break;
              }
              throw new Error("No ML.");
            case 7:
              _context47.next = 9;
              return mlManager.isEnabledFor("altText");
            case 9:
              if (_context47.sent) {
                _context47.next = 11;
                break;
              }
              throw new Error("ML isn't enabled for alt text.");
            case 11:
              _ref160 = imageData || this.copyCanvas(null, null, true).imageData, data = _ref160.data, width = _ref160.width, height = _ref160.height;
              _context47.next = 14;
              return mlManager.guess({
                name: "altText",
                request: {
                  data: data,
                  width: width,
                  height: height,
                  channels: data.length / (width * height)
                }
              });
            case 14:
              response = _context47.sent;
              if (response) {
                _context47.next = 17;
                break;
              }
              throw new Error("No response from the AI service.");
            case 17:
              if (!response.error) {
                _context47.next = 19;
                break;
              }
              throw new Error("Error from the AI service.");
            case 19:
              if (!response.cancel) {
                _context47.next = 21;
                break;
              }
              return _context47.abrupt("return", null);
            case 21:
              if (response.output) {
                _context47.next = 23;
                break;
              }
              throw new Error("No valid response from the AI service.");
            case 23:
              altText = response.output;
              _context47.next = 26;
              return this.setGuessedAltText(altText);
            case 26:
              if (updateAltTextData && !this.hasAltTextData()) {
                this.altTextData = {
                  alt: altText,
                  decorative: false
                };
              }
              return _context47.abrupt("return", altText);
            case 28:
            case "end":
              return _context47.stop();
          }
        }, _callee46, this);
      }));
      function mlGuessAltText() {
        return _mlGuessAltText.apply(this, arguments);
      }
      return mlGuessAltText;
    }()
  }, {
    key: "remove",
    value: function remove() {
      if (_classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId]) {
        var _classPrivateFieldLoo110, _classPrivateFieldLoo111;
        _classPrivateFieldLooseBase(this, _bitmap)[_bitmap] = null;
        this._uiManager.imageManager.deleteId(_classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId]);
        (_classPrivateFieldLoo110 = _classPrivateFieldLooseBase(this, _canvas)[_canvas]) === null || _classPrivateFieldLoo110 === void 0 || _classPrivateFieldLoo110.remove();
        _classPrivateFieldLooseBase(this, _canvas)[_canvas] = null;
        (_classPrivateFieldLoo111 = _classPrivateFieldLooseBase(this, _observer2)[_observer2]) === null || _classPrivateFieldLoo111 === void 0 || _classPrivateFieldLoo111.disconnect();
        _classPrivateFieldLooseBase(this, _observer2)[_observer2] = null;
        if (_classPrivateFieldLooseBase(this, _resizeTimeoutId)[_resizeTimeoutId]) {
          clearTimeout(_classPrivateFieldLooseBase(this, _resizeTimeoutId)[_resizeTimeoutId]);
          _classPrivateFieldLooseBase(this, _resizeTimeoutId)[_resizeTimeoutId] = null;
        }
      }
      _superPropGet(StampEditor, "remove", this, 3)([]);
    }
  }, {
    key: "rebuild",
    value: function rebuild() {
      if (!this.parent) {
        if (_classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId]) {
          _classPrivateFieldLooseBase(this, _getBitmap)[_getBitmap]();
        }
        return;
      }
      _superPropGet(StampEditor, "rebuild", this, 3)([]);
      if (this.div === null) {
        return;
      }
      if (_classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId] && _classPrivateFieldLooseBase(this, _canvas)[_canvas] === null) {
        _classPrivateFieldLooseBase(this, _getBitmap)[_getBitmap]();
      }
      if (!this.isAttachedToDOM) {
        this.parent.add(this);
      }
    }
  }, {
    key: "onceAdded",
    value: function onceAdded() {
      this._isDraggable = true;
      this.div.focus();
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !(_classPrivateFieldLooseBase(this, _bitmapPromise)[_bitmapPromise] || _classPrivateFieldLooseBase(this, _bitmap)[_bitmap] || _classPrivateFieldLooseBase(this, _bitmapUrl)[_bitmapUrl] || _classPrivateFieldLooseBase(this, _bitmapFile)[_bitmapFile] || _classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId]);
    }
  }, {
    key: "isResizable",
    get: function get() {
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.div) {
        return this.div;
      }
      var baseX, baseY;
      if (this.width) {
        baseX = this.x;
        baseY = this.y;
      }
      _superPropGet(StampEditor, "render", this, 3)([]);
      this.div.hidden = true;
      this.div.setAttribute("role", "figure");
      this.addAltTextButton();
      if (_classPrivateFieldLooseBase(this, _bitmap)[_bitmap]) {
        _classPrivateFieldLooseBase(this, _createCanvas4)[_createCanvas4]();
      } else {
        _classPrivateFieldLooseBase(this, _getBitmap)[_getBitmap]();
      }
      if (this.width && !this.annotationElementId) {
        var _this$parentDimension13 = _slicedToArray(this.parentDimensions, 2),
          parentWidth = _this$parentDimension13[0],
          parentHeight = _this$parentDimension13[1];
        this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
      }
      return this.div;
    }
  }, {
    key: "copyCanvas",
    value: function copyCanvas(maxDataDimension, maxPreviewDimension) {
      var createImageData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!maxDataDimension) {
        maxDataDimension = 224;
      }
      var _classPrivateFieldLoo112 = _classPrivateFieldLooseBase(this, _bitmap)[_bitmap],
        bitmapWidth = _classPrivateFieldLoo112.width,
        bitmapHeight = _classPrivateFieldLoo112.height;
      var outputScale = new _OutputScale();
      var bitmap = _classPrivateFieldLooseBase(this, _bitmap)[_bitmap];
      var width = bitmapWidth,
        height = bitmapHeight;
      var canvas = null;
      if (maxPreviewDimension) {
        var _window$matchMedia, _window2;
        if (bitmapWidth > maxPreviewDimension || bitmapHeight > maxPreviewDimension) {
          var ratio = Math.min(maxPreviewDimension / bitmapWidth, maxPreviewDimension / bitmapHeight);
          width = Math.floor(bitmapWidth * ratio);
          height = Math.floor(bitmapHeight * ratio);
        }
        canvas = document.createElement("canvas");
        var scaledWidth = canvas.width = Math.ceil(width * outputScale.sx);
        var scaledHeight = canvas.height = Math.ceil(height * outputScale.sy);
        if (!_classPrivateFieldLooseBase(this, _isSvg)[_isSvg]) {
          bitmap = _classPrivateFieldLooseBase(this, _scaleBitmap)[_scaleBitmap](scaledWidth, scaledHeight);
        }
        var ctx = canvas.getContext("2d");
        ctx.filter = this._uiManager.hcmFilter;
        var white = "white",
          black = "#cfcfd8";
        if (this._uiManager.hcmFilter !== "none") {
          black = "black";
        } else if ((_window$matchMedia = (_window2 = window).matchMedia) !== null && _window$matchMedia !== void 0 && _window$matchMedia.call(_window2, "(prefers-color-scheme: dark)").matches) {
          white = "#8f8f9d";
          black = "#42414d";
        }
        var boxDim = 15;
        var boxDimWidth = boxDim * outputScale.sx;
        var boxDimHeight = boxDim * outputScale.sy;
        var pattern = new OffscreenCanvas(boxDimWidth * 2, boxDimHeight * 2);
        var patternCtx = pattern.getContext("2d");
        patternCtx.fillStyle = white;
        patternCtx.fillRect(0, 0, boxDimWidth * 2, boxDimHeight * 2);
        patternCtx.fillStyle = black;
        patternCtx.fillRect(0, 0, boxDimWidth, boxDimHeight);
        patternCtx.fillRect(boxDimWidth, boxDimHeight, boxDimWidth, boxDimHeight);
        ctx.fillStyle = ctx.createPattern(pattern, "repeat");
        ctx.fillRect(0, 0, scaledWidth, scaledHeight);
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
      }
      var imageData = null;
      if (createImageData) {
        var dataWidth, dataHeight;
        if (outputScale.symmetric && bitmap.width < maxDataDimension && bitmap.height < maxDataDimension) {
          dataWidth = bitmap.width;
          dataHeight = bitmap.height;
        } else {
          bitmap = _classPrivateFieldLooseBase(this, _bitmap)[_bitmap];
          if (bitmapWidth > maxDataDimension || bitmapHeight > maxDataDimension) {
            var _ratio = Math.min(maxDataDimension / bitmapWidth, maxDataDimension / bitmapHeight);
            dataWidth = Math.floor(bitmapWidth * _ratio);
            dataHeight = Math.floor(bitmapHeight * _ratio);
            if (!_classPrivateFieldLooseBase(this, _isSvg)[_isSvg]) {
              bitmap = _classPrivateFieldLooseBase(this, _scaleBitmap)[_scaleBitmap](dataWidth, dataHeight);
            }
          }
        }
        var offscreen = new OffscreenCanvas(dataWidth, dataHeight);
        var offscreenCtx = offscreen.getContext("2d", {
          willReadFrequently: true
        });
        offscreenCtx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, dataWidth, dataHeight);
        imageData = {
          width: dataWidth,
          height: dataHeight,
          data: offscreenCtx.getImageData(0, 0, dataWidth, dataHeight).data
        };
      }
      return {
        canvas: canvas,
        width: width,
        height: height,
        imageData: imageData
      };
    }
  }, {
    key: "getImageForAltText",
    value: function getImageForAltText() {
      return _classPrivateFieldLooseBase(this, _canvas)[_canvas];
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var isForCopying = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (this.isEmpty()) {
        return null;
      }
      if (this.deleted) {
        return this.serializeDeleted();
      }
      var serialized = {
        annotationType: _AnnotationEditorType.STAMP,
        bitmapId: _classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId],
        pageIndex: this.pageIndex,
        rect: this.getRect(0, 0),
        rotation: this.rotation,
        isSvg: _classPrivateFieldLooseBase(this, _isSvg)[_isSvg],
        structTreeParentId: this._structTreeParentId
      };
      if (isForCopying) {
        serialized.bitmapUrl = _classPrivateFieldLooseBase(this, _serializeBitmap)[_serializeBitmap](true);
        serialized.accessibilityData = this.serializeAltText(true);
        return serialized;
      }
      var _this$serializeAltTex = this.serializeAltText(false),
        decorative = _this$serializeAltTex.decorative,
        altText = _this$serializeAltTex.altText;
      if (!decorative && altText) {
        serialized.accessibilityData = {
          type: "Figure",
          alt: altText
        };
      }
      if (this.annotationElementId) {
        var changes = _classPrivateFieldLooseBase(this, _hasElementChanged5)[_hasElementChanged5](serialized);
        if (changes.isSame) {
          return null;
        }
        if (changes.isSameAltText) {
          delete serialized.accessibilityData;
        } else {
          var _this$_initialData$st;
          serialized.accessibilityData.structParent = (_this$_initialData$st = this._initialData.structParent) !== null && _this$_initialData$st !== void 0 ? _this$_initialData$st : -1;
        }
      }
      serialized.id = this.annotationElementId;
      if (context === null) {
        return serialized;
      }
      context.stamps || (context.stamps = new Map());
      var area = _classPrivateFieldLooseBase(this, _isSvg)[_isSvg] ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
      if (!context.stamps.has(_classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId])) {
        context.stamps.set(_classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId], {
          area: area,
          serialized: serialized
        });
        serialized.bitmap = _classPrivateFieldLooseBase(this, _serializeBitmap)[_serializeBitmap](false);
      } else if (_classPrivateFieldLooseBase(this, _isSvg)[_isSvg]) {
        var prevData = context.stamps.get(_classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId]);
        if (area > prevData.area) {
          prevData.area = area;
          prevData.serialized.bitmap.close();
          prevData.serialized.bitmap = _classPrivateFieldLooseBase(this, _serializeBitmap)[_serializeBitmap](false);
        }
      }
      return serialized;
    }
  }, {
    key: "renderAnnotationElement",
    value: function renderAnnotationElement(annotation) {
      annotation.updateEdited({
        rect: this.getRect(0, 0)
      });
      return null;
    }
  }], [{
    key: "initialize",
    value: function initialize(l10n, uiManager) {
      AnnotationEditor.initialize(l10n, uiManager);
    }
  }, {
    key: "supportedTypes",
    get: function get() {
      var types = ["apng", "avif", "bmp", "gif", "jpeg", "png", "svg+xml", "webp", "x-icon"];
      return _shadow(this, "supportedTypes", types.map(function (type) {
        return "image/".concat(type);
      }));
    }
  }, {
    key: "supportedTypesStr",
    get: function get() {
      return _shadow(this, "supportedTypesStr", this.supportedTypes.join(","));
    }
  }, {
    key: "isHandlingMimeForPasting",
    value: function isHandlingMimeForPasting(mime) {
      return this.supportedTypes.includes(mime);
    }
  }, {
    key: "paste",
    value: function paste(item, parent) {
      parent.pasteEditor(_AnnotationEditorType.STAMP, {
        bitmapFile: item.getAsFile()
      });
    }
  }, {
    key: "computeTelemetryFinalData",
    value: function computeTelemetryFinalData(data) {
      var _hasAltTextStats$get, _hasAltTextStats$get2;
      var hasAltTextStats = data.get("hasAltText");
      return {
        hasAltText: (_hasAltTextStats$get = hasAltTextStats.get(true)) !== null && _hasAltTextStats$get !== void 0 ? _hasAltTextStats$get : 0,
        hasNoAltText: (_hasAltTextStats$get2 = hasAltTextStats.get(false)) !== null && _hasAltTextStats$get2 !== void 0 ? _hasAltTextStats$get2 : 0
      };
    }
  }, {
    key: "deserialize",
    value: function () {
      var _deserialize5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee47(data, parent, uiManager) {
        var initialData, _yield$parent$_struct, _data7, _data7$data, _rect5, rotation, _id19, structParent, popupRef, container, pageNumber, canvas, imageData, altText, editor, _data8, rect, bitmap, bitmapUrl, bitmapId, isSvg, accessibilityData, _editor$pageDimension4, parentWidth, parentHeight;
        return _regeneratorRuntime().wrap(function _callee47$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              initialData = null;
              if (!(data instanceof StampAnnotationElement)) {
                _context48.next = 22;
                break;
              }
              _data7 = data, _data7$data = _data7.data, _rect5 = _data7$data.rect, rotation = _data7$data.rotation, _id19 = _data7$data.id, structParent = _data7$data.structParent, popupRef = _data7$data.popupRef, container = _data7.container, pageNumber = _data7.parent.page.pageNumber;
              canvas = container.querySelector("canvas");
              imageData = uiManager.imageManager.getFromCanvas(container.id, canvas);
              canvas.remove();
              _context48.next = 8;
              return parent._structTree.getAriaAttributes("".concat(AnnotationPrefix).concat(_id19));
            case 8:
              _context48.t2 = _yield$parent$_struct = _context48.sent;
              _context48.t1 = _context48.t2 === null;
              if (_context48.t1) {
                _context48.next = 12;
                break;
              }
              _context48.t1 = _yield$parent$_struct === void 0;
            case 12:
              if (!_context48.t1) {
                _context48.next = 16;
                break;
              }
              _context48.t3 = void 0;
              _context48.next = 17;
              break;
            case 16:
              _context48.t3 = _yield$parent$_struct.get("aria-label");
            case 17:
              _context48.t0 = _context48.t3;
              if (_context48.t0) {
                _context48.next = 20;
                break;
              }
              _context48.t0 = "";
            case 20:
              altText = _context48.t0;
              initialData = data = {
                annotationType: _AnnotationEditorType.STAMP,
                bitmapId: imageData.id,
                bitmap: imageData.bitmap,
                pageIndex: pageNumber - 1,
                rect: _rect5.slice(0),
                rotation: rotation,
                id: _id19,
                deleted: false,
                accessibilityData: {
                  decorative: false,
                  altText: altText
                },
                isSvg: false,
                structParent: structParent,
                popupRef: popupRef
              };
            case 22:
              _context48.next = 24;
              return _superPropGet(StampEditor, "deserialize", this, 2)([data, parent, uiManager]);
            case 24:
              editor = _context48.sent;
              _data8 = data, rect = _data8.rect, bitmap = _data8.bitmap, bitmapUrl = _data8.bitmapUrl, bitmapId = _data8.bitmapId, isSvg = _data8.isSvg, accessibilityData = _data8.accessibilityData;
              if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) {
                _classPrivateFieldLooseBase(editor, _bitmapId)[_bitmapId] = bitmapId;
                if (bitmap) {
                  _classPrivateFieldLooseBase(editor, _bitmap)[_bitmap] = bitmap;
                }
              } else {
                _classPrivateFieldLooseBase(editor, _bitmapUrl)[_bitmapUrl] = bitmapUrl;
              }
              _classPrivateFieldLooseBase(editor, _isSvg)[_isSvg] = isSvg;
              _editor$pageDimension4 = _slicedToArray(editor.pageDimensions, 2), parentWidth = _editor$pageDimension4[0], parentHeight = _editor$pageDimension4[1];
              editor.width = (rect[2] - rect[0]) / parentWidth;
              editor.height = (rect[3] - rect[1]) / parentHeight;
              editor.annotationElementId = data.id || null;
              if (accessibilityData) {
                editor.altTextData = accessibilityData;
              }
              editor._initialData = initialData;
              _classPrivateFieldLooseBase(editor, _hasBeenAddedInUndoStack)[_hasBeenAddedInUndoStack] = !!initialData;
              return _context48.abrupt("return", editor);
            case 36:
            case "end":
              return _context48.stop();
          }
        }, _callee47, this);
      }));
      function deserialize(_x43, _x44, _x45) {
        return _deserialize5.apply(this, arguments);
      }
      return deserialize;
    }()
  }]);
}(AnnotationEditor);
_StampEditor = StampEditor;
function _getBitmapFetched2(data) {
  var fromId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!data) {
    this.remove();
    return;
  }
  _classPrivateFieldLooseBase(this, _bitmap)[_bitmap] = data.bitmap;
  if (!fromId) {
    _classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId] = data.id;
    _classPrivateFieldLooseBase(this, _isSvg)[_isSvg] = data.isSvg;
  }
  if (data.file) {
    _classPrivateFieldLooseBase(this, _bitmapFileName)[_bitmapFileName] = data.file.name;
  }
  _classPrivateFieldLooseBase(this, _createCanvas4)[_createCanvas4]();
}
function _getBitmapDone2() {
  _classPrivateFieldLooseBase(this, _bitmapPromise)[_bitmapPromise] = null;
  this._uiManager.enableWaiting(false);
  if (!_classPrivateFieldLooseBase(this, _canvas)[_canvas]) {
    return;
  }
  if (this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && _classPrivateFieldLooseBase(this, _bitmap)[_bitmap]) {
    this._editToolbar.hide();
    this._uiManager.editAltText(this, true);
    return;
  }
  if (!this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && _classPrivateFieldLooseBase(this, _bitmap)[_bitmap]) {
    this._reportTelemetry({
      action: "pdfjs.image.image_added",
      data: {
        alt_text_modal: false,
        alt_text_type: "empty"
      }
    });
    try {
      this.mlGuessAltText();
    } catch (_unused15) {}
  }
  this.div.focus();
}
function _getBitmap2() {
  var _this108 = this;
  if (_classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId]) {
    this._uiManager.enableWaiting(true);
    this._uiManager.imageManager.getFromId(_classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId]).then(function (data) {
      return _classPrivateFieldLooseBase(_this108, _getBitmapFetched)[_getBitmapFetched](data, true);
    }).finally(function () {
      return _classPrivateFieldLooseBase(_this108, _getBitmapDone)[_getBitmapDone]();
    });
    return;
  }
  if (_classPrivateFieldLooseBase(this, _bitmapUrl)[_bitmapUrl]) {
    var url = _classPrivateFieldLooseBase(this, _bitmapUrl)[_bitmapUrl];
    _classPrivateFieldLooseBase(this, _bitmapUrl)[_bitmapUrl] = null;
    this._uiManager.enableWaiting(true);
    _classPrivateFieldLooseBase(this, _bitmapPromise)[_bitmapPromise] = this._uiManager.imageManager.getFromUrl(url).then(function (data) {
      return _classPrivateFieldLooseBase(_this108, _getBitmapFetched)[_getBitmapFetched](data);
    }).finally(function () {
      return _classPrivateFieldLooseBase(_this108, _getBitmapDone)[_getBitmapDone]();
    });
    return;
  }
  if (_classPrivateFieldLooseBase(this, _bitmapFile)[_bitmapFile]) {
    var file = _classPrivateFieldLooseBase(this, _bitmapFile)[_bitmapFile];
    _classPrivateFieldLooseBase(this, _bitmapFile)[_bitmapFile] = null;
    this._uiManager.enableWaiting(true);
    _classPrivateFieldLooseBase(this, _bitmapPromise)[_bitmapPromise] = this._uiManager.imageManager.getFromFile(file).then(function (data) {
      return _classPrivateFieldLooseBase(_this108, _getBitmapFetched)[_getBitmapFetched](data);
    }).finally(function () {
      return _classPrivateFieldLooseBase(_this108, _getBitmapDone)[_getBitmapDone]();
    });
    return;
  }
  var input = document.createElement("input");
  input.type = "file";
  input.accept = _StampEditor.supportedTypesStr;
  var signal = this._uiManager._signal;
  _classPrivateFieldLooseBase(this, _bitmapPromise)[_bitmapPromise] = new Promise(function (resolve) {
    input.addEventListener("change", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
      var data;
      return _regeneratorRuntime().wrap(function _callee52$(_context53) {
        while (1) switch (_context53.prev = _context53.next) {
          case 0:
            if (!(!input.files || input.files.length === 0)) {
              _context53.next = 4;
              break;
            }
            _this108.remove();
            _context53.next = 10;
            break;
          case 4:
            _this108._uiManager.enableWaiting(true);
            _context53.next = 7;
            return _this108._uiManager.imageManager.getFromFile(input.files[0]);
          case 7:
            data = _context53.sent;
            _this108._reportTelemetry({
              action: "pdfjs.image.image_selected",
              data: {
                alt_text_modal: _this108._uiManager.useNewAltTextFlow
              }
            });
            _classPrivateFieldLooseBase(_this108, _getBitmapFetched)[_getBitmapFetched](data);
          case 10:
            resolve();
          case 11:
          case "end":
            return _context53.stop();
        }
      }, _callee52);
    })), {
      signal: signal
    });
    input.addEventListener("cancel", function () {
      _this108.remove();
      resolve();
    }, {
      signal: signal
    });
  }).finally(function () {
    return _classPrivateFieldLooseBase(_this108, _getBitmapDone)[_getBitmapDone]();
  });
  input.click();
}
function _createCanvas5() {
  var div = this.div;
  var _classPrivateFieldLoo169 = _classPrivateFieldLooseBase(this, _bitmap)[_bitmap],
    width = _classPrivateFieldLoo169.width,
    height = _classPrivateFieldLoo169.height;
  var _this$pageDimensions9 = _slicedToArray(this.pageDimensions, 2),
    pageWidth = _this$pageDimensions9[0],
    pageHeight = _this$pageDimensions9[1];
  var MAX_RATIO = 0.75;
  if (this.width) {
    width = this.width * pageWidth;
    height = this.height * pageHeight;
  } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
    var factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
    width *= factor;
    height *= factor;
  }
  var _this$parentDimension22 = _slicedToArray(this.parentDimensions, 2),
    parentWidth = _this$parentDimension22[0],
    parentHeight = _this$parentDimension22[1];
  this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
  this._uiManager.enableWaiting(false);
  var canvas = _classPrivateFieldLooseBase(this, _canvas)[_canvas] = document.createElement("canvas");
  canvas.setAttribute("role", "img");
  this.addContainer(canvas);
  if (!this._uiManager.useNewAltTextWhenAddingImage || !this._uiManager.useNewAltTextFlow || this.annotationElementId) {
    div.hidden = false;
  }
  _classPrivateFieldLooseBase(this, _drawBitmap)[_drawBitmap](width, height);
  _classPrivateFieldLooseBase(this, _createObserver3)[_createObserver3]();
  if (!_classPrivateFieldLooseBase(this, _hasBeenAddedInUndoStack)[_hasBeenAddedInUndoStack]) {
    this.parent.addUndoableEditor(this);
    _classPrivateFieldLooseBase(this, _hasBeenAddedInUndoStack)[_hasBeenAddedInUndoStack] = true;
  }
  this._reportTelemetry({
    action: "inserted_image"
  });
  if (_classPrivateFieldLooseBase(this, _bitmapFileName)[_bitmapFileName]) {
    canvas.setAttribute("aria-label", _classPrivateFieldLooseBase(this, _bitmapFileName)[_bitmapFileName]);
  }
}
function _setDimensions2(width, height) {
  var _this$_initialOptions2,
    _this109 = this;
  var _this$parentDimension23 = _slicedToArray(this.parentDimensions, 2),
    parentWidth = _this$parentDimension23[0],
    parentHeight = _this$parentDimension23[1];
  this.width = width / parentWidth;
  this.height = height / parentHeight;
  if ((_this$_initialOptions2 = this._initialOptions) !== null && _this$_initialOptions2 !== void 0 && _this$_initialOptions2.isCentered) {
    this.center();
  } else {
    this.fixAndSetPosition();
  }
  this._initialOptions = null;
  if (_classPrivateFieldLooseBase(this, _resizeTimeoutId)[_resizeTimeoutId] !== null) {
    clearTimeout(_classPrivateFieldLooseBase(this, _resizeTimeoutId)[_resizeTimeoutId]);
  }
  var TIME_TO_WAIT = 200;
  _classPrivateFieldLooseBase(this, _resizeTimeoutId)[_resizeTimeoutId] = setTimeout(function () {
    _classPrivateFieldLooseBase(_this109, _resizeTimeoutId)[_resizeTimeoutId] = null;
    _classPrivateFieldLooseBase(_this109, _drawBitmap)[_drawBitmap](width, height);
  }, TIME_TO_WAIT);
}
function _scaleBitmap2(width, height) {
  var _classPrivateFieldLoo170 = _classPrivateFieldLooseBase(this, _bitmap)[_bitmap],
    bitmapWidth = _classPrivateFieldLoo170.width,
    bitmapHeight = _classPrivateFieldLoo170.height;
  var newWidth = bitmapWidth;
  var newHeight = bitmapHeight;
  var bitmap = _classPrivateFieldLooseBase(this, _bitmap)[_bitmap];
  while (newWidth > 2 * width || newHeight > 2 * height) {
    var prevWidth = newWidth;
    var prevHeight = newHeight;
    if (newWidth > 2 * width) {
      newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
    }
    if (newHeight > 2 * height) {
      newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
    }
    var offscreen = new OffscreenCanvas(newWidth, newHeight);
    var ctx = offscreen.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
    bitmap = offscreen.transferToImageBitmap();
  }
  return bitmap;
}
function _drawBitmap2(width, height) {
  var outputScale = new _OutputScale();
  var scaledWidth = Math.ceil(width * outputScale.sx);
  var scaledHeight = Math.ceil(height * outputScale.sy);
  var canvas = _classPrivateFieldLooseBase(this, _canvas)[_canvas];
  if (!canvas || canvas.width === scaledWidth && canvas.height === scaledHeight) {
    return;
  }
  canvas.width = scaledWidth;
  canvas.height = scaledHeight;
  var bitmap = _classPrivateFieldLooseBase(this, _isSvg)[_isSvg] ? _classPrivateFieldLooseBase(this, _bitmap)[_bitmap] : _classPrivateFieldLooseBase(this, _scaleBitmap)[_scaleBitmap](scaledWidth, scaledHeight);
  var ctx = canvas.getContext("2d");
  ctx.filter = this._uiManager.hcmFilter;
  ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
}
function _serializeBitmap2(toUrl) {
  if (toUrl) {
    if (_classPrivateFieldLooseBase(this, _isSvg)[_isSvg]) {
      var url = this._uiManager.imageManager.getSvgUrl(_classPrivateFieldLooseBase(this, _bitmapId)[_bitmapId]);
      if (url) {
        return url;
      }
    }
    var canvas = document.createElement("canvas");
    var _classPrivateFieldLoo171 = _classPrivateFieldLooseBase(this, _bitmap)[_bitmap];
    canvas.width = _classPrivateFieldLoo171.width;
    canvas.height = _classPrivateFieldLoo171.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(_classPrivateFieldLooseBase(this, _bitmap)[_bitmap], 0, 0);
    return canvas.toDataURL();
  }
  if (_classPrivateFieldLooseBase(this, _isSvg)[_isSvg]) {
    var _this$pageDimensions10 = _slicedToArray(this.pageDimensions, 2),
      pageWidth = _this$pageDimensions10[0],
      pageHeight = _this$pageDimensions10[1];
    var width = Math.round(this.width * pageWidth * _PixelsPerInch.PDF_TO_CSS_UNITS);
    var height = Math.round(this.height * pageHeight * _PixelsPerInch.PDF_TO_CSS_UNITS);
    var offscreen = new OffscreenCanvas(width, height);
    var _ctx = offscreen.getContext("2d");
    _ctx.drawImage(_classPrivateFieldLooseBase(this, _bitmap)[_bitmap], 0, 0, _classPrivateFieldLooseBase(this, _bitmap)[_bitmap].width, _classPrivateFieldLooseBase(this, _bitmap)[_bitmap].height, 0, 0, width, height);
    return offscreen.transferToImageBitmap();
  }
  return structuredClone(_classPrivateFieldLooseBase(this, _bitmap)[_bitmap]);
}
function _createObserver4() {
  var _this110 = this;
  if (!this._uiManager._signal) {
    return;
  }
  _classPrivateFieldLooseBase(this, _observer2)[_observer2] = new ResizeObserver(function (entries) {
    var rect = entries[0].contentRect;
    if (rect.width && rect.height) {
      _classPrivateFieldLooseBase(_this110, _setDimensions)[_setDimensions](rect.width, rect.height);
    }
  });
  _classPrivateFieldLooseBase(this, _observer2)[_observer2].observe(this.div);
  this._uiManager._signal.addEventListener("abort", function () {
    var _classPrivateFieldLoo172;
    (_classPrivateFieldLoo172 = _classPrivateFieldLooseBase(_this110, _observer2)[_observer2]) === null || _classPrivateFieldLoo172 === void 0 || _classPrivateFieldLoo172.disconnect();
    _classPrivateFieldLooseBase(_this110, _observer2)[_observer2] = null;
  }, {
    once: true
  });
}
function _hasElementChanged6(serialized) {
  var _serialized$accessibi;
  var _this$_initialData3 = this._initialData,
    rect = _this$_initialData3.rect,
    pageIndex = _this$_initialData3.pageIndex,
    altText = _this$_initialData3.accessibilityData.altText;
  var isSameRect = serialized.rect.every(function (x, i) {
    return Math.abs(x - rect[i]) < 1;
  });
  var isSamePageIndex = serialized.pageIndex === pageIndex;
  var isSameAltText = (((_serialized$accessibi = serialized.accessibilityData) === null || _serialized$accessibi === void 0 ? void 0 : _serialized$accessibi.alt) || "") === altText;
  return {
    isSame: isSameRect && isSamePageIndex && isSameAltText,
    isSameAltText: isSameAltText
  };
}
StampEditor._type = "stamp";
StampEditor._editorType = _AnnotationEditorType.STAMP;
; // ./src/display/editor/annotation_editor_layer.js
var _accessibilityManager2 = /*#__PURE__*/_classPrivateFieldLooseKey("accessibilityManager");
var _allowClick = /*#__PURE__*/_classPrivateFieldLooseKey("allowClick");
var _annotationLayer = /*#__PURE__*/_classPrivateFieldLooseKey("annotationLayer");
var _clickAC = /*#__PURE__*/_classPrivateFieldLooseKey("clickAC");
var _editorFocusTimeoutId = /*#__PURE__*/_classPrivateFieldLooseKey("editorFocusTimeoutId");
var _editors = /*#__PURE__*/_classPrivateFieldLooseKey("editors");
var _hadPointerDown = /*#__PURE__*/_classPrivateFieldLooseKey("hadPointerDown");
var _isCleaningUp = /*#__PURE__*/_classPrivateFieldLooseKey("isCleaningUp");
var _isDisabling = /*#__PURE__*/_classPrivateFieldLooseKey("isDisabling");
var _textLayer = /*#__PURE__*/_classPrivateFieldLooseKey("textLayer");
var _textSelectionAC = /*#__PURE__*/_classPrivateFieldLooseKey("textSelectionAC");
var _uiManager4 = /*#__PURE__*/_classPrivateFieldLooseKey("uiManager");
var _editorTypes2 = /*#__PURE__*/_classPrivateFieldLooseKey("editorTypes");
var _textLayerPointerDown = /*#__PURE__*/_classPrivateFieldLooseKey("textLayerPointerDown");
var _currentEditorType = /*#__PURE__*/_classPrivateFieldLooseKey("currentEditorType");
var _createNewEditor = /*#__PURE__*/_classPrivateFieldLooseKey("createNewEditor");
var _getCenterPoint = /*#__PURE__*/_classPrivateFieldLooseKey("getCenterPoint");
var _cleanup = /*#__PURE__*/_classPrivateFieldLooseKey("cleanup");
var _AnnotationEditorLayer = /*#__PURE__*/function () {
  function _AnnotationEditorLayer(_ref161) {
    var uiManager = _ref161.uiManager,
      pageIndex = _ref161.pageIndex,
      div = _ref161.div,
      structTreeLayer = _ref161.structTreeLayer,
      accessibilityManager = _ref161.accessibilityManager,
      annotationLayer = _ref161.annotationLayer,
      drawLayer = _ref161.drawLayer,
      textLayer = _ref161.textLayer,
      viewport = _ref161.viewport,
      l10n = _ref161.l10n;
    _classCallCheck(this, _AnnotationEditorLayer);
    Object.defineProperty(this, _cleanup, {
      value: _cleanup2
    });
    Object.defineProperty(this, _getCenterPoint, {
      value: _getCenterPoint2
    });
    Object.defineProperty(this, _createNewEditor, {
      value: _createNewEditor2
    });
    Object.defineProperty(this, _currentEditorType, {
      get: _get_currentEditorType,
      set: void 0
    });
    Object.defineProperty(this, _textLayerPointerDown, {
      value: _textLayerPointerDown2
    });
    Object.defineProperty(this, _accessibilityManager2, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _allowClick, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _annotationLayer, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _clickAC, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _editorFocusTimeoutId, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _editors, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _hadPointerDown, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _isCleaningUp, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _isDisabling, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _textLayer, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _textSelectionAC, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _uiManager4, {
      writable: true,
      value: void 0
    });
    var editorTypes = _toConsumableArray(_classPrivateFieldLooseBase(_AnnotationEditorLayer, _editorTypes2)[_editorTypes2].values());
    if (!_AnnotationEditorLayer._initialized) {
      _AnnotationEditorLayer._initialized = true;
      var _iterator146 = _createForOfIteratorHelper(editorTypes),
        _step146;
      try {
        for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
          var editorType = _step146.value;
          editorType.initialize(l10n, uiManager);
        }
      } catch (err) {
        _iterator146.e(err);
      } finally {
        _iterator146.f();
      }
    }
    uiManager.registerEditorTypes(editorTypes);
    _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4] = uiManager;
    this.pageIndex = pageIndex;
    this.div = div;
    _classPrivateFieldLooseBase(this, _accessibilityManager2)[_accessibilityManager2] = accessibilityManager;
    _classPrivateFieldLooseBase(this, _annotationLayer)[_annotationLayer] = annotationLayer;
    this.viewport = viewport;
    _classPrivateFieldLooseBase(this, _textLayer)[_textLayer] = textLayer;
    this.drawLayer = drawLayer;
    this._structTree = structTreeLayer;
    _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].addLayer(this);
  }
  return _createClass(_AnnotationEditorLayer, [{
    key: "isEmpty",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _editors)[_editors].size === 0;
    }
  }, {
    key: "isInvisible",
    get: function get() {
      return this.isEmpty && _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getMode() === _AnnotationEditorType.NONE;
    }
  }, {
    key: "updateToolbar",
    value: function updateToolbar(mode) {
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].updateToolbar(mode);
    }
  }, {
    key: "updateMode",
    value: function updateMode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getMode();
      _classPrivateFieldLooseBase(this, _cleanup)[_cleanup]();
      switch (mode) {
        case _AnnotationEditorType.NONE:
          this.disableTextSelection();
          this.togglePointerEvents(false);
          this.toggleAnnotationLayerPointerEvents(true);
          this.disableClick();
          return;
        case _AnnotationEditorType.INK:
          this.addInkEditorIfNeeded(false);
          this.disableTextSelection();
          this.togglePointerEvents(true);
          this.disableClick();
          break;
        case _AnnotationEditorType.HIGHLIGHT:
          this.enableTextSelection();
          this.togglePointerEvents(false);
          this.disableClick();
          break;
        default:
          this.disableTextSelection();
          this.togglePointerEvents(true);
          this.enableClick();
      }
      this.toggleAnnotationLayerPointerEvents(false);
      var classList = this.div.classList;
      var _iterator147 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(_AnnotationEditorLayer, _editorTypes2)[_editorTypes2].values()),
        _step147;
      try {
        for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
          var editorType = _step147.value;
          classList.toggle("".concat(editorType._type, "Editing"), mode === editorType._editorType);
        }
      } catch (err) {
        _iterator147.e(err);
      } finally {
        _iterator147.f();
      }
      this.div.hidden = false;
    }
  }, {
    key: "hasTextLayer",
    value: function hasTextLayer(textLayer) {
      var _classPrivateFieldLoo113;
      return textLayer === ((_classPrivateFieldLoo113 = _classPrivateFieldLooseBase(this, _textLayer)[_textLayer]) === null || _classPrivateFieldLoo113 === void 0 ? void 0 : _classPrivateFieldLoo113.div);
    }
  }, {
    key: "addInkEditorIfNeeded",
    value: function addInkEditorIfNeeded(isCommitting) {
      if (_classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getMode() !== _AnnotationEditorType.INK) {
        return;
      }
      if (!isCommitting) {
        var _iterator148 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values()),
          _step148;
        try {
          for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
            var _editor4 = _step148.value;
            if (_editor4.isEmpty()) {
              _editor4.setInBackground();
              return;
            }
          }
        } catch (err) {
          _iterator148.e(err);
        } finally {
          _iterator148.f();
        }
      }
      var editor = this.createAndAddNewEditor({
        offsetX: 0,
        offsetY: 0
      }, false);
      editor.setInBackground();
    }
  }, {
    key: "setEditingState",
    value: function setEditingState(isEditing) {
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].setEditingState(isEditing);
    }
  }, {
    key: "addCommands",
    value: function addCommands(params) {
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].addCommands(params);
    }
  }, {
    key: "toggleDrawing",
    value: function toggleDrawing() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.div.classList.toggle("drawing", !enabled);
    }
  }, {
    key: "togglePointerEvents",
    value: function togglePointerEvents() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.div.classList.toggle("disabled", !enabled);
    }
  }, {
    key: "toggleAnnotationLayerPointerEvents",
    value: function toggleAnnotationLayerPointerEvents() {
      var _classPrivateFieldLoo114;
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      (_classPrivateFieldLoo114 = _classPrivateFieldLooseBase(this, _annotationLayer)[_annotationLayer]) === null || _classPrivateFieldLoo114 === void 0 || _classPrivateFieldLoo114.div.classList.toggle("disabled", !enabled);
    }
  }, {
    key: "enable",
    value: function () {
      var _enable = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
        var annotationElementIds, _iterator149, _step149, editor, editables, _iterator150, _step150, editable, _editor5;
        return _regeneratorRuntime().wrap(function _callee48$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              this.div.tabIndex = 0;
              this.togglePointerEvents(true);
              annotationElementIds = new Set();
              _iterator149 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values());
              try {
                for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
                  editor = _step149.value;
                  editor.enableEditing();
                  editor.show(true);
                  if (editor.annotationElementId) {
                    _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].removeChangedExistingAnnotation(editor);
                    annotationElementIds.add(editor.annotationElementId);
                  }
                }
              } catch (err) {
                _iterator149.e(err);
              } finally {
                _iterator149.f();
              }
              if (_classPrivateFieldLooseBase(this, _annotationLayer)[_annotationLayer]) {
                _context49.next = 7;
                break;
              }
              return _context49.abrupt("return");
            case 7:
              editables = _classPrivateFieldLooseBase(this, _annotationLayer)[_annotationLayer].getEditableAnnotations();
              _iterator150 = _createForOfIteratorHelper(editables);
              _context49.prev = 9;
              _iterator150.s();
            case 11:
              if ((_step150 = _iterator150.n()).done) {
                _context49.next = 27;
                break;
              }
              editable = _step150.value;
              editable.hide();
              if (!_classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].isDeletedAnnotationElement(editable.data.id)) {
                _context49.next = 16;
                break;
              }
              return _context49.abrupt("continue", 25);
            case 16:
              if (!annotationElementIds.has(editable.data.id)) {
                _context49.next = 18;
                break;
              }
              return _context49.abrupt("continue", 25);
            case 18:
              _context49.next = 20;
              return this.deserialize(editable);
            case 20:
              _editor5 = _context49.sent;
              if (_editor5) {
                _context49.next = 23;
                break;
              }
              return _context49.abrupt("continue", 25);
            case 23:
              this.addOrRebuild(_editor5);
              _editor5.enableEditing();
            case 25:
              _context49.next = 11;
              break;
            case 27:
              _context49.next = 32;
              break;
            case 29:
              _context49.prev = 29;
              _context49.t0 = _context49["catch"](9);
              _iterator150.e(_context49.t0);
            case 32:
              _context49.prev = 32;
              _iterator150.f();
              return _context49.finish(32);
            case 35:
            case "end":
              return _context49.stop();
          }
        }, _callee48, this, [[9, 29, 32, 35]]);
      }));
      function enable() {
        return _enable.apply(this, arguments);
      }
      return enable;
    }()
  }, {
    key: "disable",
    value: function disable() {
      _classPrivateFieldLooseBase(this, _isDisabling)[_isDisabling] = true;
      this.div.tabIndex = -1;
      this.togglePointerEvents(false);
      var changedAnnotations = new Map();
      var resetAnnotations = new Map();
      var _iterator151 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values()),
        _step151;
      try {
        for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
          var _this$getEditableAnno;
          var _editor6 = _step151.value;
          _editor6.disableEditing();
          if (!_editor6.annotationElementId) {
            continue;
          }
          if (_editor6.serialize() !== null) {
            changedAnnotations.set(_editor6.annotationElementId, _editor6);
            continue;
          } else {
            resetAnnotations.set(_editor6.annotationElementId, _editor6);
          }
          (_this$getEditableAnno = this.getEditableAnnotation(_editor6.annotationElementId)) === null || _this$getEditableAnno === void 0 || _this$getEditableAnno.show();
          _editor6.remove();
        }
      } catch (err) {
        _iterator151.e(err);
      } finally {
        _iterator151.f();
      }
      if (_classPrivateFieldLooseBase(this, _annotationLayer)[_annotationLayer]) {
        var editables = _classPrivateFieldLooseBase(this, _annotationLayer)[_annotationLayer].getEditableAnnotations();
        var _iterator152 = _createForOfIteratorHelper(editables),
          _step152;
        try {
          for (_iterator152.s(); !(_step152 = _iterator152.n()).done;) {
            var editable = _step152.value;
            var _id20 = editable.data.id;
            if (_classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].isDeletedAnnotationElement(_id20)) {
              continue;
            }
            var editor = resetAnnotations.get(_id20);
            if (editor) {
              editor.resetAnnotationElement(editable);
              editor.show(false);
              editable.show();
              continue;
            }
            editor = changedAnnotations.get(_id20);
            if (editor) {
              _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].addChangedExistingAnnotation(editor);
              if (editor.renderAnnotationElement(editable)) {
                editor.show(false);
              }
            }
            editable.show();
          }
        } catch (err) {
          _iterator152.e(err);
        } finally {
          _iterator152.f();
        }
      }
      _classPrivateFieldLooseBase(this, _cleanup)[_cleanup]();
      if (this.isEmpty) {
        this.div.hidden = true;
      }
      var classList = this.div.classList;
      var _iterator153 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(_AnnotationEditorLayer, _editorTypes2)[_editorTypes2].values()),
        _step153;
      try {
        for (_iterator153.s(); !(_step153 = _iterator153.n()).done;) {
          var editorType = _step153.value;
          classList.remove("".concat(editorType._type, "Editing"));
        }
      } catch (err) {
        _iterator153.e(err);
      } finally {
        _iterator153.f();
      }
      this.disableTextSelection();
      this.toggleAnnotationLayerPointerEvents(true);
      _classPrivateFieldLooseBase(this, _isDisabling)[_isDisabling] = false;
    }
  }, {
    key: "getEditableAnnotation",
    value: function getEditableAnnotation(id) {
      var _classPrivateFieldLoo115;
      return ((_classPrivateFieldLoo115 = _classPrivateFieldLooseBase(this, _annotationLayer)[_annotationLayer]) === null || _classPrivateFieldLoo115 === void 0 ? void 0 : _classPrivateFieldLoo115.getEditableAnnotation(id)) || null;
    }
  }, {
    key: "setActiveEditor",
    value: function setActiveEditor(editor) {
      var currentActive = _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getActive();
      if (currentActive === editor) {
        return;
      }
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].setActiveEditor(editor);
    }
  }, {
    key: "enableTextSelection",
    value: function enableTextSelection() {
      var _classPrivateFieldLoo116;
      this.div.tabIndex = -1;
      if ((_classPrivateFieldLoo116 = _classPrivateFieldLooseBase(this, _textLayer)[_textLayer]) !== null && _classPrivateFieldLoo116 !== void 0 && _classPrivateFieldLoo116.div && !_classPrivateFieldLooseBase(this, _textSelectionAC)[_textSelectionAC]) {
        _classPrivateFieldLooseBase(this, _textSelectionAC)[_textSelectionAC] = new AbortController();
        var signal = _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].combinedSignal(_classPrivateFieldLooseBase(this, _textSelectionAC)[_textSelectionAC]);
        _classPrivateFieldLooseBase(this, _textLayer)[_textLayer].div.addEventListener("pointerdown", _classPrivateFieldLooseBase(this, _textLayerPointerDown)[_textLayerPointerDown].bind(this), {
          signal: signal
        });
        _classPrivateFieldLooseBase(this, _textLayer)[_textLayer].div.classList.add("highlighting");
      }
    }
  }, {
    key: "disableTextSelection",
    value: function disableTextSelection() {
      var _classPrivateFieldLoo117;
      this.div.tabIndex = 0;
      if ((_classPrivateFieldLoo117 = _classPrivateFieldLooseBase(this, _textLayer)[_textLayer]) !== null && _classPrivateFieldLoo117 !== void 0 && _classPrivateFieldLoo117.div && _classPrivateFieldLooseBase(this, _textSelectionAC)[_textSelectionAC]) {
        _classPrivateFieldLooseBase(this, _textSelectionAC)[_textSelectionAC].abort();
        _classPrivateFieldLooseBase(this, _textSelectionAC)[_textSelectionAC] = null;
        _classPrivateFieldLooseBase(this, _textLayer)[_textLayer].div.classList.remove("highlighting");
      }
    }
  }, {
    key: "enableClick",
    value: function enableClick() {
      if (_classPrivateFieldLooseBase(this, _clickAC)[_clickAC]) {
        return;
      }
      _classPrivateFieldLooseBase(this, _clickAC)[_clickAC] = new AbortController();
      var signal = _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].combinedSignal(_classPrivateFieldLooseBase(this, _clickAC)[_clickAC]);
      this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
        signal: signal
      });
      this.div.addEventListener("pointerup", this.pointerup.bind(this), {
        signal: signal
      });
    }
  }, {
    key: "disableClick",
    value: function disableClick() {
      var _classPrivateFieldLoo118;
      (_classPrivateFieldLoo118 = _classPrivateFieldLooseBase(this, _clickAC)[_clickAC]) === null || _classPrivateFieldLoo118 === void 0 || _classPrivateFieldLoo118.abort();
      _classPrivateFieldLooseBase(this, _clickAC)[_clickAC] = null;
    }
  }, {
    key: "attach",
    value: function attach(editor) {
      _classPrivateFieldLooseBase(this, _editors)[_editors].set(editor.id, editor);
      var annotationElementId = editor.annotationElementId;
      if (annotationElementId && _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].isDeletedAnnotationElement(annotationElementId)) {
        _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].removeDeletedAnnotationElement(editor);
      }
    }
  }, {
    key: "detach",
    value: function detach(editor) {
      var _classPrivateFieldLoo119;
      _classPrivateFieldLooseBase(this, _editors)[_editors].delete(editor.id);
      (_classPrivateFieldLoo119 = _classPrivateFieldLooseBase(this, _accessibilityManager2)[_accessibilityManager2]) === null || _classPrivateFieldLoo119 === void 0 || _classPrivateFieldLoo119.removePointerInTextLayer(editor.contentDiv);
      if (!_classPrivateFieldLooseBase(this, _isDisabling)[_isDisabling] && editor.annotationElementId) {
        _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].addDeletedAnnotationElement(editor);
      }
    }
  }, {
    key: "remove",
    value: function remove(editor) {
      this.detach(editor);
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].removeEditor(editor);
      editor.div.remove();
      editor.isAttachedToDOM = false;
      if (!_classPrivateFieldLooseBase(this, _isCleaningUp)[_isCleaningUp]) {
        this.addInkEditorIfNeeded(false);
      }
    }
  }, {
    key: "changeParent",
    value: function changeParent(editor) {
      var _editor$parent;
      if (editor.parent === this) {
        return;
      }
      if (editor.parent && editor.annotationElementId) {
        _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].addDeletedAnnotationElement(editor.annotationElementId);
        AnnotationEditor.deleteAnnotationElement(editor);
        editor.annotationElementId = null;
      }
      this.attach(editor);
      (_editor$parent = editor.parent) === null || _editor$parent === void 0 || _editor$parent.detach(editor);
      editor.setParent(this);
      if (editor.div && editor.isAttachedToDOM) {
        editor.div.remove();
        this.div.append(editor.div);
      }
    }
  }, {
    key: "add",
    value: function add(editor) {
      if (editor.parent === this && editor.isAttachedToDOM) {
        return;
      }
      this.changeParent(editor);
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].addEditor(editor);
      this.attach(editor);
      if (!editor.isAttachedToDOM) {
        var div = editor.render();
        this.div.append(div);
        editor.isAttachedToDOM = true;
      }
      editor.fixAndSetPosition();
      editor.onceAdded();
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].addToAnnotationStorage(editor);
      editor._reportTelemetry(editor.telemetryInitialData);
    }
  }, {
    key: "moveEditorInDOM",
    value: function moveEditorInDOM(editor) {
      var _this87 = this,
        _classPrivateFieldLoo120;
      if (!editor.isAttachedToDOM) {
        return;
      }
      var _document3 = document,
        activeElement = _document3.activeElement;
      if (editor.div.contains(activeElement) && !_classPrivateFieldLooseBase(this, _editorFocusTimeoutId)[_editorFocusTimeoutId]) {
        editor._focusEventsAllowed = false;
        _classPrivateFieldLooseBase(this, _editorFocusTimeoutId)[_editorFocusTimeoutId] = setTimeout(function () {
          _classPrivateFieldLooseBase(_this87, _editorFocusTimeoutId)[_editorFocusTimeoutId] = null;
          if (!editor.div.contains(document.activeElement)) {
            editor.div.addEventListener("focusin", function () {
              editor._focusEventsAllowed = true;
            }, {
              once: true,
              signal: _classPrivateFieldLooseBase(_this87, _uiManager4)[_uiManager4]._signal
            });
            activeElement.focus();
          } else {
            editor._focusEventsAllowed = true;
          }
        }, 0);
      }
      editor._structTreeParentId = (_classPrivateFieldLoo120 = _classPrivateFieldLooseBase(this, _accessibilityManager2)[_accessibilityManager2]) === null || _classPrivateFieldLoo120 === void 0 ? void 0 : _classPrivateFieldLoo120.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
    }
  }, {
    key: "addOrRebuild",
    value: function addOrRebuild(editor) {
      if (editor.needsToBeRebuilt()) {
        editor.parent || (editor.parent = this);
        editor.rebuild();
        editor.show();
      } else {
        this.add(editor);
      }
    }
  }, {
    key: "addUndoableEditor",
    value: function addUndoableEditor(editor) {
      var cmd = function cmd() {
        return editor._uiManager.rebuild(editor);
      };
      var undo = function undo() {
        editor.remove();
      };
      this.addCommands({
        cmd: cmd,
        undo: undo,
        mustExec: false
      });
    }
  }, {
    key: "getNextId",
    value: function getNextId() {
      return _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getId();
    }
  }, {
    key: "combinedSignal",
    value: function combinedSignal(ac) {
      return _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].combinedSignal(ac);
    }
  }, {
    key: "canCreateNewEmptyEditor",
    value: function canCreateNewEmptyEditor() {
      var _classPrivateFieldLoo121;
      return (_classPrivateFieldLoo121 = _classPrivateFieldLooseBase(this, _currentEditorType)[_currentEditorType]) === null || _classPrivateFieldLoo121 === void 0 ? void 0 : _classPrivateFieldLoo121.canCreateNewEmptyEditor();
    }
  }, {
    key: "pasteEditor",
    value: function pasteEditor(mode, params) {
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].updateToolbar(mode);
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].updateMode(mode);
      var _classPrivateFieldLoo122 = _classPrivateFieldLooseBase(this, _getCenterPoint)[_getCenterPoint](),
        offsetX = _classPrivateFieldLoo122.offsetX,
        offsetY = _classPrivateFieldLoo122.offsetY;
      var id = this.getNextId();
      var editor = _classPrivateFieldLooseBase(this, _createNewEditor)[_createNewEditor](_objectSpread({
        parent: this,
        id: id,
        x: offsetX,
        y: offsetY,
        uiManager: _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4],
        isCentered: true
      }, params));
      if (editor) {
        this.add(editor);
      }
    }
  }, {
    key: "deserialize",
    value: function () {
      var _deserialize6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee49(data) {
        var _classPrivateFieldLoo123, _data$annotationType;
        return _regeneratorRuntime().wrap(function _callee49$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              _context50.next = 2;
              return (_classPrivateFieldLoo123 = _classPrivateFieldLooseBase(_AnnotationEditorLayer, _editorTypes2)[_editorTypes2].get((_data$annotationType = data.annotationType) !== null && _data$annotationType !== void 0 ? _data$annotationType : data.annotationEditorType)) === null || _classPrivateFieldLoo123 === void 0 ? void 0 : _classPrivateFieldLoo123.deserialize(data, this, _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4]);
            case 2:
              _context50.t0 = _context50.sent;
              if (_context50.t0) {
                _context50.next = 5;
                break;
              }
              _context50.t0 = null;
            case 5:
              return _context50.abrupt("return", _context50.t0);
            case 6:
            case "end":
              return _context50.stop();
          }
        }, _callee49, this);
      }));
      function deserialize(_x46) {
        return _deserialize6.apply(this, arguments);
      }
      return deserialize;
    }()
  }, {
    key: "createAndAddNewEditor",
    value: function createAndAddNewEditor(event, isCentered) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var id = this.getNextId();
      var editor = _classPrivateFieldLooseBase(this, _createNewEditor)[_createNewEditor](_objectSpread({
        parent: this,
        id: id,
        x: event.offsetX,
        y: event.offsetY,
        uiManager: _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4],
        isCentered: isCentered
      }, data));
      if (editor) {
        this.add(editor);
      }
      return editor;
    }
  }, {
    key: "addNewEditor",
    value: function addNewEditor() {
      this.createAndAddNewEditor(_classPrivateFieldLooseBase(this, _getCenterPoint)[_getCenterPoint](), true);
    }
  }, {
    key: "setSelected",
    value: function setSelected(editor) {
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].setSelected(editor);
    }
  }, {
    key: "toggleSelected",
    value: function toggleSelected(editor) {
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].toggleSelected(editor);
    }
  }, {
    key: "unselect",
    value: function unselect(editor) {
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].unselect(editor);
    }
  }, {
    key: "pointerup",
    value: function pointerup(event) {
      var isMac = util_FeatureTest.platform.isMac;
      if (event.button !== 0 || event.ctrlKey && isMac) {
        return;
      }
      if (event.target !== this.div) {
        return;
      }
      if (!_classPrivateFieldLooseBase(this, _hadPointerDown)[_hadPointerDown]) {
        return;
      }
      _classPrivateFieldLooseBase(this, _hadPointerDown)[_hadPointerDown] = false;
      if (!_classPrivateFieldLooseBase(this, _allowClick)[_allowClick]) {
        _classPrivateFieldLooseBase(this, _allowClick)[_allowClick] = true;
        return;
      }
      if (_classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getMode() === _AnnotationEditorType.STAMP) {
        _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].unselectAll();
        return;
      }
      this.createAndAddNewEditor(event, false);
    }
  }, {
    key: "pointerdown",
    value: function pointerdown(event) {
      if (_classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getMode() === _AnnotationEditorType.HIGHLIGHT) {
        this.enableTextSelection();
      }
      if (_classPrivateFieldLooseBase(this, _hadPointerDown)[_hadPointerDown]) {
        _classPrivateFieldLooseBase(this, _hadPointerDown)[_hadPointerDown] = false;
        return;
      }
      var isMac = util_FeatureTest.platform.isMac;
      if (event.button !== 0 || event.ctrlKey && isMac) {
        return;
      }
      if (event.target !== this.div) {
        return;
      }
      _classPrivateFieldLooseBase(this, _hadPointerDown)[_hadPointerDown] = true;
      var editor = _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getActive();
      _classPrivateFieldLooseBase(this, _allowClick)[_allowClick] = !editor || editor.isEmpty();
    }
  }, {
    key: "findNewParent",
    value: function findNewParent(editor, x, y) {
      var layer = _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].findParent(x, y);
      if (layer === null || layer === this) {
        return false;
      }
      layer.changeParent(editor);
      return true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _classPrivateFieldLoo124;
      if (((_classPrivateFieldLoo124 = _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getActive()) === null || _classPrivateFieldLoo124 === void 0 ? void 0 : _classPrivateFieldLoo124.parent) === this) {
        _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].commitOrRemove();
        _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].setActiveEditor(null);
      }
      if (_classPrivateFieldLooseBase(this, _editorFocusTimeoutId)[_editorFocusTimeoutId]) {
        clearTimeout(_classPrivateFieldLooseBase(this, _editorFocusTimeoutId)[_editorFocusTimeoutId]);
        _classPrivateFieldLooseBase(this, _editorFocusTimeoutId)[_editorFocusTimeoutId] = null;
      }
      var _iterator154 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values()),
        _step154;
      try {
        for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
          var _classPrivateFieldLoo125;
          var editor = _step154.value;
          (_classPrivateFieldLoo125 = _classPrivateFieldLooseBase(this, _accessibilityManager2)[_accessibilityManager2]) === null || _classPrivateFieldLoo125 === void 0 || _classPrivateFieldLoo125.removePointerInTextLayer(editor.contentDiv);
          editor.setParent(null);
          editor.isAttachedToDOM = false;
          editor.div.remove();
        }
      } catch (err) {
        _iterator154.e(err);
      } finally {
        _iterator154.f();
      }
      this.div = null;
      _classPrivateFieldLooseBase(this, _editors)[_editors].clear();
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].removeLayer(this);
    }
  }, {
    key: "render",
    value: function render(_ref162) {
      var viewport = _ref162.viewport;
      this.viewport = viewport;
      _setLayerDimensions(this.div, viewport);
      var _iterator155 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getEditors(this.pageIndex)),
        _step155;
      try {
        for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
          var editor = _step155.value;
          this.add(editor);
          editor.rebuild();
        }
      } catch (err) {
        _iterator155.e(err);
      } finally {
        _iterator155.f();
      }
      this.updateMode();
    }
  }, {
    key: "update",
    value: function update(_ref163) {
      var viewport = _ref163.viewport;
      _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].commitOrRemove();
      _classPrivateFieldLooseBase(this, _cleanup)[_cleanup]();
      var oldRotation = this.viewport.rotation;
      var rotation = viewport.rotation;
      this.viewport = viewport;
      _setLayerDimensions(this.div, {
        rotation: rotation
      });
      if (oldRotation !== rotation) {
        var _iterator156 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values()),
          _step156;
        try {
          for (_iterator156.s(); !(_step156 = _iterator156.n()).done;) {
            var editor = _step156.value;
            editor.rotate(rotation);
          }
        } catch (err) {
          _iterator156.e(err);
        } finally {
          _iterator156.f();
        }
      }
      this.addInkEditorIfNeeded(false);
    }
  }, {
    key: "pageDimensions",
    get: function get() {
      var _this$viewport$rawDim = this.viewport.rawDims,
        pageWidth = _this$viewport$rawDim.pageWidth,
        pageHeight = _this$viewport$rawDim.pageHeight;
      return [pageWidth, pageHeight];
    }
  }, {
    key: "scale",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].viewParameters.realScale;
    }
  }]);
}();
_AnnotationEditorLayer2 = _AnnotationEditorLayer;
function _textLayerPointerDown2(event) {
  var _this111 = this;
  _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].unselectAll();
  var target = event.target;
  if (target === _classPrivateFieldLooseBase(this, _textLayer)[_textLayer].div || (target.getAttribute("role") === "img" || target.classList.contains("endOfContent")) && _classPrivateFieldLooseBase(this, _textLayer)[_textLayer].div.contains(target)) {
    var isMac = util_FeatureTest.platform.isMac;
    if (event.button !== 0 || event.ctrlKey && isMac) {
      return;
    }
    _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].showAllEditors("highlight", true, true);
    _classPrivateFieldLooseBase(this, _textLayer)[_textLayer].div.classList.add("free");
    this.toggleDrawing();
    HighlightEditor.startHighlighting(this, _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].direction === "ltr", {
      target: _classPrivateFieldLooseBase(this, _textLayer)[_textLayer].div,
      x: event.x,
      y: event.y
    });
    _classPrivateFieldLooseBase(this, _textLayer)[_textLayer].div.addEventListener("pointerup", function () {
      _classPrivateFieldLooseBase(_this111, _textLayer)[_textLayer].div.classList.remove("free");
      _this111.toggleDrawing(true);
    }, {
      once: true,
      signal: _classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4]._signal
    });
    event.preventDefault();
  }
}
function _get_currentEditorType() {
  return _classPrivateFieldLooseBase(_AnnotationEditorLayer2, _editorTypes2)[_editorTypes2].get(_classPrivateFieldLooseBase(this, _uiManager4)[_uiManager4].getMode());
}
function _createNewEditor2(params) {
  var editorType = _classPrivateFieldLooseBase(this, _currentEditorType)[_currentEditorType];
  return editorType ? new editorType.prototype.constructor(params) : null;
}
function _getCenterPoint2() {
  var _this$div$getBounding2 = this.div.getBoundingClientRect(),
    x = _this$div$getBounding2.x,
    y = _this$div$getBounding2.y,
    width = _this$div$getBounding2.width,
    height = _this$div$getBounding2.height;
  var tlX = Math.max(0, x);
  var tlY = Math.max(0, y);
  var brX = Math.min(window.innerWidth, x + width);
  var brY = Math.min(window.innerHeight, y + height);
  var centerX = (tlX + brX) / 2 - x;
  var centerY = (tlY + brY) / 2 - y;
  var _ref186 = this.viewport.rotation % 180 === 0 ? [centerX, centerY] : [centerY, centerX],
    _ref187 = _slicedToArray(_ref186, 2),
    offsetX = _ref187[0],
    offsetY = _ref187[1];
  return {
    offsetX: offsetX,
    offsetY: offsetY
  };
}
function _cleanup2() {
  _classPrivateFieldLooseBase(this, _isCleaningUp)[_isCleaningUp] = true;
  var _iterator183 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _editors)[_editors].values()),
    _step183;
  try {
    for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
      var editor = _step183.value;
      if (editor.isEmpty()) {
        editor.remove();
      }
    }
  } catch (err) {
    _iterator183.e(err);
  } finally {
    _iterator183.f();
  }
  _classPrivateFieldLooseBase(this, _isCleaningUp)[_isCleaningUp] = false;
}
_AnnotationEditorLayer._initialized = false;
Object.defineProperty(_AnnotationEditorLayer, _editorTypes2, {
  writable: true,
  value: new Map([FreeTextEditor, InkEditor, StampEditor, HighlightEditor].map(function (type) {
    return [type._editorType, type];
  }))
});
; // ./src/display/draw_layer.js
var _parent2 = /*#__PURE__*/_classPrivateFieldLooseKey("parent");
var _id21 = /*#__PURE__*/_classPrivateFieldLooseKey("id");
var _mapping = /*#__PURE__*/_classPrivateFieldLooseKey("mapping");
var _toUpdate = /*#__PURE__*/_classPrivateFieldLooseKey("toUpdate");
var _setBox = /*#__PURE__*/_classPrivateFieldLooseKey("setBox");
var _createSVG2 = /*#__PURE__*/_classPrivateFieldLooseKey("createSVG");
var _createClipPath = /*#__PURE__*/_classPrivateFieldLooseKey("createClipPath");
var _DrawLayer = /*#__PURE__*/function () {
  function _DrawLayer(_ref164) {
    var pageIndex = _ref164.pageIndex;
    _classCallCheck(this, _DrawLayer);
    Object.defineProperty(this, _createClipPath, {
      value: _createClipPath2
    });
    Object.defineProperty(this, _createSVG2, {
      value: _createSVG3
    });
    Object.defineProperty(this, _parent2, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _id21, {
      writable: true,
      value: 0
    });
    Object.defineProperty(this, _mapping, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _toUpdate, {
      writable: true,
      value: new Map()
    });
    this.pageIndex = pageIndex;
  }
  return _createClass(_DrawLayer, [{
    key: "setParent",
    value: function setParent(parent) {
      if (!_classPrivateFieldLooseBase(this, _parent2)[_parent2]) {
        _classPrivateFieldLooseBase(this, _parent2)[_parent2] = parent;
        return;
      }
      if (_classPrivateFieldLooseBase(this, _parent2)[_parent2] !== parent) {
        if (_classPrivateFieldLooseBase(this, _mapping)[_mapping].size > 0) {
          var _iterator157 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _mapping)[_mapping].values()),
            _step157;
          try {
            for (_iterator157.s(); !(_step157 = _iterator157.n()).done;) {
              var root = _step157.value;
              root.remove();
              parent.append(root);
            }
          } catch (err) {
            _iterator157.e(err);
          } finally {
            _iterator157.f();
          }
        }
        _classPrivateFieldLooseBase(this, _parent2)[_parent2] = parent;
      }
    }
  }, {
    key: "draw",
    value: function draw(outlines, color, opacity) {
      var _root$classList;
      var isPathUpdatable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var id = _classPrivateFieldLooseBase(this, _id21)[_id21]++;
      var root = _classPrivateFieldLooseBase(this, _createSVG2)[_createSVG2](outlines.box);
      (_root$classList = root.classList).add.apply(_root$classList, _toConsumableArray(outlines.classNamesForDrawing));
      var defs = _DrawLayer._svgFactory.createElement("defs");
      root.append(defs);
      var path = _DrawLayer._svgFactory.createElement("path");
      defs.append(path);
      var pathId = "path_p".concat(this.pageIndex, "_").concat(id);
      path.setAttribute("id", pathId);
      path.setAttribute("d", outlines.toSVGPath());
      if (isPathUpdatable) {
        _classPrivateFieldLooseBase(this, _toUpdate)[_toUpdate].set(id, path);
      }
      var clipPathId = _classPrivateFieldLooseBase(this, _createClipPath)[_createClipPath](defs, pathId);
      var use = _DrawLayer._svgFactory.createElement("use");
      root.append(use);
      root.setAttribute("fill", color);
      root.setAttribute("fill-opacity", opacity);
      use.setAttribute("href", "#".concat(pathId));
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].set(id, root);
      return {
        id: id,
        clipPathId: "url(#".concat(clipPathId, ")")
      };
    }
  }, {
    key: "drawOutline",
    value: function drawOutline(outlines) {
      var _root$classList2;
      var id = _classPrivateFieldLooseBase(this, _id21)[_id21]++;
      var root = _classPrivateFieldLooseBase(this, _createSVG2)[_createSVG2](outlines.box);
      (_root$classList2 = root.classList).add.apply(_root$classList2, _toConsumableArray(outlines.classNamesForOutlining));
      var defs = _DrawLayer._svgFactory.createElement("defs");
      root.append(defs);
      var path = _DrawLayer._svgFactory.createElement("path");
      defs.append(path);
      var pathId = "path_p".concat(this.pageIndex, "_").concat(id);
      path.setAttribute("id", pathId);
      path.setAttribute("d", outlines.toSVGPath());
      path.setAttribute("vector-effect", "non-scaling-stroke");
      var maskId;
      if (outlines.mustRemoveSelfIntersections) {
        var mask = _DrawLayer._svgFactory.createElement("mask");
        defs.append(mask);
        maskId = "mask_p".concat(this.pageIndex, "_").concat(id);
        mask.setAttribute("id", maskId);
        mask.setAttribute("maskUnits", "objectBoundingBox");
        var rect = _DrawLayer._svgFactory.createElement("rect");
        mask.append(rect);
        rect.setAttribute("width", "1");
        rect.setAttribute("height", "1");
        rect.setAttribute("fill", "white");
        var use = _DrawLayer._svgFactory.createElement("use");
        mask.append(use);
        use.setAttribute("href", "#".concat(pathId));
        use.setAttribute("stroke", "none");
        use.setAttribute("fill", "black");
        use.setAttribute("fill-rule", "nonzero");
        use.classList.add("mask");
      }
      var use1 = _DrawLayer._svgFactory.createElement("use");
      root.append(use1);
      use1.setAttribute("href", "#".concat(pathId));
      if (maskId) {
        use1.setAttribute("mask", "url(#".concat(maskId, ")"));
      }
      var use2 = use1.cloneNode();
      root.append(use2);
      use1.classList.add("mainOutline");
      use2.classList.add("secondaryOutline");
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].set(id, root);
      return id;
    }
  }, {
    key: "finalizeLine",
    value: function finalizeLine(id, line) {
      var path = _classPrivateFieldLooseBase(this, _toUpdate)[_toUpdate].get(id);
      _classPrivateFieldLooseBase(this, _toUpdate)[_toUpdate].delete(id);
      this.updateBox(id, line.box);
      path.setAttribute("d", line.toSVGPath());
    }
  }, {
    key: "updateLine",
    value: function updateLine(id, line) {
      var root = _classPrivateFieldLooseBase(this, _mapping)[_mapping].get(id);
      var defs = root.firstChild;
      var path = defs.firstChild;
      path.setAttribute("d", line.toSVGPath());
    }
  }, {
    key: "updatePath",
    value: function updatePath(id, line) {
      _classPrivateFieldLooseBase(this, _toUpdate)[_toUpdate].get(id).setAttribute("d", line.toSVGPath());
    }
  }, {
    key: "updateBox",
    value: function updateBox(id, box) {
      _classPrivateFieldLooseBase(_DrawLayer, _setBox)[_setBox](_classPrivateFieldLooseBase(this, _mapping)[_mapping].get(id), box);
    }
  }, {
    key: "show",
    value: function show(id, visible) {
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].get(id).classList.toggle("hidden", !visible);
    }
  }, {
    key: "rotate",
    value: function rotate(id, angle) {
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].get(id).setAttribute("data-main-rotation", angle);
    }
  }, {
    key: "changeColor",
    value: function changeColor(id, color) {
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].get(id).setAttribute("fill", color);
    }
  }, {
    key: "changeOpacity",
    value: function changeOpacity(id, opacity) {
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].get(id).setAttribute("fill-opacity", opacity);
    }
  }, {
    key: "addClass",
    value: function addClass(id, className) {
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].get(id).classList.add(className);
    }
  }, {
    key: "removeClass",
    value: function removeClass(id, className) {
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].get(id).classList.remove(className);
    }
  }, {
    key: "getSVGRoot",
    value: function getSVGRoot(id) {
      return _classPrivateFieldLooseBase(this, _mapping)[_mapping].get(id);
    }
  }, {
    key: "remove",
    value: function remove(id) {
      _classPrivateFieldLooseBase(this, _toUpdate)[_toUpdate].delete(id);
      if (_classPrivateFieldLooseBase(this, _parent2)[_parent2] === null) {
        return;
      }
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].get(id).remove();
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].delete(id);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _classPrivateFieldLooseBase(this, _parent2)[_parent2] = null;
      var _iterator158 = _createForOfIteratorHelper(_classPrivateFieldLooseBase(this, _mapping)[_mapping].values()),
        _step158;
      try {
        for (_iterator158.s(); !(_step158 = _iterator158.n()).done;) {
          var root = _step158.value;
          root.remove();
        }
      } catch (err) {
        _iterator158.e(err);
      } finally {
        _iterator158.f();
      }
      _classPrivateFieldLooseBase(this, _mapping)[_mapping].clear();
      _classPrivateFieldLooseBase(this, _toUpdate)[_toUpdate].clear();
    }
  }], [{
    key: "_svgFactory",
    get: function get() {
      return _shadow(this, "_svgFactory", new _DOMSVGFactory());
    }
  }]);
}();
_DrawLayer2 = _DrawLayer;
function _setBox2(element) {
  var _ref188 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref188$x = _ref188.x,
    x = _ref188$x === void 0 ? 0 : _ref188$x,
    _ref188$y = _ref188.y,
    y = _ref188$y === void 0 ? 0 : _ref188$y,
    _ref188$width = _ref188.width,
    width = _ref188$width === void 0 ? 1 : _ref188$width,
    _ref188$height = _ref188.height,
    height = _ref188$height === void 0 ? 1 : _ref188$height;
  var style = element.style;
  style.top = "".concat(100 * y, "%");
  style.left = "".concat(100 * x, "%");
  style.width = "".concat(100 * width, "%");
  style.height = "".concat(100 * height, "%");
}
function _createSVG3(box) {
  var svg = _DrawLayer2._svgFactory.create(1, 1, true);
  _classPrivateFieldLooseBase(this, _parent2)[_parent2].append(svg);
  svg.setAttribute("aria-hidden", true);
  _classPrivateFieldLooseBase(_DrawLayer2, _setBox)[_setBox](svg, box);
  return svg;
}
function _createClipPath2(defs, pathId) {
  var clipPath = _DrawLayer2._svgFactory.createElement("clipPath");
  defs.append(clipPath);
  var clipPathId = "clip_".concat(pathId);
  clipPath.setAttribute("id", clipPathId);
  clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
  var clipPathUse = _DrawLayer2._svgFactory.createElement("use");
  clipPath.append(clipPathUse);
  clipPathUse.setAttribute("href", "#".concat(pathId));
  clipPathUse.classList.add("clip");
  return clipPathId;
}
Object.defineProperty(_DrawLayer, _setBox, {
  value: _setBox2
});
; // ./src/pdf.js

var pdfjsVersion = "4.8.69";
var pdfjsBuild = "3634dab10";
var __webpack_exports__AbortException = __webpack_exports__.AbortException;
var __webpack_exports__AnnotationEditorLayer = __webpack_exports__.AnnotationEditorLayer;
var __webpack_exports__AnnotationEditorParamsType = __webpack_exports__.AnnotationEditorParamsType;
var __webpack_exports__AnnotationEditorType = __webpack_exports__.AnnotationEditorType;
var __webpack_exports__AnnotationEditorUIManager = __webpack_exports__.AnnotationEditorUIManager;
var __webpack_exports__AnnotationLayer = __webpack_exports__.AnnotationLayer;
var __webpack_exports__AnnotationMode = __webpack_exports__.AnnotationMode;
var __webpack_exports__ColorPicker = __webpack_exports__.ColorPicker;
var __webpack_exports__DOMSVGFactory = __webpack_exports__.DOMSVGFactory;
var __webpack_exports__DrawLayer = __webpack_exports__.DrawLayer;
var __webpack_exports__FeatureTest = __webpack_exports__.FeatureTest;
var __webpack_exports__GlobalWorkerOptions = __webpack_exports__.GlobalWorkerOptions;
var __webpack_exports__ImageKind = __webpack_exports__.ImageKind;
var __webpack_exports__InvalidPDFException = __webpack_exports__.InvalidPDFException;
var __webpack_exports__MissingPDFException = __webpack_exports__.MissingPDFException;
var __webpack_exports__OPS = __webpack_exports__.OPS;
var __webpack_exports__OutputScale = __webpack_exports__.OutputScale;
var __webpack_exports__PDFDataRangeTransport = __webpack_exports__.PDFDataRangeTransport;
var __webpack_exports__PDFDateString = __webpack_exports__.PDFDateString;
var __webpack_exports__PDFWorker = __webpack_exports__.PDFWorker;
var __webpack_exports__PasswordResponses = __webpack_exports__.PasswordResponses;
var __webpack_exports__PermissionFlag = __webpack_exports__.PermissionFlag;
var __webpack_exports__PixelsPerInch = __webpack_exports__.PixelsPerInch;
var __webpack_exports__RenderingCancelledException = __webpack_exports__.RenderingCancelledException;
var __webpack_exports__TextLayer = __webpack_exports__.TextLayer;
var __webpack_exports__UnexpectedResponseException = __webpack_exports__.UnexpectedResponseException;
var __webpack_exports__Util = __webpack_exports__.Util;
var __webpack_exports__VerbosityLevel = __webpack_exports__.VerbosityLevel;
var __webpack_exports__XfaLayer = __webpack_exports__.XfaLayer;
var __webpack_exports__build = __webpack_exports__.build;
var __webpack_exports__createValidAbsoluteUrl = __webpack_exports__.createValidAbsoluteUrl;
var __webpack_exports__fetchData = __webpack_exports__.fetchData;
var __webpack_exports__getDocument = __webpack_exports__.getDocument;
var __webpack_exports__getFilenameFromUrl = __webpack_exports__.getFilenameFromUrl;
var __webpack_exports__getPdfFilenameFromUrl = __webpack_exports__.getPdfFilenameFromUrl;
var __webpack_exports__getXfaPageViewport = __webpack_exports__.getXfaPageViewport;
var __webpack_exports__isDataScheme = __webpack_exports__.isDataScheme;
var __webpack_exports__isPdfFile = __webpack_exports__.isPdfFile;
var __webpack_exports__noContextMenu = __webpack_exports__.noContextMenu;
var __webpack_exports__normalizeUnicode = __webpack_exports__.normalizeUnicode;
var __webpack_exports__setLayerDimensions = __webpack_exports__.setLayerDimensions;
var __webpack_exports__shadow = __webpack_exports__.shadow;
var __webpack_exports__version = __webpack_exports__.version;
export { __webpack_exports__AbortException as AbortException, __webpack_exports__AnnotationEditorLayer as AnnotationEditorLayer, __webpack_exports__AnnotationEditorParamsType as AnnotationEditorParamsType, __webpack_exports__AnnotationEditorType as AnnotationEditorType, __webpack_exports__AnnotationEditorUIManager as AnnotationEditorUIManager, __webpack_exports__AnnotationLayer as AnnotationLayer, __webpack_exports__AnnotationMode as AnnotationMode, __webpack_exports__ColorPicker as ColorPicker, __webpack_exports__DOMSVGFactory as DOMSVGFactory, __webpack_exports__DrawLayer as DrawLayer, __webpack_exports__FeatureTest as FeatureTest, __webpack_exports__GlobalWorkerOptions as GlobalWorkerOptions, __webpack_exports__ImageKind as ImageKind, __webpack_exports__InvalidPDFException as InvalidPDFException, __webpack_exports__MissingPDFException as MissingPDFException, __webpack_exports__OPS as OPS, __webpack_exports__OutputScale as OutputScale, __webpack_exports__PDFDataRangeTransport as PDFDataRangeTransport, __webpack_exports__PDFDateString as PDFDateString, __webpack_exports__PDFWorker as PDFWorker, __webpack_exports__PasswordResponses as PasswordResponses, __webpack_exports__PermissionFlag as PermissionFlag, __webpack_exports__PixelsPerInch as PixelsPerInch, __webpack_exports__RenderingCancelledException as RenderingCancelledException, __webpack_exports__TextLayer as TextLayer, __webpack_exports__UnexpectedResponseException as UnexpectedResponseException, __webpack_exports__Util as Util, __webpack_exports__VerbosityLevel as VerbosityLevel, __webpack_exports__XfaLayer as XfaLayer, __webpack_exports__build as build, __webpack_exports__createValidAbsoluteUrl as createValidAbsoluteUrl, __webpack_exports__fetchData as fetchData, __webpack_exports__getDocument as getDocument, __webpack_exports__getFilenameFromUrl as getFilenameFromUrl, __webpack_exports__getPdfFilenameFromUrl as getPdfFilenameFromUrl, __webpack_exports__getXfaPageViewport as getXfaPageViewport, __webpack_exports__isDataScheme as isDataScheme, __webpack_exports__isPdfFile as isPdfFile, __webpack_exports__noContextMenu as noContextMenu, __webpack_exports__normalizeUnicode as normalizeUnicode, __webpack_exports__setLayerDimensions as setLayerDimensions, __webpack_exports__shadow as shadow, __webpack_exports__version as version };